const NOCData = [{
    "id": 1,
    "noc": 11,
    "job": "Legislators",
    "title1": "Aboriginal band chief",
    "title2": "Aboriginal band council member",
    "title3": "alderman",
    "allTitles": "Aboriginal band chiefAboriginal band council memberaldermanalderman/womanalderwomanattorney generalband chief, First Nationscabinet ministerchair, metropolitan councilchair, regional municipalitychief, First Nations bandcity aldermancity councillorcity councilmancity councilman/womancity councilwomancouncillorcouncilman, citycouncilman/woman, citycouncil member, First Nations bandcouncilwoman, cityFirst Nations band chiefFirst Nations band council memberFirst Nations government leadergovernment leadergovernor generalleader of the oppositionlegislative body speakerlegislatorlieutenant-governormayorMember of Legislative Assembly (MLA)Member of Parliament (MP)Member of the House of Assembly (MHA)Member of the National Assembly (MNA)Member of the Provincial Parliament (MPP)metropolitan council chairMHA (Member of the House of Assembly)minister - governmentMLA (Member of the Legislative Assembly)MNA (Member of the National Assembly)MP (Member of Parliament)MPP (Member of the Provincial Parliament)municipal council chairmanmunicipal council chairman/womanmunicipal council chairwomanopposition leaderorator - governmentpremierprime ministerreeveregional municipality chairschool board trusteesenatorsolicitor generalspeaker, legislative bodyTreasury Board presidenttrustee, school board",
    "workers": 295,
    "minEduc": 3,
    "yearsStudy": 3.75,
    "automationRisk": 0.015,
    "salaryLow": 28.75,
    "salaryMed": 80.7,
    "salaryHigh": 147.98,
    "totalSkill": 171,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Senior management occupations",
    "cluster": 1,
    "wage": 49.05957447,
    "skillsComp": 46,
    "skillsLogi": 43,
    "skillsMath": 24,
    "skillsLang": 59,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 35,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 90,
    "f9Law": 85,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 35,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 90,
    "d10Engineering": 0,
    "d11Law": 85,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 2,
    "noc": 12,
    "job": "Senior government managers and officials",
    "title1": "ambassador",
    "title2": "assistant chief statistician - government services",
    "title3": "assistant deputy minister",
    "allTitles": "ambassadorassistant chief statistician - government servicesassistant deputy ministerassistant deputy minister - government servicesassistant executive director - government servicesassistant general director - government servicesassistant undersecretary of stateband manager - First Nationschairman - government serviceschairman/woman - government serviceschairperson - government serviceschairperson, Human Rights Commissionchairwoman - government serviceschief administrative officer - government serviceschief administrative officer - regional municipalitychief - disaster managementchief electoral officerchief statistician - government servicescity administratorcity hall clerkcity managercity superintendentclerk of the House of CommonsClerk of the Privy Councilcommissioner - government servicescommissioner of inquiriescommissioner of inquiries - government servicescommissioner, territorialcomptroller general of Canadaconsulcouncil secretary - government servicescounty clerkdeputy commissioner - government servicesdeputy ministerdeputy minister - government servicesdeputy municipal clerkdeputy provincial secretary - government servicesdirector general - government servicesemployment insurance appeals board chairpersonemployment insurance commissionerexecutive administrator - government agencyexecutive administrator - government departmentexecutive director - emergency preparednessexecutive director - government servicesfire marshalFirst Nations band managergeneral manager - government servicesgeneral secretary - government servicesgovernment agency commissionergovernment agency presidentgovernment agency senior administratorgrain commissionerhealth commissionerhigh commissionerhighway commissionerHuman Rights Commission chairpersoninspector general of financial institutionsliquor commissionerlocal government managermanager - First Nationsmunicipal administratorombudsman - government servicesombudsperson - government servicesparole board chairmanparole board chairman/womanparole board chairwomanpresident - government servicesrailroad commissionerreceiver general for Canadaregional municipality general directorsecretary to the council - government servicessenior administrator, government agencysergeant-at-arms, House of Commonssuperintendent of financial institutionsterritorial commissionertown clerktownship clerktrade commissionerundersecretary of statevice-consulvice-president - government services",
    "workers": 2865,
    "minEduc": 3,
    "yearsStudy": 3.975903614,
    "automationRisk": 0.088,
    "salaryLow": 25.96,
    "salaryMed": 53.57,
    "salaryHigh": 87.18,
    "totalSkill": 170,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Senior management occupations",
    "cluster": 1,
    "wage": 53.57,
    "skillsComp": 46,
    "skillsLogi": 43,
    "skillsMath": 24,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 30,
    "f2Engineering": 210,
    "f3Humanities": 25,
    "f4SocialScience": 840,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 45,
    "f7Arts&Education": 155,
    "f8Education(teachertraining)": 50,
    "f9Law": 300,
    "f10Health": 260,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 930,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 60,
    "d4Humanities": 25,
    "d5SocialSciences": 840,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 35,
    "d8OtherArts&Science": 155,
    "d9Education(teachertraining)": 50,
    "d10Engineering": 150,
    "d11Law": 300,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 245,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 930,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 3,
    "noc": 13,
    "job": "Senior managers - financial, communications and other business services",
    "title1": "advertising agency president",
    "title2": "assistant executive director - financial, communications and other business services",
    "title3": "bank credit vice-president",
    "allTitles": "advertising agency presidentassistant executive director - financial, communications and other business servicesbank credit vice-presidentbank presidentCEO (chief executive officer) - financial, communications and other business servicesCEO (chief executive officer) - telephone companyCFO (chief financial officer) - advertising agencyCFO (chief financial officer) - financial, communications and other business serviceschairman - financial, communications and other business serviceschairman/woman - financial, communications and other business serviceschairperson - financial, communications and other business serviceschairwoman - financial, communications and other business serviceschief executive officer (CEO) - financial, communications and other business serviceschief executive officer (CEO) - telephone companychief financial officer (CFO) - advertising agencychief financial officer (CFO) - financial, communications and other business serviceschief operating officer - engineering firmchief operating officer - financial, communications and other business servicescomputing services company presidentcontroller - financial, communications and other business servicescorporate banking vice-presidentcorporate controller - financial, communications and other business servicescorporate controller, mortgage brokerage firmcredit union executive directorcredit union general managerdeputy chief executive officer - financial, communications and other business servicesdeputy chief executive officer, life insurance companydomestic banking operations vice-presidentemployment agency general managerengineering firm presidentengineering research general managerengineering vice-president - financial, communications and other business servicesexecutive director, credit unionexecutive director - financial, communications and other business servicesexecutive vice-president - financial, communications and other business servicesexecutive vice-president, real estate agencyfinance and administration vice-president - financial, communications and other business servicesfinance vice-president - financial, communications and other business servicesfinance vice-president - holding companygeneral manager - financial, communications and other business servicesgeneral manager, real estate management companyhuman resources and organizational development vice-president - financial, communications and other business serviceshuman resources vice-president - bankhuman resources vice-president - financial, communications and other business servicesinformation systems vice-president - financial, communications and other business servicesinsurance company general managerinternational banking operations vice-presidentmarketing vice-president - clerical staff servicesmarketing vice-president - financial, communications and other business servicesoperations vice-president - financial, communications and other business servicesoperations vice-president - satellite communication servicespersonal banking vice-presidentpersonnel vice-president - bankpersonnel vice-president - financial, communications and other business servicesplanning vice-president - financial, communications and other business servicespresident, advertising agencypresident and chief executive officerpresident and chief executive officer - financial, communications and other business servicespresident, computing service companypresident - financial, communications and other business servicesprotective services executive directorreal estate management company executive directorregional vice-president - financial, communications and other business servicesregional vice-president, trust companysenior vice-president and chief economistsupport services vice-president - financial, communications and other business servicestelecommunications general managertreasury vice-president, banking institutiontrust company general managertrust company regional vice-presidentvice-president, finance - holding companyvice-president - financial, communications and other business servicesvice-president, human resources - bankvice-president, marketing - clerical staff servicesvice-president, operations - satellite communication servicesvice-president, personnel - bank",
    "workers": 22945,
    "minEduc": 3,
    "yearsStudy": 3.873841305,
    "automationRisk": 0.063,
    "salaryLow": 28.95,
    "salaryMed": 55,
    "salaryHigh": 87.18,
    "totalSkill": 171.5,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 38.075,
    "skillsComp": 42,
    "skillsLogi": 43,
    "skillsMath": 24.5,
    "skillsLang": 62,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.5,
    "s6MoneyMath": 5.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 16.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 24.5,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 15,
    "s14Writing": 21,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 365,
    "f2Engineering": 2010,
    "f3Humanities": 225,
    "f4SocialScience": 2040,
    "f5FineArts": 490,
    "f6MathAndComputerScience": 980,
    "f7Arts&Education": 935,
    "f8Education(teachertraining)": 265,
    "f9Law": 510,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 70,
    "f12Business": 8545,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 100,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 50,
    "d4Humanities": 190,
    "d5SocialSciences": 2040,
    "d6Fine&AppliedArts": 490,
    "d7ComputerScience": 695,
    "d8OtherArts&Science": 935,
    "d9Education(teachertraining)": 265,
    "d10Engineering": 1960,
    "d11Law": 510,
    "d12Mathematics": 285,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 35,
    "d15PhysicalSciences": 265,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 70,
    "d18Business&Commerce": 8545,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 4,
    "noc": 14,
    "job": "Senior managers - health, education, social and community services and membership organizations",
    "title1": "academic business vice-president",
    "title2": "administrator, hospital",
    "title3": "assistant executive director - health, education, social and community services and membership organizations",
    "allTitles": "academic business vice-presidentadministrator, hospitalassistant executive director - health, education, social and community services and membership organizationsassociation executive directorautomobile association executive directorbusiness association general managerbusiness general managerbusiness school general managerCEO (chief executive officer) - health, education, social and community services and membership organizationsCFO (chief financial officer), educational institutionCFO (chief financial officer) - health, education, social and community services and membership organizationschairman - health, education, social and community services and membership organizationschairman/woman - health, education, social and community services and membership organizationschairperson, arts and culture associationchairperson, educators associationchairperson - health, education, social and community services and membership organizationschairperson, scientific associationchairwoman - health, education, social and community services and membership organizationschancellor - educationcharitable organization directorcharitable organization executive directorchief executive officer (CEO) - health, education, social and community services and membership organizationschief financial officer (CFO), educational institutionchief financial officer (CFO) - health, education, social and community services and membership organizationschief operating officer - health, education, social and community services and membership organizationscollege chancellorcollege presidentcommunity college presidentcorporate controller - health, education, social and community services and membership organizationscorporate controller, social services institutiondeputy chief executive officer - health, education, social and community services and membership organizationsdirector general - health, education, social and community services and membership organizationsexecutive director, alumni associationexecutive director, arts associationexecutive director, associationexecutive director, automobile associationexecutive director, crafts guildexecutive director, environmental groupexecutive director - health, education, social and community services and membership organizationsexecutive director, health services institutionexecutive director, hospitalexecutive director, NGO (non-governmental organization)executive director, non-governmental organization (NGO)executive director, nurse's associationexecutive director, professional associationexecutive director, recreational associationexecutive director, teacher's federationexecutive director, voluntary organizationexecutive director, YMCAexecutive general manager - health, education, social and community services and membership organizationsexecutive vice-president - health, education, social and community services and membership organizationsfinance and administration vice-president - health, education, social and community services and membership organizationsfinance vice-president - health, education, social and community services and membership organizationsgeneral manager - health, education, social and community services and membership organizationsgeneral manager, membership organizationhockey association general managerhospital administratorhospital executive directorhuman resources and organizational development vice-president - health, education, social and community services and membership organizationshuman resources vice-president - health, education, social and community services and membership organizationsinformation systems vice-president - health, education, social and community services and membership organizationslabour organization presidentlobby chief executive officer - health, education, social and community services and membership organizationsmarketing vice-president - health, education, social and community services and membership organizationsmedical vice-president - health servicesnursing vice-president - health, education, social and community services and membership organizationsoperations vice-president - health, education, social and community services and membership organizationspersonnel vice-president - health, education, social and community services and membership organizationsplanning vice-president - health, education, social and community services and membership organizationspolitical organization general managerpolitical party presidentpresident, academic associationpresident and general manager - health, education, social and community services and membership organizationspresident, business associationpresident, cultural associationpresident, ethnic associationpresident, health care associationpresident - health, education, social and community services and membership organizationspresident, labour organizationpresident, music guildpresident, political partypresident, sports associationrector - educationregional vice-president - health, education, social and community services and membership organizationsscientific association chairpersonsupport services vice-president - health, education, social and community services and membership organizationstrade school general managerunion association presidentuniversity presidentvice-president - health, education, social and community services and membership organizations",
    "workers": 43915,
    "minEduc": 1.5,
    "yearsStudy": 3.040179003,
    "automationRisk": 0.35,
    "salaryLow": 35.7,
    "salaryMed": 43.52,
    "salaryHigh": 86.54,
    "totalSkill": 149.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 32.76,
    "skillsComp": 44.5,
    "skillsLogi": 38,
    "skillsMath": 19,
    "skillsLang": 47.5,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 6.5,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 21.5,
    "s13DocumentUse": 16.5,
    "s14Writing": 12,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 20,
    "f2Engineering": 30,
    "f3Humanities": 295,
    "f4SocialScience": 720,
    "f5FineArts": 100,
    "f6MathAndComputerScience": 85,
    "f7Arts&Education": 160,
    "f8Education(teachertraining)": 530,
    "f9Law": 205,
    "f10Health": 640,
    "f11Health,Nursing&ClinicalLaboratory": 455,
    "f12Business": 1810,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 240,
    "d5SocialSciences": 720,
    "d6Fine&AppliedArts": 100,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 160,
    "d9Education(teachertraining)": 530,
    "d10Engineering": 30,
    "d11Law": 205,
    "d12Mathematics": 45,
    "d13Kinesiology/Recreation/PhysicalEducation": 150,
    "d14Theology": 55,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 490,
    "d17Health,Nursing&ClinicalLaboratory": 455,
    "d18Business&Commerce": 1810,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 5,
    "noc": 15,
    "job": "Senior managers - trade, broadcasting and other services, n.e.c.",
    "title1": "broadcasting corporation president",
    "title2": "casino general manager",
    "title3": "CEO (chief executive officer), deputy - trade, broadcasting and other services",
    "allTitles": "broadcasting corporation presidentcasino general managerCEO (chief executive officer), deputy - trade, broadcasting and other servicesCEO (chief executive officer) - trade, broadcasting and other servicesCEO (chief executive officer), travel agencyCFO (chief financial officer), professional sports clubCFO (chief financial officer) - trade, broadcasting and other serviceschairman - trade, broadcasting and other serviceschairman/woman - trade, broadcasting and other serviceschairperson - trade, broadcasting and other serviceschairwoman - trade, broadcasting and other serviceschief executive officer (CEO), deputy - trade, broadcasting and other serviceschief executive officer (CEO) - trade, broadcasting and other serviceschief executive officer (CEO), travel agencychief financial officer (CFO), professional sports clubchief financial officer (CFO) - trade, broadcasting and other serviceschief operating officer - trade, broadcasting and other servicescleaning service general managercorporate controller, restaurant chaincorporate controller - trade, broadcasting and other servicesdepartment store presidentdeputy chief executive officer (CEO) - trade, broadcasting and other servicesengineering vice-president - television broadcasting servicesengineering vice-president - trade, broadcasting and other servicesexecutive director - trade, broadcasting and other servicesexecutive vice-president - metal and metal products wholesalerexecutive vice-president - trade, broadcasting and other servicesfinance and administration vice-president - trade, broadcasting and other servicesfinance vice-president - food wholesalingfinance vice-president - trade, broadcasting and other servicesfuneral services general managergeneral manager, cleaning servicegeneral manager, sales - trade, broadcasting and other serviceshotel general managerhuman resources and organizational development vice-president - trade, broadcasting and other serviceshuman resources vice-president - trade, broadcasting and other servicesinformation systems vice president - trade, broadcasting and other serviceslaundry and dry cleaning general managermarketing vice-president - grocery store chainmarketing vice-president - trade, broadcasting and other servicesoperations manager - trade, broadcasting and other servicesoperations vice-president - radio broadcasting servicesoperations vice-president - trade, broadcasting and other servicespersonnel vice-president - trade, broadcasting and other servicesplanning vice-president - trade, broadcasting and other servicespresident and director - trade, broadcasting and other servicespresident and general manager - trade, broadcasting and other servicespresident, department storepresident - trade, broadcasting and other servicesradio station general managerregional vice-president, hotel chainregional vice-president - trade, broadcasting and other servicesretail establishment presidentsales and advertising vice-president - trade, broadcasting and other servicessales general manager - trade, broadcasting and other servicessales vice-president - trade, broadcasting and other servicessupport services vice-president - trade, broadcasting and other servicesvice-president and general sales manager - trade, broadcasting and other servicesvice-president, engineering - television broadcasting servicesvice-president, finance - food wholesalingvice-president, information systems - trade, broadcasting and other servicesvice-president, marketing - grocery store chainvice-president, operations - radio broadcasting servicesvice-president - trade, broadcasting and other serviceswholesaler - broadcasting",
    "workers": 8805,
    "minEduc": 0,
    "yearsStudy": 3.357142857,
    "automationRisk": 0.088,
    "salaryLow": 21,
    "salaryMed": 52.3,
    "salaryHigh": 102.54,
    "totalSkill": 170,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Senior management occupations",
    "cluster": 1,
    "wage": 52.3,
    "skillsComp": 46,
    "skillsLogi": 42,
    "skillsMath": 24,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 275,
    "f2Engineering": 880,
    "f3Humanities": 70,
    "f4SocialScience": 1015,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 260,
    "f7Arts&Education": 925,
    "f8Education(teachertraining)": 170,
    "f9Law": 155,
    "f10Health": 90,
    "f11Health,Nursing&ClinicalLaboratory": 75,
    "f12Business": 4745,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 70,
    "d5SocialSciences": 1015,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 210,
    "d8OtherArts&Science": 925,
    "d9Education(teachertraining)": 170,
    "d10Engineering": 865,
    "d11Law": 155,
    "d12Mathematics": 50,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 0,
    "d15PhysicalSciences": 215,
    "d16Therapy&Rehabilitation": 20,
    "d17Health,Nursing&ClinicalLaboratory": 75,
    "d18Business&Commerce": 4745,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 6,
    "noc": 16,
    "job": "Senior managers - construction, transportation, production and utilities",
    "title1": "assistant executive director - goods production, utilities, transportation and construction",
    "title2": "building construction general manager",
    "title3": "CEO (chief executive officer) - goods production, utilities, transportation and construction",
    "allTitles": "assistant executive director - goods production, utilities, transportation and constructionbuilding construction general managerCEO (chief executive officer) - goods production, utilities, transportation and constructionCEO (chief executive officer) - manufacturing companyCFO (chief financial officer) - goods production, utilities, transportation and constructionCFO (chief financial officer) - urban transit systemchief executive officer (CEO) - goods production, utilities, transportation and constructionchief executive officer (CEO) - manufacturing companychief financial officer (CFO) - goods production, utilities, transportation and constructionchief financial officer (CFO) - urban transit systemchief operating officer - goods production, utilities, transportation and constructionconstruction general managercorporate controller - goods production, utilities, transportation and constructioncorporate controller, logging companydeputy chief executive officer - goods production, utilities, transportation and constructionelectric power company presidentengineering vice-president - goods production, utilities, transportation and constructionexecutive director - goods production, utilities, transportation and constructionexecutive vice-president - goods production, utilities, transportation and constructionexecutive vice-president - railwayfeed and flour mills general managerfinance and administration vice-president - goods production, utilities, transportation and constructionfinance vice-president - goods production, utilities, transportation and constructionfinance vice-president - mining companygas distribution general managergeneral manager - goods production, utilities, transportation and constructiongeneral manager, trucking companyhighway construction general managerhuman resources and organizational development vice-president - goods production, utilities, transportation and constructionhuman resources vice-president - goods production, utilities, transportation and constructionhydro-electric power station presidentinformation systems vice-president - goods production, utilities, transportation and constructionmanufacturing company chief executive officermarketing vice-president - airlinemarketing vice-president - goods production, utilities, transportation and constructionoperations vice-president - electric power companyoperations vice-president - goods production, utilities, transportation and constructionpersonnel vice-president - goods production, utilities, transportation and constructionplanning vice-president - goods production, utilities, transportation and constructionpresident - goods production, utilities, transportation and constructionpresident, residential construction companyproduction general manager - goods production, utilities, transportation and constructionpublisherpublishing house general managerregional vice-president - goods production, utilities, transportation and constructionregional vice-president, petroleum production companyresidential construction company presidentsales vice-president - goods production, utilities, transportation and constructionsales vice-president - pulp and paper manufacturingsupport services vice-president - goods production, utilities, transportation and constructiontransit system general managertransport and communications general managertrucking company general managervice-president, engineering - goods production, utilities, transportation and constructionvice-president, finance - mining companyvice-president - goods production, utilities, transportation and constructionvice-president, human resources and organizational development - goods production, utilities, transportation and constructionvice-president, human resources - goods production, utilities, transportation and constructionvice-president, marketing - airlinevice-president, operations - electric power companyvice-president, sales - pulp and paper manufacturing",
    "workers": 9695,
    "minEduc": 0,
    "yearsStudy": 2.927672956,
    "automationRisk": 0.479,
    "salaryLow": 24.68,
    "salaryMed": 52.88,
    "salaryHigh": 84.13,
    "totalSkill": 145,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Senior management occupations",
    "cluster": 1,
    "wage": 35.44,
    "skillsComp": 39.5,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 48.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 15.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16.5,
    "s13DocumentUse": 17.5,
    "s14Writing": 13.5,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 555,
    "f2Engineering": 2430,
    "f3Humanities": 50,
    "f4SocialScience": 555,
    "f5FineArts": 130,
    "f6MathAndComputerScience": 110,
    "f7Arts&Education": 1275,
    "f8Education(teachertraining)": 95,
    "f9Law": 60,
    "f10Health": 70,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 4310,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 55,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 165,
    "d4Humanities": 50,
    "d5SocialSciences": 555,
    "d6Fine&AppliedArts": 130,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 1275,
    "d9Education(teachertraining)": 95,
    "d10Engineering": 2265,
    "d11Law": 60,
    "d12Mathematics": 60,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 0,
    "d15PhysicalSciences": 500,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 4310,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 7,
    "noc": 111,
    "job": "Financial managers",
    "title1": "accounting and financial control chief",
    "title2": "accounting and financial control director",
    "title3": "accounting department manager",
    "allTitles": "accounting and financial control chiefaccounting and financial control directoraccounting department manageraccounting directoraccounting manageraccounting manager - financial services departmentaccounting office manageradministrator, pension plansassigned public accountants chiefassistant accounting managerassistant treasurer - financesaudit and compliance directorauditing department managerchief, accounting and financial controlcollections department managercontroller - financial servicescorporate budgeting and analysis managercorporate financing managercorporate risk department managerdepartment manager, collectionsdirector, accounting and financial controldirector, audit and compliancedirector, budget and sectoral profitabilitydirector, financedirector, financial evaluationsdirector, financial planning and reportingdirector - financial servicesdirector, financing and administrationdirector of accountingdirector-treasurer - financial servicesfinance and control managerfinance chieffinance directorfinance managerfinancial administratorfinancial audit managerfinancial controllerfinancial control managerfinancial directorfinancial evaluations directorfinancial managerfinancial planning and advisory service managerfinancial planning and analysis managerfinancial planning and reporting directorfinancial planning and reporting managerfinancial resources service co-ordinatorfinancing and administration directorgroup accounting managerindependent public accountants chiefinternal audit managerinternal audit services managerinvestments research directormanager, accountingmanager, auditing departmentmanager, collectionmanager, corporate budgeting and analysismanager, corporate financingmanager, corporate risk departmentmanager, financemanager, financial controlmanager, financial planning and analysismanager, financial planning and reportingmanager, internal auditsmanager, internal audit servicesmanager of accounting departmentmanager of auditing departmentmanager, pension servicespension plans administratorpension services managerregional controller - financial servicesresearch director, investmentsrevenue accounting and controls section chieftreasurertreasurer and controller - finances",
    "workers": 25715,
    "minEduc": 0,
    "yearsStudy": 3.448412698,
    "automationRisk": 0.069,
    "salaryLow": 21.23,
    "salaryMed": 44.87,
    "salaryHigh": 72.12,
    "totalSkill": 167,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 44.87,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 230,
    "f2Engineering": 410,
    "f3Humanities": 140,
    "f4SocialScience": 2195,
    "f5FineArts": 305,
    "f6MathAndComputerScience": 895,
    "f7Arts&Education": 675,
    "f8Education(teachertraining)": 390,
    "f9Law": 485,
    "f10Health": 245,
    "f11Health,Nursing&ClinicalLaboratory": 255,
    "f12Business": 19490,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 140,
    "d5SocialSciences": 2195,
    "d6Fine&AppliedArts": 305,
    "d7ComputerScience": 485,
    "d8OtherArts&Science": 675,
    "d9Education(teachertraining)": 390,
    "d10Engineering": 410,
    "d11Law": 485,
    "d12Mathematics": 410,
    "d13Kinesiology/Recreation/PhysicalEducation": 90,
    "d14Theology": 0,
    "d15PhysicalSciences": 145,
    "d16Therapy&Rehabilitation": 155,
    "d17Health,Nursing&ClinicalLaboratory": 255,
    "d18Business&Commerce": 19490,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 8,
    "noc": 112,
    "job": "Human resources managers",
    "title1": "administrator, human resources",
    "title2": "benefits manager",
    "title3": "chief, classification and compensation",
    "allTitles": "administrator, human resourcesbenefits managerchief, classification and compensationchief, employment equitychief, official languageschief, personnelchief, staffingchief, staff relationschief, staff training and developmentchief, trainingclassification and compensation chiefcompensation managerco-ordinator, staff trainingdirector, employee benefitsdirector, employment equity - human resourcesdirector, human resourcesdirector, human resources developmentdirector, human resources development and planningdirector, human resources managementdirector, labour relationsdirector, language trainingdirector, occupational training - human resourcesdirector, pay and benefitsdirector, pay-processing division - government servicesdirector, pay services - human resourcesdirector, personneldirector, personnel and industrial relationsdirector, personnel servicesdirector, recruitingdirector, vocational training - human resourcesemployee benefits directoremployee benefits manageremployer-employee relations manageremployment equity chiefemployment equity director - human resourcesemployment equity manager - human resourcesemployment managerhealth and safety co-ordinatorhuman resources administratorhuman resources development and planning directorhuman resources development directorhuman resources directorhuman resources management directorhuman resources managerhuman resources planning managerindustrial relations managerjob evaluation and salary research managerlabour relations directorlabour relations managerlanguage training directormanager, benefitsmanager, compensationmanager, disability management programmanager, employee benefitsmanager, employer-employee relationsmanager, employmentmanager, employment equity - human resourcesmanager, human resourcesmanager, human resources planningmanager, industrial relationsmanager, job evaluation and salary researchmanager, labour relationsmanager, occupational health and safetymanager, official languagesmanager, pay and benefitsmanager, pensions and benefitsmanager, personnelmanager, personnel administrationmanager, personnel servicesmanager, personnel training and developmentmanager, recruitingmanager, salary research and administrationmanager, staff relationsmanager, staff training and developmentmanager, training and developmentmanager, wage and salary administrationoccupational health and safety manageroccupational training director - human resourcesofficial languages chiefofficial languages managerpay and benefits directorpay and benefits managerpay-processing division director - government servicespay services director - human resourcespensions and benefits managerpersonnel administration managerpersonnel and industrial relations directorpersonnel chiefpersonnel directorpersonnel managerpersonnel services directorpersonnel services managerpersonnel training and development managerrecruiting directorrecruiting managersalary research and administration managerstaffing chiefstaff relations chiefstaff relations managerstaff training and development chief",
    "workers": 13860,
    "minEduc": 0,
    "yearsStudy": 3.493617021,
    "automationRisk": 0.006,
    "salaryLow": 25.64,
    "salaryMed": 43.27,
    "salaryHigh": 69.67,
    "totalSkill": 196,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 43.27,
    "skillsComp": 34,
    "skillsLogi": 50,
    "skillsMath": 21,
    "skillsLang": 91,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 17,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 27,
    "s9ProblemSolving": 17,
    "s10Reading": 33,
    "s11SchedulingorBudgetingandAccounting": 15,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 10,
    "s14Writing": 31,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 130,
    "f2Engineering": 390,
    "f3Humanities": 230,
    "f4SocialScience": 2095,
    "f5FineArts": 415,
    "f6MathAndComputerScience": 105,
    "f7Arts&Education": 685,
    "f8Education(teachertraining)": 510,
    "f9Law": 380,
    "f10Health": 320,
    "f11Health,Nursing&ClinicalLaboratory": 475,
    "f12Business": 8125,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 230,
    "d5SocialSciences": 2095,
    "d6Fine&AppliedArts": 415,
    "d7ComputerScience": 90,
    "d8OtherArts&Science": 685,
    "d9Education(teachertraining)": 510,
    "d10Engineering": 390,
    "d11Law": 380,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 105,
    "d14Theology": 0,
    "d15PhysicalSciences": 35,
    "d16Therapy&Rehabilitation": 215,
    "d17Health,Nursing&ClinicalLaboratory": 475,
    "d18Business&Commerce": 8125,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 9,
    "noc": 113,
    "job": "Purchasing managers",
    "title1": "building supplies purchasing manager",
    "title2": "chief, purchasing",
    "title3": "clothing purchasing director",
    "allTitles": "building supplies purchasing managerchief, purchasingclothing purchasing directorclothing purchasing managercontract directorcontract managerdirector, procurement operationsdirector, purchasingdirector, supply managementelectronic components purchasing chiefelectronic components purchasing directorelectronic components purchasing managerequipment managerfood purchasing directorfood purchasing managerhardware purchasing directorhardware purchasing managermanager, procurementmanager, purchasing contractsmaterial and services purchasing managermaterial managermerchandise purchasing directormerchandise purchasing manageroffice equipment purchasing managerprocurement directorprocurement managerprocurement operations directorpurchasing chiefpurchasing contracts directorpurchasing contracts managerpurchasing directorpurchasing managersupply chain directorsupply chain logistics managersupply chain managersupply chiefsupply-management directorsupply service chief",
    "workers": 2635,
    "minEduc": 0,
    "yearsStudy": 3.5,
    "automationRisk": 0.03,
    "salaryLow": 22.97,
    "salaryMed": 43.00333333,
    "salaryHigh": 70.5,
    "totalSkill": 158,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 36.47605804,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 230,
    "f3Humanities": 0,
    "f4SocialScience": 160,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 155,
    "f8Education(teachertraining)": 0,
    "f9Law": 10,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 2055,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 160,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 155,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 230,
    "d11Law": 10,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 2055,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 10,
    "noc": 114,
    "job": "Other administrative services managers",
    "title1": "accounting records manager",
    "title2": "account records manager",
    "title3": "administration and property management services director",
    "allTitles": "accounting records manageraccount records manageradministration and property management services directoradministrative manageradministrative records department manageradministrative records manageradministrative services chiefadministrative services directoradministrative services manageradministrative support services manageradministrator, recordsbranch manager - administrationbuildings, vehicles and supplies managerbusiness manager - non-profit organizationchartered administrator - managementchartered secretary - managementchief, administrative serviceschief, financial and administrative serviceschief, legal departmentchief, management services divisiondepartment manager, securitydirector, administration and property management servicesdirector, administrative servicesdirector, finance and administrationdirector, legal departmentdirector, operational planningdivision administrative managerfinance and administration directorfinancial and administrative services chiefhealth records administratorhospital admissions directorinventory control managerinventory managerlegal department chieflegal department directormanagement services division chiefmanager, administrative recordsmanager, administrative servicesmanager, administrative support servicesmanager, buildings, vehicles and suppliesmanager, medical recordsmanager, patient registrationmanager, securitymanager, security departmentmanager, support servicesmanaging directormaterial control managermedical records department managermedical records manageroffice manager - non-profit organizationoperational planning directoroperations chiefoperations director - administrative servicesoperations manager - administrative servicesorganizational rules analysis managerorganization rules analysis managerpatient-registration managerplanning and organizational development managerrecords administratorrecords management services managerrecords managerregional administrative managersecurity department managersecurity managersupport services administrative managersupport services manager",
    "workers": 4955,
    "minEduc": 0,
    "yearsStudy": 3.477272727,
    "automationRisk": 0.73,
    "salaryLow": 22.04,
    "salaryMed": 40.87,
    "salaryHigh": 69.71,
    "totalSkill": 137,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 40.87,
    "skillsComp": 37,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 35,
    "f2Engineering": 260,
    "f3Humanities": 75,
    "f4SocialScience": 635,
    "f5FineArts": 125,
    "f6MathAndComputerScience": 90,
    "f7Arts&Education": 325,
    "f8Education(teachertraining)": 230,
    "f9Law": 435,
    "f10Health": 115,
    "f11Health,Nursing&ClinicalLaboratory": 150,
    "f12Business": 2480,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 40,
    "d4Humanities": 75,
    "d5SocialSciences": 635,
    "d6Fine&AppliedArts": 125,
    "d7ComputerScience": 90,
    "d8OtherArts&Science": 325,
    "d9Education(teachertraining)": 230,
    "d10Engineering": 220,
    "d11Law": 435,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 40,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 75,
    "d17Health,Nursing&ClinicalLaboratory": 150,
    "d18Business&Commerce": 2480,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 11,
    "noc": 121,
    "job": "Insurance, real estate and financial brokerage managers",
    "title1": "bond sales manager",
    "title2": "branch manager - insurance",
    "title3": "branch manager, real estate",
    "allTitles": "bond sales managerbranch manager - insurancebranch manager, real estatebrokerage manager - investmentsbusiness development manager - damage insurancecommission brokers manager - investmentscommodities trading managerdistrict manager, insurance salesdistrict manager, real estate salesdistrict sales manager, real estatefinancial brokerage managerfutures research managerfutures research services managergrain trading managerinsurance benefits executive directorinsurance claims service managerinsurance managerinsurance managing directorinsurance regional managerinsurance sales district managerinsurance sales managerinvestment director - financial brokerageinvestment managerinvestment manager - financial brokerageleasing manager - real estateliability trading managermanager, insurance salesmanager, leasing - real estatemanager, liability tradingmanager, mortgage brokersmanager, petroleum research - securitiesmanager, real estate officemanager, real estate salesmanager, securities and investmentmanager, trading floormanager, underwriting departmentmanaging director, insurancemanaging director, real estate salesmanaging supervisor, real estate agentsmortgage broker managermutual funds manager - financial brokeragenational sales manager, real estatepetroleum research manager - securitiesreal estate agents managing supervisorreal estate branch managerreal estate developerreal estate national sales managerreal estate office managerreal estate sales district managerreal estate sales managerreal estate sales managing directorreal estate service managerrealtorresearch director, securitiessales manager, insurancesecurities and investment managersecurities managersecurities research directorsecurities research managersecurities sales directortrading floor managerunderwriting department manager",
    "workers": 10105,
    "minEduc": 0,
    "yearsStudy": 3.21761658,
    "automationRisk": 0.81,
    "salaryLow": 24.04,
    "salaryMed": 52.82,
    "salaryHigh": 74.09,
    "totalSkill": 139,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 52.82,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 80,
    "f2Engineering": 380,
    "f3Humanities": 205,
    "f4SocialScience": 1430,
    "f5FineArts": 300,
    "f6MathAndComputerScience": 300,
    "f7Arts&Education": 505,
    "f8Education(teachertraining)": 125,
    "f9Law": 330,
    "f10Health": 75,
    "f11Health,Nursing&ClinicalLaboratory": 170,
    "f12Business": 6205,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 135,
    "d4Humanities": 205,
    "d5SocialSciences": 1430,
    "d6Fine&AppliedArts": 300,
    "d7ComputerScience": 190,
    "d8OtherArts&Science": 505,
    "d9Education(teachertraining)": 125,
    "d10Engineering": 245,
    "d11Law": 330,
    "d12Mathematics": 110,
    "d13Kinesiology/Recreation/PhysicalEducation": 60,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 15,
    "d17Health,Nursing&ClinicalLaboratory": 170,
    "d18Business&Commerce": 6205,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 12,
    "noc": 122,
    "job": "Banking, credit and other investment managers",
    "title1": "accounts manager - banking, credit and investment",
    "title2": "accounts manager, commercial mortgages",
    "title3": "area manager - banking, credit and investment",
    "allTitles": "accounts manager - banking, credit and investmentaccounts manager, commercial mortgagesarea manager - banking, credit and investmentassistant branch manager - banking, credit and investmentassistant consumer credit managerassistant corporate banking services managerassistant credit managerassistant manager, consumer creditassistant manager, corporate banking servicesassistant manager, creditassistant manager, operations - banking, credit and investmentassistant operations manager - banking, credit and investmentassistant regional manager - bankingbank branch managerbank directorbanking accounts managerbanking operations managerbank managerbranch administrative manager - banking, credit and investmentbranch manager - banking, credit and investmentcollection centre managercollection managercollection manager - bank or trust companycommercial attach�commercial banking managercommercial mortgages accounts managercommercial mortgages managerconsumer credit management traineeconsumer credit services manager traineecorporate accounts manager - banking, credit and investmentcorporate banking centre managercorporate trust services managercredit and accounts managercredit and collection department managercredit and collection managercredit approval and market development managercredit area co-ordinatorcredit card centre managercredit card company operations managercredit managercredit union managerfinancial services managerinternational banking managerinvestment manager - banking, credit and investmentinvestment manager - bank or trust companyloan and credit manager - banking or trust companyloans managerloans manager traineemanagement trainee, consumer creditmanager, bankmanager, banking operationsmanager, collection centremanager, corporate accounts - banking, credit and investmentmanager, corporate banking centremanager, corporate services - banking, credit and investmentmanager, corporate trust servicesmanager, credit and collectionmanager, credit card centremanager, credit unionmanager, international bankingmanager, loansmanager, mortgagesmanager, operations - banking, credit and investmentmanager, personal services - banking, credit and investmentmanager, personal trustmanager trainee, consumer credit servicesmanager, trust companymortgage and consumer credit managermortgage manageroperations manager - banking, credit and investmentoperations manager, credit card companypersonal trust managerregional bank managerregional collection managerregional credit managerregional manager, banksenior accounts manager - banking, credit and investmentsenior manager, personal financial servicestrust company branch managertrust company investment managertrust company manager",
    "workers": 27375,
    "minEduc": 0.5,
    "yearsStudy": 2.916601153,
    "automationRisk": 0.3645,
    "salaryLow": 25,
    "salaryMed": 45.13,
    "salaryHigh": 75.55,
    "totalSkill": 131.5,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 29.14,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19.5,
    "skillsLang": 43,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 8.5,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 17.5,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 11.5,
    "s13DocumentUse": 18,
    "s14Writing": 11.5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 175,
    "f2Engineering": 550,
    "f3Humanities": 445,
    "f4SocialScience": 3315,
    "f5FineArts": 410,
    "f6MathAndComputerScience": 1040,
    "f7Arts&Education": 1185,
    "f8Education(teachertraining)": 330,
    "f9Law": 520,
    "f10Health": 75,
    "f11Health,Nursing&ClinicalLaboratory": 250,
    "f12Business": 15675,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 120,
    "d2Forestry": 35,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 435,
    "d5SocialSciences": 3315,
    "d6Fine&AppliedArts": 410,
    "d7ComputerScience": 680,
    "d8OtherArts&Science": 1185,
    "d9Education(teachertraining)": 330,
    "d10Engineering": 535,
    "d11Law": 520,
    "d12Mathematics": 360,
    "d13Kinesiology/Recreation/PhysicalEducation": 30,
    "d14Theology": 10,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 45,
    "d17Health,Nursing&ClinicalLaboratory": 250,
    "d18Business&Commerce": 15675,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 13,
    "noc": 124,
    "job": "Advertising, marketing and public relations managers",
    "title1": "advertising administrator",
    "title2": "advertising agency manager",
    "title3": "advertising director",
    "allTitles": "advertising administratoradvertising agency manageradvertising directoradvertising manageragency marketing department managerbusiness manager - sales and advertisingcampaign managercirculation managercommercial network development managercommunications directorcommunications director - sales and marketingcommunications managercommunications manager, Internetcommunications manager - public relationscorrespondence and public inquiries managerdirector, advertisingdirector, communicationsdirector, external relationsdirector, marketingdirector, media relationsdirector, public affairsdirector, public informationdirector, public relationsdirector, regional communicationsdirector, sales agency marketing divisiondirector, sales and marketinge-business (electronic business) managere-business managere-commerce (electronic commerce) managere-commerce managerelection campaign managerelectronic business (e-business) managerelectronic commerce (e-commerce) managerexternal relations directorfundraising campaign managerinformation and communications managerinformation service managerInternet communications managerInternet site managermanager, advertisingmanager, advertising agencymanager, agency marketing departmentmanager, campaignmanager, circulationmanager, communicationsmanager, correspondence and public inquiriesmanager, e-businessmanager, e-commercemanager, election campaignmanager, fundraising campaignmanager, information and communicationsmanager, information servicemanager, marketingmanager - marketing servicesmanager, media advertisingmanager, media relationsmanager, promotionsmanager, publicitymanager, public relationsmanager, sales and advertisingmanager, sales and marketingmanager, sales and publicitymanager, sales promotionmarket development managermarketing directormarketing division director, sales agencymarketing executivemarketing managermarketing manager - online marketingmedia advertising managermedia relations directormedia relations managerpromotions managerpublic affairs directorpublic information directorpublicity administratorpublicity directorpublicity managerpublic relations directorpublic relations managerregional communications directorsales agency marketing division directorsales and advertising managersales and marketing directorsales and marketing managersales and publicity managersales director - computer marketing developmentsales promotion managerWeb communications managerWeb marketing manager",
    "workers": 19670,
    "minEduc": 0,
    "yearsStudy": 3.593059937,
    "automationRisk": 0.023,
    "salaryLow": 22.5,
    "salaryMed": 38.46,
    "salaryHigh": 73.33,
    "totalSkill": 166,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 38.46,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 210,
    "f2Engineering": 850,
    "f3Humanities": 450,
    "f4SocialScience": 4710,
    "f5FineArts": 2235,
    "f6MathAndComputerScience": 360,
    "f7Arts&Education": 1260,
    "f8Education(teachertraining)": 260,
    "f9Law": 235,
    "f10Health": 230,
    "f11Health,Nursing&ClinicalLaboratory": 120,
    "f12Business": 8750,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 90,
    "d2Forestry": 45,
    "d3Architecture&LandscapeArchitecture": 35,
    "d4Humanities": 380,
    "d5SocialSciences": 4710,
    "d6Fine&AppliedArts": 2235,
    "d7ComputerScience": 295,
    "d8OtherArts&Science": 1260,
    "d9Education(teachertraining)": 260,
    "d10Engineering": 815,
    "d11Law": 235,
    "d12Mathematics": 65,
    "d13Kinesiology/Recreation/PhysicalEducation": 200,
    "d14Theology": 70,
    "d15PhysicalSciences": 75,
    "d16Therapy&Rehabilitation": 30,
    "d17Health,Nursing&ClinicalLaboratory": 120,
    "d18Business&Commerce": 8750,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 14,
    "noc": 125,
    "job": "Other business services managers",
    "title1": "accounting firm manager",
    "title2": "accounting firm manager - business services",
    "title3": "audit firm manager",
    "allTitles": "accounting firm manageraccounting firm manager - business servicesaudit firm managerauditing firm managercall centre managerconference development managerconference services managercontact centre managercustoms manager - business servicesdetective agency managerdirector, organizational methods analysisdirector, organizational methods analysis - business servicesdirector, organizational planning and developmentemployment agency manageremployment office managerenergy asset joint venture managerhead, management services division - business serviceshead, organizational servicesland contracts managerlegal firm managermanagement consulting service managermanager, accounting firmmanager, auditing firmmanager, detective agencymanager, employment agencymanager, employment officemanager, legal firmmanager, management consulting servicemanager, market research servicemanager, methods and proceduresmanager, mineral land and contractsmanager, nursing registrymanager, payroll servicemanager, personnel agencymanager, personnel consulting servicemanager, placement agencymanager, placement officemanager, private investigation and security servicemanager, security servicemanager, surface land administrationmanager, survey research servicemarket research service managermethods and procedures managermineral land administration managernursing registry managerorganizational methods analysis directororganizational methods analysis director - business servicesorganizational methods analysis managerorganizational planning and development directorpayroll service managerpersonnel agency managerpersonnel consulting service managerplacement agency managerplacement office managerprivate investigation and security service managerprofessional services manager - business servicessecurity service managersurvey research service managerwell and facilities asset manager",
    "workers": 1665,
    "minEduc": 0,
    "yearsStudy": 3.338709677,
    "automationRisk": 0.232,
    "salaryLow": 23.84666667,
    "salaryMed": 45.47,
    "salaryHigh": 74.32333333,
    "totalSkill": 151,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 32.68485074,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 80,
    "f3Humanities": 20,
    "f4SocialScience": 160,
    "f5FineArts": 80,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 105,
    "f8Education(teachertraining)": 0,
    "f9Law": 120,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 1085,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 160,
    "d6Fine&AppliedArts": 80,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 105,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 80,
    "d11Law": 120,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 1085,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 15,
    "noc": 131,
    "job": "Telecommunication carriers managers",
    "title1": "communications manager - telecommunications",
    "title2": "co-ordinator of technical services - telecommunications",
    "title3": "dial plant manager - telecommunications",
    "allTitles": "communications manager - telecommunicationsco-ordinator of technical services - telecommunicationsdial plant manager - telecommunicationsdial plant superintendent - telecommunicationsdirector, switching systemsdistrict manager - telecommunicationsdistrict manager, telephone companyearth station manager - telecommunicationsequipment chief - telecommunicationsfacilities manager, telecommunicationsinstallation manager, telecommunicationsinstallation superintendent - telecommunicationsmanager, earth station - telecommunicationsmanager, network installationmanager, network installation - telecommunicationsmanager, networks - telecommunicationsmanager, space programs - telecommunicationsmanager, telecommunications servicesmicrowave facilities managermicrowave facilities manager - telecommunicationsnetwork conduct centre assistant managernetwork installation manager - telecommunicationsnetwork operations managernetwork operations manager - telecommunicationsnetwork services managernetwork services manager - telecommunicationsnetworks manager - telecommunicationsnetwork traffic manager - telecommunicationsoperations and transmission services manageroperations and transmission services manager - telecommunicationsoperations manager - telecommunicationsproduction manager - telecommunicationsregional manager - telecommunications systemspace programs manager - telecommunicationssurveillance manager - telecommunicationsswitching systems director - telecommunicationstechnical services co-ordinator - telecommunicationstechnical services managertelecommunications managertelecommunications services managertelephone company district managertraffic chief - telecommunicationstraffic manager - cable systemstraffic manager - telephone systemtransmission traffic manager - telecommunications",
    "workers": 2895,
    "minEduc": 0,
    "yearsStudy": 3.5,
    "automationRisk": 0.25,
    "salaryLow": 31.25,
    "salaryMed": 41.6,
    "salaryHigh": 67.31,
    "totalSkill": 158,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 41.6,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 15,
    "f2Engineering": 1020,
    "f3Humanities": 0,
    "f4SocialScience": 290,
    "f5FineArts": 40,
    "f6MathAndComputerScience": 280,
    "f7Arts&Education": 90,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 1140,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 290,
    "d6Fine&AppliedArts": 40,
    "d7ComputerScience": 220,
    "d8OtherArts&Science": 90,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1020,
    "d11Law": 20,
    "d12Mathematics": 60,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 1140,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 16,
    "noc": 132,
    "job": "Postal and courier services managers",
    "title1": "area manager - postal service",
    "title2": "collection and delivery operations manager - postal service",
    "title3": "commercial development manager - postal and courier services",
    "allTitles": "area manager - postal servicecollection and delivery operations manager - postal servicecommercial development manager - postal and courier servicescourier service managerdelivery service manager - postal and courier servicesdirector, district post officedistrict post office directorfield service manager - postal and courier servicesmail operations managermail processing plant managermail processing plant superintendentmanager, collection and delivery operationsmanager, collection and delivery operations - postal servicemanager, commercial development - postal and courier servicesmanager, courier servicemanager, mail operationsmanager, mail processing plantmanager, messenger servicemanager, parcel processing plantmanager, plant operations - postal servicemanager, postal areamanager, postal zonemanager, postal zone facilitiesmanager, post officemanager, production control - postal servicemanager, regional services - postal and courier servicesmessenger service managerparcel processing plant managerplant manager - postal and courier servicesplant operations manager - postal serviceplant superintendent - postal and courier servicespostal area managerpostal station superintendentpostal zone facilities managerpostal zone managerpost office managerproduction control manager - postal serviceregional services manager - postal and courier servicessuperintendent, mail processing plant",
    "workers": 950,
    "minEduc": 0,
    "yearsStudy": 2.971428572,
    "automationRisk": 0.345,
    "salaryLow": 31.25,
    "salaryMed": 41.6,
    "salaryHigh": 67.31,
    "totalSkill": 147.5,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 26.12289018,
    "skillsComp": 40,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 50,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 9.5,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14.5,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 285,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 285,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 17,
    "noc": 211,
    "job": "Engineering managers",
    "title1": "aerospace engineering service head",
    "title2": "civil engineering division manager",
    "title3": "director, engineering research and development",
    "allTitles": "aerospace engineering service headcivil engineering division managerdirector, engineering research and developmentdirector engineering service, quality assurancedirector, engineering service quality control departmentdirector engineering service, safety serviceelectrical engineering service managerengineering delivery chiefengineering department managerengineering managerengineering research and development directorengineering service group managerengineering service managerengineering service project managerengineering service quality assurance directorengineering service quality assurance managerengineering service quality control department directorengineering service quality control managerengineering service quality system managerengineering service safety service directorengineering service superintendentindustrial engineering department managermanager, civil engineering divisionmanager, electrical engineering servicemanager, engineeringmanager, engineering departmentmanager, engineering servicemanager, engineering service groupmanager engineering service, quality assurancemanager, engineering service quality controlmanager, industrial engineering departmentmanager, mechanical engineering servicemanager, production engineeringmanager, telecommunications engineering servicemanager, traffic engineering service - telecommunicationsmechanical engineering service managerproduction engineering managersuperintendent, engineering servicetelecommunications engineering service managertraffic engineering service manager - telecommunications",
    "workers": 5620,
    "minEduc": 0,
    "yearsStudy": 3.725274725,
    "automationRisk": 0.017,
    "salaryLow": 38.46,
    "salaryMed": 55.29,
    "salaryHigh": 86.54,
    "totalSkill": 174,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 55.29,
    "skillsComp": 47,
    "skillsLogi": 44,
    "skillsMath": 24,
    "skillsLang": 60,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 110,
    "f2Engineering": 4800,
    "f3Humanities": 0,
    "f4SocialScience": 15,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 95,
    "f7Arts&Education": 125,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 475,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 40,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 0,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 95,
    "d8OtherArts&Science": 125,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 4785,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 475,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 18,
    "noc": 212,
    "job": "Architecture and science managers",
    "title1": "statistical service manager",
    "title2": "landscape architecture manager",
    "title3": "manager, life sciences program",
    "allTitles": "statistical service manager",
    "workers": 12760,
    "minEduc": 0,
    "yearsStudy": 3.627562736,
    "automationRisk": 0.026,
    "salaryLow": 29.81,
    "salaryMed": 38.46,
    "salaryHigh": 60.1,
    "totalSkill": 172,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 52.005,
    "skillsComp": 46.5,
    "skillsLogi": 43.5,
    "skillsMath": 24,
    "skillsLang": 59,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7.5,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23.5,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21.5,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 10.5,
    "f1Science&Agriculture": 427.5,
    "f2Engineering": 4477.5,
    "f3Humanities": 80,
    "f4SocialScience": 527.5,
    "f5FineArts": 190,
    "f6MathAndComputerScience": 3947.5,
    "f7Arts&Education": 587.5,
    "f8Education(teachertraining)": 37.5,
    "f9Law": 37.5,
    "f10Health": 37.5,
    "f11Health,Nursing&ClinicalLaboratory": 12.5,
    "f12Business": 2397.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 95,
    "d2Forestry": 32.5,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 72.5,
    "d5SocialSciences": 527.5,
    "d6Fine&AppliedArts": 190,
    "d7ComputerScience": 3550,
    "d8OtherArts&Science": 587.5,
    "d9Education(teachertraining)": 37.5,
    "d10Engineering": 4462.5,
    "d11Law": 37.5,
    "d12Mathematics": 397.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 37.5,
    "d14Theology": 7.5,
    "d15PhysicalSciences": 300,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 12.5,
    "d18Business&Commerce": 2397.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 19,
    "noc": 213,
    "job": "Computer and information systems managers",
    "title1": "communication systems design manager",
    "title2": "computer and related services manager",
    "title3": "computer applications manager",
    "allTitles": "communication systems design managercomputer and related services managercomputer applications managercomputer department co-ordinatorcomputer development division headcomputer facility managercomputerized information systems managercomputerized technical information managercomputer managercomputer networks managercomputer programs managercomputer projects managercomputer software design managercomputer system operations managercomputer systems development managercomputer systems managerdata centre managerdata processing and systems analysis managerdata processing directordata processing managerdata processing planning managerdirector, data processingdirector, information systems developmentdirector, information systems operationsdirector of technology managementdirector, software engineeringEDP (electronic data processing) managerelectronic data processing (EDP) managerinformation systems managerinformation technology (IT) development managerinformation technology (IT) integration managerInternet systems administratorIT (information technology) development managerIT (information technology) integration managermanagement information system (MIS) managermanager, computer and related servicesmanager, computer application developmentmanager, computer applicationsmanager, computer facilitymanager, computerized information systemsmanager, computer legacy systemsmanager, computer system operationsmanager, computer systemsmanager, computer systems developmentmanager, data centremanager, data processingmanager, data processing and systems analysismanager, data processing planningmanager, EDP (electronic data processing)manager, electronic data processing (EDP)manager, information systemsmanager, information technology (IT) implementationmanager, information technology (IT) integrationmanager, IT (information technology) implementationmanager, IT (information technology) integrationmanager, management information system (MIS)manager, MIS (management information system)manager, network designmanager, software engineeringmanager, systems - computer systemsmanager, systems development - computer systemsMIS (management information system) managersoftware development managersystems development managersystems development manager - computer systemssystems implementation manager - computer systemssystems integration manager - computer systemssystems manager - computer systemssystems operations manager - computer systems",
    "workers": 19900,
    "minEduc": 0,
    "yearsStudy": 3.529850746,
    "automationRisk": 0.035,
    "salaryLow": 26.44,
    "salaryMed": 48.72,
    "salaryHigh": 72.12,
    "totalSkill": 170,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 48.72,
    "skillsComp": 46,
    "skillsLogi": 43,
    "skillsMath": 24,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 745,
    "f2Engineering": 4155,
    "f3Humanities": 160,
    "f4SocialScience": 1040,
    "f5FineArts": 380,
    "f6MathAndComputerScience": 7800,
    "f7Arts&Education": 1050,
    "f8Education(teachertraining)": 75,
    "f9Law": 75,
    "f10Health": 75,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 4320,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 175,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 145,
    "d5SocialSciences": 1040,
    "d6Fine&AppliedArts": 380,
    "d7ComputerScience": 7005,
    "d8OtherArts&Science": 1050,
    "d9Education(teachertraining)": 75,
    "d10Engineering": 4140,
    "d11Law": 75,
    "d12Mathematics": 795,
    "d13Kinesiology/Recreation/PhysicalEducation": 75,
    "d14Theology": 15,
    "d15PhysicalSciences": 545,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 4320,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 20,
    "noc": 311,
    "job": "Managers in health care",
    "title1": "administrator, blood bank",
    "title2": "administrator, dental health services",
    "title3": "administrator, nursing unit",
    "allTitles": "administrator, blood bankadministrator, dental health servicesadministrator, nursing unitadministrator, therapeutic servicesadmissions director - health careanesthesia, chief ofassistant administrator for nursingassistant administrator, nursing servicesassistant director of nursingassistant director of nursing servicesassistant nursing services administratoraudiology and speech language pathology, chief ofaudiology and speech language pathology, director ofbehaviour therapy services directorchief dietitianchief of anatomical pathologychief of anesthesiachief of audiology and speech language pathologychief of biomedical engineering servicechief of cardiologychief of dermatologychief of diagnostic imagingchief of diagnostic radiologychief of emergency medicinechief of endocrinologychief of gastro-enterologychief of hematologychief of housing activitieschief of infectious diseaseschief of laboratory medicinechief of medical staffchief of medicinechief of nephrologychief of neurologychief of obstetrics and gynecologychief of occupational therapychief of operating areachief of ophthalmologychief of pathologychief of pediatricschief of pharmacychief of physiotherapychief of psychiatrychief of psychologychief of radiation oncologychief of respirologychief of rheumatologychief of staff - hospitalchief of surgerychief of urologychief radiology technologistclinical medicine, director ofclinical services managerdental health services administratordental laboratory managing supervisordermatology, chief ofdiagnostic imaging, chief ofdiagnostic radiology, chief ofdirector, behaviour therapy servicesdirector, first aid servicesdirector, home care servicesdirector, medicaldirector, medical clinicdirector, nursing services - medical servicesdirector, occupational health servicesdirector of audiology and speech language pathologydirector of clinical medicinedirector of dieteticsdirector of laboratory medicinedirector of nursing - medical servicesdirector of occupational therapydirector of physiotherapydirector of professional services - medical servicesdirector of psychology - health caredirector of surgerydirector, pharmacydirector, psychology - health caredirector, public health nursing servicesdirector, rehabilitation servicesdirector, rehabilitation services - medical servicesdirector, therapeutic services - psychiatric hospitalemergency medicine, chief ofendocrinology, chief offirst aid services directorgastro-enterology, chief ofhematology, chief ofhome care services director - medical servicesinfectious diseases, chief oflaboratory medicine, chief oflaboratory medicine, director ofmanager, nursing care - medical servicesmanager, nursing services - medical servicesmanaging supervisor, dental laboratorymedical clinic directormedical directormedicine, chief ofmental health residential care program managernephrology, chief ofneurology, chief ofnursing care manager - medical services",
    "workers": 6665,
    "minEduc": 0,
    "yearsStudy": 3.77443609,
    "automationRisk": 0.007,
    "salaryLow": 20.19,
    "salaryMed": 43.27,
    "salaryHigh": 63.08,
    "totalSkill": 169,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 43.27,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 180,
    "f2Engineering": 15,
    "f3Humanities": 65,
    "f4SocialScience": 390,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 260,
    "f8Education(teachertraining)": 205,
    "f9Law": 25,
    "f10Health": 380,
    "f11Health,Nursing&ClinicalLaboratory": 4305,
    "f12Business": 750,
    "f13Medical,Dental&Veterinary": 75,
    "d1Agriculture&BiologicalScience": 180,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 65,
    "d5SocialSciences": 390,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 260,
    "d9Education(teachertraining)": 205,
    "d10Engineering": 0,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 75,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 305,
    "d17Health,Nursing&ClinicalLaboratory": 4305,
    "d18Business&Commerce": 750,
    "d19Medical,Dental&Veterinary": 75,
    "equalRadius": 10
  },
  {
    "id": 21,
    "noc": 411,
    "job": "Government managers - health and social policy development and program administration",
    "title1": "adjustment programs director - government services",
    "title2": "administrative tribunal judge - government services",
    "title3": "administrator, social programs - government services",
    "allTitles": "adjustment programs director - government servicesadministrative tribunal judge - government servicesadministrator, social programs - government servicesadministrator, traffic safety - government servicesadministrator, welfare services - government servicesapprenticeship training director - government servicesapprenticeship training service director - government servicesassistant chief health inspector - government servicesassistant director, health programs - government servicesassistant director, social programs - government servicescareer development and employment district director - government servicescareer development director - government servicescareer information director - government serviceschief, claims and benefits control - employment insurancechief, health information and promotion - government serviceschief, health promotion - government serviceschief, immigration appeals and litigation - government serviceschief, inquiries and services - employment insurancechief, labour demand analysis - government serviceschief, office of health promotion - government serviceschief, regional pay centre - employment insurancechief, repayment and benefits control - employment insurancechief, social development programs - government serviceschief, social programs development - government serviceschild welfare regional manager - government serviceschild welfare services manager - government servicescity medical officer of healthcity medical officer of health - government servicesclaims and benefits control chief - employment insurancecommunity planning director - government servicescommunity rehabilitation manager - government servicesday-care planning services director - government servicesdirector, adjustment programs - government servicesdirector, apprenticeship training - government servicesdirector, apprenticeship training service - government servicesdirector, career development - government servicesdirector, career information - government servicesdirector, community planning - government servicesdirector, day-care planning services - government servicesdirector, employment and insurance programs - government servicesdirector, employment equity programs - government servicesdirector, employment programs - government servicesdirector, environmental health services - government servicesdirector, family and children's services - government servicesdirector, family benefits - government servicesdirector, family services - government servicesdirector, health care insurance plan - government servicesdirector, health care insurance refund claims - government servicesdirector, health education - government servicesdirector, health information and promotiondirector, health information and promotion - government servicesdirector, health services - government servicesdirector, home care services - government servicesdirector, homemaker services - government servicesdirector, housekeeping services - government servicesdirector, housing policy and developmentdirector, housing policy and development - government servicesdirector, immigration and settlement - government servicesdirector, Immigration Appeal Division - government servicesdirector, industrial hygiene and health - government servicesdirector, job training - government servicesdirector, local health services - government servicesdirector, occupational training - government servicesdirector, professional development - government servicesdirector, protection services - government servicesdirector, rural housing programs - government servicesdirector, settlement programs - government servicesdirector, social planning - government servicesdirector, social services - government servicesdirector, social services policy, planning and research - government servicesdirector, social surveys - government servicesdirector, social work - government servicesdirector, survey research - government servicesdirector, vocational education - government servicesdirector, vocational training - government servicesdirector, welfare services administration - government servicesdirector, welfare services - government servicesdistrict administrator, income security - government servicesdistrict director, career development and employment - government servicesdistrict director, professional development and employment - government servicesdistrict director, rural and Native housing services - government servicesdistrict manager - employment insuranceeducational director, public health nursing - government servicesemployment and insurance programs director - government servicesemployment centre directoremployment equity programs director - government servicesemployment insurance regional manager - government servicesemployment programs director - government servicesenvironmental health services director - government servicesfamily and children's services director - government servicesfamily benefits director - government servicesfamily services director - government servicesfood safety programs manager - government serviceshealth and welfare manager - government serviceshealth care insurance plan director - government serviceshealth care insurance refund claims director - government serviceshealth education director - government serviceshealth information and promotion chief - government serviceshealth information and promotion director - government serviceshealth program operations manager - government services",
    "workers": 540,
    "minEduc": 0,
    "yearsStudy": 4.48,
    "automationRisk": 0.25,
    "salaryLow": 29.33,
    "salaryMed": 50.26,
    "salaryHigh": 66.67,
    "totalSkill": 162,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 50.26,
    "skillsComp": 43,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 18,
    "s14Writing": 16,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 180,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 30,
    "f8Education(teachertraining)": 25,
    "f9Law": 15,
    "f10Health": 105,
    "f11Health,Nursing&ClinicalLaboratory": 70,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 180,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 30,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 0,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 105,
    "d17Health,Nursing&ClinicalLaboratory": 70,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 22,
    "noc": 412,
    "job": "Government managers - economic analysis, policy development and program administration",
    "title1": "agricultural policy director - government services",
    "title2": "agricultural products market development director - government services",
    "title3": "agricultural products market director",
    "allTitles": "agricultural policy director - government servicesagricultural products market development director - government servicesagricultural products market directoragricultural programs manager - government servicesassistant director, economic policy analysis - government servicesassistant director, international trade policy - government servicesborder services managerbusiness development director - government serviceschief, economic analysischief, economic analysis - government serviceschief, economic policy analysis - government serviceschief, forest resource analysischief, forest resource analysis - government servicescommercial analysis director - government servicescommunity economic development director - government servicescustoms manager - government servicesdirector, agricultural policy - government servicesdirector, agricultural products market development - government servicesdirector, business developmentdirector, business development - government servicesdirector, commercial analysis - government servicesdirector, community economic development - government servicesdirector, economic and trade analysis - government servicesdirector, economic developmentdirector, economic development - government servicesdirector, economic policy analysisdirector, economic policy analysis - government servicesdirector, energy market analysisdirector, energy policy - government servicesdirector, excise tax programsdirector, excise tax programs - government servicesdirector, farm products marketingdirector, farm products marketing - government servicesdirector, fishery policy - government servicesdirector, forestry policy - government servicesdirector, industrial development - government servicesdirector, industry, trade and technology - government servicesdirector market analysis director - government servicesdirector, microeconomic policy development - government servicesdirector, natural resources policy - government servicesdirector, parks administrationdirector, taxation programsdirector, tourism development - government servicesdirector, tourism promotion - government servicesdirector, trade development - government servicesdirector, trade liaison - government servicesdirector, transportation policy - government serviceseconomic analysis chief - government serviceseconomic and political affairs assistanteconomic and trade analysis director - government serviceseconomic development co-ordinatoreconomic development director - government serviceseconomic policy analysis assistant director - government serviceseconomic policy analysis chief - government serviceseconomic policy analysis director - government servicesenergy market analysis director - government servicesenergy policy director - government servicesexcise tax programs director - government servicesexport programs manager - government servicesfarm products marketing director - government servicesfishery policy director - government servicesfishery programs manager - government servicesforest resource analysis chief - government servicesforestry policy director - government servicesforestry programs manager - government servicesgoods and services tax (GST) managergrain market analysis chiefgrain market analysis managerGST (goods and services tax) managerindustrial development director - government servicesindustry, trade and technology director - government servicesinternational trade policy assistant director - government servicesinternational trade policy managerinternational trade policy manager - government serviceslabour market analysis director - government servicesmanager, agricultural programs - government servicesmanager, export programs - government servicesmanager, fishery programs - government servicesmanager, forestry programs - government servicesmanager, goods and services taxmanager, grain market analysismanager, grain market analysis - government servicesmanager, municipal taxationmanager, realty taxationmanager, regional economic services - government servicesmanager, regional taxationmanager, revenue programsmanager, revenue programs - government servicesmanager, taxationmanager, tax policy researchmanager, tax policy research - government servicesmanager, tourism development - government servicesmanager, tourism research - government servicesmanager, transportation programs - government servicesmarket development directormicroeconomic policy development director - government servicesmunicipal taxation managernatural resources policy director - government servicesparks administration directorparks service director",
    "workers": 1565,
    "minEduc": 0,
    "yearsStudy": 3.925925926,
    "automationRisk": 0.25,
    "salaryLow": 35,
    "salaryMed": 58.01,
    "salaryHigh": 71.79,
    "totalSkill": 165,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 58.01,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 18,
    "s14Writing": 16,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 120,
    "f2Engineering": 45,
    "f3Humanities": 0,
    "f4SocialScience": 515,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 20,
    "f9Law": 115,
    "f10Health": 95,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 595,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 25,
    "d2Forestry": 95,
    "d3Architecture&LandscapeArchitecture": 45,
    "d4Humanities": 0,
    "d5SocialSciences": 515,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 115,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 60,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 595,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 23,
    "noc": 413,
    "job": "Government managers - education policy development and program administration",
    "title1": "adult education services director",
    "title2": "assistant director, educational programs support",
    "title3": "assistant director, education programs",
    "allTitles": "adult education services directorassistant director, educational programs supportassistant director, education programsassistant director, language programsassistant director of school servicesassistant director of school services - public administrationassistant director, programs evaluation - educationassistant director, special education servicescomputer education directorcorporate policy manager - educationdirector, adult education servicesdirector, computer educationdirector, education curriculum developmentdirector, education policy analysis and researchdirector, education research and informationdirector, elementary educationdirector, elementary school educationdirector, heritage languages programdirector, inspection services - educationdirector, learning programs - adult educationdirector, learning programs - early-childhood educationdirector, learning programs - elementary educationdirector, learning programs - secondary educationdirector of education - public administrationdirector of school servicesdirector, policy and planning - education programsdirector, post-secondary educationdirector, post-secondary education - public administrationdirector, school inspectiondirector, school inspection - public administrationdirector, school services - public administrationdirector, secondary school educationdirector, secondary school programsdirector, second language programdirector, special education programsdirector, student assistance programeducation curriculum development directoreducation curriculum development director - public administrationeducation directoreducation policy and research director - public administrationeducation policy managereducation programs assistant director - public administrationeducation programs support director - public administrationeducation research and information directorelementary education directorelementary school education directorgovernment administrator - educationheritage languages program directorinspection services director - educationlearning programs director - adult educationlearning programs director - early-childhood educationlearning programs director - elementary educationlearning programs director - secondary educationmanager, corporate policy - educationmanager, education policymanager, education policy developmentmanager, education program administrationmanager, school board servicespolicy and planning director - education programsprogram development and educational planning director - public administrationprogram services director - educationregional director, education programsschool board services managerschool inspection director - public administrationschool services directorschool services director - public administrationsecondary school education directorsecondary school programs directorsecond language program directorservices manager - education programsspecial education programs directorspecial education services assistant directoruniversity research assistant director",
    "workers": 25,
    "minEduc": 0,
    "yearsStudy": 5,
    "automationRisk": 0.25,
    "salaryLow": 36.86,
    "salaryMed": 49.14,
    "salaryHigh": 127.52,
    "totalSkill": 161,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 49.14,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 23,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 25,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 24,
    "noc": 414,
    "job": "Other managers in public administration",
    "title1": "administrator, House of Commons",
    "title2": "bilateral relations chief",
    "title3": "Cabinet relations director",
    "allTitles": "administrator, House of Commonsbilateral relations chiefCabinet relations directorCabinet relations managerchief, bilateral relationschief, federal-provincial relationschief, intergovernmental affairschief, intergovernmental relationschief, international relations - governmentchief, interprovincial relationschief of protocolClerk - Legislative Assemblyclerk of the committee, Legislative AssemblyClerk of the Legislative AssemblyDeputy Clerk of the House of CommonsDeputy Clerk of the Legislative Assemblydirector, Cabinet relationsdirector, Elections Canadadirector, elections expensesdirector, elections financesdirector, elections planningdirector, emergency responses servicesdirector, federal-provincial relationsdirector, intergovernmental affairsdirector, intergovernmental relationsdirector, international relations - governmentdirector, Legislative Assembly servicesdirector, legislative servicesdirector of public worksdirector, parliamentary servicesdisaster relief services co-ordinatorelections expenses directorelections finances directorelections planning directoremergency management co-ordinator - government servicesemergency measures manager - government servicesemergency response co-ordinator - government servicesemergency safety manager - government servicesfederal-provincial relations chieffederal-provincial relations directorintergovernmental affairs chiefintergovernmental affairs directorintergovernmental relations chiefintergovernmental relations directorinternational relations chief - governmentinternational relations director - governmentinterprovincial relations chiefLegislative Assembly services directorlegislative services directorparliamentary services directorprincipal clerk of legislative committeesPrincipal Clerk of the House of CommonsPrincipal Clerk of the Legislative Assemblypublic works directorpublic works superintendent",
    "workers": 35595,
    "minEduc": 0.5,
    "yearsStudy": 3.47903479,
    "automationRisk": 0.615,
    "salaryLow": 25.9,
    "salaryMed": 56.04,
    "salaryHigh": 67.31,
    "totalSkill": 141.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 38.02,
    "skillsComp": 39.5,
    "skillsLogi": 33.5,
    "skillsMath": 22.5,
    "skillsLang": 46,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 6.5,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 9.5,
    "s12DigitalTechnology": 20.5,
    "s13DocumentUse": 14.5,
    "s14Writing": 13,
    "s15CriticalThinking": 8.5,
    "f1Science&Agriculture": 10,
    "f2Engineering": 180,
    "f3Humanities": 35,
    "f4SocialScience": 415,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 20,
    "f8Education(teachertraining)": 50,
    "f9Law": 110,
    "f10Health": 165,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 360,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 10,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 415,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 20,
    "d9Education(teachertraining)": 50,
    "d10Engineering": 180,
    "d11Law": 110,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 165,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 360,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 25,
    "noc": 421,
    "job": "Administrators - post-secondary education and vocational training",
    "title1": "manager, aviation school",
    "title2": "dean of adult education",
    "title3": "community college dean",
    "allTitles": "manager, aviation school",
    "workers": 8112.5,
    "minEduc": 0,
    "yearsStudy": 3.948970038,
    "automationRisk": 0.0085,
    "salaryLow": 23.08,
    "salaryMed": 45.89,
    "salaryHigh": 82.05,
    "totalSkill": 164.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 41.70386508,
    "skillsComp": 44.5,
    "skillsLogi": 41.5,
    "skillsMath": 23,
    "skillsLang": 56.5,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 22.5,
    "s11SchedulingorBudgetingandAccounting": 7.5,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9.5,
    "f1Science&Agriculture": 37.5,
    "f2Engineering": 27.5,
    "f3Humanities": 607.5,
    "f4SocialScience": 785,
    "f5FineArts": 160,
    "f6MathAndComputerScience": 5,
    "f7Arts&Education": 230,
    "f8Education(teachertraining)": 4917.5,
    "f9Law": 117.5,
    "f10Health": 590,
    "f11Health,Nursing&ClinicalLaboratory": 107.5,
    "f12Business": 527.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 7.5,
    "d3Architecture&LandscapeArchitecture": 5,
    "d4Humanities": 585,
    "d5SocialSciences": 785,
    "d6Fine&AppliedArts": 160,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 230,
    "d9Education(teachertraining)": 4917.5,
    "d10Engineering": 22.5,
    "d11Law": 117.5,
    "d12Mathematics": 5,
    "d13Kinesiology/Recreation/PhysicalEducation": 150,
    "d14Theology": 22.5,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 440,
    "d17Health,Nursing&ClinicalLaboratory": 107.5,
    "d18Business&Commerce": 527.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 26,
    "noc": 422,
    "job": "School principals and administrators of elementary and secondary education",
    "title1": "Aboriginal school principal",
    "title2": "academic superintendent",
    "title3": "administrator, board of education",
    "allTitles": "Aboriginal school principalacademic superintendentadministrator, board of educationarea superintendent - schoolsassistant district school superintendentassistant principalassistant school district superintendentassistant superintendent of schoolsassociate superintendent - schoolsboard of education administratorbusiness college principalchief superintendent - schoolscollege principal - secondary levelcommunity school principaldeputy superintendent - schoolsdirector of education, correctional institutiondirector of school for the blind or deafdirector of school for the hearing impaireddirector of school for the visually impaireddistrict school assistant superintendentdistrict school superintendentelementary school principalhall principal - secondary schoolheadmaster/mistress, private schoolheadmaster, private schoolheadmistress, private schoolhigh school principalNative school principalprincipalprivate primary college principalprivate school headmasterprivate school headmaster/mistressprivate school headmistressprivate school principalregional schools superintendentregional superintendent - schoolsschool board administratorschool district assistant superintendentschool district superintendentschool principalschool superintendentschool vice-principalsecondary school principalsuperintendent of academic affairssuperintendent of educational servicessuperintendent of education programssuperintendent of education programs in public schoolssuperintendent of elementary educationsuperintendent of elementary schoolssuperintendent of operations - schoolssuperintendent of professional development - schoolssuperintendent of secondary schoolssuperintendent of special educationsuperintendent of student servicessuperintendent, regional schoolssuperintendent, schoolstechnical high school principalvice-principal, schoolvocational high school principal",
    "workers": 10975,
    "minEduc": 0,
    "yearsStudy": 4.314606742,
    "automationRisk": 0.01,
    "salaryLow": 26.73,
    "salaryMed": 46.5,
    "salaryHigh": 57.37,
    "totalSkill": 170,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 46.5,
    "skillsComp": 46,
    "skillsLogi": 43,
    "skillsMath": 24,
    "skillsLang": 59,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 45,
    "f2Engineering": 55,
    "f3Humanities": 180,
    "f4SocialScience": 320,
    "f5FineArts": 215,
    "f6MathAndComputerScience": 10,
    "f7Arts&Education": 265,
    "f8Education(teachertraining)": 9370,
    "f9Law": 0,
    "f10Health": 165,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 350,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 10,
    "d4Humanities": 155,
    "d5SocialSciences": 320,
    "d6Fine&AppliedArts": 215,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 265,
    "d9Education(teachertraining)": 9370,
    "d10Engineering": 45,
    "d11Law": 0,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 165,
    "d14Theology": 25,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 350,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 27,
    "noc": 423,
    "job": "Managers in social, community and correctional services",
    "title1": "Aboriginal centre manager",
    "title2": "administrator, Chamber of Commerce",
    "title3": "administrator, child welfare services",
    "allTitles": "Aboriginal centre manageradministrator, Chamber of Commerceadministrator, child welfare servicesarea director, social servicesarea manager, family servicesassociation directorassociation managerbilateral relations manager - social servicesChamber of Commerce administratorchief clerk, House of Commonschild-care centre administratorchildren's aid society directorchild welfare services administratorcommunity arts co-ordinatorcommunity centre directorcommunity centre managercommunity programs directorcommunity services directorconsumer information directorcorrectional institution directorcorrectional rehabilitation society directorcorrectional services directorcorrectional treatment and training directorcounselling services directorcounselling services managerdepartment chief, social servicesdepartment director, welfare organizationdepartment head, social servicesdetention centre directordirector, children's aid societydirector, community centredirector, community programsdirector, community servicesdirector, consumer informationdirector, correctional rehabilitation societydirector, correctional servicesdirector, correctional treatment and trainingdirector, counselling servicesdirector, detention centredirector, family resourcesdirector general, teachers' associationdirector of counsellingdirector of guidance servicesdirector of operations - housing departmentdirector of public welfaredirector, psychological servicesdirector, religious educationdirector, social workdirector, veterans' servicesdirector, volunteer servicesdirector, welfare organizationdirector, young offender servicesdistrict director, social servicesenvironmental group directorfamily resources directorfamily services area managergroup home managerguidance directorguidance services directorhalfway house managerhomemaker services director - social servicesHouse of Commons chief clerkincome maintenance directorinternational program director - cooperativelabour organization managerlegislative assembly clerklocal manager, social servicesmajor community projects co-ordinatormanager, associationmanager, community centremanager, counselling servicesmanager, group homemanager, halfway housemanager, labour organizationmanager, manufacturers' associationmanager, men's hostelmanager, Native centremanager, NGO (non-governmental organization)manager, non-governmental organization (NGO)manager, vocational rehabilitation unitmanager, women's centremanufacturers' association managermembership services managermen's hostel managerNative centre managerNGO (non-governmental organization) managernon-governmental organization (NGO) managerpolitical organization managerprison wardenprovincial co-ordinator, social servicespsychological services directorpublic welfare directorregional administrator, social servicesregional correctional administratorrehabilitation residential services directorreligious education directorsocial assistance directorsocial service general managersocial services area directorsocial services centre administrator",
    "workers": 5250,
    "minEduc": 0,
    "yearsStudy": 3.583333333,
    "automationRisk": 0.007,
    "salaryLow": 24.905,
    "salaryMed": 46.195,
    "salaryHigh": 69.71,
    "totalSkill": 159,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 36.90773016,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 1035,
    "f4SocialScience": 1250,
    "f5FineArts": 105,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 195,
    "f8Education(teachertraining)": 465,
    "f9Law": 235,
    "f10Health": 1015,
    "f11Health,Nursing&ClinicalLaboratory": 215,
    "f12Business": 705,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 1015,
    "d5SocialSciences": 1250,
    "d6Fine&AppliedArts": 105,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 195,
    "d9Education(teachertraining)": 465,
    "d10Engineering": 0,
    "d11Law": 235,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 135,
    "d14Theology": 20,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 880,
    "d17Health,Nursing&ClinicalLaboratory": 215,
    "d18Business&Commerce": 705,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 28,
    "noc": 431,
    "job": "Commissioned police officers",
    "title1": "anti-gambling section inspector - police",
    "title2": "assistant chief inspector - police",
    "title3": "assistant deputy police chief",
    "allTitles": "anti-gambling section inspector - policeassistant chief inspector - policeassistant deputy police chiefassistant police commissionerchief detective - policechief inspector - policechief of policechief, railway policechief superintendentchief superintendent - policecommanding officer - policedeputy chief of policedeputy police chiefdetective inspector - policedetective sergeant - policedistrict police chiefdrug squad inspector - policefirearms section inspector - policeharbour police chiefheadquarters chief inspector - policeheadquarters police inspectorinspector, policeinvestigative inspector - policepolice captainpolice chiefpolice chief - regional operationspolice force inspectorpolice inspectorpolice lieutenantpolice staff inspectorpolice superintendentprecious metals theft inspector - policerailway police chiefrailway police supervisorRCMP (Royal Canadian Mounted Police) commissionerRoyal Canadian Mounted Police (RCMP) commissionerstaff inspectorstaff inspector - policestaff superintendent - policesuperintendent - policetraffic inspector - policetraffic superintendent - police",
    "workers": 110,
    "minEduc": 0,
    "yearsStudy": 2.8,
    "automationRisk": 0.098,
    "salaryLow": 28.88,
    "salaryMed": 53.67,
    "salaryHigh": 71.54,
    "totalSkill": 170,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 53.67,
    "skillsComp": 46,
    "skillsLogi": 43,
    "skillsMath": 24,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 100,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 10,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 100,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 10,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 29,
    "noc": 432,
    "job": "Fire chiefs and senior firefighting officers",
    "title1": "airport fire department chief",
    "title2": "chief, fire department",
    "title3": "deputy fire chief",
    "allTitles": "airport fire department chiefchief, fire departmentdeputy fire chiefdistrict fire chiefdivision chief - fire departmentfire chieffire department assistant deputy chieffire department assistant managerfire department chieffire department division chieffire department duty officerfirefighters executive officerindustrial fire chiefrefinery fire chiefsawmill fire chiefsenior firefighting officer",
    "workers": 255,
    "minEduc": 0,
    "yearsStudy": 2.166666667,
    "automationRisk": 0.004,
    "salaryLow": 21.44,
    "salaryMed": 45.835,
    "salaryHigh": 66.65,
    "totalSkill": 159,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 36.96403522,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 70,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 165,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 165,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 70,
    "d16Therapy&Rehabilitation": 20,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 30,
    "noc": 433,
    "job": "Commissioned officers of the Canadian Forces",
    "title1": "acting sub-lieutenant",
    "title2": "admiral",
    "title3": "artillery officer",
    "allTitles": "acting sub-lieutenantadmiralartillery officerbrigadier generalcaptaincaptain - air forcecaptain - armycaptain - navycolonelcommandercommodorecourt martial judgegeneralinfantry officerlieutenantlieutenant - air forcelieutenant - armylieutenant colonellieutenant commanderlieutenant generallieutenant - navylogistics officermajormajor generalnaval cadetofficer cadetrear admiralsearch and rescue captainsecond lieutenantsub-lieutenantvice admiral",
    "workers": 4005,
    "minEduc": 0,
    "yearsStudy": 4,
    "automationRisk": 0.311309013,
    "salaryLow": 14,
    "salaryMed": 38,
    "salaryHigh": 61.76,
    "totalSkill": 145,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 38,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 295,
    "f2Engineering": 695,
    "f3Humanities": 360,
    "f4SocialScience": 555,
    "f5FineArts": 75,
    "f6MathAndComputerScience": 75,
    "f7Arts&Education": 875,
    "f8Education(teachertraining)": 135,
    "f9Law": 125,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 715,
    "f13Medical,Dental&Veterinary": 20,
    "d1Agriculture&BiologicalScience": 75,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 360,
    "d5SocialSciences": 555,
    "d6Fine&AppliedArts": 75,
    "d7ComputerScience": 65,
    "d8OtherArts&Science": 875,
    "d9Education(teachertraining)": 135,
    "d10Engineering": 695,
    "d11Law": 125,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 220,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 715,
    "d19Medical,Dental&Veterinary": 20,
    "equalRadius": 10
  },
  {
    "id": 31,
    "noc": 511,
    "job": "Library, archive, museum and art gallery managers",
    "title1": "administrative librarian",
    "title2": "administrator, art gallery",
    "title3": "administrator assistant, art gallery",
    "allTitles": "administrative librarianadministrator, art galleryadministrator assistant, art galleryadministrator, historic sitesadministrator, museumarchival document managerarchives chiefarchives directorarchives managerart gallery administratorart gallery assistant directorart gallery chief curatorart gallery co-ordinatorart gallery directorart gallery managerart gallery manager assistantarts administratorassistant art gallery administratorassistant art gallery directorassistant director, art galleryassistant director, museumassistant director of archivesassistant director of historical parkassistant museum administratorassistant museum directorassistant superintendent, historical parkchief, archiveschief archivistchief curatorchief librarianco-ordinator, art galleryco-ordinator, museumcurator-director - museumdeputy librariandirector, archivesdirector, art gallerydirector, librarydirector, museumdirector of conservation, museumdivision librarianexecutive director, museumhead archivisthead librarianhead librarian, technician serviceshead of cataloguinghistorical park assistant directorhistorical park assistant superintendenthistorical park directorhistorical park superintendenthistoric sites administratorlibrary chieflibrary directormanager, archivesmanager, art gallerymanager assistant, art gallerymuseum administratormuseum assistant administratormuseum assistant directormuseum co-ordinatormuseum directormuseum director of conservationmuseum executive directormuseum general directormuseum managerregional library directorsuperintendent, historical parktechnical services head librarian",
    "workers": 445,
    "minEduc": 0,
    "yearsStudy": 4.583333333,
    "automationRisk": 0.25,
    "salaryLow": 23.4,
    "salaryMed": 38.23,
    "salaryHigh": 54.81,
    "totalSkill": 156,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 38.23,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 20,
    "f4SocialScience": 0,
    "f5FineArts": 60,
    "f6MathAndComputerScience": 45,
    "f7Arts&Education": 305,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 60,
    "d7ComputerScience": 45,
    "d8OtherArts&Science": 305,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 32,
    "noc": 512,
    "job": "Managers - publishing, motion pictures, broadcasting and performing arts",
    "title1": "administrator of studio and broadcasting station",
    "title2": "ballet company director",
    "title3": "book publishing manager",
    "allTitles": "administrator of studio and broadcasting stationballet company directorbook publishing managerbroadcasting managerbroadcasting station managerbureau chief - news agencycopyright and royalties managercopyright manager - publishingcost and royalties manager - publishingdance company directordirector, ballet companydirector, dance companydirector, opera companydirector, publishing housedirector, radio station operationsdirector, theatre companyeditorial chiefeditor-in-chiefexecutive producer, films and videosfilm and video executive producerfilm production managermanager, book publishingmanager, copyright and royaltiesmanager, film productionmanager, multimedia departmentmanager, news departmentmanager, newspapermanager, publishingmanager, radio programmingmanager, radio stationmanager, television stationmanager, theatre companymanager, video production companymanaging editormanaging editor - newspaper or periodicalmultimedia department managernews department managernewspaper managernewspaper managing editoropera company directoroperations manager - broadcastingoperations manager - publishingperiodical managing editorpermission manager - publishingprogram general manager - broadcastingprogramming director - broadcastingprogramming director - televisionpublications managerpublishing house directorpublishing managerradio programming managerradio station managerradio station operations directorroyalties manager - artsstation manager, broadcastingtelevision station managertheatre company directortheatre company managertheatre directorvideo production company manager",
    "workers": 1585,
    "minEduc": 0,
    "yearsStudy": 3.555555556,
    "automationRisk": 0.25,
    "salaryLow": 18,
    "salaryMed": 34.62,
    "salaryHigh": 67.69,
    "totalSkill": 155,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 34.62,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 15,
    "f3Humanities": 40,
    "f4SocialScience": 375,
    "f5FineArts": 760,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 120,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 275,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 40,
    "d5SocialSciences": 375,
    "d6Fine&AppliedArts": 760,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 120,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 275,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 33,
    "noc": 513,
    "job": "Recreation, sports and fitness program and service directors",
    "title1": "administrator in chief, leisure",
    "title2": "administrator in chief, recreation",
    "title3": "administrator, leisure",
    "allTitles": "administrator in chief, leisureadministrator in chief, recreationadministrator, leisureadministrator, recreationamateur sport managerchief administrator, leisurechief administrator, recreationco-ordinator, sport program administrativedirector, entertainment, sports and leisuredirector, entertainment, sports and recreationdirector, fitness administration - governmentdirector, fitness programsdirector general, sport federationdirector, horse racingdirector, leisuredirector, leisure and sportsdirector, leisure centredirector, leisure establishmentdirector, leisure programsdirector, leisure servicedirector of fitness administration - governmentdirector of leisuredirector of leisure and sportsdirector of recreationdirector of recreation and sportsdirector of sports administrationdirector of sports administration - governmentdirector of sports and leisuredirector of sports and recreationdirector, physical education programsdirector, physical trainingdirector, racetrackdirector, recreationdirector, recreation and sportsdirector, recreation centredirector, recreation establishmentdirector, recreation programsdirector, recreation servicedirector, sportsdirector, sports administration - governmentdirector, sports and leisuredirector, sports and recreationdirector, sports associationdirector, sports federationdirector, sports programsdirector, sports-service sports programsdirector, track and fieldentertainment, sports and leisure directorentertainment, sports and recreation directorexecutive director, sport governing agencyexecutive director, sport governing bodyfitness administration director - governmentfitness centre managerfitness club managerfitness programs directorgeneral director, sport federationgeneral director, YMCA (Young Men's Christian Association)general manager, professional sport teamgeneral manager, professional track and field teamgeneral secretary, YMCA (Young Men's Christian Association)head administrator, leisurehead administrator, recreationhealth club managerhealth studio managerhorse racing directorleisure administratorleisure administrator in chiefleisure and sports directorleisure centre directorleisure centre sports directorleisure chief administratorleisure directorleisure establishment directorleisure establishment managing supervisorleisure head administratorleisure managerleisure programs directorleisure programs managerleisure service directorleisure service managermanager, fitness centremanager, fitness clubmanager, health clubmanager, leisuremanager, leisure programsmanager, leisure servicemanager, professional athletes teammanager, professional football teammanager, professional hockey teammanager, professional sport teammanager, professional track and field teammanager, recreationmanager, recreation programsmanager, recreation servicemanager, team of professional athletesmanaging supervisor, leisure establishmentmanaging supervisor, recreation establishmentmunicipal director, leisuremunicipal director of leisuremunicipal director of recreation",
    "workers": 1645,
    "minEduc": 0,
    "yearsStudy": 3.023809524,
    "automationRisk": 0.25,
    "salaryLow": 20.7,
    "salaryMed": 36.425,
    "salaryHigh": 61.25,
    "totalSkill": 150,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 32.34702038,
    "skillsComp": 40,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 10,
    "f2Engineering": 0,
    "f3Humanities": 25,
    "f4SocialScience": 90,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 85,
    "f8Education(teachertraining)": 80,
    "f9Law": 0,
    "f10Health": 985,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 325,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 10,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 85,
    "d9Education(teachertraining)": 80,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 985,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 325,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 34,
    "noc": 601,
    "job": "Corporate sales managers",
    "title1": "corporate sales manager",
    "title2": "regional sales manager",
    "title3": "national accounts manager � sales",
    "allTitles": "corporate sales manager",
    "workers": 12263.33333,
    "minEduc": 0,
    "yearsStudy": 2.81907086,
    "automationRisk": 0.079666667,
    "salaryLow": 19.57,
    "salaryMed": 45,
    "salaryHigh": 74.3,
    "totalSkill": 208.8333333,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 24.02,
    "skillsComp": 57.33333333,
    "skillsLogi": 48.16666667,
    "skillsMath": 30,
    "skillsLang": 73.66666667,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 14.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5.833333333,
    "s8OralCommunication": 24.33333333,
    "s9ProblemSolving": 12,
    "s10Reading": 25.33333333,
    "s11SchedulingorBudgetingandAccounting": 15.5,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 13.33333333,
    "s14Writing": 23.83333333,
    "s15CriticalThinking": 10.83333333,
    "f1Science&Agriculture": 143.3333333,
    "f2Engineering": 348.3333333,
    "f3Humanities": 381.6666667,
    "f4SocialScience": 601.6666667,
    "f5FineArts": 265,
    "f6MathAndComputerScience": 238.3333333,
    "f7Arts&Education": 1698.333333,
    "f8Education(teachertraining)": 130,
    "f9Law": 228.3333333,
    "f10Health": 110,
    "f11Health,Nursing&ClinicalLaboratory": 310,
    "f12Business": 3673.333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 48.33333333,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 5,
    "d4Humanities": 376.6666667,
    "d5SocialSciences": 601.6666667,
    "d6Fine&AppliedArts": 265,
    "d7ComputerScience": 221.6666667,
    "d8OtherArts&Science": 1698.333333,
    "d9Education(teachertraining)": 130,
    "d10Engineering": 343.3333333,
    "d11Law": 228.3333333,
    "d12Mathematics": 16.66666667,
    "d13Kinesiology/Recreation/PhysicalEducation": 53.33333333,
    "d14Theology": 5,
    "d15PhysicalSciences": 95,
    "d16Therapy&Rehabilitation": 56.66666667,
    "d17Health,Nursing&ClinicalLaboratory": 310,
    "d18Business&Commerce": 3673.333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 35,
    "noc": 621,
    "job": "Retail and wholesale trade managers",
    "title1": "antique dealer appliance store manager area manager � retail store chain art dealer art gallery manager � retail assistant department manager � retail assistant manager � food store assistant manager � retail audio equipment store manager auto dealership manager auto glass repair shop manager auto rustproofing shop manager automobile repair garage manager automobile repair shop manager automobile servicing manager bakery department manager bakery manager � food store bakery manager � retail beer store manager bicycle shop manager bird seller bookstore manager brake shop manager branch manager � retail camera store manager car dealer car dealership manager car leasing branch manager category manager cattle dealer clothing store manager coin dealer computer products dealer � retail computer products store manager concession holder concession manager confectionery department manager � retail confectionery manager convenience store manager custom tailoring shop manager customer service manager � automobiles customer service manager � retail customer service managing supervisor dealer � retail dealer, antiques deli manager � food store delicatessen department manager � retail department manager � department store department manager � retail department store manager dispensing opticians office manager drugstore manager electronic products store manager fabric store manager farm heavy equipment dealership manager flea market concession operator flea market manager floor coverings and draperies store manager floor manager � retail flower shop manager flower store manager food store department manager � retail food store manager fruits and vegetables manager � retail furniture store manager garage manager, automobile repairs garden centre manager � retail gas station manager general store manager gift shop manager grocer hardware store manager jewellery store manager leather goods and clothing store manager liquor store manager livestock dealer management trainee � retail manager � retail store chain manager trainee � retail manager, custom tailoring shop manager, department store manager, pharmacy department � retail manager, photographic studio manager, retail sales manager, wholesale establishment managing supervisor � retail managing supervisor, customer service managing supervisor, wholesale establishment meat department manager � food store meat department manager � retail meat manager � foodstore metal dealer motor vehicle repair shop manager muffler shop manager numismatist office supplies store manager owner, retail store paint store manager parking garage operator parking lot operator parts manager � retail pawnbroker pet store manager pharmacy department manager � retail pharmacy manager � retail philatelist photographic equipment store manager photographic studio manager pleasure boat dealer produce manager � retail record store manager retail sales manager retail sales manager � e-commerce retail store owner retailer salvage dealer scrap metal dealer section manager � retail service manager � retail service station manager ship chandler shoe store manager shop manager sporting goods store manager stamp dealer stationery store manager stereo equipment store manager store manager � retail supermarket manager television and stereo equipment store manager tire dealer toy store manager travel agency manager travel branch manager variety store manager video rental store manager video store manager wholesale establishment manager wholesale establishment managing supervisor wholesaler wine store manager",
    "title2": 0,
    "title3": 0,
    "allTitles": "antique dealer appliance store manager area manager � retail store chain art dealer art gallery manager � retail assistant department manager � retail assistant manager � food store assistant manager � retail audio equipment store manager auto dealership manager auto glass repair shop manager auto rustproofing shop manager automobile repair garage manager automobile repair shop manager automobile servicing manager bakery department manager bakery manager � food store bakery manager � retail beer store manager bicycle shop manager bird seller bookstore manager brake shop manager branch manager � retail camera store manager car dealer car dealership manager car leasing branch manager category manager cattle dealer clothing store manager coin dealer computer products dealer � retail computer products store manager concession holder concession manager confectionery department manager � retail confectionery manager convenience store manager custom tailoring shop manager customer service manager � automobiles customer service manager � retail customer service managing supervisor dealer � retail dealer, antiques deli manager � food store delicatessen department manager � retail department manager � department store department manager � retail department store manager dispensing opticians office manager drugstore manager electronic products store manager fabric store manager farm heavy equipment dealership manager flea market concession operator flea market manager floor coverings and draperies store manager floor manager � retail flower shop manager flower store manager food store department manager � retail food store manager fruits and vegetables manager � retail furniture store manager garage manager, automobile repairs garden centre manager � retail gas station manager general store manager gift shop manager grocer hardware store manager jewellery store manager leather goods and clothing store manager liquor store manager livestock dealer management trainee � retail manager � retail store chain manager trainee � retail manager, custom tailoring shop manager, department store manager, pharmacy department � retail manager, photographic studio manager, retail sales manager, wholesale establishment managing supervisor � retail managing supervisor, customer service managing supervisor, wholesale establishment meat department manager � food store meat department manager � retail meat manager � foodstore metal dealer motor vehicle repair shop manager muffler shop manager numismatist office supplies store manager owner, retail store paint store manager parking garage operator parking lot operator parts manager � retail pawnbroker pet store manager pharmacy department manager � retail pharmacy manager � retail philatelist photographic equipment store manager photographic studio manager pleasure boat dealer produce manager � retail record store manager retail sales manager retail sales manager � e-commerce retail store owner retailer salvage dealer scrap metal dealer section manager � retail service manager � retail service station manager ship chandler shoe store manager shop manager sporting goods store manager stamp dealer stationery store manager stereo equipment store manager store manager � retail supermarket manager television and stereo equipment store manager tire dealer toy store manager travel agency manager travel branch manager variety store manager video rental store manager video store manager wholesale establishment manager wholesale establishment managing supervisor wholesaler wine store manager",
    "workers": 12263.33333,
    "minEduc": 0,
    "yearsStudy": 2.81907086,
    "automationRisk": 0.079666667,
    "salaryLow": 17,
    "salaryMed": 35.9,
    "salaryHigh": 62.5,
    "totalSkill": 208.8333333,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 24.02,
    "skillsComp": 57.33333333,
    "skillsLogi": 48.16666667,
    "skillsMath": 30,
    "skillsLang": 73.66666667,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 14.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5.833333333,
    "s8OralCommunication": 24.33333333,
    "s9ProblemSolving": 12,
    "s10Reading": 25.33333333,
    "s11SchedulingorBudgetingandAccounting": 15.5,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 13.33333333,
    "s14Writing": 23.83333333,
    "s15CriticalThinking": 10.83333333,
    "f1Science&Agriculture": 143.3333333,
    "f2Engineering": 348.3333333,
    "f3Humanities": 381.6666667,
    "f4SocialScience": 601.6666667,
    "f5FineArts": 265,
    "f6MathAndComputerScience": 238.3333333,
    "f7Arts&Education": 1698.333333,
    "f8Education(teachertraining)": 130,
    "f9Law": 228.3333333,
    "f10Health": 110,
    "f11Health,Nursing&ClinicalLaboratory": 310,
    "f12Business": 3673.333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 48.33333333,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 5,
    "d4Humanities": 376.6666667,
    "d5SocialSciences": 601.6666667,
    "d6Fine&AppliedArts": 265,
    "d7ComputerScience": 221.6666667,
    "d8OtherArts&Science": 1698.333333,
    "d9Education(teachertraining)": 130,
    "d10Engineering": 343.3333333,
    "d11Law": 228.3333333,
    "d12Mathematics": 16.66666667,
    "d13Kinesiology/Recreation/PhysicalEducation": 53.33333333,
    "d14Theology": 5,
    "d15PhysicalSciences": 95,
    "d16Therapy&Rehabilitation": 56.66666667,
    "d17Health,Nursing&ClinicalLaboratory": 310,
    "d18Business&Commerce": 3673.333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 36,
    "noc": 631,
    "job": "Assemblers, fabricators and inspectors, industrial electrical motors and transformers",
    "title1": "assistant bar manager",
    "title2": "assistant manager - bar",
    "title3": "assistant manager, restaurant",
    "allTitles": "assistant bar managerassistant manager - barassistant manager, restaurantbanquet managerbar managerbeverage service managercaf� managercafeteria managercanteen managercanteen service district managercanteen services managercatering service managercybercaf� managerdining establishment managing supervisordining room managerdistrict manager, canteen servicefast food restaurant managerfood and beverage service managerfood services managerhotel food and beverage service managerInternet caf� managermanager, caf�manager, catering servicemanager, cybercaf�manager, food and beverage servicemanager, food servicesmanager, hotel food and beverage servicemanager, Internet caf�manager, restaurantmanager trainee, restaurantmanaging supervisor, dining establishmentrestaurant assistant managerrestaurant managerrestaurateur - food servicestea room manager",
    "workers": 31670,
    "minEduc": 0,
    "yearsStudy": 2.872796996,
    "automationRisk": 0.064,
    "salaryLow": 14,
    "salaryMed": 19,
    "salaryHigh": 42,
    "totalSkill": 207.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 15.75,
    "skillsComp": 57,
    "skillsLogi": 47.5,
    "skillsMath": 30,
    "skillsLang": 73,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 14.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 24,
    "s9ProblemSolving": 12,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 15.5,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 13,
    "s14Writing": 23.5,
    "s15CriticalThinking": 10.5,
    "f1Science&Agriculture": 275,
    "f2Engineering": 960,
    "f3Humanities": 1045,
    "f4SocialScience": 1515,
    "f5FineArts": 675,
    "f6MathAndComputerScience": 695,
    "f7Arts&Education": 3420,
    "f8Education(teachertraining)": 330,
    "f9Law": 685,
    "f10Health": 315,
    "f11Health,Nursing&ClinicalLaboratory": 785,
    "f12Business": 8565,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 90,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 1030,
    "d5SocialSciences": 1515,
    "d6Fine&AppliedArts": 675,
    "d7ComputerScience": 645,
    "d8OtherArts&Science": 3420,
    "d9Education(teachertraining)": 330,
    "d10Engineering": 945,
    "d11Law": 685,
    "d12Mathematics": 50,
    "d13Kinesiology/Recreation/PhysicalEducation": 160,
    "d14Theology": 15,
    "d15PhysicalSciences": 185,
    "d16Therapy&Rehabilitation": 155,
    "d17Health,Nursing&ClinicalLaboratory": 785,
    "d18Business&Commerce": 8565,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 37,
    "noc": 632,
    "job": "Accommodation service managers",
    "title1": "accommodation services manager",
    "title2": "accommodations manager",
    "title3": "assistant manager, hotel",
    "allTitles": "accommodation services manageraccommodations managerassistant manager, hotelbed and breakfast managerbed and breakfast operatorboarding house keeperboarding house managercampground managercampground operatorcamp managercanoe camp operatorcountry inn operatordirector, hotelfishing camp operatorfront desk hotel managerfront desk managerfront desk manager - accommodation servicesfront desk manager, hotelfront office manager, hotelguest-house operatorguest services managerhostel managerhotel assistant managerhotel directorhotel front desk managerhotel front office managerhotel managerhotel operatorhunting and fishing lodge managerhunting camp operatorinnkeeperinn managerinn operatorlodging house managermanager, accommodation servicesmanager, bed and breakfastmanager, boarding housemanager, campmanager, campgroundmanager, hotelmanager, hotel front deskmanager, hotel front officemanager, innmanager, lodging housemanager, recreational campgroundmanager, reservationsmanager, resortmanager, seasonal resortmanager, student residencemanager, university residencemanager, youth hostelmotel managerrecreational campground managerreservations managerresort campground managerresort managerrooming house keeperrooms division directorrooms manager - accommodation servicesseasonal resort managerski resort managerstudent residence managertourist home operatoruniversity residence manageryouth hostel manager",
    "workers": 1725,
    "minEduc": 0,
    "yearsStudy": 3,
    "automationRisk": 0.004,
    "salaryLow": 14.42,
    "salaryMed": 21.63,
    "salaryHigh": 48.08,
    "totalSkill": 261,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in retail and wholesale trade and customer services",
    "cluster": 1,
    "wage": 21.63,
    "skillsComp": 72,
    "skillsLogi": 57,
    "skillsMath": 38,
    "skillsLang": 94,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 17,
    "s2DecisionMaking": 19,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 32,
    "s9ProblemSolving": 14,
    "s10Reading": 30,
    "s11SchedulingorBudgetingandAccounting": 24,
    "s12DigitalTechnology": 45,
    "s13DocumentUse": 10,
    "s14Writing": 32,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 15,
    "f2Engineering": 10,
    "f3Humanities": 20,
    "f4SocialScience": 55,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 175,
    "f8Education(teachertraining)": 40,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 45,
    "f12Business": 1350,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 55,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 175,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 10,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 45,
    "d18Business&Commerce": 1350,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 38,
    "noc": 651,
    "job": "Managers in customer and personal services, n.e.c.",
    "title1": "academy of music manager",
    "title2": "art school manager",
    "title3": "automobile driver training school manager",
    "allTitles": "academy of music managerart school managerautomobile driver training school managerautomobile driving school managerbarber shop managerbeauty shop managerboarding kennel managercarpet cleaning service managercar wash managercold-storage managercooking school managercraft school managercrematorium managerdance school managerdog grooming establishment managerdog kennel managerdriving school managerdry cleaning plant managerdry cleaning service managerescort agency manageresthetic services managerfur cleaning plant managerhairdressing salon managerhairstyling salon managerholidays service managerhome care service managerjanitorial services managerkennel managerlaundry and dry cleaning managerlaundry managerlaundry service managermanager, academy of musicmanager, automobile driver training schoolmanager, automobile driving schoolmanager, barber shopmanager, beauty shopmanager, carpet cleaning servicemanager, car washmanager, cold storagemanager, cooking schoolmanager, crematoriummanager, dance schoolmanager, dog kennelmanager, driving schoolmanager, dry cleaning plantmanager, dry cleaning servicemanager, escort agencymanager, esthetic servicesmanager, fur cleaning plantmanager, hairdressing salonmanager, hairstyling salonmanager, holidays servicemanager, home care servicemanager, janitorial servicesmanager, kennelmanager, laundry and dry cleaningmanager, laundry servicemanager, massage parlourmanager, modelling schoolmanager, movie theatremanager, music academymanager, music schoolmanager, pest control servicemanager, pet care servicesmanager, pet grooming establishmentmanager, residential cleaning servicemanager, saunamanager, school of artmanager, septic tank servicemanager, shoe repair servicemanager, swimming pool maintenance servicemanager, tanning salonmanager, truck washmanager, weight-loss clinicmanager, window washing servicemassage parlour managermodelling school managermovie theatre managermusic academy managermusic school managerpest control service managerpet care services managerpet grooming establishment managerpet grooming salon managerpet-sitting service managerresidential cleaning service managersauna managerschool of art managerseptic tank service managershoe repair service managerspa directorspa managerswimming pool maintenance service managertanning salon managertour operatortruck wash managerweight-loss clinic managerwindow washing service manager",
    "workers": 3395,
    "minEduc": 0,
    "yearsStudy": 2.584415584,
    "automationRisk": 0.171,
    "salaryLow": 14,
    "salaryMed": 34.68,
    "salaryHigh": 52.88,
    "totalSkill": 158,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in retail and wholesale trade and customer services",
    "cluster": 1,
    "wage": 34.68,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 140,
    "f2Engineering": 75,
    "f3Humanities": 80,
    "f4SocialScience": 235,
    "f5FineArts": 105,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1500,
    "f8Education(teachertraining)": 20,
    "f9Law": 0,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 100,
    "f12Business": 1105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 55,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 80,
    "d5SocialSciences": 235,
    "d6Fine&AppliedArts": 105,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1500,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 75,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 85,
    "d16Therapy&Rehabilitation": 15,
    "d17Health,Nursing&ClinicalLaboratory": 100,
    "d18Business&Commerce": 1105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 39,
    "noc": 711,
    "job": "Construction managers",
    "title1": "assistant manager, construction",
    "title2": "bridge and building construction manager",
    "title3": "bridge construction superintendent",
    "allTitles": "assistant manager, constructionbridge and building construction managerbridge construction superintendentbuilding construction general contractorbuilding construction superintendentbuilding materials branch directorcommercial construction managerconstruction assistant managerconstruction expediterconstruction general contractorconstruction general superintendentconstruction managerconstruction operations managerconstruction project co-ordinatorconstruction project managerconstruction project superintendentconstruction senior project managerconstruction site managerconstruction site superintendentconstruction special project managerconstruction superintendentgeneral contractorgeneral contractor, constructiongeneral superintendent, constructionhighway construction managerhousing construction managerindustrial construction managermanager, industrial constructionmanager, pipeline constructionpipeline construction managerpipeline construction superintendentproject co-ordinator, constructionproject manager, constructionresidential construction managersenior project manager, constructionsite manager, constructionsite superintendent, constructionspecial project manager, constructionsuperintendent, bridge constructionsuperintendent, constructionsuperintendent, pipeline construction",
    "workers": 12420,
    "minEduc": 0,
    "yearsStudy": 2.620087336,
    "automationRisk": 0.071,
    "salaryLow": 24.77,
    "salaryMed": 36.86,
    "salaryHigh": 57.69,
    "totalSkill": 163,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 36.86,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 580,
    "f2Engineering": 6100,
    "f3Humanities": 40,
    "f4SocialScience": 325,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 30,
    "f7Arts&Education": 2960,
    "f8Education(teachertraining)": 0,
    "f9Law": 85,
    "f10Health": 70,
    "f11Health,Nursing&ClinicalLaboratory": 10,
    "f12Business": 2075,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 1675,
    "d4Humanities": 40,
    "d5SocialSciences": 325,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 2960,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 4425,
    "d11Law": 85,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 0,
    "d15PhysicalSciences": 490,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 10,
    "d18Business&Commerce": 2075,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 40,
    "noc": 712,
    "job": "Home building and renovation managers",
    "title1": "builder",
    "title2": "builder - renovation",
    "title3": "builder - residential",
    "allTitles": "builderbuilder - renovationbuilder - residentialcontractor, home buildingcontractor, home renovationcontractor, residential homeshome builderhome building contractorhome renovation contractorhome renovatorhousing rehabilitation specialist - builderhousing renovatorlow-rise residential home builderrehabilitation and renovation specialistrenovation contractorresidential home builderresidential homes contractorresidential renovation contractor",
    "workers": 4465,
    "minEduc": 0,
    "yearsStudy": 2.236220472,
    "automationRisk": 0.071,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 31.5,
    "totalSkill": 275,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 20,
    "skillsComp": 76,
    "skillsLogi": 61,
    "skillsMath": 42,
    "skillsLang": 96,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 15,
    "s2DecisionMaking": 20,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 31,
    "s9ProblemSolving": 14,
    "s10Reading": 30,
    "s11SchedulingorBudgetingandAccounting": 28,
    "s12DigitalTechnology": 45,
    "s13DocumentUse": 16,
    "s14Writing": 35,
    "s15CriticalThinking": 16,
    "f1Science&Agriculture": 505,
    "f2Engineering": 1190,
    "f3Humanities": 0,
    "f4SocialScience": 115,
    "f5FineArts": 80,
    "f6MathAndComputerScience": 30,
    "f7Arts&Education": 1805,
    "f8Education(teachertraining)": 15,
    "f9Law": 55,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 670,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 55,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 305,
    "d4Humanities": 0,
    "d5SocialSciences": 115,
    "d6Fine&AppliedArts": 80,
    "d7ComputerScience": 30,
    "d8OtherArts&Science": 1805,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 885,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 450,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 670,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 41,
    "noc": 714,
    "job": "Facility operation and maintenance managers",
    "title1": "airport manager airport services manager airport terminal manager arena manager assistant shopping centre manager assistant shopping mall manager assistant warehouse manager athletic facility manager building maintenance head building maintenance manager building operations manager building services head building services manager campus maintenance manager canal director canal superintendent cemetery manager chief, maintenance support services conference centre manager convention centre manager country grain elevator facility manager director of maintenance director, canal director, facility management distribution centre manager electrical superintendent facility maintenance manager facility management director facility manager, country grain elevator facility operations manager fitness facility manager grain terminal elevator manager harbour master head, building services head, facilities maintenance industrial maintenance manager maintenance and service manager maintenance co-ordinator maintenance director maintenance manager maintenance operations manager maintenance planner maintenance services manager maintenance superintendent manager, airport manager, airport services manager, arena manager, athletic facility manager, building maintenance manager, building operations manager, building services manager, campus maintenance manager, conference centre manager, distribution centre manager, facility maintenance manager, fitness facility manager, maintenance manager, maintenance and service manager, marina manager, plant maintenance manager, recreation facility manager, school maintenance manager, shopping centre manager, shopping centre maintenance manager, shopping mall manager, shopping mall maintenance manager, sports facility manager, stadium manager, tennis court manager, tobacco warehouse manager, university maintenance manager, warehouse manager, warehousing marina manager marina operator mechanical services superintendent operations manager, maintenance plant maintenance manager plant maintenance superintendent port director property manager recreation facility manager school maintenance manager shopping centre maintenance manager shopping centre manager shopping mall maintenance manager shopping mall manager sports facility manager stadium manager superintendent of operations, maintenance superintendent, maintenance superintendent, maintenance and service superintendent, maintenance operations superintendent, mechanical services superintendent, plant maintenance tennis court manager tobacco warehouse manager university maintenance manager warehouse and distribution centre manager warehouse manager warehouse superintendent warehousing manager",
    "title2": 0,
    "title3": 0,
    "allTitles": "airport manager airport services manager airport terminal manager arena manager assistant shopping centre manager assistant shopping mall manager assistant warehouse manager athletic facility manager building maintenance head building maintenance manager building operations manager building services head building services manager campus maintenance manager canal director canal superintendent cemetery manager chief, maintenance support services conference centre manager convention centre manager country grain elevator facility manager director of maintenance director, canal director, facility management distribution centre manager electrical superintendent facility maintenance manager facility management director facility manager, country grain elevator facility operations manager fitness facility manager grain terminal elevator manager harbour master head, building services head, facilities maintenance industrial maintenance manager maintenance and service manager maintenance co-ordinator maintenance director maintenance manager maintenance operations manager maintenance planner maintenance services manager maintenance superintendent manager, airport manager, airport services manager, arena manager, athletic facility manager, building maintenance manager, building operations manager, building services manager, campus maintenance manager, conference centre manager, distribution centre manager, facility maintenance manager, fitness facility manager, maintenance manager, maintenance and service manager, marina manager, plant maintenance manager, recreation facility manager, school maintenance manager, shopping centre manager, shopping centre maintenance manager, shopping mall manager, shopping mall maintenance manager, sports facility manager, stadium manager, tennis court manager, tobacco warehouse manager, university maintenance manager, warehouse manager, warehousing marina manager marina operator mechanical services superintendent operations manager, maintenance plant maintenance manager plant maintenance superintendent port director property manager recreation facility manager school maintenance manager shopping centre maintenance manager shopping centre manager shopping mall maintenance manager shopping mall manager sports facility manager stadium manager superintendent of operations, maintenance superintendent, maintenance superintendent, maintenance and service superintendent, maintenance operations superintendent, mechanical services superintendent, plant maintenance tennis court manager tobacco warehouse manager university maintenance manager warehouse and distribution centre manager warehouse manager warehouse superintendent warehousing manager",
    "workers": 8442.5,
    "minEduc": 0,
    "yearsStudy": 2.428153904,
    "automationRisk": 0.071,
    "salaryLow": 19.385,
    "salaryMed": 28.43,
    "salaryHigh": 44.595,
    "totalSkill": 219,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 28.43,
    "skillsComp": 60,
    "skillsLogi": 51,
    "skillsMath": 32.5,
    "skillsLang": 76,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 11,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 24,
    "s9ProblemSolving": 12.5,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 17.5,
    "s12DigitalTechnology": 32.5,
    "s13DocumentUse": 16.5,
    "s14Writing": 26,
    "s15CriticalThinking": 12.5,
    "f1Science&Agriculture": 542.5,
    "f2Engineering": 3645,
    "f3Humanities": 20,
    "f4SocialScience": 220,
    "f5FineArts": 112.5,
    "f6MathAndComputerScience": 30,
    "f7Arts&Education": 2382.5,
    "f8Education(teachertraining)": 7.5,
    "f9Law": 70,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 5,
    "f12Business": 1372.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 57.5,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 990,
    "d4Humanities": 20,
    "d5SocialSciences": 220,
    "d6Fine&AppliedArts": 112.5,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 2382.5,
    "d9Education(teachertraining)": 7.5,
    "d10Engineering": 2655,
    "d11Law": 70,
    "d12Mathematics": 5,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 470,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 5,
    "d18Business&Commerce": 1372.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 42,
    "noc": 731,
    "job": "Managers in transportation",
    "title1": "air freight manager",
    "title2": "airline division manager",
    "title3": "airline division superintendent",
    "allTitles": "air freight managerairline division managerairline division superintendentairline express managerairline fleet operations managerairline flight schedule design managerairline managerairline superintendentarea manager, railway transportassistant general agent - railwayassistant manager, traffic and transportationassistant superintendent - railwayassistant traffic manager - transportationassistant transportation managerbus company managercartage company managercorporate traffic manager - transportationcorporate transportation managercurrent schedule planning manager - airlinedirector, distributiondirector, flight operationsdirector, logistics - transportationdirector of logistics - transportationdirector of operations, transportationdirector of traffic - transportationdirector of transportationdirector, transportation managementdistribution and warehousing managerdistribution directordistribution manager - logisticsdistribution operations manager - logisticsdistribution services managerdivision superintendent, airlinedivision superintendent, railwayexport traffic managerferry operations managerferry superintendentfleet manager, transportationfleet operations manager, airlineflight operations directorflight operations managerflight schedule design manager, airlineflight schedulers managerforwarder, freightfreight company managerfreight division managerfreight forwarderfreight forwarding managerfreight traffic managergeneral agent, railway transportgeneral traffic manager - transportationgeneral transportation managerimport traffic managerintegrated logistics managerinternational traffic managerlogistics director - transportationlogistics manager - transportationmanager, air freightmanager, airlinemanager, airline expressmanager, bus companymanager, cartage companymanager, corporate traffic - transportationmanager, corporate transportationmanager, current schedule planning - airlinemanager, distribution and warehousingmanager, distribution - logisticsmanager, distribution servicesmanager, export trafficmanager, freight divisionmanager, freight trafficmanager, import trafficmanager, integrated logisticsmanager, international trafficmanager, logistics - transportationmanager, motor transportmanager, moving companymanager, ocean freightmanager, rail transportmanager, ship linemanager, shipping servicesmanager, traffic - transportationmanager, transfer companymanager, transportationmanager, transportation and trafficmanager, transport departmentmanager, travel and relocation departmentmanager, urban transit systemmanager, water transportmarine operations managermarine operations superintendentmarine superintendentmarine transportation operations managermotor transport managermoving company managerocean freight manageroperations director, transportationoperations manager, marine transportationoperations manager, ship managementpassenger operations manager, railway",
    "workers": 3820,
    "minEduc": 0,
    "yearsStudy": 2.838095238,
    "automationRisk": 0.59,
    "salaryLow": 19.6,
    "salaryMed": 38.46,
    "salaryHigh": 69.93,
    "totalSkill": 142,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 38.46,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 18,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 430,
    "f2Engineering": 405,
    "f3Humanities": 20,
    "f4SocialScience": 225,
    "f5FineArts": 100,
    "f6MathAndComputerScience": 30,
    "f7Arts&Education": 480,
    "f8Education(teachertraining)": 0,
    "f9Law": 115,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 40,
    "f12Business": 1975,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 225,
    "d6Fine&AppliedArts": 100,
    "d7ComputerScience": 30,
    "d8OtherArts&Science": 480,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 405,
    "d11Law": 115,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 430,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 40,
    "d18Business&Commerce": 1975,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 43,
    "noc": 811,
    "job": "Managers in natural resources production and fishing",
    "title1": "director of mining",
    "title2": "director of mining operations",
    "title3": "drilling operations manager",
    "allTitles": "director of miningdirector of mining operationsdrilling operations managerfishing operations managerforestry and logging managerforestry operations managergas field operations managerlogging production managermanager, drilling operationsmanager, fishing operationsmanager, forestry and loggingmanager, forestry operationsmanager, gas field operationsmanager, logging productionmanager, minemanager of mining operationsmanager, oil well drillingmanager, oil well servicingmanager, peat bogmanager, production - coal miningmanager, quarrymanager, raw materials productionmanager, woodlandsmine managermine superintendentmining operations directormining operations manageroil and gas drilling superintendentoil and gas fields production manageroil well drilling manageroil well servicing managerpeat bog managerproduction manager - coal miningproduction manager, oil and gas fieldsquarrying managerquarrying operations managerquarry managerraw materials production managershore captain - fishingsuperintendent, minesuperintendent, oil and gas drillingsuperintendent, underground minesuperintendent, woodsunderground mine superintendentunderground mining superintendentwoodlands managerwoods superintendent",
    "workers": 135,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.36,
    "salaryLow": 17.44,
    "salaryMed": 54.32,
    "salaryHigh": 150.23,
    "totalSkill": 159,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 54.32,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 18,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 75,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 45,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 44,
    "noc": 821,
    "job": "Managers in agriculture",
    "title1": "animal breeder animal farmer apiarist apiculturist apple grower apple producer bean sprout farmer bean sprout grower beef cattle farmer beef producer beekeeper bird breeder breeder, dogs breeder, domestic animals breeder, goat breeder, pheasant breeder, rabbit broiler chicken producer broiler producer cat breeder cattle rancher cereal and oilseed grower cereal and oilseed producer cereal farm manager cereal grower cereal producer chicken farmer cow-calf operator crop farmer dairy cattle breeder dairy farm manager dairy farmer dog breeder egg producer farm manager farmer (except nursery and fish farm) farmer, beef cattle farmer, grain and oilseed farmer, hog farmer, poultry � egg production farmer, sheep farmer, sugar beet feedlot farmer forage crop farmer fruit farm operator fruit farmer fruit grower fruit producer fur farmer fur-bearing-animal farmer ginseng grower goat breeder grain and oilseed farmer grain and oilseed grower grain and oilseed producer grain farm manager grain farm operator grain farmer grain grower grain producer grape grower grape producer grower, ginseng grower, hop hatchery manager hatchery operator hog breeder hog farmer hog producer hop grower hop producer horse breeder kennel operator livestock farmer manager, farm maple syrup producer market gardener mixed farmer mushroom grower mushroom producer organic grower pheasant breeder potato farmer potato grower potato producer poultry breeder poultry breeder � egg production poultry farm manager poultry farmer � egg production poultry producer producer, poultry rabbit breeder rancher ranchman/woman rodent breeder rodent raiser seed farmer seed grower seed producer sheep farm operator sheep farmer sod farmer sugar beet farmer sugar maple grower tobacco farmer tomato grower tropical fish breeder turf farmer turkey producer vegetable gardener vegetable grower vineyard manager viticulturist wheat farmer wheat grower wheat producer",
    "title2": 0,
    "title3": 0,
    "allTitles": "animal breeder animal farmer apiarist apiculturist apple grower apple producer bean sprout farmer bean sprout grower beef cattle farmer beef producer beekeeper bird breeder breeder, dogs breeder, domestic animals breeder, goat breeder, pheasant breeder, rabbit broiler chicken producer broiler producer cat breeder cattle rancher cereal and oilseed grower cereal and oilseed producer cereal farm manager cereal grower cereal producer chicken farmer cow-calf operator crop farmer dairy cattle breeder dairy farm manager dairy farmer dog breeder egg producer farm manager farmer (except nursery and fish farm) farmer, beef cattle farmer, grain and oilseed farmer, hog farmer, poultry � egg production farmer, sheep farmer, sugar beet feedlot farmer forage crop farmer fruit farm operator fruit farmer fruit grower fruit producer fur farmer fur-bearing-animal farmer ginseng grower goat breeder grain and oilseed farmer grain and oilseed grower grain and oilseed producer grain farm manager grain farm operator grain farmer grain grower grain producer grape grower grape producer grower, ginseng grower, hop hatchery manager hatchery operator hog breeder hog farmer hog producer hop grower hop producer horse breeder kennel operator livestock farmer manager, farm maple syrup producer market gardener mixed farmer mushroom grower mushroom producer organic grower pheasant breeder potato farmer potato grower potato producer poultry breeder poultry breeder � egg production poultry farm manager poultry farmer � egg production poultry producer producer, poultry rabbit breeder rancher ranchman/woman rodent breeder rodent raiser seed farmer seed grower seed producer sheep farm operator sheep farmer sod farmer sugar beet farmer sugar maple grower tobacco farmer tomato grower tropical fish breeder turf farmer turkey producer vegetable gardener vegetable grower vineyard manager viticulturist wheat farmer wheat grower wheat producer",
    "workers": 135,
    "minEduc": 0,
    "yearsStudy": 2.5,
    "automationRisk": 0.47,
    "salaryLow": 14,
    "salaryMed": 19.31,
    "salaryHigh": 36.99,
    "totalSkill": 138,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 19.31,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 135,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 135,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 45,
    "noc": 822,
    "job": "Managers in horticulture",
    "title1": "Christmas tree farm operator",
    "title2": "evergreen grower",
    "title3": "flower grower",
    "allTitles": "Christmas tree farm operatorevergreen growerflower growergreenhouse managergreenhouse operatorgrower, evergreensgrower, flowergrower, hothouse flowersgrower, plants - nurserygrower, rosesgrower, shrubsgrower, trees - nurseryhorticultural greenhouse operatorhothouse flower growerhydroponic greenhouse operatorhydroponics growerhydroponics operatormanager, greenhousemanager, nurserynurserymannursery managernurseryman/womannursery operatornurserywomanoperator, greenhouseoperator, horticultural greenhouseoperator, hydroponic greenhouseoperator, nurseryoperator, tree nurseryplant grower - nurseryrose growershrub growertree grower - nurserytree nursery operator",
    "workers": 135,
    "minEduc": 0,
    "yearsStudy": 2.5,
    "automationRisk": 0.47,
    "salaryLow": 14,
    "salaryMed": 19.31,
    "salaryHigh": 36.99,
    "totalSkill": 138,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 19.31,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 135,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 135,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 46,
    "noc": 823,
    "job": "Managers in aquaculture",
    "title1": "aquaculture manager aquaculture operator eel farmer fish culture manager fish culture operator fish farm manager fish farm operator fish farmer fish hatchery manager fish hatchery operator lobster farmer manager, fish culture manager, fish farm manager, fish hatchery mussel farmer mussel grower operator, fish culture operator, fish farm operator, fish hatchery oyster farmer oyster grower salmon farmer salmon grower trout farmer",
    "title2": 0,
    "title3": 0,
    "allTitles": "aquaculture manager aquaculture operator eel farmer fish culture manager fish culture operator fish farm manager fish farm operator fish farmer fish hatchery manager fish hatchery operator lobster farmer manager, fish culture manager, fish farm manager, fish hatchery mussel farmer mussel grower operator, fish culture operator, fish farm operator, fish hatchery oyster farmer oyster grower salmon farmer salmon grower trout farmer",
    "workers": 135,
    "minEduc": 0,
    "yearsStudy": 2.5,
    "automationRisk": 0.47,
    "salaryLow": 14,
    "salaryMed": 19.31,
    "salaryHigh": 36.99,
    "totalSkill": 138,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 19.31,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 135,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 135,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 47,
    "noc": 911,
    "job": "Manufacturing managers",
    "title1": "automobile interior fittings production manager",
    "title2": "automobile production manager",
    "title3": "brewmaster",
    "allTitles": "automobile interior fittings production managerautomobile production managerbrewmasterbusiness manager - manufacturingcannery managerclothing factory managercontainer manufacturing managerco-ordinator, production planningdairy plant managerdirector of operations, manufacturingdistillery managerenologistfactory superintendentfield director - manufacturingfish-processing plant managerflour mill managerfood and beverage production managerfood-processing plant managerfood production managerfoundry managerfurniture factory managerindustrial and manufacturing production managerlogistics manager - manufacturinglumber mill managermanager, distillerymanager, flour millmanager, manufacturingmanager, manufacturing companymanager, manufacturing industrymanager, metalworks fabricationmanager, millmanager, operations - manufacturingmanager, paper millmanager, plantmanager, printingmanager, production operationsmanager, quality-control servicesmanager, railway rolling stock productionmanager, steel millmanager, textile millmanager, textile spinning millmanager, textile spinning plantmanager, tire plantmanager, tool production departmentmanufacturing company managermanufacturing industry managermanufacturing managermanufacturing operations managermanufacturing plant managermanufacturing plant superintendentmetal works fabrication managermill managermill manager, textile spinningmill superintendentmotor vehicle assembly plant manageroenologistoperations manager - manufacturingoperations manager, manufacturingoperations manager - public utilitiespackaging manufacturing plant managerpaper mill managerpickling plant managerplant assistant managerplant managerplant manager, manufacturingplant manager, motor vehicle assemblyplant manager, packaging manufacturingplant manager, picklingplant manager, plastic products manufacturingplant manager, printingplant manager, rubber products manufacturingplant manager, textile spinningplant superintendent, manufacturingplastic products-manufacturing plant managerprinting managerprinting plant managerproduction chiefproduction headproduction manager, automobile interior fittingsproduction manager - manufacturingproduction manager - printingproduction manager, railway carsproduction manager, railway rolling stockproduction operations managerproduction plannerproduction planning co-ordinatorproduction planning managerproduction senior co-ordinatorproduction superintendentpulp and paper mill managerquality-control services managerrailway car production managerrailway rolling stock production managerrefinery superintendentrubber products-manufacturing plant managersteel mill managersuperintendent, factorysuperintendent, millsuperintendent, productionsuperintendent, refinery",
    "workers": 17445,
    "minEduc": 0.5,
    "yearsStudy": 2.508982036,
    "automationRisk": 0.5,
    "salaryLow": 24.04,
    "salaryMed": 42.68,
    "salaryHigh": 69.23,
    "totalSkill": 143,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 33.4481646,
    "skillsComp": 37.5,
    "skillsLogi": 31.5,
    "skillsMath": 21,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 18.5,
    "s9ProblemSolving": 7.5,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 21,
    "s14Writing": 12.5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1690,
    "f2Engineering": 6055,
    "f3Humanities": 205,
    "f4SocialScience": 835,
    "f5FineArts": 575,
    "f6MathAndComputerScience": 425,
    "f7Arts&Education": 2455,
    "f8Education(teachertraining)": 65,
    "f9Law": 225,
    "f10Health": 40,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 4780,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 425,
    "d2Forestry": 70,
    "d3Architecture&LandscapeArchitecture": 145,
    "d4Humanities": 185,
    "d5SocialSciences": 835,
    "d6Fine&AppliedArts": 575,
    "d7ComputerScience": 330,
    "d8OtherArts&Science": 2455,
    "d9Education(teachertraining)": 65,
    "d10Engineering": 5910,
    "d11Law": 225,
    "d12Mathematics": 95,
    "d13Kinesiology/Recreation/PhysicalEducation": 40,
    "d14Theology": 20,
    "d15PhysicalSciences": 1195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 4780,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 48,
    "noc": 912,
    "job": "Utilities managers",
    "title1": "compost facility manager",
    "title2": "compressor station manager",
    "title3": "director, distribution network - utilities",
    "allTitles": "compost facility managercompressor station managerdirector, distribution network - utilitiesdirector, distribution systems - utilitiesdirector, electrical power transmission operationsdirector, hydro-electric power production plantdirector, hydro-electric power stationdirector of waste managementdirector of water pollution controldirector, sewage treatment systemdirector, transmission operations - utilitiesdirector, waste water treatment systemdirector, water departmentdirector, water supplydistribution manager, gasdistribution manager, refined petroleum productsdistribution network director - utilitiesdistribution operations manager - utilitiesdistribution systems director - utilitiesdistrict manager, irrigationdivision manager - petroleum distributionelectrical power transmission operations directorelectric generating plant managerelectric generating station managerelectric power plant managerelectric power services managergas distribution managergas supply managergas supply operations managerhydro-electric power production plant directorhydro-electric power station directorirrigation district managerlandfill managerliquid waste facility managermanager, compressor stationmanager, distribution, refined petroleum productsmanager, electric generating plantmanager, electric generating stationmanager, electric power plantmanager, electric power servicesmanager, gas supply operationsmanager, liquid waste facilitymanager, public utilitiesmanager, sanitary sewer servicemanager, sewage disposalmanager, sewage plantmanager, sewage treatment plantmanager, transmission linesmanager, waterworksnuclear waste manageroperations manager, pipelinespetroleum distribution managerpipelines operations managerplant manager, sewage treatmentpublic utilities managerrefined petroleum products distribution managersanitary sewer service managersewage disposal managersewage plant managersewage treatment plant managersewage treatment system directorsolid waste processing district managersolid waste processing managersolid waste processing operations planning managertransmission lines managertransmission operations director - utilitieswaste management directorwaste water treatment system directorwater department directorwater distribution managerwater filtration plant managerwater pollution control directorwaterworks directorwaterworks managerwaterworks superintendent",
    "workers": 1625,
    "minEduc": 0,
    "yearsStudy": 3.033898305,
    "automationRisk": 0.31,
    "salaryLow": 31.25,
    "salaryMed": 54.95,
    "salaryHigh": 76.92,
    "totalSkill": 161,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 54.95,
    "skillsComp": 43,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 18,
    "s14Writing": 16,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 105,
    "f2Engineering": 750,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 205,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 525,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 205,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 730,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 105,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 525,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 49,
    "noc": 1111,
    "job": "Financial auditors and accountants",
    "title1": "accountant accountant-controller accountants supervisor accounting controller analyst-accountant assistant controller audit unit head � taxation auditor � finance auditor-CA (chartered accountant) auditor-chartered accountant (CA) auditors supervisor bank branch accountant bank reserves auditor bankruptcy trustee branch accountant, bank budget accountant CA (chartered accountant) student certified general accountant (CGA) certified management accountant (CMA) chartered accountant (CA) chartered accountant (CA) student chief accountant claims accountant computer audit specialist cost accountant cost accounting supervisor departmental accountant division controller � accounting field auditor � finances financial accountant financial auditor financial control officer general accountant income tax adjuster income tax adviser income tax consultant income tax expert income tax investigator income tax specialist industrial accountant industrial auditor intermediate accountant internal audit project manager internal audit supervisor � finances internal auditor internal auditor � finances internal auditors supervisor � finances machine processing accountant management accountant management accounting chief manufacturing accountant officer, financial control plant accountant plant controller production accountant project accountant property accountant public accountant public accountants chief public accountants supervisor reinsurance analyst rulings officer, taxation sales auditor � finances senior accounting analyst senior cost accountant senior intern auditor supervisor, accountants supervisor, auditors supervisor, cost accounting supervisor, internal audit � finances supervisor, internal auditors � finances supervisor, public accountants tax accountant tax adviser tax analyst tax auditor tax consultant tax evaluator tax examiner tax expert tax specialist taxation rulings officer",
    "title2": 0,
    "title3": 0,
    "allTitles": "accountant accountant-controller accountants supervisor accounting controller analyst-accountant assistant controller audit unit head � taxation auditor � finance auditor-CA (chartered accountant) auditor-chartered accountant (CA) auditors supervisor bank branch accountant bank reserves auditor bankruptcy trustee branch accountant, bank budget accountant CA (chartered accountant) student certified general accountant (CGA) certified management accountant (CMA) chartered accountant (CA) chartered accountant (CA) student chief accountant claims accountant computer audit specialist cost accountant cost accounting supervisor departmental accountant division controller � accounting field auditor � finances financial accountant financial auditor financial control officer general accountant income tax adjuster income tax adviser income tax consultant income tax expert income tax investigator income tax specialist industrial accountant industrial auditor intermediate accountant internal audit project manager internal audit supervisor � finances internal auditor internal auditor � finances internal auditors supervisor � finances machine processing accountant management accountant management accounting chief manufacturing accountant officer, financial control plant accountant plant controller production accountant project accountant property accountant public accountant public accountants chief public accountants supervisor reinsurance analyst rulings officer, taxation sales auditor � finances senior accounting analyst senior cost accountant senior intern auditor supervisor, accountants supervisor, auditors supervisor, cost accounting supervisor, internal audit � finances supervisor, internal auditors � finances supervisor, public accountants tax accountant tax adviser tax analyst tax auditor tax consultant tax evaluator tax examiner tax expert tax specialist taxation rulings officer",
    "workers": 16606.66667,
    "minEduc": 1,
    "yearsStudy": 3.665234243,
    "automationRisk": 0.192,
    "salaryLow": 18,
    "salaryMed": 36,
    "salaryHigh": 60.1,
    "totalSkill": 158.6666667,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 33.01,
    "skillsComp": 41.33333333,
    "skillsLogi": 38.33333333,
    "skillsMath": 24.66666667,
    "skillsLang": 54.66666667,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6.333333333,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6.333333333,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4.666666667,
    "s6MoneyMath": 3.333333333,
    "s7NumericalEstimation": 4.333333333,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 9.333333333,
    "s10Reading": 19.66666667,
    "s11SchedulingorBudgetingandAccounting": 12.33333333,
    "s12DigitalTechnology": 18.66666667,
    "s13DocumentUse": 16,
    "s14Writing": 16.66666667,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 138.3333333,
    "f2Engineering": 435,
    "f3Humanities": 178.3333333,
    "f4SocialScience": 2363.333333,
    "f5FineArts": 180,
    "f6MathAndComputerScience": 595,
    "f7Arts&Education": 686.6666667,
    "f8Education(teachertraining)": 106.6666667,
    "f9Law": 273.3333333,
    "f10Health": 60,
    "f11Health,Nursing&ClinicalLaboratory": 76.66666667,
    "f12Business": 11513.33333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 156.6666667,
    "d5SocialSciences": 2363.333333,
    "d6Fine&AppliedArts": 180,
    "d7ComputerScience": 301.6666667,
    "d8OtherArts&Science": 686.6666667,
    "d9Education(teachertraining)": 106.6666667,
    "d10Engineering": 435,
    "d11Law": 273.3333333,
    "d12Mathematics": 293.3333333,
    "d13Kinesiology/Recreation/PhysicalEducation": 51.66666667,
    "d14Theology": 21.66666667,
    "d15PhysicalSciences": 48.33333333,
    "d16Therapy&Rehabilitation": 8.333333333,
    "d17Health,Nursing&ClinicalLaboratory": 76.66666667,
    "d18Business&Commerce": 11513.33333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 50,
    "noc": 1112,
    "job": "Financial and investment analysts",
    "title1": "analyst, investments",
    "title2": "analyst, money market",
    "title3": "analyst, securities",
    "allTitles": "analyst, investmentsanalyst, money marketanalyst, securitiesassistant financial analystchartered financial analystcost financial analysteconomic analyst, financial servicesfinance and commercial affairs analystfinancial analysis consultantfinancial analystfiscal projections consultantinvestment adviser, corporateinvestment analystinvestment consultantjunior financial analystmoney market analystportfolio managerregional financial analystresearch analyst, securitiesresearch associate, financial servicessecurities analystsecurities research analystsenior financial analystsenior investment officersenior planning and return analystsenior planning and yield analyst",
    "workers": 16205,
    "minEduc": 0,
    "yearsStudy": 3.76744186,
    "automationRisk": 0.23,
    "salaryLow": 22,
    "salaryMed": 33.65,
    "salaryHigh": 55.77,
    "totalSkill": 155,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 33.65,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 75,
    "f2Engineering": 345,
    "f3Humanities": 95,
    "f4SocialScience": 1890,
    "f5FineArts": 40,
    "f6MathAndComputerScience": 960,
    "f7Arts&Education": 380,
    "f8Education(teachertraining)": 35,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 60,
    "f12Business": 12305,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 95,
    "d5SocialSciences": 1890,
    "d6Fine&AppliedArts": 40,
    "d7ComputerScience": 395,
    "d8OtherArts&Science": 380,
    "d9Education(teachertraining)": 35,
    "d10Engineering": 345,
    "d11Law": 20,
    "d12Mathematics": 565,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 60,
    "d18Business&Commerce": 12305,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 51,
    "noc": 1113,
    "job": "Securities agents, investment dealers and brokers",
    "title1": "agent, securities",
    "title2": "annuity representative - investments",
    "title3": "arbitrager",
    "allTitles": "agent, securitiesannuity representative - investmentsarbitragerbond brokerbond dealerbond traderbrokerbroker, investmentscommodity brokercommodity traderdealer, foreign exchangediscount brokerequity traderfinancial brokerfloor trader - commodity exchangefloor trader, stock exchangeforeign exchange dealerforeign exchange traderfutures tradergrain brokergrain broker - commodity tradinggrain traderindependent floor traderinvestment brokerinvestment dealerinvestment representativemoney market tradermutual fund brokermutual fund sales agentmutual fund sales representativeoptions traderregistered investment representativeregistered representatives supervisorrepresentative, securitiessales agent, securitiessalesman, securitiessalesman/woman, securitiessaleswoman, securitiessecurities agentsecurities representativesecurities sales agentsecurities salesmansecurities salesman/womansecurities saleswomansecurities traderstockbrokerstock exchange floor traderstocks and bonds tradersupervisor, registered representativestrader, foreign exchangetrader, stocks and bondstrust services salesmantrust services salesman/womantrust services saleswoman",
    "workers": 4400,
    "minEduc": 0,
    "yearsStudy": 3.72826087,
    "automationRisk": 0.016,
    "salaryLow": 16,
    "salaryMed": 32.05,
    "salaryHigh": 76.92,
    "totalSkill": 164,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 32.05,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 35,
    "f2Engineering": 125,
    "f3Humanities": 30,
    "f4SocialScience": 785,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 140,
    "f7Arts&Education": 205,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 3060,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 30,
    "d5SocialSciences": 785,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 80,
    "d8OtherArts&Science": 205,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 125,
    "d11Law": 20,
    "d12Mathematics": 60,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 35,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 3060,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 52,
    "noc": 1114,
    "job": "Other financial officers",
    "title1": "account manager",
    "title2": "administrator, estate",
    "title3": "bank inspector",
    "allTitles": "account manageradministrator, estatebank inspectorbonds underwritercounsellor, securitiescredit adjudicatorcredit agency inspectorcredit unions examinerestate administratorestate and trust administratorestate executorestimates and programs controllerexaminer, credit unionsexaminer, financial institutionsexecutor, estatefinance and credit administrator - international bankingfinancial institutions examinerfinancial institutions inspectorfinancial investigatorfinancial management officerfinancial management officer - pension plan analysisfinancial management officer - program budgetingfinancial plannerfinancial planner - personal financesfinancial services consultantfinancial underwriterforeign interbanking arrangements officerinspector, banksinspector, credit agencyinspector, financial institutionsinterbanking arrangements officerinvestment advisor - personal financesinvestment counsellor - personal financeslending solutions managermortgage brokermortgage underwriterpersonal financial plannerpersonal trust officersecurities analyst - personal financessecurities counsellorsecurities underwritertrust officerunderwriter, securities",
    "workers": 29215,
    "minEduc": 3,
    "yearsStudy": 3.5,
    "automationRisk": 0.33,
    "salaryLow": 17.95,
    "salaryMed": 33.33,
    "salaryHigh": 59.34,
    "totalSkill": 157,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 33.33,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 29,
    "skillsLang": 55,
    "topSkill1": "Scheduling or Budgeting and Accounting",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 7,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 22,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 14,
    "s14Writing": 18,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 305,
    "f2Engineering": 835,
    "f3Humanities": 410,
    "f4SocialScience": 4415,
    "f5FineArts": 500,
    "f6MathAndComputerScience": 685,
    "f7Arts&Education": 1475,
    "f8Education(teachertraining)": 285,
    "f9Law": 780,
    "f10Health": 180,
    "f11Health,Nursing&ClinicalLaboratory": 170,
    "f12Business": 19175,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 180,
    "d2Forestry": 40,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 345,
    "d5SocialSciences": 4415,
    "d6Fine&AppliedArts": 500,
    "d7ComputerScience": 430,
    "d8OtherArts&Science": 1475,
    "d9Education(teachertraining)": 285,
    "d10Engineering": 835,
    "d11Law": 780,
    "d12Mathematics": 255,
    "d13Kinesiology/Recreation/PhysicalEducation": 155,
    "d14Theology": 65,
    "d15PhysicalSciences": 85,
    "d16Therapy&Rehabilitation": 25,
    "d17Health,Nursing&ClinicalLaboratory": 170,
    "d18Business&Commerce": 19175,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 53,
    "noc": 1121,
    "job": "Human resources professionals",
    "title1": "adjudicator, labour",
    "title2": "analyst, job evaluation",
    "title3": "arbitrator, human resources",
    "allTitles": "adjudicator, labouranalyst, job evaluationarbitrator, human resourcesbargaining agentbenefits consultantbusiness agent, labour organizationbusiness agent, labour unionbusiness representative, labour organizationcertified disability management professionalchief of compensation and human resources information systemsclaims manager - compensation and benefitsclassification officer - human resourcesclassification policy adviserclassification specialistcollective agreement negotiatorcompensation and benefits co-ordinatorcompensation and classification analystcompensation consultantcompensation officercompensation research analystcompensation researcher-analystconciliation officer - employee relationsconciliatorconciliator - labourconsultant, human resourcesconsultant, labour relationsco-ordinator, compensation and benefitsco-ordinator, employer-employee relationsco-ordinator, employment equityco-ordinator, human resourcesco-ordinator, labour relationsdisability case manager - human resourcesdisability management coordinatordisability management practitionerdisability management professionaldisability management specialistemployee relations officeremployee services officeremployer-employee relations co-ordinatoremployment adviser - human resourcesemployment equity adviser - human resourcesemployment equity co-ordinatoremployment equity officeremployment practices officerhuman resources adviserhuman resources classification officerhuman resources consultanthuman resources co-ordinatorhuman resources generalisthuman resources management consultanthuman resources planning consultanthuman resources policy analysthuman resources policy officerhuman resources program supervisorhuman resources research officerhuman resources specialisthuman resources supervisorindustrial relations consultantindustrial relations officerin-house training managerjob analystjob and wage analystjob classification system analystjob evaluation analystjob evaluation supervisorjob evaluatorlabour adjudicatorlabour organization agentlabour organization business agentlabour organization business representativelabour organization liaison officerlabour organization negotiatorlabour organizerlabour relations board officerlabour relations consultantlabour relations co-ordinatorlabour relations officerlabour relations returning officerlabour relations specialistlabour union business agentlabour union liaison officerliaison officer, labour organizationliaison officer, labour unionmediatormediator - labour relationsnegotiator, collective agreementsnegotiator, labour organizationoccupational analyst - human resourcespersonnel research officerpersonnel standards officerposition classifiersalary analystsenior industrial relations officersenior negotiating officer - labour dispute resolutionstaff relations administratorstaff relations officerstaff training and development officerstaff training and development supervisorstaff training officer - human resourcessupervisor, human resources",
    "workers": 16320,
    "minEduc": 3,
    "yearsStudy": 3.592885375,
    "automationRisk": 0.201,
    "salaryLow": 20.98,
    "salaryMed": 32.05,
    "salaryHigh": 53.85,
    "totalSkill": 194,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 32.05,
    "skillsComp": 32,
    "skillsLogi": 50,
    "skillsMath": 21,
    "skillsLang": 91,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 17,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 27,
    "s9ProblemSolving": 17,
    "s10Reading": 33,
    "s11SchedulingorBudgetingandAccounting": 15,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 10,
    "s14Writing": 31,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 95,
    "f2Engineering": 100,
    "f3Humanities": 395,
    "f4SocialScience": 2930,
    "f5FineArts": 405,
    "f6MathAndComputerScience": 330,
    "f7Arts&Education": 1250,
    "f8Education(teachertraining)": 665,
    "f9Law": 600,
    "f10Health": 405,
    "f11Health,Nursing&ClinicalLaboratory": 380,
    "f12Business": 8765,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 375,
    "d5SocialSciences": 2930,
    "d6Fine&AppliedArts": 405,
    "d7ComputerScience": 175,
    "d8OtherArts&Science": 1250,
    "d9Education(teachertraining)": 665,
    "d10Engineering": 100,
    "d11Law": 600,
    "d12Mathematics": 155,
    "d13Kinesiology/Recreation/PhysicalEducation": 95,
    "d14Theology": 20,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 310,
    "d17Health,Nursing&ClinicalLaboratory": 380,
    "d18Business&Commerce": 8765,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 54,
    "noc": 1122,
    "job": "Professional occupations in business management consulting",
    "title1": "adviser, corporate development planning",
    "title2": "analyst, business management",
    "title3": "analyst, business methods",
    "allTitles": "adviser, corporate development planninganalyst, business managementanalyst, business methodsanalyst, filing systemsanalyst, industrial and commercial methodsanalyst, methods and costanalyst, methods and proceduresanalyst, occupational - services to management firmsanalyst, records management systemsanalyst, time studyanalyst, work studybusiness consultantbusiness management analystbusiness management consultantbusiness methods analystcertified management consultantclient group supervisorconference facilitatorconsultant, businessconsultant, managementconsultant, organizational analysisco-ordinator, standardscorporate development planning advisercorporate plannerdirect mail specialistexport trade consultantfacilitator, conferencefile managerfiling systems analystforms management analysts supervisorhealth information management consultantindustrial and commercial methods analystISO consultantmanagement analystmanagement consultantmethods and cost analystmethods and procedures analystoccupational analyst - services to management firmsofficer, organization and methodsoperations management senior consultantorganizational analysis consultantorganizational analystorganization and methods officerorganization and methods researcherpoint of sale system managerprice management analystquality auditor, industrial standardsrecords filing systems analysts supervisorrecords management specialistrecords management systems analystrecords manager - business servicesresearcher, organization and methodssenior consultant, operations managementspecialist, records managementspecialist, standardsstandards co-ordinatorstandards specialistsupervisor, forms management analystssupervisor, records filing systems analystssupervisor, work study analystssupply chain process analystteam training specialisttime study analyst - services to management firmstransition management consultantwork reorganization consultantwork study analystwork study analysts supervisor",
    "workers": 20890,
    "minEduc": 3,
    "yearsStudy": 3.843930636,
    "automationRisk": 0.071,
    "salaryLow": 16.49,
    "salaryMed": 32.69,
    "salaryHigh": 50,
    "totalSkill": 183,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 32.69,
    "skillsComp": 56,
    "skillsLogi": 48,
    "skillsMath": 22,
    "skillsLang": 57,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 17,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 9,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 16,
    "s14Writing": 17,
    "s15CriticalThinking": 17,
    "f1Science&Agriculture": 560,
    "f2Engineering": 2005,
    "f3Humanities": 250,
    "f4SocialScience": 2575,
    "f5FineArts": 560,
    "f6MathAndComputerScience": 1840,
    "f7Arts&Education": 990,
    "f8Education(teachertraining)": 255,
    "f9Law": 330,
    "f10Health": 175,
    "f11Health,Nursing&ClinicalLaboratory": 110,
    "f12Business": 11240,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 140,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 230,
    "d5SocialSciences": 2575,
    "d6Fine&AppliedArts": 560,
    "d7ComputerScience": 1385,
    "d8OtherArts&Science": 990,
    "d9Education(teachertraining)": 255,
    "d10Engineering": 1990,
    "d11Law": 330,
    "d12Mathematics": 455,
    "d13Kinesiology/Recreation/PhysicalEducation": 45,
    "d14Theology": 20,
    "d15PhysicalSciences": 395,
    "d16Therapy&Rehabilitation": 130,
    "d17Health,Nursing&ClinicalLaboratory": 110,
    "d18Business&Commerce": 11240,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 55,
    "noc": 1123,
    "job": "Professional occupations in advertising, marketing and public relations",
    "title1": "account executive, advertising actor agent advertising account executive advertising account manager advertising and promotions co-ordinator advertising and promotions specialist advertising campaign organizer advertising consultant advertising specialist affiliated stations relations administrator agent, actors agent, athlete agent, career agent, entertainment agent, musicians agent, performers agent, singers agent, sports agent, talent art educator � museum artist agent artistic agent assistant brand manager � advertising assistant press secretary athlete agent athletes manager author's agent book publicist boxing promoter career agent casting agent casting agent for extras communications adviser communications consultant communications expert communications officer communications specialist community information officer consultant, advertising co-ordinator, information service co-ordinator, media relations education officer, museum entertainment agent event marketing specialist financing officer � fundraising fundraising campaign consultant fundraising campaign organizer fundraising consultant fundraising organizer information co-ordinator information officer information officer, publicity information officer, recreation association literary agent manager, athletes marketing consultant � advertising marketing co-ordinator marketing specialist � advertising media co-ordinator media events co-ordinator media relations co-ordinator media relations officer museum education officer museum educator musicians agent officer, public relations organizer, advertising campaign performers agent press agent press agent, public relations press secretary press secretary, public relations product manager � marketing promotion strategies consultant public affairs officer public relations agent public relations consultant public relations co-ordinator public relations officer public relations practitioner public relations press agent public relations press secretary public relations representative public relations specialist publicist publicity agent publicity co-ordinator publicity information officer recreation association information officer sales and promotions co-ordinator singers agent specialist � e-media advertising specialist, advertising spokesperson sports agent stations-relations administrator talent agent talent representative theatrical agent theatrical business agent tourism information officer tourism information technician",
    "title2": 0,
    "title3": 0,
    "allTitles": "account executive, advertising actor agent advertising account executive advertising account manager advertising and promotions co-ordinator advertising and promotions specialist advertising campaign organizer advertising consultant advertising specialist affiliated stations relations administrator agent, actors agent, athlete agent, career agent, entertainment agent, musicians agent, performers agent, singers agent, sports agent, talent art educator � museum artist agent artistic agent assistant brand manager � advertising assistant press secretary athlete agent athletes manager author's agent book publicist boxing promoter career agent casting agent casting agent for extras communications adviser communications consultant communications expert communications officer communications specialist community information officer consultant, advertising co-ordinator, information service co-ordinator, media relations education officer, museum entertainment agent event marketing specialist financing officer � fundraising fundraising campaign consultant fundraising campaign organizer fundraising consultant fundraising organizer information co-ordinator information officer information officer, publicity information officer, recreation association literary agent manager, athletes marketing consultant � advertising marketing co-ordinator marketing specialist � advertising media co-ordinator media events co-ordinator media relations co-ordinator media relations officer museum education officer museum educator musicians agent officer, public relations organizer, advertising campaign performers agent press agent press agent, public relations press secretary press secretary, public relations product manager � marketing promotion strategies consultant public affairs officer public relations agent public relations consultant public relations co-ordinator public relations officer public relations practitioner public relations press agent public relations press secretary public relations representative public relations specialist publicist publicity agent publicity co-ordinator publicity information officer recreation association information officer sales and promotions co-ordinator singers agent specialist � e-media advertising specialist, advertising spokesperson sports agent stations-relations administrator talent agent talent representative theatrical agent theatrical business agent tourism information officer tourism information technician",
    "workers": 18605,
    "minEduc": 3,
    "yearsStudy": 3.718408006,
    "automationRisk": 0.136,
    "salaryLow": 18.27,
    "salaryMed": 30,
    "salaryHigh": 53.85,
    "totalSkill": 188.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 32.37,
    "skillsComp": 44,
    "skillsLogi": 49,
    "skillsMath": 21.5,
    "skillsLang": 74,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 12.5,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 3.5,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 23.5,
    "s9ProblemSolving": 13,
    "s10Reading": 26.5,
    "s11SchedulingorBudgetingandAccounting": 11,
    "s12DigitalTechnology": 18.5,
    "s13DocumentUse": 13,
    "s14Writing": 24,
    "s15CriticalThinking": 8.5,
    "f1Science&Agriculture": 327.5,
    "f2Engineering": 1052.5,
    "f3Humanities": 322.5,
    "f4SocialScience": 2752.5,
    "f5FineArts": 482.5,
    "f6MathAndComputerScience": 1085,
    "f7Arts&Education": 1120,
    "f8Education(teachertraining)": 460,
    "f9Law": 465,
    "f10Health": 290,
    "f11Health,Nursing&ClinicalLaboratory": 245,
    "f12Business": 10002.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 80,
    "d2Forestry": 22.5,
    "d3Architecture&LandscapeArchitecture": 7.5,
    "d4Humanities": 302.5,
    "d5SocialSciences": 2752.5,
    "d6Fine&AppliedArts": 482.5,
    "d7ComputerScience": 780,
    "d8OtherArts&Science": 1120,
    "d9Education(teachertraining)": 460,
    "d10Engineering": 1045,
    "d11Law": 465,
    "d12Mathematics": 305,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 20,
    "d15PhysicalSciences": 225,
    "d16Therapy&Rehabilitation": 220,
    "d17Health,Nursing&ClinicalLaboratory": 245,
    "d18Business&Commerce": 10002.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 56,
    "noc": 1211,
    "job": "Supervisors, general office and administrative support workers",
    "title1": "administrative services supervisor",
    "title2": "attendance records supervisor",
    "title3": "clerical supervisor",
    "allTitles": "administrative services supervisorattendance records supervisorclerical supervisorcontract clerks supervisorco-ordinator, word processing servicedata control supervisordata entry clerks supervisordata entry supervisordesktop publishing supervisordesktop publishing system supervisorEDP (electronic data-processing) unit - supervisorelectronic data-processing (EDP) unit - supervisorfiling clerks supervisorfiling service supervisorgeneral office clerks supervisorhospital admitting clerks supervisornight supervisor, telephone systemnursing registry supervisoroffice clerks supervisoroffice machine operators supervisoroffice services supervisoroffice supervisoroperations supervisorpersonnel clerks supervisorphotocopy unit supervisorprice information clerks supervisorreceptionists and hostesses supervisorreceptionists supervisorrecords clerks supervisorrecords management services supervisorrecords management supervisorrecords office supervisorregistration unit supervisorregistry supervisorsupervisor, attendance recordssupervisor, contract clerkssupervisor, data controlsupervisor, data entry clerkssupervisor, desktop publishing operatorssupervisor, desktop publishing systemsupervisor, EDP (electronic data-processing) unitsupervisor, electronic data processing (EDP) unitsupervisor, filing clerkssupervisor, filing servicesupervisor, general office clerkssupervisor, hospital admitting clerkssupervisor, nursing registrysupervisor, office clerkssupervisor, office machine operatorssupervisor, office servicessupervisor, personnel clerkssupervisor, photocopy unitsupervisor, price information clerkssupervisor, receptionistssupervisor, receptionists and hostessessupervisor, records clerkssupervisor, records officesupervisor, registration unitsupervisor, switchboard operatorssupervisor, telephone operatorssupervisor, unit clerkssupervisor, word processing unitswitchboard operators supervisortelephone operators supervisortelephone service supervisortelephone system night supervisortelephone system supervisorunit clerks supervisorword processing service co-ordinatorword processing unit supervisor",
    "workers": 640,
    "minEduc": 0,
    "yearsStudy": 2.565217391,
    "automationRisk": 0.014,
    "salaryLow": 14,
    "salaryMed": 25,
    "salaryHigh": 44.71,
    "totalSkill": 161,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 25,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 30,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 50,
    "f9Law": 45,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 40,
    "f12Business": 450,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 30,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 50,
    "d10Engineering": 0,
    "d11Law": 45,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 40,
    "d18Business&Commerce": 450,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 57,
    "noc": 1212,
    "job": "Supervisors, finance and insurance office workers",
    "title1": "accounting clerks supervisor",
    "title2": "accounting section head",
    "title3": "accounting supervisor",
    "allTitles": "accounting clerks supervisoraccounting section headaccounting supervisoraccounts payable analystaccounts payable supervisoraccounts receivable supervisorassessment clerks supervisorassistant accountantassistant bank accountantassistant financial institution accountant - financial servicesbank clerks supervisorbilling co-ordinatorbilling supervisorbilling unit headbookkeepers and accounting clerks supervisorbookkeeping supervisorbudget supervisorcash receipts supervisorclaims adjusters supervisorclaims service supervisorclerks supervisor - bank or financial institutioncollection clerks supervisorcollection supervisorcost supervisorcredit and collection supervisorcredit clerks supervisorcredit service group leadercredit supervisorcustoms brokerage clerks supervisorfinancial accounting supervisorfinancial control supervisorhead, accounting sectionhead, billing unitmerchandise clerks supervisorpay and benefits supervisorpaymasterpayment processing unit supervisorpayroll supervisorpetty cash supervisorsales records supervisorsupervisor, accounting clerkssupervisor, assessment clerkssupervisor, bank clerkssupervisor, billingsupervisor, bookkeepers and accounting clerkssupervisor, claims adjusterssupervisor, collection clerkssupervisor, credit clerkssupervisor, customs brokerage clerkssupervisor, financial accountingsupervisor, merchandise clerkssupervisor of accountingsupervisor, payment processing unitsupervisor, payrollsupervisor, payroll clerkstabulating supervisortabulation supervisortabulators supervisortollgate supervisor",
    "workers": 5430,
    "minEduc": 1,
    "yearsStudy": 2.157574153,
    "automationRisk": 0.417,
    "salaryLow": 16.3,
    "salaryMed": 25.64,
    "salaryHigh": 41.03,
    "totalSkill": 149.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 31.245,
    "skillsComp": 43,
    "skillsLogi": 38,
    "skillsMath": 18,
    "skillsLang": 50,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 9.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 8,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17.5,
    "s14Writing": 13,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 210,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 35,
    "f9Law": 60,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 2240,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 210,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 35,
    "d10Engineering": 0,
    "d11Law": 60,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 10,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 2240,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 58,
    "noc": 1213,
    "job": "Supervisors, library, correspondence and related information workers",
    "title1": "advertising clerks supervisor",
    "title2": "census area manager",
    "title3": "census area manager assistant",
    "allTitles": "advertising clerks supervisorcensus area managercensus area manager assistantcensus commissionercensus commissioner assistantcensus district managercommunication clerks supervisorcopyright clearance supervisorcorrespondence clerks supervisorcourt reporters supervisorcustoms clerks supervisorfingerprint classifier supervisorlaw archivists supervisorlegal services record writers supervisorlibrary clerks supervisorlibrary loans supervisorlicence clerks supervisorloans supervisor, librarypassport office supervisorpublication clerks supervisorpublic opinion interviewers supervisorregional census managerstatistical clerks supervisorsupervisor, advertising clerkssupervisor, communication clerkssupervisor, copyright clearancesupervisor, correspondence clerkssupervisor, court reporterssupervisor, customs clerkssupervisor, fingerprint classifiersupervisor, law archivistssupervisor, legal services record writerssupervisor, library clerkssupervisor, licence clerkssupervisor, passport officesupervisor, publication clerkssupervisor, public opinion interviewerssupervisor, statistical clerkssupervisor, survey interviewerssurvey interviewers supervisor",
    "workers": 220,
    "minEduc": 0,
    "yearsStudy": 3.25,
    "automationRisk": 0.014,
    "salaryLow": 15.23333333,
    "salaryMed": 24.54666667,
    "salaryHigh": 41.91333333,
    "totalSkill": 158,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 36.77635169,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 80,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 80,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 59,
    "noc": 1214,
    "job": "Business development officers and marketing researchers and consultants",
    "title1": "assistant postmaster",
    "title2": "assistant postmaster/mistress",
    "title3": "assistant postmistress",
    "allTitles": "assistant postmasterassistant postmaster/mistressassistant postmistresscourier service supervisorletter carriers supervisormail and postal clerks supervisormail carriers supervisormail clerks supervisormail facilities senior administratormail room supervisormessenger service supervisorpostal clerks supervisorpostal station employees supervisorpostal station supervisorpostal workers supervisorpostmasterpostmaster/mistresspostmistresssenior administrator, mail facilitiessupervisor, letter carrierssupervisor, mail and postal clerkssupervisor, mail carrierssupervisor, mail clerkssupervisor, messenger servicesupervisor, postal clerkssupervisor, postal stationsupervisor, postal station employeessupervisor, postal workers",
    "workers": 16915,
    "minEduc": 1.5,
    "yearsStudy": 3.013138138,
    "automationRisk": 0.122,
    "salaryLow": 15.23333333,
    "salaryMed": 24.54666667,
    "salaryHigh": 41.91333333,
    "totalSkill": 174.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 34.63817584,
    "skillsComp": 51,
    "skillsLogi": 38.5,
    "skillsMath": 20.5,
    "skillsLang": 64.5,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Writing",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4.5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 25.5,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 26,
    "s13DocumentUse": 16.5,
    "s14Writing": 22,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 40,
    "f3Humanities": 25,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 110,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 40,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 110,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 60,
    "noc": 1215,
    "job": "Supervisors, supply chain, tracking and scheduling co-ordination occupations",
    "title1": "911 emergency centre operations officer",
    "title2": "aerodrome supervisor",
    "title3": "airline load control supervisor",
    "allTitles": "911 emergency centre operations officeraerodrome supervisorairline load control supervisorair transport operating staff supervisorair transport operations supervisorair transport operations support supervisorammunition foremanammunition foreman/womanammunition forewomanavionics service supervisorco-ordinator, freight trafficcrew schedulers supervisorcrew schedules supervisorcross dock supervisordispatchers supervisordispatch logisticiandistribution and transport logistics techniciandistribution officerdistribution supervisorexplosives and ammunition magazine foremanexplosives and ammunition magazine foreman/womanexplosives and ammunition magazine forewomanexplosives magazine foremanexplosives magazine foreman/womanexplosives magazine forewomanexport traffic supervisorflight crew scheduling supervisorflight crew supervisorfreight forwarding logisticianfreight forwarding supervisorfreight forwarding technicianfreight forwarding unit supervisorfreight supervisorfreight traffic co-ordinatorfreight traffic scheduling supervisorfreight traffic supervisorguide-operatorhead dispatcherhead shipperimport traffic supervisorinventory clerks supervisorinventory control supervisorinventory management officerjob order clerks supervisor - manufacturingload control supervisorlogistical supervisor - trafficlogistics supervisorlogistics supervisor - transportationmagazine foreman, explosivesmagazine foreman/woman, explosivesmagazine forewoman, explosivesmanufacturing orders clerks supervisormaterial clerks supervisormaterial control co-ordinatorocean freight co-ordinatorocean freight technicianparts clerks supervisorparts service supervisorparts shipping managerproduction clerks supervisorproduction planning clerks supervisorpurchasing and inventory management co-ordinatorpurchasing clerks supervisorramp services supervisor - airportreceiving clerks supervisorreceiving supervisorroute planning supervisorscheduling clerks supervisorshipping and receiving supervisorshipping clerks supervisorshipping co-ordinatorshipping supervisorstock clerks supervisorstock control supervisorsupervisor, aerodromesupervisor, airline load controlsupervisor, air transport operationssupervisor, air transport operations supportsupervisor, crew schedulerssupervisor, crew schedulessupervisor, dispatcherssupervisor, distributionsupervisor, export trafficsupervisor, flight crew schedulingsupervisor, freightsupervisor, freight forwarding unitsupervisor, freight traffic schedulingsupervisor, import trafficsupervisor, inventory clerkssupervisor, job order clerks - manufacturingsupervisor, load controlsupervisor, logisticssupervisor, manufacturing order clerkssupervisor, material clerkssupervisor, parts clerkssupervisor, parts servicesupervisor, production clerkssupervisor, production planning clerkssupervisor, purchasing clerkssupervisor, ramp services - airport",
    "workers": 3270,
    "minEduc": 0,
    "yearsStudy": 2.752688172,
    "automationRisk": 0.014,
    "salaryLow": 15.4,
    "salaryMed": 23,
    "salaryHigh": 40,
    "totalSkill": 160,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 23,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 95,
    "f2Engineering": 255,
    "f3Humanities": 30,
    "f4SocialScience": 320,
    "f5FineArts": 10,
    "f6MathAndComputerScience": 140,
    "f7Arts&Education": 375,
    "f8Education(teachertraining)": 0,
    "f9Law": 195,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 1800,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 30,
    "d5SocialSciences": 320,
    "d6Fine&AppliedArts": 10,
    "d7ComputerScience": 140,
    "d8OtherArts&Science": 375,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 255,
    "d11Law": 195,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 95,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 1800,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 61,
    "noc": 1221,
    "job": "Administrative officers",
    "title1": "access to information and privacy officer access to information officer administration analyst administration officer administration services co-ordinator administrative analyst administrative co-ordinator administrative officer administrative planning officer administrative services co-ordinator administrative services officer administrative support officer administrative technician administrator, reserve admissions officer, post-secondary educational institution band administrator bilingual services co-ordinator budget analyst business representative � club, lodge or society business services officer chief invigilator civil emergency measures officer claims officer co-ordinator, bilingual services co-ordinator, office services Crown assets distribution officer documentation and projects analyst exam invigilator, post-secondary institution exam proctor, post-secondary institution exam supervisor, post-secondary institution financial aid officer financial assistance co-ordinator � college or university financial assistance officer forms management officer freedom of information officer immigrant investors program co-ordinator lease administration supervisor management planning officer Native band administrator Native reserve administrator non-technical project manager office administrative technician office administrator office automation administrator office automation co-ordinator office automation technician office co-ordinator office manager officer, access to information and privacy officer, civil emergency measures official languages co-ordinator ombudsman officer operating officer � administration operational officer � administration operations officer � administration organization and productivity project manager organization and productivity project officer parking co-ordinator planning officer preliminary press planner prepress planner � publishing privacy officer project administration officer project manager � non-technical records analyst � access to information reserve administrator student aid officer student assistance officer surplus assets officer technical assistant � office support test administrator testing co-ordinator testing supervisor university admissions officer",
    "title2": 0,
    "title3": 0,
    "allTitles": "access to information and privacy officer access to information officer administration analyst administration officer administration services co-ordinator administrative analyst administrative co-ordinator administrative officer administrative planning officer administrative services co-ordinator administrative services officer administrative support officer administrative technician administrator, reserve admissions officer, post-secondary educational institution band administrator bilingual services co-ordinator budget analyst business representative � club, lodge or society business services officer chief invigilator civil emergency measures officer claims officer co-ordinator, bilingual services co-ordinator, office services Crown assets distribution officer documentation and projects analyst exam invigilator, post-secondary institution exam proctor, post-secondary institution exam supervisor, post-secondary institution financial aid officer financial assistance co-ordinator � college or university financial assistance officer forms management officer freedom of information officer immigrant investors program co-ordinator lease administration supervisor management planning officer Native band administrator Native reserve administrator non-technical project manager office administrative technician office administrator office automation administrator office automation co-ordinator office automation technician office co-ordinator office manager officer, access to information and privacy officer, civil emergency measures official languages co-ordinator ombudsman officer operating officer � administration operational officer � administration operations officer � administration organization and productivity project manager organization and productivity project officer parking co-ordinator planning officer preliminary press planner prepress planner � publishing privacy officer project administration officer project manager � non-technical records analyst � access to information reserve administrator student aid officer student assistance officer surplus assets officer technical assistant � office support test administrator testing co-ordinator testing supervisor university admissions officer",
    "workers": 6024.166667,
    "minEduc": 1.5,
    "yearsStudy": 3.239183019,
    "automationRisk": 0.446416667,
    "salaryLow": 14.42,
    "salaryMed": 23.1,
    "salaryHigh": 36.26,
    "totalSkill": 135.4166667,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 28.25833333,
    "skillsComp": 31.5,
    "skillsLogi": 32.08333333,
    "skillsMath": 17.58333333,
    "skillsLang": 54.33333333,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.785714286,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6.142857143,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3.25,
    "s7NumericalEstimation": 3.416666667,
    "s8OralCommunication": 17.5,
    "s9ProblemSolving": 8.083333333,
    "s10Reading": 20.58333333,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 15.66666667,
    "s13DocumentUse": 12.08333333,
    "s14Writing": 15.64285714,
    "s15CriticalThinking": 7.75,
    "f1Science&Agriculture": 75,
    "f2Engineering": 124.1666667,
    "f3Humanities": 147.5,
    "f4SocialScience": 1013.333333,
    "f5FineArts": 259.1666667,
    "f6MathAndComputerScience": 50.83333333,
    "f7Arts&Education": 464.1666667,
    "f8Education(teachertraining)": 166.6666667,
    "f9Law": 445.8333333,
    "f10Health": 113.3333333,
    "f11Health,Nursing&ClinicalLaboratory": 167.5,
    "f12Business": 2855,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 27.5,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 21.66666667,
    "d4Humanities": 143.3333333,
    "d5SocialSciences": 1013.333333,
    "d6Fine&AppliedArts": 128.5714286,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 464.1666667,
    "d9Education(teachertraining)": 166.6666667,
    "d10Engineering": 102.5,
    "d11Law": 445.8333333,
    "d12Mathematics": 10.83333333,
    "d13Kinesiology/Recreation/PhysicalEducation": 79.16666667,
    "d14Theology": 4.166666667,
    "d15PhysicalSciences": 47.5,
    "d16Therapy&Rehabilitation": 34.16666667,
    "d17Health,Nursing&ClinicalLaboratory": 167.5,
    "d18Business&Commerce": 2855,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 62,
    "noc": 1222,
    "job": "Executive assistants",
    "title1": "committee clerk",
    "title2": "constituency aid",
    "title3": "constituency assistant",
    "allTitles": "committee clerkconstituency aidconstituency assistantcorporate secretaryexecutive assistantlegislative assistantmedical information assistantministerial assistantparliamentary assistantparliamentary committee clerkspecial assistant",
    "workers": 7895,
    "minEduc": 2,
    "yearsStudy": 3.029761905,
    "automationRisk": 0.86,
    "salaryLow": 14,
    "salaryMed": 26.44,
    "salaryHigh": 40.87,
    "totalSkill": 117,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 26.44,
    "skillsComp": 31,
    "skillsLogi": 23,
    "skillsMath": 15,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 4,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 6,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 11,
    "s14Writing": 16,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 45,
    "f2Engineering": 15,
    "f3Humanities": 235,
    "f4SocialScience": 1260,
    "f5FineArts": 470,
    "f6MathAndComputerScience": 90,
    "f7Arts&Education": 465,
    "f8Education(teachertraining)": 180,
    "f9Law": 480,
    "f10Health": 95,
    "f11Health,Nursing&ClinicalLaboratory": 430,
    "f12Business": 4130,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 235,
    "d5SocialSciences": 1260,
    "d6Fine&AppliedArts": 470,
    "d7ComputerScience": 60,
    "d8OtherArts&Science": 465,
    "d9Education(teachertraining)": 180,
    "d10Engineering": 0,
    "d11Law": 480,
    "d12Mathematics": 30,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 80,
    "d17Health,Nursing&ClinicalLaboratory": 430,
    "d18Business&Commerce": 4130,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 63,
    "noc": 1223,
    "job": "Human resources and recruitment officers",
    "title1": "assistant personnel officer",
    "title2": "employment interviewer",
    "title3": "employment supervisor",
    "allTitles": "assistant personnel officeremployment intervieweremployment supervisorexecutive recruiterhuman resources officerinterviewer - human resourceslabour force consultantpersonnel administratorpersonnel adviserpersonnel interviewerpersonnel management adviserpersonnel officerpersonnel recruitment officerpersonnel selection officerpersonnel supervisorplacement officer - human resourcesrecruiter - employmentrecruiting officerrecruitment assistantrecruitment consultantrecruitment officerrecruitment specialistsenior staffing officerstaffing adviserstaffing analyststaffing co-ordinatorstaffing officerstudent placement officer",
    "workers": 6950,
    "minEduc": 2,
    "yearsStudy": 3.481203008,
    "automationRisk": 0.31,
    "salaryLow": 16,
    "salaryMed": 30.77,
    "salaryHigh": 45.64,
    "totalSkill": 123,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 30.77,
    "skillsComp": 26,
    "skillsLogi": 27,
    "skillsMath": 17,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 4,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 8,
    "s14Writing": 13,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 25,
    "f2Engineering": 0,
    "f3Humanities": 170,
    "f4SocialScience": 1415,
    "f5FineArts": 185,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 500,
    "f8Education(teachertraining)": 205,
    "f9Law": 225,
    "f10Health": 110,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 4090,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 25,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 170,
    "d5SocialSciences": 1415,
    "d6Fine&AppliedArts": 185,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 500,
    "d9Education(teachertraining)": 205,
    "d10Engineering": 0,
    "d11Law": 225,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 75,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 35,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 4090,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 64,
    "noc": 1224,
    "job": "Architecture and science managers",
    "title1": "accommodation co-ordinator",
    "title2": "accommodation officer",
    "title3": "accommodation planning officer",
    "allTitles": "accommodation co-ordinatoraccommodation officeraccommodation planning officeradvertising space officeragent, apartment rentalapartment rental agentarea manager, property acquisitionsbuilding managing supervisorchief of property managementcommercial building rental agentcommercial property managerhead, property sectionhousing development officerhousing project managerlandladylandlordlandlord/ladyleasing and development officer - public worksleasing co-ordinator, propertymanaging supervisor, buildingofficer, advertising spaceoperations co-ordinator, property managementproperty acquisitions area managerproperty administratorproperty leasing co-ordinatorproperty management agentproperty management officerproperty management operations co-ordinatorproperty rental agentproperty rental co-ordinatorproperty rentals managerproperty section headreal estate rental agentrental agent, apartmentsrental agent, real estaterentals agentresidential property managerstrata property manager",
    "workers": 9740,
    "minEduc": 1,
    "yearsStudy": 3.481105991,
    "automationRisk": 0.4135,
    "salaryLow": 14,
    "salaryMed": 22.12,
    "salaryHigh": 39.9,
    "totalSkill": 136.5,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 30.29,
    "skillsComp": 35,
    "skillsLogi": 31.5,
    "skillsMath": 23.5,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 7.5,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 13.5,
    "s14Writing": 13.5,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 285,
    "f2Engineering": 710,
    "f3Humanities": 205,
    "f4SocialScience": 970,
    "f5FineArts": 235,
    "f6MathAndComputerScience": 90,
    "f7Arts&Education": 1080,
    "f8Education(teachertraining)": 395,
    "f9Law": 400,
    "f10Health": 135,
    "f11Health,Nursing&ClinicalLaboratory": 345,
    "f12Business": 4040,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 115,
    "d4Humanities": 180,
    "d5SocialSciences": 970,
    "d6Fine&AppliedArts": 235,
    "d7ComputerScience": 70,
    "d8OtherArts&Science": 1080,
    "d9Education(teachertraining)": 395,
    "d10Engineering": 595,
    "d11Law": 400,
    "d12Mathematics": 20,
    "d13Kinesiology/Recreation/PhysicalEducation": 85,
    "d14Theology": 25,
    "d15PhysicalSciences": 285,
    "d16Therapy&Rehabilitation": 50,
    "d17Health,Nursing&ClinicalLaboratory": 345,
    "d18Business&Commerce": 4040,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 65,
    "noc": 1225,
    "job": "Purchasing agents and officers",
    "title1": "advertising buyer agent, right-of-way analyst, purchasing contracts business services purchasing officer buyer � manufacturing and processing buyer � purchasing buyer, advertising buyer, media time and space contract claims examiner contract management officer contract negotiator contracts officer energy asset joint venture representative energy asset surface land analyst estimator, media grain buyer hotel purchasing agent hotel purchasing officer land agent land negotiator landman/woman � oil and gas material management officer material purchasing officer materials co-ordinator media buyer media estimator media time and space buyer mineral land contracts analyst negotiator, purchasing contracts office equipment purchasing officer officer, contract management ore buyer passenger and freight rates analyst petroleum land administrator procurement officer products administrator pulpwood buyer purchaser purchaser, furniture and furnishings purchasing agent purchasing contracts administrator purchasing contracts analyst purchasing contracts management officer purchasing contracts negotiator purchasing contracts officer purchasing officer purchasing supervisor purchasing-services contracts negotiator radio time buyer restaurant purchasing agent restaurant purchasing officer right-of-way agent senior buyer � purchasing services contracts negotiator stewardship officer storage purchasing co-ordinator supervisor, purchasing supply chain specialist � procurement supply officer, government television time buyer well and facilities asset analyst",
    "title2": 0,
    "title3": 0,
    "allTitles": "advertising buyer agent, right-of-way analyst, purchasing contracts business services purchasing officer buyer � manufacturing and processing buyer � purchasing buyer, advertising buyer, media time and space contract claims examiner contract management officer contract negotiator contracts officer energy asset joint venture representative energy asset surface land analyst estimator, media grain buyer hotel purchasing agent hotel purchasing officer land agent land negotiator landman/woman � oil and gas material management officer material purchasing officer materials co-ordinator media buyer media estimator media time and space buyer mineral land contracts analyst negotiator, purchasing contracts office equipment purchasing officer officer, contract management ore buyer passenger and freight rates analyst petroleum land administrator procurement officer products administrator pulpwood buyer purchaser purchaser, furniture and furnishings purchasing agent purchasing contracts administrator purchasing contracts analyst purchasing contracts management officer purchasing contracts negotiator purchasing contracts officer purchasing officer purchasing supervisor purchasing-services contracts negotiator radio time buyer restaurant purchasing agent restaurant purchasing officer right-of-way agent senior buyer � purchasing services contracts negotiator stewardship officer storage purchasing co-ordinator supervisor, purchasing supply chain specialist � procurement supply officer, government television time buyer well and facilities asset analyst",
    "workers": 6024.166667,
    "minEduc": 1.5,
    "yearsStudy": 3.239183019,
    "automationRisk": 0.446416667,
    "salaryLow": 15.38,
    "salaryMed": 26,
    "salaryHigh": 44.51,
    "totalSkill": 135.4166667,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 28.25833333,
    "skillsComp": 31.5,
    "skillsLogi": 32.08333333,
    "skillsMath": 17.58333333,
    "skillsLang": 54.33333333,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.040816327,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5.234693878,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3.25,
    "s7NumericalEstimation": 3.416666667,
    "s8OralCommunication": 17.5,
    "s9ProblemSolving": 8.083333333,
    "s10Reading": 20.58333333,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 15.66666667,
    "s13DocumentUse": 12.08333333,
    "s14Writing": 16.02040816,
    "s15CriticalThinking": 7.75,
    "f1Science&Agriculture": 75,
    "f2Engineering": 124.1666667,
    "f3Humanities": 147.5,
    "f4SocialScience": 1013.333333,
    "f5FineArts": 259.1666667,
    "f6MathAndComputerScience": 50.83333333,
    "f7Arts&Education": 464.1666667,
    "f8Education(teachertraining)": 166.6666667,
    "f9Law": 445.8333333,
    "f10Health": 113.3333333,
    "f11Health,Nursing&ClinicalLaboratory": 167.5,
    "f12Business": 2855,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 27.5,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 21.66666667,
    "d4Humanities": 143.3333333,
    "d5SocialSciences": 1013.333333,
    "d6Fine&AppliedArts": 240.5102041,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 464.1666667,
    "d9Education(teachertraining)": 166.6666667,
    "d10Engineering": 102.5,
    "d11Law": 445.8333333,
    "d12Mathematics": 10.83333333,
    "d13Kinesiology/Recreation/PhysicalEducation": 79.16666667,
    "d14Theology": 4.166666667,
    "d15PhysicalSciences": 47.5,
    "d16Therapy&Rehabilitation": 34.16666667,
    "d17Health,Nursing&ClinicalLaboratory": 167.5,
    "d18Business&Commerce": 2855,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 66,
    "noc": 1226,
    "job": "Conference and event planners",
    "title1": "conference and meeting planner",
    "title2": "conference co-ordinator",
    "title3": "conference organizer",
    "allTitles": "conference and meeting plannerconference co-ordinatorconference organizerconference plannerconference services officerconvention and special events plannerconvention co-ordinatorconvention plannerconvention planning services officerco-ordinator, conferencesco-ordinator, conventionsco-ordinator, social eventsco-ordinator, special eventsevent co-ordinatorevent plannerexhibition co-ordinatorfestival organizermeeting co-ordinatormeeting plannerorganizer, special eventsplanner, conventions and special eventsplanner, special eventsprogram planner, special eventssocial events co-ordinatorspecial events co-ordinatorspecial events organizerspecial events plannerspecial events program plannertrade show organizertrade show planner",
    "workers": 4305,
    "minEduc": 2,
    "yearsStudy": 3.303571429,
    "automationRisk": 0.037,
    "salaryLow": 14,
    "salaryMed": 21.68,
    "salaryHigh": 38.46,
    "totalSkill": 153,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 21.68,
    "skillsComp": 28,
    "skillsLogi": 42,
    "skillsMath": 10,
    "skillsLang": 73,
    "topSkill1": "Writing",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 28,
    "s9ProblemSolving": 15,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 7,
    "s14Writing": 29,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 20,
    "f2Engineering": 0,
    "f3Humanities": 105,
    "f4SocialScience": 820,
    "f5FineArts": 520,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 405,
    "f8Education(teachertraining)": 60,
    "f9Law": 100,
    "f10Health": 265,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 1975,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 105,
    "d5SocialSciences": 820,
    "d6Fine&AppliedArts": 520,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 405,
    "d9Education(teachertraining)": 60,
    "d10Engineering": 0,
    "d11Law": 100,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 265,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 1975,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 67,
    "noc": 1227,
    "job": "Court officers and justices of the peace",
    "title1": "administrator, court",
    "title2": "administrator of the court",
    "title3": "assistant deputy registrar - courts",
    "allTitles": "administrator, courtadministrator of the courtassistant deputy registrar - courtsassistant registrar - courtscitizenship judgeclerk of probateclerk of proceedings - courtsclerk of the courtclerk of the Crown - courtsclerk, Supreme Courtcommissioner of affidavitscommissioner of marriagesco-ordinator of court servicescounty court registrarcourt administratorcourt clerk supervisorcourt deputy administratorcourt of appeal registrarcourt officercourt registrarcourtroom officercourt services managercourt supervisordeed recorderdeed registrardeputy administrator of the courtdeputy court registrardeputy land registrardeputy registrardeputy registrar - courtsdistrict court registrarexpropriation officerfamily court administratorfamily court registrarfamily court supervisorjudicial administratorjudicial court administratorjudicial officerjudicial officer - courtsjudicial services administratorjustice of the peaceland registrarlegal services officer - courtsmanager, court servicesofficer, courtprothonotaryQueen's Bench registrarrecorder of deedsrecorder of willsregistrar - courtsregistrar of bankruptcyregistrar of deedsregistrar of probateregistrar of willsregistry officer - marriagessmall claims court registrarsmall claims court supervisorSupreme Court clerkSupreme Court registrarsurrogate court registrartrial co-ordinatortrial co-ordinator - courts",
    "workers": 420,
    "minEduc": 0,
    "yearsStudy": 2.833333333,
    "automationRisk": 0.64,
    "salaryLow": 18.5,
    "salaryMed": 26.52,
    "salaryHigh": 36,
    "totalSkill": 134,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 26.52,
    "skillsComp": 36,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 15,
    "f9Law": 345,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 0,
    "d11Law": 345,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 68,
    "noc": 1228,
    "job": "Employment insurance, immigration, border services and revenue officers",
    "title1": "adjudication officer - employment insurance",
    "title2": "adjudication officer - immigration",
    "title3": "adjudicator - employment insurance",
    "allTitles": "adjudication officer - employment insuranceadjudication officer - immigrationadjudicator - employment insuranceappeal judge - employment insuranceappeal officerappeal officer - taxationappraiser, customsassessing officer - taxationassessing unit head - taxationassessor, taxaudit reviewer - taxationbaggage inspector, customsborder services officercase review officer - immigrationcitizenship registration examinerclaims adjudication officer - employment insuranceclaims adjudicator - employment insuranceclaims processing officer - immigrationcollection agent - government servicescollection officer - taxationcollection unit head - government servicescoverage and interpretation officer - taxationcustoms and excise examinercustoms appraisercustoms baggage inspectorcustoms collectorcustoms examinercustoms inspection supervisorcustoms inspectorcustoms inspectors supervisorcustoms investigatorcustoms officeremployment insurance agentemployment insurance benefit claims investigatoremployment insurance benefits control officeremployment insurance officerexaminer, citizenship registrationexcise duty agentexcise duty officerexcise duty supervisorexcise examinerexcise tax collection supervisorexcise tax collectorexcise tax inspectorexcise tax officers supervisorfield auditor - taxationgoods and services tax (GST) collection officerGST (goods and services tax) collection officerImmigration Act enforcement officerimmigration agentimmigration agent - government servicesimmigration appeal officerimmigration examinerimmigration examining officerimmigration inspectorimmigration officer - government servicesimmigration officers supervisorinspector, customsinvestigator, taxationmunicipal tax collectoroffice auditor - taxationofficer, adjudication - employment insuranceofficer, adjudication - immigrationofficer, employment insuranceofficer, immigration - government servicesofficer, taxationregional claims and benefits officer - employment insurancerevenue agentrevenue officerrevenue recovery officerrevenue supervisorsuccession duty auditor - taxationsupervisor, customs inspectionsupervisor, excise tax officerssupervisor, immigration officerstax appeal officertax assessortaxation investigatortaxation officertax auditor - government servicestax collection officertax enforcement officertax interpretation officertax investigatortax officertax recovery officer",
    "workers": 6835,
    "minEduc": 2,
    "yearsStudy": 3.306122449,
    "automationRisk": 0.418,
    "salaryLow": 23.08,
    "salaryMed": 33.85,
    "salaryHigh": 40,
    "totalSkill": 149,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 33.85,
    "skillsComp": 33,
    "skillsLogi": 35,
    "skillsMath": 21,
    "skillsLang": 60,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 7,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 16,
    "s14Writing": 13,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 75,
    "f2Engineering": 20,
    "f3Humanities": 170,
    "f4SocialScience": 1595,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 125,
    "f7Arts&Education": 335,
    "f8Education(teachertraining)": 145,
    "f9Law": 1125,
    "f10Health": 75,
    "f11Health,Nursing&ClinicalLaboratory": 170,
    "f12Business": 2855,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 75,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 170,
    "d5SocialSciences": 1595,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 110,
    "d8OtherArts&Science": 335,
    "d9Education(teachertraining)": 145,
    "d10Engineering": 20,
    "d11Law": 1125,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 40,
    "d17Health,Nursing&ClinicalLaboratory": 170,
    "d18Business&Commerce": 2855,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 69,
    "noc": 1241,
    "job": "Administrative assistants",
    "title1": "administrative assistant administrative assistant � office administrative secretary appointment secretary church secretary contracts secretary executive secretary (except legal and medical) finance secretary human resources secretary loans and grants administrative assistant office administrative assistant personal secretary private secretary recording secretary sales secretary school secretary secretary (except legal and medical) secretary, church secretary, school taxation service secretary technical secretary",
    "title2": 0,
    "title3": 0,
    "allTitles": "administrative assistant administrative assistant � office administrative secretary appointment secretary church secretary contracts secretary executive secretary (except legal and medical) finance secretary human resources secretary loans and grants administrative assistant office administrative assistant personal secretary private secretary recording secretary sales secretary school secretary secretary (except legal and medical) secretary, church secretary, school taxation service secretary technical secretary",
    "workers": 6907.5,
    "minEduc": 2,
    "yearsStudy": 2.389038462,
    "automationRisk": 0.62,
    "salaryLow": 14,
    "salaryMed": 20.89,
    "salaryHigh": 30,
    "totalSkill": 126.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 24.5,
    "skillsComp": 36,
    "skillsLogi": 29.5,
    "skillsMath": 18.5,
    "skillsLang": 42.5,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 4.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 5.5,
    "s7NumericalEstimation": 2.5,
    "s8OralCommunication": 10.5,
    "s9ProblemSolving": 8,
    "s10Reading": 20.5,
    "s11SchedulingorBudgetingandAccounting": 10.5,
    "s12DigitalTechnology": 21.5,
    "s13DocumentUse": 11.5,
    "s14Writing": 11.5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 95,
    "f4SocialScience": 202.5,
    "f5FineArts": 127.5,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 215,
    "f8Education(teachertraining)": 17.5,
    "f9Law": 3732.5,
    "f10Health": 17.5,
    "f11Health,Nursing&ClinicalLaboratory": 1515,
    "f12Business": 960,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 95,
    "d5SocialSciences": 202.5,
    "d6Fine&AppliedArts": 127.5,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 215,
    "d9Education(teachertraining)": 17.5,
    "d10Engineering": 0,
    "d11Law": 3732.5,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 17.5,
    "d17Health,Nursing&ClinicalLaboratory": 1515,
    "d18Business&Commerce": 960,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 70,
    "noc": 1242,
    "job": "Legal administrative assistants",
    "title1": "administrative assistant, commercial law",
    "title2": "administrative assistant, corporate law",
    "title3": "administrative assistant, estate",
    "allTitles": "administrative assistant, commercial lawadministrative assistant, corporate lawadministrative assistant, estateadministrative assistant - legaladministrative assistant, legaladministrative assistant, litigationadministrative assistant, real estateadministrative assistant, trademarkscollection legal assistantcommercial law administrative assistantcommercial law legal assistantcommercial law secretarycorporate finance legal assistantcorporate law administrative assistantcorporate law legal assistantcorporate law secretarycorporate records legal assistantestate administrative assistantestate secretaryfamily law legal assistantforeclosures legal assistantinsurance legal assistantlabour law legal assistantlegal administrative assistantlegal assistantlegal assistant, collectionlegal assistant - criminal lawlegal secretarylegal stenographerlitigation administrative assistantlitigation legal assistantlitigation secretarymortgage and real estate legal assistantoil and gas rights legal assistantreal estate administrative assistantreal estate secretarysecretary, litigationsecretary, real estatesecretary, trademarkstax legal assistanttrademark administrative assistanttrademark secretarywills and estates legal assistant",
    "workers": 10350,
    "minEduc": 2,
    "yearsStudy": 2.798076923,
    "automationRisk": 0.94,
    "salaryLow": 14.42,
    "salaryMed": 27,
    "salaryHigh": 37,
    "totalSkill": 112,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 27,
    "skillsComp": 27,
    "skillsLogi": 24,
    "skillsMath": 20,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 1,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 7,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 6,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 12,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 130,
    "f4SocialScience": 380,
    "f5FineArts": 225,
    "f6MathAndComputerScience": 35,
    "f7Arts&Education": 375,
    "f8Education(teachertraining)": 35,
    "f9Law": 7355,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 265,
    "f12Business": 1515,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 130,
    "d5SocialSciences": 380,
    "d6Fine&AppliedArts": 225,
    "d7ComputerScience": 35,
    "d8OtherArts&Science": 375,
    "d9Education(teachertraining)": 35,
    "d10Engineering": 0,
    "d11Law": 7355,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 35,
    "d17Health,Nursing&ClinicalLaboratory": 265,
    "d18Business&Commerce": 1515,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 71,
    "noc": 1243,
    "job": "Medical administrative assistants",
    "title1": "administrative assistant - medical",
    "title2": "administrative assistant, medical",
    "title3": "medical administrative assistant",
    "allTitles": "administrative assistant - medicaladministrative assistant, medicalmedical administrative assistantmedical secretarymedical stenographersecretary, ward - hospitalward secretaryward secretary - hospital",
    "workers": 3465,
    "minEduc": 2,
    "yearsStudy": 1.98,
    "automationRisk": 0.3,
    "salaryLow": 15,
    "salaryMed": 22,
    "salaryHigh": 32,
    "totalSkill": 141,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 22,
    "skillsComp": 45,
    "skillsLogi": 35,
    "skillsMath": 17,
    "skillsLang": 44,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Scheduling or Budgeting and Accounting",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 10,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 28,
    "s13DocumentUse": 11,
    "s14Writing": 10,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 60,
    "f4SocialScience": 25,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 0,
    "f9Law": 110,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 2765,
    "f12Business": 405,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 60,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 110,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 2765,
    "d18Business&Commerce": 405,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 72,
    "noc": 1251,
    "job": "Court reporters, medical transcriptionists and related occupations",
    "title1": "braille transcriber",
    "title2": "braille volumes transcriber",
    "title3": "closed captioner",
    "allTitles": "braille transcriberbraille volumes transcriberclosed captionercourt monitorcourt recordercourt reportercourt stenographerdictatypistHansard reportermedia transcribermedia transcriptionistmedical dictatypistmedical transcriptioniststenotype operatortranscribertranscriptionist",
    "workers": 1870,
    "minEduc": 0,
    "yearsStudy": 2.16,
    "automationRisk": 0.695,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 28,
    "totalSkill": 129,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 21,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 15,
    "f4SocialScience": 50,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10,
    "f8Education(teachertraining)": 0,
    "f9Law": 275,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1355,
    "f12Business": 165,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 50,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 275,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1355,
    "d18Business&Commerce": 165,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 73,
    "noc": 1252,
    "job": "Health information management occupations",
    "title1": "classifier, health records",
    "title2": "health information management coder",
    "title3": "health information management practitioner",
    "allTitles": "classifier, health recordshealth information management coderhealth information management practitionerhealth information management professionalhealth information management supervisorhealth information management technicianhealth records classifierhealth records management coderhealth records management supervisorhealth records technicianmedical records supervisormedical records technicianmedical records technicians supervisormedical records unit supervisorsupervisor, medical records technicianssupervisor, medical records unittechnician, medical records",
    "workers": 650,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.91,
    "salaryLow": 14,
    "salaryMed": 21.33,
    "salaryHigh": 35,
    "totalSkill": 120,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 21.33,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 650,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 650,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 74,
    "noc": 1253,
    "job": "Records management technicians",
    "title1": "classifier, records",
    "title2": "documentation technician",
    "title3": "document management technician",
    "allTitles": "classifier, recordsdocumentation techniciandocument management techniciandocument technicianfingerprint classifierinformation management technicianmicrofilm camera operatormicrofilmermicrofilm mountermicrofilm records searcherrecords classifierrecords digitizing technicianrecords management technicianrecords techniciantechnical indexer - records and file management",
    "workers": 310,
    "minEduc": 0,
    "yearsStudy": 2.909090909,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 36.18,
    "totalSkill": 119,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 22,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 65,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 45,
    "f8Education(teachertraining)": 0,
    "f9Law": 10,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 165,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 65,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 45,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 10,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 165,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 75,
    "noc": 1254,
    "job": "Statistical officers and related research support occupations",
    "title1": "psychology research assistant (except university)",
    "title2": "research assistant (except post-secondary)",
    "title3": "research assistant - generalist (except university)",
    "allTitles": "psychology research assistant (except university)research assistant (except post-secondary)research assistant - generalist (except university)research assistant, psychology (except university)research support officersocial research assistant (except university)social science research assistant (except university)statistical officerstatistical techniciantechnical research assistant (except post-secondary)technical services officer - statistics",
    "workers": 61165,
    "minEduc": 0,
    "yearsStudy": 3.288913437,
    "automationRisk": 0.81,
    "salaryLow": 20.13,
    "salaryMed": 37.36,
    "salaryHigh": 76.92,
    "totalSkill": 128.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 30.23,
    "skillsComp": 35,
    "skillsLogi": 32.5,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 10.5,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 60,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 210,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 60,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 210,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 76,
    "noc": 1311,
    "job": "Accounting technicians and bookkeepers",
    "title1": "accounting bookkeeper",
    "title2": "accounting technician",
    "title3": "bookkeeper",
    "allTitles": "accounting bookkeeperaccounting technicianbookkeeperbookkeeping clerkbudget officerfinance officerfinancial officersenior bookkeeper",
    "workers": 28295,
    "minEduc": 0,
    "yearsStudy": 3.066091954,
    "automationRisk": 0.98,
    "salaryLow": 14,
    "salaryMed": 19.23,
    "salaryHigh": 35.71,
    "totalSkill": 116,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 19.23,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 235,
    "f2Engineering": 555,
    "f3Humanities": 450,
    "f4SocialScience": 1615,
    "f5FineArts": 605,
    "f6MathAndComputerScience": 645,
    "f7Arts&Education": 1570,
    "f8Education(teachertraining)": 1015,
    "f9Law": 720,
    "f10Health": 120,
    "f11Health,Nursing&ClinicalLaboratory": 1430,
    "f12Business": 19335,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 135,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 70,
    "d4Humanities": 450,
    "d5SocialSciences": 1615,
    "d6Fine&AppliedArts": 605,
    "d7ComputerScience": 395,
    "d8OtherArts&Science": 1570,
    "d9Education(teachertraining)": 1015,
    "d10Engineering": 485,
    "d11Law": 720,
    "d12Mathematics": 250,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 100,
    "d16Therapy&Rehabilitation": 95,
    "d17Health,Nursing&ClinicalLaboratory": 1430,
    "d18Business&Commerce": 19335,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 77,
    "noc": 1312,
    "job": "Insurance adjusters and claims examiners",
    "title1": "adjuster",
    "title2": "adjuster - insurance",
    "title3": "adjuster trainee - insurance",
    "allTitles": "adjusteradjuster - insuranceadjuster trainee - insuranceautomobile claims technical adjustercasualty insurance adjusterclaims adjuster - insuranceclaims approver - insuranceclaims consultantclaims examinerclaims examiner - insuranceclaims investigatorclaims investigator - insuranceclaims representativeclaims representative - insurancedisability claims examiner - insurancedisaster relief claims adjuster - insurancefield adjuster - insurancefire insurance adjusterfreight adjuster - insurancegroup life claims examiner - insurancehealth and dental claims examiner - insuranceinsurance adjusterinsurance inspectorliability adjuster - insuranceloss examiner - insurancemarine claims adjuster - insurancemarine insurance adjustermedical claims assessor - insurancemotor vehicle claims adjuster - insuranceproduction examinerproperty adjuster - insurancepublic adjuster - insurancerailroad claims adjuster - insurancesettlement management associatesettlement specialiststaff adjuster - insurancetelephone adjuster - insurancetrainee adjuster - insuranceworkers' compensation adjuster - insurance",
    "workers": 5205,
    "minEduc": 0,
    "yearsStudy": 3.040983607,
    "automationRisk": 0.98,
    "salaryLow": 18.8,
    "salaryMed": 26.52,
    "salaryHigh": 43.59,
    "totalSkill": 119,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 26.52,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 185,
    "f2Engineering": 15,
    "f3Humanities": 95,
    "f4SocialScience": 855,
    "f5FineArts": 55,
    "f6MathAndComputerScience": 125,
    "f7Arts&Education": 515,
    "f8Education(teachertraining)": 45,
    "f9Law": 260,
    "f10Health": 205,
    "f11Health,Nursing&ClinicalLaboratory": 210,
    "f12Business": 2640,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 95,
    "d5SocialSciences": 855,
    "d6Fine&AppliedArts": 55,
    "d7ComputerScience": 30,
    "d8OtherArts&Science": 515,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 15,
    "d11Law": 260,
    "d12Mathematics": 95,
    "d13Kinesiology/Recreation/PhysicalEducation": 165,
    "d14Theology": 0,
    "d15PhysicalSciences": 140,
    "d16Therapy&Rehabilitation": 40,
    "d17Health,Nursing&ClinicalLaboratory": 210,
    "d18Business&Commerce": 2640,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 78,
    "noc": 1313,
    "job": "Insurance underwriters",
    "title1": "accident and sickness underwriter - insurance",
    "title2": "assistant underwriter - insurance",
    "title3": "automobile and home insurance consultant",
    "allTitles": "accident and sickness underwriter - insuranceassistant underwriter - insuranceautomobile and home insurance consultantautomobile underwriter - insuranceboiler and machinery underwriter - insurancecasualty insurance products analyst-designercasualty underwriter - insurancecommercial underwriter - insurancefarm underwriter - insurancefire underwriter - insurancegroup underwritergroup underwriter - insurancehead office underwriter - insurancehome office underwriter - insuranceinsurance rating analystinsurance underwriterjunior underwriter - insuranceliability underwriterlife underwritermarine and aircraft underwriter - insurancemarine underwriter - insurancepackage underwriter - insurancepersonal lines underwriterproperty underwriterproperty underwriter - insurancepublic liability underwriter - insurancereinsurance underwriter - insurancesenior underwriter - insurancesurety underwriter - insuranceunderwriter, accident and sickness - insuranceunderwriter, automobile - insuranceunderwriter, boiler and machinery - insuranceunderwriter, casualty - insuranceunderwriter, commercial - insuranceunderwriter, farm - insuranceunderwriter, fire - insuranceunderwriter, group - insuranceunderwriter, head office - insuranceunderwriter, home office - insuranceunderwriter - insuranceunderwriter, lifeunderwriter, marine and aircraft - insuranceunderwriter, marine - insuranceunderwriter, package - insuranceunderwriter, property - insuranceunderwriter, public liability - insuranceunderwriter, surety - insurance",
    "workers": 3550,
    "minEduc": 0,
    "yearsStudy": 3.127906977,
    "automationRisk": 0.99,
    "salaryLow": 22.31,
    "salaryMed": 28.85,
    "salaryHigh": 43.59,
    "totalSkill": 120,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 28.85,
    "skillsComp": 33,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 60,
    "f2Engineering": 15,
    "f3Humanities": 85,
    "f4SocialScience": 475,
    "f5FineArts": 70,
    "f6MathAndComputerScience": 75,
    "f7Arts&Education": 240,
    "f8Education(teachertraining)": 0,
    "f9Law": 75,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 90,
    "f12Business": 2350,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 85,
    "d5SocialSciences": 475,
    "d6Fine&AppliedArts": 70,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 240,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 75,
    "d12Mathematics": 25,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 90,
    "d18Business&Commerce": 2350,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 79,
    "noc": 1314,
    "job": "Assessors, valuators and appraisers",
    "title1": "accredited appraiser appraisal technician appraiser (except customs) assessor (except tax) assistant appraiser automobile appraiser building appraiser business appraiser business valuation officer business valuator Canadian residential appraiser (CRA) chartered appraiser chartered business valuator (CBV) CRA (Canadian residential appraiser) fishing vessels appraiser furniture appraiser insurance appraiser municipal assessor property appraiser property assessor property valuator real estate appraisal technician real estate appraiser real estate assessor technician, real estate appraisal valuation consultant valuator-appraiser",
    "title2": 0,
    "title3": 0,
    "allTitles": "accredited appraiser appraisal technician appraiser (except customs) assessor (except tax) assistant appraiser automobile appraiser building appraiser business appraiser business valuation officer business valuator Canadian residential appraiser (CRA) chartered appraiser chartered business valuator (CBV) CRA (Canadian residential appraiser) fishing vessels appraiser furniture appraiser insurance appraiser municipal assessor property appraiser property assessor property valuator real estate appraisal technician real estate appraiser real estate assessor technician, real estate appraisal valuation consultant valuator-appraiser",
    "workers": 9382.5,
    "minEduc": 0,
    "yearsStudy": 2.763291089,
    "automationRisk": 0.9825,
    "salaryLow": 20,
    "salaryMed": 31.02,
    "salaryHigh": 56.41,
    "totalSkill": 117.75,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 23.5,
    "skillsComp": 32.5,
    "skillsLogi": 30.25,
    "skillsMath": 17.5,
    "skillsLang": 38.25,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 120,
    "f2Engineering": 146.25,
    "f3Humanities": 157.5,
    "f4SocialScience": 736.25,
    "f5FineArts": 182.5,
    "f6MathAndComputerScience": 211.25,
    "f7Arts&Education": 587.5,
    "f8Education(teachertraining)": 265,
    "f9Law": 293.75,
    "f10Health": 85,
    "f11Health,Nursing&ClinicalLaboratory": 432.5,
    "f12Business": 6165,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 17.5,
    "d4Humanities": 157.5,
    "d5SocialSciences": 736.25,
    "d6Fine&AppliedArts": 182.5,
    "d7ComputerScience": 118.75,
    "d8OtherArts&Science": 587.5,
    "d9Education(teachertraining)": 265,
    "d10Engineering": 128.75,
    "d11Law": 293.75,
    "d12Mathematics": 92.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 51.25,
    "d14Theology": 0,
    "d15PhysicalSciences": 60,
    "d16Therapy&Rehabilitation": 33.75,
    "d17Health,Nursing&ClinicalLaboratory": 432.5,
    "d18Business&Commerce": 6165,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 80,
    "noc": 1315,
    "job": "Customs, ship and other brokers",
    "title1": "broker, cargo",
    "title2": "broker, customs house",
    "title3": "broker, gas",
    "allTitles": "broker, cargobroker, customs housebroker, gasbroker, information customsbroker, oil leasebroker, yachtcargo brokerchartered shipbrokercustoms brokercustoms clearance agentcustoms consultantcustoms house brokercustoms information brokerdesignated shipbrokergas brokerlicensed customs brokeroil lease brokerqualified customs brokerroyalty brokership agentshipbrokership line agentsupply chain specialist - customs brokerageyacht broker",
    "workers": 480,
    "minEduc": 0,
    "yearsStudy": 1.818181818,
    "automationRisk": 0.98,
    "salaryLow": 14,
    "salaryMed": 19.4,
    "salaryHigh": 26.67,
    "totalSkill": 116,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 19.4,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 120,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 335,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 120,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 335,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 81,
    "noc": 1411,
    "job": "General office support workers",
    "title1": "address forms clerk",
    "title2": "administrative clerk",
    "title3": "aircraft records clerk",
    "allTitles": "address forms clerkadministrative clerkaircraft records clerkauction clerkbill sorterboard marker, grain quotationsbroadcast clerkbus terminal clerkcard filerclassification clerkclassification clerk, recordsclerical assistantclerk, aircraft recordsclerk, classificationclerk, general officeclerk, meter recordsclerk, recordsclerk, records classificationclerk-stenographerclerk, technical recordscorrespondence filing clerkcourse co-ordinatorcredit card authorization clerkdietetics office clerk - hospitaldocuments clerkdrawings filing clerkfile and classification clerkfile clerkfiling clerkfilm filing clerkfloat clerkgeneral office clerkgeneral office workergrain quotations board markerhealth information clerkhealth records clerkhospital records clerkinformation and records clerkjunior office clerkmail order clerkmail order fillermap clerkmedical records clerkmeter records clerkmunicipal office clerkoffice administration clerkoffice assistantoffice clerkoffice machine operatoroperator, office machinesorder transcriberplate filing clerkpolice station clerkrecords classification clerkrecords clerkrecords filing-system clerkrecords management clerkrecords support clerkrelief clerkroad clerkroad maintenance clerksubscription clerktechnical records clerkticket preparer - manufacturingtypistunit clerkutilities clerkutility clerkward clerk - hospitalwarranty clerkword processor clerk",
    "workers": 49645,
    "minEduc": 0.5,
    "yearsStudy": 3.003988005,
    "automationRisk": 0.9625,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 31.32,
    "totalSkill": 123,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 17.925,
    "skillsComp": 38,
    "skillsLogi": 28,
    "skillsMath": 18.5,
    "skillsLang": 38.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2.5,
    "s8OralCommunication": 10.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 6.5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 21.5,
    "s14Writing": 11.5,
    "s15CriticalThinking": 2,
    "f1Science&Agriculture": 1015,
    "f2Engineering": 1150,
    "f3Humanities": 1600,
    "f4SocialScience": 4475,
    "f5FineArts": 2330,
    "f6MathAndComputerScience": 1610,
    "f7Arts&Education": 4560,
    "f8Education(teachertraining)": 1755,
    "f9Law": 2040,
    "f10Health": 1135,
    "f11Health,Nursing&ClinicalLaboratory": 7130,
    "f12Business": 18895,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 560,
    "d2Forestry": 150,
    "d3Architecture&LandscapeArchitecture": 135,
    "d4Humanities": 1470,
    "d5SocialSciences": 4475,
    "d6Fine&AppliedArts": 2330,
    "d7ComputerScience": 1500,
    "d8OtherArts&Science": 4560,
    "d9Education(teachertraining)": 1755,
    "d10Engineering": 1015,
    "d11Law": 2040,
    "d12Mathematics": 110,
    "d13Kinesiology/Recreation/PhysicalEducation": 495,
    "d14Theology": 130,
    "d15PhysicalSciences": 305,
    "d16Therapy&Rehabilitation": 640,
    "d17Health,Nursing&ClinicalLaboratory": 7130,
    "d18Business&Commerce": 18895,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 82,
    "noc": 1414,
    "job": "Receptionists",
    "title1": "admitting clerk",
    "title2": "answering service operator",
    "title3": "appointment clerk",
    "allTitles": "admitting clerkanswering service operatorappointment clerkbusiness receptionistcharge operator - telephone systemchief telephone operatorclerk, hospital admissionsclerk switchboard operatorcollect call operator - telephone systemdental office receptionistdental receptionistdoctor's office receptionistemergency admitting clerkfront desk clerk (except hotel)hospital admissions clerkhospital admitting clerkhospital receptionistinformation desk clerkinternational exchange operator - telephone systemlong distance telephone operatormail and message distribution clerkmedical clinic receptionistmedical office assistantmedical office secretary-receptionistmedical receptionistoffice reception clerkoffice receptionistoperator, switchboardoperator, telephone answering serviceoperator - telephone systemreception clerkreception clerk, officereception desk clerk (except hotel)receptionistreceptionist-clerkreceptionist, hospitalreceptionist, medical clinicreceptionist-secretaryreceptionist-switchboard operatorreceptionist-telephone operatorreceptionist-typistsecretary-receptionist, medical officeservice assistant - telephone systemswitchboard operatorswitchboard operator, clericaltelephone answering service operatortelephone clerktelephone operatortelephone operator, long distancetelephone service analysttelephone service assistanttelereceptionisttoll operatorvoice communication system operator",
    "workers": 28690,
    "minEduc": 1,
    "yearsStudy": 2.729591837,
    "automationRisk": 0.96,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 25.64,
    "totalSkill": 124,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 16,
    "skillsComp": 40,
    "skillsLogi": 30,
    "skillsMath": 16,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 22,
    "s14Writing": 11,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 320,
    "f2Engineering": 110,
    "f3Humanities": 1120,
    "f4SocialScience": 1740,
    "f5FineArts": 1515,
    "f6MathAndComputerScience": 620,
    "f7Arts&Education": 2765,
    "f8Education(teachertraining)": 955,
    "f9Law": 1125,
    "f10Health": 605,
    "f11Health,Nursing&ClinicalLaboratory": 9285,
    "f12Business": 8530,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 305,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 1090,
    "d5SocialSciences": 1740,
    "d6Fine&AppliedArts": 1515,
    "d7ComputerScience": 620,
    "d8OtherArts&Science": 2765,
    "d9Education(teachertraining)": 955,
    "d10Engineering": 80,
    "d11Law": 1125,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 180,
    "d14Theology": 30,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 425,
    "d17Health,Nursing&ClinicalLaboratory": 9285,
    "d18Business&Commerce": 8530,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 83,
    "noc": 1415,
    "job": "Personnel clerks",
    "title1": "classification clerk - human resources",
    "title2": "employment clerk",
    "title3": "human resources assistant",
    "allTitles": "classification clerk - human resourcesemployment clerkhuman resources assistanthuman resources clerkidentification clerklabour relations clerkpersonnel clerkpersonnel services clerkstaffing assistantstaffing clerktraining clerk",
    "workers": 2090,
    "minEduc": 0,
    "yearsStudy": 3.226415094,
    "automationRisk": 0.9,
    "salaryLow": 14,
    "salaryMed": 22.79,
    "salaryHigh": 27.47,
    "totalSkill": 121,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 22.79,
    "skillsComp": 33,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 85,
    "f4SocialScience": 240,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 125,
    "f8Education(teachertraining)": 0,
    "f9Law": 130,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 1465,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 85,
    "d5SocialSciences": 240,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 125,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 130,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 1465,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 84,
    "noc": 1416,
    "job": "Court clerks",
    "title1": "clerk, court",
    "title2": "clerk-crier, court",
    "title3": "clerk of process - courts",
    "allTitles": "clerk, courtclerk-crier, courtclerk of process - courtscounty court clerkcourt clerkcourt clerk-criercourtroom clerkcriminal court clerkjudicial clerkprovincial court clerkyouth court clerk",
    "workers": 180,
    "minEduc": 0,
    "yearsStudy": 2.333333333,
    "automationRisk": 0.46,
    "salaryLow": 16.83,
    "salaryMed": 26,
    "salaryHigh": 33,
    "totalSkill": 142,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 26,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 165,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 165,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 85,
    "noc": 1422,
    "job": "Data entry clerks",
    "title1": "computer equipment operator",
    "title2": "computer terminal operator",
    "title3": "control clerk, data processing",
    "allTitles": "computer equipment operatorcomputer terminal operatorcontrol clerk, data processingdata control clerkdata entry clerkdata entry operatordata entry verifier-operatordata input clerkdata processing control clerkdata processing verifierdata processorEDP (electronic data-processing) equipment operatorelectronic data-processing (EDP) equipment operatorinterpreting machine operator - data entrypayment entry clerkpayment input clerkverifier, data processing",
    "workers": 7730,
    "minEduc": 1,
    "yearsStudy": 2.828282828,
    "automationRisk": 0.99,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 27.5,
    "totalSkill": 79,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 16,
    "skillsComp": 23,
    "skillsLogi": 24,
    "skillsMath": 8,
    "skillsLang": 24,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8,
    "s10Reading": 7,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 8,
    "s14Writing": 7,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 75,
    "f2Engineering": 145,
    "f3Humanities": 230,
    "f4SocialScience": 745,
    "f5FineArts": 370,
    "f6MathAndComputerScience": 500,
    "f7Arts&Education": 715,
    "f8Education(teachertraining)": 200,
    "f9Law": 405,
    "f10Health": 60,
    "f11Health,Nursing&ClinicalLaboratory": 855,
    "f12Business": 3430,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 65,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 230,
    "d5SocialSciences": 745,
    "d6Fine&AppliedArts": 370,
    "d7ComputerScience": 500,
    "d8OtherArts&Science": 715,
    "d9Education(teachertraining)": 200,
    "d10Engineering": 145,
    "d11Law": 405,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 60,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 855,
    "d18Business&Commerce": 3430,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 86,
    "noc": 1423,
    "job": "Desktop publishing operators and related occupations",
    "title1": "ad compositor - typesetting",
    "title2": "braille block maker",
    "title3": "braille computer translations specialist",
    "allTitles": "ad compositor - typesettingbraille block makerbraille computer translations specialistbraille data entry clerkbraille keyboard operatorbraille keyboard operator - typesettingbraille process engraverbraille stereograph machine operatorbraille transcription technicianbraillewriter operatorcold-composition typographercold-typesetting typographercomposing machine operator, Linotypecomposing machine operator - typesettingcompositor - typesettingcompositor-typographercomputer-aided page maker-upcomputer photocompositorcomputer phototypesettercomputer typesettercopy cuttercopy marker - typesettingcopy stylist - typesettingcopy typist - typesettingdesktop compositordesktop publishing (DTP) operatordesktop publishing (DTP) specialistDTP (desktop publishing) operatorDTP (desktop publishing) specialistelectronic formatterelectronic letterer operatorelectronic photocomposer operatorelectronic phototypesetting machine operatorelectronic sign maker operator - typesettingformatter operator - typesettingimposition plannerimpositorinput compositor - typesettinginput operator - typesettingIntertype machine operatorIntertype operatorjob compositor - typesettingkeyboard operator - typesettingLinotype composing machine operatorLudlow machine operatorLudlow typesetting machine operatormachine compositor - typesettingmachine typecastermanual compositormarkup personmarkup person - typesettingMonotype casting machine operatorMonotype hot metal typesetter keyboard operatorMonotype keyboard operatornewspaper page assembleroperator, formatter - typesettingoperator, Linotype composing machineoutput compositor - typesettingoutput operator - typesettingpage compositorpage maker-upphotocomposer operatorphotocomposing machine keyboard operatorphotocomposing machine operatorphotocomposing machine tenderphotocomposing-perforating machine operatorphotocomposition typesetterphotocompositorphotomechanical composition typographerphototypesetterphototypesetter operatorphototypesetter terminal operatorphototypesetting machine operatorpreproduction operatorprocessing and output compositorscanner operator - desktop publishingscanning machine operator - desktop publishingterminal operatortypecasting machine operatortype compositortypesetter, photocompositiontypesetter - typesettingtypesetting machine operatortypesetting machine tendertypographertypographer apprenticeVariTyper operatorvideotext operator",
    "workers": 50,
    "minEduc": 1,
    "yearsStudy": 2,
    "automationRisk": 0.16,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 27.5,
    "totalSkill": 127,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 30.31999453,
    "skillsComp": 28,
    "skillsLogi": 35,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Oral Communication",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 13,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 16,
    "s14Writing": 12,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 50,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 50,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 87,
    "noc": 1431,
    "job": "Accounting and related clerks",
    "title1": "account audit clerk account verification clerk accounting and auditing clerk accounting assistant accounting clerk accounts payable and receivable clerk accounts payable clerk accounts receivable clerk assessment clerk audit clerk auditing clerk balance clerk bill clerk billing clerk billing machine operator budget clerk cash on delivery (COD) clerk cheque control clerk COD (cash on delivery) clerk control clerk � hotel and restaurant cost accounting clerk cost clerk costing clerk currency sorter deposit clerk disbursement clerk expenditure clerk finance clerk financial investigation clerk fiscal clerk freight-rate clerk freight-rate revision clerk income tax return preparer investment clerk invoice clerk journal entry audit clerk journal entry clerk junior billing clerk junior invoice clerk ledger clerk patient-billing clerk rate reviewer remittance accounts clerk revenue accounting clerk senior accounting clerk tariff clerk tax clerk tax return preparer traffic rate clerk transfer clerk treasury clerk utilities billing clerk vault clerk voucher clerk wharfinger",
    "title2": 0,
    "title3": 0,
    "allTitles": "account audit clerk account verification clerk accounting and auditing clerk accounting assistant accounting clerk accounts payable and receivable clerk accounts payable clerk accounts receivable clerk assessment clerk audit clerk auditing clerk balance clerk bill clerk billing clerk billing machine operator budget clerk cash on delivery (COD) clerk cheque control clerk COD (cash on delivery) clerk control clerk � hotel and restaurant cost accounting clerk cost clerk costing clerk currency sorter deposit clerk disbursement clerk expenditure clerk finance clerk financial investigation clerk fiscal clerk freight-rate clerk freight-rate revision clerk income tax return preparer investment clerk invoice clerk journal entry audit clerk journal entry clerk junior billing clerk junior invoice clerk ledger clerk patient-billing clerk rate reviewer remittance accounts clerk revenue accounting clerk senior accounting clerk tariff clerk tax clerk tax return preparer traffic rate clerk transfer clerk treasury clerk utilities billing clerk vault clerk voucher clerk wharfinger",
    "workers": 4453.333333,
    "minEduc": 1,
    "yearsStudy": 2.827948042,
    "automationRisk": 0.96,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 30.29,
    "totalSkill": 124.3333333,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 21.09,
    "skillsComp": 32.33333333,
    "skillsLogi": 30,
    "skillsMath": 17.33333333,
    "skillsLang": 44.66666667,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.333333333,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7.333333333,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 0.666666667,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 2.333333333,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 9.333333333,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 8.333333333,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 15,
    "s14Writing": 12.66666667,
    "s15CriticalThinking": 3.333333333,
    "f1Science&Agriculture": 0,
    "f2Engineering": 5,
    "f3Humanities": 58.33333333,
    "f4SocialScience": 383.3333333,
    "f5FineArts": 76.66666667,
    "f6MathAndComputerScience": 81.66666667,
    "f7Arts&Education": 280,
    "f8Education(teachertraining)": 58.33333333,
    "f9Law": 180,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 191.6666667,
    "f12Business": 3128.333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 58.33333333,
    "d5SocialSciences": 383.3333333,
    "d6Fine&AppliedArts": 76.66666667,
    "d7ComputerScience": 51.66666667,
    "d8OtherArts&Science": 280,
    "d9Education(teachertraining)": 58.33333333,
    "d10Engineering": 5,
    "d11Law": 180,
    "d12Mathematics": 30,
    "d13Kinesiology/Recreation/PhysicalEducation": 5,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 5,
    "d17Health,Nursing&ClinicalLaboratory": 191.6666667,
    "d18Business&Commerce": 3128.333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 88,
    "noc": 1432,
    "job": "Payroll clerks",
    "title1": "account records clerk - payroll",
    "title2": "assistant paymaster",
    "title3": "benefits and pension plan officer",
    "allTitles": "account records clerk - payrollassistant paymasterbenefits and pension plan officerbenefits officerpay accounts clerkpay advisorpay and benefits administratorpay and benefits clerkpay clerkpayroll administratorpayroll clerkpayroll machine operatorpayroll officerpay verifiersalary administration officersuperannuation clerk - governmenttimekeeper - payroll",
    "workers": 6295,
    "minEduc": 1,
    "yearsStudy": 2.815789474,
    "automationRisk": 0.97,
    "salaryLow": 14,
    "salaryMed": 24.04,
    "salaryHigh": 38,
    "totalSkill": 136,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 24.04,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 22,
    "skillsLang": 43,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 9,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 13,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 11,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 22,
    "s14Writing": 14,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 105,
    "f4SocialScience": 345,
    "f5FineArts": 110,
    "f6MathAndComputerScience": 65,
    "f7Arts&Education": 265,
    "f8Education(teachertraining)": 100,
    "f9Law": 190,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 295,
    "f12Business": 4805,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 105,
    "d5SocialSciences": 345,
    "d6Fine&AppliedArts": 110,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 265,
    "d9Education(teachertraining)": 100,
    "d10Engineering": 0,
    "d11Law": 190,
    "d12Mathematics": 45,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 15,
    "d17Health,Nursing&ClinicalLaboratory": 295,
    "d18Business&Commerce": 4805,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 89,
    "noc": 1434,
    "job": "Banking, insurance and other financial clerks",
    "title1": "accounts clerk - financial sector",
    "title2": "accounts representative - financial sector",
    "title3": "actuarial clerk",
    "allTitles": "accounts clerk - financial sectoraccounts representative - financial sectoractuarial clerkapplication reviewer - insuranceATM (automatic teller machine) clerkautomatic teller machine (ATM) clerkbank clerkbenefits and entitlement clerk - insurancebrokerage clerkcalculation clerk - insuranceclaims clerk - insuranceclerk - financial sectorcontract clerk - financial sectorcontrol clerk - financial sectorcredit application clerk - financial sectorcredit assessment clerkcredit authorization clerkcredit clerkcredit register clerkdeath benefits clerkdental claims clerkdisability benefits clerk - insurancediscount clerk - financial sectordividend calculation clerkdividend calculation clerk - financial sectoremployee insurance clerkexchange rate clerk - financial sectorfinancial clerk - financial sectorforeign currency accounts adjuster - financial sectorforeign exchange clerk - financial sectorforeign remittance clerk - financial sectorgroup insurance clerkhospital insurance clerkinsurance clerk - financial sectorinsurance raterinterest clerkledger control clerkledger control clerk - financial sectorledger control officer - financial sectorliability clerk - financial sectorloan clerk - financial sectormargin calculation clerk - financial sectormortgage clerkpension administrator - insurance companypension plans clerk - insurancepersonal credit lines clerkpersonal lines clerk - insurancepolicy change clerk - insurancepolicy clerk - insurancepolicy information clerk - insurancepremium rater - insuranceproof clerk - financial sectorproperty and equipment insurance clerkproperty clerkrater, insurancereal estate clerkrealty clerkreconciliation clerk - financial sectorrenewal clerk - financial sectorreserves calculation clerk - financial sectorsafety deposit box clerksavings accounts clerk - financial sectorsecurities clerk - financial sectorsenior claims clerkspecial endorsement clerk - insurancesuperannuation clerk - financial sectorsurgical-medical claims clerk - insurancevaluation clerk - financial sectorvault attendant - financial sector",
    "workers": 5435,
    "minEduc": 1,
    "yearsStudy": 3.15862069,
    "automationRisk": 0.98,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 26.67,
    "totalSkill": 145,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 20,
    "skillsComp": 43,
    "skillsLogi": 32,
    "skillsMath": 20,
    "skillsLang": 50,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 4,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 6,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 27,
    "s13DocumentUse": 13,
    "s14Writing": 13,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 15,
    "f3Humanities": 70,
    "f4SocialScience": 680,
    "f5FineArts": 105,
    "f6MathAndComputerScience": 140,
    "f7Arts&Education": 435,
    "f8Education(teachertraining)": 75,
    "f9Law": 200,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 195,
    "f12Business": 3505,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 70,
    "d5SocialSciences": 680,
    "d6Fine&AppliedArts": 105,
    "d7ComputerScience": 95,
    "d8OtherArts&Science": 435,
    "d9Education(teachertraining)": 75,
    "d10Engineering": 15,
    "d11Law": 200,
    "d12Mathematics": 45,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 195,
    "d18Business&Commerce": 3505,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 90,
    "noc": 1435,
    "job": "Collectors",
    "title1": "advertising collector",
    "title2": "bill collector",
    "title3": "claims collector",
    "allTitles": "advertising collectorbill collectorclaims collectorcollection agent (except taxation)collection clerkcollection officer (except taxation)collections investigation officercollectorcollector of taxescredit and collection clerkfinancial collectorinspector and bill collector - electric power companyinspector and bill collector - gas companyinstalment collectorinsurance premium collectorloan collectorlocator - collectionskip tracer - collectiontax collector",
    "workers": 1630,
    "minEduc": 1,
    "yearsStudy": 2.509433962,
    "automationRisk": 0.93,
    "salaryLow": 14,
    "salaryMed": 19.23,
    "salaryHigh": 36.81,
    "totalSkill": 92,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 19.23,
    "skillsComp": 17,
    "skillsLogi": 24,
    "skillsMath": 10,
    "skillsLang": 41,
    "topSkill1": "Oral Communication",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 9,
    "s10Reading": 11,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 10,
    "s14Writing": 11,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 125,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 40,
    "f7Arts&Education": 140,
    "f8Education(teachertraining)": 0,
    "f9Law": 150,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 85,
    "f12Business": 1075,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 125,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 140,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 150,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 85,
    "d18Business&Commerce": 1075,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 91,
    "noc": 1451,
    "job": "Library assistants and clerks",
    "title1": "aide, library",
    "title2": "art department library clerk",
    "title3": "assistant, library",
    "allTitles": "aide, libraryart department library clerkassistant, librarybookmobile clerkbook returns clerk - librarybraille and talking books library clerkbranch library clerkcirculation assistantcirculation clerk - libraryclerk, libraryfiler, photographs - libraryfilms and recordings library clerkinterlibrary loan clerklibrary aidelibrary assistantlibrary clerklibrary filerlibrary pagemusic library assistanton call library assistantpage, libraryperiodicals clerkperiodicals clerk - libraryphotograph filer - libraryrecordings library clerkrecord library assistantreference aide - libraryreference assistant - libraryreference clerkreference clerk - libraryshelving clerk - librarytechnical services clerk - libraryvault clerk - film library",
    "workers": 1195,
    "minEduc": 1,
    "yearsStudy": 3.456521739,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 30,
    "totalSkill": 110,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 15,
    "skillsComp": 29,
    "skillsLogi": 27,
    "skillsMath": 9,
    "skillsLang": 45,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 7,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 8,
    "s13DocumentUse": 18,
    "s14Writing": 13,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 35,
    "f2Engineering": 0,
    "f3Humanities": 80,
    "f4SocialScience": 95,
    "f5FineArts": 195,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 475,
    "f8Education(teachertraining)": 105,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 185,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 80,
    "d5SocialSciences": 95,
    "d6Fine&AppliedArts": 195,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 475,
    "d9Education(teachertraining)": 105,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 185,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 92,
    "noc": 1452,
    "job": "Correspondence, publication and regulatory clerks",
    "title1": "administrative contract clerk",
    "title2": "advertising assistant",
    "title3": "advertising clerk",
    "allTitles": "administrative contract clerkadvertising assistantadvertising clerkadvertising space measurerapplication clerkarchives clerkauthorization clerkbrand recorderbusiness documentalistby-law clerkcatalogue compilercirculation clerk, newspaperclassified advertising clerkclipping markercompilercomposing room proofreaderconstruction permits clerkcontract clerkcopy holdercopy-reader, proofreadercopyright clerkcorrespondence clerkcorrespondence review clerkcustoms and excise clerkcustoms clerkdirectory clerkdirectory compilerdocumentalistdocumentalist, businessdocumentation clerkediting clerkeditorial assistanteditorial clerkengineering clerkexport documentation clerkexports clerkfingerprint clerkforms control clerkimport clerkimport documentation clerkland registry clerklicence clerkmailing list compilermanuscript proofreadermotor vehicle bureau clerknewspaper circulation clerkpassport clerkpassport issuerpermit clerkphotograph examinerpress clipperpress readerproofreaderproofreader, manuscriptspublication clerkpublishing clerkreaderregistrar clerkregistration clerkregistry clerktests clerktranslation clerk",
    "workers": 3810,
    "minEduc": 1,
    "yearsStudy": 2.945454545,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 24,
    "salaryHigh": 33,
    "totalSkill": 133,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 24,
    "skillsComp": 38,
    "skillsLogi": 32,
    "skillsMath": 11,
    "skillsLang": 52,
    "topSkill1": "Writing",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 9,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 7,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 21,
    "s14Writing": 22,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 45,
    "f2Engineering": 105,
    "f3Humanities": 265,
    "f4SocialScience": 510,
    "f5FineArts": 265,
    "f6MathAndComputerScience": 125,
    "f7Arts&Education": 345,
    "f8Education(teachertraining)": 40,
    "f9Law": 250,
    "f10Health": 40,
    "f11Health,Nursing&ClinicalLaboratory": 285,
    "f12Business": 1535,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 50,
    "d4Humanities": 245,
    "d5SocialSciences": 510,
    "d6Fine&AppliedArts": 265,
    "d7ComputerScience": 125,
    "d8OtherArts&Science": 345,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 55,
    "d11Law": 250,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 20,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 40,
    "d17Health,Nursing&ClinicalLaboratory": 285,
    "d18Business&Commerce": 1535,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 93,
    "noc": 1454,
    "job": "Survey interviewers and statistical clerks",
    "title1": "census clerk",
    "title2": "census enumerator",
    "title3": "census taker",
    "allTitles": "census clerkcensus enumeratorcensus takercensus workerchart clerkcoding clerk - statisticselection enumeratorenumeratorinterview clerkinterviewer - survey or pollmeter readerpoll clerkpublic opinion collectorpublic opinion interviewerstatistical assistantstatistical clerksurvey compilersurvey interviewersurvey takersurvey team notekeepertechnical assistant - statisticstelephone survey clerktraffic checkertraffic countervehicle counter",
    "workers": 3280,
    "minEduc": 1,
    "yearsStudy": 2.816513761,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 16.36,
    "salaryHigh": 30.48,
    "totalSkill": 107,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Office support occupations",
    "cluster": 4,
    "wage": 16.36,
    "skillsComp": 33,
    "skillsLogi": 24,
    "skillsMath": 12,
    "skillsLang": 38,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 11,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 11,
    "s14Writing": 12,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 95,
    "f2Engineering": 55,
    "f3Humanities": 240,
    "f4SocialScience": 340,
    "f5FineArts": 130,
    "f6MathAndComputerScience": 45,
    "f7Arts&Education": 395,
    "f8Education(teachertraining)": 385,
    "f9Law": 140,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 335,
    "f12Business": 1120,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 50,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 230,
    "d5SocialSciences": 340,
    "d6Fine&AppliedArts": 130,
    "d7ComputerScience": 30,
    "d8OtherArts&Science": 395,
    "d9Education(teachertraining)": 385,
    "d10Engineering": 55,
    "d11Law": 140,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 10,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 335,
    "d18Business&Commerce": 1120,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 94,
    "noc": 1511,
    "job": "Mail, postal and related workers",
    "title1": "addressing machine operator - mail and postal services",
    "title2": "address-labelling machine tender",
    "title3": "address-plate inserter",
    "allTitles": "addressing machine operator - mail and postal servicesaddress-labelling machine tenderaddress-plate inserterbursting machine tenderbus parcel express clerkclerk, mailclerk, mail distributionclerk, mail - railway transportclerk, mail roomclerk, post officeclerk, shipping - railway transportcounter clerk - mail and postal servicesenvelope-sealing and envelope-imprinting machine tenderexpress mail service clerkexpress service clerk - railwayfiling clerk, mailinserting machine tender - mail and postal servicesletter sorting clerklost parcel post search clerklost postal package search clerkmail clerkmail clerk - railway transportmail counter clerkmail distribution clerkmailermail filing clerkmail handlermailing machine operatormail processing clerkmail room assistantmail room clerkmail sortermail-sorting system operatormail tracing clerkmanagement services clerk - mail and postal servicesmessenger service representativeparcel post clerkpostal clerkpostal counter clerkpostal services wicket clerkpostal wicket clerkpost office clerkrailway mail clerkrailway station mail clerkregistered mail clerkrouting clerksearch clerk, lost parcel postsearch clerk, lost postal packagesshipping clerk - railway transportsorter, mailsorting and routing clerksorting system operator, mailstamp-cancelling machine tender - postal servicessub-post office clerktracing clerk, mailwicket clerk - mail and postal serviceswicket clerk, postal services",
    "workers": 2260,
    "minEduc": 0,
    "yearsStudy": 2.481927711,
    "automationRisk": 0.865,
    "salaryLow": 14,
    "salaryMed": 18.99,
    "salaryHigh": 26,
    "totalSkill": 121,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 18.99,
    "skillsComp": 33,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 30,
    "f2Engineering": 170,
    "f3Humanities": 75,
    "f4SocialScience": 40,
    "f5FineArts": 40,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 330,
    "f8Education(teachertraining)": 140,
    "f9Law": 155,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 200,
    "f12Business": 1030,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 75,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 40,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 330,
    "d9Education(teachertraining)": 140,
    "d10Engineering": 170,
    "d11Law": 155,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 200,
    "d18Business&Commerce": 1030,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 95,
    "noc": 1512,
    "job": "Letter carriers",
    "title1": "deliverer, mail",
    "title2": "letter carrier",
    "title3": "mail carrier",
    "allTitles": "deliverer, mailletter carriermail carriermail carrier, special deliverymail collectormail delivererpostal carrierpostal service delivererpostal workerpostmanpostman/womanpostwomanpriority post carrierrural mail carrierspecial delivery mail carrier",
    "workers": 2070,
    "minEduc": 0,
    "yearsStudy": 2.257142857,
    "automationRisk": 0.68,
    "salaryLow": 17.95,
    "salaryMed": 25.95,
    "salaryHigh": 28,
    "totalSkill": 132,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 25.95,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 35,
    "f2Engineering": 135,
    "f3Humanities": 90,
    "f4SocialScience": 205,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 25,
    "f9Law": 115,
    "f10Health": 85,
    "f11Health,Nursing&ClinicalLaboratory": 130,
    "f12Business": 645,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 90,
    "d5SocialSciences": 205,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 135,
    "d11Law": 115,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 85,
    "d14Theology": 0,
    "d15PhysicalSciences": 35,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 130,
    "d18Business&Commerce": 645,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 96,
    "noc": 1513,
    "job": "Couriers, messengers and door-to-door distributors",
    "title1": "advertisement delivery person � courier service advertising item delivery person � courier service announcement deliverer � courier service announcement delivery person � courier service bank messenger bank runner bill distributor circular distributor � courier service copy runner � courier service courier courier service delivery person courier service parcels deliverer deliverer, parcels � courier service delivery person � courier service door-to-door distributor flyer distributor � courier service handbill passer � courier service mail courier � courier service message carrier message deliverer messenger messenger, bank messenger-clerk news item delivery person � courier service newspaper carrier newspaper carrier � courier service newspaper carrier and vendor newspaper deliverer newspaper distributor � courier service office messenger paper boy/girl � courier service paper boy/paper girl parcels deliverer, courier service public notice delivery person � courier service runner � courier service sample distributor � courier service",
    "title2": 0,
    "title3": 0,
    "allTitles": "advertisement delivery person � courier service advertising item delivery person � courier service announcement deliverer � courier service announcement delivery person � courier service bank messenger bank runner bill distributor circular distributor � courier service copy runner � courier service courier courier service delivery person courier service parcels deliverer deliverer, parcels � courier service delivery person � courier service door-to-door distributor flyer distributor � courier service handbill passer � courier service mail courier � courier service message carrier message deliverer messenger messenger, bank messenger-clerk news item delivery person � courier service newspaper carrier newspaper carrier � courier service newspaper carrier and vendor newspaper deliverer newspaper distributor � courier service office messenger paper boy/girl � courier service paper boy/paper girl parcels deliverer, courier service public notice delivery person � courier service runner � courier service sample distributor � courier service",
    "workers": 2165,
    "minEduc": 0,
    "yearsStudy": 2.369535284,
    "automationRisk": 0.7725,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 28,
    "totalSkill": 126.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 22.47,
    "skillsComp": 34.5,
    "skillsLogi": 32,
    "skillsMath": 18.5,
    "skillsLang": 41.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17.5,
    "s14Writing": 11,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 32.5,
    "f2Engineering": 152.5,
    "f3Humanities": 82.5,
    "f4SocialScience": 122.5,
    "f5FineArts": 92.5,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 370,
    "f8Education(teachertraining)": 82.5,
    "f9Law": 135,
    "f10Health": 42.5,
    "f11Health,Nursing&ClinicalLaboratory": 165,
    "f12Business": 837.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 82.5,
    "d5SocialSciences": 122.5,
    "d6Fine&AppliedArts": 92.5,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 370,
    "d9Education(teachertraining)": 82.5,
    "d10Engineering": 152.5,
    "d11Law": 135,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 32.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 165,
    "d18Business&Commerce": 837.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 97,
    "noc": 1521,
    "job": "Shippers and receivers",
    "title1": "billing rate clerk cargo location clerk delivery clerk distribution clerk export traffic clerk export-booking clerk freight checker freight forwarding clerk freight receiver freight receiver clerk freight receiving clerk freight shipper import freight clerk import traffic clerk milk and cream receiver � food and beverage processing produce shipper receiver receiving checker receiving clerk receiving clerk for returned merchandise receiving room clerk shipper shipper-receiver shipping agent shipping and receiving clerk shipping clerk stock handler stock receiver supercargo supply chain assistant warehouse receiver warehouse shipper warehouse shipping clerk",
    "title2": 0,
    "title3": 0,
    "allTitles": "billing rate clerk cargo location clerk delivery clerk distribution clerk export traffic clerk export-booking clerk freight checker freight forwarding clerk freight receiver freight receiver clerk freight receiving clerk freight shipper import freight clerk import traffic clerk milk and cream receiver � food and beverage processing produce shipper receiver receiving checker receiving clerk receiving clerk for returned merchandise receiving room clerk shipper shipper-receiver shipping agent shipping and receiving clerk shipping clerk stock handler stock receiver supercargo supply chain assistant warehouse receiver warehouse shipper warehouse shipping clerk",
    "workers": 2282,
    "minEduc": 0,
    "yearsStudy": 2.389838262,
    "automationRisk": 0.842,
    "salaryLow": 14,
    "salaryMed": 16.5,
    "salaryHigh": 23,
    "totalSkill": 122.2,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 19.762,
    "skillsComp": 33.2,
    "skillsLogi": 31,
    "skillsMath": 18.2,
    "skillsLang": 40,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.6,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.8,
    "s9ProblemSolving": 8.4,
    "s10Reading": 17.2,
    "s11SchedulingorBudgetingandAccounting": 4.2,
    "s12DigitalTechnology": 12.2,
    "s13DocumentUse": 17.6,
    "s14Writing": 9.8,
    "s15CriticalThinking": 5.2,
    "f1Science&Agriculture": 172,
    "f2Engineering": 178,
    "f3Humanities": 38,
    "f4SocialScience": 128,
    "f5FineArts": 79,
    "f6MathAndComputerScience": 60,
    "f7Arts&Education": 204,
    "f8Education(teachertraining)": 10,
    "f9Law": 217,
    "f10Health": 5,
    "f11Health,Nursing&ClinicalLaboratory": 111,
    "f12Business": 1080,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 7,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 3,
    "d4Humanities": 38,
    "d5SocialSciences": 128,
    "d6Fine&AppliedArts": 79,
    "d7ComputerScience": 60,
    "d8OtherArts&Science": 204,
    "d9Education(teachertraining)": 10,
    "d10Engineering": 175,
    "d11Law": 217,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 5,
    "d14Theology": 0,
    "d15PhysicalSciences": 165,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 111,
    "d18Business&Commerce": 1080,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 98,
    "noc": 1522,
    "job": "Storekeepers and partspersons",
    "title1": "ammunition storekeeper",
    "title2": "automotive parts clerk - retail",
    "title3": "automotive partsman apprentice",
    "allTitles": "ammunition storekeeperautomotive parts clerk - retailautomotive partsman apprenticeautomotive partsman - retailautomotive partsperson apprenticeautomotive partsperson - retailautomotive partswoman apprenticeautomotive partswoman - retailauto parts clerk - retailaviation partspersoncounter clerk, partscounter sales clerk, automobile parts - retaildrilling rig storekeeperexplosives and ammunition magazine keeperindustrial engines and equipment apprenticeindustrial engines and equipment partsman - retailindustrial engines and equipment partsperson - retailindustrial engines and equipment partswoman - retailindustrial warehouse personlinenkeeperlinen room attendantlinen supply clerkmachine shop keepermagazine keepermaterial keepermedical supply attendantmedical supply clerkmotor vehicle parts clerkmotor vehicle parts clerk apprenticemotor vehicle partspersonparts clerkparts counter clerkparts counter clerk - retailparts listerpartspersonparts sorterparts supplierparts technicianpowder keepersales clerk, automobile parts counter - retailsalvage clerksample clerk - storage and warehousingsample control clerkship keepership storekeepership storemanship storeman/womanship storewomanstock clerk - parts and equipmentstock control clerkstock keeperstock records clerkstorekeeperstorekeeper, drilling rigstorekeeper, shipstoremanstoreman/womanstorewomansupply centre clerktool clerktool room attendanttool room storemantool room storeman/womantool room storewomantool store clerkunderground tool crib attendantwarehouse checkerwarehouse clerk - parts and equipmentwarehouse person - parts and equipmentwine cellar attendant",
    "workers": 1735,
    "minEduc": 0,
    "yearsStudy": 1.877192982,
    "automationRisk": 0.64,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 27,
    "totalSkill": 129,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 16,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 740,
    "f2Engineering": 100,
    "f3Humanities": 35,
    "f4SocialScience": 0,
    "f5FineArts": 10,
    "f6MathAndComputerScience": 40,
    "f7Arts&Education": 240,
    "f8Education(teachertraining)": 0,
    "f9Law": 135,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 355,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 10,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 240,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 100,
    "d11Law": 135,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 740,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 355,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 99,
    "noc": 1523,
    "job": "Production logistics co-ordinators",
    "title1": "construction progress report clerk",
    "title2": "construction schedule co-ordinator",
    "title3": "control clerk, production",
    "allTitles": "construction progress report clerkconstruction schedule co-ordinatorcontrol clerk, productioncontrol officer, steel milldelivery checkerexpediterexpediter, purchasingindustrial order completion checking clerklogistics inbound/outbound co-ordinator - productionlumber tallymanlumber tallyman/womanlumber tallywomanmanufacturing order clerkmaterial checkermaterial co-ordinatormaterial estimatormotor vehicle repair shop co-ordinatororder clerk, manufacturingproduction agentproduction clerkproduction control clerkproduction controllerproduction co-ordinatorproduction expediterproduction material estimatorproduction officerproduction schedulerprogress report clerk, constructionpurchasing expediterrecording clerk - broadcastingschedule clerkscheduling clerkservice sector workershipping control clerksteel mill control officersupply chain co-ordinator - productionsupply clerk - aeronauticssupply clerk - productionsupply needs estimatortally clerktallymantallyman - productiontallyman/womantallyman/woman - productiontallywomantallywoman - productiontraffic clerktraffic clerk - broadcastingtraffic control clerkvehicle servicing clerk",
    "workers": 2610,
    "minEduc": 0,
    "yearsStudy": 2.987951807,
    "automationRisk": 0.88,
    "salaryLow": 14,
    "salaryMed": 22.5,
    "salaryHigh": 32.78,
    "totalSkill": 122,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 22.5,
    "skillsComp": 33,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 40,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 565,
    "f3Humanities": 15,
    "f4SocialScience": 90,
    "f5FineArts": 195,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 280,
    "f8Education(teachertraining)": 40,
    "f9Law": 50,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 1360,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 15,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 195,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 280,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 550,
    "d11Law": 50,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 1360,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 100,
    "noc": 1524,
    "job": "Purchasing and inventory control workers",
    "title1": "equipment inventory clerk",
    "title2": "food and beverage control clerk - inventory",
    "title3": "food controller - inventory",
    "allTitles": "equipment inventory clerkfood and beverage control clerk - inventoryfood controller - inventoryinventory analystinventory clerkinventory control clerkinventory plannerinvoice and purchase order checkerinvoice control clerkliquor controller - inventorypermanent inventory clerkprinting plates order clerkprocurement clerkpurchase order clerkpurchasing clerkpurchasing clerk assistantpurchasing control clerkship supply clerksupply clerksupply clerk, ship",
    "workers": 3570,
    "minEduc": 0,
    "yearsStudy": 2.836734694,
    "automationRisk": 0.77,
    "salaryLow": 14,
    "salaryMed": 16.83,
    "salaryHigh": 32.25,
    "totalSkill": 124,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 16.83,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 35,
    "f2Engineering": 150,
    "f3Humanities": 75,
    "f4SocialScience": 270,
    "f5FineArts": 140,
    "f6MathAndComputerScience": 175,
    "f7Arts&Education": 195,
    "f8Education(teachertraining)": 10,
    "f9Law": 180,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 115,
    "f12Business": 2225,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 75,
    "d5SocialSciences": 270,
    "d6Fine&AppliedArts": 140,
    "d7ComputerScience": 175,
    "d8OtherArts&Science": 195,
    "d9Education(teachertraining)": 10,
    "d10Engineering": 150,
    "d11Law": 180,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 115,
    "d18Business&Commerce": 2225,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 101,
    "noc": 1525,
    "job": "Dispatchers",
    "title1": "911 dispatcher",
    "title2": "airline radio operator",
    "title3": "alarm system dispatcher",
    "allTitles": "911 dispatcherairline radio operatoralarm system dispatcheralarm system operatorambulance dispatcherboat dispatchercar assignments clerkcar dispatcher, coal minecoal mine car dispatchercommunications specialist dispatcherdispatcher, 911dispatcher, fire departmentdispatcher, gas service crewsdispatcher, mail servicedispatcher, minedispatcher, mobile equipmentdispatcher, motor vehiclesdispatcher, newspapersdispatcher, oil well servicesdispatcher, plantdispatcher, policedispatcher, taxisdispatcher, tow trucksdispatcher, trucksdispatcher, utilities maintenance crewsdrilling rig radio operatoremergency medical dispatcheremergency services dispatcheremergency vehicle dispatcherfire alarm operatorfire department dispatchergas service crew dispatcherhighway radio-telephone operatorinbound/outbound freight co-ordinatormail service dispatchermaintenance services dispatchermine dispatchermobile equipment dispatchermonitoring station operatormotor vehicle dispatchernewspaper dispatcheroil well service dispatcherpilot services dispatcherplant dispatcherpolice department dispatcherprotective signal operatorradio dispatcherradio operatorradio operator, drilling rigradio-telephone operatorradio-telephone operator, highwaysservice dispatchertaxi dispatchertelecommunications operatortow truck dispatchertroubleshooting services dispatchertruck dispatchertugboat dispatcherutilities maintenance crew dispatcherwater service dispatcheryard clerk",
    "workers": 3355,
    "minEduc": 0,
    "yearsStudy": 2.247311828,
    "automationRisk": 0.96,
    "salaryLow": 14,
    "salaryMed": 21.85,
    "salaryHigh": 33.65,
    "totalSkill": 118,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 21.85,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 70,
    "f2Engineering": 60,
    "f3Humanities": 65,
    "f4SocialScience": 280,
    "f5FineArts": 50,
    "f6MathAndComputerScience": 85,
    "f7Arts&Education": 305,
    "f8Education(teachertraining)": 0,
    "f9Law": 720,
    "f10Health": 25,
    "f11Health,Nursing&ClinicalLaboratory": 360,
    "f12Business": 1335,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 65,
    "d5SocialSciences": 280,
    "d6Fine&AppliedArts": 50,
    "d7ComputerScience": 85,
    "d8OtherArts&Science": 305,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 60,
    "d11Law": 720,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 360,
    "d18Business&Commerce": 1335,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 102,
    "noc": 1526,
    "job": "Transportation route and crew schedulers",
    "title1": "air transport schedule analyst",
    "title2": "analyst, air transport schedules",
    "title3": "bus scheduler",
    "allTitles": "air transport schedule analystanalyst, air transport schedulesbus schedulerbus transportation service co-ordinatorcrew dispatchercrew scheduler - aeronauticscrew scheduler - railway transportcrew scheduler, transportationdepot clerk - transit systemflight crew schedulerflight schedulerlogistics clerk, transportationrapid transit schedulerschedule analystschedule analyst, air transportschedule control clerkschedule makerschedule maker, transportationscheduler, flightscheduler, flight crewsscheduler - transit systemschedule writerschedule writer, transportationsenior schedule writersubway schedulertrain schedulertransit plannertransit schedulertransportation clerktransportation route schedulertransportation routes schedulertransportation schedule clerktransportation schedule makertransportation schedules writertruck scheduler",
    "workers": 140,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.96,
    "salaryLow": 15.87,
    "salaryMed": 21.63,
    "salaryHigh": 32.97,
    "totalSkill": 118,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 21.63,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 125,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 125,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 103,
    "noc": 2111,
    "job": "Physicists and astronomers",
    "title1": "acoustics physicist",
    "title2": "aerodynamicist",
    "title3": "aerophysicist",
    "allTitles": "acoustics physicistaerodynamicistaerophysicistaerospace research scientistastronomerastrophysicistatmospheric physicistbiophysicistbiophysicist, radiationchemical physicistcommunications research scientistcosmic ray physicistcosmologistcryogenics physicistcrystal physicistelectricity and magnetism physicistelectronics physicistelectronics research scientistelementary particle physicistelementary particle theoristexperimental physicistfluid physicisthealth physicisthigh-temperature physicistlaser physicistlow-temperature physicistmagnetism physicistmathematical biophysicistmechanics physicistmedical biophysicistmedical engineering biophysicistmedical physicistmetal physicistmetrologistmicrowave physicistmolecular biophysicistnanotechnology physicistnuclear physicistnuclear reactor physicistoptics physicistparticle accelerator physicistparticle physicistphotonics physicistphysicistphysicist, elementary particlesphysics research scientistplasma physicistradiation biophysicistradio astronomerreactor physicistremote sensing research scientistresearch scientist, aerospaceresearch scientist, communicationsresearch scientist, electronicsresearch scientist, physicsresearch scientist, remote sensingrheologistsemiconductor physicistsolid-state physicistspace physicisttheoretical nuclear physicisttheorist, elementary particlesthermal physicistX-ray physicist",
    "workers": 640,
    "minEduc": 0,
    "yearsStudy": 4.888888889,
    "automationRisk": 0.071,
    "salaryLow": 20.85,
    "salaryMed": 38.92,
    "salaryHigh": 64.54,
    "totalSkill": 164,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.92,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 565,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 75,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 565,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 75,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 104,
    "noc": 2112,
    "job": "Chemists",
    "title1": "agricultural chemist",
    "title2": "agrochemist",
    "title3": "analytical biochemist",
    "allTitles": "agricultural chemistagrochemistanalytical biochemistanalytical chemistatmospheric chemistbioanalytical chemistbiochemistbiochemistry research scientistbiological chemistchemical spectroscopistchemistchemist - biomolecular assemblychemistry researcherchemistry research scientistclinical chemistcoatings chemistcontrol chemistdairy chemistdetergent chemistdye chemistelectrochemistenvironmental chemistenzyme chemistfermentologistfood chemistforensic chemistglass chemisthydrochemistindustrial chemistinorganic chemistlaboratory chemistleather chemistmedical biochemistmedical chemistmedicinal chemistnanochemistNMR (nuclear magnetic resonance) spectroscopistnuclear chemistnuclear magnetic resonance (NMR) spectroscopistnutritional chemistoceanographic chemistoptical spectroscopistorganic chemistorganic mass spectrometristorganometallic chemistpetroleum chemistpharmaceutical chemistpharmacological chemistphysical chemistphysical research chemistphysiological chemistplastics and resins chemistpolymer chemistprocess control chemistprotective coatings chemistprotein chemistquality control chemistresearch chemistresearch scientist, biochemistryresearch scientist, chemistrysoil chemistspectroscopist, NMR (nuclear magnetic resonance)spectroscopist, nuclear magnetic resonance (NMR)standards chemisttextile chemisttheoretical chemistwater chemistwater purification chemistwood chemist",
    "workers": 5445,
    "minEduc": 0,
    "yearsStudy": 4.014925373,
    "automationRisk": 0.1,
    "salaryLow": 21.35,
    "salaryMed": 31.28,
    "salaryHigh": 66.83,
    "totalSkill": 160,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 31.28,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 4110,
    "f2Engineering": 500,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 520,
    "f8Education(teachertraining)": 25,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 185,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 770,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 520,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 500,
    "d11Law": 0,
    "d12Mathematics": 20,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 3340,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 185,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 105,
    "noc": 2113,
    "job": "Geoscientists and oceanographers",
    "title1": "biological oceanographer",
    "title2": "biostratigrapher",
    "title3": "chemical oceanographer",
    "allTitles": "biological oceanographerbiostratigrapherchemical oceanographercoal geologistconsulting geologistconsulting geophysicistdevelopment geologistenvironmental geologistexploration geologistexploration geophysicistfisheries oceanographergeochemistgeological oceanographergeologistgeologist, groundwatergeologist, petroleumgeomorphologistgeophysicistgeophysicist, explorationglaciologistgroundwater geologisthydrogeologisthydrographic surveyor - geologyhydrologistice specialist - oceanographymarine geologistmarine geophysicistmicropaleontologistmine geologistmineralogistmining geologistoceanographeroil geologistpaleobotanistpaleoecologistpaleontologistpalynologistpetrographerpetroleum geologistpetrologistpetrophysicistphotogeologistphysical oceanographerplacer geologistprospecting geologistquaternaristquaternary scientistquaternary specialistremote sensing geologistsedimentary geologistsedimentologistseismologiststratigrapherstructural geologistvolcanologistwellsite co-ordinator - geology",
    "workers": 2070,
    "minEduc": 0,
    "yearsStudy": 4.227272727,
    "automationRisk": 0.63,
    "salaryLow": 20,
    "salaryMed": 39.9,
    "salaryHigh": 60.58,
    "totalSkill": 141,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 39.9,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 18,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 1825,
    "f2Engineering": 70,
    "f3Humanities": 0,
    "f4SocialScience": 75,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 100,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 75,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 100,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 70,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 1825,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 106,
    "noc": 2114,
    "job": "Meteorologists and climatologists",
    "title1": "agricultural meteorologist",
    "title2": "air quality meteorologist",
    "title3": "applied meteorologist",
    "allTitles": "agricultural meteorologistair quality meteorologistapplied meteorologistclimatologistforecaster, weatherhydrometeorologistindustrial meteorologistmeteorologistmeteorologist, air qualityoperational meteorologistpaleometeorologistphysical meteorologistsynoptic meteorologistweather forecaster",
    "workers": 90,
    "minEduc": 0,
    "yearsStudy": 4.666666667,
    "automationRisk": 0.67,
    "salaryLow": 20.585,
    "salaryMed": 36.665,
    "salaryHigh": 60.4825,
    "totalSkill": 135,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 24.46431212,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 90,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 90,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 107,
    "noc": 2115,
    "job": "Other professional occupations in physical sciences",
    "title1": "astronaut",
    "title2": "ballistician",
    "title3": "ballistics examiner",
    "allTitles": "astronautballisticianballistics examinercosmonautextractive metallurgistfirearms examinerfirearms experthydrometallurgistmaterials engineering scientistmaterials scientistmetallographermetallurgistpedologistphysical metallurgistpyrometallurgistresearch metallurgistresearch scientist - ceramicsresearch scientist - composite materialssoil scientist",
    "workers": 45,
    "minEduc": 0,
    "yearsStudy": 5,
    "automationRisk": 0.43,
    "salaryLow": 20.14,
    "salaryMed": 36.56,
    "salaryHigh": 49.98,
    "totalSkill": 148,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 36.56,
    "skillsComp": 40,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 50,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 30,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 108,
    "noc": 2121,
    "job": "Biologists and related scientists",
    "title1": "agricultural scientist",
    "title2": "agrogeologist",
    "title3": "algologist",
    "allTitles": "agricultural scientistagrogeologistalgologistanatomistanimal ecologistanimal geneticistanimal nutritionistanimal taxonomistaquatic biologistastrobiologistbacteriologistbacteriologist - animal healthbioinformaticianbiological scientistbiologistbiologist, enzymologybiologist, medical parasitologybiologist, parasitologybiologist, protozoologybiologist, veterinary parasitologybiomedical nanotechnology research scientistbotanistbryologistcell biologistcellular physiologistcrop-research scientistcrop scientistcytochemistcytogeneticistcytologistcytologist-microbiologistdairy bacteriologistdairy scientistdescriptive toxicologistdevelopmental biologistdevelopmental geneticistdomestic animal scientistecobiologistecologisteconomic botanistembryologistentomologistentomologist, apicultureenvironmental and occupational toxicologistenvironmental biologistenvironmental toxicologistenzymologistenzymology biologistetiologistfishery bacteriologistfishery products bacteriologistfood bacteriologistfood products bacteriologistfood products scientistfood research scientistfood scientistforest ecologistforest pathologistgeneticisthelminthologistherpetologisthistologisthistopathologisthuman physiologisthydrobiologistichthyologistimmunologistindustrial bacteriologistinsect physiologistinterpretative naturalistinvertebrate zoologistlaboratory immunologistlimnologistmalariologistmammalogistmarine biologistmarine hydrobiologistmarine mammal trainermechanistic toxicologistmedical parasitology biologistmicrobiologistmolecular biologistmolecular geneticistmolecular physiologistmycologistnaturalistnematologistornithologistosteologistparasitologistparasitology biologistpark naturalistpathologist, forestspathologist, plantspharmaceutical bacteriologistpharmacologistphysiological biophysicistphysiologistphysiologist-biochemist - nuclear medicinephytobiologist",
    "workers": 4805,
    "minEduc": 0.5,
    "yearsStudy": 2.980392157,
    "automationRisk": 0.543,
    "salaryLow": 24,
    "salaryMed": 38.46,
    "salaryHigh": 65.13,
    "totalSkill": 119.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 28.23,
    "skillsComp": 29,
    "skillsLogi": 32.5,
    "skillsMath": 19,
    "skillsLang": 39,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 4.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 10,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 14,
    "s14Writing": 10.5,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 4145,
    "f2Engineering": 95,
    "f3Humanities": 0,
    "f4SocialScience": 65,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 285,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 120,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 3710,
    "d2Forestry": 345,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 65,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 285,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 95,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 90,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 120,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 109,
    "noc": 2122,
    "job": "Forestry professionals",
    "title1": "appraisal forester",
    "title2": "consulting forester",
    "title3": "Crown lands forester",
    "allTitles": "appraisal foresterconsulting foresterCrown lands foresterdistrict foresterengineer, forestextension foresterforest engineerforesterforester, Crown landsforester, extensionforester, parks and recreationforester, private landsforester, professionalforester, projectsforester, researchforest nursery foresterforestry superintendentGIS (geographic information system) foresterindustrial foresterofficer, regional forest inventoryoperations foresterparks and recreation foresterprivate lands foresterprofessional foresterproject foresterregional forest inventory officerregional inventory officer - forestryregistered professional forester (RPF)research foresterRPF (registered professional forester)superintendent - forestryunit foresterurban forester",
    "workers": 445,
    "minEduc": 3,
    "yearsStudy": 3.6,
    "automationRisk": 0.008,
    "salaryLow": 24,
    "salaryMed": 38.46,
    "salaryHigh": 65.13,
    "totalSkill": 151,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 36.63579649,
    "skillsComp": 38,
    "skillsLogi": 39,
    "skillsMath": 25,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 14,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 16,
    "s14Writing": 14,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 445,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 445,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 110,
    "noc": 2123,
    "job": "Agricultural representatives, consultants and specialists",
    "title1": "acreage-quota assignment officer",
    "title2": "agricultural advisor",
    "title3": "agricultural consultant",
    "allTitles": "acreage-quota assignment officeragricultural advisoragricultural consultantagricultural extension supervisoragricultural livestock specialistagricultural representativeagricultural soil and crop specialistagricultural specialistagriculturistagrologistagronomistconsulting agrologistcrop specialistdemonstrator, Department of Agriculturedistrict agricultural specialistdistrict agronomistdistrict representative, government agricultural serviceextension service agronomistfarming consultantfarm management consultantfield service adviser - agriculturefield service agentfield service agent - agriculturegovernment agricultural service district representativegrowers' advisorirrigation consultant - agriculturelivestock specialistP.Ag. (professional agrologist)professional agrologist (P.Ag.)representative, government agricultural servicesoil conservationistsoil fertility expert",
    "workers": 260,
    "minEduc": 3,
    "yearsStudy": 3.363636364,
    "automationRisk": 0.49,
    "salaryLow": 24,
    "salaryMed": 38.46,
    "salaryHigh": 65.13,
    "totalSkill": 122,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 30.9838422,
    "skillsComp": 34,
    "skillsLogi": 22,
    "skillsMath": 18,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 3,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 260,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 260,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 111,
    "noc": 2131,
    "job": "Civil engineers",
    "title1": "airport engineer",
    "title2": "appraisal engineer",
    "title3": "architectural engineer",
    "allTitles": "airport engineerappraisal engineerarchitectural engineerasphalt engineerbridge engineerbuilding envelope engineerbuildings and bridge engineercartographic engineerchief civil engineercivil engineercivil inspection engineercoastal engineerconcrete engineerconstruction engineerconstruction project engineerconsulting civil engineercounty engineerdams engineerdistrict engineerdrainage design engineerengineer, solid waste managementengineer, surveyingenvironmental engineerenvironmental engineer, civilerecting engineerfoundation engineergeodetic engineergeomatics engineerhighway engineerhydraulics engineerhydrographic engineerhydrological engineerirrigation and drainage engineerirrigation engineerland drainage engineermapping engineermaterials and testing engineer, civilmunicipal engineernavigation and positioning engineernoise abatement engineerocean engineerphotogrammetric engineerpipeline engineer, civilpollution control engineerprecision survey engineerproject engineer, constructionpublic health engineerpublic works engineerrail transportation traffic engineerreclamation engineerremote sensing engineerriver and canal works engineersanitary engineersanitation engineersewage control engineersoil engineersolid waste management engineerspatial information systems engineerstructural design engineerstructural engineerstructural engineer, civilsurvey engineersurveying engineertraffic engineertraffic engineer, rail transportationtraffic operations engineertransportation engineertunnel engineerurban road system engineerwater and sewer engineerwater management engineerwater resources engineerwater systems engineerwater treatment engineer",
    "workers": 16315,
    "minEduc": 0,
    "yearsStudy": 3.882882883,
    "automationRisk": 0.019,
    "salaryLow": 20,
    "salaryMed": 38.46,
    "salaryHigh": 56,
    "totalSkill": 196,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.46,
    "skillsComp": 60,
    "skillsLogi": 35,
    "skillsMath": 36,
    "skillsLang": 65,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Writing",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 16,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 28,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 30,
    "s13DocumentUse": 21,
    "s14Writing": 24,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 75,
    "f2Engineering": 15420,
    "f3Humanities": 0,
    "f4SocialScience": 80,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 70,
    "f7Arts&Education": 220,
    "f8Education(teachertraining)": 20,
    "f9Law": 0,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 395,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 140,
    "d4Humanities": 0,
    "d5SocialSciences": 80,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 70,
    "d8OtherArts&Science": 220,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 15280,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 50,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 395,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 112,
    "noc": 2132,
    "job": "Mechanical engineers",
    "title1": "acoustical engineer",
    "title2": "acoustics and vibration engineer",
    "title3": "acoustics engineer",
    "allTitles": "acoustical engineeracoustics and vibration engineeracoustics engineerautomotive engineerbuilding systems engineerchief mechanical engineerconsulting mechanical engineercryogenics engineerdesign engineer - mechanicaldesign engineer, oil well equipmentdiesel engineer - design and researchenergy conservation engineerengineer, mechanical designengineer, nuclear operationsengineer, power generationfluid mechanics engineergas utilization mechanical engineerheating specialist engineerheating, ventilation and air conditioning (HVAC) engineerHVAC (heating, ventilation and air conditioning) engineerinternal combustion engineerlubrication engineermarine mechanical engineermechanical design engineermechanical engineermechanical engineer, gas utilizationmechanical engineer, marinemechanical engineer, projectsmechanical hydraulic engineermechanical maintenance engineermechanical power engineermechatronic engineermicro-electro-mechanical systems (MEMS) research engineermould design engineernuclear design engineernuclear engineernuclear operations engineeroil well equipment design engineerpattern engineerpiping engineerpower generation engineerpower plant engineerproject mechanical engineerrefrigeration engineerrobotics engineerthermal design engineerthermal power engineertool engineertribologist",
    "workers": 18645,
    "minEduc": 3,
    "yearsStudy": 3.625,
    "automationRisk": 0.011,
    "salaryLow": 24.04,
    "salaryMed": 38.46,
    "salaryHigh": 46.15,
    "totalSkill": 230,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.46,
    "skillsComp": 45,
    "skillsLogi": 53,
    "skillsMath": 59,
    "skillsLang": 73,
    "topSkill1": "Digital Technology",
    "topSkill2": "Measurement and Calculation",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 13,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 31,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 11,
    "s8OralCommunication": 27,
    "s9ProblemSolving": 20,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 0,
    "s14Writing": 20,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 240,
    "f2Engineering": 17580,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 160,
    "f8Education(teachertraining)": 30,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 635,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 160,
    "d9Education(teachertraining)": 30,
    "d10Engineering": 17560,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 240,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 635,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 113,
    "noc": 2133,
    "job": "Electrical and electronics engineers",
    "title1": "analogue amplifier design engineer",
    "title2": "antenna engineer",
    "title3": "audio engineer - electricity and electronics",
    "allTitles": "analogue amplifier design engineerantenna engineeraudio engineer - electricity and electronicsavionics engineerbroadcasting professional engineerchief electrical engineerchief electronics engineerchief engineer - electric powerchief engineer - radio and television broadcastingcircuit design engineercontrol systems engineerdesign and development engineer, electrical and electronic systemsdesign engineer, electricaldesign engineer, electrical power systemsdesign engineer, radio and television broadcasting systemsdigital circuit design engineerdisplays and controls design engineerdistribution planning engineer, electricalelectrical and electronics research engineerelectrical design engineerelectrical distribution engineerelectrical energy transmission engineerelectrical energy transmission planning engineerelectrical engineerelectrical engineer, process controlelectrical equipment engineerelectrical network engineerelectrical power scheduling engineerelectrical power systems design engineerelectrical research engineerelectrical systems planning engineerelectronics engineerelectronics research engineerelectronics test engineerengineer, avionicsengineer, electrical distribution planningengineer, electrical energy transmissionengineer, electrical energy transmission planningengineer, electronicsengineer, instrumentationengineer, instrumentation and controlinstrumentation and control engineerinstrumentation engineerline construction engineerlow voltage equipment engineermeter engineermetrology engineermicroelectronics engineeroverhead electrical distribution engineerplanning engineer, electrical energy transmissionplanning engineer, electrical systemsprocess control engineer, electricalprocess instrumentation engineerprofessional engineer, broadcastingprotection engineer, electrical systemsprotective relay engineerradar engineerradio and television broadcasting design engineerradio and television broadcasting systems design engineerradio research engineerresearch engineer - nanoelectronicsroadway lighting design engineerrural electrification engineersatellite antenna engineersatellite instrumentation engineerservice engineer, electrical power systemssignal engineerspacecraft electronics engineertechnical services electrical engineertelevision systems engineertest engineer, electronicsunderground electrical distribution engineer",
    "workers": 17400,
    "minEduc": 3,
    "yearsStudy": 3.821428571,
    "automationRisk": 0.063,
    "salaryLow": 23,
    "salaryMed": 38.5,
    "salaryHigh": 70.19,
    "totalSkill": 235,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.5,
    "skillsComp": 58,
    "skillsLogi": 70,
    "skillsMath": 40,
    "skillsLang": 67,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 14,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 18,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 20,
    "s10Reading": 31,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 26,
    "s13DocumentUse": 25,
    "s14Writing": 22,
    "s15CriticalThinking": 20,
    "f1Science&Agriculture": 130,
    "f2Engineering": 16445,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 190,
    "f7Arts&Education": 280,
    "f8Education(teachertraining)": 40,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 285,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 190,
    "d8OtherArts&Science": 280,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 16445,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 130,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 285,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 114,
    "noc": 2134,
    "job": "Chemical engineers",
    "title1": "adhesives engineer biochemical and biotechnical engineer biochemical development engineer biochemical engineer biotechnical engineer biotechnology engineer chemical engineer chemical engineer, design and development chemical engineer, environmental chemical engineer, production chemical engineer, research chemical process engineer chief chemical engineer chief process engineer coatings engineer, chemical electrochemical engineer engineer, adhesives engineer, biotechnology engineer, chemical processes engineer, coatings engineer, industrial hygiene engineer, pulp and paper engineer, refinery engineer, waste treatment environmental engineer, chemical explosives engineer fuels engineer industrial hygiene engineer industrial waste treatment engineer liquid fuels engineer petrochemical engineer petroleum refinery process engineer plastics engineer polymer engineer process control engineer, chemical process engineer, petroleum refinery project engineer, chemical pulp and paper engineer pulp and paper engineer, chemical refinery engineer waste treatment engineer",
    "title2": 0,
    "title3": 0,
    "allTitles": "adhesives engineer biochemical and biotechnical engineer biochemical development engineer biochemical engineer biotechnical engineer biotechnology engineer chemical engineer chemical engineer, design and development chemical engineer, environmental chemical engineer, production chemical engineer, research chemical process engineer chief chemical engineer chief process engineer coatings engineer, chemical electrochemical engineer engineer, adhesives engineer, biotechnology engineer, chemical processes engineer, coatings engineer, industrial hygiene engineer, pulp and paper engineer, refinery engineer, waste treatment environmental engineer, chemical explosives engineer fuels engineer industrial hygiene engineer industrial waste treatment engineer liquid fuels engineer petrochemical engineer petroleum refinery process engineer plastics engineer polymer engineer process control engineer, chemical process engineer, petroleum refinery project engineer, chemical pulp and paper engineer pulp and paper engineer, chemical refinery engineer waste treatment engineer",
    "workers": 17453.33333,
    "minEduc": 2,
    "yearsStudy": 3.776437151,
    "automationRisk": 0.031,
    "salaryLow": 22.12,
    "salaryMed": 34.85,
    "salaryHigh": 64.9,
    "totalSkill": 220.3333333,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.47333333,
    "skillsComp": 54.33333333,
    "skillsLogi": 52.66666667,
    "skillsMath": 45,
    "skillsLang": 68.33333333,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 9.666666667,
    "s2DecisionMaking": 12.33333333,
    "s3FindingInformation": 10.33333333,
    "s4JobTaskPlanningandOrganizing": 3.666666667,
    "s5MeasurementandCalculation": 21.66666667,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 16.33333333,
    "s10Reading": 28.33333333,
    "s11SchedulingorBudgetingandAccounting": 11.33333333,
    "s12DigitalTechnology": 29.33333333,
    "s13DocumentUse": 15.33333333,
    "s14Writing": 22,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 148.3333333,
    "f2Engineering": 16481.66667,
    "f3Humanities": 0,
    "f4SocialScience": 26.66666667,
    "f5FineArts": 5,
    "f6MathAndComputerScience": 86.66666667,
    "f7Arts&Education": 220,
    "f8Education(teachertraining)": 30,
    "f9Law": 0,
    "f10Health": 6.666666667,
    "f11Health,Nursing&ClinicalLaboratory": 10,
    "f12Business": 438.3333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 8.333333333,
    "d3Architecture&LandscapeArchitecture": 53.33333333,
    "d4Humanities": 0,
    "d5SocialSciences": 26.66666667,
    "d6Fine&AppliedArts": 5,
    "d7ComputerScience": 86.66666667,
    "d8OtherArts&Science": 220,
    "d9Education(teachertraining)": 30,
    "d10Engineering": 16428.33333,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 6.666666667,
    "d14Theology": 0,
    "d15PhysicalSciences": 140,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 10,
    "d18Business&Commerce": 438.3333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 115,
    "noc": 2141,
    "job": "Industrial and manufacturing engineers",
    "title1": "CIM (computer integrated manufacturing) engineer",
    "title2": "computer integrated manufacturing (CIM) engineer",
    "title3": "consulting industrial engineer",
    "allTitles": "CIM (computer integrated manufacturing) engineercomputer integrated manufacturing (CIM) engineerconsulting industrial engineercost engineerefficiency engineerengineer, computer integrated manufacturing (CIM)engineer, manufacturingfire prevention engineerindustrial efficiency engineerindustrial engineerindustrial safety engineermanufacturing engineermethods engineerplant engineerproduction engineerQA (quality assurance) engineerquality assurance (QA) engineerquality control engineersafety engineersystems engineer - manufacturingtime-study engineerwork measurement engineer",
    "workers": 5440,
    "minEduc": 3,
    "yearsStudy": 3.59375,
    "automationRisk": 0.029,
    "salaryLow": 27.57,
    "salaryMed": 38.46,
    "salaryHigh": 64.1,
    "totalSkill": 208,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.46,
    "skillsComp": 51,
    "skillsLogi": 54,
    "skillsMath": 43,
    "skillsLang": 60,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 11,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 8,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 20,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 16,
    "s12DigitalTechnology": 25,
    "s13DocumentUse": 15,
    "s14Writing": 21,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 60,
    "f2Engineering": 4960,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 100,
    "f7Arts&Education": 120,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 180,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 100,
    "d8OtherArts&Science": 120,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 4960,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 60,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 180,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 116,
    "noc": 2142,
    "job": "Metallurgical and materials engineers",
    "title1": "ceramics engineer",
    "title2": "coal preparation consulting engineer",
    "title3": "corrosion engineer",
    "allTitles": "ceramics engineercoal preparation consulting engineercorrosion engineerelectrometallurgical engineerengineer, ceramicsengineer, materialsextractive engineerextractive metallurgy engineerfoundry engineerhydrometallurgical engineermaterials engineermetallurgical engineerphysical metallurgical engineerpyrometallurgical engineerrefining and metalworking engineersmelter engineer, mineralssmelting plant engineerwelding engineer",
    "workers": 480,
    "minEduc": 3,
    "yearsStudy": 4.6,
    "automationRisk": 0.021,
    "salaryLow": 24.5,
    "salaryMed": 39.926,
    "salaryHigh": 63.684,
    "totalSkill": 208,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 34.74923665,
    "skillsComp": 58,
    "skillsLogi": 52,
    "skillsMath": 34,
    "skillsLang": 64,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Reading",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 15,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 15,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 25,
    "s13DocumentUse": 21,
    "s14Writing": 24,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 45,
    "f2Engineering": 435,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 435,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 117,
    "noc": 2143,
    "job": "Mining engineers",
    "title1": "consulting mining engineer",
    "title2": "engineer, mineral",
    "title3": "engineer, mining",
    "allTitles": "consulting mining engineerengineer, mineralengineer, miningexploration engineer, minesmine design engineermine development engineermine layout engineermine planning engineermine production engineermineral dressing engineermineral engineermine safety engineermines exploration engineermine ventilation engineermining engineer",
    "workers": 625,
    "minEduc": 0,
    "yearsStudy": 4.176470588,
    "automationRisk": 0.14,
    "salaryLow": 24.5,
    "salaryMed": 39.926,
    "salaryHigh": 63.684,
    "totalSkill": 154,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 34.41153921,
    "skillsComp": 41,
    "skillsLogi": 39,
    "skillsMath": 21,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 625,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 625,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 118,
    "noc": 2144,
    "job": "Geological engineers",
    "title1": "engineer, geological",
    "title2": "engineer, geophysical",
    "title3": "engineer, geotechnical",
    "allTitles": "engineer, geologicalengineer, geophysicalengineer, geotechnicalgeological engineergeophysical engineergeotechnical engineerhydrogeological engineerhydrogeological engineer - engineeringhydrogeology engineer - engineeringsupervising engineer - petrographysupervising engineer - rock sciences",
    "workers": 250,
    "minEduc": 3,
    "yearsStudy": 4.4,
    "automationRisk": 0.14,
    "salaryLow": 22.96,
    "salaryMed": 38.1,
    "salaryHigh": 75.78,
    "totalSkill": 138,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.1,
    "skillsComp": 43,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 6,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 13,
    "s14Writing": 10,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 0,
    "f2Engineering": 250,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 250,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 119,
    "noc": 2145,
    "job": "Petroleum engineers",
    "title1": "chief engineer, drilling and recovery",
    "title2": "chief petroleum engineer",
    "title3": "drilling and recovery chief engineer",
    "allTitles": "chief engineer, drilling and recoverychief petroleum engineerdrilling and recovery chief engineerdrilling and recovery petroleum engineerdrilling engineer, oil and gasengineer, natural gasengineer, oil and gas drillingengineer, petroleumengineer, petroleum productionengineer, petroleum well completionexploitation engineer - oil and gasexploitation engineer - petroleumlogging engineer, oil wellsmud engineermud engineer - petroleum drillingnatural gas engineeroffshore drilling engineeroffshore drilling rig subsea equipment engineeroil and gas drilling engineeroil and gas production engineeroil well logging engineerpetroleum engineerpetroleum engineer, completionpetroleum engineer, drilling and recoverypetroleum engineer, productionpetroleum production engineerpetroleum reservoir engineerpetroleum well completion engineerproduction engineer, oil and gasreservoir engineer, petroleumsubsea engineersubsea equipment engineer, offshore drilling rigwell logging engineer",
    "workers": 885,
    "minEduc": 2.5,
    "yearsStudy": 3.85,
    "automationRisk": 0.23,
    "salaryLow": 24.5,
    "salaryMed": 39.926,
    "salaryHigh": 63.684,
    "totalSkill": 184.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 31.07975505,
    "skillsComp": 52,
    "skillsLogi": 43,
    "skillsMath": 32,
    "skillsLang": 57.5,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 11,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 10,
    "s8OralCommunication": 18.5,
    "s9ProblemSolving": 9,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 18,
    "s14Writing": 15,
    "s15CriticalThinking": 11.5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 120,
    "noc": 2146,
    "job": "Aerospace engineers",
    "title1": "aerodynamics engineer",
    "title2": "aeronautical engineer",
    "title3": "aerospace engineer",
    "allTitles": "aerodynamics engineeraeronautical engineeraerospace engineeraerospace engineer - design and developmentaerospace engineer - flight operationsaerospace engineer - flight supportaerospace engineer - flight testaerospace engineer - mass propertiesaerospace engineer - materials and processesaerospace engineer - material stressaerospace engineer - propulsion systemsaerospace engineer, structuresaerospace engineer - systemsaerospace engineer - systems analysisaerospace engineer - weight and balanceaerospace reliability specialistaerospace structural engineeraerospace systems engineeraerospace test engineeraircraft design engineerdesign engineer, aircraftprojects engineer, aeronauticalpropulsion engineer - aerospace vehiclesspace reliability specialiststress engineer - aerospacestructural engineer, aerospacestructures aerospace engineersystems engineer, aerospacetest engineer, aerospaceweight analyst, aircraft design - engineerweight and balance engineer - aerospace",
    "workers": 1330,
    "minEduc": 3,
    "yearsStudy": 4.138888889,
    "automationRisk": 0.017,
    "salaryLow": 21,
    "salaryMed": 38.46,
    "salaryHigh": 57,
    "totalSkill": 256,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.46,
    "skillsComp": 93,
    "skillsLogi": 64,
    "skillsMath": 33,
    "skillsLang": 66,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 25,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 17,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 16,
    "s10Reading": 27,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 42,
    "s13DocumentUse": 26,
    "s14Writing": 20,
    "s15CriticalThinking": 20,
    "f1Science&Agriculture": 0,
    "f2Engineering": 1315,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1315,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 121,
    "noc": 2147,
    "job": "Computer engineers (except software engineers and designers)",
    "title1": "application specific integrated circuit (ASIC) design engineer",
    "title2": "capacity planner, network",
    "title3": "capacity planning analyst",
    "allTitles": "application specific integrated circuit (ASIC) design engineercapacity planner, networkcapacity planning analystcomputer engineercomputer engineer (except software)computer hardware engineercomputer systems engineercomputer telecommunications specialistdata communications specialistengineer, computer (except software)engineer, computer hardwareengineer, hardwareengineer, network systemsengineer, optical communicationsengineer, optical communications hardwareengineer, telecommunications hardwarefibre-optic network designerhardware circuit board designerhardware design engineerhardware development engineerhardware engineerhardware specialist, telecommunicationshardware technical architectmicroprocessor designer and application engineermicrowave systems engineermicrowave transmission systems engineernetwork architect - computer systemsnetwork designer - computer systemsnetwork engineer, communication hardwarenetwork specialist - computer systemsnetwork systems engineernetwork test engineeroptical communications engineeroptical communications hardware engineeroptical systems engineer - telecommunicationsradio systems engineersatellite data transmission engineerspacecraft electronics engineer - hardwarespecialist, telecommunications hardwaresystems designer - hardwaretechnical architect - hardwaretelecommunications engineertelecommunications hardware engineertelecommunications hardware specialisttelecommunications specialist - computer systemstelecommunications systems specialistwireless communications network engineer",
    "workers": 10050,
    "minEduc": 0,
    "yearsStudy": 3.639344262,
    "automationRisk": 0.22,
    "salaryLow": 28.85,
    "salaryMed": 38.46,
    "salaryHigh": 60,
    "totalSkill": 158,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 38.46,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 155,
    "f2Engineering": 6865,
    "f3Humanities": 0,
    "f4SocialScience": 30,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 2400,
    "f7Arts&Education": 200,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 400,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 0,
    "d5SocialSciences": 30,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 2340,
    "d8OtherArts&Science": 200,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 6845,
    "d11Law": 0,
    "d12Mathematics": 60,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 155,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 400,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 122,
    "noc": 2148,
    "job": "Other professional engineers, n.e.c.",
    "title1": "agricultural engineer",
    "title2": "agronomy engineer",
    "title3": "agroprocessing engineer",
    "allTitles": "agricultural engineeragronomy engineeragroprocessing engineerarchitect, navalbioelectrical engineerbiomechanical engineerbiomedical engineerbiomedical engineer - research and developmentbio-resource engineerclinical biomedical engineerdairy plant engineerengineer, agroprocessingengineer, bioelectricalengineer, biomechanicalengineer, biomedicalengineer, food processingengineer, food technologyengineer in agronomyengineering physicistengineering scientistengineer, textilefood processing engineerfood technology engineermarine engineermarine systems engineernaval architectnaval engineershipbuilding engineership construction engineertextile engineer",
    "workers": 520,
    "minEduc": 0,
    "yearsStudy": 4.533333333,
    "automationRisk": 0.108,
    "salaryLow": 22.12,
    "salaryMed": 46.15,
    "salaryHigh": 61.54,
    "totalSkill": 166,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 46.15,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 15,
    "f2Engineering": 505,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 505,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 123,
    "noc": 2151,
    "job": "Architects",
    "title1": "architect architect, residential buildings architectural standards specialist chief architect consulting architect industrial and commercial buildings architect residential architect",
    "title2": 0,
    "title3": 0,
    "allTitles": "architect architect, residential buildings architectural standards specialist chief architect consulting architect industrial and commercial buildings architect residential architect",
    "workers": 1518.333333,
    "minEduc": 3,
    "yearsStudy": 3.807946128,
    "automationRisk": 0.185,
    "salaryLow": 23.08,
    "salaryMed": 32.69,
    "salaryHigh": 62.5,
    "totalSkill": 199.6666667,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 31.56333333,
    "skillsComp": 50.66666667,
    "skillsLogi": 50.33333333,
    "skillsMath": 32,
    "skillsLang": 66.66666667,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7.333333333,
    "s2DecisionMaking": 9.666666667,
    "s3FindingInformation": 9.666666667,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 4.666666667,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 14,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 9.333333333,
    "s12DigitalTechnology": 21.66666667,
    "s13DocumentUse": 21.66666667,
    "s14Writing": 22.66666667,
    "s15CriticalThinking": 13.66666667,
    "f1Science&Agriculture": 130,
    "f2Engineering": 1193.333333,
    "f3Humanities": 0,
    "f4SocialScience": 171.6666667,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 6.666666667,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 16.66666667,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 6.666666667,
    "d2Forestry": 123.3333333,
    "d3Architecture&LandscapeArchitecture": 870,
    "d4Humanities": 0,
    "d5SocialSciences": 171.6666667,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 6.666666667,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 323.3333333,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 16.66666667,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 124,
    "noc": 2152,
    "job": "Landscape architects",
    "title1": "architect, golf course",
    "title2": "architect, landscape",
    "title3": "golf course architect",
    "allTitles": "architect, golf coursearchitect, landscapegolf course architectlandscape architectlandscape planner",
    "workers": 530,
    "minEduc": 3,
    "yearsStudy": 4.272727273,
    "automationRisk": 0.045,
    "salaryLow": 14,
    "salaryMed": 31.97,
    "salaryHigh": 47.79,
    "totalSkill": 179,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 31.97,
    "skillsComp": 47,
    "skillsLogi": 45,
    "skillsMath": 30,
    "skillsLang": 57,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 14,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 13,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 20,
    "s14Writing": 21,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 530,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 530,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 125,
    "noc": 2153,
    "job": "Urban and land use planners",
    "title1": "city planner",
    "title2": "city planner - land use",
    "title3": "community and urban planner",
    "allTitles": "city plannercity planner - land usecommunity and urban plannercommunity plannercommunity recreation plannerenvironmental plannerheritage planner - land useheritage work plannerland use plannerland use specialistlong-range planner - land usemass transit services analystmunicipal park plannermunicipal plannerneighbourhood plannerpark plannerpark planner, municipalplannerplanner, community recreationplanner, urban and regionalplanning analyst - land userecreation plannerregional plannersenior planner - land usesite plannertown plannertransportation plannertransportation route planning analysturban and regional plannerurban plannerurban renovation plannerzoning officer - land use",
    "workers": 3090,
    "minEduc": 3,
    "yearsStudy": 4.311111111,
    "automationRisk": 0.13,
    "salaryLow": 17.31,
    "salaryMed": 37.72,
    "salaryHigh": 54.95,
    "totalSkill": 205,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 37.72,
    "skillsComp": 52,
    "skillsLogi": 53,
    "skillsMath": 31,
    "skillsLang": 69,
    "topSkill1": "Oral Communication",
    "topSkill2": "Writing",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 14,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 25,
    "s9ProblemSolving": 14,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 11,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 16,
    "s14Writing": 23,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 390,
    "f2Engineering": 2180,
    "f3Humanities": 0,
    "f4SocialScience": 460,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 50,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 370,
    "d3Architecture&LandscapeArchitecture": 2080,
    "d4Humanities": 0,
    "d5SocialSciences": 460,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 100,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 50,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 126,
    "noc": 2154,
    "job": "Land surveyors",
    "title1": "cadastral surveyor",
    "title2": "Canada lands surveyor",
    "title3": "city surveyor",
    "allTitles": "cadastral surveyorCanada lands surveyorcity surveyorcommissioned land surveyorcountry surveyorland surveying party chiefland surveyorland survey supervisorlegal surveyorparty chief, land surveyingpipeline surveyorport surveyorprofessional land surveyorproperty surveyorprovincial land surveyorrailway surveyorsupervisor, land surveysurveyor, Canada landssurveyor, citysurveyor, countrysurveyor, landsurveyor, pipelinesurveyor, portsurveyor, propertysurveyor, provincial landsurveyor, railway",
    "workers": 935,
    "minEduc": 3,
    "yearsStudy": 2.84,
    "automationRisk": 0.38,
    "salaryLow": 17,
    "salaryMed": 25,
    "salaryHigh": 41.96,
    "totalSkill": 215,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 25,
    "skillsComp": 53,
    "skillsLogi": 53,
    "skillsMath": 35,
    "skillsLang": 74,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 12,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 18,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 25,
    "s9ProblemSolving": 15,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 29,
    "s14Writing": 24,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 0,
    "f2Engineering": 870,
    "f3Humanities": 0,
    "f4SocialScience": 55,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 55,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 870,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 127,
    "noc": 2161,
    "job": "Mathematicians, statisticians and actuaries",
    "title1": "actuarial analyst",
    "title2": "actuarial assistant",
    "title3": "actuary",
    "allTitles": "actuarial analystactuarial assistantactuaryanalysis supervisor - statisticsapplied mathematicianapplied statisticianassociate actuarybiological and agricultural science statisticianbiometricianbiostatisticianbusiness and economics statisticiancasualty actuarychemistry statisticiancipher expertconsulting actuaryconsulting pension actuarycryptanalystcryptoanalystcryptographerdemographereducation statisticianenvironmental epidemiologistepidemiologist (except physician and veterinarian)financial statisticianindustrial statisticianinsurance actuarylife actuarymathematical statisticianmathematicianmathematician, researchmedical statisticianmethodologist, statisticaloperations research analystoperations researcheropinion polling statisticianphysical science and engineering statisticianpublic health statisticianresearch mathematiciansales statisticiansenior actuarial analystsocial science statisticianstatistical analysis supervisorstatistical analyststatistical consultantstatistical methodologiststatisticiansurvey statisticianvital statistician",
    "workers": 3980,
    "minEduc": 3,
    "yearsStudy": 4.574074074,
    "automationRisk": 0.159,
    "salaryLow": 31.73,
    "salaryMed": 50,
    "salaryHigh": 66.67,
    "totalSkill": 218,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 50,
    "skillsComp": 69,
    "skillsLogi": 42,
    "skillsMath": 39,
    "skillsLang": 68,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Reading",
    "s1DataAnalysis": 18,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 11,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 9,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 14,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 19,
    "s14Writing": 26,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 355,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 195,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 1575,
    "f7Arts&Education": 135,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 50,
    "f12Business": 1670,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 355,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 195,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 135,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 1575,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 50,
    "d18Business&Commerce": 1670,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 128,
    "noc": 2171,
    "job": "Information systems analysts and consultants",
    "title1": "account manager, IT (information technology) consulting",
    "title2": "analyst, business - computer systems",
    "title3": "analyst, computer",
    "allTitles": "account manager, IT (information technology) consultinganalyst, business - computer systemsanalyst, computeranalyst, computer simulationsanalyst, computer systemsanalyst, informatics securityanalyst, information systems - computer systemsanalyst, information technology (IT)analyst, management information systems (MIS)analyst, MIS (management information systems)analyst, systemsapplications analyst - computer systemsartificial intelligence analystartificial intelligence consultantauditor, systemsbusiness analyst, computer systemsbusiness analyst, informaticsbusiness continuity analystbusiness re-engineering analyst, systemsbusiness systems analystbusiness systems specialist - computer systemscomputer analystcomputer consultantcomputer simulations analystcomputer systems analystcomputer systems development co-ordinatorconsultant, data processingconsultant, information technology (IT)consultant, management information systems (MIS)consultant, systemscontingency planner, information systemsco-ordinator, computer systems developmentdata processing consultantEDP (electronic data processing) auditorelectronic data processing (EDP) auditorinformatics applications analystinformatics business analystinformatics consultantinformatics quality assurance (QA) analystinformatics security analystinformatics security consultantinformation systems analyst - computer systemsinformation systems business analystinformation systems contingency plannerinformation systems quality assurance analystinformation systems quality assurance (QA) analystinformation technology (IT) analystinformation technology (IT) business analystinformation technology (IT) consultantinteractive media consultantInternet security analystIT (information technology) business analystIT (information technology) consultantIT (information technology) consulting account managermanagement information systems consultantmanagement information systems (MIS) analystMIS (management information systems) analystMIS (management information systems) consultantmultimedia consultantplanner, systems securityQA (quality assurance) analyst - informaticsquality assurance analyst, information systemsquality assurance (QA) auditor, softwaresecurity planner, systemssimulations analyst - computer systemssoftware QA (quality assurance) analystsoftware QA (quality assurance) auditorsoftware quality assurance (QA) analystsystem integration analystsystem integration consultantsystems analystsystems auditorsystems consultantsystems QA (quality assurance) analystsystems quality assurance (QA) analystsystems security analystsystems security plannersystems specialist, business - computer systemssystems specialist - computer systems",
    "workers": 61785,
    "minEduc": 3,
    "yearsStudy": 3.583333333,
    "automationRisk": 0.113,
    "salaryLow": 22.6,
    "salaryMed": 37.5,
    "salaryHigh": 60.58,
    "totalSkill": 158,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 37.5,
    "skillsComp": 44,
    "skillsLogi": 47,
    "skillsMath": 15,
    "skillsLang": 52,
    "topSkill1": "Digital Technology",
    "topSkill2": "Writing",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 11,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 26,
    "s13DocumentUse": 17,
    "s14Writing": 20,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 2190,
    "f2Engineering": 12595,
    "f3Humanities": 485,
    "f4SocialScience": 3735,
    "f5FineArts": 900,
    "f6MathAndComputerScience": 26255,
    "f7Arts&Education": 3350,
    "f8Education(teachertraining)": 530,
    "f9Law": 425,
    "f10Health": 140,
    "f11Health,Nursing&ClinicalLaboratory": 445,
    "f12Business": 10735,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 520,
    "d2Forestry": 110,
    "d3Architecture&LandscapeArchitecture": 135,
    "d4Humanities": 335,
    "d5SocialSciences": 3735,
    "d6Fine&AppliedArts": 900,
    "d7ComputerScience": 23775,
    "d8OtherArts&Science": 3350,
    "d9Education(teachertraining)": 530,
    "d10Engineering": 12460,
    "d11Law": 425,
    "d12Mathematics": 2480,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 150,
    "d15PhysicalSciences": 1560,
    "d16Therapy&Rehabilitation": 70,
    "d17Health,Nursing&ClinicalLaboratory": 445,
    "d18Business&Commerce": 10735,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 129,
    "noc": 2172,
    "job": "Database analysts and data administrators",
    "title1": "administrator, data",
    "title2": "administrator, database",
    "title3": "analyst, database",
    "allTitles": "administrator, dataadministrator, databaseanalyst, databaseanalyst, EDP (electronic data processing)analyst, electronic data processing (EDP) systemsarchitect, databasedata administratordata analyst - informatics and systemsdatabase administrator (DBA)database analystdatabase analyst (DBA)database architectdatabase architect (DBA)database designerdatabase management supervisor - computer systemsdatabase managerdata custodiandata dictionary administratordata minerdata mining analystdata processing specialistdata warehouse analystDBA (database administrator)DBA (database analyst)DBA (database architect)designer, databaseEDP (electronic data processing) analystEDP (electronic data processing) specialistEDP (electronic data processing) systems analystelectronic data processing (EDP) specialistelectronic data processing (EDP) systems analystinformation resource analystmanager, databasespecialist, electronic data processing (EDP)supervisor, database management - computer systemssystems analyst, EDP (electronic data processing)systems analyst, electronic data processing (EDP)technical architect - database",
    "workers": 4115,
    "minEduc": 3,
    "yearsStudy": 3.773195876,
    "automationRisk": 0.03,
    "salaryLow": 20.65,
    "salaryMed": 32.97,
    "salaryHigh": 50.48,
    "totalSkill": 172,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 32.97,
    "skillsComp": 52,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 55,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 6,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 27,
    "s13DocumentUse": 22,
    "s14Writing": 20,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 110,
    "f2Engineering": 795,
    "f3Humanities": 0,
    "f4SocialScience": 90,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 2420,
    "f7Arts&Education": 245,
    "f8Education(teachertraining)": 45,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 395,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 10,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 2195,
    "d8OtherArts&Science": 245,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 795,
    "d11Law": 0,
    "d12Mathematics": 225,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 100,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 395,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 130,
    "noc": 2173,
    "job": "Software engineers and designers",
    "title1": "application architect",
    "title2": "artificial intelligence (AI) designer",
    "title3": "artificial intelligence designer",
    "allTitles": "application architectartificial intelligence (AI) designerartificial intelligence designercomputer applications engineercomputer software engineercomputer telecommunications software specialistdesign engineer, softwaredesigner, softwareembedded software engineerengineer, softwaresimulation software design engineersoftware architectsoftware design engineersoftware designersoftware design supervisorsoftware design verification engineersoftware engineersoftware systems designersoftware systems integration engineersoftware technical architectsoftware testing engineerspecialist, telecommunications softwaresupervisor, software designsystems applications engineersystems architectsystems designer - softwaresystems engineer - softwaresystems integration engineer - softwaretechnical architect - softwaretelecommunications software engineertelecommunications software specialisttest engineer, softwaretesting engineer, software",
    "workers": 16505,
    "minEduc": 0,
    "yearsStudy": 3.914772727,
    "automationRisk": 0.086,
    "salaryLow": 25.13,
    "salaryMed": 48.08,
    "salaryHigh": 69.71,
    "totalSkill": 168,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 48.08,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 305,
    "f2Engineering": 7985,
    "f3Humanities": 15,
    "f4SocialScience": 180,
    "f5FineArts": 35,
    "f6MathAndComputerScience": 6530,
    "f7Arts&Education": 555,
    "f8Education(teachertraining)": 45,
    "f9Law": 20,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 40,
    "f12Business": 780,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 180,
    "d6Fine&AppliedArts": 35,
    "d7ComputerScience": 5810,
    "d8OtherArts&Science": 555,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 7985,
    "d11Law": 20,
    "d12Mathematics": 720,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 245,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 40,
    "d18Business&Commerce": 780,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 131,
    "noc": 2174,
    "job": "Computer programmers and interactive media developers",
    "title1": "animation programmer",
    "title2": "application programmer",
    "title3": "business application programmer",
    "allTitles": "animation programmerapplication programmerbusiness application programmercomputer application programmercomputer game developercomputer programmerdetail programmerdeveloper, softwaree-business (electronic business) software developere-commerce (electronic commerce) software developerEDP (electronic data processing) applications programmerelectronic business (e-business) software developerelectronic commerce (e-commerce) software developerelectronic data processing (EDP) applications programmergame developer, computergraphical user interface (GUI) designergraphical user interface (GUI) developerinteractive media developerinteractive media programmerJava programmermainframe systems programmerminicomputer systems programmermultimedia developermultimedia programmeroperating systems programmerPC (personal computer) application developerpersonal computer (PC) application developerprogrammer analystprogrammer, animationprogrammer, interactive mediaprogrammer, special effectsprogrammer, systemsprogrammer, Websatellite scientific telecommunications programmerscientific programmersoftware developersoftware developer, e-business (electronic business)software developer, e-commerce (electronic commerce)software developer, electronic business (e-business)software developer, electronic commerce (e-commerce)software development programmersoftware programmerspecial effects programmersystems programmerteleprocessing software programmervisual basic programmerWeb programmer",
    "workers": 38550,
    "minEduc": 3,
    "yearsStudy": 3.706214689,
    "automationRisk": 0.048,
    "salaryLow": 21,
    "salaryMed": 35.9,
    "salaryHigh": 57.69,
    "totalSkill": 161,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 35.9,
    "skillsComp": 50,
    "skillsLogi": 33,
    "skillsMath": 16,
    "skillsLang": 62,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 24,
    "s13DocumentUse": 19,
    "s14Writing": 24,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 1110,
    "f2Engineering": 8830,
    "f3Humanities": 255,
    "f4SocialScience": 1025,
    "f5FineArts": 1155,
    "f6MathAndComputerScience": 21945,
    "f7Arts&Education": 1620,
    "f8Education(teachertraining)": 210,
    "f9Law": 60,
    "f10Health": 55,
    "f11Health,Nursing&ClinicalLaboratory": 100,
    "f12Business": 2185,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 250,
    "d2Forestry": 10,
    "d3Architecture&LandscapeArchitecture": 95,
    "d4Humanities": 135,
    "d5SocialSciences": 1025,
    "d6Fine&AppliedArts": 1155,
    "d7ComputerScience": 20060,
    "d8OtherArts&Science": 1620,
    "d9Education(teachertraining)": 210,
    "d10Engineering": 8735,
    "d11Law": 60,
    "d12Mathematics": 1885,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 120,
    "d15PhysicalSciences": 850,
    "d16Therapy&Rehabilitation": 30,
    "d17Health,Nursing&ClinicalLaboratory": 100,
    "d18Business&Commerce": 2185,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 132,
    "noc": 2175,
    "job": "Web designers and developers",
    "title1": "corporate Webmaster",
    "title2": "e-business (electronic business) Web site developer",
    "title3": "e-business Web site developer",
    "allTitles": "corporate Webmastere-business (electronic business) Web site developere-business Web site developere-commerce (electronic commerce) Web site developere-commerce Web site developerInternet site designerInternet site developerIntranet site designerIntranet site developerWeb designerWeb developerWeb managerWebmasterWeb site designerWeb site developer",
    "workers": 9245,
    "minEduc": 3,
    "yearsStudy": 3.824546756,
    "automationRisk": 0.1135,
    "salaryLow": 19,
    "salaryMed": 28.57,
    "salaryHigh": 46.15,
    "totalSkill": 199,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 31.71,
    "skillsComp": 60,
    "skillsLogi": 51.5,
    "skillsMath": 25,
    "skillsLang": 62.5,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Writing",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 12.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 8.5,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 6.5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 12,
    "s10Reading": 23.5,
    "s11SchedulingorBudgetingandAccounting": 6.5,
    "s12DigitalTechnology": 28.5,
    "s13DocumentUse": 19.5,
    "s14Writing": 23,
    "s15CriticalThinking": 16.5,
    "f1Science&Agriculture": 60,
    "f2Engineering": 630,
    "f3Humanities": 35,
    "f4SocialScience": 600,
    "f5FineArts": 1165,
    "f6MathAndComputerScience": 2540,
    "f7Arts&Education": 195,
    "f8Education(teachertraining)": 30,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 545,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 25,
    "d4Humanities": 35,
    "d5SocialSciences": 600,
    "d6Fine&AppliedArts": 1165,
    "d7ComputerScience": 2460,
    "d8OtherArts&Science": 195,
    "d9Education(teachertraining)": 30,
    "d10Engineering": 605,
    "d11Law": 25,
    "d12Mathematics": 80,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 545,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 133,
    "noc": 2211,
    "job": "Chemical plant machine operators",
    "title1": "analytical chemistry technician",
    "title2": "analytical chemistry technologist",
    "title3": "analytical technician, chemical",
    "allTitles": "analytical chemistry techniciananalytical chemistry technologistanalytical technician, chemicalassistant, laboratory - applied chemistrybiochemistry laboratory technicianbiochemistry laboratory technologistbiochemistry technician (except medical)biochemistry technologistbiochemistry technologist (except medical)brewery technicianbrewery technician - applied chemistrycellulose film solutions testerchemical analysis specialistchemical analystchemical engineering technicianchemical engineering technologistchemical laboratory analystchemical laboratory supervisorchemical laboratory technicianchemical laboratory technologistchemical process analystchemical processing quality control technicianchemical processing quality control technologistchemical process technologistchemical products quality control technologistchemical research technicianchemical research technologistchemical technicianchemical technician - heavy water plant and nuclear generating stationchemical technician, NMR (nuclear magnetic resonance)chemical technician, nuclear magnetic resonance (NMR)chemical technologistcompressed gases testerdocuments examiner - applied chemistrydyeing and finishing techniciandyeing and finishing technologistdyeing technicianfood processing quality control technicianfood processing quality control technologistfood technicianfood technologistforensic examiner - alcoholforensic lab analyst, chemicalforensic laboratory technicianforest products technologistformulation technicianfuel techniciangas chromatographergeochemical techniciangeochemical technologisthandwriting expert, forensichome economics technologistindustrial hygiene technologistinspector, pharmaceuticalslaboratory assistant - applied chemistrylaboratory technician, chemicallaboratory technologist, chemicallaboratory testerlaboratory tester, chemical processinglaboratory tester - pulp and papermass spectrometer technicianmass spectrometer technologistmass spectrometry technicianmaster dyer - textilesNMR (nuclear magnetic resonance) chemical techniciannuclear magnetic resonance (NMR) chemical technicianpaint technicianpetrochemical engineering technicianpetrochemical engineering technologistpetrochemical laboratory technologistpetroleum processing testerpetroleum research technologistpharmaceuticals and toiletries inspectorpharmaceuticals inspectorpilot plant technicianpilot plant technologistplastics and synthetic resins technicianpolymers testerquality control technician - chemical processingquality control technician - chemistryquality control technician - food processingquality control technologist - chemical processingquality control technologist, chemical productsquality control technologist - food processingresearch technologist, petroleumspectroscopic technologistspectroscopistsynthetic textiles techniciantechnician, biochemistry (except medical)technician, chemical engineeringtechnician, chemical processing quality controltechnician, dyeingtechnician, foodtechnician, food processing quality controltechnician, formulationtechnician, mass spectrometertechnician, mass spectrometrytechnician, paintstechnician, petrochemical engineeringtechnician, pilot plant",
    "workers": 210,
    "minEduc": 1,
    "yearsStudy": 3.875,
    "automationRisk": 0.76,
    "salaryLow": 14,
    "salaryMed": 25,
    "salaryHigh": 39.66,
    "totalSkill": 106,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 18,
    "skillsComp": 29,
    "skillsLogi": 28,
    "skillsMath": 5,
    "skillsLang": 44,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 8,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 7,
    "s13DocumentUse": 18,
    "s14Writing": 15,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 2065,
    "f2Engineering": 1350,
    "f3Humanities": 0,
    "f4SocialScience": 90,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 890,
    "f8Education(teachertraining)": 15,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 315,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 700,
    "d2Forestry": 375,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 890,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 1350,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 990,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 315,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 134,
    "noc": 2212,
    "job": "Geological and mineral technologists and technicians",
    "title1": "analyst, mines",
    "title2": "assayer",
    "title3": "assayer, gold",
    "allTitles": "analyst, minesassayerassayer, goldassayer - mineralogyassayer, precious metalsdiamond drilling techniciandrilling fluid technicianfoundry laboratory techniciangeological engineering techniciangeological engineering technologistgeological prospecting technologistgeological survey techniciangeological techniciangeological technologistgeology technical assistantgeophysical data techniciangeophysical equipment operator, airbornegeophysical observergeophysical prospecting technologistgeophysical survey techniciangeophysical survey technologistgeophysical techniciangeophysical technologistgold assayergold prospectorgravity data techniciangroundwater technologistheat treat technicianhydrographic survey technicianhydrographic survey technologisthydrological technicianhydrology technicianlaboratory technician - metallurgylog analystlog technicianmagnetic observermarine geoscience technologistmetallurgical control analystmetallurgical engineering technicianmetallurgical engineering technologistmetallurgical technologistmine analystmine development technologistmine production technicianmineralogy technicianmineralogy technologistmineral technicianmineral technologistmine survey technicianmine survey technologistmining engineering technicianmining engineering technologistmining survey technicianmining survey technologistmining technicianmining technologistmud man - petroleum drillingmud man/woman - petroleum drillingmud woman - petroleum drillingoil geology technologistore technologistpaleontology technicianpalynology technicianpetroleum engineering technicianpetroleum engineering technologistpetroleum field technologistpetroleum geology technologistpetroleum technicianpetrology technicianphysical metallurgy technicianphysical metallurgy technologistprecious metal assayerprospectorprospector, goldreservoir engineering technicianrock mechanics techniciansea-bottom technologistsea-floor technologistseismic exploration line crew co-ordinatorseismic exploration observerseismic prospecting observerseismic survey co-ordinatorseismic technicianseismology technician - petroleum geologyseismology technologist - petroleum geologyseismometer techniciansoil science technician - miningtechnician, geological engineeringtechnician, geological surveytechnician, geophysical datatechnician, geophysical surveytechnician, gravity datatechnician, hydrologytechnician, logstechnician, metallurgical engineeringtechnician, mine productiontechnician, mineralogytechnician, mine surveytechnician, miningtechnician, mining engineering",
    "workers": 465,
    "minEduc": 0,
    "yearsStudy": 2.133333333,
    "automationRisk": 0.91,
    "salaryLow": 16.83,
    "salaryMed": 30,
    "salaryHigh": 43.96,
    "totalSkill": 124,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 30,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 40,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 30,
    "f2Engineering": 370,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 0,
    "f9Law": 10,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 370,
    "d11Law": 10,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 135,
    "noc": 2221,
    "job": "Biological technologists and technicians",
    "title1": "agricultural sciences technician agricultural technician agricultural technologist agrology technician agrology technologist agronomy technician agronomy technologist aquaculture technician aquatic biology technician bacteriological technician bacteriological technologist biological laboratory technologist biological technician biological technologist biotechnology technician botanical technician botanical technologist crop production technician dairy products technician dairy technologist ecological technician ecological technologist eel culture technician entomological technician entomological technologist field crop technician field crop technologist fish culturist fish farm technologist fish hatchery technician fish roe technician fisheries technician fisheries technologist fishery bacteriological technician fishery bacteriological technologist food bacteriological technician food bacteriological technologist foreman/woman, zoo forensic examiner, hair and fibre forensic laboratory technologist, biological habitat management technician ichthyological technician ichthyological technologist industrial bacteriological technician industrial bacteriological technologist life sciences research technician lobster culture technician malacology technician mammalogy technician mammalogy technologist marine biological technician marine biology technician marine biology technologist marine culture technologist marine farming technologist microbiological technician microbiology quality control technologist microbiology technician (except medical) microbiology technologist (except medical) mycological technician mycological technologist nanobiotechnology technician natural resources technician � biology ornithological technician ornithological technologist oyster culture technician pisciculture bacteriological technologist plant breeding technician plant pathology technician plant pathology technologist poultry technician poultry technologist research technician, life sciences sea-farming technologist seed technologist soil bacteriological technician soil bacteriological technologist technician, dairy products technician, fisheries technician, microbiology (except medical) technician, wildlife technician, wildlife resources technologist, fisheries technologist, microbiology (except medical) technologist, wildlife vaccine technician virology technologist wildlife biology technician wildlife resources technician wildlife technician wildlife technologist zoo foreman/woman zoo supervisor zoological technician zoological technologist",
    "title2": 0,
    "title3": 0,
    "allTitles": "agricultural sciences technician agricultural technician agricultural technologist agrology technician agrology technologist agronomy technician agronomy technologist aquaculture technician aquatic biology technician bacteriological technician bacteriological technologist biological laboratory technologist biological technician biological technologist biotechnology technician botanical technician botanical technologist crop production technician dairy products technician dairy technologist ecological technician ecological technologist eel culture technician entomological technician entomological technologist field crop technician field crop technologist fish culturist fish farm technologist fish hatchery technician fish roe technician fisheries technician fisheries technologist fishery bacteriological technician fishery bacteriological technologist food bacteriological technician food bacteriological technologist foreman/woman, zoo forensic examiner, hair and fibre forensic laboratory technologist, biological habitat management technician ichthyological technician ichthyological technologist industrial bacteriological technician industrial bacteriological technologist life sciences research technician lobster culture technician malacology technician mammalogy technician mammalogy technologist marine biological technician marine biology technician marine biology technologist marine culture technologist marine farming technologist microbiological technician microbiology quality control technologist microbiology technician (except medical) microbiology technologist (except medical) mycological technician mycological technologist nanobiotechnology technician natural resources technician � biology ornithological technician ornithological technologist oyster culture technician pisciculture bacteriological technologist plant breeding technician plant pathology technician plant pathology technologist poultry technician poultry technologist research technician, life sciences sea-farming technologist seed technologist soil bacteriological technician soil bacteriological technologist technician, dairy products technician, fisheries technician, microbiology (except medical) technician, wildlife technician, wildlife resources technologist, fisheries technologist, microbiology (except medical) technologist, wildlife vaccine technician virology technologist wildlife biology technician wildlife resources technician wildlife technician wildlife technologist zoo foreman/woman zoo supervisor zoological technician zoological technologist",
    "workers": 968.3333333,
    "minEduc": 1.333333333,
    "yearsStudy": 2.361409797,
    "automationRisk": 0.577,
    "salaryLow": 15,
    "salaryMed": 25,
    "salaryHigh": 38.78,
    "totalSkill": 178.6666667,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 24.43457773,
    "skillsComp": 45.33333333,
    "skillsLogi": 45.33333333,
    "skillsMath": 29.66666667,
    "skillsLang": 58.33333333,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 13.66666667,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 4.333333333,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 12.66666667,
    "s10Reading": 21.33333333,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 20.33333333,
    "s13DocumentUse": 18.33333333,
    "s14Writing": 18,
    "s15CriticalThinking": 7.333333333,
    "f1Science&Agriculture": 906.6666667,
    "f2Engineering": 23.33333333,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 5,
    "f8Education(teachertraining)": 0,
    "f9Law": 16.66666667,
    "f10Health": 8.333333333,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 606.6666667,
    "d2Forestry": 300,
    "d3Architecture&LandscapeArchitecture": 23.33333333,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 16.66666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 8.333333333,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 136,
    "noc": 2222,
    "job": "Agricultural and fish products inspectors",
    "title1": "agricultural products inspector animal health inspector animal primary products inspector assistant grain inspector bread inspector butter inspector cream inspector crop certification inspector dairy products inspector fish and fish products inspector fish inspector fish inspector-grader fish products inspector flour inspector food products inspector fruit and vegetables inspector fruit inspector grain inspection supervisor grain inspector inspector of perishable goods inspector, contagious animal diseases prevention inspector, fish and fish products inspector, fruit and vegetables inspector, grain inspector, livestock inspector, meat inspector, milk inspector, slaughtering and meat processing plant inspector-grader, fish livestock inspector meat hygiene inspector meat inspection supervisor meat inspector milk inspector plant primary products inspector plant protection inspector poultry inspector primary products inspector, animals produce inspector seed crop inspector seed grains inspector supervisor, agricultural products inspection supervisor, fish products inspection supervisor, fruit and vegetables inspection centre vegetable inspector",
    "title2": 0,
    "title3": 0,
    "allTitles": "agricultural products inspector animal health inspector animal primary products inspector assistant grain inspector bread inspector butter inspector cream inspector crop certification inspector dairy products inspector fish and fish products inspector fish inspector fish inspector-grader fish products inspector flour inspector food products inspector fruit and vegetables inspector fruit inspector grain inspection supervisor grain inspector inspector of perishable goods inspector, contagious animal diseases prevention inspector, fish and fish products inspector, fruit and vegetables inspector, grain inspector, livestock inspector, meat inspector, milk inspector, slaughtering and meat processing plant inspector-grader, fish livestock inspector meat hygiene inspector meat inspection supervisor meat inspector milk inspector plant primary products inspector plant protection inspector poultry inspector primary products inspector, animals produce inspector seed crop inspector seed grains inspector supervisor, agricultural products inspection supervisor, fish products inspection supervisor, fruit and vegetables inspection centre vegetable inspector",
    "workers": 968.3333333,
    "minEduc": 1.333333333,
    "yearsStudy": 2.361409797,
    "automationRisk": 0.577,
    "salaryLow": 18.45,
    "salaryMed": 33.08,
    "salaryHigh": 41.21,
    "totalSkill": 178.6666667,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 24.43457773,
    "skillsComp": 45.33333333,
    "skillsLogi": 45.33333333,
    "skillsMath": 29.66666667,
    "skillsLang": 58.33333333,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 13.66666667,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 4.333333333,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 12.66666667,
    "s10Reading": 21.33333333,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 20.33333333,
    "s13DocumentUse": 18.33333333,
    "s14Writing": 18,
    "s15CriticalThinking": 7.333333333,
    "f1Science&Agriculture": 906.6666667,
    "f2Engineering": 23.33333333,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 5,
    "f8Education(teachertraining)": 0,
    "f9Law": 16.66666667,
    "f10Health": 8.333333333,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 606.6666667,
    "d2Forestry": 300,
    "d3Architecture&LandscapeArchitecture": 23.33333333,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 16.66666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 8.333333333,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 137,
    "noc": 2223,
    "job": "Forestry technologists and technicians",
    "title1": "chief cruiser",
    "title2": "chief scaler",
    "title3": "conservation technician - forestry",
    "allTitles": "chief cruiserchief scalerconservation technician - forestrycrew leader - forest fire suppressioncruisercruising technician - forestryenforcement officer - forestryextension forest rangerextension ranger - forestryextension technician, forestryfield office supervisor - forestryfire crew leader - forestryfire suppression officer - forestryforest engineering technicianforest engineering technologistforest extension technicianforest firefighting crew leaderforest fire officerforest fire rangerforest fire technicianforest inventory resource officerforest planning technicianforest protection co-ordinatorforest regional inventory technicianforest research technologistforest resource management technicianforest resource technicianforestry conservation technicianforestry conservation technologistforestry crew co-ordinatorforestry extension technicianforestry technicianforestry technologistforest survey technicianforest technicianlog graderlog scalernatural resources technician - forestrynursery technician - forestryprotection co-ordinator - forestryrange conservationistrange managerresearch assistant - forestryresearch technician, forestry conservationresearch technologist, forestry conservationresource officer, forest inventoryresource technician - forestryscaler - forestryscalers supervisorscaler technician - loggingscaling co-ordinator - loggingsenior fire control techniciansilviculture techniciansilviculture technologistsilviculturistsupervisor, forestry technicianstechnician, forest engineeringtechnician, forest resource managementtechnician, forestrytechnician, forestry conservation and preservationtechnician, silviculturetechnologist, forest engineeringtechnologist, forestrytechnologist, forestry conservation and preservationtechnologist, silviculturetimber cruisertimber markertimber ridertimber scalertimber technician",
    "workers": 520,
    "minEduc": 2,
    "yearsStudy": 2.111111111,
    "automationRisk": 0.42,
    "salaryLow": 18.25,
    "salaryMed": 20.54,
    "salaryHigh": 25.07,
    "totalSkill": 201,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 20.54,
    "skillsComp": 46,
    "skillsLogi": 55,
    "skillsMath": 34,
    "skillsLang": 66,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 17,
    "s3FindingInformation": 12,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 9,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 18,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 15,
    "s14Writing": 20,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 520,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 520,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 138,
    "noc": 2224,
    "job": "Conservation and fishery officers",
    "title1": "conservation officer",
    "title2": "district inspector - fisheries",
    "title3": "district supervisor - fisheries",
    "allTitles": "conservation officerdistrict inspector - fisheriesdistrict supervisor - fisheriesdockside monitor - fisheriesdockside observer - fisheriesfish and game wardenfish and wildlife officerfisheries inspectorfisheries observerfisheries officerfishery officerfishing area supervisorforest ranger - wildlife managementgame officergame wardeninspector, fisheriesnatural resources officerobserver, fisheriesofficer, conservationofficer, fisheriesofficer, gamepark rangersupervisor, fisheries inspectorssupervisor, fisheries officers",
    "workers": 280,
    "minEduc": 0,
    "yearsStudy": 2.166666667,
    "automationRisk": 0.361,
    "salaryLow": 16.425,
    "salaryMed": 25.28,
    "salaryHigh": 33.765,
    "totalSkill": 146,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 30.2637332,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 230,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 50,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 230,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 50,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 139,
    "noc": 2225,
    "job": "Landscape and horticulture technicians and specialists",
    "title1": "arboriculturist",
    "title2": "arborist",
    "title3": "floriculturist",
    "allTitles": "arboriculturistarboristfloriculturistgardenergardener, landscapegolf course superintendentgreenskeepergreens superintendenthorticultural technicianhorticultural technologisthorticulture specialisthorticulture technicianhorticulture technologisthorticulturisthydroponics technicianinterior plantscape specialistirrigation technician (except agriculture)landscape architectural technicianlandscape architectural technologistlandscape designerlandscape gardenerlandscaperlandscape technicianlawn care specialistlawn care superintendentplant doctorplantscape techniciansuperintendent, greenstree and shrub specialisttree service technicianturfgrass management specialist",
    "workers": 2105,
    "minEduc": 2,
    "yearsStudy": 2.806451613,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 22.5,
    "salaryHigh": 30,
    "totalSkill": 189,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 22.5,
    "skillsComp": 51,
    "skillsLogi": 44,
    "skillsMath": 34,
    "skillsLang": 60,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 14,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 12,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 23,
    "s14Writing": 20,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 1970,
    "f2Engineering": 70,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 25,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1820,
    "d2Forestry": 150,
    "d3Architecture&LandscapeArchitecture": 70,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 140,
    "noc": 2231,
    "job": "Civil engineering technologists and technicians",
    "title1": "agricultural engineering technician",
    "title2": "air pollution field technician",
    "title3": "architectural and engineering technologists and technicians supervisor",
    "allTitles": "agricultural engineering technicianair pollution field technicianarchitectural and engineering technologists and technicians supervisorbridge design technicianbuilding materials techniciancivil engineering design technologistcivil engineering studies technologistcivil engineering techniciancivil engineering technologistconcrete technicianconstruction engineering technicianconstruction requirements writerconstruction specifications writerconstruction technicianconstruction technician - civil engineeringconstruction technologistdesign technologist, civil engineeringenvironmental technicianfield technician, air pollutionfoundation technologisthighway construction materials testing technicianhighway technicianhighway traffic technicianland use technicianmaterials testing technicianmaterials testing technologistmeasures technicianmunicipal engineering assistantnoise abatement techniciannoise reduction technicianpollution control technicianrailway technicianroad technicianroad traffic techniciansoil technologist - civil engineeringsoil testing technologistsoil testing technologist - civil engineeringsolid waste disposal technicianspecifications writer, constructionstructural design technologiststructural engineering technicianstructural investigatorsupervisor, architectural and engineering technologists and technicianstechnician, agricultural engineeringtechnician, bridge designtechnician, building materialstechnician, civil engineeringtechnician, concretetechnician, constructiontechnician, construction engineeringtechnician, environmentaltechnician, highwaytechnician, highway traffictechnician, materials testingtechnician, noise abatementtechnician, noise reductiontechnician, pollution controltechnician, railwaytechnician, road traffictechnician, solid waste disposaltechnician, structural engineeringtechnician, urban planningtechnician, water distribution systemstechnologist, civil engineeringtechnologist, civil engineering studiestechnologist, constructiontechnologist, materials testingtechnologist, soil testingtechnologist, structural designtechnologist, traffictesting technician, highway construction materialstraffic technician - civil engineeringtraffic technologisturban planning technicianwater distribution systems technician",
    "workers": 3335,
    "minEduc": 2,
    "yearsStudy": 2.865384615,
    "automationRisk": 0.75,
    "salaryLow": 14,
    "salaryMed": 30,
    "salaryHigh": 48.08,
    "totalSkill": 156,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 30,
    "skillsComp": 39,
    "skillsLogi": 32,
    "skillsMath": 28,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 11,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 7,
    "s10Reading": 33,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 3210,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 65,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 170,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 65,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 3040,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 141,
    "noc": 2232,
    "job": "Mechanical engineering technologists and technicians",
    "title1": "aeronautical technologist",
    "title2": "aerospace engineering technician",
    "title3": "aerospace engineering technologist",
    "allTitles": "aeronautical technologistaerospace engineering technicianaerospace engineering technologistautomation technologistcryonics engineering technologistdesigner, heatingdesigner, machinesdesigner, mechanical engineering equipmentdesigner, moulddesigner, tool and diedie designerengineering assistant, mechanical equipmentequipment development technicianheating designerheating, ventilation and air conditioning (HVAC) technologisthome automation technicianhouse automation technicianHVAC (heating, ventilation and air conditioning) systems specialistHVAC (heating, ventilation and air conditioning) technologistmachine designermachine tool designermarine engineering technician, mechanicalmarine engineering technologistmechanical engineering design technologistmechanical engineering development technologistmechanical engineering equipment designermechanical engineering technicianmechanical engineering technologistmechanical equipment engineering assistantmechanical marine engineering technicianmechanical technologistmould designernuclear engineering techniciannuclear engineering technologistnuclear technologistpower equipment design technicianrobotics servicing technicianrobotics systems installer and repairerrobotics systems installer and repairmanrobotics systems installer and repairwomanrobotics technicianrobotics technologistship repair technicianspecialist, HVAC (heating, ventilation and air conditioning) systemstechnical inspector, mechanicaltechnician, aerospace engineeringtechnician, mechanical engineeringtechnician, ship repairtechnologist, aerospace engineeringtechnologist, HVAC (heating, ventilation and air conditioning)technologist, marine engineeringtechnologist, mechanical engineeringtechnologist, nuclear engineeringthermal station techniciantool and die designertool designervibration technologistwind tunnel test technicianwind tunnel test technologist",
    "workers": 5110,
    "minEduc": 2,
    "yearsStudy": 2.3625,
    "automationRisk": 0.38,
    "salaryLow": 18.4,
    "salaryMed": 28,
    "salaryHigh": 51.75,
    "totalSkill": 182,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 28,
    "skillsComp": 46,
    "skillsLogi": 52,
    "skillsMath": 21,
    "skillsLang": 63,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 17,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 15,
    "s14Writing": 22,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 500,
    "f2Engineering": 3970,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 625,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 625,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 3970,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 500,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 142,
    "noc": 2233,
    "job": "Industrial engineering and manufacturing technologists and technicians",
    "title1": "3D CNC (computer numerical control) programmer",
    "title2": "CAD/CAM (computer-aided design/computer-assisted manufacturing) programmer",
    "title3": "CAD/CAM NC (computer-aided design/computer-aided manufacturing, numerical control) programmer",
    "allTitles": "3D CNC (computer numerical control) programmerCAD/CAM (computer-aided design/computer-assisted manufacturing) programmerCAD/CAM NC (computer-aided design/computer-aided manufacturing, numerical control) programmerCAD/CAM programmerCNC/CMM (computer numerically controlled coordinate measuring machine) programmerCNC (computer numerical control) Mastercam programmerCNC (computer numerical control) programmerCNC (computer numerically controlled) technologistcomputer-assisted design/computer-assisted manufacturing (CAD/CAM) programmercomputer numerical control (CNC) Mastercam programmercomputer numerically controlled coordinate measuring machine (CNC/CMM) programmercost estimator, manufacturingfabric design technologistfire protection technician - manufacturingindustrial engineering analystindustrial engineering technicianindustrial engineering technologistinjection moulding technicianinventory control technicianloss prevention technologist - manufacturingmanufacturing cost estimatormanufacturing technicianmanufacturing technician - industrial engineeringmanufacturing technologistmaterials handling technicianmethods designerNC (numerical control) programmernumerically controlled machine tool programmer (except operators)numerically controlled tool programmeroperations research technologistplanning technicianplant layout technicianplastics manufacturing technicianplastics moulding technicianplastics technicianproduction and quality control technologistproduction control technologistproduction planning technicianproduction technologist - sawmillprogrammer, CAD/CAM (computer-assisted design/computer-assisted manufacturing)programmer, CAD/CAM NC (computer-aided design/computer-aided manufacturing, numerical control)programmer, CNC/CMM (computer numerically controlled coordinate measuring machine)programmer, CNC (computer numerical control) Mastercamprogrammer, computer-aided design/computer-aided manufacturing, numerical control (CAD/CAM NC)programmer, computer-assisted design/computer-assisted manufacturing (CAD/CAM)programmer, computer numerical control (CNC) Mastercamprogrammer, computer numerically controlled coordinate measuring machine (CNC/CMM)pulp and paper manufacturing technologistpulp and paper technicianpulp and paper technologistquality assurance technologistquality control technician (except chemical)quality control technologist (except chemical)quality control technologist - industrial engineeringscheduling technician - manufacturingtechnician, industrial engineeringtechnician, manufacturingtechnician, planningtechnician, plasticstechnician, pulp and papertechnician, textiletechnologist, industrial engineeringtechnologist, manufacturingtechnologist, pulp and papertechnologist, quality control - industrial engineeringtechnologist, textiletextile techniciantextile technologisttime study analysttime study technologisttool programming technologist",
    "workers": 3280,
    "minEduc": 0,
    "yearsStudy": 2.654761905,
    "automationRisk": 0.03,
    "salaryLow": 17.8,
    "salaryMed": 25,
    "salaryHigh": 50.48,
    "totalSkill": 159,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 25,
    "skillsComp": 45,
    "skillsLogi": 30,
    "skillsMath": 15,
    "skillsLang": 69,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 9,
    "s10Reading": 29,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 22,
    "s14Writing": 17,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 150,
    "f2Engineering": 2110,
    "f3Humanities": 0,
    "f4SocialScience": 70,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 785,
    "f8Education(teachertraining)": 0,
    "f9Law": 10,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 50,
    "d4Humanities": 0,
    "d5SocialSciences": 70,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 785,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 2060,
    "d11Law": 10,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 130,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 143,
    "noc": 2234,
    "job": "Construction estimators",
    "title1": "building construction estimator",
    "title2": "certified construction estimator",
    "title3": "chief estimator - construction",
    "allTitles": "building construction estimatorcertified construction estimatorchief estimator - constructionconstruction cost consultantconstruction cost estimatorconstruction estimatorconsultant, construction costscontractors estimatorcost estimator - constructionelectrical and mechanical quantity surveyorelectrical estimator - constructionestimator, building constructionestimator, constructionestimator, construction costestimator, trade contractors - constructionjunior estimator - constructionmechanical estimator - constructionplumbing estimator - constructionprincipal estimator - constructionprofessional estimator - constructionprofessional quantity surveyorquantity surveyor - constructionquantity surveyor-estimatorsenior estimator - construction",
    "workers": 2350,
    "minEduc": 2,
    "yearsStudy": 2.411764706,
    "automationRisk": 0.57,
    "salaryLow": 20,
    "salaryMed": 32.69,
    "salaryHigh": 40.87,
    "totalSkill": 183,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 32.69,
    "skillsComp": 44,
    "skillsLogi": 46,
    "skillsMath": 34,
    "skillsLang": 59,
    "topSkill1": "Oral Communication",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 14,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 14,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 20,
    "f2Engineering": 1755,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 420,
    "f8Education(teachertraining)": 0,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 140,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 340,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 420,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1415,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 140,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 144,
    "noc": 2241,
    "job": "Electrical and electronics engineering technologists and technicians",
    "title1": "audio amplifier repairer - production",
    "title2": "audio amplifier repairman - production",
    "title3": "audio amplifier repairwoman - production",
    "allTitles": "audio amplifier repairer - productionaudio amplifier repairman - productionaudio amplifier repairwoman - productionbiomedical and laboratory equipment repairerbiomedical and laboratory equipment repairmanbiomedical and laboratory equipment repairwomanbiomedical engineering technologistcalibration testercircuit designer - railwaycommunications technologistcomputer communications techniciancomputer hardware technologistcomputer inspector-testercontrol panels testercontrol systems testerdesign technologist, electrical and electronicsdesign technologist, lines distributiondevelopment technologist - telecommunicationsdigital electronics techniciandistribution planning technologistelectrical and electronics design technologistelectrical and electronics quality control technologistelectrical engineering design technologistelectrical engineering technicianelectrical engineering technologistelectrical power supply system technicianelectrical power system planning technicianelectrical power system technicianelectrical technicianelectricity distribution network technologistelectromechanical technicianelectromedical equipment technicianelectronic components inspection technicianelectronic equipment maintenance technicianelectronic equipment repairer, hospitalelectronic equipment repairman, hospitalelectronic equipment repairwoman, hospitalelectronic prototype technologistelectronics design technologistelectronics engineering design technologistelectronics engineering technicianelectronics engineering technologistelectronics manufacturing technicianelectronics manufacturing technologistelectronics production support technicianelectronics quality control troubleshooterelectronics technicianelectronics technician, drilling rigselectronics technologist, physics departmentelectronic systems testerengineering technologist - electrical power distributionfibre optics technicianfibre optics technologistholographics technicianholographics technologisthome lighting technicianlaser technicianlighting technologistlines distribution design technologistmedical instruments repairermedical instruments repairmanmedical instruments repairwomanmedical laboratory equipment repairermedical laboratory equipment repairmanmedical laboratory equipment repairwomanmetering technologistmetrics technologistmetrology technicianmetrology technologistmicrowave maintenance technicianoptics technologistparamedical equipment repairerparamedical equipment repairmanparamedical equipment repairwomanphysical sciences laboratory technicianphysics department electronics technologistproduction repairer, electronicsproduction repairman, electronicsproduction repairwoman, electronicsproduction support technician, electronicsproduction support technician - electronics manufacturingprotection technologist - electrical power systemquality control technologist, electrical and electronicsquality control troubleshooter, electronicsradar systems technicianradar technicianradio frequency technologistrepairer - electronics productionrepairer, medical instrumentsrepairman - electronics productionrepairman, medical instrumentsrepairwoman - electronics productionrepairwoman, medical instrumentsresearch laboratory equipment repairerresearch laboratory equipment repairmanresearch laboratory equipment repairwomansatellite techniciansatellite technologistsatellite verification technologistsonar technician",
    "workers": 11370,
    "minEduc": 0,
    "yearsStudy": 2.598290598,
    "automationRisk": 0.84,
    "salaryLow": 16,
    "salaryMed": 28.85,
    "salaryHigh": 51,
    "totalSkill": 127,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 28.85,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 210,
    "f2Engineering": 9830,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 225,
    "f7Arts&Education": 810,
    "f8Education(teachertraining)": 0,
    "f9Law": 75,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 10,
    "f12Business": 145,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 40,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 225,
    "d8OtherArts&Science": 810,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 9790,
    "d11Law": 75,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 210,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 10,
    "d18Business&Commerce": 145,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 145,
    "noc": 2242,
    "job": "Electronic service technicians (household and business equipment)",
    "title1": "alarm systems installer",
    "title2": "alarm system technician",
    "title3": "amplifier repairer",
    "allTitles": "alarm systems installeralarm system technicianamplifier repaireramplifier repairmanamplifier repairwomanaudio stereo technicianaudio-video repair technicianaudio-video service technicianaudiovisual (AV) equipment installer and repaireraudiovisual (AV) equipment installer and repairmanaudiovisual (AV) equipment installer and repairwomanaudiovisual (AV) equipment repair supervisorautomatic teller machine (ATM) servicerbusiness machine servicerclosed circuit television installercomputer equipment installercomputer equipment repairercomputer equipment repairmancomputer equipment repairwomancomputer equipment technician - household and business equipmentcomputer field service techniciancomputer repair techniciancomputer service technicianelectronic cash registers servicerelectronic equipment installation and repair supervisorelectronic equipment repairerelectronic equipment repairmanelectronic equipment repairwomanelectronic games repairerelectronic games repairmanelectronic games repairwomanelectronic games technicianelectronic music equipment installer and repairerelectronic music equipment installer and repairmanelectronic music equipment installer and repairwomanelectronic organ repairerelectronic organ repairmanelectronic organ repairwomanelectronic products field service technicianelectronic service technician apprenticeelectronic service technician supervisorelectronics technician - consumer productselectronics technician, fire alarmselectronics technician - household and business equipmentfield service technician, electronic productsfield service technician - household and business equipmentfire alarm electronics technicianfire alarm systems installer and servicerhearing aid repairerhearing aid repairmanhearing aid repairwomanhousehold and business equipment technicianinstaller and repairer, electronic music equipmentinstaller and repairer - household and business equipmentinstaller and repairer, public address (P.A.) systemsinstaller and repairman, electronic music equipmentinstaller and repairman - household and business equipmentinstaller and repairman, public address (P.A.) systemsinstaller and repairwoman, electronic music equipmentinstaller and repairwoman - household and business equipmentinstaller and repairwoman, public address (P.A.) systemsinstaller and servicer, fire alarm systemsinstaller, security alarmsoffice equipment service technicianoffice machine repaireroffice machine repairmanoffice machine repairwomanphotocopier repairerphotocopier repairmanphotocopier repairwomanphotocopier servicerphotocopy machine technicianphotoelectric sorting machine repairerphotoelectric sorting machine repairmanphotoelectric sorting machine repairwomanpublic address (P.A.) system installer and repairerpublic address (P.A.) system installer and repairmanpublic address (P.A.) system installer and repairwomanradio and television service technicianradio and television service technician apprenticeradio communication equipment repairerradio communication equipment repairmanradio communication equipment repairwomanradio installation and repair technicianradio maintenance technicianradio repairerradio repairmanradio repair supervisorradio repairwomanrepairer, amplifiersrepairer, electronic equipmentrepairer, electronic gamesrepairer, electronic organsrepairer, hearing aidrepairer, photocopiersrepairer, radio communication equipmentrepairer, radiosrepairer, video cassette recordersrepairman, amplifiersrepairman, electronic equipment",
    "workers": 10005,
    "minEduc": 2,
    "yearsStudy": 2.440993789,
    "automationRisk": 0.41,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 43,
    "totalSkill": 144,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 21,
    "skillsComp": 59,
    "skillsLogi": 31,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 7,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 35,
    "s13DocumentUse": 15,
    "s14Writing": 11,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 1645,
    "f2Engineering": 5300,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 160,
    "f6MathAndComputerScience": 2010,
    "f7Arts&Education": 400,
    "f8Education(teachertraining)": 0,
    "f9Law": 120,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 330,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 10,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 160,
    "d7ComputerScience": 2000,
    "d8OtherArts&Science": 400,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 5290,
    "d11Law": 120,
    "d12Mathematics": 10,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 1645,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 330,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 146,
    "noc": 2243,
    "job": "Industrial instrument technicians and mechanics",
    "title1": "apprentice industrial instrument mechanic",
    "title2": "apprentice instrument mechanic",
    "title3": "control technician, nuclear generating station and heavy water plant",
    "allTitles": "apprentice industrial instrument mechanicapprentice instrument mechaniccontrol technician, nuclear generating station and heavy water plantheavy water plant control technicianindustrial instrument mechanicindustrial instrument panel repairerindustrial instrument panel repairmanindustrial instrument panel repairwomanindustrial instrument technicianindustrial process control equipment repairerindustrial process control equipment repairmanindustrial process control equipment repairwomaninstrumentation and electrical technician, industrialinstrumentation technician, industrialinstrument maintenance mechanicinstrument mechanic - utilitiesinstrument technician, industrialmechanic, industrial instrumentnuclear generating station and heavy water plant control techniciannucleonic controller repairernucleonic controller repairmannucleonic controller repairwomanprecision instrument mechanicprocess control equipment mechanicprocess control equipment repairerprocess control equipment repairmanprocess control equipment repairwomanrepairer, industrial process control equipmentrepairer, nucleonic controllersrepairman, industrial process control equipmentrepairman, nucleonic controllersrepairwoman, industrial process control equipmentrepairwoman, nucleonic controllersservice technician, industrial instrumentsservice technician, process control equipmenttechnician, industrial instruments",
    "workers": 565,
    "minEduc": 2,
    "yearsStudy": 1.857142857,
    "automationRisk": 0.67,
    "salaryLow": 23,
    "salaryMed": 33,
    "salaryHigh": 51,
    "totalSkill": 164,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 33,
    "skillsComp": 66,
    "skillsLogi": 37,
    "skillsMath": 14,
    "skillsLang": 47,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 7,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 45,
    "s13DocumentUse": 15,
    "s14Writing": 12,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 565,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 565,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 147,
    "noc": 2251,
    "job": "Architectural technologists and technicians",
    "title1": "architectural assistant architectural design technician architectural design technologist architectural technician architectural technologist assistant, architectural registered building technician registered building technologist residential buildings technologist technician, architectural technologist, architectural technologist, residential buildings",
    "title2": 0,
    "title3": 0,
    "allTitles": "architectural assistant architectural design technician architectural design technologist architectural technician architectural technologist assistant, architectural registered building technician registered building technologist residential buildings technologist technician, architectural technologist, architectural technologist, residential buildings",
    "workers": 1941.25,
    "minEduc": 1.5,
    "yearsStudy": 2.699081197,
    "automationRisk": 0.5205,
    "salaryLow": 17.79,
    "salaryMed": 25,
    "salaryHigh": 43.96,
    "totalSkill": 153.25,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 26.00547851,
    "skillsComp": 46,
    "skillsLogi": 38,
    "skillsMath": 25.5,
    "skillsLang": 43.5,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.75,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 2.25,
    "s5MeasurementandCalculation": 12.75,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 14.75,
    "s9ProblemSolving": 11.5,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 5.75,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 19.25,
    "s14Writing": 10.5,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 46.25,
    "f2Engineering": 1337.5,
    "f3Humanities": 0,
    "f4SocialScience": 263.75,
    "f5FineArts": 252.5,
    "f6MathAndComputerScience": 2.5,
    "f7Arts&Education": 23.75,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 380,
    "d4Humanities": 0,
    "d5SocialSciences": 263.75,
    "d6Fine&AppliedArts": 252.5,
    "d7ComputerScience": 2.5,
    "d8OtherArts&Science": 23.75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 957.5,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 16.25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 148,
    "noc": 2252,
    "job": "Industrial designers",
    "title1": "business products designer",
    "title2": "consumer products designer",
    "title3": "container designer",
    "allTitles": "business products designerconsumer products designercontainer designerdesigner, furnituredesigner, industrialdesigner, industrial productsergonomic products designerfixture designerfurniture designerindustrial design consultantindustrial designerindustrial products designerproduct designertoy designer - industrial design",
    "workers": 1295,
    "minEduc": 0,
    "yearsStudy": 2.96,
    "automationRisk": 0.037,
    "salaryLow": 17,
    "salaryMed": 29.81,
    "salaryHigh": 48.08,
    "totalSkill": 162,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 29.81,
    "skillsComp": 44,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 405,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 840,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 70,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 840,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 335,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 149,
    "noc": 2253,
    "job": "Drafting technologists and technicians",
    "title1": "aeronautical draftsperson",
    "title2": "air conditioning systems draftsperson",
    "title3": "architectural draftsperson",
    "allTitles": "aeronautical draftspersonair conditioning systems draftspersonarchitectural draftspersonCAD (computer-aided design) specialist - draftingCAD (computer-aided design) technologistCAD (computer-assisted drafting)CAD (computer-assisted drafting) draftsman - printed circuit boardsCAD (computer-assisted drafting) draftsperson - printed circuit boardsCAD (computer-assisted drafting) draftswoman - printed circuit boardsCAD (computer-assisted drafting) technicianCAD operatorchecker, draftingchief draftspersoncivil draftspersoncommercial draftspersoncomputer-aided design (CAD) specialist - draftingcomputer-aided design (CAD) technologistcomputer-aided drafting (CAD) techniciancomputer-assisted design and drafting technologistcomputer-assisted drafting (CAD) techniciancomputer-assisted electromechanical design draftspersondesign and drafting technologistdesign checker, draftingdesign draftspersondesign technician, draftingdesign technologist - draftingdetail draftspersondetailerdetailer - structural steel drafterdrafterdrafting checkerdrafting clerkdrafting supervisordrafting techniciandrafting technician, designdrafting technologistdrafting tracerdraftsmandraftsman - computer-assisted designdraftsman hull - shipbuilding and repairdraftsman/womandraftspersondraftsperson, air conditioning systemsdraftsperson, architecturaldraftsperson, civildraftsperson - computer-assisted designdraftsperson, electricaldraftsperson hull - shipbuilding and repairdraftsperson, process pipingdraftspersons supervisordraftswomandraftswoman - computer-assisted designdraftswoman hull - shipbuilding and repairelectrical drafting supervisorelectrical draftspersonelectromechanical draftspersonelectronic draftspersonengineering design and drafting technologistengineering draftspersongeneral draftspersongeological draftspersongeophysical draftspersongroup leader, draftingheating and ventilation systems draftspersonheating systems draftspersonhull draftsman - shipbuilding and repairhull draftsperson - shipbuilding and repairhull draftswoman - shipbuilding and repairhydraulic machinery draftspersonillustrator, technical - draftingmarine drafting supervisormarine draftsperson, electricalmechanical building draftspersonmechanical design draftspersonmechanical draftspersonmine draftspersonmunicipal draftspersonoptical draftspersonpetroleum exploration draftspersonpiping draftspersonprocess piping draftspersonrefrigeration systems draftspersonshipbuilding draftspersonship detail draftspersonsteel detailer - draftingsteel frame draftsmansteel frame draftsman/womansteel frame draftspersonsteel frame draftswomanstructural draftspersonstructural steel detailerstructural steel drafter-detailerstructural steel draftspersonsupervisor, draftingsupervisor, drafting officesurvey draftspersontechnical illustrator - draftingtechnologist, CAD (computer-aided design)technologist, computer-aided design (CAD)tool checker - drafting",
    "workers": 5065,
    "minEduc": 2,
    "yearsStudy": 2.855555556,
    "automationRisk": 0.67,
    "salaryLow": 14,
    "salaryMed": 25,
    "salaryHigh": 49.45,
    "totalSkill": 156,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 25,
    "skillsComp": 44,
    "skillsLogi": 39,
    "skillsMath": 26,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 16,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 11,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 20,
    "s14Writing": 11,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 20,
    "f2Engineering": 4760,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 170,
    "f6MathAndComputerScience": 10,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 1450,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 170,
    "d7ComputerScience": 10,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 3310,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 150,
    "noc": 2254,
    "job": "Land survey technologists and technicians",
    "title1": "engineering survey technician",
    "title2": "engineering survey technologist",
    "title3": "geodetic survey technician",
    "allTitles": "engineering survey technicianengineering survey technologistgeodetic survey techniciangeodetic survey technologistgeomatics technician - land surveyinggeomatics technologist - land surveyinginstrument man - surveyinginstrument man/woman - surveyinginstrument woman - surveyingland survey technicianland survey technologistlegal survey assistantlegal survey technicianlegal survey technologistplane table operator - surveyingtechnician, geomatics - land surveyingtechnician, land surveytechnician, topographic surveytechnologist, geomatics - land surveyingtechnologist, land surveytechnologist, topographic surveytopographic survey techniciantopographic survey technologisttransit man - surveyingtransit man/woman - surveyingtransit operator - surveyingtransit woman - surveying",
    "workers": 135,
    "minEduc": 2,
    "yearsStudy": 1.75,
    "automationRisk": 0.96,
    "salaryLow": 15.9475,
    "salaryMed": 27.1325,
    "salaryHigh": 44.1225,
    "totalSkill": 149,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 20.49191402,
    "skillsComp": 46,
    "skillsLogi": 44,
    "skillsMath": 24,
    "skillsLang": 35,
    "topSkill1": "Digital Technology",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 15,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 15,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 21,
    "s14Writing": 4,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 135,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 135,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 151,
    "noc": 2255,
    "job": "Technical occupations in geomatics and meteorology",
    "title1": "aerial photograph analyst",
    "title2": "aerial photograph interpreter",
    "title3": "aerial photograph technician",
    "allTitles": "aerial photograph analystaerial photograph interpreteraerial photograph technicianaerial survey technicianaerial survey technologistaerological observeraerological technicianairborne data acquisition specialistavalanche controlleravalanche observercartographercartographic compilercartographic draftsmancartographic draftsman/womancartographic draftswomancartographic techniciancartographic technologistclimate data processorclimate service technicianclimatological techniciancontroller, avalanchedraftsman, cartographicdraftsman, mapdraftsman/woman, mapdraftswoman, mapeditor, mapsgeographic information systems (GIS) techniciangeographic information systems (GIS) technologistgeological information system techniciangeological information system technologistgeological mapping techniciangeomatics technician - aerial surveysgeomatics technician - cartographygeomatics technician - geographical information systems (GIS)geomatics technician - photogrammetrygeomatics technician - remote sensinggeomatics technologist - aerial surveysgeomatics technologist - cartographygeomatics technologist - geographical information systemsgeomatics technologist - photogrammetrygeomatics technologist - remote sensingGIS (geographic information systems) technologistGIS (geographic information system) technicianice conditions service specialist - meteorologyice observerland information system (LIS) technicianland information system (LIS) technologistLIS (land information system) technicianLIS (land information system) technologistmap draftsmanmap draftsman/womanmap draftswomanmap editormapping technicianmeteorological aidemeteorological inspectormeteorological technicianobserver, surface weatherofficer-in-charge, weather stationoperations technician, weather stationphoto cartographerphotogrammetric technicianphotogrammetric technologistphotogrammetristremote sensing (RS) application specialistremote sensing (RS) technicianremote sensing (RS) technologistRS (remote sensing) application specialistRS (remote sensing) technicianRS (remote sensing) technologistsnow controllersoftcopy photogrammetristspecialist, remote sensing (RS) applicationspecialist, RS (remote sensing) applicationsurface weather observertechnician, geographic information systems (GIS)technician, geological information systemtechnician, geological mappingtechnician, geomatics - aerial surveystechnician, geomatics - cartographytechnician, geomatics - geographical information systems (GIS)technician, geomatics - photogrammetrytechnician, geomatics - remote sensingtechnician, GIS (geographic information system)technician, land information system (LIS)technician, LIS (land information system)technician, photogrammetrictechnician, remote sensing (RS)technician, RS (remote sensing)technologist, geographic information systems (GIS)technologist, geological information systemtechnologist, geomatics - aerial surveystechnologist, geomatics - cartographytechnologist, geomatics - geographical information systemstechnologist, geomatics - photogrammetrytechnologist, geomatics - remote sensingtechnologist, GIS (geographic information systems)technologist, land information system (LIS)technologist, LIS (land information system)technologist, photogrammetric",
    "workers": 1270,
    "minEduc": 2,
    "yearsStudy": 3.230769231,
    "automationRisk": 0.415,
    "salaryLow": 15,
    "salaryMed": 28.72,
    "salaryHigh": 35,
    "totalSkill": 146,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 28.72,
    "skillsComp": 50,
    "skillsLogi": 29,
    "skillsMath": 30,
    "skillsLang": 37,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 10,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 10,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 19,
    "s14Writing": 10,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 165,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 1035,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 20,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 120,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 1035,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 20,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 152,
    "noc": 2261,
    "job": "Non-destructive testers and inspection technicians",
    "title1": "acoustic emission technician",
    "title2": "acoustic emission tester",
    "title3": "aircraft non-destructive inspection technician",
    "allTitles": "acoustic emission technicianacoustic emission testeraircraft non-destructive inspection technicianblack light technician - non-destructive testingboiler testerdye penetrant techniciandye penetrant testereddy current technicianeddy current testerfluorescent penetrant testing technicianfluoroscope testerforging testerhydrostatic testerindustrial radiographerindustrial radiographer - radiotelephonyinfrared technicianinfrared testerinfrared thermographerinfrared thermography technicianliquid penetrant technician - non-destructive testingliquid penetrant testing technicianmagnetic particle technicianmagnetic particle testermagnetic particle testing technicianmaintenance technician - non-destructive testing (NDT)NDT (non-destructive testing) maintenance techniciannon-destructive examination techniciannon-destructive examinernon-destructive inspection techniciannon-destructive inspection testernon-destructive inspectornon-destructive testernon-destructive testing maintenance (NDT) techniciannon-destructive testing traineenon-destructive test technicianpipeline testing technician - non-destructive testingpipe tester - non-destructive testingpressure tank testerpressure vessel testerqualified operator, non-destructive testingradiographer, industrialradiographic technician - non-destructive testingradiographic testerreflectoscope testertechnician, NDT (non-destructive testing) maintenancetechnician, non-destructive examinationstechnician, non-destructive inspectiontester, boilertester, non-destructive inspectiontesting technician, fluorescent penetranttesting technician, ultraviolet lightthermographer-testertrainee, non-destructive testingultrasonic immersion testerultrasonic technician - non-destructive testingultrasonic testerultrasonic testing technicianultraviolet light testing technicianvibration analysis technician - non-destructive testingvisual inspection technician - weldingweld tester",
    "workers": 370,
    "minEduc": 2,
    "yearsStudy": 1.533333333,
    "automationRisk": 0.795,
    "salaryLow": 17.09,
    "salaryMed": 26,
    "salaryHigh": 40.81,
    "totalSkill": 133,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 26,
    "skillsComp": 35,
    "skillsLogi": 29,
    "skillsMath": 16,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Writing",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 8,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 270,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 100,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 100,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 270,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 153,
    "noc": 2262,
    "job": "Engineering inspectors and regulatory officers",
    "title1": "air carrier maintenance inspector",
    "title2": "air transport inspector",
    "title3": "airworthiness inspector",
    "allTitles": "air carrier maintenance inspectorair transport inspectorairworthiness inspectorammunition safety inspectorboiler and machinery inspectorboiler inspectorbroadcast interference inspectorcargo surveyorconsumer affairs inspectorcrane inspectorelectricity and gas meter inspectorelevator inspectorengineering department inspectorengineering department inspector - local governmentengineering inspectorescalator inspectorflight operations inspectorfreight car inspectorinspector, air carrier maintenanceinspector, air transportinspector, electricity and gas metersinspector, engineering departmentinspector, weights and measuresinsurance loss prevention inspectorlifting gear inspectorloss prevention inspector - insurancemarine cargo surveyormarine damage surveyormarine surveyormotor transportation inspectormotor transportation regulations officermotor vehicle defects investigatormotor vehicle inspectorpipeline equipment inspectorpipeline inspectorquality assurance officerradio interference investigatorrailway accident investigation officerrailway inspectorregulatory officer, engineeringroad safety inspectorship inspectorsurveyor, cargosurveyor, marine cargotensile strength inspectorweights and measures inspector",
    "workers": 265,
    "minEduc": 2,
    "yearsStudy": 2.7,
    "automationRisk": 0.61,
    "salaryLow": 21,
    "salaryMed": 43.27,
    "salaryHigh": 56.41,
    "totalSkill": 131,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 43.27,
    "skillsComp": 38,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 43,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 6,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 19,
    "s14Writing": 10,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 30,
    "f2Engineering": 160,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 75,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 160,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 154,
    "noc": 2263,
    "job": "Inspectors in public and environmental health and occupational health and safety",
    "title1": "beauty salon inspector",
    "title2": "dangerous goods inspector - railway transport",
    "title3": "dangerous waste inspector",
    "allTitles": "beauty salon inspectordangerous goods inspector - railway transportdangerous waste inspectorenforcement officer - environmental healthenvironmental health and safety technicianenvironmental health and safety technologistenvironmental health inspectorenvironmental health inspectors supervisorenvironmental health officerenvironmental health officers supervisorenvironmental officerexaminer, minesfield supervisor - occupational health and safetyflood damage inspectorfood inspectorhazardous waste inspectorhazardous waste inspector - environmental healthhazardous waste management technologisthealth and safety inspectorhealth and safety officerhealth and safety technicianhealth and safety technologisthealth officers supervisorhealth standards inspectorhotel and restaurant inspector - public healthindustrial health officerindustrial hygiene inspectorindustrial safety officer - occupational health and safetyindustrial waste control inspectorinspector, dangerous wasteinspector, environmental healthinspector, flood damagesinspector, hazardous wasteinspector, hazardous waste - environmental healthinspector, health standardsinspector, hotels and restaurants - public healthinspector, industrial hygieneinspector, industrial waste controlinspector, nursing homesinspector, occupational health and safetyinspector, occupational hygieneinspector, occupational safetyinspector, pollution controlinspector, public healthinspector, sanitary department - environmental healthinspector, sanitary standardsinspector, sewage disposal - environmental healthinspector, waterlabour affairs officer - occupational health and safetylabour standards officerlabour standards officer - occupational health and safetymine examinermine safety inspectornursing home inspectoroccupational health and safety officeroccupational health inspectoroccupational health officeroccupational health supervisoroccupational hygiene inspectoroccupational hygiene technicianoccupational hygienist technologistoccupational safety inspectoroccupational safety officerofficer, environmental healthofficer, health and safetyofficer, industrial healthofficer, labour standardsofficer, occupational healthofficer, occupational health and safetyofficer, occupational safetyofficer, safety and healthpollution control inspectorpublic health inspectorpublic health inspectors supervisorpublic health safety inspectorpublic health unit supervisorquarantine officer - public healthradiation monitorrestaurant inspectorrestaurant inspector - public healthrodent control inspectorrodent control officersafety and sanitary inspector - public and environmental healthsafety inspector, minessafety officersafety practitionersanitary department inspector - environmental healthsanitary standards inspectorsewage disposal inspector - environmental healthsupervisor, health officerssupervisor, occupational healthsupervisor, public health inspectorswaste water treatment plant inspectorwater inspectorwelfare institute inspector - public health",
    "workers": 3635,
    "minEduc": 0,
    "yearsStudy": 3.189473684,
    "automationRisk": 0.08,
    "salaryLow": 20,
    "salaryMed": 37.09,
    "salaryHigh": 48.21,
    "totalSkill": 163,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 37.09,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 505,
    "f2Engineering": 745,
    "f3Humanities": 0,
    "f4SocialScience": 240,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 300,
    "f8Education(teachertraining)": 40,
    "f9Law": 150,
    "f10Health": 55,
    "f11Health,Nursing&ClinicalLaboratory": 1190,
    "f12Business": 390,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 200,
    "d2Forestry": 290,
    "d3Architecture&LandscapeArchitecture": 25,
    "d4Humanities": 0,
    "d5SocialSciences": 240,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 300,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 720,
    "d11Law": 150,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 55,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1190,
    "d18Business&Commerce": 390,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 155,
    "noc": 2264,
    "job": "Construction inspectors",
    "title1": "boiler installation inspector",
    "title2": "bridge and building inspector",
    "title3": "bridge inspector",
    "allTitles": "boiler installation inspectorbridge and building inspectorbridge inspectorbridge inspector - construction and maintenancebuilding construction inspectorbuilding inspectorbuilding inspector - electrical wiringbuilding inspector - structurebuilding safety inspectorCanada Mortgage and Housing Corporation (CMHC) inspectorcarpentry inspectorclosed circuit TV sewer inspectorCMHC (Canada Mortgage and Housing Corporation) inspectorcompliance inspector - buildingsconstruction field inspectorconstruction inspectorconstruction inspector and testerconstruction safety officerdam construction inspectorditch construction inspectorelectrical energy installation inspectorelectrical inspector - constructionelectrical installation inspectorelectrical safety inspectorelectrical wiring inspector - constructionflood damage inspector - construction sitesforeman, building construction inspectorsforeman, highway construction inspectorsforeman, pipeline construction inspectorforeman, pipeline inspectorsforeman/woman, building construction inspectorsforeman/woman, highway construction inspectorsforeman/woman, pipeline construction inspectorforeman/woman, pipeline inspectorsforewoman, building construction inspectorsforewoman, highway construction inspectorsforewoman, pipeline construction inspectorforewoman, pipeline inspectorshighway construction inspectorhome construction inspectorhome inspectorhousing construction inspectorhousing rehabilitation inspectorindustrial construction safety inspectorindustrial electric installation inspectorinspector and tester, constructioninspector, boiler installationinspector, bridgesinspector, bridges and buildingsinspector, bridges - construction and maintenanceinspector, building constructioninspector, buildingsinspector, building safetyinspector, buildings - electrical wiringinspector, buildings - structureinspector, Canada Mortgage and Housing Corporation (CMHC)inspector, CMHC (Canada Mortgage and Housing Corporation)inspector, compliance - buildingsinspector, constructioninspector, construction fieldsinspector, dam constructioninspector, ditch constructioninspector, electrical energy installationinspector, electrical installationinspector, electrical safetyinspector, electrical wiring - constructioninspector, highway constructioninspector, home constructioninspector, homesinspector, housing constructioninspector, housing rehabilitationinspector, industrial construction safetyinspector, industrial electric installationsinspector, irrigation - constructioninspector, maintenance - constructioninspector, masonryinspector, mine constructioninspector, pipeline constructioninspector, plumbinginspector, pre-stressed concreteinspector, public works - constructioninspector, refinery equipmentinspector, reinforced concreteinspector, road constructioninspector, road gradinginspector, road pavinginspector, sewer constructioninspector, structural ironworkinspector, structural steelinspector, tunnel constructioninspector, waterworks constructioninspector, wiring - domestic installationinspector, wiring - industrial installationirrigation inspector - constructionmaintenance inspector - constructionmasonry inspectormine construction inspectormine inspector, constructionpipeline construction inspectorplumbing inspector",
    "workers": 2015,
    "minEduc": 2,
    "yearsStudy": 2.24,
    "automationRisk": 0.63,
    "salaryLow": 19.36333333,
    "salaryMed": 35.45333333,
    "salaryHigh": 48.47666667,
    "totalSkill": 121,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 26.24170822,
    "skillsComp": 32,
    "skillsLogi": 31,
    "skillsMath": 15,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 6,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 45,
    "f2Engineering": 1285,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 650,
    "f8Education(teachertraining)": 0,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 385,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 650,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 900,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 156,
    "noc": 2271,
    "job": "Air pilots, flight engineers and flying instructors",
    "title1": "aerial crop duster",
    "title2": "aerial sprayer",
    "title3": "aerial survey flight supervisor",
    "allTitles": "aerial crop dusteraerial sprayeraerial survey flight supervisoraerial survey pilotairline pilotairline pilot instructorairline test pilotair navigatorair patrol pilotair pilotair pilots and navigators supervisorairplane pilotbush pilotbusiness aircraft pilotcaptain - air transportcharter pilotcheck pilotchief flying instructorchief pilotchief pilot - air transportchief pilot, helicoptercommercial airline pilotcommercial pilotco-pilotco-pilot - air transportcorporate pilotcrop dusterengineering test pilotexecutive pilotexperimental test pilotfire patrol pilotfirst officer - air transportflight engineerflight engineer - air transportflight instructorflight simulator instructorflying instructorforestry patrol pilotforest spray pilothelicopter flight instructorhelicopter pilotmapping pilotnavigator - air transportpilot, airlinepilot - air transportpilot instructorpilot, remote sensingpipeline air patrol pilotpower line air patrol pilotrelief pilotremote sensing pilotsecond officer - air transportspray pilotsupervisor, air pilots and flight engineerssurvey pilottest pilottopographic survey pilotwater bomber pilot",
    "workers": 3280,
    "minEduc": 2,
    "yearsStudy": 3.044444444,
    "automationRisk": 0.18,
    "salaryLow": 19.46666667,
    "salaryMed": 35.33333333,
    "salaryHigh": 45.49666667,
    "totalSkill": 159,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 38.23015169,
    "skillsComp": 56,
    "skillsLogi": 43,
    "skillsMath": 15,
    "skillsLang": 45,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 32,
    "s14Writing": 11,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 215,
    "f2Engineering": 195,
    "f3Humanities": 0,
    "f4SocialScience": 180,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 2630,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 180,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 2630,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 195,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 215,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 157,
    "noc": 2272,
    "job": "Air traffic controllers and related occupations",
    "title1": "airline dispatcher",
    "title2": "airport air traffic controller",
    "title3": "air traffic control assistant",
    "allTitles": "airline dispatcherairport air traffic controllerair traffic control assistantair traffic control chiefair traffic controller, airportair traffic controller (ATC)air traffic controller, enrouteair traffic controller, terminalair traffic control officerair traffic co-ordinatorassistant, air traffic controlATC (air traffic controller)chief air traffic controllercontroller, air trafficdispatcher, flightsenroute air traffic controllerflight dispatch assistantflight dispatcherflight operations officerflight service specialist (FSS)head air traffic controllerinstrument flight rules air traffic controllerofficer, air traffic controlterminal air traffic controllertower controller - air trafficvisual flight rules air traffic controller",
    "workers": 280,
    "minEduc": 2,
    "yearsStudy": 1.666666667,
    "automationRisk": 0.11,
    "salaryLow": 19.46666667,
    "salaryMed": 35.33333333,
    "salaryHigh": 45.49666667,
    "totalSkill": 143,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 35.58626804,
    "skillsComp": 39,
    "skillsLogi": 42,
    "skillsMath": 21,
    "skillsLang": 41,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Critical Thinking",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 11,
    "s10Reading": 13,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 23,
    "s14Writing": 8,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 280,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 280,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 158,
    "noc": 2273,
    "job": "Deck officers, water transport",
    "title1": "apprentice master - minor waters",
    "title2": "captain, ferryboat",
    "title3": "captain, offshore rig",
    "allTitles": "apprentice master - minor waterscaptain, ferryboatcaptain, offshore rigcaptain, passenger shipcaptain, self-propelled bargecaptain, self-propelled drilling rigcaptain, shipcaptain - water transportchief officer, Coast Guard vesselchief officer, shipchief officer, ship operationsCoast Guard vessel commanding officerCoast Guard vessel first watchkeeping officerCoast Guard vessel navigation officerCoast Guard vessel second officerCoast Guard vessel second watchkeeping officerCoast Guard vessel third officerCoast Guard vessel third watchkeeping officercommanding officer, Coast Guard vesselcommanding officer, dredgecommanding officer, offshore rigcommanding officer - water transportdeck officerdeck officer - cadetdeck officer, self-propelled bargedeck officer, self-propelled oil rigdeck officer - water transportdredge captaindredge commanding officerdredge mateferryboat captainferryboat first mateferryboat masterferryboat operatorfirst mate, ferryboatfirst mate, foreign-goingfirst mate, home tradefirst mate - inland watersfirst mate, offshore drilling rigfirst mate, self-propelled drilling rigfirst mate, shipfirst watchkeeping officer, Coast Guard vesselforeign-going first mateforeign-going second mateharbour pilothome trade first matehome trade masterhome trade second matehovercraft masterinland navigation matejunior mate, shiplaunchmanlaunchman/womanlaunchwomanmaster, dredgemaster, ferryboatmaster, hovercraftmaster - inland watersmaster marinermaster - minor watersmaster, self-propelled drilling rigmaster, shipmaster - water transportmate, home trademate, inland navigationmate, merchant navymate, self-propelled drilling rigmate, shipmate - water transportmerchant navy matenavigation officer, Coast Guard vesselnavigation officer - water transportofficer, deckofficer, deck - water transportofficer, navigation - water transportoffshore drilling rig first mateoffshore rig captainoffshore rig commanding officerpassenger ship captainpilot, harbourpilot, shippilot - water transportriverboat captainriver pilotsecond deck officersecond matesecond mate, foreign-goingsecond mate, home tradesecond mate - inland waterssecond mate, shipsecond officer, Coast Guard vesselsecond watchkeeping officer, Coast Guard vesselself-propelled barge captainself-propelled barge deck officerself-propelled drilling rig captainself-propelled drilling rig first mateself-propelled drilling rig mateself-propelled oil rig deck officership first mateship master",
    "workers": 220,
    "minEduc": 0,
    "yearsStudy": 2.166666667,
    "automationRisk": 0.27,
    "salaryLow": 15.63,
    "salaryMed": 31.81,
    "salaryHigh": 37.7,
    "totalSkill": 153,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 31.81,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 220,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 220,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 159,
    "noc": 2274,
    "job": "Engineer officers, water transport",
    "title1": "apprentice marine engineer officer",
    "title2": "assistant engineer - water transport",
    "title3": "chief engineer, Coast Guard vessel",
    "allTitles": "apprentice marine engineer officerassistant engineer - water transportchief engineer, Coast Guard vesselchief engineer, fishing vesselchief engineer, mobile platform - offshore drillingchief engineer, self-propelled drilling rigchief engineer - water transportchief marine engineer, factory freezer trawlerchief marine engineer - water transportCoast Guard vessel chief engineerCoast Guard vessel first watchkeeping engineerCoast Guard vessel marine engineer officerCoast Guard vessel second engineerCoast Guard vessel second watchkeeping engineerCoast Guard vessel senior engineerCoast Guard vessel third engineerCoast Guard vessel third watchkeeping engineerengineer officer, fishing vesselengineer officer - water transportengineer, tugboatfactory freezer trawler chief marine engineerfactory freezer trawler first engineerfactory freezer trawler second engineerfirst engineer, factory freezer trawlerfirst engineer, self-propelled drilling rigfirst watchkeeping engineer, Coast Guard vesselfishing vessel chief engineerfishing vessel engineer officerfourth engineerfourth engineer - water transportjunior engineer - water transportmarine engineer, chief - water transportmarine engineer officermarine engineer officer-cadet - except armed forcesmarine engineer officer, Coast Guard vesselmarine engineer officer, offshore drilling rigmarine engineer officer - water transportmarine second engineer - water transportmarine senior engineer - water transportmobile platform chief engineer - offshore drillingoffshore drilling rig marine engineer officersecond engineersecond engineer, Coast Guard vesselsecond engineer, factory freezer trawlersecond engineer, marine - water transportsecond engineer, self-propelled drilling rigsecond engineer - water transportsecond watchkeeping engineer, Coast Guard vesselself-propelled barge marine engineer officerself-propelled drilling rig chief engineerself-propelled drilling rig first engineerself-propelled drilling rig marine engineer officerself-propelled drilling rig second engineersenior engineer, Coast Guard vesselsenior engineer, marine - water transportship engineer officerthird engineerthird engineer, Coast Guard vesselthird engineer - water transportthird watchkeeping engineer, Coast Guard vesseltugboat engineer",
    "workers": 65,
    "minEduc": 2,
    "yearsStudy": 2.4,
    "automationRisk": 0.01,
    "salaryLow": 25,
    "salaryMed": 35.21,
    "salaryHigh": 50.87,
    "totalSkill": 160,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 35.21,
    "skillsComp": 40,
    "skillsLogi": 41,
    "skillsMath": 29,
    "skillsLang": 50,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 14,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 25,
    "s14Writing": 14,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 65,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 65,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 160,
    "noc": 2275,
    "job": "Railway traffic controllers and marine traffic regulators",
    "title1": "centralized traffic control (CTC) operator � railway traffic centralized traffic controller � railway traffic chief rail traffic controller chief train dispatcher controller, rail traffic CTC (centralized traffic control) operator � railway traffic dispatcher, trains head train dispatcher locomotive dispatcher marine traffic controller marine traffic regulator operator, train rail traffic controller regulator, marine traffic supervisor, train dispatchers traffic checker, waterways train dispatcher train dispatchers supervisor train operator waterway traffic checker",
    "title2": 0,
    "title3": 0,
    "allTitles": "centralized traffic control (CTC) operator � railway traffic centralized traffic controller � railway traffic chief rail traffic controller chief train dispatcher controller, rail traffic CTC (centralized traffic control) operator � railway traffic dispatcher, trains head train dispatcher locomotive dispatcher marine traffic controller marine traffic regulator operator, train rail traffic controller regulator, marine traffic supervisor, train dispatchers traffic checker, waterways train dispatcher train dispatchers supervisor train operator waterway traffic checker",
    "workers": 961.25,
    "minEduc": 1.5,
    "yearsStudy": 2.319444445,
    "automationRisk": 0.1425,
    "salaryLow": 17.77,
    "salaryMed": 38.98,
    "salaryHigh": 47.92,
    "totalSkill": 153.75,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 35.20910493,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 21.5,
    "skillsLang": 47,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.75,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 2.75,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 24.25,
    "s14Writing": 12,
    "s15CriticalThinking": 11.75,
    "f1Science&Agriculture": 53.75,
    "f2Engineering": 65,
    "f3Humanities": 0,
    "f4SocialScience": 45,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 782.5,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 45,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 782.5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 65,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 53.75,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 161,
    "noc": 2281,
    "job": "Computer network technicians",
    "title1": "computer network technician",
    "title2": "computer network technicians' supervisor",
    "title3": "computer operations supervisor",
    "allTitles": "computer network techniciancomputer network technicians' supervisorcomputer operations supervisorcomputer tape librariancontroller, networkdata centre operatordigital computer operatorInternet Web site technicianLAN (local area network) administratorLAN (local area network) managerLAN (local area network) operatorLAN (local area network) technicianlocal area network (LAN) administratorlocal area network (LAN) managerlocal area network (LAN) operatorlocal area network (LAN) technicianmaster console operator, computernetwork administratornetwork controllernetwork operatornetwork support analystnetwork support technicianoperator, networkserver administratorsupervisor, computer network technicianssupervisor, computer operationssystem administratortape librarian, computertechnician, Internet Web sitetechnician, WebWAN (wide area network) administratorWAN (wide area network) technicianWeb site administratorWeb technicianWide area network (WAN) administratorwide area network (WAN) technician",
    "workers": 17510,
    "minEduc": 0,
    "yearsStudy": 3.129707113,
    "automationRisk": 0.03,
    "salaryLow": 17,
    "salaryMed": 31.79,
    "salaryHigh": 48.21,
    "totalSkill": 186,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 31.79,
    "skillsComp": 80,
    "skillsLogi": 34,
    "skillsMath": 24,
    "skillsLang": 48,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 9,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 6,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 58,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 425,
    "f2Engineering": 4885,
    "f3Humanities": 135,
    "f4SocialScience": 545,
    "f5FineArts": 295,
    "f6MathAndComputerScience": 8575,
    "f7Arts&Education": 595,
    "f8Education(teachertraining)": 75,
    "f9Law": 200,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 1760,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 75,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 90,
    "d5SocialSciences": 545,
    "d6Fine&AppliedArts": 295,
    "d7ComputerScience": 8370,
    "d8OtherArts&Science": 595,
    "d9Education(teachertraining)": 75,
    "d10Engineering": 4865,
    "d11Law": 200,
    "d12Mathematics": 205,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 45,
    "d15PhysicalSciences": 305,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 1760,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 162,
    "noc": 2282,
    "job": "User support technicians",
    "title1": "analyst, systems technical support",
    "title2": "call centre agent - technical support",
    "title3": "client support representative - systems",
    "allTitles": "analyst, systems technical supportcall centre agent - technical supportclient support representative - systemscomputer help desk representative - systemscomputer help desk supervisorhardware installation technicianhardware technical support analysthelp desk agent, technicalhelp desk analyst - systemshelp desk supervisor, computerhelp desk technical agenthelp desk technicianinstallation technician, hardwareinstallation technician, softwarePC (personal computer) support analystsoftware installation techniciansoftware technical support analystsupervisor, technical supportsystems support representativesystems technical support analysttechnical help desk agenttechnical support analyst - systemstechnical support supervisoruser support technician",
    "workers": 14220,
    "minEduc": 2,
    "yearsStudy": 3.167420814,
    "automationRisk": 0.65,
    "salaryLow": 16.35,
    "salaryMed": 28.85,
    "salaryHigh": 50,
    "totalSkill": 119,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 28.85,
    "skillsComp": 43,
    "skillsLogi": 32,
    "skillsMath": 11,
    "skillsLang": 33,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 7,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 27,
    "s13DocumentUse": 12,
    "s14Writing": 7,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 370,
    "f2Engineering": 4005,
    "f3Humanities": 50,
    "f4SocialScience": 590,
    "f5FineArts": 315,
    "f6MathAndComputerScience": 6415,
    "f7Arts&Education": 380,
    "f8Education(teachertraining)": 50,
    "f9Law": 110,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 110,
    "f12Business": 1790,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 590,
    "d6Fine&AppliedArts": 315,
    "d7ComputerScience": 6305,
    "d8OtherArts&Science": 380,
    "d9Education(teachertraining)": 50,
    "d10Engineering": 4005,
    "d11Law": 110,
    "d12Mathematics": 110,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 300,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 110,
    "d18Business&Commerce": 1790,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 163,
    "noc": 2283,
    "job": "Information systems testing technicians",
    "title1": "application tester",
    "title2": "application testing technician",
    "title3": "software test co-ordinator",
    "allTitles": "application testerapplication testing techniciansoftware test co-ordinatorsoftware testersoftware testing techniciansystems testersystems testing techniciantechnician, application testingtechnician, software testingtest coordination analystuser acceptance tester",
    "workers": 1850,
    "minEduc": 0,
    "yearsStudy": 3.527272727,
    "automationRisk": 0.22,
    "salaryLow": 17.75,
    "salaryMed": 36.06,
    "salaryHigh": 41.03,
    "totalSkill": 151,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 36.06,
    "skillsComp": 71,
    "skillsLogi": 33,
    "skillsMath": 8,
    "skillsLang": 39,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 7,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 49,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 590,
    "f3Humanities": 0,
    "f4SocialScience": 60,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 925,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 245,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 60,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 840,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 590,
    "d11Law": 0,
    "d12Mathematics": 85,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 245,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 164,
    "noc": 3011,
    "job": "Nursing co-ordinators and supervisors",
    "title1": "acute care co-ordinator - nursing",
    "title2": "assistant head nurse",
    "title3": "birthing room nursing supervisor",
    "allTitles": "acute care co-ordinator - nursingassistant head nursebirthing room nursing supervisorburn unit nursing co-ordinatorburn unit nursing supervisorco-ordinator, nursingco-ordinator, nursing unitco-ordinator of nursing servicescritical care nursing supervisordelivery room nursing supervisorgeriatric nursing supervisorhead nursenursing care co-ordinatornursing co-ordinatornursing services co-ordinatornursing supervisornursing supervisor, operating roomnursing unit co-ordinatornursing unit supervisornursing ward supervisorobstetrical nursing supervisoroperating room nursing supervisorpatient care co-ordinatorpatient care co-ordinator - nursingpsychiatric nursing supervisorpublic health nursing supervisorrehabilitation nursing supervisorsupervisor, nursingsupervisor, nursing wardsurgical co-ordinator - nursingsurgical ward supervisor - nursingward supervisor - nursing",
    "workers": 2690,
    "minEduc": 0,
    "yearsStudy": 3.193548387,
    "automationRisk": 0.007,
    "salaryLow": 17.88,
    "salaryMed": 40,
    "salaryHigh": 47.8,
    "totalSkill": 168,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in nursing",
    "cluster": 8,
    "wage": 40,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 80,
    "f11Health,Nursing&ClinicalLaboratory": 2525,
    "f12Business": 45,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 80,
    "d17Health,Nursing&ClinicalLaboratory": 2525,
    "d18Business&Commerce": 45,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 165,
    "noc": 3012,
    "job": "Registered nurses and registered psychiatric nurses",
    "title1": "ambulatory care nurse",
    "title2": "bedside nurse",
    "title3": "burn patient care nurse",
    "allTitles": "ambulatory care nursebedside nurseburn patient care nurseburn victim care nursecardiac surgery nursecardiology nursecardiology nurse techniciancasual duty nursecirculating nurseclinical nurseclinical nurse specialistclinic nursecommunity health nurseconsultant nurseconsultant, nursingcontagious disease transmission prevention nurseco-ordinator, infection control - hospitalcoronary intensive care nursecoronary unit nursecritical care nursedialysis nursedoctor's office nurseemergency care nurseemergency nursefirst aid nursefloat nursegeneral duty nursegeneral duty nurse - psychiatrygeriatric care nursegeriatric nursegerontology nursegraduate nursegraduate nurse - doctor's officegraduate nurse - occupational healthgraduate nurse - physician's officegraduate private duty nursegraduate religious nursehemodialysis nursehome care neuroscience nursehome care nursehome care nurse, neurosciencehospital hygiene nursehospital hygienist - nursinghospital nurseICU (intensive care unit) nurseindependent practice - registered nurseindustrial nurseinfection control co-ordinator - hospitalinfection control nurseinfection control officer - hospitalinfection control officer - medicalinfection surveillance nurseintensive care nurseintensive care unit (ICU) nurseliaison nursemedical intensive care nursemental health nursemissionary nursenephrology and kidney transplantation nursenephrology and renal transplantation nursenephrology nurseneuroscience nursenursenurse - birthing roomnurse consultantnurse, contagious disease transmission preventionnurse counsellornurse employed at national levelnurse, geriatricnurse, hospital hygienenurse of Native ancestrynurse researchernurse techniciannursing advisernursing consultantnursing counsellornursing evaluatornursing researchernursing researcher - nursenursing technicianobstetrics nurseoccupational health nurseoccupational health nurse consultantoccupational medicine nurseoffice nurseofficer, infection control - hospitalon-call nurseoncology nurseoperating room (OR) nurseOR (operating room) nurseout-patient clinic nurseoutpost nurseoutreach nursepalliative care nursepediatric intensive care nursepediatric nurseperinatal care nursephysician's office nurseprimary care nurseprimary nurse",
    "workers": 106220,
    "minEduc": 0,
    "yearsStudy": 3.299559471,
    "automationRisk": 0.009,
    "salaryLow": 17.88,
    "salaryMed": 40,
    "salaryHigh": 47.8,
    "totalSkill": 158,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in nursing",
    "cluster": 8,
    "wage": 36.87019345,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 310,
    "f2Engineering": 85,
    "f3Humanities": 270,
    "f4SocialScience": 835,
    "f5FineArts": 180,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1185,
    "f8Education(teachertraining)": 720,
    "f9Law": 210,
    "f10Health": 355,
    "f11Health,Nursing&ClinicalLaboratory": 100555,
    "f12Business": 1495,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 310,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 250,
    "d5SocialSciences": 835,
    "d6Fine&AppliedArts": 180,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1185,
    "d9Education(teachertraining)": 720,
    "d10Engineering": 85,
    "d11Law": 210,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 190,
    "d14Theology": 20,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 165,
    "d17Health,Nursing&ClinicalLaboratory": 100555,
    "d18Business&Commerce": 1495,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 166,
    "noc": 3111,
    "job": "Specialist physicians",
    "title1": "acute care specialist",
    "title2": "allergist",
    "title3": "allergologist",
    "allTitles": "acute care specialistallergistallergologistanatomical pathologistanatomopathologistanesthesiologistanesthetistanesthetist-resuscitatorautopsy pathologistbiochemist, medical - physiciancardiac surgeoncardiologistcardiology specialistcardiothoracic surgeoncardiovascular and thoracic surgeoncardiovascular and thoracic surgery specialistcardiovascular surgeonchild specialistclinical immunologistclinical immunologist-allergistclinical immunology and allergy specialistclinical pathologistclinical pharmacologistcommunity health physiciancommunity medicine physiciancommunity medicine specialistcosmetic surgeoncritical care medicine physiciancritical care medicine specialistdermatologistdiagnostic radiologistdiagnostic radiology specialistear specialistemergency medicine physicianemergency medicine specialistemergency physicianemergentologistendocrinologistenvironmental medicine specialistesthetic surgeoneye specialistforensic pathologistgastroenterologistgeneral pathologistgeneral surgeongeneticist - medical specialistgeriatriciangeriatric medicine specialistgeriatrics specialistgeriatristgynecologistheart specialisthematological-pathologisthematologisthematopathologisthematopathology specialisthistopathologist - medical specialisthyperbaric physicianimmunologist and allergologistinfectious disease physicianinfectious disease specialistinfertility specialistinpatient physicianinternal medicine specialistinternistlaryngologistlung specialistmedical bacteriologistmedical biochemist - physicianmedical examinermedical geneticistmedical genetics specialistmedical microbiologistmedical oncologistmedical oncology specialistmedical parasitologistmedical pathologistmedical physiologistmedical specialistneonatologistnephrologistnerve specialistneurological surgeonneurologistneuropathologistneuropsychiatristneurosurgeonnose specialistnuclear medicine physiciannuclear medicine specialistnuclear physicianobstetricianobstetrician-gynecologistoccupational health physician (OHP)occupational medicine specialistoccupational physicianoculistOHP (occupational health physician)oncologistoncologist, pediatric",
    "workers": 13065,
    "minEduc": 0,
    "yearsStudy": 4.785714286,
    "automationRisk": 0.004,
    "salaryLow": 44846,
    "salaryMed": 132.922,
    "salaryHigh": 376715,
    "totalSkill": 186,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 80.80364742,
    "skillsComp": 50,
    "skillsLogi": 47,
    "skillsMath": 26,
    "skillsLang": 64,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 11,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 18,
    "s14Writing": 19,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 150,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 55,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 35,
    "f7Arts&Education": 20,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 9460,
    "f12Business": 30,
    "f13Medical,Dental&Veterinary": 3280,
    "d1Agriculture&BiologicalScience": 150,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 55,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 35,
    "d8OtherArts&Science": 20,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 9460,
    "d18Business&Commerce": 30,
    "d19Medical,Dental&Veterinary": 3280,
    "equalRadius": 10
  },
  {
    "id": 167,
    "noc": 3112,
    "job": "General practitioners and family physicians",
    "title1": "civil aviation medical officer",
    "title2": "community preventive medicine physician",
    "title3": "company physician",
    "allTitles": "civil aviation medical officercommunity preventive medicine physiciancompany physiciandoctor, familydoctor, medicaldoctor of medicine (MD)family doctorfamily physicianfamily practitionergeneral practice interngeneral practice physiciangeneral practice residentgeneral practitioner (GP)GP (general practitioner)industrial medical officerindustrial medicine physicianindustrial physicianinternintern, general practiceMD (doctor of medicine)medical doctormedical missionarymedical officer, civil aviationmedical officer of health (MOH)missionary doctorMOH (medical officer of health)physician, community preventive medicinephysician, companyphysician, familyphysician, general practicephysician, industrialphysician, primary carephysician, public healthphysician residentpractitioner, generalprimary care physicianpublic health physicianresidentresident, general practiceresident physician",
    "workers": 16595,
    "minEduc": 0,
    "yearsStudy": 4.806451613,
    "automationRisk": 0.004,
    "salaryLow": 39364,
    "salaryMed": 127.405,
    "salaryHigh": 326810,
    "totalSkill": 184,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 77.44984802,
    "skillsComp": 49,
    "skillsLogi": 46,
    "skillsMath": 26,
    "skillsLang": 63,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 11,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 18,
    "s14Writing": 19,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 20,
    "f2Engineering": 60,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 14910,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 1505,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 60,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 14910,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 1505,
    "equalRadius": 10
  },
  {
    "id": 168,
    "noc": 3113,
    "job": "Dentists",
    "title1": "dental surgeon",
    "title2": "dentist",
    "title3": "dentist, public health",
    "allTitles": "dental surgeondentistdentist, public healthdoctor of dental surgeryendodontistgeneral practice dentistimplantologist - dentistryoral and dental surgeonoral and maxillofacial surgeonoral medicine specialistoral pathologistoral pathology and maxillofacial surgery specialistoral radiologistoral surgeonorthodontistpediatric dentistpedodontistperiodontistprosthodontistpublic health dentistspecialist, oral medicinestomatologistsurgeon, dentalsurgeon, oralsurgeon, oral and maxillofacial",
    "workers": 7285,
    "minEduc": 3,
    "yearsStudy": 4.684210526,
    "automationRisk": 0.004,
    "salaryLow": 45317,
    "salaryMed": 120.686,
    "salaryHigh": 253363,
    "totalSkill": 151,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 73.36534954,
    "skillsComp": 34,
    "skillsLogi": 50,
    "skillsMath": 21,
    "skillsLang": 46,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 13,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 6830,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 455,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 6830,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 455,
    "equalRadius": 10
  },
  {
    "id": 169,
    "noc": 3114,
    "job": "Veterinarians",
    "title1": "anatomist, veterinary",
    "title2": "animal pathologist",
    "title3": "avian veterinarian",
    "allTitles": "anatomist, veterinaryanimal pathologistavian veterinariancompanion animal veterinariandentist, veterinaryepidemiologist, veterinaryequine veterinarianfarm veterinarianfood animal veterinarianinspector, veterinaryinternist, veterinarylaboratory animal veterinarianmicrobiologist, veterinaryparasitologist, veterinarypathologist, animalpathologist, veterinarypharmacologist, veterinaryphysiologist, veterinarypoultry veterinarianpreventive medicine veterinarianradiologist, veterinarysmall animal veterinariansmall animal veterinary specialistsurgeon, veterinaryveterinarianveterinarian, companion animalsveterinarian, farmveterinarian, food animalsveterinarian, laboratory animalsveterinarian practitionerveterinarian, preventive medicineveterinary anatomistveterinary bacteriologistveterinary dentistveterinary epidemiologistveterinary inspectorveterinary internistveterinary laboratory diagnosticianveterinary microbiologistveterinary parasitologistveterinary pathologistveterinary pharmacologistveterinary physiologistveterinary radiologistveterinary specialist, small animalsveterinary surgeonveterinary virologistzoo veterinarian",
    "workers": 3205,
    "minEduc": 3,
    "yearsStudy": 4.909090909,
    "automationRisk": 0.038,
    "salaryLow": 28752,
    "salaryMed": 78.352,
    "salaryHigh": 149782,
    "totalSkill": 214,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 47.63039514,
    "skillsComp": 49,
    "skillsLogi": 64,
    "skillsMath": 26,
    "skillsLang": 75,
    "topSkill1": "Oral Communication",
    "topSkill2": "Writing",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 18,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 9,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 33,
    "s9ProblemSolving": 13,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 21,
    "s14Writing": 24,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 3185,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3185,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 170,
    "noc": 3121,
    "job": "Optometrists",
    "title1": "doctor of optometry",
    "title2": "doctor of optometry (OD)",
    "title3": "OD (doctor of optometry)",
    "allTitles": "doctor of optometrydoctor of optometry (OD)OD (doctor of optometry)optometrist",
    "workers": 1685,
    "minEduc": 3,
    "yearsStudy": 5,
    "automationRisk": 0.14,
    "salaryLow": 38779,
    "salaryMed": 99.18,
    "salaryHigh": 190963,
    "totalSkill": 193,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 60.29179331,
    "skillsComp": 46,
    "skillsLogi": 53,
    "skillsMath": 28,
    "skillsLang": 66,
    "topSkill1": "Reading",
    "topSkill2": "Problem Solving",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 10,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 10,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 22,
    "s10Reading": 32,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 20,
    "s14Writing": 18,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1685,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1685,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 171,
    "noc": 3122,
    "job": "Chiropractors",
    "title1": "chiropractic doctor",
    "title2": "chiropractor",
    "title3": "DC (doctor of chiropractic)",
    "allTitles": "chiropractic doctorchiropractorDC (doctor of chiropractic)doctor of chiropracticdoctor of chiropractic (DC)",
    "workers": 2990,
    "minEduc": 3,
    "yearsStudy": 3.846153846,
    "automationRisk": 0.027,
    "salaryLow": 28752,
    "salaryMed": 57.167,
    "salaryHigh": 126174,
    "totalSkill": 168,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 34.75197568,
    "skillsComp": 42,
    "skillsLogi": 36,
    "skillsMath": 23,
    "skillsLang": 67,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 13,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 28,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 15,
    "s14Writing": 21,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 2990,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 2990,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 172,
    "noc": 3124,
    "job": "Allied primary health practitioners",
    "title1": "acute care nurse practitioner",
    "title2": "advanced nurse practitioner",
    "title3": "advanced practice nurse",
    "allTitles": "acute care nurse practitioneradvanced nurse practitioneradvanced practice nurseanesthesia assistantextended class registered nurse - nurse practitionerlicensed midwifemidwifenurse-midwifenurse practioner - adult carenurse practitionernurse practitioner - anesthesianurse practitioner - cardiologynurse practitioner - extended classnurse practitioner - pediatricsnurse practitioner - primary health carephysician assistantprimary health care nurse practitionerregistered midwife (RM)registered nurse - extended class (RN-EC)RM (registered midwife)",
    "workers": 1875,
    "minEduc": 0,
    "yearsStudy": 4.368421053,
    "automationRisk": 0.055,
    "salaryLow": 32094.33333,
    "salaryMed": 66.53166667,
    "salaryHigh": 137178.3333,
    "totalSkill": 157,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 36.00684922,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1860,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1860,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 173,
    "noc": 3125,
    "job": "Other professional occupations in health diagnosing and treating",
    "title1": "chief orthoptist",
    "title2": "chiropodist",
    "title3": "clinical orthoptist",
    "allTitles": "chief orthoptistchiropodistclinical orthoptistdoctor of naturopathic medicinedoctor of naturopathydoctor of osteopathic medicinedoctor of osteopathydoctor of podiatric medicine (D.P.M.)D.P.M. (doctor of podiatric medicine)foot specialistnaturopathnaturopathic doctor (ND)naturopathic physicianND (naturopathic doctor)orthoptistosteopathosteopathic doctorosteopathic physicianpodiatristteaching orthoptist",
    "workers": 990,
    "minEduc": 0,
    "yearsStudy": 4.176470588,
    "automationRisk": 0.02,
    "salaryLow": 28752,
    "salaryMed": 43.248,
    "salaryHigh": 94398,
    "totalSkill": 161,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 26.29057751,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 990,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 990,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 174,
    "noc": 3131,
    "job": "Pharmacists",
    "title1": "clinical pharmacist",
    "title2": "community pharmacist",
    "title3": "dispensary department supervisor - hospital",
    "allTitles": "clinical pharmacistcommunity pharmacistdispensary department supervisor - hospitaldruggistdrug information pharmacisthealth care institution pharmacisthospital druggisthospital pharmacistindustrial pharmacistintern pharmacistpharmacistpharmacist consultantregistered pharmacistretail pharmacist",
    "workers": 10180,
    "minEduc": 3,
    "yearsStudy": 4.279069767,
    "automationRisk": 0.012,
    "salaryLow": 42270,
    "salaryMed": 93.136,
    "salaryHigh": 139998,
    "totalSkill": 205,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 56.61762918,
    "skillsComp": 46,
    "skillsLogi": 66,
    "skillsMath": 22,
    "skillsLang": 71,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Critical Thinking",
    "s1DataAnalysis": 12,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 12,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 14,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 12,
    "s10Reading": 33,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 21,
    "s14Writing": 25,
    "s15CriticalThinking": 24,
    "f1Science&Agriculture": 155,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 150,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 9215,
    "f12Business": 145,
    "f13Medical,Dental&Veterinary": 515,
    "d1Agriculture&BiologicalScience": 125,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 150,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 9215,
    "d18Business&Commerce": 145,
    "d19Medical,Dental&Veterinary": 515,
    "equalRadius": 10
  },
  {
    "id": 175,
    "noc": 3132,
    "job": "Dietitians and nutritionists",
    "title1": "administrative dietitian",
    "title2": "administrative nutritionist",
    "title3": "clinical dietitian",
    "allTitles": "administrative dietitianadministrative nutritionistclinical dietitianclinical nutritionistcommunity dietitiancommunity nutritionistconsultant dietitianconsultant nutritionistdietetic consultantdieticiandietitiandietitian, administrativedietitian, communitydietitian, consultantdietitian-nutritionistdietitian/nutritionist, registereddietitian, professionaldietitian, public healthdietitian, registereddietitian, researchdietitian, therapeuticnutrition and dietetics researchernutrition consultantnutritionistnutritionist, administrativenutritionist, communitynutritionist, consultantnutritionist, public healthnutritionist, registerednutritionist, therapeuticnutrition researchernutrition specialistP.Dt. (professional dietitian)private practice dietitianprofessional dietitian (P.Dt.)professional dietitian, registeredprofessional nutritionistpublic health dietitianpublic health nutritionistRDN (registered dietitian-nutritionist)RD (registered dietitian)registered dietitian-nutritionist (RDN)registered dietitian (RD)registered nutritionistregistered professional dietitianregistered professional nutritionistresearch dietitianresearch nutritionisttherapeutic dietitiantherapeutic nutritionist",
    "workers": 2730,
    "minEduc": 3,
    "yearsStudy": 3.790697674,
    "automationRisk": 0.004,
    "salaryLow": 15,
    "salaryMed": 36.06,
    "salaryHigh": 50,
    "totalSkill": 185,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 36.06,
    "skillsComp": 45,
    "skillsLogi": 59,
    "skillsMath": 29,
    "skillsLang": 52,
    "topSkill1": "Writing",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 18,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 11,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 14,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 19,
    "s14Writing": 23,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 1270,
    "f4SocialScience": 50,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 340,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1030,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 1270,
    "d5SocialSciences": 50,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 340,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1030,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 176,
    "noc": 3141,
    "job": "Audiologists and speech-language pathologists",
    "title1": "amplification audiologist",
    "title2": "audiologist",
    "title3": "audiologist, research",
    "allTitles": "amplification audiologistaudiologistaudiologist, researchaudiology clinicianaudiology specialistcertified audiologistcertified hearing aid audiologistclinical audiologistcommunity audiologistcommunity speech-language pathologistdiagnostic audiologistdispensing audiologisteducational audiologisteducational speech-language pathologisthuman communication disorders specialistindustrial audiologistlogopedistpathologist, speechpathologist, speech-languagepediatric audiologistresearch audiologistspecialist, audiologyspeech and hearing therapistspeech-language clinicianspeech-language pathologistspeech-language pathologist clinicianspeech-language pathologist researcherspeech pathologistspeech therapisttherapist, speechtherapist, speech and hearing",
    "workers": 2600,
    "minEduc": 3,
    "yearsStudy": 4.733333333,
    "automationRisk": 0.005,
    "salaryLow": 27.04,
    "salaryMed": 40.51,
    "salaryHigh": 50.55,
    "totalSkill": 142,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 40.51,
    "skillsComp": 26,
    "skillsLogi": 28,
    "skillsMath": 22,
    "skillsLang": 66,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 8,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 8,
    "s14Writing": 21,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 2550,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 2550,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 177,
    "noc": 3142,
    "job": "Physiotherapists",
    "title1": "clinical co-ordinator, physical therapy",
    "title2": "clinical co-ordinator, physiotherapy",
    "title3": "clinical physical therapist",
    "allTitles": "clinical co-ordinator, physical therapyclinical co-ordinator, physiotherapyclinical physical therapistclinical physiotherapistconsultant physical therapistconsultant physiotherapistphysical rehabilitation therapistphysical therapistphysical therapist, researchphysical therapy clinical co-ordinatorphysical therapy clinical specialistphysical therapy supervisorphysiotherapistphysiotherapist, researchphysiotherapy clinical co-ordinatorphysiotherapy supervisorregistered physical therapistregistered physiotherapistresearch physical therapistresearch physiotherapistsupervisor, physical therapysupervisor, physiotherapytherapist, physical rehabilitation",
    "workers": 6950,
    "minEduc": 3,
    "yearsStudy": 3.980392157,
    "automationRisk": 0.021,
    "salaryLow": 25.71,
    "salaryMed": 36,
    "salaryHigh": 45,
    "totalSkill": 152,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 36,
    "skillsComp": 39,
    "skillsLogi": 38,
    "skillsMath": 33,
    "skillsLang": 42,
    "topSkill1": "Writing",
    "topSkill2": "Scheduling or Budgeting and Accounting",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 10,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 6,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 16,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 15,
    "s14Writing": 17,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 40,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 75,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 145,
    "f8Education(teachertraining)": 45,
    "f9Law": 0,
    "f10Health": 150,
    "f11Health,Nursing&ClinicalLaboratory": 6400,
    "f12Business": 45,
    "f13Medical,Dental&Veterinary": 50,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 75,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 145,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 150,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 6400,
    "d18Business&Commerce": 45,
    "d19Medical,Dental&Veterinary": 50,
    "equalRadius": 10
  },
  {
    "id": 178,
    "noc": 3143,
    "job": "Occupational therapists",
    "title1": "case manager occupational therapist",
    "title2": "clinical occupational therapist",
    "title3": "clinical occupational therapy specialist",
    "allTitles": "case manager occupational therapistclinical occupational therapistclinical occupational therapy specialistcommunity occupational therapistcommunity practice occupational therapisthome care occupational therapistoccupational therapist, case manageroccupational therapist, communityoccupational therapist, community practiceoccupational therapist, home careoccupational therapist (OT)occupational therapist, researchoccupational therapist, research and developmentoccupational therapist vocational evaluatoroccupational therapy rehabilitation consultantOT (occupational therapist)rehabilitation consultant, occupational therapyresearch and development occupational therapistresearch occupational therapistspecialist, clinical occupational therapyvocational evaluator occupational therapist",
    "workers": 4285,
    "minEduc": 3,
    "yearsStudy": 4.263157895,
    "automationRisk": 0.004,
    "salaryLow": 28.85,
    "salaryMed": 38.46,
    "salaryHigh": 44,
    "totalSkill": 192,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 38.46,
    "skillsComp": 53,
    "skillsLogi": 59,
    "skillsMath": 12,
    "skillsLang": 68,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 11,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 22,
    "s9ProblemSolving": 14,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 24,
    "s14Writing": 21,
    "s15CriticalThinking": 19,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 90,
    "f8Education(teachertraining)": 60,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 4110,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 90,
    "d9Education(teachertraining)": 60,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 4110,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 179,
    "noc": 3144,
    "job": "Other professional occupations in therapy and assessment",
    "title1": "analyst, movement - medical",
    "title2": "art therapist",
    "title3": "art therapists' supervisor",
    "allTitles": "analyst, movement - medicalart therapistart therapists' supervisorart therapy consultantart therapy teacher (except education)athletic therapistathletic trainer - therapybiokineticistCAT (certified athletic therapist)certified athletic therapist (CAT)certified kinesiologistconsultant, art therapydance-movement therapistdance-movement therapy researcherdance therapistdance therapists' supervisordance therapy researcherdrama therapistdrama therapists' supervisorDTR (registered dance therapist)exercise physiologistexercise therapisthuman kineticistkinanthropologistkinesiologistmovement analyst - medicalmovement therapistmusic therapistmusic therapists' supervisormusic therapy researcherrecreational therapistregistered dance therapist (DTR)registered kinesiologistremedial gymnastremedial gymnastics teacher (except education)remedial gymnasts' supervisorremedial therapistresearcher, dance-movement therapyresearcher, dance therapyresearcher, music therapyspontaneous art teacher - therapysupervisor, art therapistssupervisor, dance therapistssupervisor, drama therapistssupervisor, music therapistssupervisor, remedial gymnaststherapeutic recreationisttherapist, arttherapist, dancetherapist, dance-movementtherapist, dramatherapist, movementtherapist, music",
    "workers": 2505,
    "minEduc": 3,
    "yearsStudy": 3.777777778,
    "automationRisk": 0.012,
    "salaryLow": 15.22,
    "salaryMed": 25,
    "salaryHigh": 42.86,
    "totalSkill": 175,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Professional occupations in health (except nursing)",
    "cluster": 8,
    "wage": 25,
    "skillsComp": 55,
    "skillsLogi": 45,
    "skillsMath": 20,
    "skillsLang": 55,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 24,
    "s14Writing": 16,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 55,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 175,
    "f8Education(teachertraining)": 15,
    "f9Law": 0,
    "f10Health": 1560,
    "f11Health,Nursing&ClinicalLaboratory": 680,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 55,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 175,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 1560,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 680,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 180,
    "noc": 3211,
    "job": "Medical laboratory technologists",
    "title1": "advanced registered technologist - medical laboratory",
    "title2": "anatomical pathology technologist",
    "title3": "autopsy technologist - medical laboratory",
    "allTitles": "advanced registered technologist - medical laboratoryanatomical pathology technologistautopsy technologist - medical laboratorybiochemistry technologist - medical laboratoryblood bank technologistcharge technologist - medical laboratoryclinical immunology technologistclinical laboratory technologistcombined laboratory and x-ray technologistcytogenetics technologist - medical laboratorycytology technologistcytotechnologist - medical laboratoryelectron microscopy technologist - medical laboratoryhematology technologist - medical laboratoryhistology technologisthistology technologist - medical laboratoryhistopathology technologisthistotechnologist - medical laboratoryimmunohematology technologistimmunohematology technologist - medical laboratoryimmunology technologist - medical laboratoryin-charge technologist - autopsy servicesmedical laboratory supervisormedical laboratory technical supervisormedical laboratory technologistmedical laboratory technologist, anatomical pathologymedical technologistmedical technologist - medical laboratorymedical technologists supervisormicrobiology technologist - medical laboratoryregistered medical technologistregistered technologist - medicalserology technologistsupervisor, medical laboratorytechnical supervisor, medical laboratorytechnologist, anatomical pathologytechnologist, autopsy - medical laboratorytechnologist, clinical laboratorytechnologist, medical laboratorytissue technologist - medical laboratory",
    "workers": 5420,
    "minEduc": 2,
    "yearsStudy": 3.666666667,
    "automationRisk": 0.9,
    "salaryLow": 24,
    "salaryMed": 35,
    "salaryHigh": 42,
    "totalSkill": 168,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 35,
    "skillsComp": 50,
    "skillsLogi": 40,
    "skillsMath": 19,
    "skillsLang": 59,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 11,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 25,
    "s14Writing": 15,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 620,
    "f2Engineering": 10,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 530,
    "f8Education(teachertraining)": 20,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 4215,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 25,
    "d1Agriculture&BiologicalScience": 555,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 530,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 10,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 4215,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 25,
    "equalRadius": 10
  },
  {
    "id": 181,
    "noc": 3212,
    "job": "Medical laboratory technicians and pathologists' assistants",
    "title1": "aide, medical laboratory",
    "title2": "assistant, medical laboratory",
    "title3": "assistant, pathology",
    "allTitles": "aide, medical laboratoryassistant, medical laboratoryassistant, pathologybiochemical technician - medical laboratorybiological technician - medical laboratoryblood bank techniciancancer research technicianclinical laboratory techniciancombined laboratory and x-ray techniciancommunity health technician - medical laboratorycytology technicianepidemiology worker - medical laboratoryhelper, medical laboratoryhematology technician - medical laboratoryhistology technicianlaboratory assistant - medicallaboratory technician - medicalmedical laboratory aidemedical laboratory assistantmedical laboratory helpermedical laboratory technical assistantmedical laboratory technicianmorgue attendant supervisorpathology assistantphlebotomistphlebotomy aiderenal techniciantechnical assistant - medical laboratorytechnical assistant - pathologytechnician, blood bank",
    "workers": 5565,
    "minEduc": 2,
    "yearsStudy": 3.023809524,
    "automationRisk": 0.47,
    "salaryLow": 20.02571429,
    "salaryMed": 28.86142857,
    "salaryHigh": 38.32142857,
    "totalSkill": 75,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 26.91527062,
    "skillsComp": 20,
    "skillsLogi": 14,
    "skillsMath": 8,
    "skillsLang": 33,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 2,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 5,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 10,
    "s14Writing": 6,
    "s15CriticalThinking": 3,
    "f1Science&Agriculture": 480,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1035,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 3985,
    "f12Business": 50,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 400,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1035,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 80,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3985,
    "d18Business&Commerce": 50,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 182,
    "noc": 3213,
    "job": "Animal health technologists and veterinary technicians",
    "title1": "(RAHT) registered animal health technologist animal care technician animal care technologist animal health technician animal health technician � agriculture animal health technologist animal health technologist supervisor animal operating room attendant attendant, animal operating room laboratory animal technician laboratory animal technologist laboratory technician, veterinary registered animal health technologist registered animal health technologist (RAHT) registered veterinary technician registered veterinary technician (RVT) technician, animal care technician, animal health technician, laboratory animals technician, veterinary technician, veterinary laboratory technologist, animal care technologist, animal health technologist, veterinary veterinarian assistant veterinary laboratory technician veterinary technician veterinary technician supervisor veterinary technologist",
    "title2": 0,
    "title3": 0,
    "allTitles": "(RAHT) registered animal health technologist animal care technician animal care technologist animal health technician animal health technician � agriculture animal health technologist animal health technologist supervisor animal operating room attendant attendant, animal operating room laboratory animal technician laboratory animal technologist laboratory technician, veterinary registered animal health technologist registered animal health technologist (RAHT) registered veterinary technician registered veterinary technician (RVT) technician, animal care technician, animal health technician, laboratory animals technician, veterinary technician, veterinary laboratory technologist, animal care technologist, animal health technologist, veterinary veterinarian assistant veterinary laboratory technician veterinary technician veterinary technician supervisor veterinary technologist",
    "workers": 4157.142857,
    "minEduc": 1.428571429,
    "yearsStudy": 3.261492073,
    "automationRisk": 0.378,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 23,
    "totalSkill": 142.7142857,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 30.42075295,
    "skillsComp": 41.14285714,
    "skillsLogi": 35.14285714,
    "skillsMath": 17.14285714,
    "skillsLang": 49.42857143,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.714285714,
    "s2DecisionMaking": 8.571428571,
    "s3FindingInformation": 5.857142857,
    "s4JobTaskPlanningandOrganizing": 2.714285714,
    "s5MeasurementandCalculation": 6.142857143,
    "s6MoneyMath": 2.857142857,
    "s7NumericalEstimation": 3.142857143,
    "s8OralCommunication": 15.57142857,
    "s9ProblemSolving": 8.571428571,
    "s10Reading": 20.85714286,
    "s11SchedulingorBudgetingandAccounting": 4.857142857,
    "s12DigitalTechnology": 17.28571429,
    "s13DocumentUse": 18,
    "s14Writing": 12.85714286,
    "s15CriticalThinking": 9.428571429,
    "f1Science&Agriculture": 380.7142857,
    "f2Engineering": 7.857142857,
    "f3Humanities": 27.14285714,
    "f4SocialScience": 21.42857143,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 330.7142857,
    "f8Education(teachertraining)": 5.714285714,
    "f9Law": 7.857142857,
    "f10Health": 39.28571429,
    "f11Health,Nursing&ClinicalLaboratory": 3216.428571,
    "f12Business": 89.28571429,
    "f13Medical,Dental&Veterinary": 30.71428571,
    "d1Agriculture&BiologicalScience": 356.4285714,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 27.14285714,
    "d5SocialSciences": 21.42857143,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 330.7142857,
    "d9Education(teachertraining)": 5.714285714,
    "d10Engineering": 7.857142857,
    "d11Law": 7.857142857,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 36.42857143,
    "d14Theology": 0,
    "d15PhysicalSciences": 24.28571429,
    "d16Therapy&Rehabilitation": 2.857142857,
    "d17Health,Nursing&ClinicalLaboratory": 3216.428571,
    "d18Business&Commerce": 89.28571429,
    "d19Medical,Dental&Veterinary": 30.71428571,
    "equalRadius": 10
  },
  {
    "id": 183,
    "noc": 3214,
    "job": "Respiratory therapists, clinical perfusionists and cardiopulmonary technologists",
    "title1": "anesthesia technologist",
    "title2": "cardiopulmonary technician",
    "title3": "cardiopulmonary technologist",
    "allTitles": "anesthesia technologistcardiopulmonary techniciancardiopulmonary technologistcardiovascular perfusion clinical instructorcardiovascular perfusion instructorcardiovascular perfusionistcardiovascular perfusion supervisorcardiovascular perfusion technologistCCP (certified clinical perfusionist)certified clinical perfusionist (CCP)chief perfusionistchief respiratory technologistchief, respiratory therapyclinical instructor, cardiovascular perfusionclinical instructor, clinical perfusionclinical instructor, respiratory therapyclinical perfusion clinical instructorclinical perfusionistclinical perfusion supervisorextracorporal circulation technologistextracorporal technicianextracorporal technologistinhalation technologistinstructor, cardiopulmonary technologyinstructor, cardiovascular perfusionoxygen therapy technicianperfusionistperfusionist, cardiovascularperfusion technologistpolysomnographic technologistpulmonary function technologistregistered respiratory care practitionerregistered respiratory therapist (RRT)respiratory care practitionerrespiratory technicianrespiratory technologistrespiratory therapistrespiratory therapy chiefrespiratory therapy clinical instructorrespiratory therapy supervisorRRT (registered respiratory therapist)supervisor, cardiopulmonary technologysupervisor, cardiovascular perfusionsupervisor, clinical perfusionsupervisor, respiratory therapytechnologist, anesthesiatechnologist, cardiovascular perfusiontechnologist, extracorporal circulationtechnologist, inhalationtechnologist, perfusiontechnologist, pulmonary functiontechnologist, respiratorytherapist, respiratory",
    "workers": 1880,
    "minEduc": 2,
    "yearsStudy": 3.32,
    "automationRisk": 0.066,
    "salaryLow": 22,
    "salaryMed": 35,
    "salaryHigh": 47,
    "totalSkill": 128,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 35,
    "skillsComp": 39,
    "skillsLogi": 26,
    "skillsMath": 21,
    "skillsLang": 42,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 3,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 165,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 25,
    "f11Health,Nursing&ClinicalLaboratory": 1595,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 165,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1595,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 184,
    "noc": 3215,
    "job": "Medical radiation technologists",
    "title1": "brachytherapy technologist",
    "title2": "chief radiographer",
    "title3": "chief radiotherapy technologist",
    "allTitles": "brachytherapy technologistchief radiographerchief radiotherapy technologistchief technologist, nuclear medicinechief technologist, radiation therapychief technologist, radiographyclinical co-ordinator, nuclear medicineclinical co-ordinator, radiation therapyclinical co-ordinator, radiographyclinical instructor, nuclear medicineclinical instructor, radiation therapyclinical instructor, radiographydiagnostic imaging technologistdiagnostic medical radiation technologistdiagnostic radiography technologistdiagnostic radiological techniciandiagnostic radiological technologistdiagnostic radiology technologistmagnetic resonance imaging (MRI) technologistmagnetic resonance technologistmammography technicianmammography technologistmedical radiation technologistmedical radiation technologists supervisorMRI (magnetic resonance imaging) technologistNMRI (nuclear magnetic resonance imaging) technologistnuclear magnetic resonance imaging (NMRI) technologistnuclear medicine chief technologistnuclear medicine clinical instructornuclear medicine supervisornuclear medicine technical co-ordinatornuclear medicine technical directornuclear medicine techniciannuclear medicine technologistnuclear medicine technologists supervisoroncology technologistoncology technologist, radiation therapyPET (positron-emission tomography) technologistpositron-emission tomography (PET) technologistradiation oncology simulator technologistradiation oncology technicianradiation oncology technologistradiation technologist - cancer therapyradiation technologist - oncologyradiation therapistradiation therapists supervisorradiation therapy chief technologistradiation therapy clinical co-ordinatorradiation therapy clinical instructorradiation therapy technical co-ordinatorradiation therapy technologist (RTT)radiographer, medicalradiographic technologistradiography chief technologistradiography clinical co-ordinatorradiography clinical instructorradiography supervisorradiography technical co-ordinatorradiography technical directorradiography technologistradiography technologists supervisorradioisotope technicianradioisotope technologistradiological technicianradiological technologistradiology technologistradiotherapy technicianradiotherapy technologistregistered radiology technologistregistered technologist in nuclear medicine (RTNM)registered technologist in radiation therapyregistered technologist in radiography (RTR)RTNM (registered technologist in nuclear medicine)RTR (registered technologist in radiography)RTT (radiation therapy technologist)senior radiation therapy technologistsupervisor, medical radiation technologistssupervisor, nuclear medicinesupervisor, nuclear medicine technologistssupervisor, radiation therapistssupervisor, radiographysupervisor, radiography technologiststechnical co-ordinator, nuclear medicinetechnical co-ordinator, radiation therapytechnical co-ordinator, radiographytechnical director, nuclear medicinetechnical director, radiographytechnician, mammographytechnician, nuclear medicinetechnician, radiation oncologytechnician, radioisotopetechnician, radiotherapytechnician, X-ray (radiology)technologist, brachytherapytechnologist, diagnostic medical radiationtechnologist, diagnostic radiographytechnologist, magnetic resonancetechnologist, magnetic resonance imaging (MRI)technologist, mammographytechnologist, medical radiation",
    "workers": 5250,
    "minEduc": 2,
    "yearsStudy": 3.648148148,
    "automationRisk": 0.23,
    "salaryLow": 27.38,
    "salaryMed": 35.8,
    "salaryHigh": 45,
    "totalSkill": 186,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 35.8,
    "skillsComp": 54,
    "skillsLogi": 51,
    "skillsMath": 13,
    "skillsLang": 68,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Writing",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 13,
    "s10Reading": 28,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 28,
    "s13DocumentUse": 20,
    "s14Writing": 21,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 1055,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 210,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 25,
    "f11Health,Nursing&ClinicalLaboratory": 3825,
    "f12Business": 50,
    "f13Medical,Dental&Veterinary": 45,
    "d1Agriculture&BiologicalScience": 1055,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 210,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3825,
    "d18Business&Commerce": 50,
    "d19Medical,Dental&Veterinary": 45,
    "equalRadius": 10
  },
  {
    "id": 185,
    "noc": 3216,
    "job": "Medical sonographers",
    "title1": "adult echocardiographer",
    "title2": "cardiac sonographer",
    "title3": "cardiac ultrasound technician",
    "allTitles": "adult echocardiographercardiac sonographercardiac ultrasound techniciancardiac ultrasound technologistchief diagnostic medical sonographerdiagnostic cardiac sonographerdiagnostic echography techniciandiagnostic medical sonographerdiagnostic medical sonography instructordiagnostic ultrasonography techniciandiagnostic ultrasound supervisordiagnostic ultrasound techniciandiagnostic ultrasound technologist - medicalechocardiographerechocardiography technicianechocardiography technologistechocardiography technologist sonographerechography technicianechography technologistinstructor, diagnostic medical sonographymedical sonographermedical sonographers supervisorpediatric echocardiographerRDMS (registered diagnostic medical sonographer)registered diagnostic cardiac sonographerregistered diagnostic medical sonographer (RDMS)registered technologist, ultrasoundregistered ultrasound technologistsonographer - medicalsonography technologiststudent medical sonographerstudent sonographer - medicalsupervisor, diagnostic ultrasoundsupervisor, medical sonographerstechnician, diagnostic echographytechnician, diagnostic ultrasonographytechnician, diagnostic ultrasoundtechnician, echographytechnician, ultrasonographytechnician, ultrasoundtechnologist, echographytechnologist, ultrasonographytechnologist, ultrasoundultrasonographer - medicalultrasonography technicianultrasonography technologistultrasound supervisorultrasound technicianultrasound technologistvascular sonographer",
    "workers": 1715,
    "minEduc": 0,
    "yearsStudy": 3.84375,
    "automationRisk": 0.35,
    "salaryLow": 23,
    "salaryMed": 34,
    "salaryHigh": 42,
    "totalSkill": 150,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 34,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 70,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1585,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 25,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1585,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 25,
    "equalRadius": 10
  },
  {
    "id": 186,
    "noc": 3217,
    "job": "Cardiology technologists and electrophysiological diagnostic technologists, n.e.c.",
    "title1": "assistant cardiology supervisor",
    "title2": "assistant supervisor, cardiology",
    "title3": "cardiac catheterization technician",
    "allTitles": "assistant cardiology supervisorassistant supervisor, cardiologycardiac catheterization techniciancardiac catheterization technologistcardiac stress technologistcardiac techniciancardiology instructorcardiology supervisorcardiology techniciancardiology technologistcardiovascular techniciancardiovascular technologistcharge technologist - electrocardiographychief electroencephalograph technologistchief electromyography (EMG) technologistchief EMG (electromyography) technologistchief technologist, electroencephalographchief technologist, electromyography (EMG)chief technologist, EMG (electromyography)ECG (electrocardiographic) technicianECG (electrocardiographic) technologistechoencephalographic technologistechoencephalography technicianEEG (electroencephalograph) chief technologistEEG (electroencephalograph) technicianEEG (electroencephalograph) technologistEEG (electroencephalography) technologistelectrocardiographic (ECG) technicianelectrocardiographic (ECG) technologistelectrocardiography technicianelectrocardiography technologistelectrocardiology technicianelectrocardiology technologistelectroencephalograph (EEG) chief technologistelectroencephalograph (EEG) technicianelectroencephalograph (EEG) technologistelectroencephalographic instructorelectroencephalograph technologistelectromyography (EMG) chief technologistelectromyography (EMG) technicianelectromyography (EMG) technologistelectroneurodiagnostic (END) technologistelectroneurophysiology (ENP) technologistEMG (electromyography) chief technologistEMG (electromyography) technicianEMG (electromyography) technologistEND (electroneurodiagnostic) technologistevoked potential (EP) technologistHolter monitor technologistHolter scanning technologistneuroelectrophysiology technologistnon-registered electrocardiography technicianregistered cardiology technologistregistered electrocardiography technicianstudent cardiology technologistsupervisor, cardiologytechnician, cardiac catheterizationtechnician, cardiologytechnician, echoencephalographytechnician, electrocardiographic (ECG)technician, electrocardiographytechnician, electrocardiologytechnician, electroencephalograph (EEG)technician, electromyography (EMG)technician, EMG (electromyography)technologist, cardiac catheterizationtechnologist, cardiologytechnologist, ECG (electrocardiographic)technologist, echoencephalographictechnologist, electrocardiographic (ECG)technologist, electrocardiographytechnologist, electrocardiologytechnologist, electroencephalographtechnologist, electroencephalograph (EEG)technologist, electromyography (EMG)technologist, electroneurodiagnostic (END)technologist, EMG (electromyography)technologist, END (electroneurodiagnostic)technologist, evoked potential (EP)technologist, vascularvascular technologist",
    "workers": 410,
    "minEduc": 0,
    "yearsStudy": 2.6,
    "automationRisk": 0.23,
    "salaryLow": 15.8,
    "salaryMed": 27,
    "salaryHigh": 38.75,
    "totalSkill": 152,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 27,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 50,
    "f11Health,Nursing&ClinicalLaboratory": 340,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 50,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 340,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 187,
    "noc": 3219,
    "job": "Other medical technologists and technicians (except dental health)",
    "title1": "aeromedical instructor",
    "title2": "aeromedical technician",
    "title3": "aeromedicine technician",
    "allTitles": "aeromedical instructoraeromedical technicianaeromedicine technicianapprentice ocularistartificial eye makerartificial limb assemblerartificial limb finisherartificial limb makerassembler, artificial limbsassembler, orthopedic appliancesaviation medicine technicianbrace makercertified orthotist (CO)certified pedorthist (C Ped)certified prosthetistcertified prosthetist-orthotist (CPO)CO (certified orthotist)C Ped (certified pedorthist)CPO (certified prosthetist and orthotist)dialysis techniciandialysis technologistdietary techniciandietary technologistfinisher, artificial limbsfitter, surgical appliancesfood and nutrition technician - dieteticshemodialysis technicianhemodialysis technologistkidney dialysis techniciankidney dialysis technologistocularistocularist apprenticeocularist technicianocular prosthetistorthopedic appliance assemblerorthopedic mechanicorthotic corset makerorthotic technicianorthotistorthotist-prosthetistpedorthistpharmacy technical assistantpharmacy technicianprosthetic aideprosthetic assistantprosthetic-orthotic technicianprosthetic technicianprosthetistprosthetist assistantprosthetist-orthotistregistered orthotic technician (R.T.O.)registered prosthetic and orthotic technician (R.T.P.O.)registered prosthetic technician (R.T.P.)R.T.O. (registered orthotic technician)R.T.P.O. (registered prosthetic and orthotic technician)R.T.P. (registered prosthetic technician)surgical appliance fittersurgical fittertechnical assistant, pharmacytechnician, aeromedicinetechnician, aviation medicinetechnician, food and nutrition - dieteticstechnician, orthotictechnician, pharmacytechnician, prosthetictechnician, prosthetic-orthotic",
    "workers": 8860,
    "minEduc": 2,
    "yearsStudy": 2.728070175,
    "automationRisk": 0.4,
    "salaryLow": 14,
    "salaryMed": 19.23,
    "salaryHigh": 30.5,
    "totalSkill": 140,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 19.23,
    "skillsComp": 43,
    "skillsLogi": 39,
    "skillsMath": 17,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 19,
    "s14Writing": 7,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 275,
    "f2Engineering": 30,
    "f3Humanities": 190,
    "f4SocialScience": 90,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 20,
    "f9Law": 55,
    "f10Health": 175,
    "f11Health,Nursing&ClinicalLaboratory": 6970,
    "f12Business": 525,
    "f13Medical,Dental&Veterinary": 120,
    "d1Agriculture&BiologicalScience": 250,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 190,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 30,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 155,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 20,
    "d17Health,Nursing&ClinicalLaboratory": 6970,
    "d18Business&Commerce": 525,
    "d19Medical,Dental&Veterinary": 120,
    "equalRadius": 10
  },
  {
    "id": 188,
    "noc": 3221,
    "job": "Denturists",
    "title1": "apprentice dental mechanic",
    "title2": "dental mechanic",
    "title3": "dental mechanic apprentice",
    "allTitles": "apprentice dental mechanicdental mechanicdental mechanic apprenticedenture mechanicdenture techniciandenture therapistdenturistdenturologistmechanic, denturesstudent dental mechanicstudent denturisttechnician, denturestherapist, denture",
    "workers": 380,
    "minEduc": 2,
    "yearsStudy": 2.5,
    "automationRisk": 0.004,
    "salaryLow": 28752,
    "salaryMed": 41.569,
    "salaryHigh": 127732,
    "totalSkill": 162,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 25.26990881,
    "skillsComp": 39,
    "skillsLogi": 55,
    "skillsMath": 23,
    "skillsLang": 45,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 14,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 19,
    "s14Writing": 10,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 380,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 380,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 189,
    "noc": 3222,
    "job": "Dental hygienists and dental therapists",
    "title1": "community dental hygienist",
    "title2": "dental hygiene technician",
    "title3": "dental hygienist",
    "allTitles": "community dental hygienistdental hygiene techniciandental hygienistdental hygienist techniciandental nursedental therapistexpanded duty dental hygienistexpanded duty dental nurselicensed dental therapistorthodontic hygienistperiodontal hygienistregistered dental hygienistregistered dental therapist",
    "workers": 9050,
    "minEduc": 2,
    "yearsStudy": 3.071428571,
    "automationRisk": 0.68,
    "salaryLow": 22,
    "salaryMed": 40,
    "salaryHigh": 44,
    "totalSkill": 144,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 40,
    "skillsComp": 40,
    "skillsLogi": 32,
    "skillsMath": 20,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 10,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 21,
    "s14Writing": 7,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 100,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 45,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 250,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 8590,
    "f12Business": 45,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 100,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 45,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 250,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 8590,
    "d18Business&Commerce": 45,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 190,
    "noc": 3223,
    "job": "Dental technologists, technicians and laboratory assistants",
    "title1": "apprentice dental prosthesis maker",
    "title2": "apprentice dental technician",
    "title3": "bench moulder, dentures",
    "allTitles": "apprentice dental prosthesis makerapprentice dental technicianbench moulder, denturesCDT (certified dental technician)ceramic caster, denturesceramic denture casterceramic denture mechanicceramic denture mechanic-moulderceramic denture moulderceramic moulder, denturescertified dental techniciancrown and bridge dental techniciandental ceramic casterdental ceramic moulderdental ceramistdental laboratory assistantdental laboratory bench workerdental laboratory techniciandental laboratory technician assistantdental prosthesis makerdental techniciandental technician apprenticedental technician supervisordental technologistdenture bench moulderdenture finisherdenture framework finisherdenture packerdenture setterdenture set-up mandenture set-up man/womandenture set-up womandenture trimmer-polisherdenture wax pattern formerdenture wax pattern former - metal frameworkframework finisher, denturesmetal dental technicianocclusion rim former - denturesorthodontic band makerorthodontic dental technicianorthodontic prosthesis makerorthodontic technicianplaster moulder - denturesRDT (registered dental technician)RDT (registered dental technologist)registered dental technicianregistered dental technologistset-up man, denturesset-up man/woman, denturesset-up woman, denturessupervisor, dental techniciantechnician, dental laboratory",
    "workers": 1165,
    "minEduc": 2,
    "yearsStudy": 2.142857143,
    "automationRisk": 0.97,
    "salaryLow": 19,
    "salaryMed": 23,
    "salaryHigh": 35.9,
    "totalSkill": 100,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 23,
    "skillsComp": 30,
    "skillsLogi": 22,
    "skillsMath": 15,
    "skillsLang": 33,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 5,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 14,
    "s14Writing": 7,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1165,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1165,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 191,
    "noc": 3231,
    "job": "Opticians",
    "title1": "apprentice optician",
    "title2": "contact lens dispenser",
    "title3": "contact lens fitter",
    "allTitles": "apprentice opticiancontact lens dispensercontact lens fittercontact lens practitionercontact lens techniciandispenser, contact lensdispenser, ophthalmic devicesdispenser, optical devicesdispensing opticiandispensing optician studenteyeglasses fittereyeglasses frame fitterfitter, contact lensfitter, eyeglassesfitter, eyeglasses frameintern opticianlicensed contact lens practitionerlicensed dispensing opticianlicensed opticianlicensed practitioner, contact lensesmanaging opticianophthalmic device dispenserophthalmic dispenseroptical device dispenseroptical dispensing manageroptical frame fitteropticianoptician, dispensingoptician, studentoptometric dispenserpractitioner, contact lensesspectacle frame fitterstudent opticiantechnician, contact lensestechnician, visual orthesestechnician, visual orthotic devicesvisual orthesis technicianvisual orthotic device technician",
    "workers": 1925,
    "minEduc": 0,
    "yearsStudy": 2.772727273,
    "automationRisk": 0.71,
    "salaryLow": 14,
    "salaryMed": 24.04,
    "salaryHigh": 33,
    "totalSkill": 231,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 24.04,
    "skillsComp": 66,
    "skillsLogi": 66,
    "skillsMath": 33,
    "skillsLang": 66,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 10,
    "s2DecisionMaking": 15,
    "s3FindingInformation": 11,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 33,
    "s9ProblemSolving": 20,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 33,
    "s14Writing": 16,
    "s15CriticalThinking": 18,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 65,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1860,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 65,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1860,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 192,
    "noc": 3232,
    "job": "Practitioners of natural healing",
    "title1": "acupressure therapist",
    "title2": "acupuncture, doctor of",
    "title3": "acupuncturist",
    "allTitles": "acupressure therapistacupuncture, doctor ofacupuncturistaromatherapistauriculotherapistayurvedic practitionercertified iridologistcertified reflexologistcertified rolfercertified rolfing movement teacherchartered herbalistChinese medicine doctor (CMD)Chinese medicine practitionerclinical hypnotherapistCMD (Chinese medicine doctor)doctor of acupuncturedoctor of Chinese medicinedoctor of homeopathic therapeuticsdoctor of homeopathydoctor of Oriental medicineherbalistherbal practitionerherbal specialistherbologistherbology practitionerherboristherb practitionerholistic practitionerhomeopathhomeopathic physicianhomeopathic practitionerhomeopathisthypnotherapistiridologistmedical Qi gong pactitionerOriental medical practitionerosteopathic manual practitionerphysician, homeopathicpractitioner, Chinese medicinepractitioner, herbpractitioner, herbalpractitioner, herbologypractitioner, holisticpractitioner, homeopathicreflexologistregistered acupuncture practitionerremedial herbalistremedial herbologistrolferrolfing movement teachershamanshiatsu therapistteacher, rolfing movementtherapist, shiatsutraditional Chinese medicine practitioner",
    "workers": 1110,
    "minEduc": 2,
    "yearsStudy": 3.28125,
    "automationRisk": 0.158,
    "salaryLow": 18,
    "salaryMed": 26.385,
    "salaryHigh": 34.7125,
    "totalSkill": 175,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 31.45672125,
    "skillsComp": 52,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 65,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 9,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 24,
    "s9ProblemSolving": 10,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 24,
    "s13DocumentUse": 19,
    "s14Writing": 16,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 20,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 1045,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 1045,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 193,
    "noc": 3233,
    "job": "Licensed practical nurses",
    "title1": "certified nursing assistant (CNA)",
    "title2": "CNA (certified nursing assistant)",
    "title3": "graduate nursing assistant",
    "allTitles": "certified nursing assistant (CNA)CNA (certified nursing assistant)graduate nursing assistantlicensed nursing assistantlicensed practical nurse (L.P.N.)L.P.N. (licensed practical nurse)nursing assistant (registered - Qu�bec)operating room technicianoperating room technician - nursingregistered nursing assistant (R.N.A.)registered practical nurse (R.P.N.)R.N.A. (registered nursing assistant)R.P.N. (registered practical nurse)surgical assistant, nursingsurgical nursing assistantsurgical technician - nursingtechnician, operating room - nursingtechnician, surgical - nursing",
    "workers": 14155,
    "minEduc": 2,
    "yearsStudy": 2.549019608,
    "automationRisk": 0.058,
    "salaryLow": 19,
    "salaryMed": 24.7,
    "salaryHigh": 31,
    "totalSkill": 137,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 24.7,
    "skillsComp": 34,
    "skillsLogi": 42,
    "skillsMath": 9,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 9,
    "s14Writing": 13,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 40,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 14050,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 14050,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 194,
    "noc": 3234,
    "job": "Paramedical occupations",
    "title1": "advanced care paramedic",
    "title2": "advanced emergency medical assistant",
    "title3": "advanced life support attendant",
    "allTitles": "advanced care paramedicadvanced emergency medical assistantadvanced life support attendantadvanced life support co-ordinatoradvanced life support paramedicambulance attendantambulance attendants supervisorambulance attendant traineeambulance driverambulance driver-attendantambulance services field supervisorambulance services supervisorambulance services unit chiefambulance technicianassistant paramedicattendant, advanced life supportattendant, ambulanceattendant, infant transportchief ambulance attendantcritical care paramedicdrilling rig medicdrilling rig medical techniciandrilling rig medical wardendrilling rig medical workerdriver, ambulanceEMA (emergency medical attendant)emergency medical assistantemergency medical attendant (EMA)emergency medical care technician, newbornsemergency medical technician (EMT)emergency medical technician, paramedicemergency medical technician - paramedic/advanced care paramedic (EMT - P/ACP)emergency medical technician - primary care paramedic (EMT - PCP)emergency medical technologist - paramedic (EMT-P)emergency paramedicEMT (emergency medical technician)EMT-P (emergency medical technologist - paramedic)field supervisor, ambulance servicesinfant transport attendantintermediate care paramedicmedical assistant (paramedic)medical care technician, newbornsmedical technicianmedical technician, drilling rigmedical warden, drilling rigmedic, drilling rignewborn emergency medical care techniciannewborn medical care technicianparamedicparamedic workerprimary care paramedicregistered emergency paramedicsupervisor ambulance attendantssupervisor, ambulance servicestechnician, ambulanceunit chief, ambulance services",
    "workers": 6925,
    "minEduc": 2,
    "yearsStudy": 2.773584906,
    "automationRisk": 0.049,
    "salaryLow": 25,
    "salaryMed": 37.08,
    "salaryHigh": 41,
    "totalSkill": 251,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 37.08,
    "skillsComp": 50,
    "skillsLogi": 58,
    "skillsMath": 33,
    "skillsLang": 110,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 18,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 22,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 11,
    "s8OralCommunication": 43,
    "s9ProblemSolving": 23,
    "s10Reading": 47,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 33,
    "s14Writing": 20,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 80,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 130,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 140,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 140,
    "f11Health,Nursing&ClinicalLaboratory": 6405,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 80,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 130,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 140,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 140,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 6405,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 195,
    "noc": 3236,
    "job": "Massage therapists",
    "title1": "massage therapist (MT)",
    "title2": "masso kinesitherapist",
    "title3": "massotherapist",
    "allTitles": "massage therapist (MT)masso kinesitherapistmassotherapistMT (massage therapist)myotherapistorthotherapistregistered massage practitionerregistered massage therapist (RMT)RMT (registered massage therapist)Thai massage therapisttherapist, massage",
    "workers": 6740,
    "minEduc": 0,
    "yearsStudy": 3.096153846,
    "automationRisk": 0.54,
    "salaryLow": 14,
    "salaryMed": 19.72,
    "salaryHigh": 33.85,
    "totalSkill": 135,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 19.72,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 40,
    "f2Engineering": 0,
    "f3Humanities": 20,
    "f4SocialScience": 95,
    "f5FineArts": 120,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 245,
    "f8Education(teachertraining)": 45,
    "f9Law": 10,
    "f10Health": 245,
    "f11Health,Nursing&ClinicalLaboratory": 5905,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 95,
    "d6Fine&AppliedArts": 120,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 245,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 0,
    "d11Law": 10,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 245,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 5905,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 196,
    "noc": 3237,
    "job": "Other technical occupations in therapy and assessment",
    "title1": "aide, physical therapy",
    "title2": "aide, speech",
    "title3": "aide, speech therapy",
    "allTitles": "aide, physical therapyaide, speechaide, speech therapyassistant, audiometricassistant, communication disordersassistant, hearing aidassistant, occupational therapistassistant, occupational therapyassistant, ophthalmicassistant, speech languageassistant, speech therapyassistive listening device technicianaudiological technicianaudiology technicianaudiometric aideaudiometric assistantaudiometricianaudiometric technicianaudiometric technician - public healthaudiometristaudiometrist aidecommunication aide - medicalcommunication assistant - medicalcommunication disorders assistantcommunication disorders instructorcommunicative disorders assistantcommunicative disorders instructorhearing aid assistanthearing aid consultanthearing aid dealerhearing aid dealer and consultanthearing aid practitionerhearing aid specialisthearing aid technicianhearing assessment technicianhearing disorder technicianhearing instrument dispenserhearing instrument practitionerhearing instrument practitioner assistanthearing instrument specialistindustrial audiometric technicianinstructor, communication disorderskinesitherapistlicensed hearing instrument specialistmanual arts therapistoccupational therapist assistantoccupational therapy assistantoccupational therapy technicianophthalmic assistantophthalmic medical assistantophthalmic medical technicianophthalmic medical technologistophthalmic technicianophthalmic technician (except retail)ophthalmic technologistophthalmologist assistantphysical rehabilitation technicianphysical therapist assistant (PTA)physical therapy aidephysical therapy technicianphysiotherapist assistant (PTA)physiotherapy aidephysiotherapy assistantphysiotherapy technicianPTA (physical therapist assistant)speech aidespeech correctionist - medicalspeech language assistantspeech-language pathology assistantspeech technicianspeech therapist aidespeech therapist assistantspeech therapy aidespeech therapy assistanttechnician, assistive listening devicestechnician, audiologytechnician, audiometrictechnician, hearing aidstechnician, hearing assessmenttechnician, hearing disorderstechnician, occupational therapytechnician, ophthalmic (except retail)technician, physical rehabilitationtechnician, physiotherapytechnician, speechtechnologist, ophthalmic",
    "workers": 790,
    "minEduc": 0,
    "yearsStudy": 2.772727273,
    "automationRisk": 0.373,
    "salaryLow": 18,
    "salaryMed": 26.385,
    "salaryHigh": 34.7125,
    "totalSkill": 146,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 30.03851296,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 15,
    "f4SocialScience": 35,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 30,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 710,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 35,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 30,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 710,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 197,
    "noc": 3411,
    "job": "Dental assistants",
    "title1": "certified dental assistant",
    "title2": "certified intra-oral dental assistant",
    "title3": "chair-side assistant - dental",
    "allTitles": "certified dental assistantcertified intra-oral dental assistantchair-side assistant - dentaldental aidedental assistantdental clinical assistantintra-oral dental assistantlicensed dental assistantpreventive dental assistantregistered dental assistant",
    "workers": 10070,
    "minEduc": 1,
    "yearsStudy": 2.604166667,
    "automationRisk": 0.51,
    "salaryLow": 15,
    "salaryMed": 19.23,
    "salaryHigh": 26,
    "totalSkill": 103,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Assisting occupations in support of health services",
    "cluster": 8,
    "wage": 19.23,
    "skillsComp": 36,
    "skillsLogi": 24,
    "skillsMath": 13,
    "skillsLang": 30,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 5,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 13,
    "s14Writing": 6,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 20,
    "f2Engineering": 0,
    "f3Humanities": 60,
    "f4SocialScience": 35,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 65,
    "f8Education(teachertraining)": 30,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 9685,
    "f12Business": 175,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 60,
    "d5SocialSciences": 35,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 65,
    "d9Education(teachertraining)": 30,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 9685,
    "d18Business&Commerce": 175,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 198,
    "noc": 3413,
    "job": "Nurse aides, orderlies and patient service associates",
    "title1": "aide, emergency room",
    "title2": "aide, health care",
    "title3": "aide, hospital",
    "allTitles": "aide, emergency roomaide, health careaide, hospitalaide, hospital wardaide, medicalaide, neuropsychiatricaide, nursery - hospitalaide, operating roomaide, patient careaide, psychiatricaide, special care - nursingaide, surgicalanesthetic attendant - hospitalassistant, emergency medical careattendant, hospitalattendant, nursingattendant, nursing homeattendant, personal care - medicalattendant, special care facilitycontinuing care assistant(EMCA) emergency medical care attendantemergency medical care assistantemergency medical care attendant (EMCA)emergency medical responderemergency room aideenvironmental assistant - medicalenvironmental support person - medicalfirst aid attendantfirst aid attendant - emergencygeriatric aidegeriatric health care attendanthealth care aidehealth care assistanthospice workerhospital aidehospital attendanthospital orderlyhospital porterhospital ward aidehostel service aide - medicalinstitutional aidelong term care aidemedical aidemedical attendant - patient transfermedical orderlyneuropsychiatric aidenurse aidenursery aide - hospitalnursing assistant (non-registered)nursing attendantnursing home attendantnursing orderlynursing services aideoperating room aideorderlypatient care aidepatient care assistantpatient care associatepatient service aidepatient service assistantpatient service associatepatient service attendantpatient service workerpersonal care aide - medicalpersonal care attendant - medicalpersonal care provider - medicalpersonal support aide - medicalpsychiatric aideregistered care aideresident care aide - medicalresident companion - medicalrespite care aideservice assistant - medicalservice associate - medicalservice attendant - medicalspecial care aide - nursingspecial care facility attendantspecial care worker - medicalsupport services assistant - medicalsurgical aideunit aide - medicalunit assistant - medicalunit support technician - medicalward aide - medical",
    "workers": 47400,
    "minEduc": 0.5,
    "yearsStudy": 2.512201454,
    "automationRisk": 0.6675,
    "salaryLow": 14.25,
    "salaryMed": 20,
    "salaryHigh": 32,
    "totalSkill": 106,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Assisting occupations in support of health services",
    "cluster": 8,
    "wage": 18.5,
    "skillsComp": 27.5,
    "skillsLogi": 31.5,
    "skillsMath": 11,
    "skillsLang": 36.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 8.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 11.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 11.5,
    "s13DocumentUse": 13,
    "s14Writing": 6.5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 220,
    "f2Engineering": 145,
    "f3Humanities": 1695,
    "f4SocialScience": 805,
    "f5FineArts": 345,
    "f6MathAndComputerScience": 95,
    "f7Arts&Education": 1845,
    "f8Education(teachertraining)": 805,
    "f9Law": 530,
    "f10Health": 1085,
    "f11Health,Nursing&ClinicalLaboratory": 36930,
    "f12Business": 2415,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 100,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 1695,
    "d5SocialSciences": 805,
    "d6Fine&AppliedArts": 345,
    "d7ComputerScience": 95,
    "d8OtherArts&Science": 1845,
    "d9Education(teachertraining)": 805,
    "d10Engineering": 145,
    "d11Law": 530,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 220,
    "d14Theology": 0,
    "d15PhysicalSciences": 120,
    "d16Therapy&Rehabilitation": 865,
    "d17Health,Nursing&ClinicalLaboratory": 36930,
    "d18Business&Commerce": 2415,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 199,
    "noc": 3414,
    "job": "Other assisting occupations in support of health services",
    "title1": "activationist - health support services",
    "title2": "activities co-ordinator - health support services",
    "title3": "activity aide - health support services",
    "allTitles": "activationist - health support servicesactivities co-ordinator - health support servicesactivity aide - health support servicesactivity leader - seniorsactivity worker - health support servicesacupuncture assistantacupuncture attendantadjuvantaide, chiropracticaide, occupational therapyaide, pharmacyaide, supply, processing and distribution - medicalantireflection (AR) coating technician, ophthalmic goodsAR (antireflection) coating technician, ophthalmic goodsassistant, acupunctureassistant, autopsiesassistant, blood donor clinicassistant, chiropractic healthassistant, clinic - medicalassistant, herbal medicineassistant, orthopedicassistant, phytotherapyattendant, blood samplingattendant, fracture roomattendant, morgueattendant, physiotherapyattendant, plaster roomattendant, post-mortemautopsy assistantautopsy attendantautopsy technicianbench worker, ophthalmic goodsblood donor clinic assistantblood donor clinic attendantblood donor clinic helperblood sampling attendantcast room techniciancentral service room worker - hospitalcentral supply aidecentral supply aide - medicalcentral supply room supervisor - hospitalcentral supply room technician - hospitalchiropractic aidechiropractic assistantchiropractic health assistantchiropractic office assistantchiropractor aideclinical laboratory helperclinic assistant - medicaldispensary assistantdispensing assistant, drugstoredrugstore dispensing assistantdrugstore side room attendantedge grinder, ophthalmic lensesemergency-entry attendant - hospitalemergency room attendantfracture room attendantgrinder, ophthalmic lenseshealth aidehelper, blood donor clinichelper, occupational therapyhelper, physiotherapyherbal medicine assistantinspector, optical goodsinspector, optical lensesinstrument sterilizer - medicallaboratory technician, ophthalmic - retaillaboratory technician, optical - retaillens coating technician, ophthalmic goodslens cutter, ophthalmic goodslens grinder, ophthalmiclens grinder-polisher setterlens marker - health support serviceslens marker - ophthalmiclens picker, optical and ophthalmic goodslens tinter, ophthalmic goodsmarker, ophthalmic lensesmechanic, optical lab - retailmedical clinic assistantmedical instrument sterilizermedical material handlermorgue attendantmorgue technicianoccupational therapy aideoccupational therapy helperophthalmic goods bench workerophthalmic laboratory technician - retailophthalmic lab technician - retailophthalmic lens bench workerophthalmic lens cutterophthalmic lens edge grinderophthalmic lens grinderophthalmic lens grinder and polisherophthalmic lens grinder-polisher setterophthalmic lens inspectorophthalmic lens markeroptical goods inspectoroptical lab mechanic - retailoptical laboratory assistantoptical laboratory technician",
    "workers": 4785,
    "minEduc": 1,
    "yearsStudy": 2.433962264,
    "automationRisk": 0.594,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 30,
    "totalSkill": 132,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Assisting occupations in support of health services",
    "cluster": 8,
    "wage": 17,
    "skillsComp": 39,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 12,
    "s14Writing": 7,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 75,
    "f2Engineering": 30,
    "f3Humanities": 105,
    "f4SocialScience": 110,
    "f5FineArts": 25,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 340,
    "f8Education(teachertraining)": 0,
    "f9Law": 35,
    "f10Health": 460,
    "f11Health,Nursing&ClinicalLaboratory": 3435,
    "f12Business": 145,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 75,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 105,
    "d5SocialSciences": 110,
    "d6Fine&AppliedArts": 25,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 340,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 30,
    "d11Law": 35,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 320,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 140,
    "d17Health,Nursing&ClinicalLaboratory": 3435,
    "d18Business&Commerce": 145,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 200,
    "noc": 4011,
    "job": "Chefs",
    "title1": "agriculture professor - university",
    "title2": "anatomy professor - university",
    "title3": "anthropology professor - university",
    "allTitles": "agriculture professor - universityanatomy professor - universityanthropology professor - universityarchaeology professor - universityAsian studies professor - universityassistant professor, botanyassistant professor, botany - universityassistant professor, history - universityassistant professor - universityassociate professor, linguisticsassociate professor - universityastronomy professor - universitybacteriology professor - universitybiochemistry professor - universitybiology professor - universitybiomechanics professor - universitybotany professor - universitybusiness administration professor - universitychairman, food sciences department - universitychairman, geography department - universitychairman, linguistics department - universitychairman, physics department - universitychairman, theology department - universitychairman, visual arts department - universitychairman/woman, food sciences department - universitychairman/woman, geography department - universitychairman/woman, linguistics department - universitychairman/woman, physics department - universitychairman/woman, theology department - universitychairman/woman, visual arts department - universitychairperson, food sciences departmentchairperson, food sciences department - universitychairperson, geography department - universitychairperson, linguistics department - universitychairperson, physics departmentchairperson, physics department - universitychairperson, theology department - universitychairperson, visual arts department - universitychairwoman, food sciences department - universitychairwoman, geography department - universitychairwoman, linguistics department - universitychairwoman, physics department - universitychairwoman, theology department - universitychairwoman, visual arts department - universitychemical engineering professor - universitychemistry professor - universitycivil engineering professor - universityclassics professor - universitycomputer science professor - universitycriminology professor - universitydentistry professor - universitydepartment chairman - universitydepartment chairman/woman - universitydepartment chairperson - universitydepartment chairwoman - universitydepartment head, food sciences - universitydepartment head, geographydepartment head, geography - universitydepartment head, linguistics - universitydepartment head, physics - universitydepartment head, theology - universitydepartment head - universitydepartment head, visual arts - universitydrama professor - universityeconomics professor - universityeducation professor - universityelectrical engineering professor - universityengineering and architecture professor - universityengineering professor - universityEnglish professor - universityfine arts professor - universityfood science professor - universityforestry professor - universityFrench language professor - universityfull professor - universitygeography professor - universitygeology professor - universitygeophysics professor - universityhistory professor - universityhumanities professor - universityhygiene professor - universityindustrial engineering professor - universityjournalism professor - universitylaboratory technology professor - universitylanguage professor - universitylaw professor - universitylecturer - universitylecturer, universitylibrary science professor - universitylife sciences professor - universitylinguistics professor - universityliterature professor - universitymathematics professor - universitymechanical engineering professor - universitymedical sciences professor - universitymedicine professor - universitymetallurgical engineering professor - universitymetallurgy professor - universitymeteorology professor - universitymusic professor - university",
    "workers": 34100,
    "minEduc": 0,
    "yearsStudy": 3.727248677,
    "automationRisk": 0.066,
    "salaryLow": 21.5,
    "salaryMed": 43,
    "salaryHigh": 76.92,
    "totalSkill": 160.5,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 29.515,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10.5,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 7.5,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16.5,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 3940,
    "f2Engineering": 1900,
    "f3Humanities": 2230,
    "f4SocialScience": 4770,
    "f5FineArts": 2570,
    "f6MathAndComputerScience": 1295,
    "f7Arts&Education": 430,
    "f8Education(teachertraining)": 2390,
    "f9Law": 330,
    "f10Health": 395,
    "f11Health,Nursing&ClinicalLaboratory": 1540,
    "f12Business": 1685,
    "f13Medical,Dental&Veterinary": 70,
    "d1Agriculture&BiologicalScience": 2280,
    "d2Forestry": 135,
    "d3Architecture&LandscapeArchitecture": 135,
    "d4Humanities": 1355,
    "d5SocialSciences": 4770,
    "d6Fine&AppliedArts": 2570,
    "d7ComputerScience": 610,
    "d8OtherArts&Science": 430,
    "d9Education(teachertraining)": 2390,
    "d10Engineering": 1765,
    "d11Law": 330,
    "d12Mathematics": 685,
    "d13Kinesiology/Recreation/PhysicalEducation": 150,
    "d14Theology": 875,
    "d15PhysicalSciences": 1525,
    "d16Therapy&Rehabilitation": 245,
    "d17Health,Nursing&ClinicalLaboratory": 1540,
    "d18Business&Commerce": 1685,
    "d19Medical,Dental&Veterinary": 70,
    "equalRadius": 10
  },
  {
    "id": 201,
    "noc": 4012,
    "job": "Metalworking and forging machine operators",
    "title1": "college laboratory assistant",
    "title2": "college teaching assistant",
    "title3": "demonstrator, laboratory - post-secondary teaching assistance",
    "allTitles": "college laboratory assistantcollege teaching assistantdemonstrator, laboratory - post-secondary teaching assistancediscussion group leader - post-secondary teaching assistantgraduate assistant - universitylaboratory assistant, collegelaboratory assistant, universitylaboratory demonstrator - post-secondary teaching assistancelaboratory supervisor - post-secondary teaching assistantmarker - post-secondary teaching assistancepost-secondary research assistantpost-secondary teaching assistantresearch assistant - post-secondaryresearch assistant, universityteaching assistant, collegeteaching assistant - post-secondaryteaching assistant - universityteaching assistant, universitytutor - post-secondary teaching assistantuniversity laboratory assistantuniversity research assistantuniversity teaching assistant",
    "workers": 27245,
    "minEduc": 0,
    "yearsStudy": 3.045530146,
    "automationRisk": 0.753,
    "salaryLow": 14,
    "salaryMed": 23.41,
    "salaryHigh": 46.2,
    "totalSkill": 130.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in education services",
    "cluster": 5,
    "wage": 22.19169923,
    "skillsComp": 35.5,
    "skillsLogi": 32.5,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17.5,
    "s14Writing": 11.5,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 7590,
    "f2Engineering": 3615,
    "f3Humanities": 1445,
    "f4SocialScience": 4435,
    "f5FineArts": 1195,
    "f6MathAndComputerScience": 1310,
    "f7Arts&Education": 2130,
    "f8Education(teachertraining)": 735,
    "f9Law": 300,
    "f10Health": 690,
    "f11Health,Nursing&ClinicalLaboratory": 1635,
    "f12Business": 1045,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 4915,
    "d2Forestry": 350,
    "d3Architecture&LandscapeArchitecture": 200,
    "d4Humanities": 955,
    "d5SocialSciences": 4435,
    "d6Fine&AppliedArts": 1195,
    "d7ComputerScience": 750,
    "d8OtherArts&Science": 2130,
    "d9Education(teachertraining)": 735,
    "d10Engineering": 3415,
    "d11Law": 300,
    "d12Mathematics": 560,
    "d13Kinesiology/Recreation/PhysicalEducation": 525,
    "d14Theology": 490,
    "d15PhysicalSciences": 2325,
    "d16Therapy&Rehabilitation": 165,
    "d17Health,Nursing&ClinicalLaboratory": 1635,
    "d18Business&Commerce": 1045,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 202,
    "noc": 4021,
    "job": "College and other vocational instructors",
    "title1": "academic subjects teacher - college level",
    "title2": "accounting teacher - college level",
    "title3": "administration teacher",
    "allTitles": "academic subjects teacher - college levelaccounting teacher - college leveladministration teacheradvertising art teacheragricultural college teacheragricultural school teacherairline customer-service instructorapparel design teacherappliance servicing teacher - vocational instituteapplied arts teacher - college levelarchitectural technology instructorautomotive repair instructor - community collegeBible college teacherBible school teacherbookkeeping teacherbusiness administration teacherbusiness administration teacher - college levelbusiness college instructorbusiness college teacherbusiness law teacherbusiness subjects teacher - vocational instituteCEGEP (general and vocational college) teacherCEGEP teacherchemical technology teacherchemistry teacher - agricultural schoolchild-care service teacherchild-care service teacher - college levelclothing design teachercollege instructorcollege lecturercollege of applied arts and technology instructorcollege of applied arts and technology teachercollege teachercommercial art instructorcommercial art teachercommercial subjects teacher - vocational institutecommercial vehicle driver instructorcommunications teacher - college levelcommunity-based trainercommunity college instructorcommunity college teachercommunity planning teacher - college levelcompany trainercomputer-assisted drafting (CAD) instructorcomputer-based trainercomputer programming instructor - college levelcomputer science teacher - college levelcomputer trainercomputer training instructorcomputer training representativecorrespondence school instructorcorrespondence school tutorcorrespondence teacher - college levelcourt reporting instructordata-processing teacher - college leveldenominational institute teacherdental assistant program teacher - community collegedental hygienist program teacherdepartment chairman - collegedepartment chairman - community collegedepartment chairman/woman - collegedepartment chairman/woman - community collegedepartment chairperson - collegedepartment chairperson - community collegedepartment chairwoman - collegedepartment chairwoman - community collegedepartment head - CEGEPdepartment head - collegedepartment head - community collegedepartment head - institute of technologydepartment head - private training institutedepartment head - technical institutedepartment head - vocational institutedirect sales instructordrafting instructordrafting instructor - college leveldrafting teacherdrafting teacher - college leveldriving instructor, commercial vehiclesearly childhood education instructor - college levelearly childhood education teacher - college leveleconomics teacher - college levelelectrolysis instructor - vocational instituteelectromechanical technology teacher - college levelelectronic technology teacher - college levelelocution teacher - non-medicalembalming teacherEnglish as a second language teacher (ESL) - college levelEnglish teacher - business collegeEnglish teacher - college levelESL (English as a second language) teacher - college levelfashion design teacher - CEGEPfashion teacher - college levelfine arts teacher - college levelfirefighters instructorfirefighting instructorflight attendants instructorFrench as a second language teacher (except elementary, high school or university)gliding instructorgraphic arts teacher",
    "workers": 25255,
    "minEduc": 0,
    "yearsStudy": 3.631889764,
    "automationRisk": 0.032,
    "salaryLow": 19.23,
    "salaryMed": 33.33,
    "salaryHigh": 69.23,
    "totalSkill": 164,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in education services",
    "cluster": 5,
    "wage": 33.33,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 1115,
    "f2Engineering": 1640,
    "f3Humanities": 990,
    "f4SocialScience": 2520,
    "f5FineArts": 2600,
    "f6MathAndComputerScience": 840,
    "f7Arts&Education": 2160,
    "f8Education(teachertraining)": 6105,
    "f9Law": 615,
    "f10Health": 920,
    "f11Health,Nursing&ClinicalLaboratory": 2245,
    "f12Business": 3505,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 385,
    "d2Forestry": 65,
    "d3Architecture&LandscapeArchitecture": 150,
    "d4Humanities": 725,
    "d5SocialSciences": 2520,
    "d6Fine&AppliedArts": 2600,
    "d7ComputerScience": 555,
    "d8OtherArts&Science": 2160,
    "d9Education(teachertraining)": 6105,
    "d10Engineering": 1490,
    "d11Law": 615,
    "d12Mathematics": 285,
    "d13Kinesiology/Recreation/PhysicalEducation": 380,
    "d14Theology": 265,
    "d15PhysicalSciences": 665,
    "d16Therapy&Rehabilitation": 540,
    "d17Health,Nursing&ClinicalLaboratory": 2245,
    "d18Business&Commerce": 3505,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 203,
    "noc": 4031,
    "job": "Secondary school teachers",
    "title1": "Aboriginal school community teacher - secondary school",
    "title2": "academic subjects high school teacher",
    "title3": "academic subjects secondary school teacher",
    "allTitles": "Aboriginal school community teacher - secondary schoolacademic subjects high school teacheracademic subjects secondary school teacheraccounting teacher - secondary schooladult education teacher, secondary schoolalgebra teacher - secondary schoolarts and crafts teacher - secondary schoolart teacher - secondary schoolbiology teacher, high schoolbiology teacher - secondary schoolbusiness and commerce teacher - secondary schoolbusiness education teacherbusiness teacher - secondary schoolcalculus teacher - secondary schoolcareer and life management teachercareer and technology studies teachercareer education teachercareer exploration teacherchemistry teacher - secondary schoolclassical languages secondary school teachercommerce teacher - secondary schoolcommunity teacher, Aboriginal school - secondary schoolcommunity teacher, Native school - secondary schoolcomputer technology teacher - secondary schoolcooking teacher - secondary schoolcooperative education teachercooperative learning teachercorrespondence teacher - secondary schooldata processing teacher - secondary schooldepartment head, secondary schooldistance education teacher - secondary schooldrama teacher - secondary schooleconomics teacher - secondary schoolEnglish as a second language (ESL) high school teacherEnglish as a second language teacher, high schoolEnglish literature high school teacherEnglish teacher, secondary schoolESL (English as a second language) high school teacherethics teacher - secondary schoolfine arts teacher - secondary schoolFrench as a second language teacher, high schoolFrench as a second language teacher - secondary schoolFrench teacher - secondary schoolgeography teacher - secondary schoolgeometry teacher - secondary schoolGerman teacher - secondary schoolGreek teacher - secondary schoolguest teacher - secondary schoolhealth education teacher - secondary schoolhigh school teacherhigh school teacher, English as a second languagehigh school teacher, French as a second languagehigh school teacher, outdoor activitieshigh school teacher, physical educationhigh school teacher, religious educationhigh school teacher, sciencehigh school teacher, special educationhistory teacher, secondary schoolhome economics teacher - secondary schoolhumanities teacher - high schoolindustrial and vocational education teacher - secondary schoolindustrial arts teacher - secondary schoolinformation technology teacher - secondary schoolItalian teacher - secondary schoolLatin teacher - secondary schoollibrarian-teacher, high schoolmathematics teacher - secondary schoolmodern languages teacher - secondary schoolmusic teacher - secondary schoolNative school community teacher - secondary schooloutdoor physical education teacher - secondary schoolphysical and health education teacher - secondary schoolphysical education teacher - secondary schoolphysical science teacher - secondary schoolphysics teacher - secondary schoolpractical and applied arts teacherprivate teacher - secondary schoolreading clinician - secondary schoolreligious education high school teacherremedial teacher - secondary schoolremedial teacher, secondary schoolschool teacher - secondary schoolscience high school teacherscience teacher - secondary schoolsecondary school department headsecondary school reading cliniciansecondary school teachersecondary school teacher, classical languagessecondary school teacher, physical educationsecondary school teacher, special educationsecondary school vocational teachersewing teacher - secondary schoolsheet metal instructor - secondary schoolsocial sciences teacher - secondary schoolSpanish teacher - secondary schoolspecial education teacher - secondary schoolspecial needs teacher - secondary schoolspecial programs teacher - secondary schoolsubstitute high school teachersubstitute teacher - secondary school",
    "workers": 69045,
    "minEduc": 0,
    "yearsStudy": 4.353808354,
    "automationRisk": 0.008,
    "salaryLow": 22.5,
    "salaryMed": 44.87,
    "salaryHigh": 54.73,
    "totalSkill": 170,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in education services",
    "cluster": 5,
    "wage": 44.87,
    "skillsComp": 46,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 18,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 2505,
    "f2Engineering": 970,
    "f3Humanities": 2915,
    "f4SocialScience": 3080,
    "f5FineArts": 3715,
    "f6MathAndComputerScience": 1810,
    "f7Arts&Education": 3025,
    "f8Education(teachertraining)": 47035,
    "f9Law": 195,
    "f10Health": 2010,
    "f11Health,Nursing&ClinicalLaboratory": 270,
    "f12Business": 1515,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1145,
    "d2Forestry": 265,
    "d3Architecture&LandscapeArchitecture": 15,
    "d4Humanities": 2445,
    "d5SocialSciences": 3080,
    "d6Fine&AppliedArts": 3715,
    "d7ComputerScience": 255,
    "d8OtherArts&Science": 3025,
    "d9Education(teachertraining)": 47035,
    "d10Engineering": 955,
    "d11Law": 195,
    "d12Mathematics": 1555,
    "d13Kinesiology/Recreation/PhysicalEducation": 1915,
    "d14Theology": 470,
    "d15PhysicalSciences": 1095,
    "d16Therapy&Rehabilitation": 95,
    "d17Health,Nursing&ClinicalLaboratory": 270,
    "d18Business&Commerce": 1515,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 204,
    "noc": 4032,
    "job": "Elementary school and kindergarten teachers",
    "title1": "art teacher - elementary school",
    "title2": "cooking teacher - elementary school",
    "title3": "correspondence teacher - elementary school",
    "allTitles": "art teacher - elementary schoolcooking teacher - elementary schoolcorrespondence teacher - elementary schoolcrafts teacher - elementary schoolearly childhood services teacher - elementary schoolelementary school reading clinicianelementary school substitute teacherelementary school supply teacherelementary school teacherelementary school teacher, English as a second languageelementary school teacher, French as a second languageelementary school teacher, special educationEnglish as a second language teacher - elementary schoolEnglish teacher - elementary schoolFrench as a second language teacher - elementary schoolFrench immersion teacher - elementary schoolFrench teacher - elementary schoolgrade school teacherhome economics teacher - elementary schoolindustrial arts teacher - elementary schooljunior high school teacherkindergarten teacherlanguage teacher - elementary schoollibrarian-teacher, elementary schoolmusic teacher - elementary schoolnature study teacher - elementary schoolphysical education teacher - elementary schoolprimary school teacherreading clinician - elementary schoolremedial teacher - elementary schoolsewing teacher - elementary schoolspecial education teacher - elementary schoolspecial education teacher - primary schoolspecial needs teacher - elementary schoolsubstitute teacher - elementary schoolsupply teacher - elementary schoolteacher, Aboriginal school - elementary schoolteacher, elementary schoolteacher, English as a second language - elementary schoolteacher, French as a second language - elementary schoolteacher - junior kindergartenteacher, kindergartenteacher-librarian, elementary schoolteacher, primary schoolvisiting teacher - elementary school",
    "workers": 120415,
    "minEduc": 0,
    "yearsStudy": 4.213219616,
    "automationRisk": 0.004,
    "salaryLow": 19.23,
    "salaryMed": 38.46,
    "salaryHigh": 50.55,
    "totalSkill": 167,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in education services",
    "cluster": 5,
    "wage": 38.46,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 1315,
    "f2Engineering": 435,
    "f3Humanities": 5160,
    "f4SocialScience": 6605,
    "f5FineArts": 4210,
    "f6MathAndComputerScience": 560,
    "f7Arts&Education": 4725,
    "f8Education(teachertraining)": 91860,
    "f9Law": 280,
    "f10Health": 2225,
    "f11Health,Nursing&ClinicalLaboratory": 1060,
    "f12Business": 1980,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 730,
    "d2Forestry": 245,
    "d3Architecture&LandscapeArchitecture": 25,
    "d4Humanities": 4730,
    "d5SocialSciences": 6605,
    "d6Fine&AppliedArts": 4210,
    "d7ComputerScience": 105,
    "d8OtherArts&Science": 4725,
    "d9Education(teachertraining)": 91860,
    "d10Engineering": 410,
    "d11Law": 280,
    "d12Mathematics": 455,
    "d13Kinesiology/Recreation/PhysicalEducation": 1850,
    "d14Theology": 430,
    "d15PhysicalSciences": 340,
    "d16Therapy&Rehabilitation": 375,
    "d17Health,Nursing&ClinicalLaboratory": 1060,
    "d18Business&Commerce": 1980,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 205,
    "noc": 4033,
    "job": "Educational counsellors",
    "title1": "academic adviser",
    "title2": "academic adviser, First Nations studies program",
    "title3": "academic counsellor",
    "allTitles": "academic adviseracademic adviser, First Nations studies programacademic counselloracademic skills counselloradjustment officer, schooladviser, academiccareer counsellor - educationcollege counsellorco-op officercounselling interncounsellor for Aboriginal studentscounsellor, schooldirector, educational guidanceeducational counselloreducational guidance directoreducation officerFirst Nations counsellor - EducationFirst Nations studies program academic adviserguidance counsellorguidance service headhead, school guidance departmentindependent or applied studies officerinternational student adviserlearning and study skills specialistpersonal academic counsellorpersonal counsellor - educationschool adjustment officerschool counsellorschool guidance department headstudent affairs and employment officerstudent counsellorstudent employment services co-ordinatorstudent services counselloruniversity counsellorvocational counsellor - education",
    "workers": 3045,
    "minEduc": 0,
    "yearsStudy": 3.946666667,
    "automationRisk": 0.009,
    "salaryLow": 20.865,
    "salaryMed": 41.665,
    "salaryHigh": 52.64,
    "totalSkill": 158,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in education services",
    "cluster": 5,
    "wage": 36.87019345,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 20,
    "f2Engineering": 0,
    "f3Humanities": 205,
    "f4SocialScience": 540,
    "f5FineArts": 75,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 90,
    "f8Education(teachertraining)": 1505,
    "f9Law": 25,
    "f10Health": 435,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 150,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 190,
    "d5SocialSciences": 540,
    "d6Fine&AppliedArts": 75,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 90,
    "d9Education(teachertraining)": 1505,
    "d10Engineering": 0,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 45,
    "d14Theology": 15,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 390,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 150,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 206,
    "noc": 4111,
    "job": "Judges",
    "title1": "administrative judge",
    "title2": "appellate court judge",
    "title3": "associate chief justice",
    "allTitles": "administrative judgeappellate court judgeassociate chief justicechief justicecounty court judgecounty judgeCourt of Queen's Bench justicedeputy justicedistrict and surrogate court judgedistrict court judgefamily court judgefederal court justicefederal court justice - trial divisionFederal Court of Appeal justicefederal trial court justicejudge - lawjusticejuvenile court judgemagistrate court judgeprobate court judgeprovincial court judgeprovincial court of appeal justiceprovincial supreme court justicepuisne judgesmall claims court judgesuperior court justiceSupreme Court justiceSupreme Court of Canada justiceTax Court judgetrial court judgeyouth court judge",
    "workers": 805,
    "minEduc": 0,
    "yearsStudy": 4.666666667,
    "automationRisk": 0.4,
    "salaryLow": 51.2,
    "salaryMed": 116.18,
    "salaryHigh": 132.31,
    "totalSkill": 185,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 116.18,
    "skillsComp": 49,
    "skillsLogi": 47,
    "skillsMath": 26,
    "skillsLang": 62,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 22,
    "s13DocumentUse": 20,
    "s14Writing": 18,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 805,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 805,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 207,
    "noc": 4112,
    "job": "Lawyers and Quebec notaries",
    "title1": "administrative lawyer",
    "title2": "adviser, law and corporate affairs",
    "title3": "advisory counsel",
    "allTitles": "administrative lawyeradviser, law and corporate affairsadvisory counseladvocate, legalarticling law studentassistant corporate counselassistant Crown attorneyassistant general solicitorassistant legal advisorassistant regional counselassociate counselassociate lawyerassociate legal advisorassociate legal counselattorneyattorney-at-lawattorney's assistant chief agentbarristerbarrister and solicitorcity attorneycity solicitorcivil lawyerclaim attorneycommercial law notarycommercial lawyercontract counselcorporate counselcorporate notary (Quebec)corporation lawyercounselcounsellor-at-lawcounsellor-lawyercounty attorneycriminal lawyerCrown attorneyCrown corporation counselCrown counselCrown prosecutordefence counseldepartmental solicitordeputy city solicitorfamily and estates lawyergeneral counselgeneral solicitorimmigration lawyerindustrial lawyerin-house legal counselinsurance lawyerintellectual-property lawyerjudicial assistant - Supreme Courtlabour lawyerlaw and corporate affairs adviserlaw partnerlawyerlawyer, legal aidlegal advisorlegal aid lawyerlegal attach�legal counsellegal officerlegislative adviserlegislative counsellitigatormunicipal solicitornotary (Quebec)notary, Quebecpatent counselpatent lawyerpatent solicitorprosecuting attorneyprosecutorQuebec notaryQueen's Counselreal estate lawyerregional attorneyregional Crown prosecutorreview lawyersolicitorspecial prosecutorstaff counselstaff lawyerstaff solicitorstudent-at-lawtariff counseltax attorneytax lawyertitle lawyertrademark lawyer",
    "workers": 32785,
    "minEduc": 0,
    "yearsStudy": 4.487804878,
    "automationRisk": 0.035,
    "salaryLow": 40.1,
    "salaryMed": 134.82,
    "salaryHigh": 449.94,
    "totalSkill": 185,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 81.95744681,
    "skillsComp": 49,
    "skillsLogi": 46,
    "skillsMath": 26,
    "skillsLang": 64,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 11,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 18,
    "s14Writing": 19,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 75,
    "f2Engineering": 170,
    "f3Humanities": 425,
    "f4SocialScience": 770,
    "f5FineArts": 280,
    "f6MathAndComputerScience": 215,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 130,
    "f9Law": 29165,
    "f10Health": 135,
    "f11Health,Nursing&ClinicalLaboratory": 50,
    "f12Business": 960,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 290,
    "d5SocialSciences": 770,
    "d6Fine&AppliedArts": 280,
    "d7ComputerScience": 215,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 130,
    "d10Engineering": 170,
    "d11Law": 29165,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 135,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 135,
    "d17Health,Nursing&ClinicalLaboratory": 50,
    "d18Business&Commerce": 960,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 208,
    "noc": 4151,
    "job": "Psychologists",
    "title1": "behavioural modification psychologist",
    "title2": "behavioural psychologist",
    "title3": "behavioural therapist",
    "allTitles": "behavioural modification psychologistbehavioural psychologistbehavioural therapistbehaviouristbiopsychologistchartered psychologistchild psychologistclinical psychologistcognitive psychologistcommunity psychologistcounselling psychologistdevelopmental psychologisteducational psychologistexperimental psychologistforensic psychologisthuman development psychologistindustrial psychologistintern psychologistneuropsychologistorganizational psychologistphysiological psychologistpsychological associatepsychologistpsychologist - counsellingpsychologist, schoolpsychotherapistregistered psychologistresearch psychologistschool psychologistsocial psychologistsports psychologistvocational psychologist",
    "workers": 5370,
    "minEduc": 3,
    "yearsStudy": 4.261904762,
    "automationRisk": 0.007,
    "salaryLow": 23.3,
    "salaryMed": 35,
    "salaryHigh": 70,
    "totalSkill": 179,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 35,
    "skillsComp": 46,
    "skillsLogi": 46,
    "skillsMath": 27,
    "skillsLang": 60,
    "topSkill1": "Oral Communication",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 15,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 8,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 10,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 13,
    "s14Writing": 20,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 95,
    "f4SocialScience": 4725,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 95,
    "f9Law": 0,
    "f10Health": 250,
    "f11Health,Nursing&ClinicalLaboratory": 150,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 4725,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 95,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 45,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 250,
    "d17Health,Nursing&ClinicalLaboratory": 150,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 209,
    "noc": 4152,
    "job": "Social workers",
    "title1": "addiction social worker",
    "title2": "case management consultant - social work",
    "title3": "case management social worker",
    "allTitles": "addiction social workercase management consultant - social workcase management social workercase work consultant - social workcaseworker - social workcasework supervisor - social workcertified social workerchildren's aid investigatorchild welfare social workerco-ordinator of social workfamily social workergeriatric social workergroup social workermedical social workerpsychiatric social workerregistered social workerschool social workersocial casework consultantsocial work co-ordinatorsocial workersocial worker, groupssocial workers supervisorsocial work officersocial work supervisor",
    "workers": 19805,
    "minEduc": 3,
    "yearsStudy": 3.657342657,
    "automationRisk": 0.012,
    "salaryLow": 18.5,
    "salaryMed": 34,
    "salaryHigh": 45,
    "totalSkill": 135,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 34,
    "skillsComp": 24,
    "skillsLogi": 49,
    "skillsMath": 8,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Critical Thinking",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 14,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 9,
    "s14Writing": 16,
    "s15CriticalThinking": 17,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 575,
    "f4SocialScience": 2525,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 395,
    "f8Education(teachertraining)": 635,
    "f9Law": 150,
    "f10Health": 14450,
    "f11Health,Nursing&ClinicalLaboratory": 580,
    "f12Business": 450,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 545,
    "d5SocialSciences": 2525,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 395,
    "d9Education(teachertraining)": 635,
    "d10Engineering": 0,
    "d11Law": 150,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 60,
    "d14Theology": 30,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 14390,
    "d17Health,Nursing&ClinicalLaboratory": 580,
    "d18Business&Commerce": 450,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 210,
    "noc": 4153,
    "job": "Family, marriage and other related counsellors",
    "title1": "addictions counsellor",
    "title2": "alcohol addiction counsellor",
    "title3": "behavioural consultant",
    "allTitles": "addictions counselloralcohol addiction counsellorbehavioural consultantbereavement counsellorchild and family counsellorchild and youth counsellorchildren's counsellorclinical counsellorcommunity mental health counsellorcounselling program supervisorcounsellor, child and youthcounsellor for persons who are intellectually impairedcounsellor, marriagecounsellor, preretirementcounsellor, rehabilitationcouples therapistcrisis counsellordisability consultantdrug addiction counselloreating disorder therapistfamily counsellorfamily planning counsellorfamily therapistfamily therapist (FT)gambling addictions counsellorgambling addictions therapistgenetic counsellorgrief counsellorgroup home counsellorhuman relations officer - family and children's serviceshuman relations officer - family therapymarital counsellormarriage and family therapistmarriage and family therapist (MFT)marriage consultantmarriage counsellormarriage therapistmarriage therapist (MT)mental health counsellorplay therapistpreretirement counsellorpsychoeducational consultantpsychoeducatorregistered clinical counsellorregistered family therapistregistered marriage and family therapistregistered marriage therapistrehabilitation counsellorsexologistsex therapistspecial needs counsellorsupervisor, counselling programstherapist, marriagevocational rehabilitation consultantvocational rehabilitation counsellorwelfare organization counsellorzootherapist",
    "workers": 5615,
    "minEduc": 3,
    "yearsStudy": 3.631067961,
    "automationRisk": 0.021,
    "salaryLow": 17.65,
    "salaryMed": 26.44,
    "salaryHigh": 40,
    "totalSkill": 141,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 26.44,
    "skillsComp": 32,
    "skillsLogi": 32,
    "skillsMath": 11,
    "skillsLang": 66,
    "topSkill1": "Oral Communication",
    "topSkill2": "Writing",
    "topSkill3": "Reading",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 5,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 11,
    "s14Writing": 22,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 550,
    "f4SocialScience": 1355,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 165,
    "f8Education(teachertraining)": 320,
    "f9Law": 100,
    "f10Health": 1945,
    "f11Health,Nursing&ClinicalLaboratory": 1160,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 440,
    "d5SocialSciences": 1355,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 165,
    "d9Education(teachertraining)": 320,
    "d10Engineering": 0,
    "d11Law": 100,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 30,
    "d14Theology": 110,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 1915,
    "d17Health,Nursing&ClinicalLaboratory": 1160,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 211,
    "noc": 4154,
    "job": "Professional occupations in religion",
    "title1": "archbishop",
    "title2": "archdeacon",
    "title3": "assistant minister - religion",
    "allTitles": "archbishoparchdeaconassistant minister - religionbishopcardinalchancellor - religionchaplainclergymanclergyman/womanclergywomancurateevangelistgranthiimamministerminister - religionmoderator - religionofficiating clergymanofficiating clergyman/womanofficiating clergywomanparish priestpastorpreacherpresbyterpriestrabbireverendSalvation Army commissioned officertelevision evangelist",
    "workers": 9640,
    "minEduc": 0,
    "yearsStudy": 3.808510638,
    "automationRisk": 0.025,
    "salaryLow": 14,
    "salaryMed": 23.08,
    "salaryHigh": 42.86,
    "totalSkill": 159,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 23.08,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 8715,
    "f4SocialScience": 170,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 150,
    "f8Education(teachertraining)": 370,
    "f9Law": 0,
    "f10Health": 55,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 165,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 10,
    "d5SocialSciences": 170,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 150,
    "d9Education(teachertraining)": 370,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 8705,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 55,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 165,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 212,
    "noc": 4155,
    "job": "Probation and parole officers and related occupations",
    "title1": "case management worker - corrections",
    "title2": "case manager - corrections",
    "title3": "classification counsellor - corrections",
    "allTitles": "case management worker - correctionscase manager - correctionsclassification counsellor - correctionsclassification officer, correctional institutionclemency officer - correctionscommunity case manager officer - correctionscorrectional centre caseworkerparole officerparole supervisorprobation and parole officerprobation officersocial assistance program officer - correctionswelfare program officer - correctionsyouth worker - corrections",
    "workers": 1280,
    "minEduc": 3,
    "yearsStudy": 4.148148148,
    "automationRisk": 0.25,
    "salaryLow": 19.23,
    "salaryMed": 38.97,
    "salaryHigh": 46,
    "totalSkill": 144,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 38.97,
    "skillsComp": 28,
    "skillsLogi": 43,
    "skillsMath": 11,
    "skillsLang": 62,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Writing",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 10,
    "s10Reading": 28,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 12,
    "s14Writing": 16,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 885,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 135,
    "f8Education(teachertraining)": 0,
    "f9Law": 80,
    "f10Health": 180,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 885,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 135,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 80,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 180,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 213,
    "noc": 4156,
    "job": "Employment counsellors",
    "title1": "Aboriginal employment developer",
    "title2": "Aboriginal employment officer",
    "title3": "Aboriginal employment worker",
    "allTitles": "Aboriginal employment developerAboriginal employment officerAboriginal employment workercareer coachcareer counsellor - except educationcareer development counsellorcareer development facilitatorcareer development practitionercareer group facilitatorcareer resource centre co-ordinatorcounsellor, employmentcounsellor, employment - government servicescounsellor, employment groupcounsellor, jobcounsellor, job - government servicescounsellor, outplacementcounsellor, relocationemployment consultantemployment counselloremployment counsellor - government servicesemployment group counselloremployment outreach counselloremployment outreach program co-ordinatoremployment outreach program counselloremployment services assessment officeremployment services officergroup counsellor, employment servicesjob counsellorjob counsellor - government servicesjob search trainerlabour market information consultantoutplacement consultantoutplacement counselloroutreach counsellor, employmentoutreach program co-ordinator, employmentoutreach program counsellor, employmentrelocation consultantrelocation counsellorworkforce adjustment officerworkforce development officer",
    "workers": 2685,
    "minEduc": 0,
    "yearsStudy": 3.671232877,
    "automationRisk": 0.009,
    "salaryLow": 24.04,
    "salaryMed": 26.67,
    "salaryHigh": 37.36,
    "totalSkill": 162,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 26.67,
    "skillsComp": 44,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 185,
    "f4SocialScience": 675,
    "f5FineArts": 85,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 90,
    "f8Education(teachertraining)": 215,
    "f9Law": 20,
    "f10Health": 650,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 750,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 185,
    "d5SocialSciences": 675,
    "d6Fine&AppliedArts": 85,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 90,
    "d9Education(teachertraining)": 215,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 650,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 750,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 214,
    "noc": 4161,
    "job": "Natural and applied science policy researchers, consultants and program officers",
    "title1": "agricultural association analyst",
    "title2": "agricultural issues lobbyist",
    "title3": "analyst, agricultural association",
    "allTitles": "agricultural association analystagricultural issues lobbyistanalyst, agricultural associationcertified ergonomistcertified industrial hygienistcommunications policy researcherconsultant, natural and applied sciencesco-ordinator, municipal recycling programco-ordinator, waste management programdisaster emergency response planneremergency management analystemergency preparedness plannerenergy policy analystenergy program officerenvironmental advisor (except engineer)environmental consultant (except engineer)environmental education consultantenvironmental impact analystenvironmental issues lobbyistenvironmental lobbyistenvironmental program co-ordinatorenvironmental program development supervisorenvironmental program managerergonomics consultantergonomics specialistergonomistfisheries analystfisheries program officerhuman factors engineerhuman factors specialist (except engineer)industrial hygienistindustrial waste reduction program co-ordinatorinterface ergonomistlobbyist, agricultural issueslobbyist, environmental issuesmultimedia ergonomistmunicipal recycling program co-ordinatornatural and applied sciences consultantnatural and applied sciences policy advisornatural and applied sciences policy analystnatural and applied sciences program officernatural and applied sciences researchernatural resources plannernatural resources policy analystoccupational hygiene officeroccupational hygienistpatent agentpatent agent, registeredpatent searcherpolicy analyst, natural and applied sciencesprogram co-ordinator - environmental organizationprogram co-ordinator, solid wasteprogram manager, solid wasteprogram officer, energyprogram officer, fisheriesprogram officer, natural and applied sciencesrecycling co-ordinator - residuals managementrecycling program co-ordinatorregional recycling and waste reduction program co-ordinatorregistered occupational hygienistregistered patent agentresearcher, natural and applied sciencesscientific consultantsolid waste program co-ordinatorsolid waste program managersupervisor, environmental program developmenttechnology transfer officertransportation program analysttransportation safety analystwaste diversion consultantwaste diversion program co-ordinatorwaste diversion program managerwaste management program co-ordinatorwaste reduction and recycling officerwaste reduction education program officerwaste reduction program co-ordinatorwind energy analystwork site analystwork site auditor",
    "workers": 5365,
    "minEduc": 0,
    "yearsStudy": 4.295302013,
    "automationRisk": 0.33,
    "salaryLow": 28.85,
    "salaryMed": 40.87,
    "salaryHigh": 64.9,
    "totalSkill": 154,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 40.87,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 2200,
    "f2Engineering": 745,
    "f3Humanities": 10,
    "f4SocialScience": 765,
    "f5FineArts": 10,
    "f6MathAndComputerScience": 35,
    "f7Arts&Education": 570,
    "f8Education(teachertraining)": 65,
    "f9Law": 80,
    "f10Health": 265,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 540,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 580,
    "d2Forestry": 1170,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 10,
    "d5SocialSciences": 765,
    "d6Fine&AppliedArts": 10,
    "d7ComputerScience": 35,
    "d8OtherArts&Science": 570,
    "d9Education(teachertraining)": 65,
    "d10Engineering": 715,
    "d11Law": 80,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 90,
    "d14Theology": 0,
    "d15PhysicalSciences": 450,
    "d16Therapy&Rehabilitation": 175,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 540,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 215,
    "noc": 4162,
    "job": "Economists and economic policy researchers and analysts",
    "title1": "agricultural economist",
    "title2": "analyst, economic",
    "title3": "analyst, fiscal economics",
    "allTitles": "agricultural economistanalyst, economicanalyst, fiscal economicsbusiness analyst - economicsbusiness economistconsumer advisor - economicsdevelopment economisteconometricianeconomic advisoreconomic analysteconomic consultanteconomic policy advisereconomic policy analysteconomic policy researchereconomic research group supervisoreconomisteconomist, natural resourcesenergy economistfarm economistfinancial economistfinancial market economistfiscal economics analystforest economistforest resources economistgeneral economisthealth economisthuman resources economistindustrial economistindustrial relations economistindustrial trade economistinternational trade economistinvestment economistlabour economistlabour market information analystland use economistmathematical economistnatural resources economistprice economistregional economistresource economistrisk management analystsalary analyst - economic policysocial economistsupervisor, economic research grouptax economistterritorial resources economisttrade analysttrade economisttransport economistwage analyst - economic policywelfare economist",
    "workers": 5450,
    "minEduc": 0,
    "yearsStudy": 4.35,
    "automationRisk": 0.33,
    "salaryLow": 21.54,
    "salaryMed": 39.42,
    "salaryHigh": 53.85,
    "totalSkill": 153,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 39.42,
    "skillsComp": 41,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 140,
    "f2Engineering": 40,
    "f3Humanities": 15,
    "f4SocialScience": 3180,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 150,
    "f7Arts&Education": 110,
    "f8Education(teachertraining)": 0,
    "f9Law": 90,
    "f10Health": 215,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 1510,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 140,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 3180,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 110,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 40,
    "d11Law": 90,
    "d12Mathematics": 100,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 215,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 1510,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 216,
    "noc": 4163,
    "job": "Business development officers and marketing researchers and consultants",
    "title1": "Aboriginal economic development officer advertising analyst agriculture and food sector development consultant agriculture and food sector marketing consultant agri-food sector development consultant agri-food sector marketing consultant analyst � market research analyst, manufacturers' association analyst, marketing area development officer � government business development officer business issues lobbyist commerce officer commercial development officer � government commercial research analyst community development consultant community economic development consultant community economic development officer consultant, marketing � market research consultant, tourism � government co-ordinator, tourism services � government economic development consultant economic development officer economic development officer � Aboriginal communities industrial commissioner industrial development officer industrial development representative international development and assistance researcher international marketing specialist lobbyist, business issues manufacturers' association analyst market analyst � non-financial market research analyst market research specialist market researcher marketing analysis specialist marketing analyst marketing analyst � non-financial marketing consultant � market research marketing consultant � wholesale marketing project officer marketing research specialist marketing researcher mining industry development consultant officer, commercial development � government officer, economic development � government officer, industrial development � government officer, regional economic development agency officer, tourism development � government program delivery officer � business development program officer � international development agency project officer, marketing regional development analyst regional development officer regional economic development agency officer regional industrial development officer regional officer, industrial development researcher, market researcher, marketing rural development officer small business counsellor tourism consultant � government tourism development officer tourism development officer � government tourism industry consultant tourism industry specialist tourism services co-ordinator � government trade promotion officer visitor interpretation services co-ordinator � government",
    "title2": 0,
    "title3": 0,
    "allTitles": "Aboriginal economic development officer advertising analyst agriculture and food sector development consultant agriculture and food sector marketing consultant agri-food sector development consultant agri-food sector marketing consultant analyst � market research analyst, manufacturers' association analyst, marketing area development officer � government business development officer business issues lobbyist commerce officer commercial development officer � government commercial research analyst community development consultant community economic development consultant community economic development officer consultant, marketing � market research consultant, tourism � government co-ordinator, tourism services � government economic development consultant economic development officer economic development officer � Aboriginal communities industrial commissioner industrial development officer industrial development representative international development and assistance researcher international marketing specialist lobbyist, business issues manufacturers' association analyst market analyst � non-financial market research analyst market research specialist market researcher marketing analysis specialist marketing analyst marketing analyst � non-financial marketing consultant � market research marketing consultant � wholesale marketing project officer marketing research specialist marketing researcher mining industry development consultant officer, commercial development � government officer, economic development � government officer, industrial development � government officer, regional economic development agency officer, tourism development � government program delivery officer � business development program officer � international development agency project officer, marketing regional development analyst regional development officer regional economic development agency officer regional industrial development officer regional officer, industrial development researcher, market researcher, marketing rural development officer small business counsellor tourism consultant � government tourism development officer tourism development officer � government tourism industry consultant tourism industry specialist tourism services co-ordinator � government trade promotion officer visitor interpretation services co-ordinator � government",
    "workers": 4812.5,
    "minEduc": 0,
    "yearsStudy": 4.093764355,
    "automationRisk": 0.191125,
    "salaryLow": 18.27,
    "salaryMed": 32.5,
    "salaryHigh": 54.81,
    "totalSkill": 157.75,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 35.66375,
    "skillsComp": 42.5,
    "skillsLogi": 39.625,
    "skillsMath": 22,
    "skillsLang": 53.625,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7.125,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.625,
    "s7NumericalEstimation": 4.75,
    "s8OralCommunication": 16.625,
    "s9ProblemSolving": 10.125,
    "s10Reading": 21.25,
    "s11SchedulingorBudgetingandAccounting": 7.125,
    "s12DigitalTechnology": 18.875,
    "s13DocumentUse": 17,
    "s14Writing": 15.75,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 529.375,
    "f2Engineering": 115.625,
    "f3Humanities": 179.375,
    "f4SocialScience": 1390,
    "f5FineArts": 63.75,
    "f6MathAndComputerScience": 40.625,
    "f7Arts&Education": 321.25,
    "f8Education(teachertraining)": 505,
    "f9Law": 103.125,
    "f10Health": 467.5,
    "f11Health,Nursing&ClinicalLaboratory": 442.5,
    "f12Business": 654.375,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 287.5,
    "d2Forestry": 168.125,
    "d3Architecture&LandscapeArchitecture": 17.5,
    "d4Humanities": 176.875,
    "d5SocialSciences": 1390,
    "d6Fine&AppliedArts": 63.75,
    "d7ComputerScience": 16.25,
    "d8OtherArts&Science": 321.25,
    "d9Education(teachertraining)": 505,
    "d10Engineering": 98.125,
    "d11Law": 103.125,
    "d12Mathematics": 24.375,
    "d13Kinesiology/Recreation/PhysicalEducation": 185,
    "d14Theology": 2.5,
    "d15PhysicalSciences": 73.75,
    "d16Therapy&Rehabilitation": 282.5,
    "d17Health,Nursing&ClinicalLaboratory": 442.5,
    "d18Business&Commerce": 654.375,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 217,
    "noc": 4164,
    "job": "Social policy researchers, consultants and program officers",
    "title1": "Aboriginal affairs development officer",
    "title2": "Aboriginal affairs officer",
    "title3": "Aboriginal employment policy officer",
    "allTitles": "Aboriginal affairs development officerAboriginal affairs officerAboriginal employment policy officerAboriginal employment program officerAboriginal issues lobbyistadoption project officeradviser for the integration of persons with disabilitiesadviser, public assistanceaffirmation action advisoranalyst, occupational supplyanalyst, social policieschild care licensing officerchild-care programs planning officerchild-care services liaison officerchild welfare policy analystcitizenship officercommunity organizercommunity policing program consultantcommunity social development officerconsultant, social policyconsultant, social servicesconsultant, social services planningconsumer advisorco-ordinator, public rightsco-ordinator, women's shelter programcorrectional service policy consultantcorrection rehabilitation program co-ordinatoremployment equity adviser - social policyemployment equity consultantemployment equity policy analystemployment initiatives co-ordinatoremployment insurance policy analysis officeremployment insurance policy analystemployment insurance services adviseremployment standards specialistevaluation officer, job creation and employment servicesexperimental home economistextension home economistfamily violence prevention program adviserfield representative - housingfood consultant - home economicshome economics consultanthome economisthome economist - consumer associationhousing officer, public housinghousing policy analystHuman Rights Commission officerHuman Rights Commission officers supervisorhuman rights officerhuman rights officer - government serviceshuman rights specialistimmigrant settlement liaison officerimmigration and demographic analysis officerimmigration consultantimmigration policy advisorimmigration policy analystimmigration policy consultant - non-governmentimmigration settlement practitionerincome maintenance program officerinternational aid and development project officerinternational aid and development researcherinternational relations specialistjob creation and employment services evaluation officerlabour affairs officer - labour policylabour market analystlabour market information officerlabour market policy officerlabour mobility policy consultantlabour policy analystlabour policy officerlabour standards analystliaison officer, child-care serviceslobbyist, Aboriginal issueslobbyist, Native issuesmulticulturalism project officerNative affairs officerNative employment program officerNative issues lobbyistoccupational supply analystofficer, Aboriginal employment programofficer, employment insurance policy analysisofficer, human rightsofficer, Human Rights Commissionofficer, immigration and demographic analysisofficer, social programspeace activistpeace researcherplanning officer, child-care programspolicy analyst, child welfarepolicy analyst, housingpolicy analyst, immigrationpolicy analyst, status of women's directoratepolicy consultant, correction servicespolicy consultant, employment equitypolicy consultant, labour mobilitypolicy consultant, women's employmentpolicy officer, labourpolicy officer, visible minoritiespolitical organizerpollster",
    "workers": 6965,
    "minEduc": 0,
    "yearsStudy": 4.111764706,
    "automationRisk": 0.145,
    "salaryLow": 20,
    "salaryMed": 36.06,
    "salaryHigh": 51.92,
    "totalSkill": 160,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 36.06,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 160,
    "f2Engineering": 80,
    "f3Humanities": 425,
    "f4SocialScience": 3160,
    "f5FineArts": 160,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 345,
    "f8Education(teachertraining)": 235,
    "f9Law": 310,
    "f10Health": 1070,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 970,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 125,
    "d3Architecture&LandscapeArchitecture": 80,
    "d4Humanities": 425,
    "d5SocialSciences": 3160,
    "d6Fine&AppliedArts": 160,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 345,
    "d9Education(teachertraining)": 235,
    "d10Engineering": 0,
    "d11Law": 310,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 1050,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 970,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 218,
    "noc": 4165,
    "job": "Health policy researchers, consultants and program officers",
    "title1": "accreditation officer, health and social services institution",
    "title2": "child health care programs planning officer",
    "title3": "clinical research associate",
    "allTitles": "accreditation officer, health and social services institutionchild health care programs planning officerclinical research associateclinical research program managerclinical trials co-ordinatorconsultant, drug and alcohol abuseconsultant, health careconsultant, health care planningconsultant, home-care programsconsultant, labour force planning - health sectorconsultant, mental health programscoronerdental health consultantdrug and alcohol abuse consultanthealth and social services institution accreditation officerhealth and social services liaison officerhealth care association program officerhealth care consultanthealth care plannerhealth care planning consultanthealth care planning officerhealth care program administration officerhealth care researcherhealth educatorhealth policy development officerhealth policy research analysthealth program information analysthealth promotion program officerhealth research officerhealth services consultanthealth services program consultanthealth services researcherhealth services research officerhome-care programs consultantlabour force planning consultant - health sectorliaison officer, health and social serviceslong-term care program consultantmental health programs consultantnursing home guidelines development officernursing home policy development officerofficer, health care planningofficer, health policy developmentplanner, health careplanning consultant, health careplanning co-ordinator, district health council programplanning officer, child health care programsplanning officer, health carepolicy development officer, healthpolicy development officer, nursing homesprevention officer - occupational health and safetyprogram officer, health care associationprogram officer, health promotionresearch analyst, health policyresearcher, health careresearch officer, health serviceswellness consultantwellness co-ordinatorwellness program co-ordinator",
    "workers": 9585,
    "minEduc": 0,
    "yearsStudy": 4.207373272,
    "automationRisk": 0.145,
    "salaryLow": 17,
    "salaryMed": 33.4,
    "salaryHigh": 49.27,
    "totalSkill": 159,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 33.4,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 1680,
    "f2Engineering": 35,
    "f3Humanities": 265,
    "f4SocialScience": 1425,
    "f5FineArts": 65,
    "f6MathAndComputerScience": 75,
    "f7Arts&Education": 745,
    "f8Education(teachertraining)": 345,
    "f9Law": 80,
    "f10Health": 830,
    "f11Health,Nursing&ClinicalLaboratory": 3190,
    "f12Business": 850,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1490,
    "d2Forestry": 50,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 265,
    "d5SocialSciences": 1425,
    "d6Fine&AppliedArts": 65,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 745,
    "d9Education(teachertraining)": 345,
    "d10Engineering": 15,
    "d11Law": 80,
    "d12Mathematics": 50,
    "d13Kinesiology/Recreation/PhysicalEducation": 330,
    "d14Theology": 0,
    "d15PhysicalSciences": 140,
    "d16Therapy&Rehabilitation": 500,
    "d17Health,Nursing&ClinicalLaboratory": 3190,
    "d18Business&Commerce": 850,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 219,
    "noc": 4166,
    "job": "Education policy researchers, consultants and program officers",
    "title1": "adult education consultant",
    "title2": "adult education program officer",
    "title3": "analyst, education policies",
    "allTitles": "adult education consultantadult education program officeranalyst, education policiesandragogy specialistart co-ordinator - educationboard of education inspectorconsultant, adult educationconsultant, educationconsultant, education policiesconsultant, heritage languages educationconsultant, school subjectsconsultant, special educationconsultant, teachingco-ordinator, special educationcurriculum consultantcurriculum developercurriculum plannerdistance education program co-ordinatordistance education project officereducational and vocational information specialisteducation consultanteducation outreach program co-ordinatoreducation policy advisoreducation policy analysteducation policy consultanteducation policy officereducation policy supervisoreducation program co-ordinatoreducation program officereducation program plannereducation researchereducation research officereducation science specialistheritage languages education consultantinspector - educationlanguage assessorlanguage assessor - educationlanguages co-ordinator - educationmathematics co-ordinator - educationmusic co-ordinator - educationofficer, adult education programofficer, official languages educationofficial languages education officerphysical education co-ordinator - educationpolicy analyst, educationpolicy consultant, educationpolicy officer, educationprogram co-ordinator - educationprogram development specialist - collegeprogram officer, educationprogram planner, educationresearch officer, educationschool adjustment specialistschool inspectorschool subjects consultantscience co-ordinator - educationspecial education consultantspecial education co-ordinator - educationspecialist, andragogyspecialist, educational and vocational informationspecialist, program development - collegespecialist, school adjustmentsubject consultant - educationsupervisor, education policyteaching consultant",
    "workers": 4550,
    "minEduc": 0,
    "yearsStudy": 4.177777778,
    "automationRisk": 0.145,
    "salaryLow": 19.23,
    "salaryMed": 33.05,
    "salaryHigh": 53.85,
    "totalSkill": 159,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 33.05,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 25,
    "f2Engineering": 0,
    "f3Humanities": 170,
    "f4SocialScience": 595,
    "f5FineArts": 175,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 175,
    "f8Education(teachertraining)": 2805,
    "f9Law": 30,
    "f10Health": 90,
    "f11Health,Nursing&ClinicalLaboratory": 55,
    "f12Business": 405,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 25,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 150,
    "d5SocialSciences": 595,
    "d6Fine&AppliedArts": 175,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 175,
    "d9Education(teachertraining)": 2805,
    "d10Engineering": 0,
    "d11Law": 30,
    "d12Mathematics": 25,
    "d13Kinesiology/Recreation/PhysicalEducation": 10,
    "d14Theology": 20,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 80,
    "d17Health,Nursing&ClinicalLaboratory": 55,
    "d18Business&Commerce": 405,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 220,
    "noc": 4167,
    "job": "Recreation, sports and fitness policy researchers, consultants and program officers",
    "title1": "analyst, fitness",
    "title2": "analyst, fitness policy",
    "title3": "analyst, leisure",
    "allTitles": "analyst, fitnessanalyst, fitness policyanalyst, leisureanalyst, leisure policyanalyst, recreationanalyst, recreation policyanalyst, sportsanalyst, sports policyaquatic program co-ordinatorarts and crafts programs co-ordinatorcommunity recreational and leisure programs consultantcommunity recreational and leisure programs counsellorcommunity recreation and leisure consultantcommunity recreation and leisure counsellorcommunity recreation co-ordinatorconsultant, community recreational and leisure programsconsultant, community recreation and leisureconsultant, employee fitnessconsultant, geriatric recreational and leisure activitiesconsultant, leisureconsultant, leisure activitiesconsultant, recreationconsultant, recreational activitiesconsultant, sportsconsultant, sports and leisureconsultant, sports and recreationconsultant, youth recreational and leisure activitiesco-ordinator, aquatic programsco-ordinator, arts and crafts programsco-ordinator, fitnessco-ordinator, geriatric activitiesco-ordinator, geriatric recreational and leisure activitiesco-ordinator, leisureco-ordinator, leisure activities programsco-ordinator, leisure programsco-ordinator, leisure servicesco-ordinator, nautical activitiesco-ordinator, nautical programsco-ordinator, pool activitiesco-ordinator, recreationco-ordinator, recreational activitiesco-ordinator, recreational activities programsco-ordinator, recreational programsco-ordinator, recreation servicesco-ordinator, sportsco-ordinator, sports activitiesco-ordinator, sports programsco-ordinator, sports programs - sports and recreationco-ordinator, teen club programsco-ordinator, youth recreational and leisure activities programcounsellor, community recreational and leisure programscounsellor, community recreation and leisurecounsellor, employee fitnesscounsellor, geriatric recreational and leisure activitiescounsellor, leisurecounsellor, leisure activitiescounsellor, recreationcounsellor, recreational activitiescounsellor, sportscounsellor, sports and leisurecounsellor, sports and recreationcounsellor, youth recreational and leisure activitiesemployee fitness consultantemployee fitness counsellorfitness analystfitness consultantfitness co-ordinatorfitness policy analystfitness program consultantfitness programs supervisorfitness, recreation or sports policy analystgeriatric activities co-ordinatorgeriatric recreational and leisure activities consultantgeriatric recreational and leisure activities co-ordinatorgeriatric recreational and leisure activities counsellorleisure activities consultantleisure activities counsellorleisure activities program co-ordinatorleisure analystleisure consultantleisure co-ordinatorleisure counsellorleisure policy analystleisure program co-ordinatorleisure services co-ordinatornautical activities co-ordinatornautical programs co-ordinatorofficer, sports projectspolicy analyst, recreation, sports or fitnesspool activities co-ordinatorprogram co-ordinator, arts and craftsprogram co-ordinator, leisure activitiesprogram co-ordinator, recreationprogram co-ordinator, recreational activitiesprogram co-ordinator, teen clubsprogram supervisor, fitnessprogram supervisor, recreation and leisureprogram supervisor, sportsprogram supervisor - sports and leisureprogram supervisor, sports, recreation and leisure",
    "workers": 1890,
    "minEduc": 0,
    "yearsStudy": 3.195652174,
    "automationRisk": 0.145,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 34.19,
    "totalSkill": 154,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 22,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 60,
    "f4SocialScience": 190,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 310,
    "f8Education(teachertraining)": 120,
    "f9Law": 0,
    "f10Health": 1090,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 55,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 60,
    "d5SocialSciences": 190,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 310,
    "d9Education(teachertraining)": 120,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 1005,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 85,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 55,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 221,
    "noc": 4168,
    "job": "Program officers unique to government",
    "title1": "Aboriginal land claims liaison officer",
    "title2": "attach�",
    "title3": "board member - government services",
    "allTitles": "Aboriginal land claims liaison officerattach�board member - government servicesdeputy returning officerdiplomatelection commission officerelections officerextraparliamentary commission officerfederal and intergovernmental affairs research officer - government servicesfederal-provincial relations officerfirst secretary, foreign serviceforeign service officergovernment officialhealth authority board memberHouse of Commons committee officerHouse of Commons officerintergovernmental affairs officerlegislative committee officerliaison officer, Native land claimsNative land claims liaison officerofficer, election commissionofficer, federal-provincial relationsofficer, foreign serviceofficer, House of Commonsofficer, House of Commons committeeofficer, intergovernmental affairsofficer, labour relations commissionofficer, legislative committeeofficer, legislative councilofficer, office of the Speakerofficer, Office of the Speaker of the House of Commonsofficer, official languages commissionofficer, Premier's Office (provincial government)officer, Prime Minister's Office (federal government)officer, Privy Council Officeofficer, protocol - government servicesofficer, public inquiriesofficer, regional committee - government servicesofficer, regional councilofficer, royal commissionofficer, Senate committeeofficer, standing committeeofficer, standing or select committeeofficer, task forceofficer, territorial councilofficer, tribunalofficial languages promotion officerparole board memberprotocol officerrefugee board memberresearch officer - federal and intergovernmental affairsreturning officerroyal commission officersecond secretary, foreign serviceselect committee officerSenate committee officerstanding committee officertask force officerterritorial council officerthird secretary, foreign servicetribunal chairpersontribunal membertribunal officertribunal officer - government services",
    "workers": 3530,
    "minEduc": 0,
    "yearsStudy": 3.8,
    "automationRisk": 0.23,
    "salaryLow": 20.24,
    "salaryMed": 38.46,
    "salaryHigh": 55,
    "totalSkill": 157,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 38.46,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 30,
    "f2Engineering": 25,
    "f3Humanities": 260,
    "f4SocialScience": 1035,
    "f5FineArts": 50,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 225,
    "f8Education(teachertraining)": 455,
    "f9Law": 235,
    "f10Health": 180,
    "f11Health,Nursing&ClinicalLaboratory": 120,
    "f12Business": 895,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 10,
    "d4Humanities": 260,
    "d5SocialSciences": 1035,
    "d6Fine&AppliedArts": 50,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 225,
    "d9Education(teachertraining)": 455,
    "d10Engineering": 15,
    "d11Law": 235,
    "d12Mathematics": 20,
    "d13Kinesiology/Recreation/PhysicalEducation": 25,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 155,
    "d17Health,Nursing&ClinicalLaboratory": 120,
    "d18Business&Commerce": 895,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 222,
    "noc": 4169,
    "job": "Other professional occupations in social science, n.e.c.",
    "title1": "analyst, handwriting",
    "title2": "anthropologist",
    "title3": "applied anthropologist",
    "allTitles": "analyst, handwritinganthropologistapplied anthropologistapplied geographerapplied linguistarchaeological consultantarchaeological field workerarchaeologistbiogeographerbiological anthropologistcriminologistcultural anthropologistcultural geographerdiplomatic historiandramatic arts historianeconomic geographereconomic historianeducational sociologistethnographerethnologistetymologistgeographergerontologistgraphoanalystgraphologisthandwriting analysthandwriting experthistorianhistorical geographerindustrial geographerindustrial sociologistlinguistlinguistic anthropologistmedical sociologistmilitary historianpenologistphilologistphilosopherphysical anthropologistphysical geographerpolitical geographerpolitical historianpolitical scientistpoliticistpsycholinguistpsychometricianpsychometristquantitative historianresearch anthropologistresearch archaeologistrural sociologistscientific expert, handwritingscientific handwriting expertsocial and cultural anthropologistsocial anthropologistsocial ecologistsocial historiansocial scientistsociolinguistsociologisttheatre historianurban geographerurban sociologist",
    "workers": 1165,
    "minEduc": 0,
    "yearsStudy": 4.612244898,
    "automationRisk": 0.059,
    "salaryLow": 18,
    "salaryMed": 42.05,
    "salaryHigh": 50.77,
    "totalSkill": 166,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Professional occupations in law and social, community and government services",
    "cluster": 5,
    "wage": 42.05,
    "skillsComp": 45,
    "skillsLogi": 42,
    "skillsMath": 23,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 230,
    "f4SocialScience": 770,
    "f5FineArts": 50,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 90,
    "f8Education(teachertraining)": 15,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 10,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 230,
    "d5SocialSciences": 770,
    "d6Fine&AppliedArts": 50,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 90,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 10,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 223,
    "noc": 4211,
    "job": "Paralegal and related occupations",
    "title1": "abstractor",
    "title2": "brief writer - law",
    "title3": "British Columbia notary public",
    "allTitles": "abstractorbrief writer - lawBritish Columbia notary publicclerk, lawcollection paralegalcommercial law clerkcommercial law paralegalcontract clerk - lawconveyance clerkcopyright agentcorporate law and litigation clerkcorporate law clerkcorporate paralegalcorporate securities law clerkcorporation paralegalcourt and tribunal agentcriminal law clerkcriminal law paralegalfamily law clerkfamily law paralegalforeclosure clerkforeclosure paralegalindependent paralegalinsurance law clerkinsurance paralegallabour law clerklabour law paralegalland titles clerkland titles examinerlaw clerklaw clerk to judgelay notary publiclease and title clerklegal researcherlegal technicianlitigation law clerklitigation paralegalmortgage and real estate paralegalnotary publicnotary public (British Columbia)notary public clerknotary public, laynotary public (outside Quebec)oil and gas property paralegaloil and gas rights law clerkoil and gas rights paralegalparalegalproperty paralegalreal estate law clerkreal estate paralegalregistered trademark agentresearcher, legaltax law clerktax paralegaltitle and lease clerktitle examinertitle searchertrademark agenttransfer-of-title clerkwills and estates law clerkwills and estates paralegal",
    "workers": 10245,
    "minEduc": 2,
    "yearsStudy": 3.317757009,
    "automationRisk": 0.94,
    "salaryLow": 15,
    "salaryMed": 26.84,
    "salaryHigh": 43,
    "totalSkill": 151,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Paraprofessional occupations in legal, social, community and education services",
    "cluster": 5,
    "wage": 26.84,
    "skillsComp": 35,
    "skillsLogi": 35,
    "skillsMath": 13,
    "skillsLang": 68,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 0,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 7,
    "s10Reading": 30,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 19,
    "s14Writing": 17,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 195,
    "f4SocialScience": 780,
    "f5FineArts": 120,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 315,
    "f8Education(teachertraining)": 40,
    "f9Law": 7890,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 60,
    "f12Business": 845,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 165,
    "d5SocialSciences": 780,
    "d6Fine&AppliedArts": 120,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 315,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 0,
    "d11Law": 7890,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 30,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 60,
    "d18Business&Commerce": 845,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 224,
    "noc": 4212,
    "job": "Social and community service workers",
    "title1": "Aboriginal centre co-ordinator",
    "title2": "Aboriginal outreach officer - social services",
    "title3": "Aboriginal outreach worker",
    "allTitles": "Aboriginal centre co-ordinatorAboriginal outreach officer - social servicesAboriginal outreach workeraddictions workeraddictions worker - compulsive gamblingassistant, social servicescase aide - social servicescertified return-to-work co-ordinator - disability managementcertified return-to-work facilitator - disability managementchild and youth workerchild-care worker (except day care)child welfare workercoach, life skillscommunity and social services workercommunity centre co-ordinatorcommunity centre workercommunity counsellor - social servicescommunity development workercommunity liaison workercommunity mental health workercommunity organization workercommunity rehabilitation workercommunity services officer - social servicescommunity service workercommunity workerco-ordinator, community centreco-ordinator, Native centreco-ordinator, youth developmentcrisis intervention workerdetention home workerdevelopmental service workerdevelopment service workerdisability management workerdrop-in centre workerdrug addiction workereligibility co-ordinator - social assistanceeligibility co-ordinator - welfareexceptional-child-care worker (except day care)family service workerfield officer, veterans' affairsfinancial assistance officer - social assistancefinancial assistance worker - social servicesgroup home operatorgroup home workerhalfway house supervisorhalfway house workerhelp centre supervisor - social serviceshostel co-ordinatorhostel outreach workerincome maintenance officer - social servicesindependent living instructorinstructor, life skillsintellectual disabilities workerItinerant support service workerlife skills coachlife skills instructormeals-on-wheels workermental health proctormental health support workermental health workerNative centre co-ordinatorNative community workerNative outreach officer - social servicesNative outreach workerneighbourhood worker - social servicesofficer, Native outreach - social servicespeer support workerpersonal skills development instructor - social servicesproctor, mental healthpsychological assistantregistered social service workerrehabilitation officer - social servicesrehabilitation service workerrehabilitation worker - social servicesresidence co-ordinator - group homeresidential counsellor - group homereturn-to-work co-ordinator - disability managementreturn-to-work facilitator - disability managementsettlement worker - community servicesshelter supervisor - social servicesshelter workshop supervisorsocial aid officersocial animatorsocial assistance officersocial rehabilitation officersocial rehabilitation techniciansocial rehabilitation workersocial services assistantsocial services volunteer co-ordinatorsocial services workersocial welfare officerspecial education technician - social and community servicesstreet outreach workerstreetworker - social servicessubstance abuse workersupervised access workersupervisor, halfway housesupervisor, women's centre - social servicessupervisor, women's shelter - social servicestransition home worker - social services",
    "workers": 41965,
    "minEduc": 1,
    "yearsStudy": 3.082169442,
    "automationRisk": 0.391,
    "salaryLow": 16.83,
    "salaryMed": 21.76,
    "salaryHigh": 30,
    "totalSkill": 145.5,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 16.68,
    "skillsComp": 44.5,
    "skillsLogi": 31.5,
    "skillsMath": 17,
    "skillsLang": 52.5,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Writing",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 6.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3.5,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 7.5,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 25,
    "s13DocumentUse": 13.5,
    "s14Writing": 16,
    "s15CriticalThinking": 9.5,
    "f1Science&Agriculture": 190,
    "f2Engineering": 65,
    "f3Humanities": 6355,
    "f4SocialScience": 6180,
    "f5FineArts": 740,
    "f6MathAndComputerScience": 105,
    "f7Arts&Education": 1690,
    "f8Education(teachertraining)": 1900,
    "f9Law": 1755,
    "f10Health": 13375,
    "f11Health,Nursing&ClinicalLaboratory": 4020,
    "f12Business": 2500,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 115,
    "d2Forestry": 25,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 6155,
    "d5SocialSciences": 6180,
    "d6Fine&AppliedArts": 740,
    "d7ComputerScience": 105,
    "d8OtherArts&Science": 1690,
    "d9Education(teachertraining)": 1900,
    "d10Engineering": 65,
    "d11Law": 1755,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 745,
    "d14Theology": 200,
    "d15PhysicalSciences": 50,
    "d16Therapy&Rehabilitation": 12630,
    "d17Health,Nursing&ClinicalLaboratory": 4020,
    "d18Business&Commerce": 2500,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 225,
    "noc": 4214,
    "job": "Early childhood educators and assistants",
    "title1": "aide, daycare",
    "title2": "aide, nursery school",
    "title3": "assistant ECE",
    "allTitles": "aide, daycareaide, nursery schoolassistant ECEbaby-care workerbaby-care worker assistantbaby-care workers supervisorchild care worker assistantchild care worker - daycarechild care worker, daycareco-op daycare co-ordinatorco-ordinator, co-op daycareco-ordinator, daycaredaycare aidedaycare attendantdaycare co-ordinatordaycare helperdaycare supervisordaycare teacherdaycare workerdaycare worker assistantearly childhood assistantearly childhood education workerearly childhood educator assistantearly childhood educator assistant - junior kindergartenearly childhood educator assistant - kindergartenearly childhood educator (E.C.E.)early childhood educator - junior kindergartenearly childhood educator - kindergartenearly childhood educator - preschoolearly childhood program staff assistantearly childhood program supervisorearly childhood supervisorECE assistanteducator assistant - junior kindergartenhelper, daycarehelper, nursery schoolinfant daycare workers supervisorinfants' daycare workernursery school aidenursery school helpernursery school teacherpreschool helperpreschool supervisorteacher, daycare",
    "workers": 43345,
    "minEduc": 1,
    "yearsStudy": 3.00591716,
    "automationRisk": 0.007,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 30,
    "totalSkill": 98,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Paraprofessional occupations in legal, social, community and education services",
    "cluster": 5,
    "wage": 17,
    "skillsComp": 22,
    "skillsLogi": 30,
    "skillsMath": 11,
    "skillsLang": 35,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 10,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 15,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 115,
    "f2Engineering": 45,
    "f3Humanities": 23595,
    "f4SocialScience": 1865,
    "f5FineArts": 1180,
    "f6MathAndComputerScience": 130,
    "f7Arts&Education": 2095,
    "f8Education(teachertraining)": 7185,
    "f9Law": 600,
    "f10Health": 1520,
    "f11Health,Nursing&ClinicalLaboratory": 2185,
    "f12Business": 2830,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 95,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 23540,
    "d5SocialSciences": 1865,
    "d6Fine&AppliedArts": 1180,
    "d7ComputerScience": 130,
    "d8OtherArts&Science": 2095,
    "d9Education(teachertraining)": 7185,
    "d10Engineering": 45,
    "d11Law": 600,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 300,
    "d14Theology": 55,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 1220,
    "d17Health,Nursing&ClinicalLaboratory": 2185,
    "d18Business&Commerce": 2830,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 226,
    "noc": 4215,
    "job": "Instructors of persons with disabilities",
    "title1": "braille instructor",
    "title2": "braille teacher",
    "title3": "finger-spelling teacher",
    "allTitles": "braille instructorbraille teacherfinger-spelling teacherinstructor, brailleinstructor of persons who are blindinstructor of persons who are deafinstructor of persons who are hard of hearinginstructor of persons with a learning disabilityinstructor of persons with a mobility impairmentinstructor of persons with a visual impairmentinstructor of persons with developmental disabilitiesinstructor of persons with disabilitiesinstructor of persons with intellectual disabilitiesinstructor of persons with special needsinstructor, orientation and mobilityinstructor, orientation and mobility of persons who are blindinstructor, sign languageinstructor, special programs for persons with disabilitiesjob coach for persons with disabilitieslip-reading instructorlip-reading teacherorientation and mobility instructororientation and mobility instructor for persons with a visual impairmentorientation and mobility teacher for persons who are blindorientation and mobility teacher of persons with a visual impairmentrehabilitation instructor for persons who are blindrehabilitation instructor of persons with a visual impairmentrehabilitation teacherrehabilitation teacher for persons who are blindrehabilitation teacher of persons with a visual impairmentsign language instructorsign language teacherspecial education technician - persons with disabilitiesteacher, finger spellingteacher for persons with autismteacher for persons with intellectual disabilitiesteacher, lip readingteacher of brailleteacher of persons who are blindteacher of persons who are deafteacher of persons who are hard of hearingteacher of persons who are hearing impairedteacher of persons with a mobility impairmentteacher of persons with a visual impairmentteacher of persons with developmental disabilitiesteacher, rehabilitationteacher, sign language",
    "workers": 1270,
    "minEduc": 2,
    "yearsStudy": 3.5,
    "automationRisk": 0.012,
    "salaryLow": 14,
    "salaryMed": 28,
    "salaryHigh": 48.08,
    "totalSkill": 101,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Paraprofessional occupations in legal, social, community and education services",
    "cluster": 5,
    "wage": 28,
    "skillsComp": 29,
    "skillsLogi": 16,
    "skillsMath": 11,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 2,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 5,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 9,
    "s14Writing": 14,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 335,
    "f4SocialScience": 265,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 30,
    "f8Education(teachertraining)": 495,
    "f9Law": 0,
    "f10Health": 85,
    "f11Health,Nursing&ClinicalLaboratory": 60,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 335,
    "d5SocialSciences": 265,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 30,
    "d9Education(teachertraining)": 495,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 85,
    "d17Health,Nursing&ClinicalLaboratory": 60,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 227,
    "noc": 4216,
    "job": "Other instructors",
    "title1": "auto-driving instructor",
    "title2": "beauty culture school instructor",
    "title3": "child safety educator",
    "allTitles": "auto-driving instructorbeauty culture school instructorchild safety educatordriver's licence examinerdriving examinerdriving instructordriving school instructorfirst aid instructorgourmet cooking instructor - non-vocationalinstructor, auto-drivinginstructor, beauty culture schoolinstructor, first aidinstructor, gourmet cooking - non-vocationalinstructor, modelling and finishing schoolinstructor, motorcycle drivinginstructor, sailinginstructor, self-improvement courseinstructor, sewing - non-vocationalinstructor, small boat navigationmodelling and finishing school instructormotorcycle driving instructorsailing instructorself-improvement course instructorsewing instructor - non-vocationalsewing teacher - non-vocationalsmall-boat navigation instructortruck driving instructortutor - elementary school subjectstutor - secondary school subjects",
    "workers": 4480,
    "minEduc": 2,
    "yearsStudy": 3.62295082,
    "automationRisk": 0.01,
    "salaryLow": 14,
    "salaryMed": 14.25,
    "salaryHigh": 35,
    "totalSkill": 121,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Paraprofessional occupations in legal, social, community and education services",
    "cluster": 5,
    "wage": 14.25,
    "skillsComp": 24,
    "skillsLogi": 28,
    "skillsMath": 16,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Writing",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 6,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 9,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 295,
    "f2Engineering": 155,
    "f3Humanities": 230,
    "f4SocialScience": 370,
    "f5FineArts": 155,
    "f6MathAndComputerScience": 145,
    "f7Arts&Education": 565,
    "f8Education(teachertraining)": 2235,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 145,
    "f12Business": 155,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 130,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 230,
    "d5SocialSciences": 370,
    "d6Fine&AppliedArts": 155,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 565,
    "d9Education(teachertraining)": 2235,
    "d10Engineering": 155,
    "d11Law": 30,
    "d12Mathematics": 145,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 165,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 145,
    "d18Business&Commerce": 155,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 228,
    "noc": 4217,
    "job": "Other religious occupations",
    "title1": "animator - spiritual guidance",
    "title2": "brother - religion",
    "title3": "brother/sister - religion",
    "allTitles": "animator - spiritual guidancebrother - religionbrother/sister - religioncantorChristian Science nurse - non-medicalChristian science practitionerChristian science workerchurch workerdeacondeaconessexegetefaith healergospel workerhazzanhealer, faithhome mission worker - religionmissionarymohelmonkmother superior/religious superiornovice - religionnunpantheepastoral animatorpostulantragireligious education workerreligious superior/mother superiorreligious superior - religious communitySalvation Army captainSalvation Army field workerSalvation Army workersister/brother - religionsister - religion",
    "workers": 400,
    "minEduc": 0,
    "yearsStudy": 4.5,
    "automationRisk": 0.025,
    "salaryLow": 14.766,
    "salaryMed": 21.57,
    "salaryHigh": 37.216,
    "totalSkill": 158,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Paraprofessional occupations in legal, social, community and education services",
    "cluster": 5,
    "wage": 36.56989981,
    "skillsComp": 42,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 400,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 385,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 229,
    "noc": 4311,
    "job": "Mechanical assemblers and inspectors",
    "title1": "bodyguard - police",
    "title2": "cadet, police",
    "title3": "Canadian Security Intelligence Service (CSIS) investigator",
    "allTitles": "bodyguard - policecadet, policeCanadian Security Intelligence Service (CSIS) investigatorcanine-team member - policecommunity policemancommunity police officercommunity policewomancommunity relations officer - policecommunity services officer - policeconstablecounterfeit and forgery section detectivecrime prevention constablecrime scene technician - policeCSIS (Canadian Security Intelligence Service) investigatordesk officer - policedetective, counterfeit and forgery sectiondetective, narcotics squaddetective - policedetective, vice squaddivisional diving supervisor - policedog master - policedrug investigator - policeduty officer, headquarters - policeduty officer, station - policeeducation relations officer - policingethnic relations officer - policeevidence technician - policeharbour policemanharbour policeman/womanharbour police officerharbour police sergeantharbour policewomanheadquarters duty officer - policehighway patrolmanhighway patrolman/womanhighway patrol officerhighway patrolwomanidentification officer - policeinvestigator - policeinvestigator, railway - policemorality officer - policemotorcycle patrolman - policemotorcycle patrolman/woman - policemotorcycle patrolwoman - policemounted police constablemounted policemanmounted policeman/womanmounted policewomannarcotics squad detectiveofficer, community relations - policeofficer, recruitment and training - policepatrol officer - policepatrol officer, trafficpeace officerplain-clothes officerpolice cadetpolice constablepolice constable, railwaypolice corporalpolice diverpolice diver - salvagepolice investigatorpolicemanpoliceman/womanpolice officerpolice sergeantpolicewomanrailway guard - policerailway investigator - policerailway police constablerailway policemanrailway police officerrailway policewomanrailway special agent - policeRCMP officerRCMP (Royal Canadian Mounted Police) officerrecruitment and training officer - policeRoyal Canadian Mounted Police (RCMP) officersafety patrol officer - policeschool liaison officer - policeschool safety officer - policescuba diver - policescuba-diving specialist - policesecret service officersecurity constable - policesecurity officer - policestaff sergeant - policestation duty officer - policestation officer - policetraffic patrol officervice squad detective",
    "workers": 23130,
    "minEduc": 0,
    "yearsStudy": 2.511494253,
    "automationRisk": 0.499,
    "salaryLow": 23.08,
    "salaryMed": 44,
    "salaryHigh": 55,
    "totalSkill": 142.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Occupations in front-line public protection services",
    "cluster": 5,
    "wage": 32,
    "skillsComp": 38.5,
    "skillsLogi": 35.5,
    "skillsMath": 20.5,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9.5,
    "s10Reading": 19.5,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17.5,
    "s14Writing": 13.5,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 630,
    "f2Engineering": 495,
    "f3Humanities": 450,
    "f4SocialScience": 3710,
    "f5FineArts": 260,
    "f6MathAndComputerScience": 255,
    "f7Arts&Education": 1345,
    "f8Education(teachertraining)": 265,
    "f9Law": 12735,
    "f10Health": 640,
    "f11Health,Nursing&ClinicalLaboratory": 330,
    "f12Business": 1910,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 170,
    "d2Forestry": 155,
    "d3Architecture&LandscapeArchitecture": 75,
    "d4Humanities": 430,
    "d5SocialSciences": 3710,
    "d6Fine&AppliedArts": 260,
    "d7ComputerScience": 255,
    "d8OtherArts&Science": 1345,
    "d9Education(teachertraining)": 265,
    "d10Engineering": 420,
    "d11Law": 12735,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 490,
    "d14Theology": 20,
    "d15PhysicalSciences": 305,
    "d16Therapy&Rehabilitation": 150,
    "d17Health,Nursing&ClinicalLaboratory": 330,
    "d18Business&Commerce": 1910,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 230,
    "noc": 4312,
    "job": "Firefighters",
    "title1": "airport firefighter",
    "title2": "airport fireman",
    "title3": "airport firewoman",
    "allTitles": "airport firefighterairport firemanairport firewomanapprentice, firefighterapprentice, firemanapprentice, firewomancommunication service firefightercommunication service firemancommunication service firewomancrash firefightercrash firemancrash firewomanfire captainfire department platoon chieffirefighterfirefighter apprenticefirefighter, communication servicefirefighter, fire safety inspectionfirefighter, industrial complexfirefighter-inspectorfirefighter lieutenantfirefighter, shipboardfirefighter, structuralfirefighter, trainingfire inspectorfire lieutenantfiremanfireman apprenticefireman, communication servicefireman, fire safety inspectionfireman, industrial complexfireman-inspectorfireman lieutenantfireman, shipboardfireman, structuralfireman, trainingfire prevention officerfire safety inspection firefighterfire safety inspection firemanfire safety inspection firewomanfirewomanfirewoman apprenticefirewoman, communication servicefirewoman, fire safety inspectionfirewoman, industrial complexfirewoman-inspectorfirewoman lieutenantfirewoman, shipboardfirewoman, structuralfirewoman, trainingindustrial firefighterindustrial firemanindustrial firewomanlieutenant, firefightersplatoon chief, fire departmentshipboard firefightershipboard firemanshipboard firewoman",
    "workers": 6725,
    "minEduc": 0,
    "yearsStudy": 2.231578947,
    "automationRisk": 0.17,
    "salaryLow": 32.05,
    "salaryMed": 42.74,
    "salaryHigh": 55.29,
    "totalSkill": 162,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Occupations in front-line public protection services",
    "cluster": 5,
    "wage": 42.74,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 610,
    "f2Engineering": 545,
    "f3Humanities": 35,
    "f4SocialScience": 170,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 705,
    "f8Education(teachertraining)": 35,
    "f9Law": 3695,
    "f10Health": 280,
    "f11Health,Nursing&ClinicalLaboratory": 380,
    "f12Business": 235,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 145,
    "d3Architecture&LandscapeArchitecture": 40,
    "d4Humanities": 35,
    "d5SocialSciences": 170,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 705,
    "d9Education(teachertraining)": 35,
    "d10Engineering": 505,
    "d11Law": 3695,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 260,
    "d14Theology": 0,
    "d15PhysicalSciences": 435,
    "d16Therapy&Rehabilitation": 20,
    "d17Health,Nursing&ClinicalLaboratory": 380,
    "d18Business&Commerce": 235,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 231,
    "noc": 4313,
    "job": "Non-commissioned ranks of the Canadian Forces",
    "title1": "able seaman - armed forces",
    "title2": "armour defence gunner",
    "title3": "artillery soldier",
    "allTitles": "able seaman - armed forcesarmour defence gunnerartillery soldierassault pioneerchief petty officer first classchief petty officer second classchief warrant officercorporalinfanteerinfantry soldierleading seamanmaster corporalmaster seamanmaster warrant officermortarmanmortarman/womanmortarwomannaval acoustics operatornaval electronics technician - armed forcesordinary seaman - armed forcespetty officer first classpetty officer second classprivateprivate recruitreconnaissance patrolmansergeanttrooperwarrant officer",
    "workers": 3450,
    "minEduc": 0,
    "yearsStudy": 1.912087912,
    "automationRisk": 0.518721207,
    "salaryLow": 14,
    "salaryMed": 25.35,
    "salaryHigh": 43.02,
    "totalSkill": 141,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Occupations in front-line public protection services",
    "cluster": 5,
    "wage": 25.35,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 610,
    "f2Engineering": 455,
    "f3Humanities": 25,
    "f4SocialScience": 150,
    "f5FineArts": 95,
    "f6MathAndComputerScience": 140,
    "f7Arts&Education": 770,
    "f8Education(teachertraining)": 0,
    "f9Law": 665,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 175,
    "f12Business": 365,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 150,
    "d6Fine&AppliedArts": 95,
    "d7ComputerScience": 140,
    "d8OtherArts&Science": 770,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 455,
    "d11Law": 665,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 610,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 175,
    "d18Business&Commerce": 365,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 232,
    "noc": 4412,
    "job": "Home support workers, housekeepers and related occupations",
    "title1": "attendant for persons with a visual impairment - home care",
    "title2": "attendant for persons with disabilities - home care",
    "title3": "client care attendant - home care",
    "allTitles": "attendant for persons with a visual impairment - home careattendant for persons with disabilities - home careclient care attendant - home carecompaniondomestic housekeeperdoulafamily caregiverfamily worker - home carehome-care workerhome health care workerhomemakerhome support workerhome visitor - infant carehousekeeperhousekeeper, live-inlive-in caregiver - persons with disabilitieslive-in caregiver - seniorspersonal aide - home supportpersonal assistant - home carepersonal care aide - home carepersonal care attendant - home carepersonal care provider - home carepersonal support aide - home aidepersonal support worker - home supportrespite worker - home supportteaching homemakervisiting homemaker",
    "workers": 23875,
    "minEduc": 0,
    "yearsStudy": 2.685185185,
    "automationRisk": 0.63,
    "salaryLow": 14,
    "salaryMed": 15.72,
    "salaryHigh": 23.85,
    "totalSkill": 130,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 15.72,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 90,
    "f2Engineering": 45,
    "f3Humanities": 1295,
    "f4SocialScience": 480,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 75,
    "f7Arts&Education": 595,
    "f8Education(teachertraining)": 1035,
    "f9Law": 265,
    "f10Health": 1100,
    "f11Health,Nursing&ClinicalLaboratory": 16895,
    "f12Business": 1855,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 90,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 1295,
    "d5SocialSciences": 480,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 75,
    "d8OtherArts&Science": 595,
    "d9Education(teachertraining)": 1035,
    "d10Engineering": 45,
    "d11Law": 265,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 1080,
    "d17Health,Nursing&ClinicalLaboratory": 16895,
    "d18Business&Commerce": 1855,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 233,
    "noc": 4413,
    "job": "Elementary and secondary school teacher assistants",
    "title1": "aide, remedial education",
    "title2": "aide, teacher's",
    "title3": "assistant, educational",
    "allTitles": "aide, remedial educationaide, teacher'sassistant, educationalassistant, secondary school teacher'sassistant, special educationassistant, teacher'sattendant, child care - elementary schoolchild care attendant - elementary schoolclassroom assistant - primary and secondary schooleducational assistanteducational resources assistantelementary school teacher's aideelementary school teacher's assistanthelper, teacher'shomework assistantinstructional assistant - primary and secondary schoollunchroom supervisor - schoollunchtime supervisor - primary and secondary schoolparaeducatorparaprofessional educatorprogram assistant, educationremedial education aideschool lunchroom supervisorsecondary school teacher's aidesecondary school teacher's assistantspecial education assistantspecial needs educational assistantspecial programs aide - educationstudent monitorstudent support assistantteacher's aideteacher's assistantteacher's helperteaching staff assistant, primary and secondary school",
    "workers": 25400,
    "minEduc": 0,
    "yearsStudy": 2.882129278,
    "automationRisk": 0.56,
    "salaryLow": 14,
    "salaryMed": 22.36,
    "salaryHigh": 30,
    "totalSkill": 136,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 22.36,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 65,
    "f2Engineering": 0,
    "f3Humanities": 6745,
    "f4SocialScience": 1675,
    "f5FineArts": 395,
    "f6MathAndComputerScience": 85,
    "f7Arts&Education": 1405,
    "f8Education(teachertraining)": 7585,
    "f9Law": 500,
    "f10Health": 2845,
    "f11Health,Nursing&ClinicalLaboratory": 2345,
    "f12Business": 1755,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 6745,
    "d5SocialSciences": 1675,
    "d6Fine&AppliedArts": 395,
    "d7ComputerScience": 85,
    "d8OtherArts&Science": 1405,
    "d9Education(teachertraining)": 7585,
    "d10Engineering": 0,
    "d11Law": 500,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 305,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 2540,
    "d17Health,Nursing&ClinicalLaboratory": 2345,
    "d18Business&Commerce": 1755,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 234,
    "noc": 4421,
    "job": "Sheriffs and bailiffs",
    "title1": "automobile repossessor",
    "title2": "bailiff",
    "title3": "car repossessor",
    "allTitles": "automobile repossessorbailiffcar repossessorchief deputy sheriffchief sheriffcourt bailiffcourt enforcement officerdeputy sheriffdistrict sheriffprivate bailiffprocess serversheriffsheriff's bailiffsheriff's officersub-sheriffwrit server - bailiff",
    "workers": 20,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.229,
    "salaryLow": 24.13,
    "salaryMed": 36,
    "salaryHigh": 48.35,
    "totalSkill": 151,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 32.74115579,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 235,
    "noc": 4422,
    "job": "Correctional service officers",
    "title1": "convict guard",
    "title2": "correctional facility guard",
    "title3": "correctional institution guard",
    "allTitles": "convict guardcorrectional facility guardcorrectional institution guardcorrectional institution head matroncorrectional officercorrectional officers supervisorcorrectional service officercorrectional services unit supervisorcorrections officerdetention attendantdetention guardguard, correctional facilityguard, correctional institutionhead correctional officerhead matron - correctional serviceinstitution guard - correctional servicejailerjail guardmatron - correctional servicepenal institution guardpenitentiary guardprison guardprison officerreformatory guardsupervisor, correctional officers",
    "workers": 3005,
    "minEduc": 0,
    "yearsStudy": 2.466666667,
    "automationRisk": 0.6,
    "salaryLow": 26.44,
    "salaryMed": 32,
    "salaryHigh": 46.7,
    "totalSkill": 138,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 32,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 10,
    "f2Engineering": 30,
    "f3Humanities": 70,
    "f4SocialScience": 300,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 0,
    "f9Law": 2280,
    "f10Health": 80,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 150,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 70,
    "d5SocialSciences": 300,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 30,
    "d11Law": 2280,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 65,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 150,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 236,
    "noc": 4423,
    "job": "By-law enforcement and other regulatory officers, n.e.c.",
    "title1": "animal control inspector animal control officer animal control supervisor by-law enforcement officer by-law enforcement officers supervisor commercial transport inspector commercial vehicle enforcement officer development control officer dog catcher dog warden garbage collection inspector highway scale operator Humane Society inspector Humane Society officer inspector � by-law enforcement inspector � municipal law enforcement licence inspector liquor board licence inspector liquor licence inspector lottery supervisor � government services municipal law enforcement officer municipal law enforcement officers supervisor officer, by-law enforcement officer, municipal law enforcement parking control officer pound officer property standards inspector property use inspector right of way inspector road transport inspector service station inspector sign inspector subdivision control officer supervisor, animal control supervisor, by-law enforcement officers supervisor, municipal law enforcement officers taxi inspector traffic supervisor � by-law enforcement transport compliance officer transportation enforcement officer weigh station operator � by-law enforcement zoning enforcement officer zoning inspector",
    "title2": 0,
    "title3": 0,
    "allTitles": "animal control inspector animal control officer animal control supervisor by-law enforcement officer by-law enforcement officers supervisor commercial transport inspector commercial vehicle enforcement officer development control officer dog catcher dog warden garbage collection inspector highway scale operator Humane Society inspector Humane Society officer inspector � by-law enforcement inspector � municipal law enforcement licence inspector liquor board licence inspector liquor licence inspector lottery supervisor � government services municipal law enforcement officer municipal law enforcement officers supervisor officer, by-law enforcement officer, municipal law enforcement parking control officer pound officer property standards inspector property use inspector right of way inspector road transport inspector service station inspector sign inspector subdivision control officer supervisor, animal control supervisor, by-law enforcement officers supervisor, municipal law enforcement officers taxi inspector traffic supervisor � by-law enforcement transport compliance officer transportation enforcement officer weigh station operator � by-law enforcement zoning enforcement officer zoning inspector",
    "workers": 1512.5,
    "minEduc": 0,
    "yearsStudy": 2.233333334,
    "automationRisk": 0.4145,
    "salaryLow": 21.82,
    "salaryMed": 40,
    "salaryHigh": 50,
    "totalSkill": 144.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 32.3705779,
    "skillsComp": 39.5,
    "skillsLogi": 36.5,
    "skillsMath": 20.5,
    "skillsLang": 48.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 16.5,
    "s13DocumentUse": 17.5,
    "s14Writing": 13.5,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 5,
    "f2Engineering": 15,
    "f3Humanities": 35,
    "f4SocialScience": 150,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 27.5,
    "f8Education(teachertraining)": 0,
    "f9Law": 1150,
    "f10Health": 40,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 75,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 150,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 27.5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 1150,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 7.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 5,
    "d16Therapy&Rehabilitation": 32.5,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 75,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 237,
    "noc": 5111,
    "job": "Librarians",
    "title1": "art librarian",
    "title2": "associate librarian",
    "title3": "automation librarian",
    "allTitles": "art librarianassociate librarianautomation librarianbibliographerbookmobile librariancataloguer - librarychildren's services librarianclassifier - librarycomputer search librariancybrariandatabase librariandocumentation librarianhealth librarianiconographerinformation and reference librarianinformation services librarianlaw librarianliaison librarianlibrarianlibrary consultantlibrary co-ordinatorlibrary supervisormedical librarianmultimedia librarianmusic librarianmusic librarian - broadcastingperiodicals librarianreference librarianresource sharing and processing librarianscientific librariansupervisor, librarytechnical services librarianunit head librarian",
    "workers": 3865,
    "minEduc": 3,
    "yearsStudy": 3.948717949,
    "automationRisk": 0.65,
    "salaryLow": 25.96,
    "salaryMed": 31.62,
    "salaryHigh": 43.96,
    "totalSkill": 129,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 31.62,
    "skillsComp": 31,
    "skillsLogi": 27,
    "skillsMath": 14,
    "skillsLang": 57,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 7,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 11,
    "s14Writing": 17,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 125,
    "f4SocialScience": 60,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 380,
    "f7Arts&Education": 3020,
    "f8Education(teachertraining)": 100,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 35,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 125,
    "d5SocialSciences": 60,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 380,
    "d8OtherArts&Science": 3020,
    "d9Education(teachertraining)": 100,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 35,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 238,
    "noc": 5112,
    "job": "Conservators and curators",
    "title1": "archaeology curator",
    "title2": "archaeology museum curator",
    "title3": "art gallery conservator",
    "allTitles": "archaeology curatorarchaeology museum curatorart gallery conservatorart gallery curatorartifact conservatorart object curatorassistant curatorassistant museum curatoraviation and space museum curatorceramics and glass conservatorconservator, art galleryconservator - art objectsconservator - museumcontemporary art curatorcontemporary art museum curatorcuratorethnology curatorethnology museum curatorfine art and polychrome conservatorfossil conservatorfossil curatorfurniture and wooden objects conservatorherbarium curatorhistorical artifact conservatorinsectarium conservatorinsectarium curatorinvertebrate zoology curatorinvertebrate zoology museum curatorlibrary curatormetals conservatormuseologistmuseum curatormuseum objects conservatornatural history museum curatornatural history specimen conservatornatural sciences curatornatural sciences museum curatorornithology curatorornithology museum curatorpaintings conservatorpaper conservatorphotograph conservatorphotography museum curatorscience and technology curatorscience and technology museum curatorsculpture conservatortextile conservatorvertebrate zoology curatorvertebrate zoology museum curator",
    "workers": 285,
    "minEduc": 0,
    "yearsStudy": 4.2,
    "automationRisk": 0.298,
    "salaryLow": 19.5,
    "salaryMed": 30.22,
    "salaryHigh": 48.9,
    "totalSkill": 151,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 30.22,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 25,
    "f4SocialScience": 0,
    "f5FineArts": 195,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 65,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 195,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 65,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 239,
    "noc": 5113,
    "job": "Archivists",
    "title1": "archivist",
    "title2": "archivist, assistant",
    "title3": "archivist, fine arts",
    "allTitles": "archivistarchivist, assistantarchivist, fine artsarchivist, videosassistant archivistcollections archivistcorporate archivistfine arts archivisthistorical archivistmultimedia archivistphoto archivistresearch archivistvideo archivist",
    "workers": 305,
    "minEduc": 2,
    "yearsStudy": 4.818181818,
    "automationRisk": 0.76,
    "salaryLow": 22.73,
    "salaryMed": 30.92,
    "salaryHigh": 46.43,
    "totalSkill": 146,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 26.20681294,
    "skillsComp": 27,
    "skillsLogi": 34,
    "skillsMath": 21,
    "skillsLang": 64,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 9,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 11,
    "s14Writing": 22,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 120,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 25,
    "f7Arts&Education": 160,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 120,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 160,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 240,
    "noc": 5121,
    "job": "Authors and writers",
    "title1": "ad writer advertising copywriter advertising writer author biographer copywriter crossword puzzle maker designer and script writer dialogue writer dubbing dialogue writer essayist feature writer fiction writer game, CD-ROM or Web critic ghost writer handbook writer help file developer humorist-author interactive media writer lexicographer literary writer manual writer medical writer multimedia author multimedia script writer multimedia writer new media writer novelist on-line reference developer playwright poet programmed-instruction writer publicity writer radio writer rewriter scientific writer screen writer script and dialogue writer script writer self-instruction manual writer serial story writer serial writer short story writer specifications writer specifications writer (except construction) speech writer sports writer � novels and books standards writer storyboarder support materials writer technical writer technical writer � aeronautics technical writer � chemical processing technical writer � electronics equipment technical writer � pharmaceutical industry teleplay writer, screenwriter television writer writer writer, advertising writer, fiction writer, handbooks writer, interactive media writer, multimedia writer, new media writer, self-instruction manuals writer, short stories writer, speeches",
    "title2": 0,
    "title3": 0,
    "allTitles": "ad writer advertising copywriter advertising writer author biographer copywriter crossword puzzle maker designer and script writer dialogue writer dubbing dialogue writer essayist feature writer fiction writer game, CD-ROM or Web critic ghost writer handbook writer help file developer humorist-author interactive media writer lexicographer literary writer manual writer medical writer multimedia author multimedia script writer multimedia writer new media writer novelist on-line reference developer playwright poet programmed-instruction writer publicity writer radio writer rewriter scientific writer screen writer script and dialogue writer script writer self-instruction manual writer serial story writer serial writer short story writer specifications writer specifications writer (except construction) speech writer sports writer � novels and books standards writer storyboarder support materials writer technical writer technical writer � aeronautics technical writer � chemical processing technical writer � electronics equipment technical writer � pharmaceutical industry teleplay writer, screenwriter television writer writer writer, advertising writer, fiction writer, handbooks writer, interactive media writer, multimedia writer, new media writer, self-instruction manuals writer, short stories writer, speeches",
    "workers": 3516.666667,
    "minEduc": 3,
    "yearsStudy": 3.962941999,
    "automationRisk": 0.181666667,
    "salaryLow": 17.31,
    "salaryMed": 21.15,
    "salaryHigh": 34.62,
    "totalSkill": 161,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 30.29333333,
    "skillsComp": 35.66666667,
    "skillsLogi": 39.33333333,
    "skillsMath": 18.33333333,
    "skillsLang": 67.66666667,
    "topSkill1": "Writing",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3.666666667,
    "s6MoneyMath": 5.666666667,
    "s7NumericalEstimation": 3.666666667,
    "s8OralCommunication": 16.66666667,
    "s9ProblemSolving": 10.33333333,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 5.333333333,
    "s12DigitalTechnology": 19.33333333,
    "s13DocumentUse": 12.33333333,
    "s14Writing": 25,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 16.66666667,
    "f2Engineering": 0,
    "f3Humanities": 221.6666667,
    "f4SocialScience": 2078.333333,
    "f5FineArts": 773.3333333,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 173.3333333,
    "f8Education(teachertraining)": 86.66666667,
    "f9Law": 58.33333333,
    "f10Health": 5,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 103.3333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 16.66666667,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 208.3333333,
    "d5SocialSciences": 2078.333333,
    "d6Fine&AppliedArts": 773.3333333,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 173.3333333,
    "d9Education(teachertraining)": 86.66666667,
    "d10Engineering": 0,
    "d11Law": 58.33333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 13.33333333,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 5,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 103.3333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 241,
    "noc": 5122,
    "job": "Editors",
    "title1": "advertising editor",
    "title2": "art editor",
    "title3": "assistant editor",
    "allTitles": "advertising editorart editorassistant editorassociate editorbilingual editorbook editorbusiness editorcaption editorcity editorcontributing editorcontrol room editor - broadcastingcopy chiefcopy editorcopy preparerdictionary editoreditoreditor, advertisingeditor, blogeditor, bookeditor, businesseditor, control room - broadcastingeditor, dictionaryeditor, editorial pageeditorial consultanteditorial page editoreditor, journaleditor, magazineeditor, manuscriptseditor, newspapereditor, pictureeditor, Web siteEnglish editorfeature editorfinancial editorfinancial news editorforeign news broadcasting editorforeign news service editorFrench editorinformation editorjournal editorline editorline-up editorliterary editorlocal news editormagazine editormanuscript editormedical editornews desk editornews editornews editor - broadcastingnewspaper editornews service editorproduction editorpublications editorscientific editorscript editorsenior editorsociety editorspecial features editorsport desk editorsports editorsub-editortechnical editortelecommunications editorwriter-editor",
    "workers": 4880,
    "minEduc": 3,
    "yearsStudy": 3.972222222,
    "automationRisk": 0.055,
    "salaryLow": 15.57,
    "salaryMed": 24.29,
    "salaryHigh": 37,
    "totalSkill": 161,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 24.29,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 25,
    "skillsLang": 62,
    "topSkill1": "Writing",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 7,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 7,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 13,
    "s14Writing": 26,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 35,
    "f2Engineering": 0,
    "f3Humanities": 370,
    "f4SocialScience": 2010,
    "f5FineArts": 1735,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 310,
    "f8Education(teachertraining)": 150,
    "f9Law": 155,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 115,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 330,
    "d5SocialSciences": 2010,
    "d6Fine&AppliedArts": 1735,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 310,
    "d9Education(teachertraining)": 150,
    "d10Engineering": 0,
    "d11Law": 155,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 40,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 115,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 242,
    "noc": 5123,
    "job": "Journalists",
    "title1": "anchorman",
    "title2": "anchorman/woman",
    "title3": "anchorperson, television news",
    "allTitles": "anchormananchorman/womananchorperson, television newsanchorwomanart criticbook criticbook reviewerbroadcast journalistchroniclercolumnistcolumnist, entertainmentcolumnist, fashioncolumnist, societycolumnist, sportscommentatorcommentator, radiocorrespondentcorrespondent, newspapercriticculinary journalistcyberjournalistcyberreporterdrama criticeditorial writer, newspaperentertainment columnistfashion columnistfeature reporterfield reporterfilm criticfinancial reporterforeign affairs reporterforeign correspondentforeign news correspondentheadline writerinvestigative reporterjournalistlaw reporterliterary criticmovie criticmultimedia information tradermusic criticmusic reviewernetsurfernetwork reporternews analystnews analyst - broadcastingnewscast correspondentnews commentatornews commentator - broadcastingnews correspondentnewspaper correspondentnewspaper criticnewspaper editorial writernewspaper reporternewspaper writernews reporternews writer - international broadcastingon-line chronicleron-line columnistpolitical analyst - radio or televisionpolitical columnistpolitical reporterpress reporterprogram researcher - radio or televisionradio commentatorradio researcherreporterreporter, foreign affairsreporter, newspaperreporter, pressreporter, societyresearcher, radioresearcher, televisionsociety columnistsociety journalistsociety reportersports columnistsports reportersports writer - journalismstaff writer - newspaperstock market reportertelevision news anchorpersontelevision researchertheatre critic",
    "workers": 3065,
    "minEduc": 3,
    "yearsStudy": 3.86,
    "automationRisk": 0.11,
    "salaryLow": 20.43,
    "salaryMed": 32.69,
    "salaryHigh": 46.7,
    "totalSkill": 182,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 32.69,
    "skillsComp": 35,
    "skillsLogi": 53,
    "skillsMath": 18,
    "skillsLang": 76,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 15,
    "s10Reading": 30,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 13,
    "s14Writing": 25,
    "s15CriticalThinking": 13,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 120,
    "f4SocialScience": 2385,
    "f5FineArts": 390,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 110,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 120,
    "d5SocialSciences": 2385,
    "d6Fine&AppliedArts": 390,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 110,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 243,
    "noc": 5125,
    "job": "Translators, terminologists and interpreters",
    "title1": "American Sign Language (ASL) interpreter",
    "title2": "ASL (American Sign Language) interpreter",
    "title3": "certified interpreter (C.Int.)",
    "allTitles": "American Sign Language (ASL) interpreterASL (American Sign Language) interpretercertified interpreter (C.Int.)certified terminologist (C.Term.)certified translator (C.Tr.)C. Int. (certified interpreter)community interpreterconference interpreterconsecutive interpretercourt interpreterC. Term. (certified terminologist)C. Tr. (certified translator)cultural interpretercultural or international adaptation specialistdeaf interpretereducational interpreterelbow interpreterescort interpreterforeign broadcast translatorforeign news translatorinterpreterinterpreter for persons who are deafinterpreter, sign languagejurilinguist translatorlegal terminologistlegal translatorliterary translatorlocaliserLSQ (Quebec Sign Language) interpretermedical terminologistmedical translatororal interpreterplatform interpreter, sign languageQuebec Sign Language (LSQ) interpreterrelay interpreterreviser - translationscientific translatorsign language interpretersign language platform interpretersimultaneous interpretertactile interpretertechnical translatorterminologistterminology advisortranslatortranslator adaptortranslator, foreign broadcaststranslator, foreign newstranslator-revisertransliteratorvisual language interpreter",
    "workers": 2605,
    "minEduc": 3,
    "yearsStudy": 4.056603774,
    "automationRisk": 0.38,
    "salaryLow": 19.44,
    "salaryMed": 33.9,
    "salaryHigh": 48.2,
    "totalSkill": 140,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 33.9,
    "skillsComp": 34,
    "skillsLogi": 29,
    "skillsMath": 12,
    "skillsLang": 65,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 28,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 11,
    "s14Writing": 24,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 175,
    "f4SocialScience": 1840,
    "f5FineArts": 195,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 100,
    "f8Education(teachertraining)": 110,
    "f9Law": 20,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 135,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 175,
    "d5SocialSciences": 1840,
    "d6Fine&AppliedArts": 195,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 100,
    "d9Education(teachertraining)": 110,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 15,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 135,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 244,
    "noc": 5131,
    "job": "Producers, directors, choreographers and related occupations",
    "title1": "art director - motion pictures, broadcasting and performing arts",
    "title2": "artistic director - motion picture",
    "title3": "artistic director, performing arts",
    "allTitles": "art director - motion pictures, broadcasting and performing artsartistic director - motion pictureartistic director, performing artsassistant directorassistant director - motion pictures, broadcasting and performing artsaudiovisual (AV) producerbroadcasting directorbroadcasting producerbroadcasting sports directorcasting directorchoreographercinematographercyber-choreographerdirector, broadcastingdirector - motion picturedirector, motion picturedirector - motion pictures, broadcasting and performing artsdirector of photographydirector, radiodirector, stage - performing artsdirector, televisiondirector, videoseditor, filmsfilm directorfilm editorfilmmakerfilm producerfloor director - performing artsmotion picture directormotion picture producermotion picture production directormovie directormovie producermultimedia audio producerperforming arts artistic directorproducer, broadcastingproducer-directorproducer, motion pictureproducer - performing artsproducer, stageproduction designer - motion pictures, broadcasting and performing artsproduction director - motion pictureprogram director - broadcastingradio directorradio producerrecording directorrecord producerstage director - performing artsstage producertechnical director - broadcastingtechnical director - motion pictures, broadcasting and performing artstechnical producertechnical producer - motion pictures, broadcasting and performing artstelevision directortelevision director-producertelevision producervideo directorvideo illustrator - multimedia workvideo makervideo producer",
    "workers": 6370,
    "minEduc": 3,
    "yearsStudy": 3.486725664,
    "automationRisk": 0.022,
    "salaryLow": 16,
    "salaryMed": 28.21,
    "salaryHigh": 46.15,
    "totalSkill": 162,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 28.21,
    "skillsComp": 40,
    "skillsLogi": 43,
    "skillsMath": 21,
    "skillsLang": 58,
    "topSkill1": "Writing",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 11,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 19,
    "s14Writing": 22,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 40,
    "f3Humanities": 105,
    "f4SocialScience": 2020,
    "f5FineArts": 3725,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 345,
    "f8Education(teachertraining)": 15,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 85,
    "d5SocialSciences": 2020,
    "d6Fine&AppliedArts": 3725,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 345,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 40,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 20,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 245,
    "noc": 5132,
    "job": "Conductors, composers and arrangers",
    "title1": "arranger",
    "title2": "arranger, music",
    "title3": "artistic director - music",
    "allTitles": "arrangerarranger, musicartistic director - musicartistic director, orchestraauthor-composer-performerband conductorband directorbandmasterchansonnierchoir directorchoir leaderchoirmasterchoral conductorchoral directorchorus mastercomposerconductorconductor, bandconductor, choralconductor, orchestracopyist - musicdirector, banddirector, choirdirector, choraldirector, musicleader, choirlyricistmaestromaster, chorusmotion picture musical directormusic adaptermusical directormusical director, motion picturemusical director, stagemusical director, televisionmusic arrangermusic copyistmusic directormusic writerorchestra artistic directororchestral conductororchestratororchestrator-arrangersinger-songwriter-composersongwriterstage musical directortelevision musical directorwriter-composer-performerwriter, musicwriter, songs",
    "workers": 490,
    "minEduc": 0,
    "yearsStudy": 3.923076923,
    "automationRisk": 0.015,
    "salaryLow": 28.75,
    "salaryMed": 31.64,
    "salaryHigh": 60.65,
    "totalSkill": 158,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 19.24255319,
    "skillsComp": 43,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 490,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 490,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 246,
    "noc": 5133,
    "job": "Musicians and singers",
    "title1": "accompanist",
    "title2": "accordion teacher - private, conservatory or studio lessons",
    "title3": "alto",
    "allTitles": "accompanistaccordion teacher - private, conservatory or studio lessonsaltoback-up musicianbaritonebassbass drum teacher - private, conservatory or studio lessonsbassoon teacher - private, conservatory or studio lessonsbass playerblues singerbuglercarillonneurcellistcello teacher - private, conservatory or studio lessonschoristerchurch organistconcert singercornetistdrummerflutistfolk singergospel singerguitar playerharpisthorn playerhorn teacher - private, conservatory or studio lessonsinstrumentalistinstrumental musicianinstrumental music teacher - private, conservatory or studio lessonskeyboardistlied singermezzo-sopranomusical interpretermusicianmusic teacher - musiciansmusic teacher - private, conservatory or studio lessonsopera singerorganistorgan teacher - private, conservatory or studio lessonspercussionistpianistpiano teacher - private, conservatory or studio lessonspop singerrecital singerrecording artistrehearsal musicianrock singersession musiciansingersoloistsopranostreet musicianteacher, music - private, conservatory or studio lessonstenortrombonisttrumpetertuba playerviola teacher - private, conservatory or studio lessonsviolinistviolin teacher - private, conservatory or studio lessonsvocalistvocal music teacher - private, conservatory or studio lessonsvocal soloistvoice teacher - musicvoice teacher - private, conservatory or studio lessons",
    "workers": 7195,
    "minEduc": 0,
    "yearsStudy": 3.625,
    "automationRisk": 0.074,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 29.91,
    "totalSkill": 157,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 22,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 95,
    "f5FineArts": 5780,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 205,
    "f8Education(teachertraining)": 985,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 65,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 95,
    "d6Fine&AppliedArts": 5780,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 205,
    "d9Education(teachertraining)": 985,
    "d10Engineering": 0,
    "d11Law": 30,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 65,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 247,
    "noc": 5134,
    "job": "Dancers",
    "title1": "ballerina",
    "title2": "ballet dancer",
    "title3": "ballet master",
    "allTitles": "ballerinaballet dancerballet masterballet teacherballroom dancing teacherbaton twirling instructorbelly dancerchorus dancerclassical dance instructorclassical dancerdance instructordance notatordancerdance teacherdancing instructorfolk dancerfolk dance teacherfolkloric dancerfolkloric dance teachergroup dancergroup dance teacherinterpretative dancerinterpretive dancerline dancerline dance teacherperformance movement teachertap dancertap dance teacherteacher, balletteacher, ballroom dancing",
    "workers": 470,
    "minEduc": 0,
    "yearsStudy": 2.823529412,
    "automationRisk": 0.13,
    "salaryLow": 15,
    "salaryMed": 30,
    "salaryHigh": 50,
    "totalSkill": 158,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 30,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 335,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 95,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 335,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 95,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 248,
    "noc": 5135,
    "job": "Actors and comedians",
    "title1": "acting teacher - private or studio",
    "title2": "actor",
    "title3": "actor/actress",
    "allTitles": "acting teacher - private or studioactoractor/actressactresscomediancomicdiction coachdrama actordrama coachdrama teacher - private or studiodramatic arts teacher - private or studiodramatic readerextra, performing artsfilm dubberhumorist - performing artsimprovisermimemovie actornarratorreader - performing artsstandardized patientstand-up comedianstory tellerstraight manvoice coachvoice-over actor",
    "workers": 1345,
    "minEduc": 0,
    "yearsStudy": 3.5625,
    "automationRisk": 0.37,
    "salaryLow": 17.55,
    "salaryMed": 27.37,
    "salaryHigh": 49.466,
    "totalSkill": 146,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 30.09481802,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 1225,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 105,
    "f8Education(teachertraining)": 15,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 1225,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 105,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 249,
    "noc": 5136,
    "job": "Painters, sculptors and other visual artists",
    "title1": "animal art painter",
    "title2": "animal art sculptor",
    "title3": "art instructor",
    "allTitles": "animal art painteranimal art sculptorart instructorart instructor (except primary, secondary, post-secondary education)artistartistic painterartistic printmakerartist, plastic artsartist, visual artsart teacher (except primary, secondary and post-secondary education)charcoal artistclay modellerdecorations painter - visual artsetcher - visual artsice sculptorink sketcherInuit art sculptorlandscape artist, muralslandscape painterlithographic artistmaritime art paintermural landscape artistmural painteroil painterpainter - visual artsplastic arts artistportrait painterprintmaker - visual artsprintmaking teacherscenery painterscenic painter - visual artssculptorsculptor, metalsculptor-modellersculptor, monumentssculptor, woodsculpture teacher (except primary, secondary, post-secondary education)sculpturing teacher (except primary, secondary, post-secondary education)silhouette artistsilkscreen artistteacher, paintingteacher, printmakingteacher, sculpturing (except primary, secondary, post-secondary education)video artistvisual arts teacher (except primary, secondary, post-secondary education)watercolouristwood block artistwood sculptor",
    "workers": 2815,
    "minEduc": 0,
    "yearsStudy": 3.636363636,
    "automationRisk": 0.042,
    "salaryLow": 14,
    "salaryMed": 25,
    "salaryHigh": 60.62,
    "totalSkill": 159,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Professional occupations in art and culture",
    "cluster": 2,
    "wage": 25,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 80,
    "f5FineArts": 2260,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 165,
    "f8Education(teachertraining)": 290,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 80,
    "d6Fine&AppliedArts": 2260,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 165,
    "d9Education(teachertraining)": 290,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 250,
    "noc": 5211,
    "job": "Library and public archive technicians",
    "title1": "archival assistant",
    "title2": "archival management technician",
    "title3": "archive assistant",
    "allTitles": "archival assistantarchival management technicianarchive assistantarchive attendantarchive technicianassistant music librarianattendant, archivecataloguing technicianelementary school librarianhigh school librarianlibrary technicianschool librarian - secondary schoolsecondary school librariantechnical indexer - librarytechnician, library",
    "workers": 2100,
    "minEduc": 2,
    "yearsStudy": 3.513513514,
    "automationRisk": 0.99,
    "salaryLow": 14.34,
    "salaryMed": 27.62,
    "salaryHigh": 44.87,
    "totalSkill": 137,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 27.62,
    "skillsComp": 31,
    "skillsLogi": 41,
    "skillsMath": 12,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 1,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 10,
    "s14Writing": 15,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 100,
    "f4SocialScience": 15,
    "f5FineArts": 130,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1630,
    "f8Education(teachertraining)": 115,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 100,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 130,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1630,
    "d9Education(teachertraining)": 115,
    "d10Engineering": 0,
    "d11Law": 30,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 251,
    "noc": 5212,
    "job": "Technical occupations related to museums and art galleries",
    "title1": "aircraft restoration technician - museum",
    "title2": "aquarium interpreter",
    "title3": "archaeological technician",
    "allTitles": "aircraft restoration technician - museumaquarium interpreterarchaeological technicianart gallery preparatorart gallery registrarart objects preparatorart restoration technicianassistant registrar - museumbotanical garden interpretercataloguer - museumcataloguer, museum objectschief display officer - museumchief exhibit officer - museumchief preparatorchief preparator - museums and art galleriescommunications equipment restoration technician - museumcommunity museum technicianconservation and restoration technicianconservation area interpreterconservation technician - museums and art galleriescuratorial assistantdinosaur museum interpreterdiorama maker - museums and art galleriesdiorama techniciandisplay officer - museums and art galleriesdocument restoration technicianecological interpreterexhibit officer - museumexhibit preparatorexhibit technicianfossil recovery and reparation technicianframe fitter - museums and art galleriesframer - museum and art galleryframing technicianhead preparator - museums and art galleriesheritage interpreterhistorical interpreterhistorical site technicianhistorical village supervisorhistorical village technicianhistoric site interpreterhistory museum interpreterinsectarium interpreterinterpreter, historic siteinterpreter, museuminterpretive guide - museummodel maker-preparatormuseology technicianmuseum cataloguermuseum exhibit officermuseum extension officermuseum interpretermuseum objects cataloguermuseum objects preparatormuseum preparatormuseum registrarmuseum technicianmuseum technician - earth's history and paleontologynatural habitat interpreternature interpreternature site interpreterornithology centre interpreterpaintings restoration technicianpark interpreterpicture framer - museum and art galleryplanetarium interpreterplanetarium technicianpreparatorrailway equipment restoration technician - museumrecording technician - museumregional museum technicianregistrar, museumrestoration technician - museumroad transport equipment restoration technician - museumtaxidermisttaxidermy techniciantechnical officer - museumtechnician, conservation - museums and art galleriestechnician, museumtechnician, restoration - museumwilderness interpreterzoo interpreter",
    "workers": 305,
    "minEduc": 2,
    "yearsStudy": 4,
    "automationRisk": 0.59,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 28,
    "totalSkill": 261,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 20,
    "skillsComp": 52,
    "skillsLogi": 61,
    "skillsMath": 32,
    "skillsLang": 116,
    "topSkill1": "Writing",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 19,
    "s3FindingInformation": 20,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 17,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 19,
    "s10Reading": 49,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 24,
    "s13DocumentUse": 25,
    "s14Writing": 55,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 125,
    "f4SocialScience": 20,
    "f5FineArts": 60,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 10,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 125,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 60,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 252,
    "noc": 5221,
    "job": "Aircraft instrument, electrical and avionics mechanics, technicians and inspectors",
    "title1": "aerial photographer",
    "title2": "chief photographer",
    "title3": "commercial photographer",
    "allTitles": "aerial photographerchief photographercommercial photographerevidence photographer - forensicfashion photographerfinish photographerforensic photographerindustrial photographermedical photographermultimedia photographermultimedia picture illustratornews photographerphotographerphotography supervisorphotojournalistphotomicrographerpolice photographerportrait photographerracetrack finish photographerretoucher - photographyscientific photographerstill photographerstreet photographersupervisor, photographywildlife photographer",
    "workers": 3570,
    "minEduc": 1,
    "yearsStudy": 2.346335698,
    "automationRisk": 0.3255,
    "salaryLow": 14,
    "salaryMed": 27.4,
    "salaryHigh": 69.23,
    "totalSkill": 161.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 32.2,
    "skillsComp": 45,
    "skillsLogi": 43.5,
    "skillsMath": 22.5,
    "skillsLang": 50,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 20.5,
    "s13DocumentUse": 19.5,
    "s14Writing": 18,
    "s15CriticalThinking": 14,
    "f1Science&Agriculture": 0,
    "f2Engineering": 25,
    "f3Humanities": 0,
    "f4SocialScience": 110,
    "f5FineArts": 1825,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 100,
    "f8Education(teachertraining)": 40,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 110,
    "d6Fine&AppliedArts": 1825,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 100,
    "d9Education(teachertraining)": 40,
    "d10Engineering": 25,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 253,
    "noc": 5222,
    "job": "Film and video camera operators",
    "title1": "assistant camera operator",
    "title2": "camera operator",
    "title3": "camera operator, motion picture",
    "allTitles": "assistant camera operatorcamera operatorcamera operator, motion picturecamera operator, videodance videographerEFP (electronic field production) camera operatorelectronic field production (EFP) camera operatorelectronic news gathering (ENG) camera operatorENG (electronic news gathering) camera operatorfilm cameramanfilm cameraman/womanfilm camera operatorfilm camerawomanmotion picture camera operatornews camera operatorsenior motion picture camera operatorstudio camera operatortelevision camera operatortelevision news camera operatorvideo camera operatorvideographer",
    "workers": 480,
    "minEduc": 0,
    "yearsStudy": 2.4,
    "automationRisk": 0.6,
    "salaryLow": 14,
    "salaryMed": 30,
    "salaryHigh": 43.13,
    "totalSkill": 137,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 30,
    "skillsComp": 37,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 70,
    "f5FineArts": 410,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 70,
    "d6Fine&AppliedArts": 410,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 254,
    "noc": 5223,
    "job": "Graphic arts technicians",
    "title1": "airbrush artist",
    "title2": "animated cartoon inker",
    "title3": "animated cartoon painter",
    "allTitles": "airbrush artistanimated cartoon inkeranimated cartoon painteranimated cartoons inker and painteranimated cartoon techniciananimation camera operatoranimation inkeranimation painterapprentice sign painterartist, airbrushartist, cartoon backgroundartist, paste-upart work assemblerassembler, art workassembler, graphic artscartoon background artistcolourist, photographycomputer graphics design techniciancomputer graphics operatorcomputer graphics techniciancopy stylist, graphic artscutter, silkscreen stencilsdesign assistant - advertising productiondesigner, poster layoutsdetailer, sign layoutsdigital graphic design techniciangraphic arts assemblergraphic arts copy stylistgraphic arts renderergraphic arts techniciangraphics technicianhand painter - graphic artsinker and painter, animated cartoonsinker, animated cartoonsletterer, photo processes - graphic artslettering artistmannequin artistmultimedia graphic design technicianmultimedia graphics technicianoperator, animation camerapainter, animated cartoonspainter, animationpainter, hand - graphic artspainter, posterspainter, signspainter, traffic signspaste-up artistphotographic airbrush artistphotographic colouristphotograph retoucherphotography colouristphoto process letterer - graphic artsphoto stencil makerposter layout designerposter painterrenderer, graphic artsrendering specialistscreen stencil cutter - graphic artssign layout detailersign paintersign writersilkscreen stencil cuttersilkscreen technicianstencil markerstencil marker - graphic artstechnician, graphic artstechnician, silkscreentraffic sign paintervideo game artistvideo game designervinyl lettering artistwriter, signs",
    "workers": 345,
    "minEduc": 2,
    "yearsStudy": 2,
    "automationRisk": 0.049,
    "salaryLow": 14,
    "salaryMed": 19,
    "salaryHigh": 32.75,
    "totalSkill": 151,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 19,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 26,
    "skillsLang": 60,
    "topSkill1": "Writing",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 12,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 8,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 14,
    "s14Writing": 22,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 345,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 345,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 255,
    "noc": 5225,
    "job": "Audio and video recording technicians",
    "title1": "assistant sound editor",
    "title2": "audio engineer - recording studio",
    "title3": "audio operator",
    "allTitles": "assistant sound editoraudio engineer - recording studioaudio operatoraudio operator assistantaudio recording studio operatoraudio technicianaudiovisual (AV) technicianAV (audiovisual) techniciancolour timer - videodigital effects specialistdubbing machine operatoreditor, soundeditor, videotapeelectronic news gathering (ENG) editorelectronic video graphics operatorENG (electronic news gathering) editorfilm technicianfilm technician - motion picturemaster record cuttermixer, music or soundmultimedia sound-effects supervisormultimedia sound technicianmusic editor - recording studiomusic mixermusic or sound mixeroperator, P.A. (public address)operator, P.A. (public address) systemsoperator, public address (P.A.)operator, public address (P.A.) systemsP.A. (public address) operatorP.A. (public address) system operatorplayback operatorpostproduction technicianproduction sound recordistpublic address (P.A.) operatorpublic address (P.A.) system operatorradio recorderradio technicianrecording engineerrecording studio technicianre-recording mixersound cuttersound editorsound effects editorsound effects specialistsound engineersound engineer assistantsound engineer (except professional engineers)sound keyersound librarian - audio-recordingsound mix engineersound mixersound operatorsound recordersound-recording and video-recording reproduction equipment operatorsound recording engineersound-recording equipment operatorsound recording supervisorsound recordistsound technicianstereo tape editorstudio operator, audio recordingsupervisor, sound recordingvideo and sound recordervideo-editing equipment operatorvideo recordervideo-recording equipment operatorvideo recording technicianvideo sound mixervideotape editorvideotape postproduction editorvideotape recording (VTR) editorvideotape recording (VTR) operatorvideotape technicianvideo technicianVTR (videotape recording) editorVTR (videotape recording) operator",
    "workers": 2075,
    "minEduc": 0,
    "yearsStudy": 2.647058824,
    "automationRisk": 0.55,
    "salaryLow": 16.58,
    "salaryMed": 26.19,
    "salaryHigh": 40.34,
    "totalSkill": 138,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 26.19,
    "skillsComp": 37,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 10,
    "f2Engineering": 30,
    "f3Humanities": 0,
    "f4SocialScience": 105,
    "f5FineArts": 1890,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 105,
    "d6Fine&AppliedArts": 1890,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 30,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 256,
    "noc": 5226,
    "job": "Other technical and co-ordinating occupations in motion pictures, broadcasting and the performing arts",
    "title1": "animal wrangler - motion pictures, broadcasting and performing arts",
    "title2": "broadcasting co-ordinator",
    "title3": "chief lighting technician",
    "allTitles": "animal wrangler - motion pictures, broadcasting and performing artsbroadcasting co-ordinatorchief lighting technicianchief stage electricianchief technician, lighting effectscostume makercostumercostumer - motion pictures, broadcasting and performing artscostumes co-ordinatorcostume supervisorcostumierelectrician, setelectrician, stageexterior set managerexterior shooting directorextra wrangler - motion pictures, broadcasting and performing artsfilm location managerfirst gripfloor director - broadcastingfloor manager - broadcastinggafferhead griphead of wardrobekey dresserkey griplighting effects chief technicianlighting technicianlocation manager - motion pictures and broadcastingmachinist-electricianmake-up artistmake-up artist and hairdresser - performing artsmake-up artist and wig makermake-up artist - motion pictures, broadcasting and performing artsmotion picture facilities supervisormusic program plannermusic program planner, radiooptical effects co-ordinatorpresentation co-ordinator - broadcastingproduction co-ordinator - motion pictures, broadcasting and performing artsproduction co-ordinator - radiobroadcastingproduction technician - motion pictures, broadcasting and performing artsprogram co-ordinator - broadcastingprogramming managerprogram planner, musicprogram planner, radioproperties custodian - stage productions or motion picturesproperty master - broadcastingproperty master - motion pictures, broadcasting and performing artsradio music program plannerradio program plannerremote broadcasting co-ordinatorrigging gafferscript supervisorset electriciansettings shop foremansettings shop foreman/womansettings shop forewomanspecial effects techniciansports program co-ordinator - broadcastingstage assistant directorstage electricianstage managerstage technicianstaging supervisorstudio administratorstudio electricianstudio managerstudio manager - broadcastingstunt co-ordinatortelecasting techniciantheatre technicianunit manager - motion pictures and broadcastingwardrobe co-ordinatorwardrobe masterwardrobe master/mistresswardrobe mistresswardrobe supervisorwig hairdresser - motion pictures, broadcasting and performing arts",
    "workers": 725,
    "minEduc": 0,
    "yearsStudy": 2.826086957,
    "automationRisk": 0.61,
    "salaryLow": 15,
    "salaryMed": 25,
    "salaryHigh": 33.83,
    "totalSkill": 135,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 25,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 660,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 45,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 660,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 45,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 257,
    "noc": 5227,
    "job": "Support occupations in motion pictures, broadcasting, photography and the performing arts",
    "title1": "artistic rigger",
    "title2": "audiovisual (AV) assistant - motion pictures and broadcasting",
    "title3": "AV (audiovisual) assistant",
    "allTitles": "artistic riggeraudiovisual (AV) assistant - motion pictures and broadcastingAV (audiovisual) assistantbest boyboom gripboom microphone operatorboom operatorcamera crane operatorcircus riggercontinuity person - motion pictures and broadcastingdolly operator - motion pictures and broadcastingdolly pusher - motion pictures and broadcastingdresserdresser - motion pictures, broadcasting and performing artsduplicate-film examiner - motion pictures and broadcastingentertainment stage riggerexaminer, duplicate film - motion pictures and broadcastingexaminer, motion picturesfilm projectionistfilm quality inspectorfireworks handlerflymanflyman/womanflywomanfocus pullergriphandler, fireworkshigh rigger, theatreinspector, film qualitylighting assistantmotion picture examinermotion picture projectionistmovie theatre projectionistoperator, boom microphoneproduction assistantproduction assistant - motion pictures and broadcastingprojectionistprojectionist, motion picturesprompterproperty personprops handlerprops personrecording assistant - recording studiorigger - motion pictures, broadcasting and performing artsscene shifterscenic artist - motion pictures, broadcasting and performing artsscenic constructorscenic constructor - motion pictures, broadcasting and performing artsscenic painter - motion pictures, broadcasting and performing artsscript assistantscript person - motion pictures and broadcastingsearchlight operatorsecond costumes assistantset builderset dresserspecial effects assistantspotlight operatorstage best boystagehandstage production workerstage property personstaging assistanttechnical assistant - audiovisualtelecine operatorteleprompt operatortheatre high riggerwardrobe assistantwardrobe attendantwig assistant - motion pictures, broadcasting and performing arts",
    "workers": 610,
    "minEduc": 0,
    "yearsStudy": 3.095238095,
    "automationRisk": 0.674,
    "salaryLow": 14,
    "salaryMed": 23,
    "salaryHigh": 27.25,
    "totalSkill": 131,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 23,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 55,
    "f5FineArts": 505,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 55,
    "d6Fine&AppliedArts": 505,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 258,
    "noc": 5231,
    "job": "Announcers and other broadcasters",
    "title1": "announcer announcer, P.A. (public address) system announcer, public address (P.A.) system announcer-producer, international service broadcaster circus ringmaster commentator, fashion show commercial announcer disc jockey � broadcast DJ (disc jockey) � broadcast fashion show commentator freelance announcer game show host/hostess host/hostess � television or radio host/hostess, game show host/hostess, talk show international service announcer-producer MC (master of ceremonies) mobile disc jockey moderator � broadcasting news reader newscaster P.A. (public address) system announcer quiz master � radio and television radio announcer radio host/hostess reporter, traffic reporter, weather sports announcer sports commentator sportscaster staff announcer talk show host/hostess television host/hostess television newscaster video jockey (VJ) � television broadcast VJ (video jockey) � television broadcast",
    "title2": 0,
    "title3": 0,
    "allTitles": "announcer announcer, P.A. (public address) system announcer, public address (P.A.) system announcer-producer, international service broadcaster circus ringmaster commentator, fashion show commercial announcer disc jockey � broadcast DJ (disc jockey) � broadcast fashion show commentator freelance announcer game show host/hostess host/hostess � television or radio host/hostess, game show host/hostess, talk show international service announcer-producer MC (master of ceremonies) mobile disc jockey moderator � broadcasting news reader newscaster P.A. (public address) system announcer quiz master � radio and television radio announcer radio host/hostess reporter, traffic reporter, weather sports announcer sports commentator sportscaster staff announcer talk show host/hostess television host/hostess television newscaster video jockey (VJ) � television broadcast VJ (video jockey) � television broadcast",
    "workers": 35,
    "minEduc": 0,
    "yearsStudy": 4,
    "automationRisk": 0.371,
    "salaryLow": 14,
    "salaryMed": 26.28,
    "salaryHigh": 56.12,
    "totalSkill": 146,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 30.07604967,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 259,
    "noc": 5232,
    "job": "Other performers, n.e.c.",
    "title1": "acrobat",
    "title2": "aerial acrobat - entertainment",
    "title3": "art and photography model",
    "allTitles": "acrobataerial acrobat - entertainmentart and photography modelbuskercircus artistcircus performerclowncontortionistdeejay (DJ) - turntablistDJ (deejay) - turntablistentertainerequilibristerotic dancerexotic dancerface painterfashion modelhigh-wire walkerhypnotistillusionistimpersonatorjugglerlook-alikemagicianmarionette handlermascotmimicmodelMrs. Clausnude dancerprestidigitatorpuppeteerrodeo driverrodeo horse riderSanta ClausSanta Claus/Mrs. Clausshow horse riderslack-rope performer - entertainmentsleight-of-hand artiststreet entertainerstriptease dancerstuntmanstuntman/womanstunt performerstunt riderstuntwomantable dancerthrill performertrapeze artistturntablistveejay (VJ) - video performance artistventriloquistVJ (veejay) - video performance artist",
    "workers": 35,
    "minEduc": 0,
    "yearsStudy": 4,
    "automationRisk": 0.371,
    "salaryLow": 14,
    "salaryMed": 26.28,
    "salaryHigh": 56.12,
    "totalSkill": 146,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 30.07604967,
    "skillsComp": 39,
    "skillsLogi": 37,
    "skillsMath": 21,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 260,
    "noc": 5241,
    "job": "Graphic designers and illustrators",
    "title1": "2D animation artist",
    "title2": "2D animator",
    "title3": "3D animation artist",
    "allTitles": "2D animation artist2D animator3D animation artist3D animatoradvertising art directoradvertising artistadvertising art supervisoradvertising designeradvertising illustratoradvertising layout designeranimated cartoon artistanimated cartoon artist - visual artsanimated cartoon colouristanimation artistanimation layout designeranimator - animated filmsanimator, graphic design and illustrationartistic illustratorartist, storyboardart layout designerassistant animator - animated filmsbackground artistbank note designerbiological illustratorbusiness forms designercalligraphercalligraphic artistcaricaturistcartoon film artistcartoonistcartoonist sketchcatalogue illustratorcell animatorcharacter animatorchief, advertising illustratorcolour artist - cartoonscolourist - cartoonscommercial artistcommercial design artistcommercial designercommunication designercomputer animatorcomputer graphics specialistcontent directorcontent strategistcover designercover page illustratorcybergraphic designerdesigner, form layoutsdigital animator - artisteditorial cartoonistelectronic games designerfashion illustratorflash designerform layout designerforms designergraphic artistgraphic arts room supervisorgraphic design and illustration animatorgraphic designergraphic designer and layout artistgraphic designer - multimediagraphic designer - multimedia, interactive or new mediagraphic designer, Webillustratorillustrator and graphic designerinteractive media designerInternet graphic designerlayout artistlayout designerlayout designer, animationlitho artistmedical illustratormultimedia designermultimedia design specialistmultimedia illustratormultimedia instructional designer and scriptormultimedia products designermultimedia products designer-ideamanmultimedia products designer-ideaman/womanmultimedia products designer-ideawomannew media graphics designernewspaper illustratorpackage designerpage designerpaper securities designerpictographistpolitical caricaturistpolitical cartoonistposter artistregistered graphic designer (RGD)RGD (registered graphic designer)scientific illustratorsign designersports cartooniststoryboard artistsupervisor, advertising artsupervisor, graphic arts roomtitle artistuser experience designer",
    "workers": 18510,
    "minEduc": 0,
    "yearsStudy": 3.108108108,
    "automationRisk": 0.082,
    "salaryLow": 15,
    "salaryMed": 26.92,
    "salaryHigh": 45.64,
    "totalSkill": 159,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 26.92,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 40,
    "f2Engineering": 370,
    "f3Humanities": 55,
    "f4SocialScience": 1010,
    "f5FineArts": 15025,
    "f6MathAndComputerScience": 650,
    "f7Arts&Education": 510,
    "f8Education(teachertraining)": 50,
    "f9Law": 65,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 705,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 15,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 120,
    "d4Humanities": 55,
    "d5SocialSciences": 1010,
    "d6Fine&AppliedArts": 15025,
    "d7ComputerScience": 650,
    "d8OtherArts&Science": 510,
    "d9Education(teachertraining)": 50,
    "d10Engineering": 250,
    "d11Law": 65,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 705,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 261,
    "noc": 5242,
    "job": "Interior designers and interior decorators",
    "title1": "aircraft interior designer",
    "title2": "building space planner",
    "title3": "business aircraft interior designer",
    "allTitles": "aircraft interior designerbuilding space plannerbusiness aircraft interior designercertified interior designercolour consultant - home decoratingdecorating consultantdesigner - interior designgreen design consultant - interior designhome decorating consultanthome decoratorhome organizerhome stagerhome staging consultantinterior decorating consultantinterior decoratorinterior design consultantinterior designerinterior designer assistantinterior design project managerinterior design technicianinterior space designerkitchen designerlicensed interior designeroffice space plannerproject manager, interior designregistered interior designerretail space plannerspace management consultant",
    "workers": 5785,
    "minEduc": 0,
    "yearsStudy": 3.154929577,
    "automationRisk": 0.022,
    "salaryLow": 14,
    "salaryMed": 24.62,
    "salaryHigh": 37.49,
    "totalSkill": 160,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 24.62,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 475,
    "f3Humanities": 270,
    "f4SocialScience": 80,
    "f5FineArts": 4320,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 275,
    "f8Education(teachertraining)": 60,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 270,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 455,
    "d4Humanities": 270,
    "d5SocialSciences": 80,
    "d6Fine&AppliedArts": 4320,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 275,
    "d9Education(teachertraining)": 60,
    "d10Engineering": 20,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 270,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 262,
    "noc": 5243,
    "job": "Theatre, fashion, exhibit and other creative designers",
    "title1": "assistant costume designer",
    "title2": "clothing designer",
    "title3": "costume designer",
    "allTitles": "assistant costume designerclothing designercostume designercostume designer - exhibits and theatrecouturier - haute couturecrest designerdesigner, clothingdesigner, displaysdesigner, exhibitsdesigner, museumdesigner, textiledesigner - theatredisplay designerdisplay designer - museums and art galleriesdisplay designers supervisordisplay design supervisorembroidery designerexhibit and display designerexhibit designerexhibit designer - museums and art galleriesexhibit designers supervisorexhibition designer - museums and art galleriesfabric designerfacilities designerfashion co-ordinatorfashion designerfashion goods co-ordinatorfashion goods exhibit co-ordinatorfashion stylistfashion wear designerfishing lure designerflower designerfood stylistfur designergarment designerglove designerhandbag designerhat designerheraldistjacket designerjewellery designerlighting designerlighting designer - exhibitsluggage designerluggage stylistmemorial designermuseum designermuseum exhibit designernovelties stylistpottery designerrug designerscene designerscene designer assistantset decorator - theatre and motion picturesset designer - theatreshoe designershow and demonstration designersound designerstage scenery designerstore display designersupervisor, display designswimming pool designertextile designertheatre designertile designertoy designer - arts and craftstrophy designervisual display stylistvisual merchandiserwindow display designerwomen's fashion designer",
    "workers": 1890,
    "minEduc": 0,
    "yearsStudy": 2.909090909,
    "automationRisk": 0.013,
    "salaryLow": 14.42,
    "salaryMed": 22.5,
    "salaryHigh": 34.62,
    "totalSkill": 160,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 22.5,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 1645,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 130,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 1645,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 130,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 263,
    "noc": 5244,
    "job": "Artisans and craftspersons",
    "title1": "Aboriginal art carver",
    "title2": "Aboriginal craftwork instructor",
    "title3": "artificial flower maker, hand",
    "allTitles": "Aboriginal art carverAboriginal craftwork instructorartificial flower maker, handartificial flower presserartisanartistic bouquet designerartistic floral arrangerartistic floral bouquet designerartistic floral designerarts and crafts teacher (except education)bag maker - arts and craftsbalalaika makerbasket weaverbatik artisanbeadworker, handbellows makerbookbinder, handcandle maker, handcaner, custom furniturecanoe builder - arts and craftscanoe repairer - arts and craftscanoe repairman - arts and craftscanoe repairwoman - arts and craftscarvercarver, Native artcarver, totem polescase maker, handcello makerceramic artistceramic potterceramics teacher (except education)ceramistcopperplate engraver - artisancraft instructor (except education)craftsmancraftsman/womancraftspersoncraftswomancraft weavercrocheter, handcustom furniture canerdecorative engraverdollmaker, handdrum maker - artisanembroiderer, handenameller - arts and craftsenameller, handenamellist - arts and craftsengraver, handengraver, metalengraver, pantograph - arts and craftsfabric artisanfabric artistfloral arrangements designerfloral designerglass blowerglass engraverglass novelty makerglass painterglassworker, handgoldsmithguitar makerhand beadworkerhand bookbinderhand candle makerhand carver, stoneshand carver, woodenwarehand case makerhand crocheterhand dollmakerhand embroidererhand enamellerhand engraverhand glassworkerhand knitterhand leather workerhand metalworkerhand needleworkerhand papermakerhand quilterhand rug makerhand silk flower makerhand spinnerhand stone carverhand weaverhand woodworkerharpsichord builderinstructor, crafts (except education)jewellery artisan, handjewellery engraverknitter, handlace weaver - arts and craftsleather workerleather worker, handmachine engraver - arts and craftsmandolin makermaster glass blowermaster glassmakermetal arts workermetal engraver",
    "workers": 1025,
    "minEduc": 0,
    "yearsStudy": 2.333333333,
    "automationRisk": 0.751,
    "salaryLow": 14,
    "salaryMed": 16.13,
    "salaryHigh": 25,
    "totalSkill": 125,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 16.13,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 275,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 585,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 30,
    "f8Education(teachertraining)": 70,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 55,
    "f12Business": 10,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 250,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 585,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 30,
    "d9Education(teachertraining)": 70,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 55,
    "d18Business&Commerce": 10,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 264,
    "noc": 5245,
    "job": "Patternmakers - textile, leather and fur products",
    "title1": "canvas goods maker canvas goods pattern designer and patternmaker canvas layer-out � textile products canvas pattern designer canvas patternmaker cartoon embroidery enlarger digitizer operator � textile, leather and fur products doper � fabric products doper and marker dress patternmaker embroidery patternmaker fur garment patternmaker fur patternmaker fur products patternmaker garment patternmaker last-pattern grader layer-out and patternmaker lay-out and patternmaker leather products patternmaker men's and women's wear patternmaker modifier and lay-out marker modifier and marker pattern designer and patternmaker � textile, leather and fur products pattern designer and patternmaker, canvas goods pattern grader pattern marker pattern marker � fabric products pattern modifier pattern modifier � textile, leather and fur products patternmaker � computer assisted patternmaker � textile products patternmaker � textile, leather and fur products patternmaker, shoes sail lay-out and patternmaker sail maker shoe patternmaker shoe-last patternmaker textile identification mark remover textile mark remover textile marker-down textile products patternmaker tracer-patternmaker",
    "title2": 0,
    "title3": 0,
    "allTitles": "canvas goods maker canvas goods pattern designer and patternmaker canvas layer-out � textile products canvas pattern designer canvas patternmaker cartoon embroidery enlarger digitizer operator � textile, leather and fur products doper � fabric products doper and marker dress patternmaker embroidery patternmaker fur garment patternmaker fur patternmaker fur products patternmaker garment patternmaker last-pattern grader layer-out and patternmaker lay-out and patternmaker leather products patternmaker men's and women's wear patternmaker modifier and lay-out marker modifier and marker pattern designer and patternmaker � textile, leather and fur products pattern designer and patternmaker, canvas goods pattern grader pattern marker pattern marker � fabric products pattern modifier pattern modifier � textile, leather and fur products patternmaker � computer assisted patternmaker � textile products patternmaker � textile, leather and fur products patternmaker, shoes sail lay-out and patternmaker sail maker shoe patternmaker shoe-last patternmaker textile identification mark remover textile mark remover textile marker-down textile products patternmaker tracer-patternmaker",
    "workers": 6802.5,
    "minEduc": 0,
    "yearsStudy": 2.876365482,
    "automationRisk": 0.217,
    "salaryLow": 14.14,
    "salaryMed": 21.08333333,
    "salaryHigh": 32.37,
    "totalSkill": 151,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 22.5425,
    "skillsComp": 40.75,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51.25,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.25,
    "s2DecisionMaking": 9.75,
    "s3FindingInformation": 6.75,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.75,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 9.75,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6.25,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 16.75,
    "s14Writing": 14.75,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 78.75,
    "f2Engineering": 211.25,
    "f3Humanities": 81.25,
    "f4SocialScience": 277.5,
    "f5FineArts": 5393.75,
    "f6MathAndComputerScience": 162.5,
    "f7Arts&Education": 227.5,
    "f8Education(teachertraining)": 45,
    "f9Law": 16.25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 278.75,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 66.25,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 143.75,
    "d4Humanities": 81.25,
    "d5SocialSciences": 277.5,
    "d6Fine&AppliedArts": 5393.75,
    "d7ComputerScience": 162.5,
    "d8OtherArts&Science": 227.5,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 67.5,
    "d11Law": 16.25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 12.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 278.75,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 265,
    "noc": 5251,
    "job": "Athletes",
    "title1": "amateur athlete archer athlete automobile racer badminton player baseball player basketball player billiard player bowler boxer canoeist chess player chuckwagon driver chuckwagon racer � stampede competitor � chess coxswain curler cyclist demolition driver discus thrower diver, olympic sport driver, chuckwagon driver, demolition driver, harness race driver, harness racing driver, race car driver, sulky fencer figure skater football player footballer golf player golfer gymnast hammer thrower handball player harness race driver harness racing driver helmsman � sports hockey player javelin thrower jockey judoka jumper pentathlete performer, rodeo performer, stampede ping-pong player poker player prize fighter professional athlete professional boxer professional pool player professional sportsman/woman race car driver racer, automobile racer, stampede racer, stock car rider rodeo performer rower sailboarder short-distance runner shot put skater skier snowboarder soccer player sprinter stampede performer stampede racer standardbred pacer stock car racer sulky driver swimmer table tennis player tennis player track athlete volleyball player water-polo player weight-lifter wrestler",
    "title2": 0,
    "title3": 0,
    "allTitles": "amateur athlete archer athlete automobile racer badminton player baseball player basketball player billiard player bowler boxer canoeist chess player chuckwagon driver chuckwagon racer � stampede competitor � chess coxswain curler cyclist demolition driver discus thrower diver, olympic sport driver, chuckwagon driver, demolition driver, harness race driver, harness racing driver, race car driver, sulky fencer figure skater football player footballer golf player golfer gymnast hammer thrower handball player harness race driver harness racing driver helmsman � sports hockey player javelin thrower jockey judoka jumper pentathlete performer, rodeo performer, stampede ping-pong player poker player prize fighter professional athlete professional boxer professional pool player professional sportsman/woman race car driver racer, automobile racer, stampede racer, stock car rider rodeo performer rower sailboarder short-distance runner shot put skater skier snowboarder soccer player sprinter stampede performer stampede racer standardbred pacer stock car racer sulky driver swimmer table tennis player tennis player track athlete volleyball player water-polo player weight-lifter wrestler",
    "workers": 8412.5,
    "minEduc": 0.5,
    "yearsStudy": 3.482386206,
    "automationRisk": 0.15775,
    "salaryLow": 14,
    "salaryMed": 19,
    "salaryHigh": 36.62,
    "totalSkill": 161.25,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 20.565,
    "skillsComp": 45.25,
    "skillsLogi": 39,
    "skillsMath": 25.25,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9.5,
    "s6MoneyMath": 4.25,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 9.25,
    "s10Reading": 19.75,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20.5,
    "s13DocumentUse": 18.75,
    "s14Writing": 15.5,
    "s15CriticalThinking": 9.25,
    "f1Science&Agriculture": 105,
    "f2Engineering": 22.5,
    "f3Humanities": 270,
    "f4SocialScience": 727.5,
    "f5FineArts": 577.5,
    "f6MathAndComputerScience": 37.5,
    "f7Arts&Education": 677.5,
    "f8Education(teachertraining)": 687.5,
    "f9Law": 252.5,
    "f10Health": 2470,
    "f11Health,Nursing&ClinicalLaboratory": 460,
    "f12Business": 862.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 85,
    "d2Forestry": 10,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 260,
    "d5SocialSciences": 727.5,
    "d6Fine&AppliedArts": 577.5,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 677.5,
    "d9Education(teachertraining)": 687.5,
    "d10Engineering": 22.5,
    "d11Law": 252.5,
    "d12Mathematics": 12.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 2335,
    "d14Theology": 10,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 135,
    "d17Health,Nursing&ClinicalLaboratory": 460,
    "d18Business&Commerce": 862.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 266,
    "noc": 5252,
    "job": "Coaches",
    "title1": "amateur athletics team coach",
    "title2": "amateur sports team coach",
    "title3": "amateur track and field team coach",
    "allTitles": "amateur athletics team coachamateur sports team coachamateur track and field team coachathletic boxing trainerathletics coachathletics team coachbaseball coachbaseball manager-coachbaseball scoutbaseball team coachbasketball scoutbasketball team coachbobsled coachbobsleigh coachboxing trainercoachcoach, amateur athletics teamcoach, amateur sports teamcoach, amateur track and field teamcoach, athleticscoach, athletics teamcoach, baseballcoach, baseball teamcoach, basketball teamcoach, bobsledcoach, bobsleighcoach, figure skatingcoach, footballcoach, football teamcoach, gymnasticscoach, hockeycoach, hockey teamcoach, junior hockeycoach, lacrossecoach, lacrosse teamcoach, lugecoach, national teamcoach, professional sports teamcoach, professional teamcoach, provincial teamcoach, skicoach, sportscoach, swimcoach, swimmingcoach, team of professional athletescoach, tenniscoach, track and fieldcoach, track and field athletescoach, track and field teamcoach, volleyballcycling coachfigure skating coachfootball coachfootball scoutfootball team coachgymnastics coachhead coachhockey coachhockey scouthockey team coachinstructor, lugejunior hockey coachkickboxing trainerlacrosse coachlacrosse scoutlacrosse team coachluge coachluge instructormanager-coach, baseballnational team coachprofessional sports scoutprofessional sports team coachprofessional team coachprovincial team coachscout, baseballscout, basketballscout, footballscout, hockeyscout, lacrossescout, professional sportsscout, sportsski coachsoccer coachsports coachsports scoutswim coachswimming coachteam coach, professional athletestennis coachtrack and field athletes coachtrack and field coachtrack and field team coachtrainer, athletic boxingtrainer, boxingtrainer, kickboxingvolleyball coachwater-polo coach",
    "workers": 845,
    "minEduc": 0,
    "yearsStudy": 3.757575758,
    "automationRisk": 0.013,
    "salaryLow": 14,
    "salaryMed": 21.63,
    "salaryHigh": 45.06,
    "totalSkill": 159,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 21.63,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 25,
    "f4SocialScience": 110,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 155,
    "f9Law": 0,
    "f10Health": 380,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 115,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 110,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 155,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 380,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 115,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 267,
    "noc": 5253,
    "job": "Sports officials and referees",
    "title1": "athletics judge clerk of scales � racetrack clerk of the course � harness racing clerk of the course � horseback racing clerk of the course � racetrack clocker, racetrack commission steward � horse racing competitive sports judge curling judge figure skating evaluator figure skating judge goal judge harness racing starter horse identifier horse plating inspector � racetrack horse race timer horse racing starter horseshoe inspector identifier, horses inspector, horse plating � racetrack inspector, horseshoes judge, athletics judge, competitive sports judge, figure skating judge, goals judge, paddock � racetrack judge, patrol � racetrack judge, racehorses � racetrack judge, sport competitions judge, sports judge, standardbreds � racetrack judge, track judge, track and field linesman/woman, sports operator, scoreboard paddock blacksmith � racetrack paddock horseshoer � racetrack paddock judge � racetrack paddock plater � racetrack patrol judge � racetrack placing judge � racetrack presiding steward � racetrack racehorse judge � racetrack racetrack clocker racetrack steward racetrack timer racing secretary and handicapper referee referee, sports scoreboard operator scorekeeper sports competition judge sports judge sports linesman/woman sports official sports referee standardbred judge � racetrack starter, harness racing starter, horse racing steward, presiding � racetrack steward, racetrack timer, racetrack track and field judge track judge umpire",
    "title2": 0,
    "title3": 0,
    "allTitles": "athletics judge clerk of scales � racetrack clerk of the course � harness racing clerk of the course � horseback racing clerk of the course � racetrack clocker, racetrack commission steward � horse racing competitive sports judge curling judge figure skating evaluator figure skating judge goal judge harness racing starter horse identifier horse plating inspector � racetrack horse race timer horse racing starter horseshoe inspector identifier, horses inspector, horse plating � racetrack inspector, horseshoes judge, athletics judge, competitive sports judge, figure skating judge, goals judge, paddock � racetrack judge, patrol � racetrack judge, racehorses � racetrack judge, sport competitions judge, sports judge, standardbreds � racetrack judge, track judge, track and field linesman/woman, sports operator, scoreboard paddock blacksmith � racetrack paddock horseshoer � racetrack paddock judge � racetrack paddock plater � racetrack patrol judge � racetrack placing judge � racetrack presiding steward � racetrack racehorse judge � racetrack racetrack clocker racetrack steward racetrack timer racing secretary and handicapper referee referee, sports scoreboard operator scorekeeper sports competition judge sports judge sports linesman/woman sports official sports referee standardbred judge � racetrack starter, harness racing starter, horse racing steward, presiding � racetrack steward, racetrack timer, racetrack track and field judge track judge umpire",
    "workers": 8412.5,
    "minEduc": 0.5,
    "yearsStudy": 3.482386206,
    "automationRisk": 0.15775,
    "salaryLow": 14,
    "salaryMed": 18.21,
    "salaryHigh": 35.89333333,
    "totalSkill": 161.25,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 20.565,
    "skillsComp": 45.25,
    "skillsLogi": 39,
    "skillsMath": 25.25,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 9.5,
    "s6MoneyMath": 4.25,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 9.25,
    "s10Reading": 19.75,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20.5,
    "s13DocumentUse": 18.75,
    "s14Writing": 15.5,
    "s15CriticalThinking": 9.25,
    "f1Science&Agriculture": 105,
    "f2Engineering": 22.5,
    "f3Humanities": 270,
    "f4SocialScience": 727.5,
    "f5FineArts": 577.5,
    "f6MathAndComputerScience": 37.5,
    "f7Arts&Education": 677.5,
    "f8Education(teachertraining)": 687.5,
    "f9Law": 252.5,
    "f10Health": 2470,
    "f11Health,Nursing&ClinicalLaboratory": 460,
    "f12Business": 862.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 85,
    "d2Forestry": 10,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 260,
    "d5SocialSciences": 727.5,
    "d6Fine&AppliedArts": 577.5,
    "d7ComputerScience": 25,
    "d8OtherArts&Science": 677.5,
    "d9Education(teachertraining)": 687.5,
    "d10Engineering": 22.5,
    "d11Law": 252.5,
    "d12Mathematics": 12.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 2335,
    "d14Theology": 10,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 135,
    "d17Health,Nursing&ClinicalLaboratory": 460,
    "d18Business&Commerce": 862.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 268,
    "noc": 5254,
    "job": "Architectural technologists and technicians",
    "title1": "activities leader - seniors",
    "title2": "aerobics instructor",
    "title3": "arts and crafts instructor",
    "allTitles": "activities leader - seniorsaerobics instructorarts and crafts instructorarts and crafts leaderarts and crafts leader - sports and recreationarts and leisure leaderarts and recreation leaderathletics instructorbeach lifeguardbowling instructorbridge instructorbridge teachercallisthenics instructorcamp co-ordinatorcamp counsellorcamp leadercertified fitness apraisercertified personal trainerchess instructorco-ordinator, camp - sports and leisureco-ordinator, pool - recreationcounsellor, campcounsellor, day camp - recreationcultural activities leaderday camp counsellor - recreationday camp leaderdressage instructorfencing instructorfishing seminar leaderfitness appraiserfitness instructorfitness leaderfitness leader - aerobic fitnessfitness leader - aquatic fitnessfitness leader - fitness for older adultsfitness leader - strength and conditioningfitness supervisorgolf instructorgymnastics instructorgymnastics teacherhorseback riding instructorice-skating instructorinline skating instructorinstructor, aerobicsinstructor, arts and craftsinstructor, athleticsinstructor, bowlinginstructor, bridgeinstructor, callisthenicsinstructor, dressageinstructor, fencinginstructor, fitnessinstructor, golfinstructor, gymnasticsinstructor, horseback ridinginstructor, ice-skatinginstructor, judoinstructor, jujitsuinstructor, karateinstructor, martial artsinstructor, physical traininginstructor, recreationinstructor, ridinginstructor, rollerbladinginstructor, roller-skatinginstructor, skiinstructor, ski - sports and recreationinstructor, sportsinstructor, swimming - recreationinstructor, swimming - sportsinstructor, tai-chiinstructor, tennis - recreationinstructor, tennis - sportsinstructor, track and fieldinstructor, weightliftinginstructor, yogajudo instructorjujitsu instructorkarate instructorleisure program leaderlife enrichment co-ordinator - recreation and fitnesslifeguardlifeguard, beachlifeguard, poolmartial arts instructormaster, ridingpatroller, skipersonal trainerphysical training instructorphysical training leaderpilates instructorplayground leaderplayground workerpool co-ordinator - recreationpool lifeguardprofessional golf instructorprofessional instructor, golfprofessional instructor, tennisprofessional tennis instructorrecreation instructor",
    "workers": 15980,
    "minEduc": 1,
    "yearsStudy": 3.207196653,
    "automationRisk": 0.3025,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 26,
    "totalSkill": 163.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 19.5,
    "skillsComp": 47.5,
    "skillsLogi": 38,
    "skillsMath": 28.5,
    "skillsLang": 49,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 12,
    "s6MoneyMath": 4.5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 8.5,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 21.5,
    "s14Writing": 15,
    "s15CriticalThinking": 9.5,
    "f1Science&Agriculture": 210,
    "f2Engineering": 45,
    "f3Humanities": 515,
    "f4SocialScience": 1345,
    "f5FineArts": 1135,
    "f6MathAndComputerScience": 75,
    "f7Arts&Education": 1315,
    "f8Education(teachertraining)": 1220,
    "f9Law": 505,
    "f10Health": 4560,
    "f11Health,Nursing&ClinicalLaboratory": 920,
    "f12Business": 1610,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 170,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 495,
    "d5SocialSciences": 1345,
    "d6Fine&AppliedArts": 1135,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 1315,
    "d9Education(teachertraining)": 1220,
    "d10Engineering": 45,
    "d11Law": 505,
    "d12Mathematics": 25,
    "d13Kinesiology/Recreation/PhysicalEducation": 4290,
    "d14Theology": 20,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 270,
    "d17Health,Nursing&ClinicalLaboratory": 920,
    "d18Business&Commerce": 1610,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 269,
    "noc": 6211,
    "job": "Assessors, valuators and appraisers",
    "title1": "bakery supervisor - supermarket",
    "title2": "cashier supervisor - retail",
    "title3": "chief canvasser - retail",
    "allTitles": "bakery supervisor - supermarketcashier supervisor - retailchief canvasser - retailcustomer service supervisor - retaildelicatessen supervisor - food storedeliveryman supervisordelivery person supervisordeliverywoman supervisordepartment head, retail storedepartment store supervisordepartment supervisor - retaildoor-to-door sales supervisorfood store supervisorgrocery clerk supervisorhead cashierliquor store supervisormeat department supervisornewspaper delivery persons supervisornewspaper salesman supervisornewspaper salesperson supervisornewspaper sales supervisornewspaper saleswoman supervisornight crew leader - retail storeprice marker supervisor - retailproduce department supervisorrental service supervisorretail store department headretail store supervisorroute supervisor, retail salessales clerk supervisorsales supervisorsales supervisor - retailstock clerks supervisor - retailstock supervisor - retailsubscription sales team leadersupermarket department supervisorsupervisor, cashiers - retailsupervisor, delivery personssupervisor, door-to-door salespersons - retailsupervisor, price markers - retailsupervisor - retailsupervisor, sales clerkssupervisor, stock clerks - retailsupervisor, telemarketerssupervisor, telephone sales clerksteam leader, subscription salestelemarketer supervisortelemarketing services supervisortelemarketing supervisortelephone sales clerk supervisor",
    "workers": 77705,
    "minEduc": 0.666666667,
    "yearsStudy": 2.980685217,
    "automationRisk": 0.461666667,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 32,
    "totalSkill": 191,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Finance, insurance and related business administrative occupations",
    "cluster": 4,
    "wage": 27.97333333,
    "skillsComp": 51.33333333,
    "skillsLogi": 45,
    "skillsMath": 26.33333333,
    "skillsLang": 68.33333333,
    "topSkill1": "Digital Technology",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 10,
    "s2DecisionMaking": 14,
    "s3FindingInformation": 6.666666667,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 3.333333333,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 23.66666667,
    "s9ProblemSolving": 10.33333333,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 14,
    "s12DigitalTechnology": 26.66666667,
    "s13DocumentUse": 14.66666667,
    "s14Writing": 21.33333333,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 185,
    "f2Engineering": 85,
    "f3Humanities": 245,
    "f4SocialScience": 485,
    "f5FineArts": 475,
    "f6MathAndComputerScience": 80,
    "f7Arts&Education": 915,
    "f8Education(teachertraining)": 110,
    "f9Law": 360,
    "f10Health": 115,
    "f11Health,Nursing&ClinicalLaboratory": 275,
    "f12Business": 2180,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 245,
    "d5SocialSciences": 485,
    "d6Fine&AppliedArts": 475,
    "d7ComputerScience": 80,
    "d8OtherArts&Science": 915,
    "d9Education(teachertraining)": 110,
    "d10Engineering": 85,
    "d11Law": 360,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 0,
    "d15PhysicalSciences": 165,
    "d16Therapy&Rehabilitation": 45,
    "d17Health,Nursing&ClinicalLaboratory": 275,
    "d18Business&Commerce": 2180,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 270,
    "noc": 6221,
    "job": "Technical sales specialists in wholesale trade",
    "title1": "agent, country grain elevator",
    "title2": "agent, primary grain elevator",
    "title3": "agricultural equipment and supplies technical salesperson",
    "allTitles": "agent, country grain elevatoragent, primary grain elevatoragricultural equipment and supplies technical salespersonaircraft sales representativeaircraft technical sales specialistalternate heating energy consultantalternative heating energy consultant - wholesaleapplications sales engineerassistant grain elevator managerbroadcasting equipment salespersonbusiness agent, computerschemicals sales representativecommercial and industrial equipment and supplies sales representative - technical wholesalecommunication equipment sales representativecomputer applications sales engineercomputer equipment sales specialistcomputer software sales representativecomputer system sales representativeconstruction equipment sales representativeconstruction material sales representativecountry grain elevator agentcountry grain elevator managercountry grain elevator operatorcustomer support representative - wholesaledental equipment and supplies salespersondiagnostic instrument sales representativedistrict manager, grain elevatorEDP (electronic data-processing) hardware and services sales representativeelectrical equipment sales representativeelectrical industrial equipment sales representativeelectricity sales representativeelectronic data-processing (EDP) hardware and services sales representativeelectronic equipment salesman - wholesaleelectronic equipment salesperson - wholesaleelectronic equipment saleswoman - wholesaleengineering equipment salespersonengineering supplies salespersonexport company technical sales specialistfarm equipment salespersonfarm machinery salespersonforestry equipment sales representativeforestry machinery sales representativegrain elevator agentgrain elevator district managergrain elevator managergrain elevator operatorgraphic arts equipment sales representativeheavy equipment salespersonheavy equipment sales representativeheavy truck salespersonheavy truck sales representativehospital equipment salespersonhospital equipment sales representativehydro-electricity sales representativeimport company technical sales specialistindustrial equipment sales engineerindustrial machinery sales representativeindustrial supplies salespersonindustrial supplies sales representativelight, heat and power sales engineerlighting, heating and power sales representativelighting, heating and power sales specialistlogging equipment salespersonlubricating equipment salespersonmachinery salespersonmanager, grain elevatormanufacturer's sales representativematerial-handling equipment salespersonmedical equipment and supplies salespersonmedical instruments sales agentmetal products salespersonmilking machine salespersonmining equipment sales engineermining equipment sales representativenatural gas sales representativeoffice equipment salesman - wholesaleoffice equipment salesperson - wholesaleoffice equipment saleswoman - wholesaleoil refinery equipment sales representativeoil well services sales engineerpharmaceutical salespersonpharmaceutical sales representativeplumbing and heating services sales representativeprimary grain elevator agentprimary grain elevator managerprimary grain elevator operatorprinting machinery sales representativeprinting management technicianprinting supplies salespersonrailway equipment and supplies technical salespersonrailway equipment and supplies technical sales specialistresidential energy sales advisersafety equipment salespersonsale executive, technical salessales broker - wholesalesales engineersales engineer, technical supportsales representative, construction materialssales representative, lighting, heating and powersales representative, technical office equipment",
    "workers": 16870,
    "minEduc": 0,
    "yearsStudy": 3.174846626,
    "automationRisk": 0.25,
    "salaryLow": 14,
    "salaryMed": 26.44,
    "salaryHigh": 51.28,
    "totalSkill": 151,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Retail sales supervisors and specialized sales occupations",
    "cluster": 9,
    "wage": 26.44,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 51,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 17,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 1090,
    "f2Engineering": 3320,
    "f3Humanities": 360,
    "f4SocialScience": 1525,
    "f5FineArts": 475,
    "f6MathAndComputerScience": 970,
    "f7Arts&Education": 1660,
    "f8Education(teachertraining)": 145,
    "f9Law": 370,
    "f10Health": 370,
    "f11Health,Nursing&ClinicalLaboratory": 425,
    "f12Business": 6160,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 545,
    "d2Forestry": 35,
    "d3Architecture&LandscapeArchitecture": 125,
    "d4Humanities": 295,
    "d5SocialSciences": 1525,
    "d6Fine&AppliedArts": 475,
    "d7ComputerScience": 820,
    "d8OtherArts&Science": 1660,
    "d9Education(teachertraining)": 145,
    "d10Engineering": 3195,
    "d11Law": 370,
    "d12Mathematics": 150,
    "d13Kinesiology/Recreation/PhysicalEducation": 370,
    "d14Theology": 65,
    "d15PhysicalSciences": 510,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 425,
    "d18Business&Commerce": 6160,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 271,
    "noc": 6222,
    "job": "Assemblers, fabricators and inspectors, industrial electrical motors and transformers",
    "title1": "appliance buyer",
    "title2": "assistant buyer",
    "title3": "buyer - retail",
    "allTitles": "appliance buyerassistant buyerbuyer - retailbuyer - wholesalecattle buyerchief buyerchief buyer - retail or wholesaleclothing buyerfood buyerfruit buyerfur buyerhardware buyerhog buyerlivestock buyerlog buyerlumber buyermeat buyermerchandiserperishable food buyerpharmaceuticals buyerproduce buyerretail buyerretail merchandisersalvage buyerscrap buyersenior buyer - retail or wholesalespecialty food buyersupervisor, buyerstaster and buyer, beveragestimber buyertobacco buyerwholesale buyer",
    "workers": 4260,
    "minEduc": 0,
    "yearsStudy": 2.46039604,
    "automationRisk": 0.6325,
    "salaryLow": 14,
    "salaryMed": 21.63,
    "salaryHigh": 36.06,
    "totalSkill": 135.5,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 20.18498223,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19.5,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 9,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17.5,
    "s14Writing": 12,
    "s15CriticalThinking": 6.5,
    "f1Science&Agriculture": 70,
    "f2Engineering": 25,
    "f3Humanities": 80,
    "f4SocialScience": 400,
    "f5FineArts": 470,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 330,
    "f8Education(teachertraining)": 95,
    "f9Law": 135,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 130,
    "f12Business": 2380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 50,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 80,
    "d5SocialSciences": 400,
    "d6Fine&AppliedArts": 470,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 330,
    "d9Education(teachertraining)": 95,
    "d10Engineering": 25,
    "d11Law": 135,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 130,
    "d18Business&Commerce": 2380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 272,
    "noc": 6231,
    "job": "Insurance agents and brokers",
    "title1": "automobile insurance agent",
    "title2": "automobile insurance salesman",
    "title3": "automobile insurance salesman/woman",
    "allTitles": "automobile insurance agentautomobile insurance salesmanautomobile insurance salesman/womanautomobile insurance saleswomanbroker, insurancedistrict supervisor, insurance officefield agent - insurancefire insurance agentfire insurance salesmanfire insurance salesman/womanfire insurance saleswomangeneral insurance representativegroup insurance representativeinsurance agentinsurance brokerinsurance sales agentinsurance salesmaninsurance salesman/womaninsurance sales representativeinsurance sales supervisorinsurance saleswomanlife insurance agentlife insurance representativelife insurance salesmanlife insurance salesman/womanlife insurance saleswomansales agent, insurancesalesman, insurancesalesman/woman, insurancesaleswoman, insurancesupervisor, insurance agents",
    "workers": 15150,
    "minEduc": 2,
    "yearsStudy": 3.119834711,
    "automationRisk": 0.92,
    "salaryLow": 14,
    "salaryMed": 23.08,
    "salaryHigh": 38.46,
    "totalSkill": 119,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Retail sales supervisors and specialized sales occupations",
    "cluster": 9,
    "wage": 23.08,
    "skillsComp": 26,
    "skillsLogi": 30,
    "skillsMath": 20,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Writing",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 7,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 8,
    "s14Writing": 14,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 50,
    "f2Engineering": 135,
    "f3Humanities": 285,
    "f4SocialScience": 1910,
    "f5FineArts": 300,
    "f6MathAndComputerScience": 305,
    "f7Arts&Education": 790,
    "f8Education(teachertraining)": 240,
    "f9Law": 475,
    "f10Health": 90,
    "f11Health,Nursing&ClinicalLaboratory": 230,
    "f12Business": 10340,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 25,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 285,
    "d5SocialSciences": 1910,
    "d6Fine&AppliedArts": 300,
    "d7ComputerScience": 215,
    "d8OtherArts&Science": 790,
    "d9Education(teachertraining)": 240,
    "d10Engineering": 135,
    "d11Law": 475,
    "d12Mathematics": 90,
    "d13Kinesiology/Recreation/PhysicalEducation": 65,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 25,
    "d17Health,Nursing&ClinicalLaboratory": 230,
    "d18Business&Commerce": 10340,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 273,
    "noc": 6232,
    "job": "Real estate agents and salespersons",
    "title1": "agent, real estate associate broker � real estate commercial real estate agent commercial real estate salesperson new home salesperson real estate agency representative real estate agent real estate dealer real estate sales consultant real estate sales representative real estate sales supervisor real estate salesperson residential real estate agent residential real estate salesperson sales representative, real estate salesperson, new homes salesperson, real estate supervisor, real estate agents",
    "title2": 0,
    "title3": 0,
    "allTitles": "agent, real estate associate broker � real estate commercial real estate agent commercial real estate salesperson new home salesperson real estate agency representative real estate agent real estate dealer real estate sales consultant real estate sales representative real estate sales supervisor real estate salesperson residential real estate agent residential real estate salesperson sales representative, real estate salesperson, new homes salesperson, real estate supervisor, real estate agents",
    "workers": 14477.5,
    "minEduc": 1,
    "yearsStudy": 3.174596255,
    "automationRisk": 0.468,
    "salaryLow": 28752,
    "salaryMed": 45.037,
    "salaryHigh": 123595,
    "totalSkill": 139,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Retail sales supervisors and specialized sales occupations",
    "cluster": 9,
    "wage": 22.04,
    "skillsComp": 34.5,
    "skillsLogi": 35,
    "skillsMath": 21,
    "skillsLang": 48.5,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 5.5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2.5,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 8.5,
    "s10Reading": 19.5,
    "s11SchedulingorBudgetingandAccounting": 7.5,
    "s12DigitalTechnology": 16.5,
    "s13DocumentUse": 12,
    "s14Writing": 15,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 50,
    "f2Engineering": 275,
    "f3Humanities": 272.5,
    "f4SocialScience": 1872.5,
    "f5FineArts": 260,
    "f6MathAndComputerScience": 322.5,
    "f7Arts&Education": 772.5,
    "f8Education(teachertraining)": 152.5,
    "f9Law": 475,
    "f10Health": 122.5,
    "f11Health,Nursing&ClinicalLaboratory": 170,
    "f12Business": 9732.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 30,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 272.5,
    "d5SocialSciences": 1872.5,
    "d6Fine&AppliedArts": 260,
    "d7ComputerScience": 222.5,
    "d8OtherArts&Science": 772.5,
    "d9Education(teachertraining)": 152.5,
    "d10Engineering": 275,
    "d11Law": 475,
    "d12Mathematics": 100,
    "d13Kinesiology/Recreation/PhysicalEducation": 52.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 70,
    "d17Health,Nursing&ClinicalLaboratory": 170,
    "d18Business&Commerce": 9732.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 274,
    "noc": 6235,
    "job": "Financial sales representatives",
    "title1": "adviser, loans",
    "title2": "agent, loans",
    "title3": "analyst, credit",
    "allTitles": "adviser, loansagent, loansanalyst, creditanalyst, loansbanking accounts officercommercial banking accounts officerconsumer credit officerconsumer loans officercounsellor, loanscredit analystcredit investigation officercredit investigatorcredit officerdebt counsellorfinancial sales and service officerfinancial sales and service supervisorfinancial services officerfinancial services representativelending services officerlending services traineeloan inspectorloan officerloans adviserloans agentloans analystloans counsellorloans supervisormerchant services specialist - financialmortgage consultantmortgage loans consultantmortgage loans officermortgage officerofficer, banking accountsofficer, creditofficer, loansofficer, mortgage loanspersonal bankerpersonal banking accounts officerpersonal banking representativepersonal financial services associatepersonal financial services officerpersonal loans officersales associate - personal bankingsales officer - financialsenior loans officerstudent loans officer",
    "workers": 13805,
    "minEduc": 0,
    "yearsStudy": 3.229357798,
    "automationRisk": 0.016,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 37.18,
    "totalSkill": 159,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Retail sales supervisors and specialized sales occupations",
    "cluster": 9,
    "wage": 21,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 50,
    "f2Engineering": 415,
    "f3Humanities": 260,
    "f4SocialScience": 1835,
    "f5FineArts": 220,
    "f6MathAndComputerScience": 340,
    "f7Arts&Education": 755,
    "f8Education(teachertraining)": 65,
    "f9Law": 475,
    "f10Health": 155,
    "f11Health,Nursing&ClinicalLaboratory": 110,
    "f12Business": 9125,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 260,
    "d5SocialSciences": 1835,
    "d6Fine&AppliedArts": 220,
    "d7ComputerScience": 230,
    "d8OtherArts&Science": 755,
    "d9Education(teachertraining)": 65,
    "d10Engineering": 415,
    "d11Law": 475,
    "d12Mathematics": 110,
    "d13Kinesiology/Recreation/PhysicalEducation": 40,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 115,
    "d17Health,Nursing&ClinicalLaboratory": 110,
    "d18Business&Commerce": 9125,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 275,
    "noc": 6311,
    "job": "Food service supervisors",
    "title1": "cafeteria supervisor",
    "title2": "canteen supervisor",
    "title3": "catering supervisor",
    "allTitles": "cafeteria supervisorcanteen supervisorcatering supervisorfood assembly supervisorfood service supervisorfood service supervisor, hospitalhospital food service supervisorrailway dining car food service supervisorshift manager, fast food restaurantsupervisor, food concessionsupervisor, food servicesswing manager, fast food restaurantunit supervisor - food services",
    "workers": 3020,
    "minEduc": 0,
    "yearsStudy": 2.392857143,
    "automationRisk": 0.63,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 21.15,
    "totalSkill": 129,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 13.75,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 18,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 20,
    "f3Humanities": 590,
    "f4SocialScience": 50,
    "f5FineArts": 90,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1145,
    "f8Education(teachertraining)": 0,
    "f9Law": 70,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 215,
    "f12Business": 805,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 590,
    "d5SocialSciences": 50,
    "d6Fine&AppliedArts": 90,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1145,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 70,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 35,
    "d17Health,Nursing&ClinicalLaboratory": 215,
    "d18Business&Commerce": 805,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 276,
    "noc": 6312,
    "job": "Executive housekeepers",
    "title1": "assistant executive housekeeper assistant housekeeping manager executive housekeeper hospital executive housekeeper hotel executive housekeeper housekeeping director housekeeping manager",
    "title2": 0,
    "title3": 0,
    "allTitles": "assistant executive housekeeper assistant housekeeping manager executive housekeeper hospital executive housekeeper hotel executive housekeeper housekeeping director housekeeping manager",
    "workers": 1619,
    "minEduc": 0,
    "yearsStudy": 2.46007038,
    "automationRisk": 0.3606,
    "salaryLow": 14,
    "salaryMed": 17.78,
    "salaryHigh": 23.08,
    "totalSkill": 144.8,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 25.11627138,
    "skillsComp": 39.2,
    "skillsLogi": 36.4,
    "skillsMath": 20.3,
    "skillsLang": 48.9,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5.3,
    "s2DecisionMaking": 9.7,
    "s3FindingInformation": 6.7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.8,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 4.1,
    "s8OralCommunication": 15.7,
    "s9ProblemSolving": 9.5,
    "s10Reading": 19.8,
    "s11SchedulingorBudgetingandAccounting": 6.1,
    "s12DigitalTechnology": 16.8,
    "s13DocumentUse": 17.2,
    "s14Writing": 14,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 10,
    "f2Engineering": 24,
    "f3Humanities": 132,
    "f4SocialScience": 39,
    "f5FineArts": 33,
    "f6MathAndComputerScience": 13,
    "f7Arts&Education": 309,
    "f8Education(teachertraining)": 0,
    "f9Law": 139,
    "f10Health": 21,
    "f11Health,Nursing&ClinicalLaboratory": 43,
    "f12Business": 453,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 4,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 132,
    "d5SocialSciences": 39,
    "d6Fine&AppliedArts": 33,
    "d7ComputerScience": 13,
    "d8OtherArts&Science": 309,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 24,
    "d11Law": 139,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 14,
    "d14Theology": 0,
    "d15PhysicalSciences": 6,
    "d16Therapy&Rehabilitation": 7,
    "d17Health,Nursing&ClinicalLaboratory": 43,
    "d18Business&Commerce": 453,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 277,
    "noc": 6313,
    "job": "Accommodation, travel, tourism and related services supervisors",
    "title1": "airline sales and service agents supervisor",
    "title2": "assistant passenger service co-ordinator - railway",
    "title3": "baggage handler supervisor",
    "allTitles": "airline sales and service agents supervisorassistant passenger service co-ordinator - railwaybaggage handler supervisorbaggage porter supervisorbell captaincasino pit bosscasino section headcasino shift managerdealers supervisor, casinogaming tables supervisorhead baggage porterhead, hotel clerkshotel clerk supervisorhotel managing supervisorlodging house managing supervisormotel managing supervisornight clerk supervisor - hotelnight supervisor - hotelpassenger service co-ordinator - railwaypit boss, casinopit boss gamingreservations supervisorreservations supervisor - airlinereservations supervisor - hotelreservations supervisor - travel agencysection head, casinosection head, slot machinesshift manager, casinoslot machines section headslot supervisorsupervisor, airline sales and service agentssupervisor, baggage porterssupervisor, gaming tablessupervisor, hotel clerkssupervisor, night clerks - hotelsupervisor, railway station clerkssupervisor, reservations - hotelsupervisor, tour guidessupervisor, travel clerkstour guide supervisortravel clerk supervisor",
    "workers": 345,
    "minEduc": 0,
    "yearsStudy": 2.333333333,
    "automationRisk": 0.114,
    "salaryLow": 14,
    "salaryMed": 23,
    "salaryHigh": 32.69,
    "totalSkill": 155,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 23,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 21,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 70,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 255,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 70,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 255,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 278,
    "noc": 6314,
    "job": "Customer and information services supervisors",
    "title1": "accounts supervisor",
    "title2": "call centre supervisor",
    "title3": "contact centre supervisor",
    "allTitles": "accounts supervisorcall centre supervisorcontact centre supervisorcurrent accounts supervisorcustomer accounts supervisorcustomer service clerks supervisorcustomer service representatives supervisor - financial servicescustomer service supervisor (except financial services)information clerks supervisorsafety deposit box supervisorsavings accounts supervisorsavings and credit service supervisorsavings supervisorsupervisor, accountssupervisor, call centre agentssupervisor, customer service clerkssupervisor, customer service representativessupervisor, customer service representatives - financial servicessupervisor, information clerkssupervisor, tellerstellers supervisor",
    "workers": 1495,
    "minEduc": 0,
    "yearsStudy": 2.754716981,
    "automationRisk": 0.076,
    "salaryLow": 14,
    "salaryMed": 24.04,
    "salaryHigh": 35.9,
    "totalSkill": 157,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 24.04,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 80,
    "f3Humanities": 45,
    "f4SocialScience": 125,
    "f5FineArts": 35,
    "f6MathAndComputerScience": 65,
    "f7Arts&Education": 210,
    "f8Education(teachertraining)": 0,
    "f9Law": 60,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 875,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 45,
    "d5SocialSciences": 125,
    "d6Fine&AppliedArts": 35,
    "d7ComputerScience": 65,
    "d8OtherArts&Science": 210,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 80,
    "d11Law": 60,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 875,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 279,
    "noc": 6315,
    "job": "Cleaning supervisors",
    "title1": "building cleaning and maintenance supervisor",
    "title2": "building cleaning supervisor",
    "title3": "carpet cleaning supervisor",
    "allTitles": "building cleaning and maintenance supervisorbuilding cleaning supervisorcarpet cleaning supervisorcarwash supervisorcleaning and maintenance supervisorcleaning supervisorcustodian supervisor - cleaning serviceshead caretakerhead cleanerhead cleaning manhead cleaning man/womanhead cleaning womanhead custodianhead custodian - cleaning serviceshead janitorhousekeeping room attendant supervisorhousekeeping supervisorindustrial plant cleaning supervisorsupervisor, carwashsupervisor, chambermaidssupervisor, cleanerssupervisor, cleaning and maintenancesupervisor, janitorssupervisor, window washerswindow washing supervisor",
    "workers": 200,
    "minEduc": 0,
    "yearsStudy": 1.375,
    "automationRisk": 0.94,
    "salaryLow": 14,
    "salaryMed": 24.04,
    "salaryHigh": 28.85,
    "totalSkill": 120,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 24.04,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 120,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 50,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 120,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 50,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 280,
    "noc": 6316,
    "job": "Administrators - post-secondary education and vocational training",
    "title1": "apparel-service and furnishings-service workers supervisor",
    "title2": "billiard parlour supervisor",
    "title3": "bingo games supervisor",
    "allTitles": "apparel-service and furnishings-service workers supervisorbilliard parlour supervisorbingo games supervisorcampground supervisorchief security guardclubhouse attendants supervisorcommercial security officers supervisordry cleaner supervisordry cleaning production supervisordry cleaning supervisorforeman/forewoman, laundry and dry cleaning workers and press operatorsforeman, launderers, dry cleaners and press operatorsforeman - laundry and dry cleaningforeman, laundry and dry cleaning workers and press operatorsforeman/woman, launderers, dry cleaners and press operatorsforeman/woman - laundry and dry cleaningforewoman, launderers, dry cleaners and press operatorsforewoman - laundry and dry cleaningforewoman, laundry and dry cleaning workers and press operatorsfur cleaning supervisorice rink supervisorlaunderers, dry cleaners and press operators foremanlaunderers, dry cleaners and press operators foreman/womanlaunderers, dry cleaners and press operators forewomanlaunderers supervisorlaundry and dry cleaning foremanlaundry and dry cleaning foreman/womanlaundry and dry cleaning forewomanlaundry and dry cleaning workers and press operators foremanlaundry and dry cleaning workers and press operators foreman/womanlaundry and dry cleaning workers and press operators forewomanlaundry production supervisorlaundry supervisorlift operation supervisormovie theatre attendants supervisorparking lot supervisorpark supervisorpool parlour supervisorproduction supervisor, dry cleaningracetrack betting supervisorracetrack clerk supervisorrink supervisorrug cleaning foreman - dry cleaningrug cleaning foreman/woman - dry cleaningrug cleaning forewoman - dry cleaningsecurity guard supervisorski area supervisorski lift attendant supervisorski lift supervisorsupervisor, apparel and furnishings service workerssupervisor, athletic club attendantssupervisor, billiard parloursupervisor, clubhouse attendantssupervisor, commercial security officerssupervisor, commissionairessupervisor, dry cleanerssupervisor, dry cleaningsupervisor, ice rinksupervisor, laundererssupervisor, laundrysupervisor, lift operationssupervisor, parksupervisor, parking lotsupervisor, pool parloursupervisor, rinksupervisor, security guardssupervisor, ski lift attendantssupervisor, theatre attendantssupervisor, ticket clerkssupervisor, ticket sellerssupervisor, ticket takerssupervisor, toll bridge attendantssupervisor, ushersticket clerk supervisorticket seller supervisorticket taker supervisortoll bridge attendants supervisortrailer park supervisor",
    "workers": 3035,
    "minEduc": 0,
    "yearsStudy": 3.444444444,
    "automationRisk": 0.043,
    "salaryLow": 14,
    "salaryMed": 20.572,
    "salaryHigh": 28.334,
    "totalSkill": 163,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Specialized middle management occupations",
    "cluster": 1,
    "wage": 40.7513569,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 22.5,
    "skillsLang": 55.5,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 17.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7.5,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 9.5,
    "f1Science&Agriculture": 20,
    "f2Engineering": 20,
    "f3Humanities": 25,
    "f4SocialScience": 0,
    "f5FineArts": 40,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 0,
    "f9Law": 495,
    "f10Health": 70,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 280,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 40,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 495,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 70,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 280,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 281,
    "noc": 6321,
    "job": "Chefs",
    "title1": "assistant chef banquet chef chef chef de cuisine chef de partie chef p�tissier cold foods chef corporate chef entremetier executive chef executive sous-chef first sous-chef garde-manger chef head chef head rotisseur master chef meat chef meat, poultry and fish chef pasta chef pastry chef rotisserie chef saucier second chef sous-chef specialist chef specialty foods chef supervising chef sushi chef working sous-chef",
    "title2": 0,
    "title3": 0,
    "allTitles": "assistant chef banquet chef chef chef de cuisine chef de partie chef p�tissier cold foods chef corporate chef entremetier executive chef executive sous-chef first sous-chef garde-manger chef head chef head rotisseur master chef meat chef meat, poultry and fish chef pasta chef pastry chef rotisserie chef saucier second chef sous-chef specialist chef specialty foods chef supervising chef sushi chef working sous-chef",
    "workers": 17030,
    "minEduc": 0,
    "yearsStudy": 1.793798713,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 16.03,
    "salaryHigh": 28.85,
    "totalSkill": 119,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 15.625,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 17.5,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17.5,
    "s14Writing": 9.5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 360,
    "f2Engineering": 460,
    "f3Humanities": 945,
    "f4SocialScience": 435,
    "f5FineArts": 635,
    "f6MathAndComputerScience": 205,
    "f7Arts&Education": 9250,
    "f8Education(teachertraining)": 260,
    "f9Law": 555,
    "f10Health": 210,
    "f11Health,Nursing&ClinicalLaboratory": 980,
    "f12Business": 2245,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 130,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 45,
    "d4Humanities": 925,
    "d5SocialSciences": 435,
    "d6Fine&AppliedArts": 635,
    "d7ComputerScience": 205,
    "d8OtherArts&Science": 9250,
    "d9Education(teachertraining)": 260,
    "d10Engineering": 415,
    "d11Law": 555,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 110,
    "d14Theology": 20,
    "d15PhysicalSciences": 210,
    "d16Therapy&Rehabilitation": 100,
    "d17Health,Nursing&ClinicalLaboratory": 980,
    "d18Business&Commerce": 2245,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 282,
    "noc": 6322,
    "job": "Cooks",
    "title1": "apprentice cook",
    "title2": "assistant cook",
    "title3": "banquet cook",
    "allTitles": "apprentice cookassistant cookbanquet cookbreakfast cookbroiler cookcafeteria cookcamp cookcaterer cookconstruction camp cookcookcook, apprenticecook, campcook, domesticcook, ethnic foodscook, firstcook, fishing and merchant vesselcook, institutioncook, kosher foodscook, secondcook, small establishmentcook, thirddietary cookdiet kitchen cookdomestic cookethnic food cookfirst cookgrill cookhospital cookinstitutional cookjourneyman cookjourneyman/woman cookjourneywoman cookkosher foods cooklicensed cookline cooklogging camp cookmess cookpastry cookpizza cookrailway cookrestaurant cooksecond cookship's cookshort order cookspecial diet cookspecial orders cook, hospitaltherapeutic diet cookthird cook",
    "workers": 17030,
    "minEduc": 0,
    "yearsStudy": 1.793798713,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 18.89,
    "totalSkill": 119,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 15.625,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 17.5,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17.5,
    "s14Writing": 9.5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 360,
    "f2Engineering": 460,
    "f3Humanities": 945,
    "f4SocialScience": 435,
    "f5FineArts": 635,
    "f6MathAndComputerScience": 205,
    "f7Arts&Education": 9250,
    "f8Education(teachertraining)": 260,
    "f9Law": 555,
    "f10Health": 210,
    "f11Health,Nursing&ClinicalLaboratory": 980,
    "f12Business": 2245,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 130,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 45,
    "d4Humanities": 925,
    "d5SocialSciences": 435,
    "d6Fine&AppliedArts": 635,
    "d7ComputerScience": 205,
    "d8OtherArts&Science": 9250,
    "d9Education(teachertraining)": 260,
    "d10Engineering": 415,
    "d11Law": 555,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 110,
    "d14Theology": 20,
    "d15PhysicalSciences": 210,
    "d16Therapy&Rehabilitation": 100,
    "d17Health,Nursing&ClinicalLaboratory": 980,
    "d18Business&Commerce": 2245,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 283,
    "noc": 6331,
    "job": "Butchers, meat cutters and fishmongers - retail and wholesale",
    "title1": "apprentice butcher � retail or wholesale butcher � butcher shop butcher � delicatessen butcher � retail or wholesale butcher � wholesale butcher apprentice butcher, retail fishmonger � retail fishmonger � wholesale grocery store butcher head butcher � retail head butcher � retail or wholesale head butcher � wholesale meat cutter � retail or wholesale meat portion cutter � retail or wholesale pork cutter � retail or wholesale retail butcher retail meat cutter supermarket butcher supermarket meat cutter",
    "title2": 0,
    "title3": 0,
    "allTitles": "apprentice butcher � retail or wholesale butcher � butcher shop butcher � delicatessen butcher � retail or wholesale butcher � wholesale butcher apprentice butcher, retail fishmonger � retail fishmonger � wholesale grocery store butcher head butcher � retail head butcher � retail or wholesale head butcher � wholesale meat cutter � retail or wholesale meat portion cutter � retail or wholesale pork cutter � retail or wholesale retail butcher retail meat cutter supermarket butcher supermarket meat cutter",
    "workers": 2635,
    "minEduc": 0,
    "yearsStudy": 2.034482759,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 23.75,
    "totalSkill": 117,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 10,
    "f2Engineering": 0,
    "f3Humanities": 85,
    "f4SocialScience": 40,
    "f5FineArts": 70,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1555,
    "f8Education(teachertraining)": 20,
    "f9Law": 95,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 250,
    "f12Business": 480,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 85,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 70,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1555,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 95,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 10,
    "d17Health,Nursing&ClinicalLaboratory": 250,
    "d18Business&Commerce": 480,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 284,
    "noc": 6332,
    "job": "Bakers",
    "title1": "apprentice baker - retail",
    "title2": "bagel baker",
    "title3": "bagel maker",
    "allTitles": "apprentice baker - retailbagel bakerbagel makerbakerbaker apprenticebaker, p�tissierbaker - retailbaker, specialty foodsbaker, specialty foods - retailbakery bench handbakery supervisorbakery supervisor - retailbench hand, bakerybiscuit bakerbread bakerbread baker - retailcake and pastry decorator - retailcake baker - retailcake decoratorcake decorator - retailcake icerchocolate makerdonut bakerdonut makerFrench pastry baker - retailgrocery store bakerhand icer - bakeryhead bakerhead baker - retailhospital bakerhotel bakericer, hand - bakeryjunior bakermuffin bakermuffin makerpastry decoratorpastry decorator - retailpastry makerp�tissier, bakerspecialty foods bakerspecialty foods baker - retailwedding cake decorator",
    "workers": 2635,
    "minEduc": 0,
    "yearsStudy": 2.034482759,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 19.9,
    "totalSkill": 117,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 10,
    "f2Engineering": 0,
    "f3Humanities": 85,
    "f4SocialScience": 40,
    "f5FineArts": 70,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1555,
    "f8Education(teachertraining)": 20,
    "f9Law": 95,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 250,
    "f12Business": 480,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 85,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 70,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1555,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 95,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 10,
    "d17Health,Nursing&ClinicalLaboratory": 250,
    "d18Business&Commerce": 480,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 285,
    "noc": 6341,
    "job": "Hairstylists and barbers",
    "title1": "apprentice, barber",
    "title2": "apprentice, hairdresser",
    "title3": "apprentice, hairstylist",
    "allTitles": "apprentice, barberapprentice, hairdresserapprentice, hairstylistbarberbarber apprenticebeauty salon operatorhair-care specialisthair colour technicianhairdresserhairdresser apprenticehair dyerhairstyling specialisthairstylisthairstylist apprenticemen's hairdresserstylist, hairwig stylist",
    "workers": 27895,
    "minEduc": 0,
    "yearsStudy": 1.966666667,
    "automationRisk": 0.11,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 19.23,
    "totalSkill": 152,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 15,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 52,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 16,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 20,
    "f2Engineering": 40,
    "f3Humanities": 250,
    "f4SocialScience": 10,
    "f5FineArts": 130,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 26045,
    "f8Education(teachertraining)": 105,
    "f9Law": 145,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 460,
    "f12Business": 675,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 250,
    "d5SocialSciences": 10,
    "d6Fine&AppliedArts": 130,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 26045,
    "d9Education(teachertraining)": 105,
    "d10Engineering": 40,
    "d11Law": 145,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 15,
    "d17Health,Nursing&ClinicalLaboratory": 460,
    "d18Business&Commerce": 675,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 286,
    "noc": 6342,
    "job": "Tailors, dressmakers, furriers and milliners",
    "title1": "alterationist, garments",
    "title2": "alterations dressmaker",
    "title3": "alterations seamstress",
    "allTitles": "alterationist, garmentsalterations dressmakeralterations seamstresscustom fur joinercustom furriercustom sewer, women's garmentscustom tailordressmakerfur remodellerfur repair estimatorfur repairmanfur repairman/womanfur repairwomanfurrierfur tailorgarment fittergarment repair seamstressmaster tailormillinermillinery makerrepair seamstress, garmentssample maker, garmentsseamstressshop tailorsupervisor, tailorstailortailor, made-to-measure garmentstailor, men's garment alterationstailor, ready-to-wear garmentswomen's garment alterations seamstresswomen's garment custom seamstresswomen's hat maker - milliner",
    "workers": 820,
    "minEduc": 0,
    "yearsStudy": 1.791666667,
    "automationRisk": 0.84,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 25,
    "totalSkill": 120,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 14,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 300,
    "f4SocialScience": 0,
    "f5FineArts": 220,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 180,
    "f8Education(teachertraining)": 20,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 70,
    "f12Business": 30,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 300,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 220,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 180,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 70,
    "d18Business&Commerce": 30,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 287,
    "noc": 6343,
    "job": "Shoe repairers and shoemakers",
    "title1": "boot repairer bootmaker cobbler custom shoemaker orthopedic shoe repairman/woman orthopedic shoemaker shoe dyer shoe mender � retail shoe repairer shoe repairer � retail shoemaker",
    "title2": 0,
    "title3": 0,
    "allTitles": "boot repairer bootmaker cobbler custom shoemaker orthopedic shoe repairman/woman orthopedic shoemaker shoe dyer shoe mender � retail shoe repairer shoe repairer � retail shoemaker",
    "workers": 6178,
    "minEduc": 0,
    "yearsStudy": 1.768333333,
    "automationRisk": 0.532,
    "salaryLow": 14,
    "salaryMed": 17.238,
    "salaryHigh": 25.482,
    "totalSkill": 134.8,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 17.238,
    "skillsComp": 36.6,
    "skillsLogi": 34,
    "skillsMath": 19.2,
    "skillsLang": 45,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.6,
    "s2DecisionMaking": 9.6,
    "s3FindingInformation": 6.6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.8,
    "s6MoneyMath": 3.2,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.2,
    "s9ProblemSolving": 9.2,
    "s10Reading": 18.2,
    "s11SchedulingorBudgetingandAccounting": 5.4,
    "s12DigitalTechnology": 14.6,
    "s13DocumentUse": 17,
    "s14Writing": 12.2,
    "s15CriticalThinking": 6.4,
    "f1Science&Agriculture": 43,
    "f2Engineering": 8,
    "f3Humanities": 110,
    "f4SocialScience": 2,
    "f5FineArts": 121,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 5590,
    "f8Education(teachertraining)": 25,
    "f9Law": 29,
    "f10Health": 3,
    "f11Health,Nursing&ClinicalLaboratory": 106,
    "f12Business": 141,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 110,
    "d5SocialSciences": 2,
    "d6Fine&AppliedArts": 121,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 5590,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 8,
    "d11Law": 29,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 43,
    "d16Therapy&Rehabilitation": 3,
    "d17Health,Nursing&ClinicalLaboratory": 106,
    "d18Business&Commerce": 141,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 288,
    "noc": 6344,
    "job": "Jewellers, jewellery and watch repairers and related occupations",
    "title1": "appraiser, jewellery",
    "title2": "apprentice jeweller",
    "title3": "bench moulder - jewellery",
    "allTitles": "appraiser, jewelleryapprentice jewellerbench moulder - jewellerybrass or bronze chaserchaser, jewelleryclockmakerclock repairerclock repairmanclock repairman/womanclock repairwomancustom bracelet makercustom brooch makercustom jewellery mountercustom locket makercutter, designs - jewellerydesign cutter - jewellerydiamond bruterdiamond cutterdiamond expertdiamond grader - jewellery manufacturingdiamond markerdiamond polisherdiamond sawyerdiamond selector - jewellery manufacturingdiamond settergem cuttergem expertgemologistgem setterhammersmith, jewelleryjewellerjewellery appraiserjewellery chaserjewellery hammersmithjewellery model makerjewellery moulderjewellery repairerjewellery repairmanjewellery repairman/womanjewellery repairwomanjewellery sample makerjewel setterlapidarymarker, diamondsmodel maker, jewellerypearl cutterpearl setterplater - jewellery manufacturingprecious stone settersample maker, jewellerysawyer, diamondssetter - jewellery manufacturingsilver chaserstonecutter - jewellerystonesetter - jewellerywatchmakerwatch repairerwatch repairer apprenticewatch repairmanwatch repairman apprenticewatch repairman/womanwatch repairwomanwatch repairwoman apprentice",
    "workers": 505,
    "minEduc": 0,
    "yearsStudy": 1.733333333,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 17.19,
    "salaryHigh": 25.41,
    "totalSkill": 117,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 17.19,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 195,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 255,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 255,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 289,
    "noc": 6345,
    "job": "Upholsterers",
    "title1": "aircraft custom upholsterer",
    "title2": "aircraft furnishing technician",
    "title3": "aircraft interior technician",
    "allTitles": "aircraft custom upholstereraircraft furnishing technicianaircraft interior technicianaircraft patternmaker and upholstereraircraft upholstererautomobile upholstererautomotive upholsterercasket upholstererchair upholsterercustom upholstererfurniture upholstererindustrial upholstererpatternmaker and upholsterer, aircraftpatternmaker-upholstererpreparation upholstererproduction upholstererrailway car upholstererrepairer, upholsteryrepairman, upholsteryrepairwoman, upholsteryre-upholstererupholstererupholsterer, aircraftupholsterer, railway carupholstery mechanicupholstery repairerupholstery repairmanupholstery repairwomanvehicle upholstery repairervehicle upholstery repairmanvehicle upholstery repairwoman",
    "workers": 250,
    "minEduc": 0,
    "yearsStudy": 1.25,
    "automationRisk": 0.39,
    "salaryLow": 14,
    "salaryMed": 19,
    "salaryHigh": 27,
    "totalSkill": 142,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 19,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 250,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 250,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 290,
    "noc": 6346,
    "job": "Funeral directors and embalmers",
    "title1": "apprentice embalmer",
    "title2": "assistant funeral director",
    "title3": "director, funeral",
    "allTitles": "apprentice embalmerassistant funeral directordirector, funeralembalmerembalmer apprenticefuneral directorfuneral director, assistantfuneral home directorfuneral services directormorticianundertakerundertaker assistant",
    "workers": 1420,
    "minEduc": 0,
    "yearsStudy": 2.1,
    "automationRisk": 0.37,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 30.77,
    "totalSkill": 143,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 21,
    "skillsComp": 39,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1420,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1420,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 291,
    "noc": 6411,
    "job": "Sales and account representatives - wholesale trade (non-technical)",
    "title1": "advertising agency broker advertising agent advertising space representative � print media advertising time sales representative alarm system sales representative alcoholic beverage sales representative � wholesale aluminum products sales representative � wholesale auctioneer automotive parts sales representative � wholesale (non-technical) automotive parts salesperson � wholesale beer sales representative � wholesale booking agent � wholesale broker, advertising agency broker, livestock building maintenance services sales representative business equipment sales representative � wholesale business forms sales representative business services sales representative canvas product sales representative cartage and storage salesperson catalogue agent � wholesale classified ad salesperson cleaning services sales representative collection agency sales representative commercial agent � wholesale commercial and industrial equipment and supplies sales representative � wholesale (non-technical) commercial salesperson � wholesale commercial traveller � wholesale commission agent, livestock computer services sales representative concrete products salesperson � wholesale consumer sales representative contact person, recordings courier services sales representative credit bureau sales representative delivery services sales agent delivery services sales representative design sales representative � wholesale display advertising sales representative district sales representative � wholesale export company sales representative export sales representative exporter feed product sales representative field salesperson � wholesale financial services sales representative financial services salesperson fleet sales representative food products sales representative food services sales representative freight forwarding services sales representative freight sales agent freight services sales representative freight traffic agent fur trader grain broker � wholesale grain dealer grain merchandiser graphic arts sales representative graphic design sales representative group sales representative, travel group travel sales representative hotel accommodations sales executive hotel services sales representative hotel supply sales representative import company sales representative import sales representative importer import-export tradesperson � wholesale industrial tool sales representative institutional food services sales representative insulation salesperson � wholesale janitorial services sales representative laundry services sales representative leasing agent, signs and displays leasing services sales representative lighting fixture sales representative � wholesale (non-technical) liquor sales representative liquor sales representative � wholesale livestock broker livestock commission agent livestock sales representative � wholesale lumber sales representative � wholesale magazine sales representative magazine sales representative � wholesale manufacturer's agent � wholesale (non-technical) manufacturer's representative � wholesale (non-technical) media time sales representative membership sales representative motor vehicle and equipment sales representative � wholesale (non-technical) non-technical sales specialist � wholesale novelty products salesperson � wholesale novelty sales representative � wholesale ocean and lake container transportation sales representative office equipment sales representative � wholesale (non-technical) office furniture sales representative � wholesale oil distributor paper industry sales consultant periodicals sales representative periodicals sales representative � wholesale petroleum product sales representative � wholesale photographic services sales representative plastic product sales representative � wholesale postal services commercial sales representative printing services sales representative publication distributor � wholesale publication sales representative � wholesale publisher's sales representative � wholesale pulp and paper product sales representative pump and compressor sales representative � wholesale purveyor, wholesale radio advertising time sales representative recordings contact person recycling sales representative regional sales representative � wholesale reservation agent � wholesale restaurant equipment sales representative rubber product sales representative � wholesale sales agent � wholesale (non-technical) sales consultant � wholesale (non-technical) sales co-ordinator � wholesale (non-technical) sales executive � wholesale (non-technical) sales representative � wholesale (non-technical) sales representative, alcoholic beverages � wholesale sales representative, business services sales representative, canvas products sales representative, cleaning services sales representative, collection agency sales representative, commercial and industrial equipment and supplies sales representative, computer services sales representative, courier services sales representative, delivery services sales representative, design � wholesale sales representative, export sales representative, financial services sales representative, food products sales representative, freight forwarding services sales representative, hotel services sales representative, hotel supplies sales representative, import sales representative, janitorial services sales representative, livestock � wholesale sales representative, motor vehicles and equipment � wholesale (non-technical) sales representative, plastic products � wholesale sales representative, printing services sales representative, publications � wholesale sales representative, pulp and paper products sales representative, radio advertising time sales representative, rubber products � wholesale sales representative, security services � wholesale sales representative, sign and display sales representative, television advertising time sales representative, textbooks sales representative, tobacco products � wholesale sales representative, vending machine sales representative, vending machine services salesperson � wholesale (non-technical) salesperson, classified ads salesperson, novelty products � wholesale salesperson, security systems security services sales consultant security services sales consultant � wholesale security services sales representative security services sales representative � wholesale security system salesperson shipping sales representative sign and display leasing agent sign and display sales representative storage services sales representative supervisor, wholesale trade representatives supplier � wholesale telephone equipment sales representative � wholesale (non-technical) television advertising time sales representative television advertising time salesperson textbook sales representative tobacco product sales representative � wholesale tour operator � wholesale tour package sales representative � wholesale transfer company agent travelling salesperson � wholesale truck and trailer sales representative � wholesale (non-technical) vending machine sales representative vending machine services sales representative wholesale purveyor wholesale trade representative wine sales representative � wholesale",
    "title2": 0,
    "title3": 0,
    "allTitles": "advertising agency broker advertising agent advertising space representative � print media advertising time sales representative alarm system sales representative alcoholic beverage sales representative � wholesale aluminum products sales representative � wholesale auctioneer automotive parts sales representative � wholesale (non-technical) automotive parts salesperson � wholesale beer sales representative � wholesale booking agent � wholesale broker, advertising agency broker, livestock building maintenance services sales representative business equipment sales representative � wholesale business forms sales representative business services sales representative canvas product sales representative cartage and storage salesperson catalogue agent � wholesale classified ad salesperson cleaning services sales representative collection agency sales representative commercial agent � wholesale commercial and industrial equipment and supplies sales representative � wholesale (non-technical) commercial salesperson � wholesale commercial traveller � wholesale commission agent, livestock computer services sales representative concrete products salesperson � wholesale consumer sales representative contact person, recordings courier services sales representative credit bureau sales representative delivery services sales agent delivery services sales representative design sales representative � wholesale display advertising sales representative district sales representative � wholesale export company sales representative export sales representative exporter feed product sales representative field salesperson � wholesale financial services sales representative financial services salesperson fleet sales representative food products sales representative food services sales representative freight forwarding services sales representative freight sales agent freight services sales representative freight traffic agent fur trader grain broker � wholesale grain dealer grain merchandiser graphic arts sales representative graphic design sales representative group sales representative, travel group travel sales representative hotel accommodations sales executive hotel services sales representative hotel supply sales representative import company sales representative import sales representative importer import-export tradesperson � wholesale industrial tool sales representative institutional food services sales representative insulation salesperson � wholesale janitorial services sales representative laundry services sales representative leasing agent, signs and displays leasing services sales representative lighting fixture sales representative � wholesale (non-technical) liquor sales representative liquor sales representative � wholesale livestock broker livestock commission agent livestock sales representative � wholesale lumber sales representative � wholesale magazine sales representative magazine sales representative � wholesale manufacturer's agent � wholesale (non-technical) manufacturer's representative � wholesale (non-technical) media time sales representative membership sales representative motor vehicle and equipment sales representative � wholesale (non-technical) non-technical sales specialist � wholesale novelty products salesperson � wholesale novelty sales representative � wholesale ocean and lake container transportation sales representative office equipment sales representative � wholesale (non-technical) office furniture sales representative � wholesale oil distributor paper industry sales consultant periodicals sales representative periodicals sales representative � wholesale petroleum product sales representative � wholesale photographic services sales representative plastic product sales representative � wholesale postal services commercial sales representative printing services sales representative publication distributor � wholesale publication sales representative � wholesale publisher's sales representative � wholesale pulp and paper product sales representative pump and compressor sales representative � wholesale purveyor, wholesale radio advertising time sales representative recordings contact person recycling sales representative regional sales representative � wholesale reservation agent � wholesale restaurant equipment sales representative rubber product sales representative � wholesale sales agent � wholesale (non-technical) sales consultant � wholesale (non-technical) sales co-ordinator � wholesale (non-technical) sales executive � wholesale (non-technical) sales representative � wholesale (non-technical) sales representative, alcoholic beverages � wholesale sales representative, business services sales representative, canvas products sales representative, cleaning services sales representative, collection agency sales representative, commercial and industrial equipment and supplies sales representative, computer services sales representative, courier services sales representative, delivery services sales representative, design � wholesale sales representative, export sales representative, financial services sales representative, food products sales representative, freight forwarding services sales representative, hotel services sales representative, hotel supplies sales representative, import sales representative, janitorial services sales representative, livestock � wholesale sales representative, motor vehicles and equipment � wholesale (non-technical) sales representative, plastic products � wholesale sales representative, printing services sales representative, publications � wholesale sales representative, pulp and paper products sales representative, radio advertising time sales representative, rubber products � wholesale sales representative, security services � wholesale sales representative, sign and display sales representative, television advertising time sales representative, textbooks sales representative, tobacco products � wholesale sales representative, vending machine sales representative, vending machine services salesperson � wholesale (non-technical) salesperson, classified ads salesperson, novelty products � wholesale salesperson, security systems security services sales consultant security services sales consultant � wholesale security services sales representative security services sales representative � wholesale security system salesperson shipping sales representative sign and display leasing agent sign and display sales representative storage services sales representative supervisor, wholesale trade representatives supplier � wholesale telephone equipment sales representative � wholesale (non-technical) television advertising time sales representative television advertising time salesperson textbook sales representative tobacco product sales representative � wholesale tour operator � wholesale tour package sales representative � wholesale transfer company agent travelling salesperson � wholesale truck and trailer sales representative � wholesale (non-technical) vending machine sales representative vending machine services sales representative wholesale purveyor wholesale trade representative wine sales representative � wholesale",
    "workers": 115955,
    "minEduc": 1,
    "yearsStudy": 2.851176917,
    "automationRisk": 0.92,
    "salaryLow": 14,
    "salaryMed": 24.86,
    "salaryHigh": 43.59,
    "totalSkill": 118,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 9,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 8,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 6955,
    "f2Engineering": 7325,
    "f3Humanities": 5165,
    "f4SocialScience": 11275,
    "f5FineArts": 11395,
    "f6MathAndComputerScience": 3825,
    "f7Arts&Education": 15780,
    "f8Education(teachertraining)": 4640,
    "f9Law": 4525,
    "f10Health": 3445,
    "f11Health,Nursing&ClinicalLaboratory": 10090,
    "f12Business": 31535,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 2560,
    "d2Forestry": 595,
    "d3Architecture&LandscapeArchitecture": 665,
    "d4Humanities": 4705,
    "d5SocialSciences": 11275,
    "d6Fine&AppliedArts": 11395,
    "d7ComputerScience": 3400,
    "d8OtherArts&Science": 15780,
    "d9Education(teachertraining)": 4640,
    "d10Engineering": 6660,
    "d11Law": 4525,
    "d12Mathematics": 425,
    "d13Kinesiology/Recreation/PhysicalEducation": 1830,
    "d14Theology": 460,
    "d15PhysicalSciences": 3800,
    "d16Therapy&Rehabilitation": 1615,
    "d17Health,Nursing&ClinicalLaboratory": 10090,
    "d18Business&Commerce": 31535,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 292,
    "noc": 6421,
    "job": "Retail salespersons",
    "title1": "aluminum products salesman - retail",
    "title2": "aluminum products salesperson - retail",
    "title3": "aluminum products saleswoman - retail",
    "allTitles": "aluminum products salesman - retailaluminum products salesperson - retailaluminum products saleswoman - retailaluminum siding salesman - retailaluminum siding salesperson - retailaluminum siding saleswoman - retailappliance salesman - retailappliance salesperson - retailappliance saleswoman - retailart sales consultant - retailart salespersonaudio equipment consultant - retailaudio equipment salesman - retailaudio equipment salespersonaudio equipment salesperson - retailaudio equipment saleswoman - retailautomobile accessories salesman - retailautomobile accessories salesperson - retailautomobile accessories saleswoman - retailautomobile leasing agentautomobile leasing representativeautomobile-rental counter representativeautomobile salespersonautomobile sales representative - retailbakery clerkbakery counter clerkbakery goods sales clerkbeer store sales clerkbicycle salesman - retailbicycle salesperson - retailbicycle saleswoman - retailboat and marine equipment salesman - retailboat and marine equipment salesperson - retailboat and marine equipment saleswoman - retailbook salesman - retailbook salesperson - retailbook saleswoman - retailbook store clerk - retailbouquet salespersonbridal sales consultant - retailbuilding supplies salesman - retailbuilding supplies salesperson - retailbuilding supplies saleswoman - retailbutcher shop clerkcable television service salespersoncable-TV and pay-TV sales representativecamera equipment salesman - retailcamera equipment salesperson - retailcamera equipment saleswoman - retailcamera salesman - retailcamera salesperson - retailcamera saleswoman - retailcard shop clerkcar leasing representativecar rental agentcar rental clerkcar-rental counter representativecar salesman - retailcar salesperson - retailcar sales representative - retailcar saleswoman - retailchildren's clothing sales clerkchildren's wear sales clerkchildren's wear salesman - retailchildren's wear salesperson - retailchildren's wear saleswoman - retailchina and crystal salesman - retailchina and crystal salesperson - retailchina and crystal saleswoman - retailclerk, bakery counterclerk, deli counterclerk, meat counterclerk, retail salesclock shop clerkclothing salesman - retailclothing salespersonclothing salesperson - retailclothing saleswoman - retailcommissioned salesman - retailcommissioned salesperson - retailcommissioned saleswoman - retailcompact disc sales clerkcomputer salesman - retailcomputer salesperson - retailcomputer saleswoman - retailconfectionery sales clerkconvenience store clerkcorner store clerkcosmetics salesman - retailcosmetics salesperson - retailcosmetics saleswoman - retailcounter clerk, bakerycounter clerk, delicounter clerk, meatscounter clerk - retailcounter representative, car rentalcustom drapery salesman - retailcustom drapery salesperson - retailcustom drapery saleswoman - retailcustomer service sales clerk",
    "workers": 115955,
    "minEduc": 1,
    "yearsStudy": 2.851176917,
    "automationRisk": 0.92,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 21.03,
    "totalSkill": 118,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 9,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 8,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 6955,
    "f2Engineering": 7325,
    "f3Humanities": 5165,
    "f4SocialScience": 11275,
    "f5FineArts": 11395,
    "f6MathAndComputerScience": 3825,
    "f7Arts&Education": 15780,
    "f8Education(teachertraining)": 4640,
    "f9Law": 4525,
    "f10Health": 3445,
    "f11Health,Nursing&ClinicalLaboratory": 10090,
    "f12Business": 31535,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 2560,
    "d2Forestry": 595,
    "d3Architecture&LandscapeArchitecture": 665,
    "d4Humanities": 4705,
    "d5SocialSciences": 11275,
    "d6Fine&AppliedArts": 11395,
    "d7ComputerScience": 3400,
    "d8OtherArts&Science": 15780,
    "d9Education(teachertraining)": 4640,
    "d10Engineering": 6660,
    "d11Law": 4525,
    "d12Mathematics": 425,
    "d13Kinesiology/Recreation/PhysicalEducation": 1830,
    "d14Theology": 460,
    "d15PhysicalSciences": 3800,
    "d16Therapy&Rehabilitation": 1615,
    "d17Health,Nursing&ClinicalLaboratory": 10090,
    "d18Business&Commerce": 31535,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 293,
    "noc": 6511,
    "job": "Maitres d'hotel and hosts/hostesses",
    "title1": "chief hostess - food services",
    "title2": "chief host - food services",
    "title3": "chief host/hostess - food services",
    "allTitles": "chief hostess - food serviceschief host - food serviceschief host/hostess - food servicesdining room hostdining room hostessdining room host/hostesshost, dining roomhostess, dining roomhostess, food servicehostess, restauranthostess - restaurant or cocktail loungehost, food servicehost/hostess, dining roomhost/hostess, food servicehost/hostess, restauranthost/hostess - restaurant or cocktail loungehost, restauranthost - restaurant or cocktail loungema�tre d'ma�tre d'h�telrestaurant hostrestaurant hostessrestaurant host/hostess",
    "workers": 565,
    "minEduc": 0,
    "yearsStudy": 2.761904762,
    "automationRisk": 0.97,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 21.63,
    "totalSkill": 113,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 31,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 95,
    "f4SocialScience": 110,
    "f5FineArts": 95,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 135,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 100,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 95,
    "d5SocialSciences": 110,
    "d6Fine&AppliedArts": 95,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 135,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 100,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 294,
    "noc": 6512,
    "job": "Bartenders",
    "title1": "attendant, bar bar attendant bar steward barkeeper barmaid barman/barwoman barman/woman, beer bartender bartender, tap bartenders supervisor beer barman/woman head barmaid head barman/barwoman head bartender lounge supervisor-bartender managing bartender service bartender supervisor, bartenders supervisor-bartender, lounge tapman/woman",
    "title2": 0,
    "title3": 0,
    "allTitles": "attendant, bar bar attendant bar steward barkeeper barmaid barman/barwoman barman/woman, beer bartender bartender, tap bartenders supervisor beer barman/woman head barmaid head barman/barwoman head bartender lounge supervisor-bartender managing bartender service bartender supervisor, bartenders supervisor-bartender, lounge tapman/woman",
    "workers": 11272.5,
    "minEduc": 0,
    "yearsStudy": 2.837167071,
    "automationRisk": 0.955,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 16.82,
    "totalSkill": 113.5,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 11.8,
    "skillsComp": 31,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 8.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 305,
    "f2Engineering": 77.5,
    "f3Humanities": 557.5,
    "f4SocialScience": 1652.5,
    "f5FineArts": 1407.5,
    "f6MathAndComputerScience": 122.5,
    "f7Arts&Education": 1820,
    "f8Education(teachertraining)": 647.5,
    "f9Law": 532.5,
    "f10Health": 415,
    "f11Health,Nursing&ClinicalLaboratory": 1205,
    "f12Business": 2530,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 252.5,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 545,
    "d5SocialSciences": 1652.5,
    "d6Fine&AppliedArts": 1407.5,
    "d7ComputerScience": 70,
    "d8OtherArts&Science": 1820,
    "d9Education(teachertraining)": 647.5,
    "d10Engineering": 77.5,
    "d11Law": 532.5,
    "d12Mathematics": 52.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 235,
    "d14Theology": 12.5,
    "d15PhysicalSciences": 22.5,
    "d16Therapy&Rehabilitation": 180,
    "d17Health,Nursing&ClinicalLaboratory": 1205,
    "d18Business&Commerce": 2530,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 295,
    "noc": 6513,
    "job": "Food and beverage servers",
    "title1": "assistant waiter - food and beverage services",
    "title2": "assistant waiter/waitress - food and beverage services",
    "title3": "assistant waitress - food and beverage services",
    "allTitles": "assistant waiter - food and beverage servicesassistant waiter/waitress - food and beverage servicesassistant waitress - food and beverage servicesbanquet captainbanquet headwaiterbanquet headwaiter/headwaitressbanquet headwaitressbanquet serverbanquet waiterbanquet waiter/waitressbanquet waitressbar service waiterbar service waiter/waitressbar service waitressbeer serverbuffet waiterbuffet waiter/waitressbuffet waitresscamp waitercamp waiter/waitresscamp waitresscaptain waitercaptain waiter - food and beverage servicescaptain waiter - formal servicecaptain waiter/waitresscaptain waiter/waitress - food and beverage servicescaptain waiter/waitress - formal servicecaptain waitresscaptain waitress - food and beverage servicescaptain waitress - formal servicecaterer waitercaterer waiter/waitresscaterer waitresschief wine stewardclub car attendantcocktail waitercocktail waiter/waitresscocktail waitresscommissary waitercommissary waiter/waitresscommissary waitressdining car stewarddining car waiterdining car waiter/waitressdining car waitressdining room captaindining room stewardfood and beverage serverformal service waiterformal service waiter/waitressformal service waitressheadwaiter - food and beverage servicesheadwaiter/headwaitress - food and beverage servicesheadwaitress - food and beverage serviceshotel waiter - formal servicehotel waiter/waitress - formal servicehotel waitress - formal servicelounge waiterlounge waiter/waitresslounge waitressmess waitermess waiter/waitressmess waitressrestaurant waiter - formal servicerestaurant waiter/waitress - formal servicerestaurant waitress - formal serviceroom service waiterroom service waiter/waitressroom service waitressserver - food and beverage servicessommeliersteward - food and beverage serviceswaiterwaiter - drive-in restaurantwaiter - food and beverage serviceswaiter/waitresswaiter/waitress - drive-in restaurantwaiter/waitress - food and beverage serviceswaitresswaitress - drive-in restaurantwaitress - food and beverage serviceswine serverwine stewardwine waiterwine waiter/waitresswine waitress",
    "workers": 21980,
    "minEduc": 0,
    "yearsStudy": 2.912429379,
    "automationRisk": 0.94,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 17.24,
    "totalSkill": 114,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 11.6,
    "skillsComp": 31,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 610,
    "f2Engineering": 155,
    "f3Humanities": 1020,
    "f4SocialScience": 3195,
    "f5FineArts": 2720,
    "f6MathAndComputerScience": 245,
    "f7Arts&Education": 3505,
    "f8Education(teachertraining)": 1295,
    "f9Law": 1065,
    "f10Health": 830,
    "f11Health,Nursing&ClinicalLaboratory": 2380,
    "f12Business": 4960,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 505,
    "d2Forestry": 60,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 995,
    "d5SocialSciences": 3195,
    "d6Fine&AppliedArts": 2720,
    "d7ComputerScience": 140,
    "d8OtherArts&Science": 3505,
    "d9Education(teachertraining)": 1295,
    "d10Engineering": 155,
    "d11Law": 1065,
    "d12Mathematics": 105,
    "d13Kinesiology/Recreation/PhysicalEducation": 470,
    "d14Theology": 25,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 360,
    "d17Health,Nursing&ClinicalLaboratory": 2380,
    "d18Business&Commerce": 4960,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 296,
    "noc": 6521,
    "job": "Travel counsellors",
    "title1": "agent, booking - travel agency",
    "title2": "agent, travel",
    "title3": "agent, travel information",
    "allTitles": "agent, booking - travel agencyagent, travelagent, travel informationbooking agent - travel agencyconsultant, travelcounsellor, travelcounsellor, travel centreinformation agent, travelreservation agent - travel agencyreservation sales agent - travel agencytourist information counsellortravel agenttravel centre counsellortravel consultanttravel counsellortravel information agenttravel specialistvisitor information counsellor",
    "workers": 5830,
    "minEduc": 0,
    "yearsStudy": 2.977011494,
    "automationRisk": 0.099,
    "salaryLow": 14,
    "salaryMed": 17.5,
    "salaryHigh": 26.44,
    "totalSkill": 154,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 17.5,
    "skillsComp": 41,
    "skillsLogi": 38,
    "skillsMath": 21,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 16,
    "s14Writing": 15,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 45,
    "f4SocialScience": 245,
    "f5FineArts": 100,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 125,
    "f8Education(teachertraining)": 140,
    "f9Law": 35,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 60,
    "f12Business": 5055,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 45,
    "d5SocialSciences": 245,
    "d6Fine&AppliedArts": 100,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 125,
    "d9Education(teachertraining)": 140,
    "d10Engineering": 0,
    "d11Law": 35,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 10,
    "d17Health,Nursing&ClinicalLaboratory": 60,
    "d18Business&Commerce": 5055,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 297,
    "noc": 6522,
    "job": "Pursers and flight attendants",
    "title1": "aircraft flight attendant",
    "title2": "airline purser",
    "title3": "attendant, commissary - air transport",
    "allTitles": "aircraft flight attendantairline purserattendant, commissary - air transportattendant, flightchief steward, shipcommissary attendant - air transportCSD (customer service director) - water transportationcustomer service director (CSD) - water transportationcustomer service director - water transportationdirector, flight servicedirector, passenger service - water transportationflight attendantflight purserflight service directorin-charge flight attendantin-flight service managermanager, in-flight servicepassenger service director - water transportationpurser, airlinepurser - air transportationpurser - water transportship pursership supply officersupply officer, ship",
    "workers": 1155,
    "minEduc": 0,
    "yearsStudy": 2.764705882,
    "automationRisk": 0.35,
    "salaryLow": 14,
    "salaryMed": 23,
    "salaryHigh": 42.74,
    "totalSkill": 145,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 23,
    "skillsComp": 39,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 49,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 17,
    "s14Writing": 14,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 50,
    "f2Engineering": 0,
    "f3Humanities": 15,
    "f4SocialScience": 145,
    "f5FineArts": 120,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 205,
    "f8Education(teachertraining)": 15,
    "f9Law": 0,
    "f10Health": 30,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 540,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 50,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 15,
    "d5SocialSciences": 145,
    "d6Fine&AppliedArts": 120,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 205,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 30,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 540,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 298,
    "noc": 6523,
    "job": "Airline ticket and service agents",
    "title1": "agent, cargo - airline",
    "title2": "agent, check-in - airline",
    "title3": "agent, commissary - airline",
    "allTitles": "agent, cargo - airlineagent, check-in - airlineagent, commissary - airlineagent, counter services - airlineagent, customer sales - airlineagent, customer service - airlineagent, load control - airlineagent, passengers - airlineagent, reservations - airlineagent, station - airlineagent, station services - airlineagent ticket and information - airlineagent, tickets - airlineairline baggage agentairline cargo agentairline customer service representativeairline load plannerairline passenger agentairline reservation agentairline sales and service agentairline ticket agentbaggage agent - airlinebaggage tracer, airlinebaggage tracing agent - airlinecargo agent - airlinecargo customer service representative - airlinecertified load control agent - airlinecertified load planner - airlinecheck-in agent - airlineclerk, reservations - airlineclient service representative - airlinecommissary agent - airlinecounter services agent, airlinecustomer sales agent - airlinecustomer service agent, airlinecustomer service representative - airlineflight agentload agent - airlineload control agent - airlineload planner, airlinepassenger agent, airlinepassenger sales agent - airlinepassenger sales representative - airlinepassenger service representativepassenger service representative - airlinerepresentative, client service - airlinerepresentative, customer service - airlinereservation agent - airlinereservation agent, airlinereservation clerk - airlinereservation sales agent - airlinesales agent, passengers - airlinestation agent, airlinestation services agent - airlineticket agent, airlineticket and information agent - airlinetracer, baggage - airline",
    "workers": 800,
    "minEduc": 0,
    "yearsStudy": 2.473684211,
    "automationRisk": 0.61,
    "salaryLow": 14,
    "salaryMed": 21.9,
    "salaryHigh": 33.65,
    "totalSkill": 133,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 21.9,
    "skillsComp": 36,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 50,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 675,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 50,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 675,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 299,
    "noc": 6524,
    "job": "Ground and water transport ticket agents, cargo service representatives and related clerks",
    "title1": "agent, counter sales � railway agent, freight � railway agent, passengers � railway agent, passengers (except airline) agent, railway express agent, reservations � railway agent, ship cargo agent, tickets � bus line agent, tickets � cruise line agent, tickets � transit station baggage agent � railway baggage agent (except airline) baggage clerk (except airline) bookings clerk � railway bookings clerk � wholesale travel bookings clerk (except airline) bus ticket agent cargo customer service representative � bus line cargo customer service representative � marine shipping cargo customer service representative � railway check-in agent (except airline) clerk, bookings � railway clerk, bookings � wholesale travel clerk, bookings (except airline) clerk, reservations � cruise line clerk, reservations � railway clerk, reservations � wholesale travel clerk, reservations (except airline) clerk, stowage client service representative � bus line counter clerk (except airline) counter sales agent � railway counter sales agent (except airline) counter service agent (except airline) counter service agent, railway customer sales and service agent (except airline) customer service agent � bus line customer service representative � bus line freight agent � railway freight agent (except airline) luggage checker (except airline) passenger agent � railway passenger agent (except airline) railway express agent railway passenger agent reservations agent � cruise line reservations agent � railway reservations agent (except airline) reservations clerk � cruise line reservations clerk � wholesale travel reservations clerk (except airline) reservations clerk, railway sales agent � railway sales agent, counter � railway sales agent, counter (except airline) ship cargo agent station agent � railway stowage clerk ticket agent � bus line ticket agent � cruise line ticket agent � transit station ticket agent (except airline) ticket and customer service clerk (except airline) ticket and information clerk (except airline) ticket clerk � railway ticket clerk (except airline) transit station ticket agent transportation agent (except airline)",
    "title2": 0,
    "title3": 0,
    "allTitles": "agent, counter sales � railway agent, freight � railway agent, passengers � railway agent, passengers (except airline) agent, railway express agent, reservations � railway agent, ship cargo agent, tickets � bus line agent, tickets � cruise line agent, tickets � transit station baggage agent � railway baggage agent (except airline) baggage clerk (except airline) bookings clerk � railway bookings clerk � wholesale travel bookings clerk (except airline) bus ticket agent cargo customer service representative � bus line cargo customer service representative � marine shipping cargo customer service representative � railway check-in agent (except airline) clerk, bookings � railway clerk, bookings � wholesale travel clerk, bookings (except airline) clerk, reservations � cruise line clerk, reservations � railway clerk, reservations � wholesale travel clerk, reservations (except airline) clerk, stowage client service representative � bus line counter clerk (except airline) counter sales agent � railway counter sales agent (except airline) counter service agent (except airline) counter service agent, railway customer sales and service agent (except airline) customer service agent � bus line customer service representative � bus line freight agent � railway freight agent (except airline) luggage checker (except airline) passenger agent � railway passenger agent (except airline) railway express agent railway passenger agent reservations agent � cruise line reservations agent � railway reservations agent (except airline) reservations clerk � cruise line reservations clerk � wholesale travel reservations clerk (except airline) reservations clerk, railway sales agent � railway sales agent, counter � railway sales agent, counter (except airline) ship cargo agent station agent � railway stowage clerk ticket agent � bus line ticket agent � cruise line ticket agent � transit station ticket agent (except airline) ticket and customer service clerk (except airline) ticket and information clerk (except airline) ticket clerk � railway ticket clerk (except airline) transit station ticket agent transportation agent (except airline)",
    "workers": 2368.75,
    "minEduc": 0,
    "yearsStudy": 2.682638276,
    "automationRisk": 0.49975,
    "salaryLow": 14,
    "salaryMed": 17.73,
    "salaryHigh": 28.62,
    "totalSkill": 137,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 19.1,
    "skillsComp": 37,
    "skillsLogi": 34.25,
    "skillsMath": 19.25,
    "skillsLang": 45.75,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.75,
    "s6MoneyMath": 3.25,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.25,
    "s9ProblemSolving": 9.25,
    "s10Reading": 18.75,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 15.25,
    "s13DocumentUse": 16.75,
    "s14Writing": 12.5,
    "s15CriticalThinking": 6.25,
    "f1Science&Agriculture": 12.5,
    "f2Engineering": 0,
    "f3Humanities": 23.75,
    "f4SocialScience": 110,
    "f5FineArts": 62.5,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 110,
    "f8Education(teachertraining)": 43.75,
    "f9Law": 18.75,
    "f10Health": 16.25,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 1926.25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 12.5,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 23.75,
    "d5SocialSciences": 110,
    "d6Fine&AppliedArts": 62.5,
    "d7ComputerScience": 11.25,
    "d8OtherArts&Science": 110,
    "d9Education(teachertraining)": 43.75,
    "d10Engineering": 0,
    "d11Law": 18.75,
    "d12Mathematics": 3.75,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 16.25,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 1926.25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 300,
    "noc": 6525,
    "job": "Hotel front desk clerks",
    "title1": "clerk, front desk - hotel",
    "title2": "clerk, front office - hotel",
    "title3": "clerk, hotel",
    "allTitles": "clerk, front desk - hotelclerk, front office - hotelclerk, hotelclerk, hotel front deskclerk, night - hotelclerk, reservations - hotelclerk, room - hotelday clerk - hoteldesk clerk, hotelfront desk agentfront desk clerk, hotelfront desk hotel clerkfront office clerk, hotelfront office hotel clerkguest service agentguest service representativeguest service representative - hotelguest services agent - hotelhotel clerkhotel clerk, front officehotel conciergehotel front desk clerkhotel front office clerkhotel night auditorhotel receptionistnight auditor - hotelnight clerknight clerk - hotelreception clerk - hotelreceptionist, hotelreservations clerk - hotelroom clerkroom clerk - hotelroom service clerk - hotelservice agent, guests - hotelsuperintendent of services - hotel",
    "workers": 1690,
    "minEduc": 0,
    "yearsStudy": 2.515151515,
    "automationRisk": 0.94,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 21,
    "totalSkill": 116,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 14,
    "skillsComp": 32,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 35,
    "f4SocialScience": 0,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 30,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 20,
    "f9Law": 20,
    "f10Health": 25,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 1435,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 30,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 25,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 1435,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 301,
    "noc": 6531,
    "job": "Tour and travel guides",
    "title1": "adventure travel site interpreter",
    "title2": "bicycle tour guide",
    "title3": "boat tour guide",
    "allTitles": "adventure travel site interpreterbicycle tour guideboat tour guidebus tour guidecal�che drivercal�che operatorescort, tourescort, travelestablishment guidefactory tour guideguide, establishmentguide, horse-drawn vehicle sightseeing toursguide, sightseeingguide, travelhorse-drawn vehicle sightseeing tour guidehostess, ski resorthost/hostess, ski resorthost, ski resortindustrial site interpreterinterpreter, adventure siteinterpreter, industrial sitelocal tour guidemine guideplant tour guidesightseeing guidesightseeing tour guide, horse-drawn vehiclessite interpreter, adventure travelski resort hostski resort hostessski resort host/hostesstour directortour escorttour guidetourist guidetravel escorttravel guidewalking tour guide",
    "workers": 110,
    "minEduc": 0,
    "yearsStudy": 3.6,
    "automationRisk": 0.91,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 21,
    "totalSkill": 116,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 75,
    "f8Education(teachertraining)": 25,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 10,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 75,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 10,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 302,
    "noc": 6532,
    "job": "Outdoor sport and recreational guides",
    "title1": "airship pilot alpine guide balloon pilot canoeing guide dirigible pilot dogsledding guide dude wrangler fishing guide freshwater angling guide guide, hunting and fishing guide, mountain climbing guide, outdoor guide, outfitting guide, rafting guide, whitewater rafting hiking guide horseback riding guide hot air balloonist hunting and fishing guide hunting and fishing outfitter hunting guide mountain climbing guide mountain guide mountaineering guide outdoor guide outfitter outfitting guide rafting guide rock climbing guide snowmobile operations guide trapping guide whitewater rafting guide winter camping guide wrangler, dude ranch",
    "title2": 0,
    "title3": 0,
    "allTitles": "airship pilot alpine guide balloon pilot canoeing guide dirigible pilot dogsledding guide dude wrangler fishing guide freshwater angling guide guide, hunting and fishing guide, mountain climbing guide, outdoor guide, outfitting guide, rafting guide, whitewater rafting hiking guide horseback riding guide hot air balloonist hunting and fishing guide hunting and fishing outfitter hunting guide mountain climbing guide mountain guide mountaineering guide outdoor guide outfitter outfitting guide rafting guide rock climbing guide snowmobile operations guide trapping guide whitewater rafting guide winter camping guide wrangler, dude ranch",
    "workers": 410,
    "minEduc": 0,
    "yearsStudy": 3.014285715,
    "automationRisk": 0.822,
    "salaryLow": 14.5,
    "salaryMed": 18,
    "salaryHigh": 24.5,
    "totalSkill": 122,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 17.5,
    "skillsComp": 33.5,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 40,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 72.5,
    "f3Humanities": 0,
    "f4SocialScience": 42.5,
    "f5FineArts": 7.5,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 12.5,
    "f9Law": 20,
    "f10Health": 67.5,
    "f11Health,Nursing&ClinicalLaboratory": 5,
    "f12Business": 132.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 42.5,
    "d6Fine&AppliedArts": 7.5,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 12.5,
    "d10Engineering": 72.5,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 45,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 22.5,
    "d17Health,Nursing&ClinicalLaboratory": 5,
    "d18Business&Commerce": 132.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 303,
    "noc": 6533,
    "job": "Casino occupations",
    "title1": "baccarat croupier",
    "title2": "blackjack croupier",
    "title3": "casino dealer",
    "allTitles": "baccarat croupierblackjack croupiercasino dealercasino runnercasino slot machine attendantcounting attendant - casinocroupiercroupier, baccaratcroupier, blackjackcroupier - casinocroupier, pai gowcroupier, pai gow dominocroupier, pai gow pokercroupier, pokercroupier, roulettecroupier, sic bocroupier, super pan 9croupier, twenty-onedealer, casinogambling table operatorgaming table dealergaming table operator - casinokeno dealerkeno runner, casinokeno writeroperator, gambling tablepai gow croupierpai gow domino croupierpai gow poker croupierpoker croupierroulette croupierrunner, casinosic bo croupierslot machine attendant, casinosuper pan 9 croupier",
    "workers": 710,
    "minEduc": 0,
    "yearsStudy": 2.428571429,
    "automationRisk": 0.734,
    "salaryLow": 15,
    "salaryMed": 22,
    "salaryHigh": 28,
    "totalSkill": 128,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 22,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 145,
    "f3Humanities": 0,
    "f4SocialScience": 85,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 40,
    "f10Health": 135,
    "f11Health,Nursing&ClinicalLaboratory": 10,
    "f12Business": 255,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 85,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 145,
    "d11Law": 40,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 90,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 45,
    "d17Health,Nursing&ClinicalLaboratory": 10,
    "d18Business&Commerce": 255,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 304,
    "noc": 6541,
    "job": "Security guards and related security service occupations",
    "title1": "air courier guard",
    "title2": "airport security guard",
    "title3": "alarm investigator",
    "allTitles": "air courier guardairport security guardalarm investigatoralarm signal investigatoralarm signal specialistarmoured car driverarmoured car guardATM (automatic teller machine) guardattendant, gate - securityautomatic teller machine (ATM) guardbodyguard (except police)bouncerbouncer - securitybusiness establishment investigator - securitycabin baggage inspectorcarry-on baggage inspectorcommissionairecommissionaire - securityconvoy guardcorporate security officercrossing guarddetective, privatefloorman, retail storefloorman/woman, retail storefloorwalker, retail storefloorwoman, retail storegate attendant - securitygatemangateman/womangatewomanguard, armoured carguard, securityhand baggage inspectorhand luggage inspectorhouse detectiveinvestigations officer - postal serviceinvestigator, business establishmentinvestigator, privatelie detector examinerloss prevention officer - retailloss prevention officers supervisormystery shoppernight guardnight watchmannight watchman/womannight watchwomanofficer, corporate securityofficer, investigations - postal serviceofficer, loss prevention - retailofficer, postal inspectionofficer, security analysis - postal servicepatrolman - securitypatrolman/woman - securitypatrol officer - securitypatrolwoman - securityplant gatekeeperplant guardpolygraph examinerpolygraphistpolygraph operatorpostal inspection officerpostal service inspectorpreboarding security guardprivate detectiveprivate investigatorprivate investigators supervisorprivate police agents and investigators supervisorprivate policemen/women and investigators supervisorprivate security officerresidential alarm system specialistretail investigatorretail loss investigatorretail loss prevention officerretail store floormanretail store floorman/womanretail store floorwalkerretail store floorwomanschool crossing guardsecurity alarm system consultantsecurity analysis officer - postal servicesecurity and investigations officersecurity consultant (except computer systems)security guardsecurity guard - explosivessecurity investigatorsecurity officersecurity officer, privatesecurity specialist (except computer systems)shopping investigator - securitystore detectivesupervisor, loss prevention officerssupervisor, private investigatorssupervisor, private police agents and investigatorssupervisor, private policemen/women and investigatorstheft prevention officervault custodian",
    "workers": 19805,
    "minEduc": 0,
    "yearsStudy": 2.709770115,
    "automationRisk": 0.84,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 25,
    "totalSkill": 119,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 13.05,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 39,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 775,
    "f2Engineering": 1570,
    "f3Humanities": 285,
    "f4SocialScience": 1345,
    "f5FineArts": 455,
    "f6MathAndComputerScience": 570,
    "f7Arts&Education": 2060,
    "f8Education(teachertraining)": 230,
    "f9Law": 8495,
    "f10Health": 220,
    "f11Health,Nursing&ClinicalLaboratory": 540,
    "f12Business": 3260,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 95,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 25,
    "d4Humanities": 255,
    "d5SocialSciences": 1345,
    "d6Fine&AppliedArts": 455,
    "d7ComputerScience": 530,
    "d8OtherArts&Science": 2060,
    "d9Education(teachertraining)": 230,
    "d10Engineering": 1545,
    "d11Law": 8495,
    "d12Mathematics": 40,
    "d13Kinesiology/Recreation/PhysicalEducation": 90,
    "d14Theology": 30,
    "d15PhysicalSciences": 650,
    "d16Therapy&Rehabilitation": 130,
    "d17Health,Nursing&ClinicalLaboratory": 540,
    "d18Business&Commerce": 3260,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 305,
    "noc": 6551,
    "job": "Customer services representatives - financial institutions",
    "title1": "accounts information service clerk - financial institution",
    "title2": "bank customer service officer",
    "title3": "bank teller",
    "allTitles": "accounts information service clerk - financial institutionbank customer service officerbank tellercredit union tellercurrent account representative - financial servicescustomer service agent - financial institutioncustomer service officer, bankcustomer service representative - financial servicesfinancial customer service representativeforeign exchange teller - financial serviceshead teller - financial servicesproof teller - banksavings account teller - financial servicessenior teller - financial servicesteller - financial servicesteller traineetrust company teller",
    "workers": 17920,
    "minEduc": 0,
    "yearsStudy": 3.114006515,
    "automationRisk": 0.55,
    "salaryLow": 14,
    "salaryMed": 17.95,
    "salaryHigh": 24.62,
    "totalSkill": 134,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 17.95,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 230,
    "f2Engineering": 135,
    "f3Humanities": 455,
    "f4SocialScience": 2410,
    "f5FineArts": 685,
    "f6MathAndComputerScience": 490,
    "f7Arts&Education": 1640,
    "f8Education(teachertraining)": 405,
    "f9Law": 625,
    "f10Health": 485,
    "f11Health,Nursing&ClinicalLaboratory": 745,
    "f12Business": 9615,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 105,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 425,
    "d5SocialSciences": 2410,
    "d6Fine&AppliedArts": 685,
    "d7ComputerScience": 430,
    "d8OtherArts&Science": 1640,
    "d9Education(teachertraining)": 405,
    "d10Engineering": 135,
    "d11Law": 625,
    "d12Mathematics": 60,
    "d13Kinesiology/Recreation/PhysicalEducation": 190,
    "d14Theology": 30,
    "d15PhysicalSciences": 125,
    "d16Therapy&Rehabilitation": 295,
    "d17Health,Nursing&ClinicalLaboratory": 745,
    "d18Business&Commerce": 9615,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 306,
    "noc": 6552,
    "job": "Other customer and information services representatives",
    "title1": "accounts information clerk",
    "title2": "adjustment clerk",
    "title3": "attendant, tourist booth",
    "allTitles": "accounts information clerkadjustment clerkattendant, tourist boothattendant, tourist information officeautomobile dealerships service representativebill complaints investigatorbusiness office service representative - telecommunicationsbus information clerkbus schedule information clerkbus service information clerkcall centre agent - customer serviceclaim clerk, lost or damaged goodsclerk, customer serviceclerk, maintenance serviceclient service clerkcompensation agentcomplaints adjustercomplaints clerk - customer servicecomplaints clerk - telephone systemcomplaints specialist - customer servicecontact centre agent - customer servicecounter enquiries clerkcourtesy desk clerkcustomer information service clerk - insurancecustomer information service representative - retailcustomer relations clerkcustomer satisfaction representativecustomer service advisercustomer service agentcustomer service assistantcustomer service clerkcustomer service monitor - telephone systemcustomer service operator - telephone systemcustomer service representative - call centrecustomer service representative - insurancedepartment store information clerkenquiries clerkexpress and freight information clerkhospital information clerkhotel information clerk - contact centreinbound customer service representative - contact centreinformation clerk - customer serviceinvestigator, bill complaintskiosk information clerklost-and-found clerklost-and-found desk clerklost claims clerklost or damaged goods claim clerkmaintenance service clerkmerchandise exchange clerkorder clerk - customer servicesorder desk agentoutbound customer service representative - contact centreprice information clerkpublic relations clerkroad transport terminal attendantroute supply and return clerkservice adviserservice advisor - auto repairservice consultant - auto repairservice representative, business office - telecommunicationsservice writer - auto repairsupply and return clerktelephone enquiries clerktourist booth attendanttourist information clerktourist information office attendanttourist information officer",
    "workers": 41175,
    "minEduc": 0,
    "yearsStudy": 2.854098361,
    "automationRisk": 0.55,
    "salaryLow": 14,
    "salaryMed": 18,
    "salaryHigh": 28.33,
    "totalSkill": 134,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 18,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 1505,
    "f2Engineering": 2085,
    "f3Humanities": 1375,
    "f4SocialScience": 4000,
    "f5FineArts": 2370,
    "f6MathAndComputerScience": 2700,
    "f7Arts&Education": 4280,
    "f8Education(teachertraining)": 960,
    "f9Law": 2190,
    "f10Health": 1160,
    "f11Health,Nursing&ClinicalLaboratory": 3280,
    "f12Business": 15270,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 430,
    "d2Forestry": 65,
    "d3Architecture&LandscapeArchitecture": 40,
    "d4Humanities": 1310,
    "d5SocialSciences": 4000,
    "d6Fine&AppliedArts": 2370,
    "d7ComputerScience": 2585,
    "d8OtherArts&Science": 4280,
    "d9Education(teachertraining)": 960,
    "d10Engineering": 2045,
    "d11Law": 2190,
    "d12Mathematics": 115,
    "d13Kinesiology/Recreation/PhysicalEducation": 390,
    "d14Theology": 65,
    "d15PhysicalSciences": 1010,
    "d16Therapy&Rehabilitation": 770,
    "d17Health,Nursing&ClinicalLaboratory": 3280,
    "d18Business&Commerce": 15270,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 307,
    "noc": 6561,
    "job": "Image, social and other personal consultants",
    "title1": "adviser, weight loss",
    "title2": "colour analyst, fashion",
    "title3": "colour consultant, fashion",
    "allTitles": "adviser, weight losscolour analyst, fashioncolour consultant, fashionconsultant, corporate imageconsultant, etiquetteconsultant, fashionconsultant, fashion and wardrobeconsultant, fashion coloursconsultant, imageconsultant, make-upconsultant, personal imageconsultant, personal improvementconsultant, personal wardrobeconsultant, professional imageconsultant, public speakingconsultant, wardrobeconsultant, wedding servicesconsultant, weight losscorporate image consultantcounsellor, personal imageetiquette consultantfashion and wardrobe consultantfashion colour analystfashion colour consultantfashion consultantimage consultantimage co-ordinatormake-up consultantpersonal image consultantpersonal image counsellorpersonal improvement consultantpersonal style co-ordinatorpersonal wardrobe consultantprofessional image consultantpublic image consultant - personal consultantspublic speaking consultantsocial consultantwardrobe consultantwedding consultantwedding services consultantweight loss adviserweight loss consultant",
    "workers": 50,
    "minEduc": 0,
    "yearsStudy": 3,
    "automationRisk": 0.424,
    "salaryLow": 14,
    "salaryMed": 17.81,
    "salaryHigh": 46.36,
    "totalSkill": 140,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 17.81,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 50,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 50,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 308,
    "noc": 6562,
    "job": "Estheticians, electrologists and related occupations",
    "title1": "artist, tattoo",
    "title2": "beautician",
    "title3": "beauty care specialist",
    "allTitles": "artist, tattoobeauticianbeauty care specialistbeauty culture operatorbeauty culturistbeauty treatment operatorbody piercerconsultant, hair replacementcosmeticiancosmetologistdepilatordepilator, waxdermal therapistelectrologistelectrolysis operatorelectrolysis technicianestheticianfacial treatment operatorhair removal specialisthair replacement consultanthair replacement technicianhair weaverhenna tattoo artistmanicuristmehndi tattoo artistnail care techniciannails and lashes applicatoroperator, beauty cultureoperator, beauty treatmentoperator, electrolysisoperator, facial treatmentpedicuristregistered dermal therapistscalp treatment specialistskin care consultantskin care specialistskin care technicianspecialist, beauty carespecialist, hair removalspecialist, scalp treatmentspecialist, wax depilationtattoo artisttattooertattooisttechnician, electrolysistechnician, hair replacementtechnician, thermology and electrolysisthermology and electrolysis techniciantrichologistwax depilation specialistwax depilator",
    "workers": 8810,
    "minEduc": 0,
    "yearsStudy": 2.169014085,
    "automationRisk": 0.424,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 22.5,
    "totalSkill": 138,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 14,
    "skillsComp": 37,
    "skillsLogi": 35,
    "skillsMath": 19,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 155,
    "f4SocialScience": 70,
    "f5FineArts": 305,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 7065,
    "f8Education(teachertraining)": 0,
    "f9Law": 150,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 445,
    "f12Business": 620,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 155,
    "d5SocialSciences": 70,
    "d6Fine&AppliedArts": 305,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 7065,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 150,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 445,
    "d18Business&Commerce": 620,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 309,
    "noc": 6563,
    "job": "Pet groomers and animal care workers",
    "title1": "animal attendant",
    "title2": "animal attendant, laboratory",
    "title3": "animal attendants supervisor",
    "allTitles": "animal attendantanimal attendant, laboratoryanimal attendants supervisoranimal attendant, zooanimal care worker (except farm)animal groomer (except horses)animal health care assistantanimal trainer (except horses or marine mammals)aquaristattendant, animalattendant, pet shopattendant, veterinarycertified dog masterdog groomerdog handlerdog masterdog master trainerdog trainergroomer, petsgroom - horse race trackhorse hot-walkerhot-walker, horseskennel attendantkennel keeperkennelmankennelman/womankennelwomanlaboratory animal attendantlaboratory animal care workermaster groomer, petspet groomerpet master groomerpet shop attendantpet-sitterpound animal attendantpound attendantreceiving barn custodiansupervisor, animal attendantsveterinary attendantveterinary helperzoo animal attendantzoo attendant",
    "workers": 1210,
    "minEduc": 0,
    "yearsStudy": 1.962962963,
    "automationRisk": 0.46,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 25,
    "totalSkill": 135,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 530,
    "f2Engineering": 0,
    "f3Humanities": 45,
    "f4SocialScience": 15,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 265,
    "f8Education(teachertraining)": 0,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 310,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 530,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 45,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 265,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 310,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 310,
    "noc": 6564,
    "job": "Other personal service occupations",
    "title1": "astrologer astrologist card reader chat line agent clairvoyant consultant, dating agency consultant, dating service crystal ball reader dating agency consultant dating service consultant escort feng shui practitioner fortune teller massager masseur/masseuse medium mental telepathist numerologist palm reader phone agent, personal services phrenologist psychic psychic consultant psychic reader Reiki master tarot card reader tea leaf reader telepath telephone agent, personal services",
    "title2": 0,
    "title3": 0,
    "allTitles": "astrologer astrologist card reader chat line agent clairvoyant consultant, dating agency consultant, dating service crystal ball reader dating agency consultant dating service consultant escort feng shui practitioner fortune teller massager masseur/masseuse medium mental telepathist numerologist palm reader phone agent, personal services phrenologist psychic psychic consultant psychic reader Reiki master tarot card reader tea leaf reader telepath telephone agent, personal services",
    "workers": 3356.666667,
    "minEduc": 0,
    "yearsStudy": 2.377325683,
    "automationRisk": 0.436,
    "salaryLow": 14,
    "salaryMed": 15.27,
    "salaryHigh": 31.28666667,
    "totalSkill": 137.6666667,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service representatives and other customer and personal services occupations",
    "cluster": 9,
    "wage": 14.60333333,
    "skillsComp": 37.33333333,
    "skillsLogi": 34.66666667,
    "skillsMath": 19.33333333,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6.333333333,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.333333333,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 18.66666667,
    "s11SchedulingorBudgetingandAccounting": 5.666666667,
    "s12DigitalTechnology": 15.66666667,
    "s13DocumentUse": 17,
    "s14Writing": 12.66666667,
    "s15CriticalThinking": 6.666666667,
    "f1Science&Agriculture": 176.6666667,
    "f2Engineering": 0,
    "f3Humanities": 66.66666667,
    "f4SocialScience": 28.33333333,
    "f5FineArts": 123.3333333,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 2443.333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 55,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 251.6666667,
    "f12Business": 211.6666667,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 176.6666667,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 66.66666667,
    "d5SocialSciences": 28.33333333,
    "d6Fine&AppliedArts": 123.3333333,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 2443.333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 251.6666667,
    "d18Business&Commerce": 211.6666667,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 311,
    "noc": 6611,
    "job": "Cashiers",
    "title1": "box office cashier",
    "title2": "cafeteria cashier",
    "title3": "car park cashier",
    "allTitles": "box office cashiercafeteria cashiercar park cashiercashiercashier, casinocashier, currency exchangecashier, customer servicecashier, hotelcashier, supermarketcashier-wrappercasino cashierconvenience store cashiercorner store cashiercurrency exchange cashiercustomer service cashierdining room cashierfood store cashierfront desk cashiergas bar attendant, self-servegas bar cashier, self-servegrocery store cashiergroceteria cashierhotel cashiermoney countermovie theatre cashieroffice cashierparking lot cashierracetrack cashierrestaurant cashierself-serve gas bar attendantself-serve gas bar cashiersupermarket cashiertheatre cashierticket seller - cashier",
    "workers": 29715,
    "minEduc": 1,
    "yearsStudy": 2.744421907,
    "automationRisk": 0.97,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 14.5,
    "totalSkill": 91,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales support occupations",
    "cluster": 9,
    "wage": 11.6,
    "skillsComp": 23,
    "skillsLogi": 23,
    "skillsMath": 8,
    "skillsLang": 37,
    "topSkill1": "Oral Communication",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 4,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 1,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 7,
    "s10Reading": 13,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 8,
    "s14Writing": 4,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 805,
    "f2Engineering": 450,
    "f3Humanities": 1690,
    "f4SocialScience": 2120,
    "f5FineArts": 2050,
    "f6MathAndComputerScience": 730,
    "f7Arts&Education": 4475,
    "f8Education(teachertraining)": 1310,
    "f9Law": 1180,
    "f10Health": 1065,
    "f11Health,Nursing&ClinicalLaboratory": 5150,
    "f12Business": 8690,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 385,
    "d2Forestry": 120,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 1635,
    "d5SocialSciences": 2120,
    "d6Fine&AppliedArts": 2050,
    "d7ComputerScience": 580,
    "d8OtherArts&Science": 4475,
    "d9Education(teachertraining)": 1310,
    "d10Engineering": 450,
    "d11Law": 1180,
    "d12Mathematics": 150,
    "d13Kinesiology/Recreation/PhysicalEducation": 195,
    "d14Theology": 55,
    "d15PhysicalSciences": 300,
    "d16Therapy&Rehabilitation": 870,
    "d17Health,Nursing&ClinicalLaboratory": 5150,
    "d18Business&Commerce": 8690,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 312,
    "noc": 6621,
    "job": "Service station attendants",
    "title1": "apprentice service station attendant",
    "title2": "attendant, gas bar (except self-service)",
    "title3": "attendant, marina",
    "allTitles": "apprentice service station attendantattendant, gas bar (except self-service)attendant, marinaattendant, service stationbus refuelerfilling station attendantgas bar attendant (except self-service)gas jockeygas station attendant (except self-serve)marina attendantmarina workerpropane gas attendantpropane gas pump attendantpropane refuelerpropane tank attendantpump attendant - service stationpump operator - service stationservice attendant - gas stationservice station attendantservice station attendant apprentice",
    "workers": 165,
    "minEduc": 1,
    "yearsStudy": 2.571428571,
    "automationRisk": 0.91,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 24.1,
    "totalSkill": 35,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales support occupations",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 6,
    "skillsLogi": 11,
    "skillsMath": 4,
    "skillsLang": 14,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 4,
    "s3FindingInformation": 1,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 0,
    "s8OralCommunication": 5,
    "s9ProblemSolving": 3,
    "s10Reading": 6,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 1,
    "s13DocumentUse": 5,
    "s14Writing": 3,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 50,
    "f3Humanities": 10,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 10,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 313,
    "noc": 6622,
    "job": "Store shelf stockers, clerks and order fillers",
    "title1": "bag boy",
    "title2": "bag boy/girl",
    "title3": "bag clerk",
    "allTitles": "bag boybag boy/girlbag clerkbag girlbakery assistant - food storebox boybox boy/girlbox girlclerk, supermarketfloor clerk - retailfloor clerk - supermarketgarment price markergrocery clerkgrocery packerhand packer - food storemeat cutter helper - supermarketmeat department assistant - supermarketmeat wrapper - grocery storeorder filler - retailorder pickerpack boypack boy/girlpack girlprice checker - grocery storeprice clerk - retailprice marker - supermarketproduce clerkproduce clerk, supermarketretail shelf stockershelf stocker - retailshelf stocker - supermarketstock clerk - retailstock handler - food storestockroom clerk - retailsupermarket clerksupermarket produce clerk",
    "workers": 9655,
    "minEduc": 1,
    "yearsStudy": 2.473895582,
    "automationRisk": 0.64,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 17.94,
    "totalSkill": 31,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales support occupations",
    "cluster": 9,
    "wage": 11.65,
    "skillsComp": 6,
    "skillsLogi": 10,
    "skillsMath": 5,
    "skillsLang": 10,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 3,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 1,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 4,
    "s9ProblemSolving": 2,
    "s10Reading": 5,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 3,
    "s14Writing": 1,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 300,
    "f2Engineering": 660,
    "f3Humanities": 305,
    "f4SocialScience": 350,
    "f5FineArts": 760,
    "f6MathAndComputerScience": 390,
    "f7Arts&Education": 2045,
    "f8Education(teachertraining)": 100,
    "f9Law": 665,
    "f10Health": 230,
    "f11Health,Nursing&ClinicalLaboratory": 910,
    "f12Business": 2940,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 85,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 305,
    "d5SocialSciences": 350,
    "d6Fine&AppliedArts": 760,
    "d7ComputerScience": 390,
    "d8OtherArts&Science": 2045,
    "d9Education(teachertraining)": 100,
    "d10Engineering": 640,
    "d11Law": 665,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 115,
    "d14Theology": 0,
    "d15PhysicalSciences": 215,
    "d16Therapy&Rehabilitation": 115,
    "d17Health,Nursing&ClinicalLaboratory": 910,
    "d18Business&Commerce": 2940,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 314,
    "noc": 6623,
    "job": "Other sales related occupations",
    "title1": "beauty products consultant - door-to-door sales",
    "title2": "beauty products representative - home sales",
    "title3": "canvasser - retail",
    "allTitles": "beauty products consultant - door-to-door salesbeauty products representative - home salescanvasser - retailcanvassing agentcatalogue agent - retailcatalogue sales agent - retailcigarette vendorcleaning products salesman - door-to-door salescleaning products salesperson - door-to-door salescleaning products saleswoman - door-to-door salescomparison shoppercosmetics demonstrator - retailcosmetics salesman - home salescosmetics salesperson - home salescosmetics saleswoman - home salesdemonstrator - retaildirect distributor - retaildirect sellerdoor-to-door salespersonfood demonstrator - retailhome demonstrator - retailhome salespersonmagazine distribution agent - retailmagazine subscription solicitornewspaper vendornewspaper vendor - street salespersonal shopperpromotions demonstatorstreet vendorsubscription agent - retailsubscription solicitortelemarketertelephone sales agenttelephone sales clerktelephone salespersontelephone solicitorvendor",
    "workers": 3610,
    "minEduc": 1,
    "yearsStudy": 2.803278689,
    "automationRisk": 0.853,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 16.03,
    "totalSkill": 67,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales support occupations",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 17,
    "skillsLogi": 19,
    "skillsMath": 11,
    "skillsLang": 20,
    "topSkill1": "Document Use",
    "topSkill2": "Writing",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 5,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 5,
    "s9ProblemSolving": 4,
    "s10Reading": 7,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 9,
    "s14Writing": 8,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 35,
    "f2Engineering": 85,
    "f3Humanities": 110,
    "f4SocialScience": 410,
    "f5FineArts": 95,
    "f6MathAndComputerScience": 55,
    "f7Arts&Education": 500,
    "f8Education(teachertraining)": 165,
    "f9Law": 215,
    "f10Health": 45,
    "f11Health,Nursing&ClinicalLaboratory": 365,
    "f12Business": 1530,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 110,
    "d5SocialSciences": 410,
    "d6Fine&AppliedArts": 95,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 500,
    "d9Education(teachertraining)": 165,
    "d10Engineering": 85,
    "d11Law": 215,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 25,
    "d17Health,Nursing&ClinicalLaboratory": 365,
    "d18Business&Commerce": 1530,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 315,
    "noc": 6711,
    "job": "Food counter attendants, kitchen helpers and related support occupations",
    "title1": "airline food assembler",
    "title2": "attendant, cafeteria-buffet",
    "title3": "attendant, food service counter",
    "allTitles": "airline food assemblerattendant, cafeteria-buffetattendant, food service counterattendant, take-out - fast foodbar helperbaristabartender helperbus boybus boy/girlbus girlcafeteria-buffet attendantcafeteria counter attendantcafeteria helpercafeteria workercamp cook's helpercamp lunchroom attendantcaterer helpercook's helpercook's helper, campcook's helper, logging campcounter attendant, cafeteriacounter attendant - food servicecounter attendant, lunchroomcounter attendant, restaurantcounterperson - food servicesdessert makerdessert preparerdietary aidedining room assistantdining room attendantdishwasherdishwashing machine attendantdonut shop attendantdonut shop clerkdonut shop counter clerkdoughnut shop attendantdoughnut shop clerkdoughnut shop counter clerkdrive-in food service attendantexpediter - food servicesfast-food preparerfast-food service attendantfish and chips preparerfood and beverage service runner assistantfood assembler - fast foodfood concession workerfood counter attendantfood preparerfood runnerfood service attendantfood service counter attendantfood service helperfood service workerhelper, barhospital meal attendanthospital tray carrierhot dog vendorice cream counter attendantice cream vendorkitchen helperlogging camp cook's helperlunchroom counter attendantlunchroom countermanlunchroom counterman/womanlunchroom counterwomanmeal attendant, hospitalpopcorn vendorpot washerrestaurant counter attendantsalad and sandwich makersalad bar attendantsalad makersandwich artistsandwich makersandwich, salad and dessert makersilverware cleanersnack bar attendantsteam table attendant - food servicesstreet food vendorsushi preparertake-out attendant - fast foodtray carrier attendant, hospitaltray carrier, hospital",
    "workers": 30610,
    "minEduc": 0,
    "yearsStudy": 2.799180328,
    "automationRisk": 0.915,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 15.5,
    "totalSkill": 116,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 11.6,
    "skillsComp": 32,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 1050,
    "f2Engineering": 590,
    "f3Humanities": 1925,
    "f4SocialScience": 1890,
    "f5FineArts": 2025,
    "f6MathAndComputerScience": 700,
    "f7Arts&Education": 6810,
    "f8Education(teachertraining)": 1100,
    "f9Law": 1160,
    "f10Health": 710,
    "f11Health,Nursing&ClinicalLaboratory": 5290,
    "f12Business": 7360,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 420,
    "d2Forestry": 65,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 1830,
    "d5SocialSciences": 1890,
    "d6Fine&AppliedArts": 2025,
    "d7ComputerScience": 645,
    "d8OtherArts&Science": 6810,
    "d9Education(teachertraining)": 1100,
    "d10Engineering": 570,
    "d11Law": 1160,
    "d12Mathematics": 55,
    "d13Kinesiology/Recreation/PhysicalEducation": 215,
    "d14Theology": 95,
    "d15PhysicalSciences": 565,
    "d16Therapy&Rehabilitation": 495,
    "d17Health,Nursing&ClinicalLaboratory": 5290,
    "d18Business&Commerce": 7360,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 316,
    "noc": 6721,
    "job": "Support occupations in accommodation, travel and facilities set-up services",
    "title1": "attendant, hotel guest services",
    "title2": "attendant, sleeping car",
    "title3": "audiovisual helper",
    "allTitles": "attendant, hotel guest servicesattendant, sleeping caraudiovisual helperbaggage handlerbaggage masterbaggage porterbanquet porterbellhopcar supplier - railwaycruise line passenger attendantdisplay installerdoorkeeper, hoteldoor person - hotelfacilities porterguest services attendant, hotelhotel doorkeeperhotel guest services attendantlobby porterluggage attendantpassenger attendant, cruise linepassenger attendant, shippassenger service attendant - railwayporter, baggageporter, facilitiesporter, sleeping carport redcapredcapredcap, portroom flipperroom portership passenger attendantshowcase installersleeping car portertrain service attendant",
    "workers": 50,
    "minEduc": 0,
    "yearsStudy": 3,
    "automationRisk": 0.847,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 33.65,
    "totalSkill": 121,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 17,
    "skillsComp": 33,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 317,
    "noc": 6722,
    "job": "Operators and attendants in amusement, recreation and sport",
    "title1": "amusement attraction operator",
    "title2": "amusement concession operator",
    "title3": "amusement park attendant",
    "allTitles": "amusement attraction operatoramusement concession operatoramusement park attendantamusement ride attendantamusement ride operatorarena ice patrollerartificial ice maker - rinkathletic equipment attendantathletic equipment custodianattendance checkerattendant, amusement parkattendant, amusement rideattendant, athletic equipmentattendant, bicycle rentalattendant, billiard parlourattendant, bingo hallattendant, boat rentalattendant, bowling alleyattendant, bungee jumpattendant, campgroundattendant, clubhouseattendant, drive-in theatreattendant, driving rangeattendant, go-kart rideattendant, go-kart trackattendant, golf rangeattendant, ice rinkattendant, J-barattendant, leisureattendant, leisure and sportsattendant, leisure facilityattendant, mini-golfattendant, parkattendant, pool parlourattendant, recreationattendant, recreational campattendant, recreational facilityattendant, recreation and sportsattendant, recreation parkattendant, rideattendant, rinkattendant, rope towattendant, ski liftattendant, ski towattendant, snowmaking facilityattendant, sportattendant, sports and leisureattendant, sports and recreationattendant, sports centreattendant, sports equipmentattendant, sports facilityattendant, T-barattendant, tennis courtattendant, tourist campattendant, trailer campsiteattendant, trailer parkattendant, waterslideballracker, billiardsbicycle rental attendantbilliard parlour attendantbilliards ballrackerbingo callerbingo floor attendantbingo floormanbingo floorman/womanbingo floorwomanbingo hall attendantboat rental attendantbowling alley attendantbowling pinsetterboxing secondbungee jump attendantcable car operatorcaddiecaller, bingocampground attendantcampground gate attendantcampground workercarousel operatorchecker, attendanceclubhouse attendantcustodian, athletic equipmentcustodian, jockey roomcustodian, sports equipmentdrive-in theatre attendantdriver, zambonidriving range attendantferris wheel operatorfloor attendant, bingofloorman, bingofloorman/woman, bingofloorwoman, bingofun house operatorgame booth operatorgame concession operatorgate attendant, campgroundgo-kart ride attendantgo-kart track attendantgolf course rangergolf course starter",
    "workers": 1475,
    "minEduc": 0,
    "yearsStudy": 2.517857143,
    "automationRisk": 0.72,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 19,
    "totalSkill": 124,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 12,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 160,
    "f2Engineering": 15,
    "f3Humanities": 60,
    "f4SocialScience": 90,
    "f5FineArts": 25,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 210,
    "f8Education(teachertraining)": 65,
    "f9Law": 70,
    "f10Health": 325,
    "f11Health,Nursing&ClinicalLaboratory": 60,
    "f12Business": 375,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 60,
    "d5SocialSciences": 90,
    "d6Fine&AppliedArts": 25,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 210,
    "d9Education(teachertraining)": 65,
    "d10Engineering": 15,
    "d11Law": 70,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 325,
    "d14Theology": 0,
    "d15PhysicalSciences": 140,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 60,
    "d18Business&Commerce": 375,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 318,
    "noc": 6731,
    "job": "Light duty cleaners",
    "title1": "airport cleaner",
    "title2": "building cleaner",
    "title3": "chambermaid",
    "allTitles": "airport cleanerbuilding cleanerchambermaidcharworkercleanercleaner, hospitalcleaner, light dutycleaner, lodgecleaner, rest roomscleaner, roomscleaning ladycleaning mancleaning man/womancleaning womanclean-up crew workerdomestic maid - cleaning servicesfloor cleanerfloor sweeperguest home cleanerhall cleanerhome cleanerhomemaker helper, rest homehospital cleanerhotel cleanerhouse cleanerhousekeeping aidehousekeeping attendanthousekeeping room attendanthousemaid - cleaning serviceshousemanhouseman/womanhousewomanlight duty cleanerlodge cleanerlodging-establishment cleaner (except private households)maid - cleaning servicesmotel cleanernursing home cleaneroffice building cleaneroffice cleanerresidence cleanerresidential boarding-home cleanerrest home cleanerrest room attendantrest room cleanerroom attendantroom cleanerstudent residence cleanersweepertourist camp cleanerwall washerwashroom cleaner",
    "workers": 18660,
    "minEduc": 0,
    "yearsStudy": 2.382681564,
    "automationRisk": 0.69,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 20,
    "totalSkill": 126,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 14,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 615,
    "f2Engineering": 830,
    "f3Humanities": 845,
    "f4SocialScience": 435,
    "f5FineArts": 725,
    "f6MathAndComputerScience": 365,
    "f7Arts&Education": 3710,
    "f8Education(teachertraining)": 925,
    "f9Law": 425,
    "f10Health": 330,
    "f11Health,Nursing&ClinicalLaboratory": 4150,
    "f12Business": 5305,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 165,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 50,
    "d4Humanities": 845,
    "d5SocialSciences": 435,
    "d6Fine&AppliedArts": 725,
    "d7ComputerScience": 350,
    "d8OtherArts&Science": 3710,
    "d9Education(teachertraining)": 925,
    "d10Engineering": 780,
    "d11Law": 425,
    "d12Mathematics": 15,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 450,
    "d16Therapy&Rehabilitation": 330,
    "d17Health,Nursing&ClinicalLaboratory": 4150,
    "d18Business&Commerce": 5305,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 319,
    "noc": 6732,
    "job": "Specialized cleaners",
    "title1": "acid tank cleaner",
    "title2": "air duct cleaner",
    "title3": "air duct cleaning technician",
    "allTitles": "acid tank cleanerair duct cleanerair duct cleaning technicianauto care workerauto detailerautomobile cleanerboiler cleanerbuilding exterior cleanerbuilding sanderbus cleanerbus washercar care workercar detailercarpet cleanercar scrubbercar wash attendantcar washercesspool cleanerchimney cleanerchimney sweepcleaner and repairer, venetian blindscleaner and repairman, venetian blindscleaner and repairwoman, venetian blindscleaner, building exteriorscleaner, carpetscleaner, chimneyscleaner, drain-rotocleaner, fireplacescleaner, freight carscleaner, furnacecleaner, laboratory equipmentcleaner, rugscleaner, septic tankcleaner, swimming poolcleaner, tankcleaner, vehiclecleaner, ventilation systemcleaner, windowdetailer, autodetailer, cardrain-roto cleanerfireplace cleanerfreight car cleanerfurnace cleanerglass cleanerlaboratory equipment cleanerlaboratory facilities cleanerlot porter - auto cleaningrailway car cleanerrock or brick sandblasterrug cleanersandblastersandblasting building cleanerseptic tank cleanerspecialized cleanerspecialized cleaner - automobile aestheticssteamblastersteamblasting building cleanersteam cleanerstreetcar cleanersubway car cleanerswimming pool cleanertank car cleanertank cleanertransportation vehicle scrubbertruck washerupholstery cleanervat washervehicle cleanervenetian blinds cleaner and repairervenetian blinds cleaner and repairmanvenetian blinds cleaner and repairwomanventilation system cleanerwindow cleanerwindow washer",
    "workers": 905,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.37,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 26,
    "totalSkill": 139,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 11.6,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 255,
    "f2Engineering": 160,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 215,
    "f8Education(teachertraining)": 20,
    "f9Law": 65,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 85,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 215,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 130,
    "d11Law": 65,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 255,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 85,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 320,
    "noc": 6733,
    "job": "Janitors, caretakers and building superintendents",
    "title1": "airport janitor",
    "title2": "airport maintenance worker",
    "title3": "apartment building caretaker",
    "allTitles": "airport janitorairport maintenance workerapartment building caretakerapartment building conciergeapartment building maintenance workerapartment maintenance manapartment maintenance man/womanapartment maintenance womanbuilding caretakerbuilding custodianbuilding handymanbuilding handyman/womanbuilding handywomanbuilding maintenance manbuilding maintenance man/womanbuilding maintenance womanbuilding maintenance workerbuilding operator - maintenancebuilding services workerbuilding superintendentcampground cleanercaretaker, buildingchurch caretakercleaner, heavy dutycleaner, industrial plantcleaner, plantconcierge, apartment buildingconcierge, office buildingconstruction campsite attendantcustodiancustodian, buildingfactory cleanerfactory maintenance manfactory maintenance man/womanfactory maintenance womanhandymanhandyman/womanhandywomanheavy-duty cleanerindustrial cleanerindustrial plant cleanerjanitorlive-in superintendantmaintenance man, buildingsmaintenance man/woman, buildingsmaintenance woman, buildingsmaintenance worker, buildingoffice building conciergeplant cleanerplant maintenance workerschool custodianschool janitorsuperintendant, live-insuperintendent, building",
    "workers": 22905,
    "minEduc": 0,
    "yearsStudy": 2.216517857,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 17.44,
    "salaryHigh": 25.75,
    "totalSkill": 129,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 17.44,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 4055,
    "f2Engineering": 3840,
    "f3Humanities": 255,
    "f4SocialScience": 410,
    "f5FineArts": 600,
    "f6MathAndComputerScience": 570,
    "f7Arts&Education": 6910,
    "f8Education(teachertraining)": 380,
    "f9Law": 610,
    "f10Health": 430,
    "f11Health,Nursing&ClinicalLaboratory": 1095,
    "f12Business": 3750,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 420,
    "d2Forestry": 270,
    "d3Architecture&LandscapeArchitecture": 145,
    "d4Humanities": 225,
    "d5SocialSciences": 410,
    "d6Fine&AppliedArts": 600,
    "d7ComputerScience": 570,
    "d8OtherArts&Science": 6910,
    "d9Education(teachertraining)": 380,
    "d10Engineering": 3695,
    "d11Law": 610,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 290,
    "d14Theology": 30,
    "d15PhysicalSciences": 3365,
    "d16Therapy&Rehabilitation": 140,
    "d17Health,Nursing&ClinicalLaboratory": 1095,
    "d18Business&Commerce": 3750,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 321,
    "noc": 6741,
    "job": "Dry cleaning, laundry and related occupations",
    "title1": "apprentice dry cleaner",
    "title2": "assembler, laundry and dry cleaning",
    "title3": "attendant, laundry",
    "allTitles": "apprentice dry cleanerassembler, laundry and dry cleaningattendant, laundrybagger, laundry and dry cleaningblocker - laundry and dry cleaningchecker - laundry and dry cleaningcleaner and presser - laundry and dry cleaningcleaner - laundry and dry cleaningcleaning machine operator - laundry and dry cleaningclothes presser - laundry and dry cleaningclothing ironer - laundry and dry cleaningcurtain and drapery presser - laundry and dry cleaningdrapery cleanerdrapery cleaner - laundry and dry cleaningdry cleanerdry cleaner helperdry cleaning machine operator helperdry cleaning machine operator - laundry and dry cleaningdyer, laundry and dry cleaningextractor operator - laundry and dry cleaningfeather renovatorfinisher - laundry and dry cleaningflatwork finisher - laundry and dry cleaningflatwork folder - laundry and dry cleaningflatwork ironer - laundry and dry cleaningfluting machine operator - laundry and dry cleaningfolder - laundry and dry cleaningfolding machine tender - laundry and dry cleaningframer - laundry and dry cleaningfur cleanerfur cleaner - laundry and dry cleaningfur-drummer machine operator - laundry and dry cleaningfur glazer - laundry and dry cleaningfur ironer glazer - laundry and dry cleaningfur ironer - laundry and dry cleaningfur ironing machine operator - laundry and dry cleaningfur lining presser - laundry and dry cleaningfur lusterizer - laundry and dry cleaningfur steamergarment cleaner - laundry and dry cleaninggarment dyer - laundry and dry cleaninghand finisher - laundry and dry cleaninghand fur cleanerhand ironer - laundry and dry cleaninghand presser - laundry and dry cleaninghand washer - laundry and dry cleaninghat cleanerhatter, dry cleaninghelper, dry cleanerhelper, laundryinspector - laundry and dry cleaningironer glazer, furs - laundry and dry cleaningironer - laundry and dry cleaninglabourer, laundrylaundererlaundry attendantlaundry finisherlaundry helperlaundry labourerlaundry machine operatorlaundry workerleather cleanerleather cleaner - laundry and dry cleaningleather finisher - dry cleaningleather or suede sprayer - laundry and dry cleaningmachine fur cleanermachine operator, laundry and dry cleaningmachine presser - laundry and dry cleaningmachine washer - laundry and dry cleaningmarker - laundry and dry cleaningpackager - laundry and dry cleaningpatcher - laundry and dry cleaningpatching machine operator - laundry and dry cleaningpleat finisher - laundry and dry cleaningpleat presser - laundry and dry cleaningpresser - laundry and dry cleaningpressing machine tender - laundry and dry cleaningshirt finisher - laundry and dry cleaningshirt folder - laundry and dry cleaningshirt-folding machine operator - laundry and dry cleaningshirt presser - laundry and dry cleaningsilk finisher - laundry and dry cleaningspotter - laundry and dry cleaningsprayer, leather or suede - laundry and dry cleaningstain removersteam finisher - laundry and dry cleaningsteam presser - laundry and dry cleaningsteam press operator - laundry and dry cleaningsteam tunnel operator - laundry and dry cleaningstretcher dryer - laundry and dry cleaningsuede cleanersuede cleaner - laundry and dry cleaningtagger - laundry and dry cleaningtender, washing machine extractor - laundry and dry cleaningtumble dryer tender - laundry and dry cleaningvelvet steamer - laundry and dry cleaningwasher, hand - laundry and dry cleaningwasher, machine - laundry and dry cleaningwashing machine extractor operator - laundry and dry cleaningwashing machine operator - laundry and dry cleaning",
    "workers": 605,
    "minEduc": 0,
    "yearsStudy": 1.75,
    "automationRisk": 0.71,
    "salaryLow": 14,
    "salaryMed": 14.6,
    "salaryHigh": 18.97,
    "totalSkill": 126,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 14.6,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 15,
    "f3Humanities": 35,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 65,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 385,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 65,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 385,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 322,
    "noc": 6742,
    "job": "Other service support occupations, n.e.c.",
    "title1": "attendant, beauty salon",
    "title2": "attendant, car",
    "title3": "attendant, checkroom",
    "allTitles": "attendant, beauty salonattendant, carattendant, checkroomattendant, funeral homeattendant, fur storageattendant, garageattendant, laundromatattendant, locker roomattendant, parking lotattendant, sauna roomattendant, steam roomattendant, suntan salonattendant, suntan studioattendant, theatreattendant, toll boothattendant, turnstilebeauty salon attendantbeauty salon supplies attendantbutlercar attendantcar jockeycar lot attendantcar storage attendantcheckroom attendantcloakroom attendantcoat and hat checkercoin laundry attendantcrematorcrematorium attendantdomestic servantdoor attendant (except hotel)doorman (except hotel)doorman/woman (except hotel)doorwoman (except hotel)elevator operatorfare box collectorfreight elevator operatorfuneral home attendantfur storage attendantfur vault custodiangallery attendantgarage attendantgarage jockeyhat check attendanthotel valethousesitterjockey, carjockey, garagelaundromat attendantlocker room attendantmotor vehicle attendantmotor vehicle jockeymovie usheroperator, elevatorpallbearerparking lot attendantparking valetpersonal servantsauna room attendantservant, domesticshampooershoe shinersteam room attendantsuntan studio attendantsupplies attendant, beauty salontanning salon attendanttanning studio attendanttheatre attendanttheatre usherticket takerticket taker and ushertoll booth attendanttoll collectorturnstile attendantvaletvalet, parkingvault custodian, furs",
    "workers": 1240,
    "minEduc": 0,
    "yearsStudy": 2.434782609,
    "automationRisk": 0.658,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 20.96,
    "totalSkill": 127,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service support and other service occupations, n.e.c.",
    "cluster": 9,
    "wage": 13,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 90,
    "f2Engineering": 50,
    "f3Humanities": 25,
    "f4SocialScience": 60,
    "f5FineArts": 180,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 320,
    "f8Education(teachertraining)": 80,
    "f9Law": 50,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 70,
    "f12Business": 295,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 60,
    "d6Fine&AppliedArts": 180,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 320,
    "d9Education(teachertraining)": 80,
    "d10Engineering": 50,
    "d11Law": 50,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 90,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 70,
    "d18Business&Commerce": 295,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 323,
    "noc": 7201,
    "job": "Contractors and supervisors, machining, metal forming, shaping and erecting trades and related occupations",
    "title1": "automotive machine shop foreman",
    "title2": "automotive machine shop foreman/woman",
    "title3": "automotive machine shop forewoman",
    "allTitles": "automotive machine shop foremanautomotive machine shop foreman/womanautomotive machine shop forewomanblacksmith shop foremanblacksmith shop foreman/womanblacksmith shop forewomanboilermaking shop foremanboilermaking shop foreman/womanboilermaking shop forewomancontractor, construction ironworkcontractor, construction ironworkingcontractor, ironworkcontractor, metalwork forming, shaping and installingcontractor, sheet metalcontractor, sheet metal roofingcontractor, steel structure forming, shaping and erectingcontractor, structural steel erectingcontractor, weldingforeman, automotive machine shopforeman, blacksmithsforeman, blacksmith shopforeman, boilermakersforeman, boilermakers, platers, and structural metal workersforeman, boilermaking shopforeman, coppersmithsforeman, ironworkersforeman, machine shopforeman, machine shop inspectorsforeman, machine tool operatorsforeman, machiningforeman, machining and tooling inspectorsforeman, machining inspectorsforeman, machining tool operatorsforeman, machining toolsforeman, machinistsforeman, machinists and machine tool set-up operatorsforeman, maintenance machine shopforeman, metal fabricatorsforeman, metal fittersforeman, metal-machining inspectionforeman, metal mould and metal patternmakersforeman, metal shapersforeman, mould shop - machiningforeman, plate shopforeman, platework fabricatorsforeman, sheet metal workersforeman, steel fitters - metal fabricationforeman, steel frame erectorsforeman, steel riggersforeman, steel structure erectorsforeman, steel truss erectorsforeman, structural metal erectorsforeman, structural metal fabricatorsforeman, structural steel workersforeman, tool and die inspectorsforeman, tool and die makersforeman, tooling inspectorsforeman, weldersforeman/woman, automotive machine shopforeman/woman, blacksmithsforeman/woman, blacksmith shopforeman/woman, boilermakersforeman/woman, boilermakers, platers, and structural metal workersforeman/woman, boilermaking shopforeman/woman, coppersmithsforeman/woman, ironworkersforeman/woman, machine shopforeman/woman, machine shop inspectorsforeman/woman, machine tool operatorsforeman/woman, machiningforeman/woman, machining and tooling inspectorsforeman/woman, machining inspectorsforeman/woman, machining tool operatorsforeman/woman, machining toolsforeman/woman, machinistsforeman/woman, machinists and machine tool set-up operatorsforeman/woman, maintenance machine shopforeman/woman, metal fabricatorsforeman/woman, metal fittersforeman/woman, metal-machining inspectionforeman/woman, metal mould and metal patternmakersforeman/woman, metal shapersforeman/woman, mould shop - machiningforeman/woman, plate shopforeman/woman, platework fabricatorsforeman/woman, sheet metal workersforeman/woman, steel fitters - metal fabricationforeman/woman, steel frame erectorsforeman/woman, steel riggersforeman/woman, steel structure erectorsforeman/woman, steel truss erectorsforeman/woman, structural metal erectorsforeman/woman, structural metal fabricatorsforeman/woman, structural steel workersforeman/woman, tool and die inspectorsforeman/woman, tool and die makersforeman/woman, tooling inspectorsforeman/woman, weldersforeman/woman, zinc roofersforeman, zinc roofers",
    "workers": 2065,
    "minEduc": 0,
    "yearsStudy": 1.409090909,
    "automationRisk": 0.17,
    "salaryLow": 21.85,
    "salaryMed": 31,
    "salaryHigh": 45,
    "totalSkill": 157,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 31,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 205,
    "f2Engineering": 10,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1800,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 50,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1800,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 10,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 205,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 50,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 324,
    "noc": 7202,
    "job": "Contractors and supervisors, electrical trades and telecommunications occupations",
    "title1": "cable installation and repair foreman - telecommunications",
    "title2": "cable installation and repair foreman/woman - telecommunications",
    "title3": "cable installation and repair forewoman - telecommunications",
    "allTitles": "cable installation and repair foreman - telecommunicationscable installation and repair foreman/woman - telecommunicationscable installation and repair forewoman - telecommunicationscable installation contractorcable installation foremancable installation foreman/womancable installation forewomancable installation supervisorcable installers and repairers foreman - telecommunicationscable installers and repairers foreman/woman - telecommunicationscable installers and repairers forewoman - telecommunicationscable maintenance and repair supervisorcable splicers foreman - telecommunicationscable splicers foreman/woman - telecommunicationscable splicers forewoman - telecommunicationscable splicing foreman - telecommunicationscable splicing foreman/woman - telecommunicationscable splicing forewoman - telecommunicationscable television system installers and repairers foremancable television system installers and repairers foreman/womancable television system installers and repairers forewomancablevision technicians foremancablevision technicians foreman/womancablevision technicians forewomancable workers front line supervisorchief electriciancommunications foremancommunications foreman/womancommunications forewomanconstruction electricians and repairers foremanconstruction electricians and repairers foreman/womanconstruction electricians and repairers forewomanconstruction electricians foremanconstruction electricians foreman/womanconstruction electricians forewomanconstruction electricians supervisorcontractor, electrical installationcontractor, electrical systemscontractor, electrical wiring installationcontractor-electriciancontractor, telecommunicationselectrical appliances installation foremanelectrical appliances installation foreman/womanelectrical appliances installation forewomanelectrical construction contractorelectrical construction foremanelectrical construction foreman/womanelectrical construction forewomanelectrical contractorelectrical contractor, constructionelectrical equipment installation and repair foremanelectrical equipment installation and repair foreman/womanelectrical equipment installation and repair forewomanelectrical foremanelectrical foreman/womanelectrical forewomanelectrical power inspector and tester supervisorelectrical supervisor - drilling rigelectrical systems contractorelectrical wiring inspector supervisorelectrical wiring installation contractorelectrician-contractorelectrician foremanelectrician foreman/womanelectrician forewomanelectricians supervisorelectric meter installers foremanelectric meter installers foreman/womanelectric meter installers forewomanelectric meter installers supervisoremergency team foreman - telecommunicationsemergency team foreman/woman - telecommunicationsemergency team forewoman - telecommunicationsforeman, cable installationsforeman, cable splicers - telecommunicationsforeman, cable television system installers and repairersforeman, cablevision techniciansforeman, construction electriciansforeman, construction electricians and repair workersforeman, electrical appliances installationsforeman, electrical constructionforeman, electrical equipment installation and repairforeman, electriciansforeman, industrial electriciansforeman, installers and repairers - telecommunicationsforeman, line and cable installationforeman, line and cable installersforeman, line and cable repairers - power linesforeman, maintenance electriciansforeman, marine electriciansforeman, meter installers and repairersforeman, power line and cable workersforeman, power line repairersforeman, power line technicianforeman, power system electriciansforeman, signaling system installationforeman, telecommunication cable installationforeman, telecommunication installers and repairersforeman, telecommunication line installation, repair and testingforeman, telecommunication line installers",
    "workers": 2155,
    "minEduc": 0,
    "yearsStudy": 2.289473684,
    "automationRisk": 0.17,
    "salaryLow": 23.08,
    "salaryMed": 36.92,
    "salaryHigh": 47.79,
    "totalSkill": 159,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 36.92,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 15,
    "f2Engineering": 570,
    "f3Humanities": 0,
    "f4SocialScience": 40,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1405,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 105,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 40,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1405,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 570,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 105,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 325,
    "noc": 7203,
    "job": "Contractors and supervisors, pipefitting trades",
    "title1": "contractor, pipefitting",
    "title2": "contractor, plumbing",
    "title3": "foreman, fire protection equipment installers",
    "allTitles": "contractor, pipefittingcontractor, plumbingforeman, fire protection equipment installersforeman, gas fittersforeman, gas serviceforeman, marine pipefittersforeman, marine pipe fittersforeman, pipefittersforeman, plumbersforeman, sprinkler system installersforeman, steamfittersforeman/woman, fire protection equipment installersforeman/woman, gas fittersforeman/woman, gas serviceforeman/woman, marine pipefittersforeman/woman, marine pipe fittersforeman/woman, pipefittersforeman/woman, plumbersforeman/woman, sprinkler system installersforeman/woman, steamfittersforewoman, fire protection equipment installersforewoman, gas fittersforewoman, gas serviceforewoman, marine pipefittersforewoman, marine pipe fittersforewoman, pipefittersforewoman, plumbersforewoman, sprinkler system installersforewoman, steamfittersgas fitters foremangas fitters foreman/womangas fitters forewomangas fitters supervisorgas line fitters foremangas line fitters foreman/womangas line fitters forewomangas service foremangas service foreman/womangas service forewomangas service supervisormarine pipe fitters foremanmarine pipe fitters foreman/womanmarine pipe fitters forewomanpipefitters foremanpipefitters foreman/womanpipefitters forewomanpipefitters supervisorpipefitting contractorplumber foremanplumber foreman/womanplumber forewomanplumbers supervisorplumbing and heating contractorplumbing contractorsprinkler fitters foremansprinkler fitters foreman/womansprinkler fitters forewomansprinkler system contractorsprinkler system installer foremansprinkler system installer foreman/womansprinkler system installer forewomansprinkler system installers supervisorsprinkler systems contractorsteamfitter foremansteamfitter foreman/womansteamfitter forewomansteamfitters supervisorsupervisor, gas fitterssupervisor, gas servicesupervisor, pipe fitterssupervisor, plumberssupervisor, sprinkler system installerssupervisor, steamfitters",
    "workers": 835,
    "minEduc": 0,
    "yearsStudy": 1.363636364,
    "automationRisk": 0.17,
    "salaryLow": 21.4,
    "salaryMed": 47.99,
    "salaryHigh": 52.62,
    "totalSkill": 164,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 47.99,
    "skillsComp": 44,
    "skillsLogi": 41,
    "skillsMath": 23,
    "skillsLang": 56,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 17,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 835,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 835,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 326,
    "noc": 7204,
    "job": "Contractors and supervisors, carpentry trades",
    "title1": "cabinetmakers foreman",
    "title2": "cabinetmakers foreman/woman",
    "title3": "cabinetmakers forewoman",
    "allTitles": "cabinetmakers foremancabinetmakers foreman/womancabinetmakers forewomancabinetmaking contractorcarpenter-contractorcarpenters foremancarpenters foreman/womancarpenters forewomancarpenter supervisorcarpentry contractorcarpentry foremancarpentry foreman/womancarpentry forewomancarpentry supervisorconcrete form builders foreman - carpentryconcrete form builders foreman/woman - carpentryconcrete form builders forewoman - carpentrycontractor, cabinetmakingcontractor-carpentercontractor, carpentryfinish carpenters foremanfinish carpenters foreman/womanfinish carpenters forewomanfinish joiners foremanfinish joiners foreman/womanfinish joiners forewomanforeman, cabinetmakersforeman, carpentersforeman, carpentryforeman, concrete form builders - carpentryforeman, finish carpentersforeman, finish joinersforeman, form buildersforeman, framersforeman, general carpentersforeman, maintenance carpentersforeman, residential constructionforeman, ship joinersforeman, stair buildersforeman/woman, cabinetmakersforeman/woman, carpentersforeman/woman, carpentryforeman/woman, concrete form builders - carpentryforeman/woman, finish carpentersforeman/woman, finish joinersforeman/woman, form buildersforeman/woman, framersforeman/woman, general carpentersforeman/woman, maintenance carpentersforeman/woman, residential constructionforeman/woman, ship joinersforeman/woman, stair buildersforeman/woman, wood patternmakersforeman, wood patternmakersforewoman, cabinetmakersforewoman, carpentersforewoman, carpentryforewoman, concrete form builders - carpentryforewoman, finish carpentersforewoman, finish joinersforewoman, form buildersforewoman, framersforewoman, general carpentersforewoman, maintenance carpentersforewoman, residential constructionforewoman, ship joinersforewoman, stair buildersforewoman, wood patternmakersform builders foremanform builders foreman/womanform builders forewomanframers foremanframers foreman/womanframers forewomangeneral carpenters foremangeneral carpenters foreman/womangeneral carpenters forewomangeneral foreman - building constructiongeneral foreman, residential constructiongeneral foreman/woman - building constructiongeneral foreman/woman, residential constructiongeneral forewoman - building constructiongeneral forewoman, residential constructiongeneral supervisor - building constructiongeneral supervisor - residential constructionmaintenance carpenters foremanmaintenance carpenters foreman/womanmaintenance carpenters forewomanresidential construction foremanresidential construction foreman/womanresidential construction forewomanresidential construction supervisorship joiners foremanship joiners foreman/womanship joiners forewomanstair builders foremanstair builders foreman/womanstair builders forewomansupervisor, carpenterssupervisor, carpentry",
    "workers": 1230,
    "minEduc": 0,
    "yearsStudy": 1.3,
    "automationRisk": 0.17,
    "salaryLow": 20,
    "salaryMed": 30.77,
    "salaryHigh": 45,
    "totalSkill": 156,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 30.77,
    "skillsComp": 42,
    "skillsLogi": 39,
    "skillsMath": 22,
    "skillsLang": 53,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 60,
    "f2Engineering": 75,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1075,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1075,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 75,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 60,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 327,
    "noc": 7205,
    "job": "Contractors and supervisors, other construction trades, installers, repairers and servicers",
    "title1": "asphalt roofers foreman",
    "title2": "asphalt roofers foreman/woman",
    "title3": "asphalt roofers forewoman",
    "allTitles": "asphalt roofers foremanasphalt roofers foreman/womanasphalt roofers forewomanasphalt roofing contractorasphalt roofing foremanasphalt roofing foreman/womanasphalt roofing forewomanbicycle repair shop supervisorboiler and pipe insulation specialists foremanboiler and pipe insulation specialists foreman/womanboiler and pipe insulation specialists forewomanboiler and pipe insulators foremanboiler and pipe insulators foreman/womanboiler and pipe insulators forewomanbranch supervisor, pest controlbrick and stone masons foremanbrick and stone masons foreman/womanbrick and stone masons forewomanbricklayer-contractorbricklayer foremanbricklayer foreman/womanbricklayer forewomanbricklayer supervisorbricklaying and masonry contractorbricklaying contractorbrick masonry contractorbridge painters foremanbridge painters foreman/womanbridge painters forewomanbuilding insulation material installation foremanbuilding insulation material installation foreman/womanbuilding insulation material installation forewomanbuilding insulation specialists foremanbuilding insulation specialists foreman/womanbuilding insulation specialists forewomanbuilding insulators foremanbuilding insulators foreman/womanbuilding insulators forewomanbuilding maintenance supervisorcamera repair shop supervisorcement finisher foremancement finisher foreman/womancement finisher forewomancement finishing contractorcement smoother foremancement smoother foreman/womancement smoother forewomanconcrete and cement finishers foremanconcrete and cement finishers foreman/womanconcrete and cement finishers forewomanconcrete and cement finishing contractorconcrete finishers foremanconcrete finishers foreman/womanconcrete finishers forewomanconcrete finishing foremanconcrete finishing foreman/womanconcrete finishing forewomanconstruction painters foremanconstruction painters foreman/womanconstruction painters forewomanconstruction painters supervisorcontractor, asphalt roofingcontractor, bricklayingcontractor, bricklaying and masonrycontractor, cement finishingcontractor, concrete and cement finishingcontractor, decoratingcontractor, drywall applicationcontractor, drywallingcontractor, eavestrough installationcontractor, fencingcontractor-floor coverercontractor, floor coveringcontractor, glass installation and repaircontractor-glaziercontractor, glazingcontractor, hot water heater installationcontractor, insulatingcontractor, insulationcontractor, interlocking paving stonescontractor, marble and terrazzo settingcontractor, paintingcontractor, painting and wallpaperingcontractor, paperhangingcontractor-plasterercontractor, plasteringcontractor, plastering and drywall applicationcontractor, plastering and drywallingcontractor-polisher, terrazzocontractor-roofer (except metal roofs)contractor, roofingcontractor, roofing (except sheet metal roofs)contractor, septic systemscontractor, shingle roofingcontractor, sidingcontractor, stonemasonrycontractor, swimming pool installationcontractor, terrazzo finishingcontractor, tilesettingcontractor, tile, terrazzo and marble setting",
    "workers": 1900,
    "minEduc": 0,
    "yearsStudy": 1.641509434,
    "automationRisk": 0.17,
    "salaryLow": 17,
    "salaryMed": 35,
    "salaryHigh": 42,
    "totalSkill": 158,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 35,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 54,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 155,
    "f2Engineering": 180,
    "f3Humanities": 0,
    "f4SocialScience": 30,
    "f5FineArts": 35,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 1090,
    "f8Education(teachertraining)": 0,
    "f9Law": 115,
    "f10Health": 10,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 270,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 30,
    "d6Fine&AppliedArts": 35,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 1090,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 180,
    "d11Law": 115,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 10,
    "d14Theology": 0,
    "d15PhysicalSciences": 155,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 270,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 328,
    "noc": 7231,
    "job": "Machinists and machining and tooling inspectors",
    "title1": "aircraft engine parts machinist",
    "title2": "aircraft machinist",
    "title3": "apprentice automotive machinist",
    "allTitles": "aircraft engine parts machinistaircraft machinistapprentice automotive machinistapprentice machinistautomotive machinistauto parts machine shop inspectoraviation machinistbench machinistcharge hand, machine shopCNC (computer numerical control) machinistcomputer-assisted machinistcomputer numerical control (CNC) machinistdiesel engine machinistdifferential gear testing machinistelectrical machinistfirearms machining inspectorfirearms model maker machinistgear inspector-machinistgear tester-machinistgeneral machinistinspector, auto parts machine shopinspector, firearms machininginspector, machined partsinspector, machine shopinspector, machininginspector, machining and toolinginspector, propellers - machininginspector, tool and dieinspector, tool and gaugeinspector, toolinginspector, toolroomjourneyman machinistjourneyman/woman machinistjourneywoman machinistmachined parts inspectormachine shop charge handmachine shop inspectormachine shop inspector, auto partsmachining and tooling inspectormachining inspectormachining inspector, firearmsmachinistmachinist, aircraft engine partsmachinist apprenticemachinist, automotivemachinist, ballistic laboratorymachinist, benchmachinist, CNC (computer numerical control)machinist, diesel enginesmachinist, differential gear testingmachinist, experimentalmachinist, maintenancemachinist, model makermachinist, motion picture equipmentmachinist, mouldmakingmachinist, moulds and coresmachinist, precisionmachinist, toolroommaintenance machinistmaster machinistmould and core machinistmouldmaking machinistNC (numerically controlled) machinistprecision machinistprinting press machinistpropeller inspector - machiningprototype machinistset-up machinisttool and die inspectortool and gauge inspectortooling inspectortoolroom inspectortoolroom machinistturbine blade machinist",
    "workers": 9905,
    "minEduc": 2,
    "yearsStudy": 2.078125,
    "automationRisk": 0.65,
    "salaryLow": 18,
    "salaryMed": 22.73,
    "salaryHigh": 30,
    "totalSkill": 153,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 22.73,
    "skillsComp": 51,
    "skillsLogi": 37,
    "skillsMath": 23,
    "skillsLang": 42,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 17,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 21,
    "s13DocumentUse": 23,
    "s14Writing": 11,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 745,
    "f2Engineering": 1235,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 7855,
    "f8Education(teachertraining)": 15,
    "f9Law": 40,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 7855,
    "d9Education(teachertraining)": 15,
    "d10Engineering": 1235,
    "d11Law": 40,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 745,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 329,
    "noc": 7232,
    "job": "Tool and die makers",
    "title1": "aircraft jig and template maker",
    "title2": "aircraft jig and tool maker",
    "title3": "apprentice tool and die maker",
    "allTitles": "aircraft jig and template makeraircraft jig and tool makerapprentice tool and die makerbench die cutterbench die fitterbench die sinkerbench jig makerbench stamping die makerbench tool makercarbide tool makerdiamond saw makerdiamond tool makerdiecast diemakerdie cutterdie cutter, jewellerydie cutter - metalworkingdie finisherdie fitterdie makerdie maker - jewellerydie maker, wire-drawingdie mouldmakerdie reamerdie repairerdie repairmandie repairman/womandie repairwomandie sinkerdie sinker, benchdie sinker, jewellerydie sinker - metalworkingextrusion die template makerforging die finisherforging die makergauge maker - tool and dieinjection moulding tool and die makerinjection mouldmakerjewellery die sinkerjig and form makerjig and template maker, aircraftjig and tool maker, aircraftjig-bore tool makerjig makerjig maker - die casting and plastic mouldingjig maker - metal products manufacturingjourneyman tool and die makerjourneyman/woman tool and die makerjourneywoman tool and die makermetal mould finishermetal mould makermetal patternmakermetal patternmaker apprenticemodel maker - tool and diemotor vehicle jig buildermouldmaker - aircraftmould maker apprenticemouldmaker, metalmould maker, metalmould maker - plastics processingpatternmaker, metalpatternmaker, metal apprenticeprecision tool makerprogressive die fitterstamping die finisherstamping die maker, benchsteel-rule die makertemplate maker - tool and dietire mould repairertire mould repairmantire mould repairwomantool and die makertool and die maker apprenticetool and die maker, injection mouldstool and die preparertool and die repairertool and die repairmantool and die repairwomantool fittertool maintainertool maintenance mantool maintenance man/womantool maintenance womantoolmakertool maker, benchtool maker, jig boretool repairertool repairmantool repairman/womantool repairwomanwire-drawing die maker",
    "workers": 6790,
    "minEduc": 2,
    "yearsStudy": 1.967741935,
    "automationRisk": 0.84,
    "salaryLow": 14,
    "salaryMed": 27.35,
    "salaryHigh": 49.5,
    "totalSkill": 134,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 27.35,
    "skillsComp": 37,
    "skillsLogi": 31,
    "skillsMath": 28,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Measurement and Calculation",
    "topSkill3": "Reading",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 0,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 19,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 7,
    "s13DocumentUse": 24,
    "s14Writing": 7,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 40,
    "f2Engineering": 320,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 6430,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 6430,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 320,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 40,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 330,
    "noc": 7233,
    "job": "Sheet metal workers",
    "title1": "aircraft layout man sheet metal",
    "title2": "aircraft layout man/woman sheet metal",
    "title3": "aircraft layout woman sheet metal",
    "allTitles": "aircraft layout man sheet metalaircraft layout man/woman sheet metalaircraft layout woman sheet metalapprentice sheet metal workerapprentice tinsmithbench hand, sheet metal mechanicconstruction sheet metal workercoppersmithcustom sheet metal fabricatorfitter - sheet metal workingindustrial sheet metal workerjourneyman sheet metal workerjourneyman/woman sheet metal workerjourneywoman sheet metal workerlayer-out, sheet metalmaintenance sheet metal workermetal furniture model makermetal furniture patternmakermodel maker, sheet metalplant tinsmithprecision sheet metal fabricatorprecision sheet metal mechanicprecision sheet metal workerroofer, sheet metalsheet metal fabricatorsheet metal installersheet metal mechanicsheet metal mechanic apprenticesheet metal model makersheet metal patternmakersheet metal roofersheet metal workersheet metal worker, constructionsheet metal work erectorsheet metal worker, maintenancesheet metal worker - manufacturingsheet metal worker - specialty manufacturingtinsmithtinsmith roofertinsmith - sheet metal work",
    "workers": 4575,
    "minEduc": 0,
    "yearsStudy": 1.476190476,
    "automationRisk": 0.82,
    "salaryLow": 21.5,
    "salaryMed": 32,
    "salaryHigh": 40,
    "totalSkill": 129,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 32,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 225,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 4350,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 4350,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 225,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 331,
    "noc": 7234,
    "job": "Boilermakers",
    "title1": "boiler fitter",
    "title2": "boiler installer",
    "title3": "boilermaker",
    "allTitles": "boiler fitterboiler installerboilermakerboilermaker apprenticeboilermaker, erection and repairboilermaker, maintenanceboilermaker-welderboiler repairerboiler repairmanboiler repairman/womanboiler repairwomanboiler shop mechanicconstruction boilermakerindustrial boilermakerindustrial construction boilermakerindustrial heat exchanger boilermakerjourneyman boilermakerjourneyman/woman boilermakerjourneywoman boilermakermaintenance boilermakermarine boilermakerpressure vessel boilermakerpressure vessel fabricator",
    "workers": 640,
    "minEduc": 0,
    "yearsStudy": 1.384615385,
    "automationRisk": 0.68,
    "salaryLow": 26,
    "salaryMed": 39.43,
    "salaryHigh": 46.03,
    "totalSkill": 138,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 39.43,
    "skillsComp": 37,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 640,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 640,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 332,
    "noc": 7235,
    "job": "Structural metal and platework fabricators and fitters",
    "title1": "apprentice fabricator-fitter, structural metal and platework",
    "title2": "apprentice fitter - shipbuilding",
    "title3": "apprentice metal fabricator",
    "allTitles": "apprentice fabricator-fitter, structural metal and plateworkapprentice fitter - shipbuildingapprentice metal fabricatorapprentice metal shipwrightapprentice shipfitterapprentice ship's platerapprentice steel fabricatorapprentice structural metal and platework fabricatorapprentice structural steel and platework fitterapprentice structural steel fabricatorbridge and girder platerfabricator and fitter, plateworkfabricator, metalfabricator, metal - structural metal and plateworkfabricator, plateworkfabricator, steelfabricator, steel - structural metal and plateworkfabricator - structural metalfabricator, structural metalfabricator, structural steelfitter apprentice, structural steel and plateworkfitter-assembler, structural metalfitter lead hand - structural metal and plateworkfitter - metal fabricationfitter, plateworkfitter - shipbuildingfitter, steel - metal plateworkfitter, steel - structural metalfitter, structural metalfitter, structural metal and plateworkfitter - structural metal fabricationfitter, structural steelfitter, structural steel and plateworkfitter, tubes - structural metalwork and plateworkfitter-welder, structural metal and plateworklayer out developer, structural metal and plateworklayer out, structural metal and plateworklayout marker, structural metallead hand, metal preparation - structural metal and plateworkmarine steel fittermetal fabricatormetal fabricator (fitter)metal fabricator - structural metal and plateworkmetal preparation lead hand - structural metal and plateworkmetal shipwrightplaterplater, bridges and girdersplater - shipbuildingplater, structural metal and plateworkplater-welderplate shaper, structural steelplatework fabricatorplatework fabricator and fitterplatework fittershaper, structural steel platesshipbuilding fittershipfittershipfitter apprenticeship's platershipwright, metalsteel fabricatorsteel fabricator - structural metal and plateworksteel fitter - metal plateworksteel fitter - structural metalsteel plate shaper - shipsstructural metal and platework fabricatorstructural metal and platework fabricator apprenticestructural metal and platework fitterstructural metal and platework fitter-welderstructural metal and platework layout developerstructural metal and platework layout markerstructural metal and platework platerstructural metal fabricatorstructural metal fitterstructural metal fitter-assemblerstructural metal layout markerstructural metal workerstructural steel and platework fitterstructural steel fabricatorstructural steel fitterstructural steel plate shaperstructural steelwork and platework fittertube fitter - structural metal and plateworkworker-fitter, structural steel plates",
    "workers": 875,
    "minEduc": 0,
    "yearsStudy": 1.25,
    "automationRisk": 0.41,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 29.33,
    "totalSkill": 142,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 22,
    "skillsComp": 39,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 855,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 855,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 333,
    "noc": 7236,
    "job": "Ironworkers",
    "title1": "apprentice ironworker",
    "title2": "apprentice metal structure erector",
    "title3": "bridge construction ironworker",
    "allTitles": "apprentice ironworkerapprentice metal structure erectorbridge construction ironworkerbuilding systems erectorerector, iron structureerector, precast concreteerector, structural irongeneralist erector, steel structuresgeneralist steel structure erectorinstaller, metal wall framingiron structure erectorironworkerironworker apprenticeironworker, bridge constructionironworker, curtain wall installationironworker generalistironworker - metal building systems erectorironworker, metal tank erectingironworker, metal wall framingironworker, metal wall installationironworker - ornamentalironworker - reinforcing rebarironworker, reinforcing steelironworker, steel door settingsjourneyman ironworkerjourneyman reinforcing ironworkerjourneyman/woman ironworkerjourneyman/woman reinforcing ironworkerjourneywoman ironworkerjourneywoman reinforcing ironworkermetal structure erectormetal wall framing installerornamental ironworkerornamental-metal workerprecast concrete erectorreinforcing ironworkerreinforcing rodworkerreinforcing steel ironworkerrodworker apprenticestructural iron erectorstructural ironworkerstructural metal erectorstructural steel erectortower crane erectorworker, structural iron",
    "workers": 1870,
    "minEduc": 0,
    "yearsStudy": 1.277777778,
    "automationRisk": 0.865,
    "salaryLow": 25.9,
    "salaryMed": 36.75,
    "salaryHigh": 40.6,
    "totalSkill": 129,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 36.75,
    "skillsComp": 35,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 115,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1725,
    "f8Education(teachertraining)": 0,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1725,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 30,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 115,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 334,
    "noc": 7237,
    "job": "Welders and related machine operators",
    "title1": "acetylene welder",
    "title2": "aircraft welder",
    "title3": "apprentice welder",
    "allTitles": "acetylene welderaircraft welderapprentice welderarc welderarc welder, handarc welder - pipelineassembler tack welderauto body soldererautomated welding machine operator - flash butt processautomatic welding machine operatoraviation welding technicianbattery lead burnerbattery lead-burner operatorblowtorch operatorblowtorch welderboiler welderbrazerbrazer and hammererbrazer, furnacebrazer, gasbrazer, resistancebrazing machine operatorbrazing machine settercable weldercombination welderdielectric welderdownhand welder - pipelinedrilling platform welderdrilling rig welderelectric arc welderelectric arc welder, handelectric spot welderelectric spot welder operatorelectric spot-welding machine operatorfabrication welderfit-up welderflame-brazing machine operatorflame-brazing machine setterflash butt welderfurnace brazerfurnace solderergas and arc weldergas brazergas-shielded arc weldergas-shielded arc welding machine operatorgas weldergeneral welderhand arc welderhand electric arc welderhand resistance welderheliarc welderhot gas welderhydrogen braze furnace manhydrogen braze furnace man/womanhydrogen braze furnace operatorhydrogen braze furnace womaninduction brazer operatorinduction brazer, productioninduction soldererindustrial welderiron brazerjig welder-fitterjourneyman welderjourneyman/woman welderjourneywoman welderlaser beam machine-welder operatorlaser beam welderlaser beam welding machine operatorlaser welding operatorlead burnerlead weldermachine operator - welding, brazing and solderingmachine type solderermachine weldermaintenance weldermesh-welding machine operatormetal brazier and heatermetal inert gas (MIG) weldermetal solderermetal straightener and heatermetal welderMIG (metal inert gas) welderoperator, laser beam machine welderoxyacetylene torch welderoxyacetylene welderoxyhydrogen welderpipeline welderportable spot welderprecision welderpressure vessel welderproduction induction brazierproduction line soldererproduction line spot welderproduction line welderproduction spot welderproduction welderradio-frequency welderresistance brazerresistance seam welderresistance welder",
    "workers": 14245,
    "minEduc": 0,
    "yearsStudy": 1.747126437,
    "automationRisk": 0.94,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 32,
    "totalSkill": 119,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 22,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 985,
    "f2Engineering": 835,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 40,
    "f7Arts&Education": 12255,
    "f8Education(teachertraining)": 0,
    "f9Law": 90,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 12255,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 835,
    "d11Law": 90,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 985,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 335,
    "noc": 7241,
    "job": "Electricians (except industrial and power system)",
    "title1": "apprentice construction electrician",
    "title2": "apprentice electrician",
    "title3": "apprentice electrician, construction",
    "allTitles": "apprentice construction electricianapprentice electricianapprentice electrician, constructionbuilding construction electricianbuilding electricianconstruction and maintenance electricianconstruction electricianconstruction electrician apprenticedomestic and rural electricianelectrical fixtures installerelectrical wirer, constructionelectrical wiring installer - constructionelectricianelectrician, building constructionelectrician, construction and maintenanceelectrician, institutionelectrician - troubleshooterjourneyman construction electricianjourneyman/woman construction electricianjourneywoman construction electricianresidential construction wirerresidential wiremanresidential wireman/womanresidential wirewomanwirer, residential constructionwiring electrician",
    "workers": 25140,
    "minEduc": 2,
    "yearsStudy": 2.043010753,
    "automationRisk": 0.15,
    "salaryLow": 15,
    "salaryMed": 32,
    "salaryHigh": 45,
    "totalSkill": 155,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 32,
    "skillsComp": 49,
    "skillsLogi": 38,
    "skillsMath": 19,
    "skillsLang": 49,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 20,
    "s9ProblemSolving": 8,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 24,
    "s13DocumentUse": 18,
    "s14Writing": 8,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 605,
    "f2Engineering": 3255,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 40,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 20795,
    "f8Education(teachertraining)": 0,
    "f9Law": 215,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 230,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 40,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 20795,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 3255,
    "d11Law": 215,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 605,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 230,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 336,
    "noc": 7242,
    "job": "Industrial electricians",
    "title1": "apprentice industrial electrician",
    "title2": "apprentice marine electrician",
    "title3": "diesel electrician - railway",
    "allTitles": "apprentice industrial electricianapprentice marine electriciandiesel electrician - railwayelectrical repairer, crane maintenanceelectrical repairer, industrialelectrical repairer, machine shopelectrical repairman, crane maintenanceelectrical repairman, industrialelectrical repairman, machine shopelectrical repairwoman, crane maintenanceelectrical repairwoman, industrialelectrical repairwoman, machine shopelectrician, industrialelectrician, plant maintenanceelectrician - rail transportelectrician, shipyardelectric signal repairer - railwayelectric signal repairman - railwayelectric signal repairwoman - railwayindustrial electricianindustrial electrician apprenticeindustrial electrician lead handjourneyman industrial electricianjourneyman/woman industrial electricianjourneywoman industrial electricianmaintenance electrician - industrialmarine electricianmarine equipment electricianmarine wiremanmarine wireman/womanmarine wirewomanmill electricianmine electricianplant electricianplant maintenance electricianrailway signal installerrailway signal maintainerrig electricianship's electricianship's electrician - shipbuilding and repairship's electrician - water transportshipyard electriciansignal maintainer, railway",
    "workers": 7940,
    "minEduc": 2,
    "yearsStudy": 2.217391304,
    "automationRisk": 0.15,
    "salaryLow": 18.56,
    "salaryMed": 33,
    "salaryHigh": 40.5,
    "totalSkill": 160,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 33,
    "skillsComp": 56,
    "skillsLogi": 41,
    "skillsMath": 22,
    "skillsLang": 41,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 10,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 32,
    "s13DocumentUse": 18,
    "s14Writing": 8,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 230,
    "f2Engineering": 1760,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 5950,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 5950,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1760,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 230,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 337,
    "noc": 7243,
    "job": "Appliance servicers and repairers",
    "title1": "apprentice power system electrician",
    "title2": "electrical powerhouse electrician",
    "title3": "electrical powerhouse electrician - electrical power system",
    "allTitles": "apprentice power system electricianelectrical powerhouse electricianelectrical powerhouse electrician - electrical power systemelectrician, electrical powerhouse - electrical power systemelectrician, electrical substation - electrical power systemelectrician - electricity productionmaintainer, voltage regulator - electrical power systempower electricianpowerhouse electrician - electrical power systempower station electricianpower station electrician - electrical power systempower system electricianrelay tester and maintainer - electrical power systemrelay tester and repairer - electrical power systemrelay tester and repairman - electrical power systemrelay tester and repairwoman - electrical power systemsubstation electrician - electrical power systemvoltage regulator maintainer - electrical power system",
    "workers": 2280,
    "minEduc": 1,
    "yearsStudy": 1.67545639,
    "automationRisk": 0.435,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 126.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 26.70692784,
    "skillsComp": 34.5,
    "skillsLogi": 35,
    "skillsMath": 16.5,
    "skillsLang": 40,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 11,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 14.5,
    "s13DocumentUse": 15.5,
    "s14Writing": 10.5,
    "s15CriticalThinking": 7.5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 260,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1005,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1005,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 260,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 338,
    "noc": 7244,
    "job": "Electrical power line and cable workers",
    "title1": "apprentice line maintainer - electric power systems",
    "title2": "apprentice lineman - electric power systems",
    "title3": "apprentice lineman/woman - electric power systems",
    "allTitles": "apprentice line maintainer - electric power systemsapprentice lineman - electric power systemsapprentice lineman/woman - electric power systemsapprentice linewoman - electric power systemsapprentice power line repairerapprentice power line repairmanapprentice power line repairwomanassistant transmission lineman - electric power systemsassistant transmission lineman/woman - electric power systemsassistant transmission linewoman - electric power systemscable installer and repairer - electric power systemscable installer and repairman - electric power systemscable installer and repairwoman - electric power systemscable installer - electrical powercable installer - electric power systemscable jointer - electric power systemscable line worker - electric power systemscableman - electric power systemscableman/woman - electric power systemscable repairer - electric power systemscable repairman - electric power systemscable repairwoman - electric power systemscable splicer - electrical powercable splicer - electric power systemscablewoman - electric power systemsconduit installer - electric power systemsconstruction lineman - electrical power lineconstruction lineman - electric power systemsconstruction lineman/woman - electrical power lineconstruction lineman/woman - electric power systemsconstruction linewoman - electrical power lineconstruction linewoman - electric power systemsdistribution construction linemanelectrical cable splicer - electric power systemselectric meter installer - electric power systemselectric meter setter - electric power systemsemergency line repairer - electric power systemsemergency line repairman - electric power systemsemergency line repairwoman - electric power systemsemergency serviceman - electric power systemsemergency servicer - electric power systemsemergency servicewoman - electric power systemshigh voltage linemanhigh voltage lineman - electric power systemshigh voltage lineman/linewomanhigh voltage lineman/woman - electric power systemshigh voltage linewomanhigh voltage linewoman - electric power systemshigh-voltage maintenance linemanhigh-voltage maintenance lineman/womanhigh-voltage maintenance linewomanhigh-voltage power line patroller - electric power systemshigh-voltage tower linemanhigh-voltage tower lineman/womanhigh-voltage tower linewomaninstaller, electrical cables - electric power systemslead lineman - electricity production and transmissionlead lineman - electric power systemslead lineman/woman - electricity production and transmissionlead lineman/woman - electric power systemslead linewoman - electricity production and transmissionlead linewoman - electric power systemsline checker - electric power systemsline installation trainee - electric power systemsline maintainer - electric power systemslineman - electric power systemslineman - electric streetcarlineman trainee - electricity production and transmissionlineman trainee - electric power systemslineman/woman - electric power systemslineman/woman - electric streetcarlineman/woman trainee - electricity production and transmissionlineman/woman trainee - electric power systemsline patroller - electric power systemsline repairer - electric power systemsline repairman - electric power systemsline repairwoman - electric power systemsline serviceman - electric power systemsline servicer - electric power systemsline servicewoman - electric power systemslinewoman - electric power systemslinewoman - electric streetcarlinewoman trainee - electricity production and transmissionlinewoman trainee - electric power systemslineworker - electrical power systemsmaintenance lineman - electric power systemsmaintenance lineman/woman - electric power systemsmaintenance linewoman - electric power systemsmeter installer - electric power systemspower line lineman, electricalpower line lineman/woman, electricalpower line linewoman, electricalpower line maintainer - electric power systemspower linemanpower lineman - electricity production and transmissionpower lineman/womanpower lineman/woman - electricity production and transmissionpower line patrollerpower line repairer - electric power systemspower line repairman - electric power systems",
    "workers": 2225,
    "minEduc": 2,
    "yearsStudy": 1.619047619,
    "automationRisk": 0.097,
    "salaryLow": 14,
    "salaryMed": 34.79,
    "salaryHigh": 43,
    "totalSkill": 126,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 34.79,
    "skillsComp": 29,
    "skillsLogi": 36,
    "skillsMath": 23,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 17,
    "s3FindingInformation": 0,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 16,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 17,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 5,
    "s13DocumentUse": 22,
    "s14Writing": 0,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 30,
    "f2Engineering": 240,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1955,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1955,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 240,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 339,
    "noc": 7245,
    "job": "Telecommunications line and cable workers",
    "title1": "apprentice lineman - telecommunications",
    "title2": "apprentice lineman/woman - telecommunications",
    "title3": "apprentice linewoman - telecommunications",
    "allTitles": "apprentice lineman - telecommunicationsapprentice lineman/woman - telecommunicationsapprentice linewoman - telecommunicationscable installer - telecommunicationscable repairer - telecommunicationscable repairer, telecommunicationscable repairman - telecommunicationscable repairman, telecommunicationscable repair technician - telecommunicationscable repairwoman - telecommunicationscable repairwoman, telecommunicationscable splicer, telecommunicationscable tester - telecommunicationscommunication line techniciancommunications electrician - construction craftcommunication technician - constructionconstruction technician - cable televisionconstruction technician - telecommunicationsfibre optic cable splicerjourneyman lineman - telecommunicationsjourneyman/woman lineman/woman - telecommunicationsjourneywoman linewoman - telecommunicationsline inspector - telecommunicationsline installer-repairer - telecommunicationsline installer-repairman - telecommunicationsline installer-repairwoman - telecommunicationsline installer - telecommunicationslineman-technician/linewoman-technician - telecommunicationslineman-technician - telecommunicationslineman, telecommunicationslineman/woman, telecommunicationsline repairer - telecommunicationsline repairman - telecommunicationsline repairwoman - telecommunicationsline technician, telecommunicationslinewoman-technician - telecommunicationslinewoman, telecommunicationslineworker-technician - telecommunicationsrepair lineman - telecommunicationsrepair lineman/woman - telecommunicationsrepair linewoman - telecommunicationsrigger - telecommunicationssection lineman - telecommunicationssection lineman/woman - telecommunicationssection linewoman - telecommunicationsservice tracer - telecommunicationssignal tracer - telecommunicationssplicer technician - telecommunicationssplicer technician - telephonesplicer - telecommunicationstechnician, communication linestechnician, telephone linetelecommunication cable installertelecommunication cable repairertelecommunication cable repairmantelecommunication cable repairwomantelecommunication line construction techniciantelecommunication line techniciantelecommunications line installertelecontrol technologisttelephone cable splicertelephone line and cablemantelephone line and cableman/womantelephone line and cablewomantelephone line techniciantoll line inspector - telecommunicationstoll lineman - telecommunicationstoll lineman/woman - telecommunicationstoll line repairman - telecommunicationstoll line repairman/woman - telecommunicationstoll line repairwoman - telecommunicationstoll linewoman - telecommunicationstracer - telecommunicationsunderground cable splicer - telecommunicationswire splicer - telecommunications",
    "workers": 1455,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.49,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 142,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 27.84261566,
    "skillsComp": 38,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 145,
    "f2Engineering": 805,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 105,
    "f7Arts&Education": 330,
    "f8Education(teachertraining)": 0,
    "f9Law": 70,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 105,
    "d8OtherArts&Science": 330,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 805,
    "d11Law": 70,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 145,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 340,
    "noc": 7246,
    "job": "Telecommunications installation and repair workers",
    "title1": "apprentice, communication electrician - network craft",
    "title2": "apprentice communication electrician - switching",
    "title3": "apprentice electrician - telecommunications equipment",
    "allTitles": "apprentice, communication electrician - network craftapprentice communication electrician - switchingapprentice electrician - telecommunications equipmentapprentice telephone switchmanapprentice telephone switchman/womanapprentice telephone switchwomanbranch exchange repairer - telecommunicationsbranch exchange repairman - telecommunicationsbranch exchange repairwoman - telecommunicationsbusiness telephone equipment installer and repairerbusiness telephone equipment installer and repairmanbusiness telephone equipment installer and repairwomanbusiness telephone equipment maintainercable station tester - telecommunicationscellular phone installercellular telephone installercellular telephone techniciancentral office equipment inspector - telecommunicationscentral office equipment installer - telecommunicationscentral office equipment maintainer - telecommunicationscentral office equipment repairer - telecommunicationscentral office equipment repairman - telecommunicationscentral office equipment repairwoman - telecommunicationscentral office frame serviceman - telecommunicationscentral office frame servicer - telecommunicationscentral office frame servicewoman - telecommunicationscentral office repairer - telecommunicationscentral office repairman - telecommunicationscentral office repairwoman - telecommunicationscentral office technician - telecommunicationscentral office tester - telecommunicationscharging equipment attendant - telecommunicationscombination man - telecommunicationscombination man/woman - telecommunicationscombination woman - telecommunicationscommunication electrician - network craftcommunications electrician - telecommunicationscommunication systems techniciancommunication technician, telephonecomplaint service technician - telecommunicationsdistrictman - telecommunicationsdistrictman/woman - telecommunicationsdistrictwoman - telecommunicationselectrician, switched communicationselectrician, telecommunications equipmentelectrician, telephone communicationselectrician, toll communicationselectronic communications technicianequipment installer and repairer - telecommunicationsequipment installer and repairman - telecommunicationsequipment installer and repairwoman - telecommunicationsexchange installer and repairer - telecommunicationsexchange installer and repairman - telecommunicationsexchange installer and repairwoman - telecommunicationsexchange testerexchange tester - telecommunicationsfacilities man - telecommunicationsfacilities man/woman - telecommunicationsfacilities wirer - telecommunicationsfacilities woman - telecommunicationsfacsimile equipment installerframeman - telecommunicationsframeman/woman - telecommunicationsframe wirer - telephoneframewoman - telecommunicationsinspector, private branch exchange (PBX) - telecommunicationsinstallation and repair technician - telecommunicationsinstaller, satellite receiversinstaller, switch networkinstaller - telecommunicationsinstaller, teleprintersinstaller, teletypewriters (TTY)installer, teletypewriter (TTY) - telecommunicationsinstaller, TTY (teletypewriter) - telecommunicationsline and station installer, telephonemobile radio installermobile radio installer - telecommunicationsmobile radio technician - telecommunicationsmobile radiotelephone installeroperator, test desk - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) inspector - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) installer and repairer - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) installer and repairman - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) installer and repairwoman - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) installer - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) repairer - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) repairman - telecommunicationsPBX (private branch exchange) and PABX (private automatic branch exchange) repairwoman - telecommunicationsPBX (private branch exchange) inspector - telecommunicationsPBX (private branch exchange) repairer - telecommunicationsPBX (private branch exchange) repairman - telecommunicationsPBX (private branch exchange) repairwoman - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) inspector - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) installer and repairer - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) installer and repairman - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) installer and repairwoman - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) installer - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) repairer - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) repairman - telecommunicationsprivate branch exchange (PBX) and private automatic branch exchange (PABX) repairwoman - telecommunications",
    "workers": 2830,
    "minEduc": 2,
    "yearsStudy": 2.140625,
    "automationRisk": 0.36,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 128,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 30.56863004,
    "skillsComp": 45,
    "skillsLogi": 32,
    "skillsMath": 16,
    "skillsLang": 35,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 7,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 19,
    "s14Writing": 7,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 305,
    "f2Engineering": 1800,
    "f3Humanities": 0,
    "f4SocialScience": 50,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 135,
    "f7Arts&Education": 145,
    "f8Education(teachertraining)": 0,
    "f9Law": 80,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 270,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 55,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 50,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 135,
    "d8OtherArts&Science": 145,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1800,
    "d11Law": 80,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 250,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 270,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 341,
    "noc": 7247,
    "job": "Cable television service and maintenance technicians",
    "title1": "apprentice CATV (community antenna television) technician apprentice community antenna television (CATV) technician cable servicer, television cable television installer cable television service installation technician cable television technician cable TV (television) converter and decoder equipment repairer cablevision servicer CATV (community antenna television) installation technician � telecommunications CATV (community antenna television) maintenance technician CATV (community antenna television) service installation technician � telecommunications CATV (community antenna television) technician � cable television CATV (community antenna television) technician � telecommunications CATV technician community antenna television (CATV) installation technician � telecommunications community antenna television (CATV) maintenance technician community antenna television (CATV) service installation technician � telecommunications community antenna television (CATV) technician � cable television community antenna television (CATV) technician � telecommunications DBS (direct broadcast satellite) technician � cable television direct broadcast satellite (DBS) technician � cable television electronics apprentice � community antenna television head end technician � cable television installation service technician � cable television installation technician, cable television maintenance technician, cable television repairer, cable TV (television) converter and decoder equipment satellite television technician technician, cable television television receive only (TVRO) technician TVRO (television receive only) technician",
    "title2": 0,
    "title3": 0,
    "allTitles": "apprentice CATV (community antenna television) technician apprentice community antenna television (CATV) technician cable servicer, television cable television installer cable television service installation technician cable television technician cable TV (television) converter and decoder equipment repairer cablevision servicer CATV (community antenna television) installation technician � telecommunications CATV (community antenna television) maintenance technician CATV (community antenna television) service installation technician � telecommunications CATV (community antenna television) technician � cable television CATV (community antenna television) technician � telecommunications CATV technician community antenna television (CATV) installation technician � telecommunications community antenna television (CATV) maintenance technician community antenna television (CATV) service installation technician � telecommunications community antenna television (CATV) technician � cable television community antenna television (CATV) technician � telecommunications DBS (direct broadcast satellite) technician � cable television direct broadcast satellite (DBS) technician � cable television electronics apprentice � community antenna television head end technician � cable television installation service technician � cable television installation technician, cable television maintenance technician, cable television repairer, cable TV (television) converter and decoder equipment satellite television technician technician, cable television television receive only (TVRO) technician TVRO (television receive only) technician",
    "workers": 6978.333333,
    "minEduc": 1.5,
    "yearsStudy": 1.949255178,
    "automationRisk": 0.280333333,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 139.5833333,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 30.81802892,
    "skillsComp": 41.91666667,
    "skillsLogi": 36.33333333,
    "skillsMath": 19.41666667,
    "skillsLang": 41.66666667,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4.583333333,
    "s2DecisionMaking": 10.66666667,
    "s3FindingInformation": 5.333333333,
    "s4JobTaskPlanningandOrganizing": 2.416666667,
    "s5MeasurementandCalculation": 9.166666667,
    "s6MoneyMath": 3.333333333,
    "s7NumericalEstimation": 3.833333333,
    "s8OralCommunication": 15.83333333,
    "s9ProblemSolving": 10.33333333,
    "s10Reading": 18.08333333,
    "s11SchedulingorBudgetingandAccounting": 3.083333333,
    "s12DigitalTechnology": 19.08333333,
    "s13DocumentUse": 18.25,
    "s14Writing": 7.75,
    "s15CriticalThinking": 7.583333333,
    "f1Science&Agriculture": 219.1666667,
    "f2Engineering": 1353.333333,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 14.16666667,
    "f6MathAndComputerScience": 40,
    "f7Arts&Education": 5030,
    "f8Education(teachertraining)": 0,
    "f9Law": 60.83333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 83.33333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 14.16666667,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 14.16666667,
    "d7ComputerScience": 40,
    "d8OtherArts&Science": 5030,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1353.333333,
    "d11Law": 60.83333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 205,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 83.33333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 342,
    "noc": 7251,
    "job": "Plumbers",
    "title1": "apprentice plumber",
    "title2": "journeyman plumber",
    "title3": "journeyman/woman plumber",
    "allTitles": "apprentice plumberjourneyman plumberjourneyman/woman plumberjourneywoman plumbermaintenance and repair plumbermaintenance and repair plumber, (non-construction)maintenance plumbermarine plumberplumberplumber apprenticeplumber, maintenance and repairplumber, (non-construction) maintenance and repairplumber - pipefittingplumber, residential constructionplumbing installerplumbing mechanicradiator plumberresidential construction plumber",
    "workers": 14805,
    "minEduc": 2,
    "yearsStudy": 2.404853129,
    "automationRisk": 0.1895,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 144,
    "industry": "Health",
    "industryNum": 8,
    "sector": "Technical occupations in health",
    "cluster": 8,
    "wage": 24.20570419,
    "skillsComp": 43.5,
    "skillsLogi": 36.5,
    "skillsMath": 22,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 4.5,
    "s5MeasurementandCalculation": 10.5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 17.5,
    "s13DocumentUse": 20.5,
    "s14Writing": 6.5,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 100,
    "f2Engineering": 410,
    "f3Humanities": 0,
    "f4SocialScience": 15,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10600,
    "f8Education(teachertraining)": 0,
    "f9Law": 65,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 200,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10600,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 410,
    "d11Law": 65,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 100,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 200,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 343,
    "noc": 7252,
    "job": "Steamfitters, pipefitters and sprinkler system installers",
    "title1": "apprentice fitter, sprinkler systems",
    "title2": "apprentice pipefitter",
    "title3": "apprentice pipefitter-steamfitter",
    "allTitles": "apprentice fitter, sprinkler systemsapprentice pipefitterapprentice pipefitter-steamfitterapprentice sprinkler system fitterapprentice steamfitterfire prevention and automatic suppression systems installerfire protection mechanicfire protection piping installerfire sprinkler fitterfitter, sprinkler systeminstaller, fire prevention and automatic suppression systemsinstaller, fire protection piping systeminstaller, sprinklers and fire protection systemsinstaller, sprinkler systemsjourneyman pipefitterjourneyman sprinkler system installerjourneyman steamfitter-pipefitterjourneyman/woman pipefitterjourneyman/woman sprinkler system installerjourneyman/woman steamfitter-pipefitterjourneywoman pipefitterjourneywoman sprinkler system installerjourneywoman steamfitter-pipefittermaintenance pipefittermarine pipefittermarine steamfitterpipefitterpipefitter, railway cars and locomotivespipefitter - shipbuildingpipefitter-steamfitterpipefitter, turbinespipefitter, weldingpipe installer, radiatorrailway car and locomotive pipefittership pipefittership steamfittersprinkler and fire protection installersprinkler fittersprinkler system fittersprinkler system installersprinkler system installer apprenticesprinkler system installer (non-construction)steamfittersteamfitter-pipefittersteamfitter/pipefitter (non-construction)steamfitter - shipbuildingsteamfitter, shipssteam heating installersteam main servicersteam pipefitterturbine pipefitter",
    "workers": 4075,
    "minEduc": 0,
    "yearsStudy": 1.464285714,
    "automationRisk": 0.35,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 154,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 30.0704112,
    "skillsComp": 40,
    "skillsLogi": 32,
    "skillsMath": 30,
    "skillsLang": 52,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 10,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 15,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 19,
    "s9ProblemSolving": 12,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 30,
    "s14Writing": 14,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 165,
    "f2Engineering": 40,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 3735,
    "f8Education(teachertraining)": 0,
    "f9Law": 120,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 3735,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 120,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 165,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 344,
    "noc": 7253,
    "job": "Gas fitters",
    "title1": "apprentice gas fitter",
    "title2": "district gas serviceman",
    "title3": "district gas serviceman/woman",
    "allTitles": "apprentice gas fitterdistrict gas servicemandistrict gas serviceman/womandistrict gas servicewomanfitter, gas mainsfurnace convertergas customer servicergas fittergas fitter apprenticegas fitter-installergas fitter traineegas main fittergas pipefittergas servicergas techniciangas works troubleshooterindustrial gas fitter-testerindustrial gas servicerjourneyman gas fitterjourneyman/woman gas fitterjourneywoman gas fittermechanic, gas pipesservicer, gastroubleshooter, gas works",
    "workers": 2730,
    "minEduc": 2,
    "yearsStudy": 1.46875,
    "automationRisk": 0.35,
    "salaryLow": 15.85333333,
    "salaryMed": 33.26333333,
    "salaryHigh": 42.83333333,
    "totalSkill": 214,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 34.33668924,
    "skillsComp": 51,
    "skillsLogi": 64,
    "skillsMath": 36,
    "skillsLang": 63,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 13,
    "s2DecisionMaking": 18,
    "s3FindingInformation": 13,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 16,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 22,
    "s9ProblemSolving": 15,
    "s10Reading": 26,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 24,
    "s14Writing": 15,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 360,
    "f2Engineering": 1015,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1355,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1355,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1015,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 360,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 345,
    "noc": 7271,
    "job": "Carpenters",
    "title1": "access floor specialist carpenter apprentice boat carpenter apprentice carpenter apprentice carpenter-joiner boat carpenter boat joiner boatbuilder, wood boatbuilding apprentice bridge carpenter builder, wooden boats building addition carpenter building carpenter carpenter carpenter lead hand carpenter rough carpenter, bridges carpenter, building additions carpenter, concrete forms carpenter, floor systems carpenter, framing carpenter, houses carpenter, interior finish carpenter, interior systems carpenter, log homes carpenter, maintenance carpenter, manufactured houses carpenter, mill carpenter, mine carpenter, plant carpenter, prefabricated structures carpenter, railway rolling stock carpenter, renovation carpenter, restoration carpenter, shipbuilding carpenter, studio carpenter-joiner carpentry repairman/woman concrete forms carpenter construction carpenter dock carpenter finish carpenter floor systems carpenter form builder � carpentry form carpenter framer-carpenter framing carpenter house carpenter interior finish carpenter interior finish joiner interior systems carpenter interior trimmer carpenter joiner, railway rolling stock journeyman/woman carpenter log home carpenter log home carpenter-builder maintenance carpenter maintenance carpenter-joiner maintenance joiner metal framer � carpentry mill carpenter mine carpenter plant carpenter prefabricated house carpenter renovation carpenter restoration carpenter rough carpenter ship joiner shipbuilding carpenter shipbuilding joiner shipwright, wood sign carpenter stage carpenter stair builder-carpenter stairway carpenter steel framer � carpentry steel stud framer � carpentry studio carpenter wood frame carpenter wood frame house carpenter wood shipwright wooden boatbuilder",
    "title2": 0,
    "title3": 0,
    "allTitles": "access floor specialist carpenter apprentice boat carpenter apprentice carpenter apprentice carpenter-joiner boat carpenter boat joiner boatbuilder, wood boatbuilding apprentice bridge carpenter builder, wooden boats building addition carpenter building carpenter carpenter carpenter lead hand carpenter rough carpenter, bridges carpenter, building additions carpenter, concrete forms carpenter, floor systems carpenter, framing carpenter, houses carpenter, interior finish carpenter, interior systems carpenter, log homes carpenter, maintenance carpenter, manufactured houses carpenter, mill carpenter, mine carpenter, plant carpenter, prefabricated structures carpenter, railway rolling stock carpenter, renovation carpenter, restoration carpenter, shipbuilding carpenter, studio carpenter-joiner carpentry repairman/woman concrete forms carpenter construction carpenter dock carpenter finish carpenter floor systems carpenter form builder � carpentry form carpenter framer-carpenter framing carpenter house carpenter interior finish carpenter interior finish joiner interior systems carpenter interior trimmer carpenter joiner, railway rolling stock journeyman/woman carpenter log home carpenter log home carpenter-builder maintenance carpenter maintenance carpenter-joiner maintenance joiner metal framer � carpentry mill carpenter mine carpenter plant carpenter prefabricated house carpenter renovation carpenter restoration carpenter rough carpenter ship joiner shipbuilding carpenter shipbuilding joiner shipwright, wood sign carpenter stage carpenter stair builder-carpenter stairway carpenter steel framer � carpentry steel stud framer � carpentry studio carpenter wood frame carpenter wood frame house carpenter wood shipwright wooden boatbuilder",
    "workers": 7320.833333,
    "minEduc": 1.666666667,
    "yearsStudy": 1.53326663,
    "automationRisk": 0.567416667,
    "salaryLow": 15,
    "salaryMed": 29,
    "salaryHigh": 38.25,
    "totalSkill": 149.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 31.29380077,
    "skillsComp": 38.41666667,
    "skillsLogi": 36.5,
    "skillsMath": 25.75,
    "skillsLang": 48.83333333,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.833333333,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3.083333333,
    "s5MeasurementandCalculation": 11.75,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 5.75,
    "s8OralCommunication": 17.75,
    "s9ProblemSolving": 9.666666667,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 4.75,
    "s12DigitalTechnology": 11.75,
    "s13DocumentUse": 21.83333333,
    "s14Writing": 10.08333333,
    "s15CriticalThinking": 5.75,
    "f1Science&Agriculture": 128.3333333,
    "f2Engineering": 255.8333333,
    "f3Humanities": 3.333333333,
    "f4SocialScience": 2.5,
    "f5FineArts": 3.333333333,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 3140.833333,
    "f8Education(teachertraining)": 0,
    "f9Law": 39.16666667,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 3.333333333,
    "d4Humanities": 3.333333333,
    "d5SocialSciences": 2.5,
    "d6Fine&AppliedArts": 3.333333333,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 3140.833333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 252.5,
    "d11Law": 39.16666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 128.3333333,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 346,
    "noc": 7272,
    "job": "Cabinetmakers",
    "title1": "cabinetmaker cabinetmaker apprentice custom desk maker, wood custom frame and mirror assembler custom piano case maker custom wood furniture maker custom wooden desk maker furniture cabinetmaker jig builder � wood products manufacturing journeyman/woman cabinetmaker layout marker � cabinetmaking model maker, wood mouldmaker, wood pattern repairman/woman � foundry patternmaker, wood tradesman/woman cabinetmaker wood furniture and fixtures patternmaker wood model maker wood mould maker wood pattern inspector wood pattern repairman/woman � foundry wood patternmaker",
    "title2": 0,
    "title3": 0,
    "allTitles": "cabinetmaker cabinetmaker apprentice custom desk maker, wood custom frame and mirror assembler custom piano case maker custom wood furniture maker custom wooden desk maker furniture cabinetmaker jig builder � wood products manufacturing journeyman/woman cabinetmaker layout marker � cabinetmaking model maker, wood mouldmaker, wood pattern repairman/woman � foundry patternmaker, wood tradesman/woman cabinetmaker wood furniture and fixtures patternmaker wood model maker wood mould maker wood pattern inspector wood pattern repairman/woman � foundry wood patternmaker",
    "workers": 7320.833333,
    "minEduc": 1.666666667,
    "yearsStudy": 1.53326663,
    "automationRisk": 0.567416667,
    "salaryLow": 14,
    "salaryMed": 19.5,
    "salaryHigh": 33.65,
    "totalSkill": 149.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 31.29380077,
    "skillsComp": 38.41666667,
    "skillsLogi": 36.5,
    "skillsMath": 25.75,
    "skillsLang": 48.83333333,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.833333333,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3.083333333,
    "s5MeasurementandCalculation": 11.75,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 5.75,
    "s8OralCommunication": 17.75,
    "s9ProblemSolving": 9.666666667,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 4.75,
    "s12DigitalTechnology": 11.75,
    "s13DocumentUse": 21.83333333,
    "s14Writing": 10.08333333,
    "s15CriticalThinking": 5.75,
    "f1Science&Agriculture": 128.3333333,
    "f2Engineering": 255.8333333,
    "f3Humanities": 3.333333333,
    "f4SocialScience": 2.5,
    "f5FineArts": 3.333333333,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 3140.833333,
    "f8Education(teachertraining)": 0,
    "f9Law": 39.16666667,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 3.333333333,
    "d4Humanities": 3.333333333,
    "d5SocialSciences": 2.5,
    "d6Fine&AppliedArts": 3.333333333,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 3140.833333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 252.5,
    "d11Law": 39.16666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 128.3333333,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 347,
    "noc": 7281,
    "job": "Bricklayers",
    "title1": "apprentice bricklayer apprentice brickmason apprentice mason artificial stone mason brick and stone mason brick chimney builder brick setter bricklayer bricklayer, chimney repair bricklayer, furnace lining bricklayer, kiln repair bricklayer, ladle repair bricklayer, maintenance bricklayer, refractory brick bricklayer, residential bricklayer, smokestacks brickmason builder, refractory chimney bricklayer chimney repair bricklayer chimney repair stonemason cinder block mason cinder block setter concrete block setter fire brick layer fire brick liner repairer fireplace brickmason industrial furnace bricklayer industrial furnace brickmason industrial oven brickmason installer, permastones journeyman/woman bricklayer journeyman/woman brickmason journeyman/woman mason journeyman/woman stonemason layer, fire bricks maintenance bricklayer mason, brick and stone mason, refractory masonry silo erector permastone mason refractory brick repairer-mason refractory bricklayer refractory builder refractory mason residential construction bricklayer restoration stonemason setter, artificial stones setter, simulated stones simulated stone mason smokestack bricklayer stone setter stonecutter stonemason stonemason, chimney repair stonemason, restoration terra cotta mason",
    "title2": 0,
    "title3": 0,
    "allTitles": "apprentice bricklayer apprentice brickmason apprentice mason artificial stone mason brick and stone mason brick chimney builder brick setter bricklayer bricklayer, chimney repair bricklayer, furnace lining bricklayer, kiln repair bricklayer, ladle repair bricklayer, maintenance bricklayer, refractory brick bricklayer, residential bricklayer, smokestacks brickmason builder, refractory chimney bricklayer chimney repair bricklayer chimney repair stonemason cinder block mason cinder block setter concrete block setter fire brick layer fire brick liner repairer fireplace brickmason industrial furnace bricklayer industrial furnace brickmason industrial oven brickmason installer, permastones journeyman/woman bricklayer journeyman/woman brickmason journeyman/woman mason journeyman/woman stonemason layer, fire bricks maintenance bricklayer mason, brick and stone mason, refractory masonry silo erector permastone mason refractory brick repairer-mason refractory bricklayer refractory builder refractory mason residential construction bricklayer restoration stonemason setter, artificial stones setter, simulated stones simulated stone mason smokestack bricklayer stone setter stonecutter stonemason stonemason, chimney repair stonemason, restoration terra cotta mason",
    "workers": 7320.833333,
    "minEduc": 1.666666667,
    "yearsStudy": 1.53326663,
    "automationRisk": 0.567416667,
    "salaryLow": 27,
    "salaryMed": 36.85,
    "salaryHigh": 40,
    "totalSkill": 149.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 31.29380077,
    "skillsComp": 38.41666667,
    "skillsLogi": 36.5,
    "skillsMath": 25.75,
    "skillsLang": 48.83333333,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.833333333,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3.083333333,
    "s5MeasurementandCalculation": 11.75,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 5.75,
    "s8OralCommunication": 17.75,
    "s9ProblemSolving": 9.666666667,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 4.75,
    "s12DigitalTechnology": 11.75,
    "s13DocumentUse": 21.83333333,
    "s14Writing": 10.08333333,
    "s15CriticalThinking": 5.75,
    "f1Science&Agriculture": 128.3333333,
    "f2Engineering": 255.8333333,
    "f3Humanities": 3.333333333,
    "f4SocialScience": 2.5,
    "f5FineArts": 3.333333333,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 3140.833333,
    "f8Education(teachertraining)": 0,
    "f9Law": 39.16666667,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 3.333333333,
    "d4Humanities": 3.333333333,
    "d5SocialSciences": 2.5,
    "d6Fine&AppliedArts": 3.333333333,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 3140.833333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 252.5,
    "d11Law": 39.16666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 128.3333333,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 348,
    "noc": 7282,
    "job": "Concrete finishers",
    "title1": "apprentice cement finisher",
    "title2": "cement finisher",
    "title3": "cement finisher apprentice",
    "allTitles": "apprentice cement finishercement finishercement finisher apprenticecement masoncement mason apprenticecement mason, highways and streetscement mason, maintenanceconcrete finisherconcrete finisher apprenticeconcrete floor finisherconcrete masonconcrete patcher-finisherconcrete polisherconcrete smoother-finisherfinisher, cementfinisher, concretefinisher, concrete floorsfinisher, concrete productshighway and street cement masonjourneyman cement finisherjourneyman/woman cement finisherjourneywoman cement finishermaintenance cement masonmason, cementmason, concreteprecast concrete finishersidewalk concrete finisher",
    "workers": 255,
    "minEduc": 2,
    "yearsStudy": 1.111111111,
    "automationRisk": 0.94,
    "salaryLow": 30,
    "salaryMed": 34.65,
    "salaryHigh": 36.73,
    "totalSkill": 114,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 34.65,
    "skillsComp": 33,
    "skillsLogi": 32,
    "skillsMath": 13,
    "skillsLang": 36,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 11,
    "s14Writing": 7,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 255,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 255,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 349,
    "noc": 7283,
    "job": "Tilesetters",
    "title1": "apprentice tilesetter",
    "title2": "artificial marble setter",
    "title3": "ceramic tile installer",
    "allTitles": "apprentice tilesetterartificial marble setterceramic tile installerceramic tilesettergranite setterjourneyman tilesetterjourneyman/woman tilesetterjourneywoman tilesetterlayer, marblelead hand, tilesettersmarble layermarble masonmarble mechanicmarble settermarble tilesettermason, marblemechanic, marblemosaic tilesettersetter, marbleterrazzo finisherterrazzo floor layerterrazzo layerterrazzo masonterrazzo mechanicterrazzo polisherterrazzo setterterrazzo, tile and marble setterterrazzo workertile fittertile floor layertile installertile layertile masontile mechanictilesettertilesetter, apprenticetilesetters lead hand",
    "workers": 19280,
    "minEduc": 2,
    "yearsStudy": 1.495280676,
    "automationRisk": 0.735,
    "salaryLow": 18.5,
    "salaryMed": 32,
    "salaryHigh": 37.46,
    "totalSkill": 133,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 30.5,
    "skillsComp": 34,
    "skillsLogi": 29.5,
    "skillsMath": 24.5,
    "skillsLang": 45,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1.5,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 18,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 21.5,
    "s14Writing": 10,
    "s15CriticalThinking": 3.5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 400,
    "f8Education(teachertraining)": 0,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 400,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 30,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 350,
    "noc": 7284,
    "job": "Plasterers, drywall installers and finishers and lathers",
    "title1": "acoustical ceiling installer",
    "title2": "acoustic tile and drywall installer",
    "title3": "acoustic tile installer",
    "allTitles": "acoustical ceiling installeracoustic tile and drywall installeracoustic tile installerapprentice drywall applicatorapprentice installer and finisher, drywallapprentice plastererceiling installerceiling system installerdrywall and acoustic mechanicdrywall and ceiling system installerdrywall and lather applicatordrywall applicatordrywall finisherdrywall finisher apprenticedrywall hangerdrywall installerdrywall installer and finisherdrywall installer and finisher apprenticedrywall installer lead handdrywall installer team leaderdrywall interior systems installerdrywall mechanicdrywall nailerdrywall nailing persondrywall taperexterior plastererfinisher, drywallfinish plastererfireproofing applicatorfireproofing plasterergyproc applicatorgypsum lathergypsum plasterboard applicatorinstaller and finisher, drywallinstaller, drywall interior systemsinterior drywall installerinterior systems installer, drywalljourneyman drywall installerjourneyman latherjourneyman plastererjourneyman/woman drywall installerjourneyman/woman latherjourneyman/woman plastererjourneywoman drywall installerjourneywoman latherjourneywoman plastererlatherlather applicatorlather apprenticelather (interior systems mechanic)lather-mechanic, interior systemsmetal lathermoulding plastererornamental plastererplastererplasterer apprenticeplasterer-decoratorplasterer, finishplasterer, fireproofingplasterer, mouldingplasterer, stuccosheetrock applicatorstucco latherstucco plasterertaper, drywallwall and ceiling installerwallboard installerwallboard taperwire latherwood lather",
    "workers": 2780,
    "minEduc": 2,
    "yearsStudy": 1.255319149,
    "automationRisk": 0.84,
    "salaryLow": 15,
    "salaryMed": 34,
    "salaryHigh": 39,
    "totalSkill": 138,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 34,
    "skillsComp": 29,
    "skillsLogi": 25,
    "skillsMath": 29,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 23,
    "s9ProblemSolving": 5,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 3,
    "s13DocumentUse": 24,
    "s14Writing": 8,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 145,
    "f2Engineering": 70,
    "f3Humanities": 20,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 2500,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 2500,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 70,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 145,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 351,
    "noc": 7291,
    "job": "Roofers and shinglers",
    "title1": "apprentice roofer",
    "title2": "apprentice shingle roofer",
    "title3": "asphalt roofer",
    "allTitles": "apprentice rooferapprentice shingle rooferasphalt rooferasphalt shinglerasphalt shingle rooferbuilt-up flat rooferbuilt-up roofercedar shakes shinglercedar shinglercomposition rooferflat roofergravel rooferjourneyman rooferjourneyman/woman rooferjourneywoman roofermechanic, roofingmetal rooferresidential building shinglerresidential steep rooferrooferroofer and waterprooferroofer, asphaltroofer, asphalt and gravelroofer, asphalt shinglesroofer, built-up flatroofer, gravelroofer, metalroofer, shinglesroofer traineeroofer, wood shingleroofing mechanicroof tilershinglershingler, asphaltshingler, cedarshingler, cedar shakesshingle roofershingler traineeshingler, woodsingle-ply roofertar and gravel roofertar roofertile roofertiler, roofswaterproofer and rooferwood shinglerwood shingle roofer",
    "workers": 770,
    "minEduc": 2,
    "yearsStudy": 1.210526316,
    "automationRisk": 0.9,
    "salaryLow": 15.38,
    "salaryMed": 29,
    "salaryHigh": 39,
    "totalSkill": 108,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 29,
    "skillsComp": 18,
    "skillsLogi": 39,
    "skillsMath": 21,
    "skillsLang": 30,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 12,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 4,
    "s13DocumentUse": 13,
    "s14Writing": 3,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 675,
    "f8Education(teachertraining)": 0,
    "f9Law": 75,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 675,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 75,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 352,
    "noc": 7292,
    "job": "Glaziers",
    "title1": "apprentice glazier",
    "title2": "building glass glazier",
    "title3": "building glazier",
    "allTitles": "apprentice glazierbuilding glass glazierbuilding glaziercurtain wall glazierglass and metal mechanicglass installer-glazierglass setter - constructionglass wallcovering installerglass wall installerglass workerglass worker apprenticeglazierglazier and metal mechanicglazier and metal mechanic apprenticeglazier apprenticeglazier, buildingglazier, curtain wallsglazier, exterior wallsglazier, plate glassglazier, stained glassglazier, structural glassglazier, window sash and frameinstaller, glass wallcoveringsinstaller, glass wallsinstaller, structural glassjourneyman glazierjourneyman/woman glazierjourneywoman glazierleaded glass glaziermirror wall installerplate glass installerstained glass glazierstructural glass glazierstructural glass installerwindow sash and frame glazier",
    "workers": 725,
    "minEduc": 2,
    "yearsStudy": 1.272727273,
    "automationRisk": 0.73,
    "salaryLow": 17.66,
    "salaryMed": 26.52,
    "salaryHigh": 36.79,
    "totalSkill": 159,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 26.52,
    "skillsComp": 31,
    "skillsLogi": 40,
    "skillsMath": 30,
    "skillsLang": 58,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 14,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 21,
    "s9ProblemSolving": 15,
    "s10Reading": 25,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 29,
    "s14Writing": 12,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 725,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 725,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 353,
    "noc": 7293,
    "job": "Insulators",
    "title1": "apprentice insulator",
    "title2": "asbestos insulator",
    "title3": "boat and ship insulator",
    "allTitles": "apprentice insulatorasbestos insulatorboat and ship insulatorboiler and pipe insulatorboiler insulatorbuilding insulatorcork insulation installerfibreglass insulation installerfire protection insulatorfirestopping insulatorfoamed insulation applicatorheat and frost insulatorinstaller, insulationinsulation applicatorinsulation installerinsulation mechanicinsulatorinsulator apprenticeinsulator, heat and frostjourneyman insulatorjourneyman/woman insulatorjourneywoman insulatorpipe insulatorplastic insulation applicatorrefrigeration and air conditioning equipment insulatorsound insulatorsoundproof material installer",
    "workers": 935,
    "minEduc": 2,
    "yearsStudy": 1.272727273,
    "automationRisk": 0.83,
    "salaryLow": 14,
    "salaryMed": 32,
    "salaryHigh": 47.12,
    "totalSkill": 106,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 32,
    "skillsComp": 17,
    "skillsLogi": 25,
    "skillsMath": 17,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Measurement and Calculation",
    "topSkill3": "Measurement and Calculation",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 15,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 23,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 15,
    "s14Writing": 9,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 895,
    "f8Education(teachertraining)": 0,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 895,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 354,
    "noc": 7294,
    "job": "Painters and decorators (except interior decorators)",
    "title1": "apprentice industrial painter and decorator",
    "title2": "apprentice painter and decorator",
    "title3": "bridge painter",
    "allTitles": "apprentice industrial painter and decoratorapprentice painter and decoratorbridge painterbuilding paintercommercial building paintercommercial construction painterconstruction painterhouse painterindustrial construction painterindustrial maintenance painterjourneyman painter and decoratorjourneyman/woman painter and decoratorjourneywoman painter and decoratormaintenance paintermaintenance painter, plantpainterpainter and decoratorpainter and decorator apprenticepainter and paperhangerpainter, commercial buildingspainter, commercial constructionpainter, constructionpainter-decoratorpainter, industrial constructionpainter, maintenancepainter, residential constructionpaperhangerplant maintenance painterresidential construction painterresidential painterroof painterrough painter - constructionspecialized painter and decorator",
    "workers": 2875,
    "minEduc": 2,
    "yearsStudy": 3.295698925,
    "automationRisk": 0.93,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 25,
    "totalSkill": 131.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 27.04,
    "skillsComp": 30.5,
    "skillsLogi": 37,
    "skillsMath": 17,
    "skillsLang": 47,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 13.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 10,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 9.5,
    "s13DocumentUse": 16.5,
    "s14Writing": 10.5,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 195,
    "f2Engineering": 105,
    "f3Humanities": 55,
    "f4SocialScience": 35,
    "f5FineArts": 205,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1705,
    "f8Education(teachertraining)": 0,
    "f9Law": 100,
    "f10Health": 15,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 290,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 55,
    "d5SocialSciences": 35,
    "d6Fine&AppliedArts": 205,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1705,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 105,
    "d11Law": 100,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 15,
    "d14Theology": 0,
    "d15PhysicalSciences": 195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 290,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 355,
    "noc": 7295,
    "job": "Floor covering installers",
    "title1": "apprentice floor covering installer",
    "title2": "broadloom installer",
    "title3": "carpet installer",
    "allTitles": "apprentice floor covering installerbroadloom installercarpet installercarpet layercomposition floor layerfloor and wall covering installer, residentialfloor covering installerfloor covering installer apprenticefloor covering mechanicfloor layerfloor sheeting layerfloor tile layerhardwood floor covering installerhardwood floor layerjourneyman floor covering installerjourneyman floor mechanicjourneyman/woman floor covering installerjourneyman/woman floor mechanicjourneywoman floor covering installerjourneywoman floor mechaniclinoleum floor covering installerlinoleum floor covering layerlinoleum floor installerlinoleum floor layerparquet floor layerresidential floor and wall covering installerresidential wall and floor covering installerresilient floor installerresilient floor layerrug installerrug layervinyl floor installervinyl floor layervinyl tile layerwall and floor covering installer, residentialwood floor covering layerwood floor installer",
    "workers": 615,
    "minEduc": 2,
    "yearsStudy": 1.066666667,
    "automationRisk": 0.803,
    "salaryLow": 17,
    "salaryMed": 29.71,
    "salaryHigh": 37.14,
    "totalSkill": 102,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 29.71,
    "skillsComp": 35,
    "skillsLogi": 20,
    "skillsMath": 23,
    "skillsLang": 24,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 4,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 9,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 4,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 14,
    "s14Writing": 2,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 530,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 530,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 356,
    "noc": 7301,
    "job": "Contractors and supervisors, mechanic trades",
    "title1": "air conditioning and refrigeration contractor",
    "title2": "air conditioning mechanics foreman",
    "title3": "air conditioning mechanics foreman/woman",
    "allTitles": "air conditioning and refrigeration contractorair conditioning mechanics foremanair conditioning mechanics foreman/womanair conditioning mechanics forewomanaircraft engine assemblers foremanaircraft engine assemblers foreman/womanaircraft engine assemblers forewomanaircraft engine assembly foremanaircraft engine assembly foreman/womanaircraft engine assembly forewomanaircraft engine fitters foremanaircraft engine fitters foreman/womanaircraft engine fitters forewomanaircraft engine overhaul foremanaircraft engine overhaul foreman/womanaircraft engine overhaul forewomanaircraft engine repair foremanaircraft engine repair foreman/womanaircraft engine repair forewomanaircraft hydraulics repair shop foremanaircraft hydraulics repair shop foreman/womanaircraft hydraulics repair shop forewomanaircraft maintenance chiefaircraft maintenance engineer (AME) chiefaircraft maintenance engineers (AME) supervisoraircraft maintenance mechanics foreman - aircraft mechanical systemsaircraft maintenance mechanics foreman/woman - aircraft mechanical systemsaircraft maintenance mechanics forewoman - aircraft mechanical systemsaircraft maintenance service supervisoraircraft maintenance supervisor - aircraft mechanical systemsaircraft maintenance supervisor, mechanical systemsaircraft mechanical systems maintenance service supervisoraircraft mechanical systems maintenance supervisoraircraft mechanical systems mechanics foremanaircraft mechanical systems mechanics foreman/womanaircraft mechanical systems mechanics forewomanaircraft mechanics and inspectors foremanaircraft mechanics and inspectors foreman - mechanical systemsaircraft mechanics and inspectors foreman/womanaircraft mechanics and inspectors foreman/woman - mechanical systemsaircraft mechanics and inspectors forewomanaircraft mechanics and inspectors forewoman - mechanical systemsaircraft mechanics and repairers foreman - mechanical systemsaircraft mechanics and repairers foreman/woman - mechanical systemsaircraft mechanics and repairers forewoman - mechanical systemsaircraft mechanics foremanaircraft mechanics foreman/womanaircraft mechanics forewomanaircraft propeller repair foremanaircraft propeller repair foreman/womanaircraft propeller repair forewomanaircraft servicing foremanaircraft servicing foreman/womanaircraft servicing forewomanaircraft servicing supervisorAME (aircraft maintenance engineer) chiefappliance repair contractorappliance repair shop foremanappliance repair shop foreman/womanappliance repair shop forewomanappliance repair shop supervisorassembly foreman, industrial machineryassembly foreman, machineryassembly foreman/woman, industrial machineryassembly foreman/woman, machineryassembly forewoman, industrial machineryassembly forewoman, machineryassembly mechanics foremanassembly mechanics foreman/womanassembly mechanics forewomanautomobile mechanics foremanautomobile mechanics foreman/womanautomobile mechanics forewomanautomotive body repair foremanautomotive body repair foreman/womanautomotive body repair forewomanautomotive body repair shop supervisorautomotive body shop foremanautomotive body shop foreman/womanautomotive body shop forewomanautomotive body shop supervisorautomotive engine repair foremanautomotive engine repair foreman/womanautomotive engine repair forewomanautomotive repair and service shop supervisorautomotive service mechanics foremanautomotive service mechanics foreman/womanautomotive service mechanics forewomanautomotive service mechanics supervisorautomotive testing shop supervisorboat engine repair foremanboat engine repair foreman/womanboat engine repair forewomanbody shop foremanbody shop foreman/womanbody shop forewomanbody shop supervisorbus and truck repair foremanbus and truck repair foreman/womanbus and truck repair forewoman",
    "workers": 2765,
    "minEduc": 0,
    "yearsStudy": 1.673913043,
    "automationRisk": 0.676,
    "salaryLow": 16.5,
    "salaryMed": 28,
    "salaryHigh": 51,
    "totalSkill": 133,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 28,
    "skillsComp": 36,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 2245,
    "f2Engineering": 230,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 260,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 30,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 260,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 230,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 2245,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 30,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 357,
    "noc": 7302,
    "job": "Contractors and supervisors, heavy equipment operator crews",
    "title1": "airport road paving foreman",
    "title2": "airport road paving foreman/woman",
    "title3": "airport road paving forewoman",
    "allTitles": "airport road paving foremanairport road paving foreman/womanairport road paving forewomanairport runways road foremanairport runways road foreman/womanairport runways road forewomanasphalt paving foremanasphalt paving foreman/womanasphalt paving forewomanasphalt paving labour gang foremanasphalt paving labour gang foreman/womanasphalt paving labour gang forewomanblasters foreman - constructionblasters foreman/woman - constructionblasters forewoman - constructionbridge and highway construction gang foremanbridge and highway construction gang foreman/womanbridge and highway construction gang forewomanbridge construction foremanbridge construction foreman/womanbridge construction forewomanbuilding mover contractorbuilding movers foremanbuilding movers foreman/womanbuilding movers forewomanbuilding moving foremanbuilding moving foreman/womanbuilding moving forewomanbuilding wrecking contractorbuilding wrecking foremanbuilding wrecking foreman/womanbuilding wrecking forewomancargo handling supervisorconcrete-laying gang foremanconcrete-laying gang foreman/womanconcrete-laying gang forewomanconcrete paving foremanconcrete paving foreman/womanconcrete paving forewomanconcrete-paving labour gang foremanconcrete-paving labour gang foreman/womanconcrete-paving labour gang forewomanconstruction gang foremanconstruction gang foreman/womanconstruction gang forewomanconstruction site foremanconstruction site foreman/womanconstruction site forewomancontractor, excavatingcontractor, water well drillingcontractor, well diggingcontractor, well drillingcrane crew foremancrane crew foreman/womancrane crew forewomandemolition contractordemolition foremandemolition foreman/womandemolition forewomanditching foremanditching foreman/womanditching forewomandock foreman - marine cargodock foreman/woman - marine cargodock forewoman - marine cargodredgemaster - constructiondredging equipment operators foremandredging equipment operators foreman/womandredging equipment operators forewomandredging foremandredging foreman/womandredging forewomandrilling and blasting foreman - constructiondrilling and blasting foreman/woman - constructiondrilling and blasting forewoman - constructiondynamiters foreman - constructiondynamiters foreman/woman - constructiondynamiters forewoman - constructiondynamiting foreman - constructiondynamiting foreman/woman - constructiondynamiting forewoman - constructionexcavating and grading labour foremanexcavating and grading labour foreman/womanexcavating and grading labour forewomanexcavating contractorexcavating equipment operators foremanexcavating equipment operators foreman/womanexcavating equipment operators forewomanexcavating, grading and paving foremanexcavating, grading and paving foreman/womanexcavating, grading and paving forewomanexcavating, grading and related work foremanexcavating, grading and related work foreman/womanexcavating, grading and related work forewomanexcavations superintendentexcavator foremanexcavator foreman/womanexcavator forewomanforeman, asphalt pavingforeman, blasters - construction",
    "workers": 2035,
    "minEduc": 0,
    "yearsStudy": 1.576271186,
    "automationRisk": 0.719,
    "salaryLow": 18,
    "salaryMed": 35,
    "salaryHigh": 48.08,
    "totalSkill": 135,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 35,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 20,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 18,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 540,
    "f2Engineering": 560,
    "f3Humanities": 0,
    "f4SocialScience": 15,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 770,
    "f8Education(teachertraining)": 0,
    "f9Law": 85,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 65,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 25,
    "d4Humanities": 0,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 770,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 535,
    "d11Law": 85,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 540,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 65,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 358,
    "noc": 7303,
    "job": "Camera, platemaking and other prepress occupations",
    "title1": "binders foreman - printing",
    "title2": "binders foreman/woman - printing",
    "title3": "binders forewoman - printing",
    "allTitles": "binders foreman - printingbinders foreman/woman - printingbinders forewoman - printingbinders supervisor - printingbindery foreman - printingbindery foreman/woman - printingbindery forewoman - printingbindery supervisor - printingbindery workers supervisor - printingcomposing foreman - printingcomposing foreman/woman - printingcomposing forewoman - printingcomposing room supervisor - printingcompositors foreman - printingcompositors foreman/woman - printingcompositors forewoman - printingcompositors supervisor - printingengravers foreman (except photoengravers) - printingengravers foreman/woman (except photoengravers) - printingengravers forewoman (except photoengravers) - printingengraving foreman (except photoengraving) - printingengraving foreman/woman (except photoengraving) - printingengraving forewoman (except photoengraving) - printingfilm developers foremanfilm developers foreman/womanfilm developers forewomanfilm developers supervisorfilm printers foremanfilm printers foreman/womanfilm printers forewomanfilm printing foremanfilm printing foreman/womanfilm printing forewomanfilm printing supervisorfilm processing foremanfilm processing foreman/womanfilm processing forewomanfilm processing supervisorfilm processors foremanfilm processors foreman/womanfilm processors forewomanfilm processors supervisorfilmsetter operators supervisorfilmsetters supervisorfinishing foreman - printingfinishing foreman/woman - printingfinishing forewoman - printingfinishing supervisor - printingforeman, binders - printingforeman, bindery - printingforeman, composing - printingforeman, compositors - printingforeman, engravers (except photoengravers) - printingforeman, engraving (except photoengraving) - printingforeman, film developersforeman, film printersforeman, film printingforeman, film processingforeman, film processorsforeman, finishing - printingforeman, hot composition - printingforeman, letterpress - printingforeman, letterpress roomforeman, offset lithography - printingforeman, offset press operators - printingforeman, offset press - printingforeman, OptiCopy and stripping - printingforeman, photoengraversforeman, photographic and film processingforeman, photographic processing and finishingforeman, pressroom - printingforeman, printersforeman, printing shopforeman, rotogravureforeman, rotogravure pressmen/women - printingforeman, rotogravure press operators - printingforeman, stereotypists and electroplatersforeman, typesetters - printingforeman/woman, binders - printingforeman/woman, bindery - printingforeman/woman, composing - printingforeman/woman, compositors - printingforeman/woman, engravers (except photoengravers) - printingforeman/woman, engraving (except photoengraving) - printingforeman/woman, film developersforeman/woman, film printersforeman/woman, film printingforeman/woman, film processingforeman/woman, film processorsforeman/woman, finishing - printingforeman/woman, hot composition - printingforeman/woman, letterpress - printingforeman/woman, letterpress roomforeman/woman, offset lithography - printingforeman/woman, offset press operators - printingforeman/woman, offset press - printingforeman/woman, OptiCopy and stripping - printingforeman/woman, photoengraversforeman/woman, photographic and film processingforeman/woman, photographic processing and finishing",
    "workers": 605,
    "minEduc": 0.5,
    "yearsStudy": 1.762820513,
    "automationRisk": 0.503,
    "salaryLow": 14,
    "salaryMed": 28.85,
    "salaryHigh": 38,
    "totalSkill": 148.5,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 25.135,
    "skillsComp": 44,
    "skillsLogi": 34,
    "skillsMath": 21,
    "skillsLang": 50,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 11,
    "s10Reading": 17.5,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 18,
    "s13DocumentUse": 21,
    "s14Writing": 16.5,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 165,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 165,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 359,
    "noc": 7304,
    "job": "Supervisors, railway transport operations",
    "title1": "foreman/woman � railway transport freight train road foreman/woman passenger train road foreman/woman railway transport operating support foreman/woman railway transport operations foreman/woman railway transport operations supervisor road foreman/woman � railway transport station agent � railway transport stationmaster stationmaster � railway transport trainmaster yard foreman/woman � railway yardmaster � railway",
    "title2": 0,
    "title3": 0,
    "allTitles": "foreman/woman � railway transport freight train road foreman/woman passenger train road foreman/woman railway transport operating support foreman/woman railway transport operations foreman/woman railway transport operations supervisor road foreman/woman � railway transport station agent � railway transport stationmaster stationmaster � railway transport trainmaster yard foreman/woman � railway yardmaster � railway",
    "workers": 1665,
    "minEduc": 0.125,
    "yearsStudy": 1.800034811,
    "automationRisk": 0.606875,
    "salaryLow": 24.85,
    "salaryMed": 40.04,
    "salaryHigh": 66.99,
    "totalSkill": 140,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 30.06363649,
    "skillsComp": 39,
    "skillsLogi": 34.5,
    "skillsMath": 20,
    "skillsLang": 46.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5.125,
    "s2DecisionMaking": 9.25,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7.25,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4.375,
    "s8OralCommunication": 14.75,
    "s9ProblemSolving": 9.625,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 5.25,
    "s12DigitalTechnology": 15.625,
    "s13DocumentUse": 18.5,
    "s14Writing": 13.5,
    "s15CriticalThinking": 6.125,
    "f1Science&Agriculture": 715,
    "f2Engineering": 197.5,
    "f3Humanities": 0,
    "f4SocialScience": 3.75,
    "f5FineArts": 41.25,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 257.5,
    "f8Education(teachertraining)": 0,
    "f9Law": 21.25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 62.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 6.25,
    "d4Humanities": 0,
    "d5SocialSciences": 3.75,
    "d6Fine&AppliedArts": 41.25,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 257.5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 191.25,
    "d11Law": 21.25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 715,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 62.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 360,
    "noc": 7305,
    "job": "Supervisors, motor transport and other ground transit operators",
    "title1": "bus dispatcher",
    "title2": "bus drivers supervisor",
    "title3": "bus inspector",
    "allTitles": "bus dispatcherbus drivers supervisorbus inspectorbus inspector-dispatcherchauffeurs and taxi drivers supervisorchauffeurs supervisorcontroller, subwaydelivery drivers foremandelivery drivers foreman/womandelivery drivers forewomandelivery drivers supervisordispatcher, busdriver-salesmen/women supervisorforeman, delivery driversforeman, light rail transit (LRT) operatorsforeman, truck driversforeman, truck fleetforeman, urban transit systemforeman/woman, delivery driversforeman/woman, light rail transit (LRT) operatorsforeman/woman, truck driversforeman/woman, truck fleetforeman/woman, urban transit systemforewoman, delivery driversforewoman, light rail transit (LRT) operatorsforewoman, truck driversforewoman, truck fleetforewoman, urban transit systemground transit inspector - public transitinspector, businspector-dispatcher, businspector, ground transit - public transitinspector, transit systemlight rail transit (LRT) operators foremanlight rail transit (LRT) operators foreman/womanlight rail transit (LRT) operators forewomanlight rail transit (LRT) operators supervisorLRT (light rail transit) operators foremanLRT (light rail transit) operators foreman/womanLRT (light rail transit) operators forewomanLRT (light rail transit) operators supervisormobile canteen service supervisormobile inspector, transitmoving van drivers supervisorroute foreman, motor transportroute foreman/woman, motor transportroute forewoman, motor transportschool bus drivers supervisorstreetcar and subway operators supervisorstreetcar operators supervisorstreet railway and subway operators supervisorstreet railway operators supervisorsubway and streetcar operators supervisorsubway and street railway operators supervisorsubway controllersubway operators foremansubway operators foreman/womansubway operators forewomansubway operators supervisorsubway system traffic controllersubway traffic controllersupervisor, bus driverssupervisor, chauffeurssupervisor, delivery driverssupervisor, driver-salesmen/womensupervisor, light rail transit (LRT) operatorssupervisor, moving van driverssupervisor, school bus driverssupervisor, street railway operatorssupervisor, subway and street railway operatorssupervisor, subway operatorssupervisor, taxi drivers and private chauffeurssupervisor, truck driverstaxi and chauffeurs supervisorterminal supervisor - motor transporttraffic controller, subway systemtraffic inspector - public transit systemtraffic supervisor - motor transporttransit system inspectortruck drivers foremantruck drivers foreman/womantruck drivers forewomantruck drivers supervisortruck driver-supervisortruck fleet foremantruck fleet foreman/womantruck fleet forewomantrucking contractorurban transit system foremanurban transit system foreman/womanurban transit system forewoman",
    "workers": 1255,
    "minEduc": 0,
    "yearsStudy": 2.187134503,
    "automationRisk": 0.5295,
    "salaryLow": 18.3375,
    "salaryMed": 32.9725,
    "salaryHigh": 51.0175,
    "totalSkill": 143.5,
    "industry": "Education, law & social, community & government",
    "industryNum": 5,
    "sector": "Care providers and educational, legal and public protection support occupations",
    "cluster": 5,
    "wage": 32.11954594,
    "skillsComp": 39,
    "skillsLogi": 36,
    "skillsMath": 20,
    "skillsLang": 48,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9.5,
    "s10Reading": 19.5,
    "s11SchedulingorBudgetingandAccounting": 5.5,
    "s12DigitalTechnology": 16.5,
    "s13DocumentUse": 17,
    "s14Writing": 13.5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 75,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 140,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 75,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 140,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 361,
    "noc": 7311,
    "job": "Construction millwrights and industrial mechanics",
    "title1": "adjuster, knitting machines - textile manufacturing",
    "title2": "ammunition-assembling machine adjuster",
    "title3": "ammunition-loading machine adjuster",
    "allTitles": "adjuster, knitting machines - textile manufacturingammunition-assembling machine adjusterammunition-loading machine adjusterapprentice industrial mechanicapprentice millwrightautomatic knitting machine pattern setterbakery machinery mechanicboilerhouse machinery mechanicbraiding machine settercanal equipment mechaniccan seamer machine repairercan seamer machine repairmancan seamer machine repairwomancard fixercard fixer - textile manufacturingcard grindercard grinder - textile manufacturingcarding machine fixer - textile manufacturingcard setter - textile manufacturingcarpet loom fixer - textile manufacturingcarpet loom setter - textile manufacturingcarton-forming machine repairercarton-forming machine repairmancarton-forming machine repairwomanchemical plant service mechanicchemical process equipment mechaniccomb fixer - textile manufacturingcomb setter - textile manufacturingcompressed gas plant maintenance mechanicconcentrating plant mechanicconstruction millwrightconveyor repairerconveyor repairmanconveyor repairwomancutting machine fixer - textile manufacturingdairy equipment repairerdairy equipment repairmandairy equipment repairwomanderrick mechanicequipment mechanic, nuclear power stationfabric-shearing machine fixer - textile manufacturingfabric-shearing machine setter-fixer - textile manufacturingfabric-shearing machine setter - textile manufacturingfactory maintenance mechanicfibreglass-forming machine repairerfibreglass-forming machine repairmanfibreglass-forming machine repairwomanfixer, cards - textile manufacturingfixer, carpet looms - textile manufacturingfixer, cutting machines - textile manufacturingfixer, fabric-shearing machines - textile manufacturingfixer, jacquard looms - textile manufacturingfixer, loopers - textile manufacturingfixer, quillers - textile manufacturingfixer, shearing machine - textile manufacturingfixer, shuttles - textile manufacturingfixer, spinning frames - textile manufacturingfixer, spinning machines - textile manufacturingfixer, textile machineryfixer, winding machines - textile manufacturingflyer repairer - textile manufacturingflyer repairman - textile manufacturingflyer repairwoman - textile manufacturingforge equipment repairerforge equipment repairmanforge equipment repairwomanforge shop machinery mechanicforge shop machinery repairerforge shop machinery repairmanforge shop machinery repairwomangas turbine repairergas turbine repairmangas turbine repairwomangrain elevator maintenance mechanicgum-wrapping machine mechanicheavy water plant mechanical maintainerhook repairer - textile manufacturinghook repairman - textile manufacturinghook repairwoman - textile manufacturingindustrial hoist mechanicindustrial machinery maintenance mechanicindustrial mechanicindustrial mechanic and millwrightindustrial mechanic apprenticeindustrial mechanic, gas turbine machineryindustrial mechanic, mine hoistsindustrial mechanic, petroleum refineryindustrial mechanic-welderindustrial plant maintenance mechanicindustrial pump repairerindustrial pump repairmanindustrial pump repairwomanindustrial sewing machine mechanicinstaller and repairer, automatic pinsetting machinesinstaller and repairman, automatic pinsetting machinesinstaller and repairwoman, automatic pinsetting machinesjacquard loom fixer - textile manufacturingjacquard loom setter - textile manufacturingjourneyman industrial mechanicjourneyman/woman industrial mechanic",
    "workers": 19565,
    "minEduc": 2,
    "yearsStudy": 1.984251969,
    "automationRisk": 0.63,
    "salaryLow": 16,
    "salaryMed": 29.5,
    "salaryHigh": 39,
    "totalSkill": 136,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 29.5,
    "skillsComp": 45,
    "skillsLogi": 33,
    "skillsMath": 17,
    "skillsLang": 41,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 7,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 19,
    "s14Writing": 10,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 15305,
    "f2Engineering": 2485,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 1550,
    "f8Education(teachertraining)": 0,
    "f9Law": 75,
    "f10Health": 30,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 100,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 1550,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 2485,
    "d11Law": 75,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 30,
    "d14Theology": 0,
    "d15PhysicalSciences": 15275,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 100,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 362,
    "noc": 7312,
    "job": "Heavy-duty equipment mechanics",
    "title1": "agricultural equipment technician",
    "title2": "apprentice farm equipment mechanic",
    "title3": "apprentice farm machinery mechanic",
    "allTitles": "agricultural equipment technicianapprentice farm equipment mechanicapprentice farm machinery mechanicapprentice mechanic, diesel enginesapprentice mechanic, farm equipmentapprentice mechanic, farm machinerybackhoe mechaniccaterpillar tractor repairercaterpillar tractor repairmancaterpillar tractor repairwomancombination mechanic, heavy equipmentconstruction equipment mechanicconstruction equipment repairmanconstruction equipment repairman/womanconstruction equipment repairwomancrane repairercrane repairmancrane repairwomancrane service techniciandiesel engine mechanicdiesel engine mechanic apprenticediesel engine mechanic - heavy equipmentdiesel engine repairman - railwaydiesel engine repairman/woman - railwaydiesel engine repairwoman - railwaydiesel locomotive repairmandiesel locomotive repairman/womandiesel locomotive repairwomandiesel mechanicdiesel mechanic apprenticediesel mechanic - heavy equipmentdredge mechanicdredge repairerdredge repairmandredge repairwomanearthmoving equipment mechanicexcavating equipment mechanicfarm equipment mechanicfarm equipment technicianfarm machinery mechanicfarm tractor mechanicfarm tractor repairerfarm tractor repairmanfarm tractor repairwomanfelling equipment mechanicfield mechanic, heavy equipmentfuel injection unit serviceman - dieselfuel injection unit servicer - dieselfuel injection unit servicewoman - dieselgrading equipment mechanicheavy diesel engine mechanicheavy-duty equipment mechanicheavy-duty equipment mechanic apprenticeheavy-duty equipment technicianheavy-duty equipment technician apprenticeheavy equipment combination mechanicheavy equipment field mechanicheavy equipment inspector-repairerheavy equipment inspector-repairmanheavy equipment inspector-repairwomanheavy equipment mechanicheavy equipment mechanic - diesel engineheavy mobile equipment repairerheavy mobile equipment repairmanheavy mobile equipment repairman/womanheavy mobile equipment repairwomanheavy mobile logging equipment mechanicheavy mobile mining equipment mechanicinspector-repairer, heavy equipmentinspector-repairman, heavy equipmentinspector-repairwoman, heavy equipmentjourneyman heavy-duty equipment mechanicjourneyman/woman heavy-duty equipment mechanicjourneywoman heavy-duty equipment mechaniclocomotive mechaniclocomotive repairman, diesellocomotive repairman/woman, diesellocomotive repairwoman, dieselmechanic, backhoemechanic, construction equipmentmechanic, earthmoving equipmentmechanic, excavating equipmentmechanic, farm equipmentmechanic, farm machinerymechanic, farm tractorsmechanic, heavy diesel enginesmechanic, heavy equipmentmechanic, heavy equipment - diesel enginemechanic, locomotivemechanic, mobile logging equipmentmechanic, mobile mining equipmentmechanic, repairermechanic, repairmanmechanic, repairwomanmechanic, sideboommechanic, tractormine locomotive repairmanmine locomotive repairman/womanmine locomotive repairwomanmobile farm equipment mechanic",
    "workers": 5945,
    "minEduc": 2,
    "yearsStudy": 1.616666667,
    "automationRisk": 0.67,
    "salaryLow": 18,
    "salaryMed": 28.85,
    "salaryHigh": 39,
    "totalSkill": 129,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 28.85,
    "skillsComp": 43,
    "skillsLogi": 28,
    "skillsMath": 13,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 6,
    "s10Reading": 24,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 23,
    "s13DocumentUse": 14,
    "s14Writing": 9,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 5370,
    "f2Engineering": 285,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 290,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 405,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 290,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 285,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 4965,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 363,
    "noc": 7313,
    "job": "Heating, refrigeration and air conditioning mechanics",
    "title1": "air conditioning and heating mechanic",
    "title2": "air conditioning and refrigeration mechanic",
    "title3": "apprentice mechanic, refrigeration",
    "allTitles": "air conditioning and heating mechanicair conditioning and refrigeration mechanicapprentice mechanic, refrigerationapprentice refrigeration and air conditioning mechaniccentral air conditioner installercentral air conditioner repairercentral air conditioner repairmancentral air conditioner repairwomancentral air conditioning installercentral air conditioning mechaniccentral air conditioning repairercentral air conditioning repairmancentral air conditioning repairwomancentral air conditioning servicercommercial air conditioning mechaniccommercial refrigeration mechanicheating and air conditioning mechanicheating and cooling mechanicheating, ventilation and air conditioning (HVAC) mechanicHVAC (heating, ventilation and air conditioning) mechanicjourneyman refrigeration and air conditioning mechanicjourneyman/woman refrigeration and air conditioning mechanicjourneywoman refrigeration and air conditioning mechanicmechanic, central air conditioningmechanic, commercial air conditioningmechanic, heating and air conditioningmechanic, heating and coolingmechanic, HVAC (heating, ventilation and air conditioning)mechanic, refrigerationmechanic, refrigeration and air conditioningrefrigeration and air conditioning mechanicrefrigeration and air conditioning mechanic apprenticerefrigeration and air conditioning mechanic (non-construction)refrigeration and mechanical technicianrefrigeration mechanicrefrigeration mechanic apprenticerefrigeration system installerrefrigeration technicianrepairer, central air conditioningrepairman, central air conditioningrepairwoman, central air conditioningservicer, central air conditioningtransport refrigeration mechanictransport refrigeration technician",
    "workers": 16030,
    "minEduc": 1,
    "yearsStudy": 2.430674847,
    "automationRisk": 0.71,
    "salaryLow": 16,
    "salaryMed": 30,
    "salaryHigh": 46,
    "totalSkill": 137.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 28,
    "skillsComp": 40.5,
    "skillsLogi": 35,
    "skillsMath": 23,
    "skillsLang": 39,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 4.5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 17.5,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 8.5,
    "f1Science&Agriculture": 6025,
    "f2Engineering": 1600,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 895,
    "f8Education(teachertraining)": 0,
    "f9Law": 50,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 895,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1600,
    "d11Law": 50,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 6025,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 364,
    "noc": 7314,
    "job": "Railway carmen/women",
    "title1": "air brake inspector - railway car",
    "title2": "apprentice carman",
    "title3": "apprentice carman/woman - railway",
    "allTitles": "air brake inspector - railway carapprentice carmanapprentice carman/woman - railwayapprentice carwomanbrake inspector - railway carcar inspector - railwaycarman inspector - railwaycarman - railwaycarman/woman inspector - railwaycarman/woman - railwaycar repairer apprentice - railwaycar repairer - railwaycar repairman apprentice - railwaycar repairman - railwaycar repairwoman apprentice - railwaycar repairwoman - railwaycarwoman inspector - railwaycarwoman - railwaycoach repairer, railwaycoach repairman, railwaycoach repairwoman, railwayinspector-carman - railwayinspector-carman/woman - railwayinspector, cars - railwayinspector-carwoman - railwaymechanic, streetcarsrailcar mechanic apprenticerail vehicle mechanicrailway car inspectorrailway carmanrailway carman apprenticerailway carman inspectorrailway carman/womanrailway carman/woman apprenticerailway carman/woman inspectorrailway carwomanrailway carwoman apprenticerailway carwoman inspectorrailway coach repairerrailway coach repairmanrailway coach repairwomanrailway equipment inspectorstreetcar and subway car mechanicstreetcar mechanicsubway car mechanicwheel and axle inspector - railway",
    "workers": 310,
    "minEduc": 2,
    "yearsStudy": 1.181818182,
    "automationRisk": 0.735,
    "salaryLow": 26.62,
    "salaryMed": 31.76,
    "salaryHigh": 35.28,
    "totalSkill": 103,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 31.76,
    "skillsComp": 28,
    "skillsLogi": 28,
    "skillsMath": 17,
    "skillsLang": 30,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Measurement and Calculation",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 11,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 7,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 15,
    "s14Writing": 7,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 240,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 240,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 365,
    "noc": 7315,
    "job": "Aircraft mechanics and aircraft inspectors",
    "title1": "accessories overhaul mechanic, aircraft",
    "title2": "accessories overhaul technician, aircraft",
    "title3": "aero-engine mechanic",
    "allTitles": "accessories overhaul mechanic, aircraftaccessories overhaul technician, aircraftaero-engine mechanicaero-engine technicianaircraft accessories mechanicaircraft accessories overhaul mechanicaircraft accessories repaireraircraft accessories repairmanaircraft accessories repairman/womanaircraft accessories repairwomanaircraft body repaireraircraft body repairmanaircraft body repairwomanaircraft composite and sheet metal repaireraircraft composite and sheet metal repairmanaircraft composite and sheet metal repairwomanaircraft engine inspectoraircraft engine mechanicaircraft engine mechanical systems technicianaircraft engine overhaul inspectoraircraft engine overhaul inspector, mechanical systemsaircraft engine overhaul mechanicaircraft engine repair and overhaul mechanicaircraft engine testeraircraft gas turbine engine technicianaircraft hydraulics inspectoraircraft hydraulics mechanicaircraft hydraulics shop technicianaircraft hydraulics technicianaircraft hydraulics testeraircraft inspectoraircraft inspector, mechanical systemsaircraft maintenance engineer (AME) (except avionics)aircraft maintenance engineer (AME), mechanical systemsaircraft maintenance engineer (AME), rotorcraftaircraft maintenance engineer (AME), structuresaircraft maintenance engineer (except avionics)aircraft maintenance mechanic apprenticeaircraft maintenance technicianaircraft mechanicaircraft mechanical and fuel systems overhaul and repair mechanicaircraft mechanical systems inspectoraircraft mechanical systems mechanicaircraft mechanical systems preflight mechanicaircraft mechanical systems repair inspectoraircraft mechanical systems repair shop inspectoraircraft mechanical systems technicianaircraft mechanic, engine accessories overhaulaircraft mechanic, engine overhaulaircraft mechanic experimentalaircraft mechanic, flight testsaircraft mechanic learneraircraft mechanic, mechanical systemsaircraft mechanic, power plantaircraft plumbing and hydraulics mechanicaircraft propeller systems technicianaircraft reciprocating engine technicianaircraft repair and overhaul inspectoraircraft repair shop inspectoraircraft safety systems mechanicaircraft sheet metal technicianaircraft skin repaireraircraft skin repairmanaircraft skin repairwomanaircraft structural repair technicianaircraft structural technicianaircraft systems inspectoraircraft technician, accessories overhaulaircraft technician, gas turbine enginesaircraft technician, mechanical systemsaircraft technician, propeller systemsaircraft technician, propulsionairframe mechanicAME (aircraft maintenance engineer) (except avionics)AME (aircraft maintenance engineer), mechanical systemsAME (aircraft maintenance engineer), rotorcraftAME (aircraft maintenance engineer), structuresapprentice aircraft maintenance engineer (AME)apprentice aircraft mechanical systems mechanicapprentice aircraft mechanic, mechanical systemsapprentice AME (aircraft maintenance engineer)aviation maintenance inspectoraviation mechanical component shop techniciancertified aircraft techniciancomposite and sheet metal repairer, aircraftcomposite and sheet metal repairman, aircraftcomposite and sheet metal repairwoman, aircraftcomposite repair technicianengine accessories overhaul mechanicengine inspector, aircraftengine mechanic, aircraftengine overhaul inspector, aircraft mechanical systemsengine overhaul mechanic, aircraftengine repair and overhaul mechanic, aircraftengine tester, aircraftexperimental aircraft mechanicflight line mechanicflight test inspectorflight test inspector, mechanical systemsflight test mechanic, aircraft",
    "workers": 2285,
    "minEduc": 2,
    "yearsStudy": 2.193548387,
    "automationRisk": 0.71,
    "salaryLow": 15,
    "salaryMed": 23,
    "salaryHigh": 30,
    "totalSkill": 121,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 23,
    "skillsComp": 36,
    "skillsLogi": 34,
    "skillsMath": 15,
    "skillsLang": 36,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Critical Thinking",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 7,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 20,
    "s14Writing": 9,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 1840,
    "f2Engineering": 370,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 75,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 370,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 1840,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 366,
    "noc": 7316,
    "job": "Machine fitters",
    "title1": "agricultural machinery builder",
    "title2": "agricultural machinery fitter",
    "title3": "aircraft engine fitter",
    "allTitles": "agricultural machinery builderagricultural machinery fitteraircraft engine fitterassembly fitterassembly fitter, aircraft enginescharge hand, machine fitterschemical-processing machine buildercompressor fittercrane fitterengine fitter, aircraftfarm machinery builderfarm machinery fitterfitter, aircraft enginesfitter, heavy equipmentfitter, heavy machineryfitter, locomotivesfitter, machinefitter, production equipmentfitter, railway coachfitter, ship machineryfood-processing machine fittergrader fitterheavy equipment fitterheavy machinery fitterlead hand, assembly mechanics-fitterslocomotive builderlogging machinery fittermachine buildermachine builder-fittermachine fittermachinery manufacturing fittermachine tool buildermachine tool builder-integratormachine tool integratormanufacturing machinery fittermechanical fittermining machinery fitterproduction equipment fitterpulp and paper machinery buildership engine fittership machinery fittertextile machinery fitterturbine fitter",
    "workers": 365,
    "minEduc": 2,
    "yearsStudy": 1.666666667,
    "automationRisk": 0.81,
    "salaryLow": 14,
    "salaryMed": 23,
    "salaryHigh": 32.1,
    "totalSkill": 102,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 23,
    "skillsComp": 28,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 27,
    "topSkill1": "Document Use",
    "topSkill2": "Measurement and Calculation",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 13,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 5,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 4,
    "s13DocumentUse": 20,
    "s14Writing": 4,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 195,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 170,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 170,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 367,
    "noc": 7318,
    "job": "Elevator constructors and mechanics",
    "title1": "apprentice elevator mechanic",
    "title2": "dumbwaiter installer-repairer",
    "title3": "dumbwaiter installer-repairman",
    "allTitles": "apprentice elevator mechanicdumbwaiter installer-repairerdumbwaiter installer-repairmandumbwaiter installer-repairwomanelevator adjusterelevator builderelevator constructorelevator constructor and mechanic apprenticeelevator constructor-mechanicelevator erectorelevator installerelevator maintenance mechanicelevator mechanicelevator mechanic apprenticeelevator mechanic (non-construction)elevator repairerelevator repairmanelevator repair mechanicelevator repairwomanescalator installerescalator installer-repairerescalator installer-repairmanescalator installer-repairwomanescalator mechanic (non construction)escalator repairerescalator repairmanescalator repairman/womanescalator repairwomaninstaller, elevatorjourneyman elevator constructorjourneyman elevator mechanicjourneyman/woman elevator constructorjourneyman/woman elevator mechanicjourneywoman elevator constructorjourneywoman elevator mechanicmaintenance mechanic, elevatorsmechanic, elevatormoving walkway installer-repairermoving walkway installer-repairmanmoving walkway installer-repairwoman",
    "workers": 1060,
    "minEduc": 2,
    "yearsStudy": 1.473684211,
    "automationRisk": 0.39,
    "salaryLow": 17.60333333,
    "salaryMed": 27.685,
    "salaryHigh": 36.89666667,
    "totalSkill": 114,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 29.65234643,
    "skillsComp": 22,
    "skillsLogi": 39,
    "skillsMath": 13,
    "skillsLang": 40,
    "topSkill1": "Reading",
    "topSkill2": "Problem Solving",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 14,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 7,
    "s13DocumentUse": 13,
    "s14Writing": 9,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 145,
    "f2Engineering": 115,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 800,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 800,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 115,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 145,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 368,
    "noc": 7321,
    "job": "Automotive service technicians, truck and bus mechanics and mechanical repairers",
    "title1": "alignment and brakes technician apprentice mechanic, automotive radiators apprentice mechanic, trucks and transport vehicles apprentice motor vehicle mechanic apprentice repairer, truck trailers automatic transmission mechanic � motor vehicle automatic transmission technician � motor vehicles automobile mechanic automobile service mechanic automotive air conditioning mechanic automotive brake mechanic automotive brake repairer automotive brake specialist automotive carburetor mechanic automotive drive trains technician automotive electrical and tune-up service technician automotive electrical mechanic automotive electrical technician automotive engine mechanic inspector automotive mechanic automotive mechanical repairer automotive radiator mechanic automotive radiator mechanic apprentice automotive radiator repairer automotive repairer automotive service technician automotive service technician � electrical and fuel systems automotive service technician � fuel and electronics systems automotive service technician � steering, suspension and brakes automotive service technician � transmission automotive service technician apprentice automotive technician � air conditioning system automotive technician � automatic transmission systems automotive technician � brakes systems automotive technician � electrical and electronic systems automotive technician � engine and fuel systems automotive technician � front-end systems automotive technician � fuel systems automotive technician � standard transmission systems automotive technician � transmission systems automotive technician, drive trains automotive vehicle tester automotive vehicle testing mechanic brake systems mechanic bus and transport mechanic bus and truck mechanic bus mechanic car mechanic commercial trailer mechanic commercial trailer technician commercial transport vehicle mechanic diagnostic technician � motor vehicles engine mechanic � motor vehicle front-end mechanic fuel and electrical systems technician � motor vehicle garage mechanic mechanic � motor vehicle manufacturing mechanic, automobile mechanic, bus mechanic, car mechanic, motor vehicle mechanic, truck mechanical repairer, motor vehicle mechanical upgrader � motor vehicle manufacturing motor mechanic � motor vehicle manufacturing motor repairer � motor vehicle manufacturing motor vehicle diesel engine mechanic motor vehicle fuel conversion technician motor vehicle fuel-systems and electric-systems mechanic motor vehicle mechanic motor vehicle mechanical repairer motor vehicle technician motor vehicle transmission mechanic new car mechanic repairer, trucks and transport vehicles service technician � motor vehicle repair service technician, after sales service � motor vehicles testing mechanic, automotive vehicles trailer mechanic trailer mechanical systems repairer transmission mechanic transmission technician transport truck mechanic transport truck trailer mechanic trolley engine mechanic truck and coach technician truck and trailer repairer truck and transport mechanic truck and transport service technician truck and transport vehicle mechanic apprentice truck mechanic truck trailer mechanic truck trailer repairer apprentice truck trailer service technician truck-trailer repairer tune-up mechanic � motor vehicle tune-up specialist � motor vehicle wheel alignment and brake mechanic wheel alignment and brake specialist",
    "title2": 0,
    "title3": 0,
    "allTitles": "alignment and brakes technician apprentice mechanic, automotive radiators apprentice mechanic, trucks and transport vehicles apprentice motor vehicle mechanic apprentice repairer, truck trailers automatic transmission mechanic � motor vehicle automatic transmission technician � motor vehicles automobile mechanic automobile service mechanic automotive air conditioning mechanic automotive brake mechanic automotive brake repairer automotive brake specialist automotive carburetor mechanic automotive drive trains technician automotive electrical and tune-up service technician automotive electrical mechanic automotive electrical technician automotive engine mechanic inspector automotive mechanic automotive mechanical repairer automotive radiator mechanic automotive radiator mechanic apprentice automotive radiator repairer automotive repairer automotive service technician automotive service technician � electrical and fuel systems automotive service technician � fuel and electronics systems automotive service technician � steering, suspension and brakes automotive service technician � transmission automotive service technician apprentice automotive technician � air conditioning system automotive technician � automatic transmission systems automotive technician � brakes systems automotive technician � electrical and electronic systems automotive technician � engine and fuel systems automotive technician � front-end systems automotive technician � fuel systems automotive technician � standard transmission systems automotive technician � transmission systems automotive technician, drive trains automotive vehicle tester automotive vehicle testing mechanic brake systems mechanic bus and transport mechanic bus and truck mechanic bus mechanic car mechanic commercial trailer mechanic commercial trailer technician commercial transport vehicle mechanic diagnostic technician � motor vehicles engine mechanic � motor vehicle front-end mechanic fuel and electrical systems technician � motor vehicle garage mechanic mechanic � motor vehicle manufacturing mechanic, automobile mechanic, bus mechanic, car mechanic, motor vehicle mechanic, truck mechanical repairer, motor vehicle mechanical upgrader � motor vehicle manufacturing motor mechanic � motor vehicle manufacturing motor repairer � motor vehicle manufacturing motor vehicle diesel engine mechanic motor vehicle fuel conversion technician motor vehicle fuel-systems and electric-systems mechanic motor vehicle mechanic motor vehicle mechanical repairer motor vehicle technician motor vehicle transmission mechanic new car mechanic repairer, trucks and transport vehicles service technician � motor vehicle repair service technician, after sales service � motor vehicles testing mechanic, automotive vehicles trailer mechanic trailer mechanical systems repairer transmission mechanic transmission technician transport truck mechanic transport truck trailer mechanic trolley engine mechanic truck and coach technician truck and trailer repairer truck and transport mechanic truck and transport service technician truck and transport vehicle mechanic apprentice truck mechanic truck trailer mechanic truck trailer repairer apprentice truck trailer service technician truck-trailer repairer tune-up mechanic � motor vehicle tune-up specialist � motor vehicle wheel alignment and brake mechanic wheel alignment and brake specialist",
    "workers": 4060,
    "minEduc": 2,
    "yearsStudy": 1.380952381,
    "automationRisk": 0.73,
    "salaryLow": 14,
    "salaryMed": 22,
    "salaryHigh": 34.62,
    "totalSkill": 99,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 21,
    "skillsComp": 19,
    "skillsLogi": 33,
    "skillsMath": 11,
    "skillsLang": 36,
    "topSkill1": "Reading",
    "topSkill2": "Problem Solving",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 11,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 8,
    "s13DocumentUse": 10,
    "s14Writing": 5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 3945,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 80,
    "f8Education(teachertraining)": 0,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 80,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 3945,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 369,
    "noc": 7322,
    "job": "Motor vehicle body repairers",
    "title1": "antique car restorer, body",
    "title2": "antique vehicle restorer, body",
    "title3": "apprentice painter - motor vehicle repair",
    "allTitles": "antique car restorer, bodyantique vehicle restorer, bodyapprentice painter - motor vehicle repairapprentice painter, motor vehiclesautobody mechanicautobody repairerautobody repairmanautobody repairwomanautobody technicianautobody technician - collisionautobody technician - refinishingautobody workerauto glass installerautomobile body repairmanautomobile body repairman/womanautomobile body repairwomanautomobile damage repair estimatorautomobile polisher-sander - motor vehicle repairautomotive body mechanicautomotive body painterautomotive body repairerautomotive body repairer-painterautomotive body repairmanautomotive body repairman-painterautomotive body repairwomanautomotive body repairwoman-painterautomotive body technicianautomotive glass technicianautomotive painter apprenticeautomotive painter - motor vehicle repairautomotive painting and refinishing technicianbody and fender repairer - automobilebody and fender repairman - automobilebody and fender repairman/woman - automobilebody and fender repairwoman - automobilebody repairer apprentice, motor vehiclesbody repairer, motor vehiclesbody repairman apprentice, motor vehiclesbody repairman, motor vehiclesbody repairwoman apprentice, motor vehiclesbody repairwoman, motor vehiclescollision repair techniciandamage repair estimator, automobiledent remover and repairer - automobiledent remover and repairman - automobiledent remover and repairwoman - automobiledingman - autobodydingman/woman - autobodydingwoman - autobodyjourneyman motor vehicle body repairerjourneyman/woman motor vehicle body repairerjourneywoman motor vehicle body repairermetal finish and touch-up repairer - motor vehicle manufacturingmetal finish and touch-up repairman - motor vehicle manufacturingmetal finish and touch-up repairwoman - motor vehicle manufacturingmetal finisher - motor vehicle manufacturingmetal repairer - motor vehicle manufacturingmetal repairman - motor vehicle manufacturingmetal repairwoman - motor vehicle manufacturingmetal upgrader - motor vehicle manufacturingmotor repair vehicle painter apprenticemotor vehicle body finishermotor vehicle body repairermotor vehicle body repairer apprenticemotor vehicle body repairer - collisionmotor vehicle body repairer - metal and paintmotor vehicle body repairer - refinishingmotor vehicle body repairmanmotor vehicle body repairman apprenticemotor vehicle body repairman - collisionmotor vehicle body repairman - metal and paintmotor vehicle body repairman - refinishingmotor vehicle body repair-paintermotor vehicle body repairwomanmotor vehicle body repairwoman apprenticemotor vehicle body repairwoman - collisionmotor vehicle body repairwoman - metal and paintmotor vehicle body repairwoman - refinishingmotor vehicle body technicianmotor vehicle body technician - truckmotor vehicle painter - motor vehicle repairpainter, automobiles - motor vehicle repairpainter - motor vehicle repairpainter, motor vehicles - motor vehicle repairrepair shop estimator, automotiveused car renovator",
    "workers": 4060,
    "minEduc": 2,
    "yearsStudy": 1.380952381,
    "automationRisk": 0.73,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 36.06,
    "totalSkill": 99,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 21,
    "skillsComp": 19,
    "skillsLogi": 33,
    "skillsMath": 11,
    "skillsLang": 36,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Problem Solving",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 11,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 8,
    "s13DocumentUse": 10,
    "s14Writing": 5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 3945,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 80,
    "f8Education(teachertraining)": 0,
    "f9Law": 15,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 80,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 15,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 3945,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 370,
    "noc": 7331,
    "job": "Oil and solid fuel heating mechanics",
    "title1": "apprentice mechanic, oil burner",
    "title2": "coal furnace installer",
    "title3": "coal furnace installer-mechanic",
    "allTitles": "apprentice mechanic, oil burnercoal furnace installercoal furnace installer-mechanicforced air furnace installer (except gas)furnace installer and repairer (except gas)furnace installer and repairman (except gas)furnace installer and repairwoman (except gas)furnace maintenance mechanic (except gas)furnace mechanic (except gas)furnace repairer (except gas)furnace repairman (except gas)furnace repairman/woman (except gas)furnace repairwoman (except gas)heating mechanicheating service mechanicheating system mechanicheating systems installerheating systems servicerheating systems technicianheating technicianinstaller and repairer, furnaces (except gas)installer and repairman, furnaces (except gas)installer and repairwoman, furnaces (except gas)installer and servicer, residential oil burnersinstaller, forced air furnace (except gas)installer, solid fuel heatersinstaller, wood burnersoil and solid fuel heating mechanicoil burner apprenticeoil burner installeroil burner installer and repaireroil burner installer and repairmanoil burner installer and repairwomanoil burner maintaineroil burner mechanicoil burner mechanic apprenticeoil burner mechanic, residentialoil burner repaireroil burner repairmanoil burner repairwomanoil burner serviceroil burner technicianoil furnace installerresidential oil burner installer and servicerresidential oil burner mechanicsolid fuel heater installersolid fuel heating installerstoker erectorwood burner installerwood burner maintainerwood-burning appliance installerwood-burning system installerwood furnace installer",
    "workers": 240,
    "minEduc": 2,
    "yearsStudy": 1,
    "automationRisk": 0.65,
    "salaryLow": 14,
    "salaryMed": 24,
    "salaryHigh": 39,
    "totalSkill": 114,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 24,
    "skillsComp": 30,
    "skillsLogi": 34,
    "skillsMath": 20,
    "skillsLang": 30,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 10,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 8,
    "s13DocumentUse": 14,
    "s14Writing": 8,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 185,
    "f2Engineering": 55,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 55,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 185,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 371,
    "noc": 7332,
    "job": "Appliance servicers and repairers",
    "title1": "after-sales service technician � electrical appliances air conditioner repairer � window unit appliance repairer apprentice appliance repairer, gas � customer service appliance service technician appliance service technician apprentice appliance servicer apprentice appliance service technician commercial bakery appliance technician commercial foodservice appliance technician commercial laundry appliance technician dishwasher repairer domestic refrigerator repairer domestic window air conditioner mechanic domestic window air conditioner repairer electric appliance service technician electric dryer repairer electric fireplace servicer electric household appliance servicer electric lawn mower repairer electric refrigerator servicer electric tool repairer electrical appliance repairer electrical appliance serviceman/woman electrical appliance servicer electrical appliance technician gas appliance repairer gas appliance servicer gas appliance servicer � customer service gas fireplace servicer gas stove repairer household electrical appliance repairman/woman household electrical appliance service technician major electric appliance repairer major electrical appliance repairer major electrical appliance servicer portable appliance repairman/woman portable electric household appliance repairer power tool repairer refrigerator repairer refrigerator servicer refrigerator servicer, domestic repairer, air conditioners � window unit repairer, electric lawn mowers repairer, electric tools repairer, major electric household appliances repairer, portable electric household appliances repairman/woman, electric stoves service technician � electrical appliances service technician � gas appliances serviceman/woman, electric stoves stove repairer stove repairman/woman electric stove serviceman/woman electric vacuum cleaner repairer vacuum cleaner repairman/woman vacuum cleaner servicer washing machine repairman/woman washing machine servicer window air conditioner mechanic window air conditioner repairer wood fireplace servicer",
    "title2": 0,
    "title3": 0,
    "allTitles": "after-sales service technician � electrical appliances air conditioner repairer � window unit appliance repairer apprentice appliance repairer, gas � customer service appliance service technician appliance service technician apprentice appliance servicer apprentice appliance service technician commercial bakery appliance technician commercial foodservice appliance technician commercial laundry appliance technician dishwasher repairer domestic refrigerator repairer domestic window air conditioner mechanic domestic window air conditioner repairer electric appliance service technician electric dryer repairer electric fireplace servicer electric household appliance servicer electric lawn mower repairer electric refrigerator servicer electric tool repairer electrical appliance repairer electrical appliance serviceman/woman electrical appliance servicer electrical appliance technician gas appliance repairer gas appliance servicer gas appliance servicer � customer service gas fireplace servicer gas stove repairer household electrical appliance repairman/woman household electrical appliance service technician major electric appliance repairer major electrical appliance repairer major electrical appliance servicer portable appliance repairman/woman portable electric household appliance repairer power tool repairer refrigerator repairer refrigerator servicer refrigerator servicer, domestic repairer, air conditioners � window unit repairer, electric lawn mowers repairer, electric tools repairer, major electric household appliances repairer, portable electric household appliances repairman/woman, electric stoves service technician � electrical appliances service technician � gas appliances serviceman/woman, electric stoves stove repairer stove repairman/woman electric stove serviceman/woman electric vacuum cleaner repairer vacuum cleaner repairman/woman vacuum cleaner servicer washing machine repairman/woman washing machine servicer window air conditioner mechanic window air conditioner repairer wood fireplace servicer",
    "workers": 525,
    "minEduc": 1,
    "yearsStudy": 1.338235294,
    "automationRisk": 0.76925,
    "salaryLow": 14,
    "salaryMed": 19.19,
    "salaryHigh": 29.57,
    "totalSkill": 110,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 22.9642663,
    "skillsComp": 30.5,
    "skillsLogi": 29,
    "skillsMath": 20.25,
    "skillsLang": 30.25,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 5.5,
    "s2DecisionMaking": 7.5,
    "s3FindingInformation": 3,
    "s4JobTaskPlanningandOrganizing": 2.25,
    "s5MeasurementandCalculation": 8.25,
    "s6MoneyMath": 4.25,
    "s7NumericalEstimation": 4.25,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 7.5,
    "s10Reading": 13.5,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 14.75,
    "s14Writing": 7.75,
    "s15CriticalThinking": 8.75,
    "f1Science&Agriculture": 448.75,
    "f2Engineering": 43.75,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 32.5,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 32.5,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 43.75,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 448.75,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 372,
    "noc": 7333,
    "job": "Electrical mechanics",
    "title1": "armature repairman",
    "title2": "armature repairman/woman",
    "title3": "armature repairwoman",
    "allTitles": "armature repairmanarmature repairman/womanarmature repairwomanarmature winder repairerarmature winder repairmanarmature winder repairwomanautomotive-generator and starter repairerautomotive-generator and starter repairmanautomotive-generator and starter repairwomancircuit breaker mechaniccoil connector repairercoil connector repairmancoil connector repairwomancoil winder and repairercoil winder and repairmancoil winder and repairwomanelectrical apparatus mechanicelectrical equipment mechanic traineeelectrical instrument mechanicelectrical mechanicelectrical mechanic apprenticeelectrical mechanic - electrical utilitieselectrical mechanic (except avionics)electrical mechanic, meter repairelectrical mechanics group leaderelectrical mechanics lead handelectrical mechanic, switchgear repairelectrical mechanic traineeelectrical motor coil winder-repairerelectrical motor coil winder-repairmanelectrical motor coil winder-repairwomanelectrical rewind mechanicelectrical transformer repairerelectrical transformer repairmanelectrical transformer repairwomanelectric meter repairerelectric meter repairer apprenticeelectric meter repairmanelectric meter repairman apprenticeelectric meter repairwomanelectric meter repairwoman apprenticeelectric meter technicianelectric motor mechanicelectric motor repairerelectric motor repairer and testerelectric motor repairer-testerelectric motor repairmanelectric motor repairman and testerelectric motor repairman-testerelectric motor repairman/womanelectric motor repairwomanelectric motor repairwoman and testerelectric motor repairwoman-testerelectric motor systems technicianelectric motor winderelectric motor winder-repairergenerator repairergenerator repairmangenerator repairman/womangenerator repairwomangroup leader, electrical mechanicshigh-voltage power transformer repairerhigh-voltage power transformer repairmanhigh-voltage power transformer repairwomanindustrial coil winder-repairerindustrial coil winder-repairmanindustrial coil winder-repairwomanindustrial motor winder-repairerindustrial motor winder-repairmanindustrial motor winder-repairwomanlead hand, electrical mechanicsmechanic, circuit breakermechanic, electric motorsmotor coil winder-repairermotor coil winder-repairmanmotor coil winder-repairwomanpower transformer repairerpower transformer repairmanpower transformer repairman/womanpower transformer repairwomanrepairer, coil connectorsrepairer, electrical instrumentsrepairer, electric meterrepairer, electric motorrepairer, storage batteryrepairman, coil connectorsrepairman, electrical instrumentsrepairman, electric meterrepairman, electric motorrepairman, power transformersrepairman, storage batteryrepairman, transformersrepairman/woman, electric motorrepairman/woman, power transformersrepairman/woman, transformersrepairwoman, coil connectorsrepairwoman, electrical instrumentsrepairwoman, electric meterrepairwoman, electric motorrepairwoman, power transformers",
    "workers": 290,
    "minEduc": 0,
    "yearsStudy": 1.625,
    "automationRisk": 0.707,
    "salaryLow": 18,
    "salaryMed": 26,
    "salaryHigh": 34.97,
    "totalSkill": 131,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 26,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 65,
    "f2Engineering": 120,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 105,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 105,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 120,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 373,
    "noc": 7334,
    "job": "Motorcycle, all-terrain vehicle and other related mechanics",
    "title1": "all-terrain vehicle repairer",
    "title2": "all-terrain vehicle repairman",
    "title3": "all-terrain vehicle repairwoman",
    "allTitles": "all-terrain vehicle repairerall-terrain vehicle repairmanall-terrain vehicle repairwomanapprentice mechanic, outboard motorsapprentice outboard motor mechanicforklift mechanicgo-kart repairergo-kart repairmango-kart repairwomaninboard-outboard mechanicindustrial truck mechanicindustrial truck repairerindustrial truck repairmanindustrial truck repairwomanlift truck mechanicmechanic, inboard-outboard motorsmechanic, motor boatsmechanic, outboard motorsmotor boat mechanicmotorcycle mechanicmotorcycle mechanic apprenticemotorcycle repairermotorcycle repairmanmotorcycle repairman/womanmotorcycle repairwomanmotor scooter repairermotor scooter repairmanmotor scooter repairwomanoutboard motor mechanicsnowmobile repairersnowmobile repairmansnowmobile repairman/womansnowmobile repairwoman",
    "workers": 1110,
    "minEduc": 0,
    "yearsStudy": 1.352941176,
    "automationRisk": 0.79,
    "salaryLow": 15,
    "salaryMed": 21.2975,
    "salaryHigh": 32.135,
    "totalSkill": 103,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 25.85706521,
    "skillsComp": 27,
    "skillsLogi": 31,
    "skillsMath": 21,
    "skillsLang": 24,
    "topSkill1": "Document Use",
    "topSkill2": "Document Use",
    "topSkill3": "Measurement and Calculation",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 0,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 11,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 6,
    "s9ProblemSolving": 7,
    "s10Reading": 11,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 8,
    "s13DocumentUse": 15,
    "s14Writing": 7,
    "s15CriticalThinking": 15,
    "f1Science&Agriculture": 1085,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 1085,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 374,
    "noc": 7335,
    "job": "Other small engine and small equipment repairers",
    "title1": "air-cooled engine mechanic",
    "title2": "apprentice mechanic, small engines",
    "title3": "apprentice mechanic, small equipment",
    "allTitles": "air-cooled engine mechanicapprentice mechanic, small enginesapprentice mechanic, small equipmentapprentice small engine mechanicgarden tractor repairergarden tractor repairmangarden tractor repairwomangasoline-powered lawn mower mechanicgasoline-powered snow blower repairergasoline-powered snow blower repairmangasoline-powered snow blower repairwomangas-powered small equipment mechaniclawn and garden equipment technicianlawn mower repairer, gasoline poweredlawn mower repairman, gasoline poweredlawn mower repairwoman, gasoline poweredmechanic, gasoline-powered lawn mowersmechanic, gas-powered small enginesmechanic, small enginesmechanic, small engines and equipmentoutdoor power equipment technicianrepairer, gasoline-powered lawn mowersrepairer, gasoline-powered snow blowersrepairer, small enginesrepairer, small equipmentrepairman, gasoline-powered lawn mowersrepairman, gasoline-powered snow blowersrepairman, small enginesrepairman, small equipmentrepairwoman, gasoline-powered lawn mowersrepairwoman, gasoline-powered snow blowersrepairwoman, small enginesrepairwoman, small equipmentsmall engine and equipment mechanicsmall engine mechanicsmall engine repairersmall engine repairmansmall engine repairwomansmall engine techniciansmall equipment mechanic apprenticesmall equipment repairersmall equipment repairmansmall equipment repairwomantechnician, lawn and garden equipmenttechnician, outdoor power equipmenttechnician, small engine",
    "workers": 460,
    "minEduc": 2,
    "yearsStudy": 1.375,
    "automationRisk": 0.93,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 25,
    "totalSkill": 92,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 16,
    "skillsComp": 29,
    "skillsLogi": 18,
    "skillsMath": 21,
    "skillsLang": 24,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 3,
    "s3FindingInformation": 2,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 4,
    "s10Reading": 11,
    "s11SchedulingorBudgetingandAccounting": 8,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 13,
    "s14Writing": 5,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 460,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 460,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 375,
    "noc": 7361,
    "job": "Railway and yard locomotive engineers",
    "title1": "diesel locomotive engineer - railway",
    "title2": "engineer, passenger train locomotive",
    "title3": "engineer, railway locomotives",
    "allTitles": "diesel locomotive engineer - railwayengineer, passenger train locomotiveengineer, railway locomotivesengineer trainee, railwayfreight train engineerhostler, railwayindustrial locomotive engineerlocomotive engineer - railwaylocomotive hostlerpassenger train engineerrailway engineerrailway engineer traineerailway hostlerrailway locomotive engineerswitch engineer - railwaytrain engineertransfer hostler - railwayyard engineer - railwayyard locomotive engineer - railway",
    "workers": 480,
    "minEduc": 2,
    "yearsStudy": 1.25,
    "automationRisk": 0.91,
    "salaryLow": 24.73,
    "salaryMed": 40.14,
    "salaryHigh": 54.27,
    "totalSkill": 75,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 40.14,
    "skillsComp": 19,
    "skillsLogi": 16,
    "skillsMath": 7,
    "skillsLang": 33,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 3,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 2,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 2,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 16,
    "s14Writing": 4,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 450,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 450,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 376,
    "noc": 7362,
    "job": "Railway conductors and brakemen/women",
    "title1": "brakeman",
    "title2": "brakeman - railway",
    "title3": "brakeman - railway yard",
    "allTitles": "brakemanbrakeman - railwaybrakeman - railway yardbrakeman - switching yardbrakeman/womanbrakeman/woman - railwaybrakeman/woman - railway yardbrakeman/woman - switching yardbrakewomanbrakewoman - railwaybrakewoman - railway yardbrakewoman - switching yardbrake worker - switching yardconductor, passenger trainconductor, railwayconductor - railway yardconductor - road freightconductor - switching yardfreight train brakemanfreight train brakeman/womanfreight train brakewomanfreight train conductorfront-end brakemanfront-end brakeman/womanfront-end brakewomanhead brakemanhead brakeman/womanhead brakewomanpassenger train brakemanpassenger train brakeman/womanpassenger train brakewomanpassenger train conductorpullman conductorrailway conductorroad freight brakemanroad freight brakeman/womanroad freight brakewomansleeping car conductortail-end brakemantail-end brakeman/womantail-end brakewomantrain conductor",
    "workers": 235,
    "minEduc": 0,
    "yearsStudy": 1.5,
    "automationRisk": 0.83,
    "salaryLow": 16.28,
    "salaryMed": 28.25,
    "salaryHigh": 48.08,
    "totalSkill": 127,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 28.25,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 235,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 235,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 377,
    "noc": 7371,
    "job": "Crane operators",
    "title1": "apprentice mobile crane operator",
    "title2": "apprentice operator, mobile crane",
    "title3": "boat crane operator",
    "allTitles": "apprentice mobile crane operatorapprentice operator, mobile craneboat crane operatorboom crane operatorboom truck crane operatorboom truck hoist operatorbridge crane operatorcantilever crane operatorcinder crane operatorclimbing crane operatorclimbing tower crane operatorconstruction crane operatorcrane and hoisting equipment operatorcrane hoist operatorcrane operatorcrane operator apprenticecrane operator, drilling rigcrawler crane operatordemolition crane operatordragline crane operatordragline operator - cranedrilling rig crane operatorelectrical equipment operator - derrickelectric crane operatorelectric dragline operatorelectric gantry crane operatorelectric monorail crane operatorfloating crane operatorgantry crane operatorhoist operator, boom truckhoist operator, cranehoist operator (except underground mining)hoist operator - foundryhot metal crane operatorjib crane operatorladle crane operatorlocomotive cranemanlocomotive craneman/womanlocomotive crane operatorlocomotive cranewomanmechanical hoist operatormobile crane operatormonorail crane operatoroperator, boom truck hoistoverhead crane operatorpile driving crane operatorpower crane operatorrail crane operatorrailway car puller - cranerigger (except shipbuilding and aircraft assembly)ship crane operatorskip operatortower crane operatortractor crane operatortruck crane operatorwalking bridge crane operatorwrecking crane operator",
    "workers": 1515,
    "minEduc": 2,
    "yearsStudy": 1.307692308,
    "automationRisk": 0.9,
    "salaryLow": 18.5,
    "salaryMed": 30.45,
    "salaryHigh": 40,
    "totalSkill": 138,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 30.45,
    "skillsComp": 46,
    "skillsLogi": 33,
    "skillsMath": 22,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 12,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 26,
    "s14Writing": 8,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 385,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1105,
    "f8Education(teachertraining)": 0,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1105,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 385,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 378,
    "noc": 7372,
    "job": "Drillers and blasters - surface mining, quarrying and construction",
    "title1": "air-track drill operator - construction",
    "title2": "blaster, construction",
    "title3": "blaster (except underground mining)",
    "allTitles": "air-track drill operator - constructionblaster, constructionblaster (except underground mining)blaster - quarryingblaster - surface miningconstruction blasterconstruction drillercore drill operator - construction, surface mining and quarryingdiamond drill operator - surface mining and quarryingdriller, constructiondriller, quarrydriller - quarryingdriller, seismic prospectingdriller - surface minedriller - surface miningdrilling machine operator - constructionfoundation drill operatorfoundation drill operator - constructionopen-pit blasteropen-pit drilleroperator, foundation drilloperator, rotary drilling machinequarry drillerrotary drilling machine operatorrotary drilling machine operator - surface mining and quarryingseismic prospecting driller",
    "workers": 50,
    "minEduc": 0,
    "yearsStudy": 1,
    "automationRisk": 0.665,
    "salaryLow": 18.5,
    "salaryMed": 30.45,
    "salaryHigh": 40,
    "totalSkill": 135,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 24.55815389,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 20,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 50,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 50,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 379,
    "noc": 7373,
    "job": "Water well drillers",
    "title1": "apprentice water well driller",
    "title2": "cable tool driller - water well drilling",
    "title3": "churn drill operator - water well drilling",
    "allTitles": "apprentice water well drillercable tool driller - water well drillingchurn drill operator - water well drillingdriller, water well apprenticejourneyman water well drillerjourneyman/woman water well drillerjourneywoman water well drillertechnician, water well drillingwater well drillerwater well driller apprenticewater well driller journeymanwater well driller journeyman/womanwater well driller journeywomanwater well drilling technician",
    "workers": 35,
    "minEduc": 2,
    "yearsStudy": 1,
    "automationRisk": 0.84,
    "salaryLow": 18.5,
    "salaryMed": 30.45,
    "salaryHigh": 40,
    "totalSkill": 114,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 24.1840284,
    "skillsComp": 23,
    "skillsLogi": 31,
    "skillsMath": 24,
    "skillsLang": 36,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 9,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 4,
    "s13DocumentUse": 16,
    "s14Writing": 8,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 380,
    "noc": 7381,
    "job": "Printing press operators",
    "title1": "apprentice pressman",
    "title2": "apprentice pressman - printing",
    "title3": "apprentice pressman/woman",
    "allTitles": "apprentice pressmanapprentice pressman - printingapprentice pressman/womanapprentice pressman/woman - printingapprentice press operatorapprentice press operator - printingapprentice presswomanapprentice presswoman - printingapprentice printing press operatorassistant operator, printing pressassistant pressmanassistant pressman - printingassistant pressman/womanassistant pressman/woman - printingassistant press operator - printingassistant presswomanassistant presswoman - printingcommercial press operatorcylinder pressman - printingcylinder pressman/woman - printingcylinder press operator - printingcylinder press set-up operatorcylinder presswoman - printingcylinder printing press set-up operatorfirst pressmanfirst pressman - printingfirst pressman/womanfirst pressman/woman - printingfirst press operator - printingfirst presswomanfirst presswoman - printingflat-bed press set-up operatorflexographic press adjusterflexographic pressmanflexographic pressman - printingflexographic pressman/womanflexographic pressman/woman - printingflexographic press operatorflexographic press operator - printingflexographic press set-up technician - printingflexographic presswomanflexographic presswoman - printinggravure pressmangravure pressman/womangravure press operatorgravure presswomangravure printer - printinggravure printing press operatorgravure proof press operator - printinggravure proof puller - printinggravure proof wallpaper pullerink evaluation and press operator - printingink evaluation pressman - printingink evaluation pressman/woman - printingink evaluation presswoman - printingintaglio printer - printingintaglio printing press operatorjob printerletterpress operator - printingletterpress proof press operator - printingletterpress proof puller - printinglithographic offset prooferlithographic offset proofing handlithographic pressman - printinglithographic pressman, sheet metallithographic pressman/woman - printinglithographic pressman/woman, sheet metallithographic press operator - printinglithographic press operator, sheet metallithographic presswoman - printinglithographic presswoman, sheet metallithographic printernewspaper pressmannewspaper pressman/womannewspaper press operatornewspaper presswomanoffset lithographic proof press operator - printingoffset machine operatoroffset pressman - printingoffset pressman/woman - printingoffset press operatoroffset press operator - printingoffset presswoman - printingoffset printerphotoengraved plate proof press operator - printingphotoengraved plate proof puller - printingplastic sheet offset press operatorplaten press operator - printingplaten press tenderpressman, ink evaluation - printingpressman - printingpressman/woman, ink evaluation - printingpressman/woman - printingpress operator, ink evaluation - printingpress operator - printingpresswoman, ink evaluation - printingpresswoman - printingprinterprinting press assistant operatorprinting press operator",
    "workers": 6670,
    "minEduc": 1,
    "yearsStudy": 2.572173913,
    "automationRisk": 0.424,
    "salaryLow": 14,
    "salaryMed": 22.5,
    "salaryHigh": 31,
    "totalSkill": 162.5,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Professional occupations in natural and applied sciences",
    "cluster": 6,
    "wage": 27.595,
    "skillsComp": 45,
    "skillsLogi": 47,
    "skillsMath": 21,
    "skillsLang": 49.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 7.5,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 15.5,
    "s9ProblemSolving": 12,
    "s10Reading": 20.5,
    "s11SchedulingorBudgetingandAccounting": 6.5,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 23,
    "s14Writing": 13.5,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 315,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 810,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 0,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 810,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 315,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 381,
    "noc": 7384,
    "job": "Other trades and related occupations, n.e.c.",
    "title1": "aircraft mock-up maker",
    "title2": "aircraft model maker",
    "title3": "aircraft patternmaker",
    "allTitles": "aircraft mock-up makeraircraft model makeraircraft patternmakeranvilsmithapprentice marine repair technicianapprentice recreation vehicle mechanicapprentice saw repairerapprentice saw repairmanapprentice saw repairwomanblacksmithblacksmith - agricultureblacksmith, farmblacksmith - manufacturingbomb-disposal expertcalibrator, scientific instrumentscircular saw filerclearance divercommercial divercommercial free-divercommercial scuba divercommercial skin diverdeep-sea diverdie setterdiverdiving contractordiving supervisorexplosive ordnance detectorfarm blacksmithfarrierfiler, circular sawsfiler, forest products sawsfitter, sawmill sawsforest products saw filerglass calibratorgun repairergun repairmangun repairwomangunsmithhammersmithhard-hat diverhorseshoerlinesman - shipbuildinglinesman/woman - shipbuildinglineswoman - shipbuildinglock expertlock fitterlock repairerlock repairmanlock repairman/womanlock repairwomanlock setterlocksmithlocksmithing expertloftsman - aircraft manufacturingloftsman - shipbuildingloftsman/woman - aircraft manufacturingloftsman/woman - shipbuildingloftswoman - aircraft manufacturingloftswoman - shipbuildingmarine repair technicianmodel and mock-up makermodel and mock-up maker - aeronauticsmodel and mould maker - concrete productsmodel makermodel maker, aircraftmodel maker, shipsmotor vehicle model makeroffshore diverpatternmaker - aeronauticspatternmaker, plasterplaster mould maker - aircraftplaster pattern makerplaster pattern maker - aircraftreclamation diverrecreation vehicle apprentice mechanicrecreation vehicle mechanicrecreation vehicle repairerrecreation vehicle repairmanrecreation vehicle repairwomanrecreation vehicle service technicianrecreation vehicle technicianremote operated vehicle (ROV) operatorrepairer, locksrepairer, safes and vaultsrepairer, sawsrepairer, small armsrepairman, locksrepairman, safes and vaultsrepairman, sawsrepairman, small armsrepairman/woman, locksrepairman/woman, sawsrepairwoman, locksrepairwoman, safes and vaultsrepairwoman, sawsrepairwoman, small armsrestoration steeplejackrope access technician (RAT)safe and vault installer-servicersafe and vault repairer",
    "workers": 540,
    "minEduc": 0,
    "yearsStudy": 1.277777778,
    "automationRisk": 0.762,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 32.86,
    "totalSkill": 126,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Maintenance and equipment operation trades",
    "cluster": 3,
    "wage": 21,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 360,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 180,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 60,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 180,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 300,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 382,
    "noc": 7441,
    "job": "Residential and commercial installers and servicers",
    "title1": "air conditioner installer, window",
    "title2": "air conditioning installer, window",
    "title3": "air treatment installer",
    "allTitles": "air conditioner installer, windowair conditioning installer, windowair treatment installeraluminum door and window installeraluminum siding installeraluminum window installerantenna installer - electronic equipmentantenna installer, televisionapplicator, sidingautomatic door system installerautomatic door system installer and servicerautomatic door system servicerautomatic garage door installerawning erectorawning installerbillboard erectorbuilder, patioschain link fence erectorcladdercommercial sign erectorcommercial sign installerdeck builderdeck installerdental equipment installer-servicerdishwasher installerdock builder-installerdoor installerdoor installer, aluminumdoor installer, residentialdrapery hangerdrapery installerduct installereavestrough installerelectrical appliance installerelectric appliance installerelectric household appliance installerelectric household appliance installer - residential and commercial equipmentelectric sign erectorerector, electric signserector, neon signserector, signexterior cladderexterior trimmer - buildingfence builderfence builder, railfence erectorfence erector, basket weavefence erector, chain linkfence erector, louvredfence erector, metalfence erector, wirefence erector, woodfence installerfloor sanderfloor sander and finisherfloor sander and polishergarage door installerhot tub installerhot tub servicerhot water heater installerhousehold appliance installerindustrial door installerinstaller, aluminum awninginstaller, aluminum doorsinstaller, aluminum sidinginstaller, aluminum windowsinstaller and servicer, automatic door systemsinstaller, antennas - electronic equipmentinstaller, automatic door systeminstaller, automatic garage doorinstaller, awningsinstaller, curtainsinstaller, doorsinstaller, ducts - constructioninstaller, eavestroughsinstaller, electrical appliancesinstaller, electric appliancesinstaller, electric household appliances - residential and commercial equipmentinstaller, fenceinstaller, garage doorsinstaller, hot water heatersinstaller, household applianceinstaller, industrial doorsinstaller, interlocking paving stoneinstaller, kitchen cabinetinstaller, kitchen cupboards and vanitiesinstaller, kitchen unitsinstaller, laboratory furnishingsinstaller, lightning rodsinstaller, neon signsinstaller, overhead doorsinstaller, pool equipmentinstaller, recreational equipmentinstaller, residential doorsinstaller, satellite antennasinstaller, satellite dishesinstaller, septic systeminstaller, septic tankinstaller-servicer, travel trailersinstaller, siding",
    "workers": 3440,
    "minEduc": 0,
    "yearsStudy": 1.79,
    "automationRisk": 0.666,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 38.05,
    "totalSkill": 140,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 20,
    "skillsComp": 35,
    "skillsLogi": 34,
    "skillsMath": 35,
    "skillsLang": 36,
    "topSkill1": "Document Use",
    "topSkill2": "Measurement and Calculation",
    "topSkill3": "Reading",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 22,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 11,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 33,
    "s14Writing": 8,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 715,
    "f2Engineering": 555,
    "f3Humanities": 40,
    "f4SocialScience": 15,
    "f5FineArts": 95,
    "f6MathAndComputerScience": 50,
    "f7Arts&Education": 1315,
    "f8Education(teachertraining)": 45,
    "f9Law": 275,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 335,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 65,
    "d2Forestry": 35,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 95,
    "d7ComputerScience": 50,
    "d8OtherArts&Science": 1315,
    "d9Education(teachertraining)": 45,
    "d10Engineering": 555,
    "d11Law": 275,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 20,
    "d15PhysicalSciences": 615,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 335,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 383,
    "noc": 7442,
    "job": "Waterworks and gas maintenance workers",
    "title1": "distribution and maintenance worker - utilities",
    "title2": "field measurement hand - utilities",
    "title3": "gas leak inspector",
    "allTitles": "distribution and maintenance worker - utilitiesfield measurement hand - utilitiesgas leak inspectorgas leak locatorgas leak surveyorgas main maintenance and repairmangas main maintenance and repairman/womangas main maintenance and repairwomangas maintenance workergas meter installergas regulatorgas utility operatorhydrant and valve maintenance workerinstaller, gas metersinstaller, water meterleakage tester, gas mainsleak inspector, gas mainsleak locator, gas mainsline locator - utilitiesmaintenance repairman, gas mainsmaintenance repairman/woman, gas mainsmaintenance repairwoman, gas mainsmaintenance utility workermaintenance worker, water mainsmaintenance worker, waterworkspatrolman, pipelinepatrolman/woman, pipelinepatrolwoman, pipelinepipeline maintenance workerpipeline patrolmanpipeline patrolman/womanpipeline patrolwomanpipeline rehabilitation workerpipe locator - utilitiesrehabilitation worker, pipelinesrepairman, waterworksrepairman/woman, waterworksrepairwoman, waterworkstroubleshooter - pipelineunderground lines inspector - utilitiesutility maintenance workerutility plant maintenance workerwater main maintenance manwater main maintenance man/womanwater main maintenance womanwater main maintenance workerwater meter installerwater supply maintenance workerwater system maintenance workerwater utilities plant maintenance manwater utilities plant maintenance man/womanwater utilities plant maintenance womanwaterworks maintenance workerwaterworks utility servicer",
    "workers": 185,
    "minEduc": 1,
    "yearsStudy": 1.3,
    "automationRisk": 0.485,
    "salaryLow": 14.69,
    "salaryMed": 29.55,
    "salaryHigh": 44.98,
    "totalSkill": 119,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 29.55,
    "skillsComp": 38,
    "skillsLogi": 33,
    "skillsMath": 13,
    "skillsLang": 35,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 8,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 7,
    "s13DocumentUse": 30,
    "s14Writing": 8,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 65,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 384,
    "noc": 7444,
    "job": "Pest controllers and fumigators",
    "title1": "animal control trapper",
    "title2": "exterminator",
    "title3": "exterminator, pests",
    "allTitles": "animal control trapperexterminatorexterminator, pestsfumigatorfumigator, pestsnuisance control trapperpest controllerpest control operatorpest control representativepest control service representativepest control technicianpest control trapperpest extermination representativepest exterminatorpest fumigator",
    "workers": 160,
    "minEduc": 1,
    "yearsStudy": 1.4,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 20.28,
    "salaryHigh": 30.12,
    "totalSkill": 125,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 20.28,
    "skillsComp": 33,
    "skillsLogi": 32,
    "skillsMath": 16,
    "skillsLang": 44,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 9,
    "s4JobTaskPlanningandOrganizing": 6,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 19,
    "s14Writing": 16,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 160,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 160,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 385,
    "noc": 7445,
    "job": "Other repairers and servicers",
    "title1": "accordion repairer",
    "title2": "accordion repairman",
    "title3": "accordion repairwoman",
    "allTitles": "accordion repaireraccordion repairmanaccordion repairwomanadding machine repaireradding machine repairmanadding machine repairwomanadjuster, golf club headsadjuster, piano actionair compressor repairerair compressor repairmanair compressor repairwomanairport equipment maintenance repairerairport equipment maintenance repairmanairport equipment maintenance repairwomanair valve repairer, railway rolling stockair valve repairman, railway rolling stockair valve repairwoman, railway rolling stockarchery bow finisherarchery bow repairerarchery bow repairmanarchery bow repairwomanautomobile wreckerautomotive dismantlerautomotive maintenance equipment servicerawning and tent repairerawning and tent repairmanawning and tent repairwomanbeer-dispensing equipment repairerbeer-dispensing equipment repairmanbeer-dispensing equipment repairwomanbelt repairer, industrialbelt repairman, industrialbelt repairwoman, industrialbicycle mechanicbicycle repairerbicycle repairmanbicycle repairwomanbilliard and bowling equipment installer-repairerbilliard and bowling equipment installer-repairmanbilliard and bowling equipment installer-repairwomanbilliard cue weigherbilliard table repairerbilliard table repairmanbilliard table repairwomanbilliard table servicerboat propeller repairerboat propeller repairmanboat propeller repairwomanbow repairerbow repairmanbow repairwomancalibrator, pressure controllerscalibrator, torque wrenchcamera repairercamera repairmancamera repairman/womancamera repairwomandictaphone repairerdictaphone repairmandictaphone repairwomandictaphone servicerdismantler, automotivedomestic sewing machine mechanicdomestic sewing machine repairerdomestic sewing machine repairmandomestic sewing machine repairwomanelectric sign repairerelectric sign repairmanelectric sign repairwomanelectric toy repairerelectric toy repairmanelectric toy repairwomanfarebox repairerfarebox repairmanfarebox repairwomanfinisher, archery bows - sporting goods manufacturingfire equipment repairerfire equipment repairmanfire equipment repairwomanfire equipment servicerfire extinguisher repairerfire extinguisher repairmanfire extinguisher repairwomangas meter repairergas meter repairmangas meter repairwomangas meter servicergas meter testergolf club head adjustergolf club repairergolf club repairmangolf club repairwomanguitar repairerguitar repairmanguitar repairwomangyroscope repairergyroscope repairmangyroscope repairman/womangyroscope repairwomanhand tool repairman",
    "workers": 405,
    "minEduc": 1,
    "yearsStudy": 1.8,
    "automationRisk": 0.5,
    "salaryLow": 14,
    "salaryMed": 18,
    "salaryHigh": 29.94,
    "totalSkill": 101,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 18,
    "skillsComp": 17,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Reading",
    "topSkill2": "Decision Making",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 4,
    "s13DocumentUse": 11,
    "s14Writing": 11,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 125,
    "f2Engineering": 125,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 110,
    "f8Education(teachertraining)": 0,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 110,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 125,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 125,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 386,
    "noc": 7451,
    "job": "Longshore workers",
    "title1": "barge loader boat loader dock hand dockerman/woman � marine cargo handling dockworker dockworker � marine cargo handling longshore worker longshore worker and tower-loader operator longshoreman/woman lumper � marine cargo handling ship loader operator shiploader operator stevedore stower tanker loader tanker loader � marine cargo handling tankerman/woman � marine cargo handling tower-loader operator � marine cargo handling wharfman/woman � marine cargo handling",
    "title2": 0,
    "title3": 0,
    "allTitles": "barge loader boat loader dock hand dockerman/woman � marine cargo handling dockworker dockworker � marine cargo handling longshore worker longshore worker and tower-loader operator longshoreman/woman lumper � marine cargo handling ship loader operator shiploader operator stevedore stower tanker loader tanker loader � marine cargo handling tankerman/woman � marine cargo handling tower-loader operator � marine cargo handling wharfman/woman � marine cargo handling",
    "workers": 15930,
    "minEduc": 1,
    "yearsStudy": 2.356083086,
    "automationRisk": 0.85,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 23.04,
    "totalSkill": 87,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 15,
    "skillsComp": 25,
    "skillsLogi": 27,
    "skillsMath": 12,
    "skillsLang": 23,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Reading",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 7,
    "s9ProblemSolving": 8,
    "s10Reading": 9,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 5,
    "s13DocumentUse": 20,
    "s14Writing": 7,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 2040,
    "f2Engineering": 2055,
    "f3Humanities": 360,
    "f4SocialScience": 475,
    "f5FineArts": 620,
    "f6MathAndComputerScience": 660,
    "f7Arts&Education": 4400,
    "f8Education(teachertraining)": 240,
    "f9Law": 1015,
    "f10Health": 165,
    "f11Health,Nursing&ClinicalLaboratory": 495,
    "f12Business": 3405,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 85,
    "d2Forestry": 125,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 360,
    "d5SocialSciences": 475,
    "d6Fine&AppliedArts": 620,
    "d7ComputerScience": 660,
    "d8OtherArts&Science": 4400,
    "d9Education(teachertraining)": 240,
    "d10Engineering": 2055,
    "d11Law": 1015,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 100,
    "d14Theology": 0,
    "d15PhysicalSciences": 1830,
    "d16Therapy&Rehabilitation": 65,
    "d17Health,Nursing&ClinicalLaboratory": 495,
    "d18Business&Commerce": 3405,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 387,
    "noc": 7452,
    "job": "Material handlers",
    "title1": "ash handler",
    "title2": "attendant, used building materials yard",
    "title3": "automated storage and retrieval system operator",
    "allTitles": "ash handlerattendant, used building materials yardautomated storage and retrieval system operatorautomatic pallet equipment operatorbandoleer packer - explosives manufacturingbelt conveyor attendantbeltmanbeltman/womanbeltwomanbin attendantbin fillerbinmanbinman/womanbinwomanbox banderboxcar loaderbox fillerbucket elevator operatorbulk materials carrier operatorbulk materials loader operatorbulk materials unloaderbundler, handcar loader, railwaycarrier operator, bulk materialscement loader and sackercoal conveyor operatorcoal conveyor operator - surface miningcoal dumpercoal handlercoal loader-unloadercoal-moving equipment operatorcoal wheelerconveyor belt attendantconveyor belt operator (except underground mines)conveyor belt patroller-controllerconveyor console operatorconveyor operator, grainconveyor operator - material handling (except underground mines)conveyor tender - material handling (except underground mines)cribber - grain elevatordisposal worker - warehousedockman - truck transportdockman/woman - truck transportdockwoman - truck transportdumper - material handlingdumper - surface coal miningelectric dolly operatorelectric mule operatorelectric truck operatorexplosives handlerexplosives packerexpress service handler (except air transport)fats and oils loaderfeed mill loaderforklift operatorforklift truck operatorfreight car loaderfreight car unloaderfreight handler (except air transport)freight loader (except air transport)freight unloader (except air transport)furniture loader-unloaderfurniture moverglass cut-off machine unloadergrain conveyor operatorgrain handlergrain weigherhand bagger - material handlinghand bundlerhandler, explosiveshandler, freight (except air transport)handler, grainhandler, heavy materialshandler, light materialshandler, materialshandler, materials - manufacturing and warehousinghandler, recycled paperhand packagerhand packer, sacks - material handlinghand sacker - material handlinghand truck operatorheavy materials handlerhelper, stockhelper, stock-keeperhelper, warehouse keeperhousehold goods moverindustrial truck operatorjack lift operatorjigger operator, supermarketjitney driver - material handlinglabourer - material handlinglabourer - warehousing and storagelift driverlift jack operatorlift scoop operatorlift truck operatorlight materials handlerliquids loader-unloaderloader, fats and oilsloader, freight (except air transport)",
    "workers": 15930,
    "minEduc": 1,
    "yearsStudy": 2.356083086,
    "automationRisk": 0.85,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 23.04,
    "totalSkill": 87,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Other installers, repairers and servicers and material handlers",
    "cluster": 3,
    "wage": 15,
    "skillsComp": 25,
    "skillsLogi": 27,
    "skillsMath": 12,
    "skillsLang": 23,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Reading",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 7,
    "s9ProblemSolving": 8,
    "s10Reading": 9,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 5,
    "s13DocumentUse": 20,
    "s14Writing": 7,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 2040,
    "f2Engineering": 2055,
    "f3Humanities": 360,
    "f4SocialScience": 475,
    "f5FineArts": 620,
    "f6MathAndComputerScience": 660,
    "f7Arts&Education": 4400,
    "f8Education(teachertraining)": 240,
    "f9Law": 1015,
    "f10Health": 165,
    "f11Health,Nursing&ClinicalLaboratory": 495,
    "f12Business": 3405,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 85,
    "d2Forestry": 125,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 360,
    "d5SocialSciences": 475,
    "d6Fine&AppliedArts": 620,
    "d7ComputerScience": 660,
    "d8OtherArts&Science": 4400,
    "d9Education(teachertraining)": 240,
    "d10Engineering": 2055,
    "d11Law": 1015,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 100,
    "d14Theology": 0,
    "d15PhysicalSciences": 1830,
    "d16Therapy&Rehabilitation": 65,
    "d17Health,Nursing&ClinicalLaboratory": 495,
    "d18Business&Commerce": 3405,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 388,
    "noc": 7511,
    "job": "Transport truck drivers",
    "title1": "automobile carrier driver",
    "title2": "automobile transport driver",
    "title3": "bulk goods truck driver",
    "allTitles": "automobile carrier driverautomobile transport driverbulk goods truck driverbulk milk truck drivercement truck driver - constructioncoal hauler (except underground mining)driver, bulk milk truckdriver, dump truckdriver, explosives truckdriver, gravel truckdriver, heavy truckdriver, line-hauldriver, logging truckdriver, long hauldriver, low-bed semi-trailerdriver, mobile concrete mixerdriver, ready-mix - constructiondriver, ready-mix truckdriver, tow truckdriver, transportdriver, truckdriver, truck-trailerdumpster truck driverdump truck driverexplosives truck driverflatbed truck driverfreight truck driverfuel oil truck drivergasoline truck operatorgravel haulergravel truck driverhauler, gravelheavy truck driverhydrovac truck operatorLCV (long combination vehicule) driverline-haul driverliquid fertilizer truck driverlogging truck driverlog haulerlog truck driverlong combination vehicule (LCV) driverlong distance truck driverlong haul driverlong haul driver, grocerieslong haul tractor-trailer driverlong haul truck driverlow-bed semi-trailer drivermobile cement mixer drivermobile concrete mixer drivermoving truck drivermoving van drivermuskeg tractor operatoroil transport driveroperator, gasoline truckoperator, truckready-mix driver - constructionready-mix truck drivershort haul truck drivershunter truck drivershunter - truckingshunt truck drivertank truck drivertow truck drivertractor-trailer driver, long haultractor-trailer truck drivertransport drivertruck drivertruck driver, bulk milktruck driver, cement - constructiontruck driver, dangerous goodstruck driver, explosivestruck driver, flatbedtruck driver, freighttruck driver, heavy trucktruck driver, liquid fertilizertruck driver, long distancetruck driver, long haultruck driver, ready-mixtruck driver, tractor-trailertruck driver, truck-trailertruckertruck mixer driver - constructiontruck operatortruck owner operatortruck-trailer driver",
    "workers": 29285,
    "minEduc": 0,
    "yearsStudy": 2.203804348,
    "automationRisk": 0.79,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 29,
    "totalSkill": 125,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 20,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 6450,
    "f2Engineering": 3325,
    "f3Humanities": 55,
    "f4SocialScience": 340,
    "f5FineArts": 400,
    "f6MathAndComputerScience": 765,
    "f7Arts&Education": 13860,
    "f8Education(teachertraining)": 305,
    "f9Law": 840,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 260,
    "f12Business": 2665,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 880,
    "d2Forestry": 145,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 55,
    "d5SocialSciences": 340,
    "d6Fine&AppliedArts": 400,
    "d7ComputerScience": 765,
    "d8OtherArts&Science": 13860,
    "d9Education(teachertraining)": 305,
    "d10Engineering": 3325,
    "d11Law": 840,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 5425,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 260,
    "d18Business&Commerce": 2665,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 389,
    "noc": 7512,
    "job": "Bus drivers, subway operators and other transit operators",
    "title1": "articulated bus operator bus driver bus driver � special needs passengers bus operator bus operator � accessible services charter bus driver driver, bus driver, motor coach driver, public passenger transit driver, school bus intercity bus driver light rail transit operator long distance bus driver motor coach driver operator, bus operator, streetcar operator, subway operator, urban transit public passenger transit driver school bus driver school bus driver � special needs passengers shuttle bus driver shuttle operator sightseeing bus driver sightseeing tour driver streetcar conductor streetcar operator subway train operator tour bus operator transit operator � transportation trolley bus operator trolley coach driver urban transit operator",
    "title2": 0,
    "title3": 0,
    "allTitles": "articulated bus operator bus driver bus driver � special needs passengers bus operator bus operator � accessible services charter bus driver driver, bus driver, motor coach driver, public passenger transit driver, school bus intercity bus driver light rail transit operator long distance bus driver motor coach driver operator, bus operator, streetcar operator, subway operator, urban transit public passenger transit driver school bus driver school bus driver � special needs passengers shuttle bus driver shuttle operator sightseeing bus driver sightseeing tour driver streetcar conductor streetcar operator subway train operator tour bus operator transit operator � transportation trolley bus operator trolley coach driver urban transit operator",
    "workers": 13670,
    "minEduc": 0,
    "yearsStudy": 2.375387091,
    "automationRisk": 0.79,
    "salaryLow": 14,
    "salaryMed": 23.75,
    "salaryHigh": 33,
    "totalSkill": 123,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 16,
    "skillsComp": 33.66666667,
    "skillsLogi": 31.33333333,
    "skillsMath": 17.66666667,
    "skillsLang": 40.33333333,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.666666667,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13.33333333,
    "s9ProblemSolving": 8.666666667,
    "s10Reading": 16.66666667,
    "s11SchedulingorBudgetingandAccounting": 4.333333333,
    "s12DigitalTechnology": 12.33333333,
    "s13DocumentUse": 17,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 2696.666667,
    "f2Engineering": 1720,
    "f3Humanities": 25,
    "f4SocialScience": 315,
    "f5FineArts": 203.3333333,
    "f6MathAndComputerScience": 380,
    "f7Arts&Education": 5770,
    "f8Education(teachertraining)": 131.6666667,
    "f9Law": 541.6666667,
    "f10Health": 18.33333333,
    "f11Health,Nursing&ClinicalLaboratory": 170,
    "f12Business": 1698.333333,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 306.6666667,
    "d2Forestry": 55,
    "d3Architecture&LandscapeArchitecture": 6.666666667,
    "d4Humanities": 25,
    "d5SocialSciences": 315,
    "d6Fine&AppliedArts": 203.3333333,
    "d7ComputerScience": 380,
    "d8OtherArts&Science": 5770,
    "d9Education(teachertraining)": 131.6666667,
    "d10Engineering": 1713.333333,
    "d11Law": 541.6666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 18.33333333,
    "d14Theology": 0,
    "d15PhysicalSciences": 2335,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 170,
    "d18Business&Commerce": 1698.333333,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 390,
    "noc": 7513,
    "job": "Taxi and limousine drivers and chauffeurs",
    "title1": "airport limousine driver",
    "title2": "chauffeur, private household",
    "title3": "company chauffeur",
    "allTitles": "airport limousine driverchauffeur, private householdcompany chauffeurdriver, funeral servicesdriver, hearsedriver, taxidriver, taxicabfuneral chauffeurfuneral driverhearse driverlimousine driverprivate chauffeurtaxicab drivertaxi drivertaxi owner-operator",
    "workers": 5240,
    "minEduc": 0,
    "yearsStudy": 2.795774648,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 24,
    "totalSkill": 117,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 640,
    "f2Engineering": 1165,
    "f3Humanities": 20,
    "f4SocialScience": 355,
    "f5FineArts": 65,
    "f6MathAndComputerScience": 155,
    "f7Arts&Education": 1370,
    "f8Education(teachertraining)": 65,
    "f9Law": 190,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 35,
    "f12Business": 1180,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 20,
    "d5SocialSciences": 355,
    "d6Fine&AppliedArts": 65,
    "d7ComputerScience": 155,
    "d8OtherArts&Science": 1370,
    "d9Education(teachertraining)": 65,
    "d10Engineering": 1165,
    "d11Law": 190,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 640,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 35,
    "d18Business&Commerce": 1180,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 391,
    "noc": 7514,
    "job": "Delivery and courier service drivers",
    "title1": "amusement machine route agent",
    "title2": "bakery deliveryman",
    "title3": "bakery deliveryman/woman",
    "allTitles": "amusement machine route agentbakery deliverymanbakery deliveryman/womanbakery deliverywomanbakery route salesmanbakery route salesman/womanbakery route saleswomanbookmobile driverbread delivererbread route drivercanteen drivercourier drivercourier service drivercourier van driverdairy route salesmandairy route salesman/womandairy route saleswomandelivery driverdelivery driver, fast fooddelivery driver - parcelsdeliveryman, bakerydeliveryman/woman, bakerydelivery salespersondelivery truck driverdeliverywoman, bakerydriver, courier servicedriver, fast food servicedriver salesmandriver salesman/womandriver salespersondriver saleswomandriver, small vansdrug store delivery driverdry cleaning driverexpedite driverfast food delivery driverfood delivery driverfood service drivergroceries delivererlaundry route drivermail service couriermilk deliverermilkmanmilkman/womanmilkwomanmobile canteen drivermobile caterermotorized mail couriernewspaper delivery driverparts delivery driverpizza delivery driverroute driversoft drink driver-salesmansoft drink driver-salesman/womansoft drink driver-saleswomansoft drinks drivertakeout pizza drivertelephone directory deliverer - courier servicetown messenger drivervending machine driver-supplier",
    "workers": 6485,
    "minEduc": 0,
    "yearsStudy": 2.126582278,
    "automationRisk": 0.69,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 29,
    "totalSkill": 127,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 15,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1000,
    "f2Engineering": 670,
    "f3Humanities": 0,
    "f4SocialScience": 250,
    "f5FineArts": 145,
    "f6MathAndComputerScience": 220,
    "f7Arts&Education": 2080,
    "f8Education(teachertraining)": 25,
    "f9Law": 595,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 215,
    "f12Business": 1250,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 40,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 20,
    "d4Humanities": 0,
    "d5SocialSciences": 250,
    "d6Fine&AppliedArts": 145,
    "d7ComputerScience": 220,
    "d8OtherArts&Science": 2080,
    "d9Education(teachertraining)": 25,
    "d10Engineering": 650,
    "d11Law": 595,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 940,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 215,
    "d18Business&Commerce": 1250,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 392,
    "noc": 7521,
    "job": "Heavy equipment operators (except crane)",
    "title1": "aerial tram operator",
    "title2": "apprentice heavy equipment operator",
    "title3": "asphalt batch plant operator",
    "allTitles": "aerial tram operatorapprentice heavy equipment operatorasphalt batch plant operatorasphalt-grooving machine operatorasphalt-paving machine operatorasphalt-paving screed operatorasphalt plant operatorasphalt roller operatorasphalt spreader operatorasphalt street paver operatorbackhoe operatorbituminous paver operator - heavy equipmentbobcat operatorboom-conveyor operatorbucketwheel-excavator operatorbucketwheel operatorbuggy-operator skinnerbuggy-scraper operatorbulldozer driverbulldozer operatorcaterpillar car operatorcaterpillar operatorcat operatorcat skinnerconcrete-grooving machine operatorconcrete-paving machine operatorconcrete spreader operator - heavy equipmentconstruction equipment operatorcontinuous bucket excavator operatorcrawler tractor operatorditcher operator - constructionditching machine operatordozer operatordredge operatordredge runnerearth-moving equipment operatorelectrical equipment operator - shovelelevating grader operatorelevating scraper operatorequipment operator, heavy-dutyexcavating machine operatorexcavator operatorfront end loader operatorgradall operatorgrader operatorgroove-cutting machine operatorgrooving machine operator - heavy equipmenthammer operator, pile drivingheater-planer operatorheavy construction-equipment operatorheavy-duty equipment operatorheavy-duty equipment operator apprenticeheavy equipment operatorheavy equipment operator apprenticeho-ram operatorhorizontal earth-boring machine operatorhydraulic excavator operatorindustrial backhoe operatorloader operator - constructionmarine railway operatormining shovel operator (except underground)mole operatormucker operator - constructionmucking machine operator - constructionoperating engineer, heavy equipmentoperator, asphalt plantoperator, heavy construction-equipmentoperator, pile-driving hammeroperator, side boom tractorpaver operatorpayloader operatorpeat-moss-cutting machine operatorpeat-moss-gathering machine operatorpile driver winch operatorpile-driving hammer operatorpipelayer operatorpower grader operatorpower shovel operatorpulvimixer operatorripper operator - heavy equipmentroad grader operatorroad mixer operatorroad planer operatorroad roller operatorroller operatorrotary trencher operatorscarifier operatorscraper operatorscreed operator, asphalt pavingshield operatorshovel operator - heavy equipmentside boom operator - pipeline constructionside boom tractor operatorsnow-grooming machine operatorspreader operator - heavy equipmentstacker operator - heavy equipmentstreet paver, asphalt operatorstreet paver operatorstripping shovel operatorstructural hydraulic jack erector",
    "workers": 4455,
    "minEduc": 0,
    "yearsStudy": 1.467741935,
    "automationRisk": 0.892,
    "salaryLow": 16.25,
    "salaryMed": 31.5,
    "salaryHigh": 38.47,
    "totalSkill": 125,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 31.5,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 860,
    "f2Engineering": 105,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 15,
    "f7Arts&Education": 3325,
    "f8Education(teachertraining)": 0,
    "f9Law": 80,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 70,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 45,
    "d2Forestry": 15,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 15,
    "d8OtherArts&Science": 3325,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 105,
    "d11Law": 80,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 800,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 70,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 393,
    "noc": 7522,
    "job": "Public works maintenance equipment operators and related workers",
    "title1": "collection truck driver - public works",
    "title2": "drain roto serviceman - public works",
    "title3": "drain roto servicer - public works",
    "allTitles": "collection truck driver - public worksdrain roto serviceman - public worksdrain roto servicer - public worksdrain roto servicewoman - public worksdriver, sprinkling truck - public workselectrical foresterequipment operator - municipal public workgarbage collector - drivergarbage truck drivergarbage truck driver - public workshighway snowplough operatorhighway snow removal equipment operatormaintenance equipment operator - public worksmechanical sweeper operator - public worksmunicipal maintenance equipment operatormunicipal serviceman drain rotomunicipal servicer drain rotomunicipal servicewoman drain rotopower pole inspectorpower sweeper operator - public workspublic works maintenance equipment operatorrecycling truck driverrecycling truck driver - public worksrefuse truck driver - public worksroad snowplough operator - public workssalt truck operatorsalt truck operator - public workssanding truck operator - public workssand spreader operatorsand spreader operator - public workssanitation truck driversewer flusher operator-driver - public workssewer-flushing truck operatorsewer-flushing truck operator - public workssewer jet cleaner operator - public workssewer jet machine operator - public workssewer-pipe-cleaning machine operator - public workssnowplough operator, highwaysnowplough operator, road - public workssnow removal equipment operator - public workssprinkling truck driver - public worksstreet flusher operatorstreet flusher operator - public worksstreet sprinkler operator - public worksstreet sweeper operatorstreet sweeper operator - public worksurban snow removal equipment operator - public worksutility arboristutility foresterutility locatorutility pole inspectorutility pole testerutility tree trimmerutility tree worker",
    "workers": 1410,
    "minEduc": 0,
    "yearsStudy": 1.4,
    "automationRisk": 0.9,
    "salaryLow": 16.25,
    "salaryMed": 31.5,
    "salaryHigh": 38.47,
    "totalSkill": 127,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 20.14759093,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 485,
    "f2Engineering": 35,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 835,
    "f8Education(teachertraining)": 0,
    "f9Law": 55,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 125,
    "d2Forestry": 100,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 835,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 35,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 260,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 394,
    "noc": 7531,
    "job": "Railway yard and track maintenance workers",
    "title1": "aligner-tamper operator - railway",
    "title2": "anchor-applicator operator - railway",
    "title3": "attendant, locomotives - railway yard",
    "allTitles": "aligner-tamper operator - railwayanchor-applicator operator - railwayattendant, locomotives - railway yardautomatic anchor-applicator operator - railwayballast-equalizer operator - railwayballast-leveller operator - railwayballast regulator operator - railwaycar controller - railwaycar retarder operator - railway yardcontroller, cars - railwaycontroller, railway cars - railway yardcontroller, tank cars - railway yardcontrol tower operator - railwaycoupler - railway yarddistributor, freight cars - railway yarddistributor, railway carsequipment operator, railwayfitter tracks - railwayfreight car distributor - railway yardgandy dancer - railwaygreaser, journal boxes - railway yardgreaser, railway carsgrinder operator, rails - railwaygrinder, rails - railwayinspector, railway linesinterlocking cabin switcher - railway yardinterlocking signal box switcher - railway yardjournal box greaser - railway yardlag bolter operator - railwaylocomotive attendant - railway yardlocomotive distributor - railway yardlocomotive engine servicerlocomotive maintenance attendantlocomotive servicerlubricator, railway carsmachine operator - railwaymaintenance equipment operator, railway trackmaintenance of way employee - railwaymaintenance of way inspector - railwaymechanical tamper operator - railwaymotor vehicle operator - pole yardoiler, railway carsoperator, mechanical tamper - railwayoperator, railway equipmentoperator, railway tie injectoroperator, retarder - railway yardoperator, track liner - railwayoperator, track maintenance machine - railwayoperator, track-surfacing machine - railwayoperator, turntable - railway yardpatroller, railway trackrail-aligner operator - railwayrail-grinder operator - railwayrail grinder - railwayrail-lifter operator - railwayrail sanderrail saw operatorrail saw operator - railwayrailway car controller - railway yardrailway car distributorrailway car greaserrailway car lubricating specialistrailway car lubricatorrailway car oilerrailway line inspectorrailway maintenance equipment operatorrailway signalmanrailway signalman/womanrailway signalwomanrailway tank car servicerrailway-tie-injector operatorrailway tie inspectorrailway track inspectorrailway track maintenance equipment operatorrailway track maintenance workerrailway trackmanrailway trackman/womanrailway track patrollerrailway track repairerrailway track repairmanrailway track repairwomanrailway track tamper operatorrailway trackwomanrailway train engine maintenance workerretarder operator - railway yardsection worker - railwayservicer, locomotivessignalman, railwaysignalman - railway transportsignalman/woman, railwaysignalman/woman - railway transportsignal tower operator - railwaysignalwoman, railwaysignalwoman - railway transportsnowblower operator - railwayspike-driver operator - railwayspike machine operator - railwayspike puller machine operator - railwayspiker operator - railwayspiking machine operator - railway",
    "workers": 75,
    "minEduc": 0,
    "yearsStudy": 1,
    "automationRisk": 0.895,
    "salaryLow": 17.6,
    "salaryMed": 26.01,
    "salaryHigh": 31,
    "totalSkill": 123,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 26.01,
    "skillsComp": 34,
    "skillsLogi": 31,
    "skillsMath": 18,
    "skillsLang": 40,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 20,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 55,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 55,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 395,
    "noc": 7532,
    "job": "Water transport deck and engine room crew",
    "title1": "able-bodied seaman",
    "title2": "able-bodied seaman/woman",
    "title3": "able-bodied seawoman",
    "allTitles": "able-bodied seamanable-bodied seaman/womanable-bodied seawomanable seaman - except armed forcesable seaman/woman - except armed forcesable seawoman - except armed forcesbarge deckhandboatswainboatswain - water transportboiler tender - shipsdeckhanddeckhand, dredgedeckhand - shipsdredge deckhandengine and boiler room crew member - shipsengine room crew member - shipengine room crew member, shipengine room greaser - marineengine room greaser - water transportengine room mechanical assistant, shipengine room mechanical assistant - shipsferryboat deckhandgreaser, engine roomgreaser, engine room - marinehelmsman - water transporthelmsman/woman - water transporthelmswoman - water transportlog boom tugboat deckhandmarine engineering mechanicmarine engineering technicianmarine engine oilermarine oilermechanical assistant, engine room - shipsmechanical assistant, ship's engine roommechanical assistant - water transportoiler, marineordinary seaman - except armed forcesordinary seaman/woman - except armed forcesordinary seawoman - except armed forcespumpman - shipspumpman/woman - shipspump seamanpump seaman/womanpump seawomanpumpwoman - shipsquartermasterseamanseaman/womanseawomanship boiler tendership engine room greasership engine room mechanical assistantship's carpentership stokership tunnelmanship tunnelman/womanship tunnelwomanship watchmanship watchman/womanship watchwomanstoker - shipstanker pumper - shiptugboat deckhandtunnelman, shiptunnelman/woman, shiptunnel operator, shiptunnelwoman, shipwatchman, shipwatchman/woman, shipwatchwoman, shipwheelsmanwheelsman/womanwheelswoman",
    "workers": 15,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.86,
    "salaryLow": 18,
    "salaryMed": 26.87,
    "salaryHigh": 27.31,
    "totalSkill": 125,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 26.87,
    "skillsComp": 34,
    "skillsLogi": 32,
    "skillsMath": 18,
    "skillsLang": 41,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 396,
    "noc": 7533,
    "job": "Boat and cable ferry operators and related occupations",
    "title1": "attendant, ferry terminal barge captain barge operator beachcomber bridge attendant � canal lock systems bridge keeper � lock system bridgemaster bridgemaster � lock systems cable ferry deckhand cable ferry operator cable ferry operator, manual canal lock operator canal lock tender canal lockman/woman charter boat captain charter boat master charter boat operator dry dock worker � shipbuilding ferry operator ferry terminal attendant ferry terminal worker launch captain launch master launch operator launch owner-operator lighthouse keeper lineshandler � canal lock system linesman/woman � canal lock system loading bridge operator loading bridge operator � ferry lock operator lockmaster motor boat operator motor launch operator motorboat captain motorboat operator power cable ferry operator reaction ferry operator repair ship owner-operator scow captain scow operator sightseeing boat captain sightseeing boat master sightseeing boat operator small craft operator water bus captain water bus master water bus operator water taxi captain water taxi master water taxi operator workboat operator",
    "title2": 0,
    "title3": 0,
    "allTitles": "attendant, ferry terminal barge captain barge operator beachcomber bridge attendant � canal lock systems bridge keeper � lock system bridgemaster bridgemaster � lock systems cable ferry deckhand cable ferry operator cable ferry operator, manual canal lock operator canal lock tender canal lockman/woman charter boat captain charter boat master charter boat operator dry dock worker � shipbuilding ferry operator ferry terminal attendant ferry terminal worker launch captain launch master launch operator launch owner-operator lighthouse keeper lineshandler � canal lock system linesman/woman � canal lock system loading bridge operator loading bridge operator � ferry lock operator lockmaster motor boat operator motor launch operator motorboat captain motorboat operator power cable ferry operator reaction ferry operator repair ship owner-operator scow captain scow operator sightseeing boat captain sightseeing boat master sightseeing boat operator small craft operator water bus captain water bus master water bus operator water taxi captain water taxi master water taxi operator workboat operator",
    "workers": 200,
    "minEduc": 0,
    "yearsStudy": 1.520833333,
    "automationRisk": 0.83375,
    "salaryLow": 15.9,
    "salaryMed": 21.97,
    "salaryHigh": 26.4525,
    "totalSkill": 123.75,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "#DIV/0!",
    "cluster": 3,
    "wage": 21.7825,
    "skillsComp": 34,
    "skillsLogi": 31.5,
    "skillsMath": 18,
    "skillsLang": 40.5,
    "topSkill1": "#DIV/0!",
    "topSkill2": "#DIV/0!",
    "topSkill3": "#DIV/0!",
    "s1DataAnalysis": 3.75,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.75,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4.25,
    "s12DigitalTechnology": 12.25,
    "s13DocumentUse": 17.75,
    "s14Writing": 10.25,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 122.5,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 58.75,
    "f8Education(teachertraining)": 0,
    "f9Law": 12.5,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 6.25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 58.75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 12.5,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 122.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 6.25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 397,
    "noc": 7534,
    "job": "Air transport ramp attendants",
    "title1": "aircraft cleaner",
    "title2": "aircraft groomer",
    "title3": "aircraft refueler",
    "allTitles": "aircraft cleaneraircraft groomeraircraft refueleraircraft towing equipment operatorairport ramp attendantbaggage loader - air transportcargo attendant, air transportcargo handler - air transportcargo loader - air transportfreight attendant - air transportgroomer, aircraftramp agent, air transportramp attendant, air transportramp lead hand - air transportramp station attendant - air transportstation attendant, air transport",
    "workers": 85,
    "minEduc": 0,
    "yearsStudy": 1.75,
    "automationRisk": 0.99,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 29.5,
    "totalSkill": 117,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 21,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 45,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 45,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 398,
    "noc": 7535,
    "job": "Other automotive mechanical installers and servicers",
    "title1": "automobile lubricator",
    "title2": "automotive muffler installer",
    "title3": "automotive radiator installer",
    "allTitles": "automobile lubricatorautomotive muffler installerautomotive radiator installerautomotive radiator installer - automotive repairautomotive shock absorber installerautomotive spring installercaterpillar serviceman (except mechanic)caterpillar servicer (except mechanic)caterpillar servicewoman (except mechanic)crane greasercrane oilercrawler track servicerdragline oilerelectric golf cart serviceman (except mechanic)electric golf cart servicer (except mechanic)electric golf cart servicewoman (except mechanic)electric truck serviceman (except mechanic)electric truck servicer (except mechanic)electric truck servicewoman (except mechanic)emergency road servicer, motor vehicleexcavator oilergreasergreaser, heavy truckheavy-duty equipment servicerheavy equipment greaserheavy equipment servicerhostler - transit systeminstaller, automotive shock absorbersinstaller, automotive springsinstaller, mufflerinstaller, radiators - automotive serviceloading shovel oilerlubrication technician - automotive service and repairmuffler installeroil changer - motor vehicle serviceoiler and greaser, crane and draglineoiler - automotive serviceoiler, heavy truckpipeline service truck driverradiator installer - automotive serviceradiator installer - auto repair serviceservicer, heavy equipmentservicer, pipeline equipmentservice truck driver, heavy equipmentshock absorber installershovel oilerspring installerstripping shovel oilertire changer - automotive servicetire repairertire repairer - automotive servicetire repairmantire repairman - automotive servicetire repairwomantire repairwoman - automotive service",
    "workers": 625,
    "minEduc": 0,
    "yearsStudy": 1.333333333,
    "automationRisk": 0.59,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 18,
    "totalSkill": 130,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 13.25,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 455,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 120,
    "f8Education(teachertraining)": 0,
    "f9Law": 50,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 120,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 50,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 455,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 399,
    "noc": 7611,
    "job": "Construction trades helpers and labourers",
    "title1": "access floor installer helper",
    "title2": "air breaker operator",
    "title3": "air gun operator",
    "allTitles": "access floor installer helperair breaker operatorair gun operatorair hammer operator - constructionair lock tenderair tool operatorair track drill operator helperasbestos fibre preparerasbestos removerasbestos worker - constructionasphalt cold patcherasphalt mixerasphalt plant labourer - constructionasphalt rakerasphalt roofer helperasphalt spreaderasphalt worker - roadawning installer helperbatterboard setterbending machine operator - pipelinesbill posterbituminous paving labourerbituminous paving machine operatorblacktop rakerblacktop spreaderblower operator, insulationbrick cleanerbricklayer helperbrickmason's helperbridge gang worker - constructionbuilding and house wreckerbuilding painter helperbuilding wreckercabinetmaker's helpercarpenter helpercarpet layer helpercarpet mechanics helpercaulker - constructioncaulker, precast concretecement and concrete pump tendercement finisher helpercement gun nozzle operatorcement gun operatorcement mixer operator - constructioncement pump operatorchainman, pile drivingchainman/woman, pile drivingchainwoman, pile drivingchurn drill operator helper - water wellclamper - constructioncold patcher, asphaltconcrete block pourerconcrete breakerconcrete finisher helperconcrete float pourerconcrete former helperconcrete gun operatorconcrete mixer helperconcrete mixer operator - constructionconcrete mixer operator helper - highway constructionconcrete paver operator helperconcrete paving labourerconcrete pourer - constructionconcrete pump operatorconcrete spreader operatorconcrete vibrator operator, manualconcrete waterproofer - constructionconstruction craft labourerconstruction electrician helperconstruction helperconstruction labourerconstruction labourer and helperconstruction trades helperconstruction workercrane chasercrane hookercupola spray relinercurb builder, manualdampproofer helperdeck workerdemolition workerdiamond driller helper - surface miningdigger - constructiondigger, sewersditch cleaner - constructiondoor frame installerdope machine operator - pipelinesdragline operator helperdredge workerdriller helper - surface miningdrywall and acoustical installer helperdrywall sanderearthworks labourer - constructionerector, highway signserector, scaffoldexcavation labourerexcavation workerexterior cladder helperfinisher helper, terrazzofirebrick layer helper",
    "workers": 13595,
    "minEduc": 1,
    "yearsStudy": 1.91322314,
    "automationRisk": 0.88,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 35,
    "totalSkill": 98,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Trades helpers, construction labourers and related occupations",
    "cluster": 3,
    "wage": 20,
    "skillsComp": 27,
    "skillsLogi": 26,
    "skillsMath": 16,
    "skillsLang": 29,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 5,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 10,
    "s14Writing": 6,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 1725,
    "f2Engineering": 1505,
    "f3Humanities": 135,
    "f4SocialScience": 210,
    "f5FineArts": 280,
    "f6MathAndComputerScience": 240,
    "f7Arts&Education": 7485,
    "f8Education(teachertraining)": 0,
    "f9Law": 695,
    "f10Health": 140,
    "f11Health,Nursing&ClinicalLaboratory": 155,
    "f12Business": 1025,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 95,
    "d2Forestry": 35,
    "d3Architecture&LandscapeArchitecture": 100,
    "d4Humanities": 135,
    "d5SocialSciences": 210,
    "d6Fine&AppliedArts": 280,
    "d7ComputerScience": 240,
    "d8OtherArts&Science": 7485,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1405,
    "d11Law": 695,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 100,
    "d14Theology": 0,
    "d15PhysicalSciences": 1595,
    "d16Therapy&Rehabilitation": 40,
    "d17Health,Nursing&ClinicalLaboratory": 155,
    "d18Business&Commerce": 1025,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 400,
    "noc": 7612,
    "job": "Other trades helpers and labourers",
    "title1": "aerial spraying assistant",
    "title2": "aerial spraying lineman",
    "title3": "aerial spraying lineman/woman",
    "allTitles": "aerial spraying assistantaerial spraying linemanaerial spraying lineman/womanaerial spraying linewomanair conditioning mechanic helperaircraft instrument mechanic helperaircraft mechanic helperautomobile body repairer helperautomobile body repairman helperautomobile body repairwoman helperautomobile bumper straightenerautomotive electrician helperautomotive mechanic helperbody repairer helper, automobilebody repairman helper, automobilebody repairwoman helper, automobilecable installation and repair helper - telecommunicationscable installer helpercableman helpercableman/woman helpercable repairer helpercable repairer helper - telecommunicationscable repairman helpercable repairman helper - telecommunicationscable repairwoman helpercable repairwoman helper - telecommunicationscable splicer helpercablewoman helperchainman - land surveyingchainman/woman - land surveyingchainwoman - land surveyingchemical process equipment mechanic helpercommercial air conditioning mechanic helpercompassman - land surveyingcompassman/woman - land surveyingcompasswoman - land surveyingconstruction equipment mechanic helpercrawler track repairer helpercrawler track repairman helpercrawler track repairwoman helperdiesel mechanic helperdiver helperelectrical mechanic helperelectric cable network installer helperelectric cable splicer helperelectrician helper, automotiveelectrician helper, powerhouseelectric motor repairer helperelectric motor repairman helperelectric motor repairwoman helperelectric power and wire communications labourerelevator constructor helperelevator mechanic helperengine fitter helperfactory maintenance mechanic helperfield mechanic helperfire equipment serviceman helperfire equipment servicer helperfire equipment servicewoman helperfurnace repairer helperfurnace repairman helperfurnace repairwoman helpergas meter repairer helpergas meter repairman helpergas meter repairwoman helperground hand - telecommunicationsground worker - power linesground worker - telecommunicationshand cutter, peat mosshand peat moss cutterheating and air conditioning mechanic helperheating and cooling mechanic helperheavy equipment mechanic helperhelper, automotive electricianhelper, automotive mechanichelper, cable installation and repair - telecommunicationshelper, cable splicerhelper, commercial air conditioning mechanichelper, diverhelper, elevator mechanichelper, engine fitterhelper, furnace repairerhelper, furnace repairmanhelper, furnace repairwomanhelper, heating and cooling mechanichelper, industrial mechanichelper, mechanichelper, millwrighthelper, motor vehicle body repairerhelper, motor vehicle body repairmanhelper, motor vehicle body repairwomanhelper, motor vehicle mechanichelper, oil burner mechanichelper, oil burner technicianhelper, powerhouse electricianhelper, small-engine mechanicindustrial instrument repairer helperindustrial instrument repairman helperindustrial instrument repairwoman helperindustrial machinery oiler",
    "workers": 130,
    "minEduc": 1,
    "yearsStudy": 1.5,
    "automationRisk": 0.88,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 36.75,
    "totalSkill": 100,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Trades helpers, construction labourers and related occupations",
    "cluster": 3,
    "wage": 17,
    "skillsComp": 27,
    "skillsLogi": 27,
    "skillsMath": 17,
    "skillsLang": 29,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 5,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 10,
    "s14Writing": 6,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 110,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 110,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 401,
    "noc": 7621,
    "job": "Public works and maintenance labourers",
    "title1": "casual worker - public works",
    "title2": "dumpman",
    "title3": "dumpman/woman",
    "allTitles": "casual worker - public worksdumpmandumpman/womandumpwomangarbage receptacle maintainergarbage truck loadergeneral labourer - public workshelper - garbage collectionhighway line painterlabourer crew leader - public workslabourer - sanitary serviceline-painting machine operator - highways and roadsmaintenance labourer - public worksmanual cleaner, sewer pipesmanual cleaner, sidewalksmanual sewer pipe cleanermanual sidewalk cleanermanual street cleanermanual street sweepermunicipal elemental workermunicipal general labourermunicipal labourerparking meter collectorplayground maintenance manplayground maintenance man/womanplayground maintenance womanpublic works labourerroad maintenance workerroad maintenance worker - public workssanitation mansanitation man/womansanitation womansanitation workerseasonal worker - public workssewer maintenance workersewer system maintenance workersidewalk cleanersidewalk-cleaning equipment operatorsidewalk snowplough operatorsnowplough operator, sidewalk",
    "workers": 1245,
    "minEduc": 1,
    "yearsStudy": 1.756756757,
    "automationRisk": 0.898,
    "salaryLow": 14,
    "salaryMed": 18.75,
    "salaryHigh": 28.06,
    "totalSkill": 108,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Trades helpers, construction labourers and related occupations",
    "cluster": 3,
    "wage": 18.75,
    "skillsComp": 35,
    "skillsLogi": 27,
    "skillsMath": 15,
    "skillsLang": 31,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 7,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 25,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 365,
    "f2Engineering": 95,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 495,
    "f8Education(teachertraining)": 0,
    "f9Law": 175,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 100,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 495,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 95,
    "d11Law": 175,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 330,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 100,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 402,
    "noc": 7622,
    "job": "Railway and motor transport labourers",
    "title1": "car checker � railway transport car checker, railway car weigher � railway carman/woman helper � railway cold-storage checker � transport crossing attendant � railway crossing gateman/woman � railway transport deliverer helper delivery truck driver helper delivery truck helper driver helper engineer's assistant freight car checker � railway freight car weigher fuel and sand operator � railway transport fuel truck driver helper furniture mover helper gateman/woman � railway transport helper, carman/woman helper, delivery truck labourer, section � railway labourer, yard � railway transport motor transport labourer mover helper moving van helper rail lubricator railway car decal applier railway car weigher railway labourer railway track labourer railway track maintenance labourer railway yard labourer route driver helper section labourer � railway siding checker-messenger � railway transport signal gang helper swamper � truck transport track greaser � railway track labourer, railway track sweeper � railway truck driver helper weigher, freight cars weigher, railway car",
    "title2": 0,
    "title3": 0,
    "allTitles": "car checker � railway transport car checker, railway car weigher � railway carman/woman helper � railway cold-storage checker � transport crossing attendant � railway crossing gateman/woman � railway transport deliverer helper delivery truck driver helper delivery truck helper driver helper engineer's assistant freight car checker � railway freight car weigher fuel and sand operator � railway transport fuel truck driver helper furniture mover helper gateman/woman � railway transport helper, carman/woman helper, delivery truck labourer, section � railway labourer, yard � railway transport motor transport labourer mover helper moving van helper rail lubricator railway car decal applier railway car weigher railway labourer railway track labourer railway track maintenance labourer railway yard labourer route driver helper section labourer � railway siding checker-messenger � railway transport signal gang helper swamper � truck transport track greaser � railway track labourer, railway track sweeper � railway truck driver helper weigher, freight cars weigher, railway car",
    "workers": 1245,
    "minEduc": 1,
    "yearsStudy": 1.756756757,
    "automationRisk": 0.898,
    "salaryLow": 14,
    "salaryMed": 18.75,
    "salaryHigh": 28.06,
    "totalSkill": 108,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Trades helpers, construction labourers and related occupations",
    "cluster": 3,
    "wage": 18.75,
    "skillsComp": 35,
    "skillsLogi": 27,
    "skillsMath": 15,
    "skillsLang": 31,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 7,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 7,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 25,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 365,
    "f2Engineering": 95,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 15,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 495,
    "f8Education(teachertraining)": 0,
    "f9Law": 175,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 100,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 35,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 15,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 495,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 95,
    "d11Law": 175,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 330,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 100,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 403,
    "noc": 8211,
    "job": "Supervisors, logging and forestry",
    "title1": "boom master - logging",
    "title2": "buckers supervisor",
    "title3": "contractor, forest conservation",
    "allTitles": "boom master - loggingbuckers supervisorcontractor, forest conservationcontractor, loggingcontractor, silviculturefire suppression crew foreman - forestryfire suppression crew foreman/woman - forestryfire suppression crew forewoman - forestryforeman, forestryforeman, loggingforeman, planting crewforeman, pondforeman/woman, forestryforeman/woman, loggingforeman/woman, planting crewforeman/woman, pondforest operations supervisorforestry conservation contractorforestry crew supervisorforestry foremanforestry foreman/womanforestry forewomanforestry supervisorforewoman, forestryforewoman, loggingforewoman, planting crewforewoman, pondgrapple yarder hook tenderhook and rig supervisor - logginghook tenderhook tender - loggingloading foreman - loggingloading foreman/woman - loggingloading forewoman - loggingloggers supervisor - forestrylogging contractorlogging crew supervisor - forestrylogging foremanlogging foreman/womanlogging forewomanlogging supervisorlog yarding bossplanting crew foremanplanting crew foreman/womanplanting crew forewomanpond foremanpond foreman/womanpond forewomanproduction supervisor - loggingsetting foreman loggingsetting foreman/woman loggingsetting forewoman loggingsilviculture contractorsilviculture supervisorskidders foreman - loggingskidders foreman/woman - loggingskidders forewoman - loggingsupervisor, forest operationssupervisor, forestrysupervisor, forestry crewsupervisor, loggingwoods foremanwoods foreman/womanwoods forewoman",
    "workers": 9950,
    "minEduc": 1,
    "yearsStudy": 2.06680162,
    "automationRisk": 0.6885,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 142,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Transport and heavy equipment operation and related maintenance occupations",
    "cluster": 3,
    "wage": 27.01685071,
    "skillsComp": 33.5,
    "skillsLogi": 41,
    "skillsMath": 22.5,
    "skillsLang": 44.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.5,
    "s6MoneyMath": 5,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6.5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 17,
    "s14Writing": 11.5,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 50,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 50,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 404,
    "noc": 8221,
    "job": "Supervisors, mining and quarrying",
    "title1": "blasters foreman - mining and quarrying",
    "title2": "blasters foreman - quarrying",
    "title3": "blasters foreman - surface mining",
    "allTitles": "blasters foreman - mining and quarryingblasters foreman - quarryingblasters foreman - surface miningblasters foreman/woman - mining and quarryingblasters foreman/woman - quarryingblasters foreman/woman - surface miningblasters forewoman - mining and quarryingblasters forewoman - quarryingblasters forewoman - surface miningboss, level - underground miningboss, sand fill - underground miningboss, shift - mining and quarryingboss, track layers - underground miningboss, yard - mining and quarryingcoal mine foremancoal mine foreman/womancoal mine forewomanconstruction supervisor - underground mining and quarryingdiamond drilling foremandiamond drilling foreman/womandiamond drilling forewomandrill fitter boss - miningdrill fitter foreman - miningdrill fitter foreman/woman - miningdrill fitter forewoman - miningdrilling foreman - mining and quarryingdrilling foreman/woman - mining and quarryingdrilling forewoman - mining and quarryingdynamiters foreman - quarryingdynamiters foreman/woman - quarryingdynamiters forewoman - quarryingface boss - underground miningfill foremanfill foreman - underground miningfill foreman/womanfill foreman/woman - underground miningfill forewomanfill forewoman - underground miningfire boss - miningforeman, blasters - quarryingforeman, blasters - surface miningforeman, blasting - mining and quarryingforeman, coal mineforeman, diamond drillingforeman, drilling - mining and quarryingforeman, fill - underground miningforeman, mineforeman, motormen/women and dinkeymen/women (except rail transport)foreman, production - mining and quarryingforeman, quarryforeman, shift - mining and quarryingforeman, shot - mining and quarryingforeman, stope - miningforeman, surface mineforeman, underground mineforeman/woman, blasters - quarryingforeman/woman, blasters - surface miningforeman/woman, blasting - mining and quarryingforeman/woman, coal mineforeman/woman, diamond drillingforeman/woman, drilling - mining and quarryingforeman/woman, fill - underground miningforeman/woman, mineforeman/woman, motormen/women and dinkeymen/women (except rail transport)foreman/woman, production - mining and quarryingforeman/woman, quarryforeman/woman, shift - mining and quarryingforeman/woman, shot - mining and quarryingforeman/woman, stope - miningforeman/woman, surface mineforeman/woman, underground mineforewoman, blasters - quarryingforewoman, blasters - surface miningforewoman, blasting - mining and quarryingforewoman, coal mineforewoman, diamond drillingforewoman, drilling - mining and quarryingforewoman, fill - underground miningforewoman, mineforewoman, motormen/women and dinkeymen/women (except rail transport)forewoman, production - mining and quarryingforewoman, quarryforewoman, shift - mining and quarryingforewoman, shot - mining and quarryingforewoman, stope - miningforewoman, surface mineforewoman, underground minegeneral foreman - mininggeneral foreman/woman - mininggeneral forewoman - miningjunior foreman - miningjunior foreman/woman - miningjunior forewoman - miningleader, shift - mining and quarryinglevel boss - underground miningmine captainmine foremanmine foreman/womanmine forewomanmine supervisor",
    "workers": 1165,
    "minEduc": 1,
    "yearsStudy": 1.392307693,
    "automationRisk": 0.55,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 108,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 24.40835367,
    "skillsComp": 30,
    "skillsLogi": 26,
    "skillsMath": 14,
    "skillsLang": 38,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 5.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 9.5,
    "s9ProblemSolving": 6.5,
    "s10Reading": 19.5,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 10.5,
    "s13DocumentUse": 15,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 55,
    "f2Engineering": 180,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 180,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 405,
    "noc": 8222,
    "job": "Contractors and supervisors, oil and gas drilling and services",
    "title1": "assistant offshore drilling rig superintendent assistant platform superintendent assistant superintendent, offshore drilling rig assistant toolpusher � offshore drilling rig consultant � gas well drilling consultant � oil drilling directional drilling consultant � oil and gas field supervisor, oil well servicing foreman/woman, oil and gas well drilling foreman/woman, oil and natural gas well servicing fracturing supervisor fracturing supervisor � oil field services multi-service operator � oil field services offshore drilling rig superintendent oil and gas contractor oil and gas drilling foreman/woman oil and natural gas well servicing foreman/woman oil well services field supervisor oilfield consultant oilfield consultant � construction and reclamation oilfield consultant � rig moving oilfield consultant � well completions oilfield consultant � well servicing oilfield consultant � well testing oilfield consultant supervisor oilfield contractor platform superintendent � oil and gas drilling rig manager rig manager � oil and gas drilling supervisor, well services crew � oil field services toolpusher � offshore drilling rig toolpusher � oil and gas well well services crew supervisor well services crew supervisor � oil and gas drilling well services crew supervisor � oil field services well site consultant � oil and gas wireline field supervisor � oil field services",
    "title2": 0,
    "title3": 0,
    "allTitles": "assistant offshore drilling rig superintendent assistant platform superintendent assistant superintendent, offshore drilling rig assistant toolpusher � offshore drilling rig consultant � gas well drilling consultant � oil drilling directional drilling consultant � oil and gas field supervisor, oil well servicing foreman/woman, oil and gas well drilling foreman/woman, oil and natural gas well servicing fracturing supervisor fracturing supervisor � oil field services multi-service operator � oil field services offshore drilling rig superintendent oil and gas contractor oil and gas drilling foreman/woman oil and natural gas well servicing foreman/woman oil well services field supervisor oilfield consultant oilfield consultant � construction and reclamation oilfield consultant � rig moving oilfield consultant � well completions oilfield consultant � well servicing oilfield consultant � well testing oilfield consultant supervisor oilfield contractor platform superintendent � oil and gas drilling rig manager rig manager � oil and gas drilling supervisor, well services crew � oil field services toolpusher � offshore drilling rig toolpusher � oil and gas well well services crew supervisor well services crew supervisor � oil and gas drilling well services crew supervisor � oil field services well site consultant � oil and gas wireline field supervisor � oil field services",
    "workers": 1165,
    "minEduc": 1,
    "yearsStudy": 1.392307693,
    "automationRisk": 0.55,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 108,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Service supervisors and specialized service occupations",
    "cluster": 9,
    "wage": 24.40835367,
    "skillsComp": 30,
    "skillsLogi": 26,
    "skillsMath": 14,
    "skillsLang": 38,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 5.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 9.5,
    "s9ProblemSolving": 6.5,
    "s10Reading": 19.5,
    "s11SchedulingorBudgetingandAccounting": 3.5,
    "s12DigitalTechnology": 10.5,
    "s13DocumentUse": 15,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 55,
    "f2Engineering": 180,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 180,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 406,
    "noc": 8231,
    "job": "Underground production and development miners",
    "title1": "apprentice miner",
    "title2": "bench blaster - underground mining",
    "title3": "blaster - underground mining",
    "allTitles": "apprentice minerbench blaster - underground miningblaster - underground miningblast hole driller - underground miningblockholer - underground miningbolter operator - underground miningbrine well tenderchute blasterchute blaster - underground miningcoal minercontinuous mining machine operatorcore drillercore driller - underground miningcore-drill operatorcore-drill operator - underground miningcutting machine operator - underground miningdevelopment minerdiamond driller - underground miningdiamond-drill operatordiamond-drill runner - underground miningdiamond-point drill operatordiesel loaderman - underground miningdiesel loaderman/woman - underground miningdiesel loaderwoman - underground miningdownhole loader - underground miningdrift driller - underground miningdrift minerdriller, drift - underground miningdriller, long-hole - underground miningdriller, rotary raise - underground miningdriller - underground miningdrilling machine operator - underground miningfaceman - coal minefaceman/woman - coal minefacewoman - coal minehang-up blaster - underground mininghardrock minerhardrock miner apprenticehigh-raise blasterhoistman underground mininghoistman/woman underground mininghoist operator - underground mininghoistwoman underground mininghydraulic coal monitor operatorin-hole drill operator - underground miningITH (in-the-hole) drillerjack leg drill operator - underground miningjumbo drill operatorjumbo drill operator - underground miningLHD (load-haul-dump) operator - underground miningloaderman, diesel - underground miningloaderman/woman, diesel - underground miningloaderwoman, diesel - underground miningload-haul-dump (LHD) operator - underground miningloading machine operator - underground mininglong-hole blaster - underground mininglong-hole driller - underground mininglongwall coal shearer operatorminermining machine operatormucker - underground miningmucking machine operatormucking machine operator - underground miningpotash minerpowderman - underground miningpowderman/woman - underground miningpowderwoman - underground miningproduction drillerproduction loader operatorproduction minerraise boring machine operator - underground miningraise driller - underground miningraisemanraiseman/womanraise minerraisewomanring drill operatorroadheader operatorrockbolterroof bolterrotary raise driller - underground miningscoop operator - underground miningscooptram operatorscooptram operator - underground miningshaft drillershaft inspectorshaft minershearer operator - underground miningshearing machine operator - underground miningshot firershot firer - underground miningshotman - underground miningshotman/woman - underground miningshotwoman - underground miningslusher operator - underground miningsoft rock minerstope driller - underground miningstope minerundercutter operator - underground miningwagon drill operator - underground mining",
    "workers": 1885,
    "minEduc": 0.5,
    "yearsStudy": 1.25862069,
    "automationRisk": 0.7125,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 122.5,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 23.90194801,
    "skillsComp": 31,
    "skillsLogi": 33,
    "skillsMath": 17,
    "skillsLang": 42,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.5,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 10.5,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 7.5,
    "s13DocumentUse": 21,
    "s14Writing": 9.5,
    "s15CriticalThinking": 3.5,
    "f1Science&Agriculture": 185,
    "f2Engineering": 1345,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 10,
    "f7Arts&Education": 250,
    "f8Education(teachertraining)": 0,
    "f9Law": 85,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 10,
    "d8OtherArts&Science": 250,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 1345,
    "d11Law": 85,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 185,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 407,
    "noc": 8232,
    "job": "Oil and gas well drillers, servicers, testers and related workers",
    "title1": "assistant driller - offshore drilling rig",
    "title2": "assistant driller - oil and gas well drilling",
    "title3": "coring operator - oil field services",
    "allTitles": "assistant driller - offshore drilling rigassistant driller - oil and gas well drillingcoring operator - oil field servicesdirectional driller - oil and gas drillingdirectional drilling operatordirectional drilling operator - oil and gas drillingdownhole tool operatordownhole tool operator - oil and gas drillingdriller - offshore drilling rigdriller - oil and gas drillingdrill stem testerdrill stem tester - oil and gas drillingelectric line operatorelectric line operator - oil field servicese-line operator - oil field servicesfishing tool operator - oil field servicesgas tester - oil field servicesgun perforator - oil field serviceshydrocarbon mud logger - oil field serviceslogging and perforating operatorlogging and perforating operator - oil field servicesoffshore driller - oil and gasoil well perforatorperforator, oil wellsproduction testing operator - oil and gas well drillingrig technician - drillerservice rig operatorservice rig operator - oil field servicessidewall core sampler - oil field servicesslickline operatorslickline operator - oil field serviceswell puller - oil field serviceswell testing operatorwell testing operator - oil and gas drillingwireline operatorwireline operator - oil field serviceswireline operator traineeworkover rig operator - oil field services",
    "workers": 30,
    "minEduc": 0,
    "yearsStudy": 1.5,
    "automationRisk": 0.772,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 132,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 22.54994012,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 10,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 20,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 20,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 10,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 408,
    "noc": 8241,
    "job": "Logging machinery operators",
    "title1": "bunk skidder operator",
    "title2": "cable yarding operator",
    "title3": "cable yarding system operator",
    "allTitles": "bunk skidder operatorcable yarding operatorcable yarding system operatorchipping machine operatorchipping machine operator - loggingcrane and claw operator - loggingdelimber and buncher operatordelimber operatorfeller buncher operatorfeller delimber operatorfeller forwarder operatorforwarder operator - logginggrapple operator - logginggrapple yarder operator - logginglinehorse operatorloader, logging truckloader operator - logginglogging crane operatorlogging machinery operatorlogging truck loaderlog loader operatorlog loading machine operatorlog process operatorlog processor operatormechanical harvester and forwarder operatormechanical harvester operator - loggingmechanical tree processor and loader operatormechanical tree processor operator - loggingmobile chipper operator - loggingmobile whole tree chipper - loggingoperator, cable yarding systemoperator, chipping machine - loggingoperator, crane and claw - loggingoperator, delimberoperator, feller buncheroperator, forwarder - loggingoperator, grapple loader - loggingoperator, grapple yarder - loggingoperator, linehorseoperator, logging craneoperator, logging machineryoperator, log loaderoperator, log loading machineoperator, mechanical harvester - loggingoperator, mechanical tree processor - loggingoperator, mobile chipper - loggingoperator, picker truckoperator, pulpwood harvesteroperator, shortwood harvesteroperator, slasher - loggingoperator, slasher sawyer - loggingoperator, tree processor - loggingpicker truck operatorpulpwood harvester operatorrigging slinger - loggingshortwood harvester operatorslasher-brusherslasher loader operatorslasher operator - loggingslasher saw operator - loggingslasher sawyer operator - loggingsteel spar operator - loggingtree harvester operatortreelength forwarder operatortree-length harvester operatortree processor operator - loggingyarder operator - loggingyarding engineer - logging",
    "workers": 155,
    "minEduc": 0,
    "yearsStudy": 1,
    "automationRisk": 0.79,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 131,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 22.21210976,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 95,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 60,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 95,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 60,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 409,
    "noc": 8252,
    "job": "Agricultural service contractors, farm supervisors and specialized livestock workers",
    "title1": "aerial crop dusting service contractor",
    "title2": "agriculture foreman",
    "title3": "agriculture foreman/woman",
    "allTitles": "aerial crop dusting service contractoragriculture foremanagriculture foreman/womanagriculture forewomananimal farm foremananimal farm foreman/womananimal farm forewomananimal husbandry foremananimal husbandry foreman/womananimal husbandry forewomanapple orchard foremanapple orchard foreman/womanapple orchard forewomanartificial insemination service contractorartificial inseminatorbeef cattle herdspersoncaponizing service contractorcattle feedlot foremancattle feedlot foreman/womancattle feedlot forewomancattle herdspersoncattle ranch foremancattle ranch foreman/womancattle ranch forewomancontractor - agricultural servicecontractor, artificial insemination servicecontractor, crop harvesting servicecontractor, farm produce packing servicecontractor, fertilization service - agriculturecontractor, weed control service - agriculturecorral bosscrop dusting contractorcrop dusting service contractorcrop harvesting contractorcrop harvesting service contractorcustom combine contractorcustom combine operatorcustom harvestercustom operator, farm machinerydairy farm foremandairy farm foreman/womandairy farm forewomandairy farm workers foremandairy farm workers foreman/womandairy farm workers forewomandairy herdspersondehorning service contractordressage and stunt horse traineregg grading station managerfarm bossfarm business foremanfarm business foreman/womanfarm business forewomanfarm foremanfarm foreman/womanfarm forewomanfarm irrigating system contractorfarm operation foremanfarm operation foreman/womanfarm operation forewomanfarm operation supervisorfarm produce grading service contractorfarm produce packing service contractorfarm supervisorfarm workers supervisorfeedlot foremanfeedlot foreman/womanfeedlot forewomanfeedlot herd attendantfertilization service contractor - agriculturefield crop and vegetable workers foremanfield crop and vegetable workers foreman/womanfield crop and vegetable workers forewomanfield crop foremanfield crop foreman/womanfield crop forewomanfield-grown crop foremanfield-grown crop foreman/womanfield-grown crop forewomanfield-grown crop workers foremanfield-grown crop workers foreman/womanfield-grown crop workers forewomanforeman, apple orchardforeman, dairy farm workersforeman, farmforeman, feedlotforeman, field crop and vegetable workersforeman, fruit farmforeman, fruit farm workersforeman, hatchery workersforeman, livestock farm workersforeman, orchardforeman, poultry farm workersforeman, ranchforeman, vegetable farm workersforeman, vineyardforeman/woman, apple orchardforeman/woman, dairy farm workersforeman/woman, farmforeman/woman, feedlot",
    "workers": 130,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.57,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 139,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 26.34114742,
    "skillsComp": 38,
    "skillsLogi": 35,
    "skillsMath": 20,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 13,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 100,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 100,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 410,
    "noc": 8255,
    "job": "Contractors and supervisors, landscaping, grounds maintenance and horticulture services",
    "title1": "caretaker, park",
    "title2": "cemetery foreman",
    "title3": "cemetery foreman/woman",
    "allTitles": "caretaker, parkcemetery foremancemetery foreman/womancemetery forewomancontractor, lawn care servicecountry club grounds supervisorcrew chief, greenhouse workerscrew chief, nursery workersforeman, cemeteryforeman, groundskeepingforeman, landscapingforeman, nurseryforeman, weed controlforeman/woman, cemeteryforeman/woman, groundskeepingforeman/woman, landscapingforeman/woman, nurseryforeman/woman, weed controlforewoman, cemeteryforewoman, groundskeepingforewoman, landscapingforewoman, nurseryforewoman, weed controlgreenhouse foremangreenhouse foreman/womangreenhouse forewomangreenhouse supervisorgreenhouse worker crew chiefgroundskeeper supervisorgroundskeeping foremangroundskeeping foreman/womangroundskeeping forewomangroundskeeping supervisorgroundskeeping supervisor - cemeterygrounds maintenance contractorgrounds maintenance supervisorhead, park maintenancehorticultural contractorhorticulture workers supervisorinterior plantscaping contractorlandscape design contractorlandscape maintenance contractorlandscape service contractorlandscaping contractorlandscaping foremanlandscaping foreman/womanlandscaping forewomanlandscaping supervisorlawn care contractorlawn care service contractorlawn care supervisorlawn maintenance contractornursery foremannursery foreman/womannursery forewomannursery supervisornursery worker crew chiefnursery worker foremannursery worker foreman/womannursery worker forewomannursery workers supervisorpark caretakerpark labourers supervisorpark maintenance headpark maintenance supervisorpark section head - arboriculturepark supervisor, grounds maintenanceplantscape maintenance contractorsupervisor, groundsmansupervisor, groundsman/womansupervisor, groundsperson - campgroundsupervisor, groundswomansupervisor, horticulture workerssupervisor, landscapingsupervisor, maintenance worker - campgroundsupervisor, nursery workerssupervisor, park labourerssupervisor, public works grounds maintenance labourerssupervisor, public works grounds maintenance workerssupervisor, tree servicetree removal contractortree service contractortree service supervisorweed control foremanweed control foreman/womanweed control forewoman",
    "workers": 1150,
    "minEduc": 2,
    "yearsStudy": 1.96,
    "automationRisk": 0.57,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 186,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 21,
    "skillsComp": 48,
    "skillsLogi": 46,
    "skillsMath": 44,
    "skillsLang": 48,
    "topSkill1": "Digital Technology",
    "topSkill2": "Scheduling or Budgeting and Accounting",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 12,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 11,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 22,
    "s12DigitalTechnology": 25,
    "s13DocumentUse": 17,
    "s14Writing": 16,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 925,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 85,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 75,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 20,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 830,
    "d2Forestry": 50,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 85,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 20,
    "d14Theology": 0,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 411,
    "noc": 8261,
    "job": "Fishing masters and officers",
    "title1": "boatswain, fishing vessel bo'sun, fishing vessel captain, factory freezer trawler captain, fishing vessel captain, offshore fishing vessel deck officer, fishing vessel factory freezer trawler captain first mate, fishing vessel fishing master fishing vessel boatswain fishing vessel bo'sun fishing vessel captain fishing vessel master fishing vessel mate fishing vessel navigation officer fishing vessel second mate master, fishing vessel mate, fishing vessel navigation officer, fishing vessel second mate, fishing vessel trawler captain",
    "title2": 0,
    "title3": 0,
    "allTitles": "boatswain, fishing vessel bo'sun, fishing vessel captain, factory freezer trawler captain, fishing vessel captain, offshore fishing vessel deck officer, fishing vessel factory freezer trawler captain first mate, fishing vessel fishing master fishing vessel boatswain fishing vessel bo'sun fishing vessel captain fishing vessel master fishing vessel mate fishing vessel navigation officer fishing vessel second mate master, fishing vessel mate, fishing vessel navigation officer, fishing vessel second mate, fishing vessel trawler captain",
    "workers": 1953.75,
    "minEduc": 0.6875,
    "yearsStudy": 1.571254712,
    "automationRisk": 0.650375,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 133.5625,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 23.97983792,
    "skillsComp": 35.3125,
    "skillsLogi": 34.125,
    "skillsMath": 21.1875,
    "skillsLang": 42.8125,
    "topSkill1": "Digital Technology",
    "topSkill2": "Scheduling or Budgeting and Accounting",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.1875,
    "s2DecisionMaking": 9.0625,
    "s3FindingInformation": 6.1875,
    "s4JobTaskPlanningandOrganizing": 3.125,
    "s5MeasurementandCalculation": 6.875,
    "s6MoneyMath": 2.875,
    "s7NumericalEstimation": 4.5625,
    "s8OralCommunication": 13.375,
    "s9ProblemSolving": 9,
    "s10Reading": 18.25,
    "s11SchedulingorBudgetingandAccounting": 6.8125,
    "s12DigitalTechnology": 13.6875,
    "s13DocumentUse": 17,
    "s14Writing": 11.25,
    "s15CriticalThinking": 6.8125,
    "f1Science&Agriculture": 183.125,
    "f2Engineering": 214.375,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 10.625,
    "f6MathAndComputerScience": 1.25,
    "f7Arts&Education": 59.375,
    "f8Education(teachertraining)": 0,
    "f9Law": 13.125,
    "f10Health": 2.5,
    "f11Health,Nursing&ClinicalLaboratory": 3.75,
    "f12Business": 13.125,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 116.25,
    "d2Forestry": 24.375,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 10.625,
    "d7ComputerScience": 1.25,
    "d8OtherArts&Science": 59.375,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 214.375,
    "d11Law": 13.125,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 2.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 42.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3.75,
    "d18Business&Commerce": 13.125,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 412,
    "noc": 8262,
    "job": "Fishermen/women",
    "title1": "beam trawl fisherman/woman clam dredge operator clam fisherman/woman crab fisherman/woman Danish seine fisherman/woman fisherman/woman fishing vessel skipper gill net fisherman/woman gillnetter skipper handliner fisherman/woman harpoon fisherman/woman hoop net fisherman/woman inshore fisherman/woman line fisherman/woman lobster fisherman/woman longline fisherman/woman longliner fisherman/woman otter trawl fisherman/woman pot fisherman/woman pound net fisherman/woman prawn fisherman/woman purse seine fisherman/woman scallop dredger seaweed harvesting machine operator seiner fisherman/woman shellfish fisherman/woman shore fisherman/woman skipper, fishing vessel skipper, gillnetter swordfish fisherman/woman trap boss � fishing trap fisherman/woman troller fisherman/woman weir fisherman/woman",
    "title2": 0,
    "title3": 0,
    "allTitles": "beam trawl fisherman/woman clam dredge operator clam fisherman/woman crab fisherman/woman Danish seine fisherman/woman fisherman/woman fishing vessel skipper gill net fisherman/woman gillnetter skipper handliner fisherman/woman harpoon fisherman/woman hoop net fisherman/woman inshore fisherman/woman line fisherman/woman lobster fisherman/woman longline fisherman/woman longliner fisherman/woman otter trawl fisherman/woman pot fisherman/woman pound net fisherman/woman prawn fisherman/woman purse seine fisherman/woman scallop dredger seaweed harvesting machine operator seiner fisherman/woman shellfish fisherman/woman shore fisherman/woman skipper, fishing vessel skipper, gillnetter swordfish fisherman/woman trap boss � fishing trap fisherman/woman troller fisherman/woman weir fisherman/woman",
    "workers": 1953.75,
    "minEduc": 0.6875,
    "yearsStudy": 1.571254712,
    "automationRisk": 0.650375,
    "salaryLow": 15,
    "salaryMed": 21,
    "salaryHigh": 30,
    "totalSkill": 133.5625,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Supervisors and technical occupations in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 23.97983792,
    "skillsComp": 35.3125,
    "skillsLogi": 34.125,
    "skillsMath": 21.1875,
    "skillsLang": 42.8125,
    "topSkill1": "Digital Technology",
    "topSkill2": "Scheduling or Budgeting and Accounting",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.1875,
    "s2DecisionMaking": 9.0625,
    "s3FindingInformation": 6.1875,
    "s4JobTaskPlanningandOrganizing": 3.125,
    "s5MeasurementandCalculation": 6.875,
    "s6MoneyMath": 2.875,
    "s7NumericalEstimation": 4.5625,
    "s8OralCommunication": 13.375,
    "s9ProblemSolving": 9,
    "s10Reading": 18.25,
    "s11SchedulingorBudgetingandAccounting": 6.8125,
    "s12DigitalTechnology": 13.6875,
    "s13DocumentUse": 17,
    "s14Writing": 11.25,
    "s15CriticalThinking": 6.8125,
    "f1Science&Agriculture": 183.125,
    "f2Engineering": 214.375,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 10.625,
    "f6MathAndComputerScience": 1.25,
    "f7Arts&Education": 59.375,
    "f8Education(teachertraining)": 0,
    "f9Law": 13.125,
    "f10Health": 2.5,
    "f11Health,Nursing&ClinicalLaboratory": 3.75,
    "f12Business": 13.125,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 116.25,
    "d2Forestry": 24.375,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 10.625,
    "d7ComputerScience": 1.25,
    "d8OtherArts&Science": 59.375,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 214.375,
    "d11Law": 13.125,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 2.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 42.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3.75,
    "d18Business&Commerce": 13.125,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 413,
    "noc": 8411,
    "job": "Underground mine service and support workers",
    "title1": "assembler, extensible conveyor belt - underground mining",
    "title2": "backfiller - underground mining",
    "title3": "backfill plant operator - underground mining",
    "allTitles": "assembler, extensible conveyor belt - underground miningbackfiller - underground miningbackfill plant operator - underground miningblaster helperblaster helper - underground miningblaster, line crew - underground miningbottom cager - underground miningbrattice builder - underground miningbridge operator - underground miningbrusher - underground miningbuilder, brattice - underground miningcage tendercage tender - underground miningchute loader - underground miningchute operator - underground miningcoal hauler - underground miningconstruction worker - minesconveyorman - underground miningconveyorman/woman - underground miningconveyor operatorconveyor operator - underground miningconveyorwoman - underground miningcrusherman - underground miningcrusherman/woman - underground miningcrusher operatorcrusher operator - underground miningcrusherwoman - underground miningdeckman - underground miningdeckman/woman - underground miningdeckwoman - underground miningdiamond driller helper - underground miningdrill carriage operator helper - underground miningdriller helper - underground miningdryman - underground miningdryman/woman - underground miningdrywoman - underground miningerector, steelwork - underground miningextensible conveyor belt assembler - underground miningfootman - underground miningfootman/woman - underground miningfootwoman - underground mininghaulagemanhaulageman - underground mininghaulageman/womanhaulageman/woman - underground mininghaulage truck driver - underground mininghaulagewomanhaulagewoman - underground mininghauler, coal - underground miningheadman - underground miningheadman/woman - underground mininghead operator, loading - underground miningheadwoman - underground mininghelper, blaster - underground mininghelper, borer - underground raise mininghelper, diamond driller - underground mininghelper, drill carriage operator - underground mininghelper, driller - underground mininghelper, jumbo drill operator - underground mininghelper, jumbo operator - underground mininghelper, raise minerhelper, rotary driller - raise miningin-hole driller helper - underground miningjack operator - underground miningjumbo drill operator helper - underground miningjumbo operator helper - underground mininglamp keeperlamp keeper - underground miningline crew blaster - underground miningloader, chute - underground miningloader, skip - underground miningloading head operator - underground miningloading pocket operator - underground miningman, ventilation - underground miningman/woman, ventilation - underground miningmaterialmanmaterialman - underground miningmaterialman/womanmaterialman/woman - underground miningmaterialwomanmaterialwoman - underground miningmine attendantmine construction workermine motormanmine motorman/womanmine motorwomanminer helper - raise miningmine timbermanmine timberman/womanmine timberwomanmotorman - minesmotorman - underground miningmotorman/woman - minesmotorman/woman - underground miningmotorwoman - minesmotorwoman - underground miningnipper - underground miningoperator, chute gate - underground miningoperator, conveyor - underground miningoperator, crusher - underground mining",
    "workers": 80,
    "minEduc": 1,
    "yearsStudy": 1.25,
    "automationRisk": 0.37,
    "salaryLow": 14.66666667,
    "salaryMed": 16.36,
    "salaryHigh": 25.48333333,
    "totalSkill": 109,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 30.89930359,
    "skillsComp": 36,
    "skillsLogi": 30,
    "skillsMath": 12,
    "skillsLang": 31,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 18,
    "s14Writing": 6,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 15,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 414,
    "noc": 8412,
    "job": "Oil and gas well drilling and related workers and services operators",
    "title1": "acid treater � oil field services acid truck driver � oil field services acidizer, oil field services ballast control operator � offshore drilling rig blender operator � oil field services blending machine operator � oil field services carbon dioxide truck operator � oil field services cement truck driver � oil field services cementer � oil field services cementer, oil field services cementing equipment operator � oil field services chemical services operator � oil field services chemical truck operator � oil field services coiled tubing operator � oil field services control room operator � offshore drilling derrick worker � oil and gas drilling derrickhand � offshore drilling derrickhand � oil and gas drilling derrickman/woman derrickman/woman � oil and gas drilling dynamic positioning operator � offshore drilling formation fracturing operator formation fracturing operator � oil field services frac driver � oil field services motorhand � offshore drilling motorhand � oil and gas drilling motorman/woman � oil and gas drilling nitrogen operator nitrogen operator � oil field services nitrogen truck operator � oil field services oil well acidizer oil well cementer, oil field services pipeline locator � oil and gas power-tong operator production tubing operator � oil field services pump operator, well treatment � oil field services pumper operator � oil field services pumpman/woman � oil field services reeled tubing operator � oil field services rig technician � derrickhand rig technician � motorhand snubbing-unit operator well treatment blender operator � oil field services well treatment pump operator � oil field services",
    "title2": 0,
    "title3": 0,
    "allTitles": "acid treater � oil field services acid truck driver � oil field services acidizer, oil field services ballast control operator � offshore drilling rig blender operator � oil field services blending machine operator � oil field services carbon dioxide truck operator � oil field services cement truck driver � oil field services cementer � oil field services cementer, oil field services cementing equipment operator � oil field services chemical services operator � oil field services chemical truck operator � oil field services coiled tubing operator � oil field services control room operator � offshore drilling derrick worker � oil and gas drilling derrickhand � offshore drilling derrickhand � oil and gas drilling derrickman/woman derrickman/woman � oil and gas drilling dynamic positioning operator � offshore drilling formation fracturing operator formation fracturing operator � oil field services frac driver � oil field services motorhand � offshore drilling motorhand � oil and gas drilling motorman/woman � oil and gas drilling nitrogen operator nitrogen operator � oil field services nitrogen truck operator � oil field services oil well acidizer oil well cementer, oil field services pipeline locator � oil and gas power-tong operator production tubing operator � oil field services pump operator, well treatment � oil field services pumper operator � oil field services pumpman/woman � oil field services reeled tubing operator � oil field services rig technician � derrickhand rig technician � motorhand snubbing-unit operator well treatment blender operator � oil field services well treatment pump operator � oil field services",
    "workers": 80,
    "minEduc": 1,
    "yearsStudy": 1.25,
    "automationRisk": 0.37,
    "salaryLow": 14.66666667,
    "salaryMed": 16.36,
    "salaryHigh": 25.48333333,
    "totalSkill": 109,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 30.89930359,
    "skillsComp": 36,
    "skillsLogi": 30,
    "skillsMath": 12,
    "skillsLang": 31,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 18,
    "s14Writing": 6,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 15,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 415,
    "noc": 8422,
    "job": "Silviculture and forestry workers",
    "title1": "brush cutter - forestry",
    "title2": "clearing saw operator - forestry",
    "title3": "collector, seed cones",
    "allTitles": "brush cutter - forestryclearing saw operator - forestrycollector, seed conescrewman, forest fire suppressioncrewman, forestrycrewman/woman, forest fire suppressioncrewman/woman, forestrycrewwoman, forest fire suppressioncrewwoman, forestrycrew worker, forestryfire crewmanfire crewman/womanfire crewwomanfirefighter, forestfire lookoutfireman, forestfire suppression crewmanfire suppression crewman/womanfire suppression crewwomanfirewoman, forestforest firefighterforest firemanforest firewomanforestry conservation workerforestry crewmanforestry crewman/womanforestry crewwomanforestry crew workerforestry workerforestry worker - logginglookout - forestryoperator, clearing saw - forestryoperator, scarification equipment - forestryoperator, scarifier - silvicultureoperator, spacing saw - forestrypicker, seed conespieceworker - silvicultureprecommercial tree thinnerscarification equipment operatorscarification equipment operator - forestryscarifier operator - silvicultureseed cone collectorseed cone pickersilviculture workerspacing saw operatorspacing saw operator - forestrythinning saw operatorthinning saw operator - forestrytree pruner - forestrytree spacer - forestry",
    "workers": 60,
    "minEduc": 1,
    "yearsStudy": 2,
    "automationRisk": 0.008,
    "salaryLow": 16,
    "salaryMed": 21.08,
    "salaryHigh": 28.45,
    "totalSkill": 124,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 21.08,
    "skillsComp": 36,
    "skillsLogi": 37,
    "skillsMath": 15,
    "skillsLang": 36,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 13,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 19,
    "s14Writing": 10,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 60,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 60,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 416,
    "noc": 8431,
    "job": "General farm workers",
    "title1": "apiary technician",
    "title2": "apiary worker",
    "title3": "artificial breeding worker",
    "allTitles": "apiary technicianapiary workerartificial breeding workerattendant, livestock yardattendant, stockyardbaler - agriculturebaling machine operator - farmbarn workerbee farm workerbeef cattle farm workerbeekeeping technicianbinder operator - agriculturecattle ranch labourercattle ranch workerchicken catcherchick sexerchore hand - agriculturecleaner, poultry yardcombine operatorcowboycowboy/cowgirlcowgirlcowhandcowpunchercrewperson, custom harvestcropsprayer machine operatorcultivator operatorcurer, tobaccocustom harvest crewpersondairy farm labourerdairy farm workerdairy handdriver, livestockegg candleregg collectoregg gathereregg graderegg grading machine tenderegg grading station laboureregg packer - farmegg picker - poultryegg processing machine tenderexaminer, fruit - agricultureexerciser, racehorsefarm equipment operatorfarm handfarm labourerfarm labourer, grainfarm machinery operatorfarm workerfarm worker, fruitfarm worker, generalfarm worker, grainfarm worker, hogsfarm worker, mushroomsfarm worker, pheasantsfarm worker, poultryfarm worker, sugar-beetsfarm worker, tobaccofarm worker, vegetablesfarrowing technicianfeedlot assistantfeedlot workerfeedyard assistantfeedyard workerfield and vegetable crop labourerfield crop and vegetable-growing workerfruit examiner - agriculturefruit farming labourerfruit farm labourerfruit farm workerfruit tree prunerfruit tree thinnerfur farming workerfur farm workerfur ranch labourergeneral farm workergrafter - orchardgrain farm labourergrain farm workergroom - farmharvester machine operatorhatchery workerhay baler operator - agricultureherder - stockyardsherd handhog farm workerhoney farm workerhop-picking machine operatorhorse breakerincubator tender - agricultureirrigation worker - agricultureirrigator - agriculturelabourer, cattle ranchlabourer, dairy farmlabourer, egg grading stationlabourer, farmlabourer, field and vegetable cropslabourer, fruit farminglabourer, fur ranch",
    "workers": 2545,
    "minEduc": 1,
    "yearsStudy": 1.956521739,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 25,
    "totalSkill": 120,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 13,
    "skillsComp": 34,
    "skillsLogi": 29,
    "skillsMath": 24,
    "skillsLang": 33,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 7,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 8,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 19,
    "s13DocumentUse": 11,
    "s14Writing": 5,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 1315,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 30,
    "f5FineArts": 30,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 525,
    "f8Education(teachertraining)": 85,
    "f9Law": 115,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 255,
    "f12Business": 155,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1075,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 30,
    "d6Fine&AppliedArts": 30,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 525,
    "d9Education(teachertraining)": 85,
    "d10Engineering": 0,
    "d11Law": 115,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 240,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 255,
    "d18Business&Commerce": 155,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 417,
    "noc": 8432,
    "job": "Nursery and greenhouse workers",
    "title1": "Christmas tree shearer",
    "title2": "Christmas tree trimmer",
    "title3": "forest assistant nursery",
    "allTitles": "Christmas tree shearerChristmas tree trimmerforest assistant nurseryforest nursery workergreenhouse workerhand sprayer - greenhousehorticulture workerhothouse workerhydroponics workerinterior plantscapernursery workerplant propagator - greenhouse or nurserysprayer, hand - greenhousetree grafter - nursery",
    "workers": 385,
    "minEduc": 1,
    "yearsStudy": 1.916666667,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 23,
    "totalSkill": 114,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 13,
    "skillsComp": 30,
    "skillsLogi": 28,
    "skillsMath": 15,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 7,
    "s10Reading": 22,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 10,
    "s14Writing": 7,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 165,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 135,
    "f8Education(teachertraining)": 0,
    "f9Law": 55,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 165,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 135,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 418,
    "noc": 8441,
    "job": "Fishing vessel deckhands",
    "title1": "checkerman/woman, fishing vessel crewman/woman, fishing vessel deckhand, fishing vessel deckhand, gillnetter deckhand, offshore trawler deckhand, seiner deckhand, shellfish harvester fishboat deckhand fishing vessel checkerman/woman fishing vessel deckhand fishing vessel rollerman/woman fishing vessel skiffman/woman gillnetter deckhand icer, fishing vessel netmender, fishing vessel offshore trawler deckhand rollerman/woman, fishing vessel shellfish harvester deckhand skiffman/woman, fishing vessel trawlerman/woman",
    "title2": 0,
    "title3": 0,
    "allTitles": "checkerman/woman, fishing vessel crewman/woman, fishing vessel deckhand, fishing vessel deckhand, gillnetter deckhand, offshore trawler deckhand, seiner deckhand, shellfish harvester fishboat deckhand fishing vessel checkerman/woman fishing vessel deckhand fishing vessel rollerman/woman fishing vessel skiffman/woman gillnetter deckhand icer, fishing vessel netmender, fishing vessel offshore trawler deckhand rollerman/woman, fishing vessel shellfish harvester deckhand skiffman/woman, fishing vessel trawlerman/woman",
    "workers": 630,
    "minEduc": 1,
    "yearsStudy": 1.674637681,
    "automationRisk": 0.4976,
    "salaryLow": 14.66666667,
    "salaryMed": 16.36,
    "salaryHigh": 25.48333333,
    "totalSkill": 115.2,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 21.77572144,
    "skillsComp": 34.4,
    "skillsLogi": 30.8,
    "skillsMath": 15.6,
    "skillsLang": 34.4,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.6,
    "s2DecisionMaking": 7.2,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5.4,
    "s6MoneyMath": 2.4,
    "s7NumericalEstimation": 4.2,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8.8,
    "s10Reading": 17.6,
    "s11SchedulingorBudgetingandAccounting": 3.6,
    "s12DigitalTechnology": 16.6,
    "s13DocumentUse": 15.2,
    "s14Writing": 6.8,
    "s15CriticalThinking": 6.8,
    "f1Science&Agriculture": 314,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 6,
    "f5FineArts": 6,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 138,
    "f8Education(teachertraining)": 17,
    "f9Law": 34,
    "f10Health": 7,
    "f11Health,Nursing&ClinicalLaboratory": 54,
    "f12Business": 34,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 248,
    "d2Forestry": 12,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 6,
    "d6Fine&AppliedArts": 6,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 138,
    "d9Education(teachertraining)": 17,
    "d10Engineering": 20,
    "d11Law": 34,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 7,
    "d14Theology": 0,
    "d15PhysicalSciences": 54,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 54,
    "d18Business&Commerce": 34,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 419,
    "noc": 8442,
    "job": "Trappers and hunters",
    "title1": "beaver trapper fur trapper game trapper hunter land-based seal hunter land-based sealer muskrat trapper seal hunter � hunting and trapping sealer sealer � hunting and trapping trapper",
    "title2": 0,
    "title3": 0,
    "allTitles": "beaver trapper fur trapper game trapper hunter land-based seal hunter land-based sealer muskrat trapper seal hunter � hunting and trapping sealer sealer � hunting and trapping trapper",
    "workers": 630,
    "minEduc": 1,
    "yearsStudy": 1.674637681,
    "automationRisk": 0.4976,
    "salaryLow": 14.66666667,
    "salaryMed": 16.36,
    "salaryHigh": 25.48333333,
    "totalSkill": 115.2,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Workers in natural resources, agriculture and related production",
    "cluster": 10,
    "wage": 21.77572144,
    "skillsComp": 34.4,
    "skillsLogi": 30.8,
    "skillsMath": 15.6,
    "skillsLang": 34.4,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.6,
    "s2DecisionMaking": 7.2,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 5.4,
    "s6MoneyMath": 2.4,
    "s7NumericalEstimation": 4.2,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8.8,
    "s10Reading": 17.6,
    "s11SchedulingorBudgetingandAccounting": 3.6,
    "s12DigitalTechnology": 16.6,
    "s13DocumentUse": 15.2,
    "s14Writing": 6.8,
    "s15CriticalThinking": 6.8,
    "f1Science&Agriculture": 314,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 6,
    "f5FineArts": 6,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 138,
    "f8Education(teachertraining)": 17,
    "f9Law": 34,
    "f10Health": 7,
    "f11Health,Nursing&ClinicalLaboratory": 54,
    "f12Business": 34,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 248,
    "d2Forestry": 12,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 6,
    "d6Fine&AppliedArts": 6,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 138,
    "d9Education(teachertraining)": 17,
    "d10Engineering": 20,
    "d11Law": 34,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 7,
    "d14Theology": 0,
    "d15PhysicalSciences": 54,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 54,
    "d18Business&Commerce": 34,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 420,
    "noc": 8612,
    "job": "Landscaping and grounds maintenance labourers",
    "title1": "applicator, chemicals - lawn care",
    "title2": "bulb planter - landscaping",
    "title3": "campground maintenance worker",
    "allTitles": "applicator, chemicals - lawn carebulb planter - landscapingcampground maintenance workercemetery labourercemetery workerchemical applicator - lawn carecutter, grassdigger, gravesgardener helpergardening helpergardening helper, landscapegolf course labourergolf course workergrass cuttergrave diggergreenskeeper helpergreens workergroundskeepergrounds maintainergrounds maintenance labourergrounds maintenance workergroundsmangroundsman/womangroundsperson - campgroundgroundswomanhelper, gardenerhelper, gardeninghelper, greenskeeperhelper, landscape gardenerhelper, landscape gardeninghelper, plant doctorhelper, tree surgeonkeeper, groundslabourer, cemeterylabourer, golf courselabourer, grounds maintenancelabourer, landscapelabourer, park maintenancelabourer, sod layinglandscape gardener helperlandscape gardening helperlandscape labourerlandscape workerlawn care labourerlawn care workerlawn mowerlawn-mowing workermaintainer, groundsmaintenance labourer, parksmaintenance worker, campgroundmaintenance worker, groundsmaintenance worker, parksmower, lawnspark maintenance labourerpark maintenance workerplant care workerplant doctor helpersnow shoveller - grounds maintenancesod layersod laying labourersprayer, treesstadium groundskeepertransplanter - landscape maintenancetree pruner - landscapingtree sprayertree surgeon helpertree trimmer - landscapingtrimmer, trees - landscapingworker, cemeteryworker, golf courseworker, greensworker, grounds maintenanceworker, landscapeworker, lawn mowingworker, plant care",
    "workers": 9410,
    "minEduc": 1,
    "yearsStudy": 2.362745098,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 27,
    "totalSkill": 95,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Harvesting, landscaping and natural resources labourers",
    "cluster": 10,
    "wage": 15,
    "skillsComp": 31,
    "skillsLogi": 25,
    "skillsMath": 10,
    "skillsLang": 29,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 0,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 3,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 14,
    "s14Writing": 7,
    "s15CriticalThinking": 8,
    "f1Science&Agriculture": 3005,
    "f2Engineering": 530,
    "f3Humanities": 175,
    "f4SocialScience": 585,
    "f5FineArts": 460,
    "f6MathAndComputerScience": 55,
    "f7Arts&Education": 1830,
    "f8Education(teachertraining)": 165,
    "f9Law": 570,
    "f10Health": 450,
    "f11Health,Nursing&ClinicalLaboratory": 160,
    "f12Business": 1425,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 2010,
    "d2Forestry": 225,
    "d3Architecture&LandscapeArchitecture": 120,
    "d4Humanities": 140,
    "d5SocialSciences": 585,
    "d6Fine&AppliedArts": 460,
    "d7ComputerScience": 55,
    "d8OtherArts&Science": 1830,
    "d9Education(teachertraining)": 165,
    "d10Engineering": 410,
    "d11Law": 570,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 450,
    "d14Theology": 35,
    "d15PhysicalSciences": 770,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 160,
    "d18Business&Commerce": 1425,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 421,
    "noc": 8613,
    "job": "Aquaculture and marine harvest labourers",
    "title1": "aquaculture support worker aquaculture worker attendant, lobster pound clam digger dulse gatherer fish farm helper fish farm worker fish hatchery attendant fish hatchery tagger fish hatchery worker � aquaculture fish tagger fry marker fry marker � fishing fry tagger hatchery helper hatchery worker � aquaculture Irish moss gatherer lobster pound attendant marine plant gatherer mussel farm labourer mussel harvester oyster harvester oyster picker oyster picker-shucker quahog digger sea farm attendant sea farm worker seaweed gatherer shellfish bed attendant shellfish harvester",
    "title2": 0,
    "title3": 0,
    "allTitles": "aquaculture support worker aquaculture worker attendant, lobster pound clam digger dulse gatherer fish farm helper fish farm worker fish hatchery attendant fish hatchery tagger fish hatchery worker � aquaculture fish tagger fry marker fry marker � fishing fry tagger hatchery helper hatchery worker � aquaculture Irish moss gatherer lobster pound attendant marine plant gatherer mussel farm labourer mussel harvester oyster harvester oyster picker oyster picker-shucker quahog digger sea farm attendant sea farm worker seaweed gatherer shellfish bed attendant shellfish harvester",
    "workers": 4710,
    "minEduc": 1,
    "yearsStudy": 1.681372549,
    "automationRisk": 0.91,
    "salaryLow": 15,
    "salaryMed": 20.095,
    "salaryHigh": 27.425,
    "totalSkill": 95,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Harvesting, landscaping and natural resources labourers",
    "cluster": 10,
    "wage": 19.19,
    "skillsComp": 33,
    "skillsLogi": 25,
    "skillsMath": 8,
    "skillsLang": 29,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 1.5,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 4,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 15,
    "s14Writing": 7,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 1502.5,
    "f2Engineering": 265,
    "f3Humanities": 87.5,
    "f4SocialScience": 292.5,
    "f5FineArts": 230,
    "f6MathAndComputerScience": 27.5,
    "f7Arts&Education": 920,
    "f8Education(teachertraining)": 82.5,
    "f9Law": 285,
    "f10Health": 225,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 712.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1005,
    "d2Forestry": 112.5,
    "d3Architecture&LandscapeArchitecture": 60,
    "d4Humanities": 70,
    "d5SocialSciences": 292.5,
    "d6Fine&AppliedArts": 230,
    "d7ComputerScience": 27.5,
    "d8OtherArts&Science": 920,
    "d9Education(teachertraining)": 82.5,
    "d10Engineering": 205,
    "d11Law": 285,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 225,
    "d14Theology": 17.5,
    "d15PhysicalSciences": 385,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 712.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 422,
    "noc": 8614,
    "job": "Mine labourers",
    "title1": "check weigher, mine chute puller coal sampler core splitter grizzly worker � underground mining helper, miner � underground mining helper, pipeworker � underground mining helper, timber and steel prop setter labourer, mine limestone spreader � underground mining mine check weigher mine helper mine helper � underground mining mine labourer miner helper � underground mining pipeworker helper � underground mining pit scaler � underground mining pit-scaler helper powder carrier � underground mining rock duster � underground mining salvager, timber and steel props sample processor setter helper, timber and steel prop shoveller � underground mining slate picker stone duster � underground mining timber and steel prop salvager timber and steel prop setter helper timbering and steel prop setting helper timberman/woman helper � underground mining underground helper � mining underground labourer � mining underground mine labourer",
    "title2": 0,
    "title3": 0,
    "allTitles": "check weigher, mine chute puller coal sampler core splitter grizzly worker � underground mining helper, miner � underground mining helper, pipeworker � underground mining helper, timber and steel prop setter labourer, mine limestone spreader � underground mining mine check weigher mine helper mine helper � underground mining mine labourer miner helper � underground mining pipeworker helper � underground mining pit scaler � underground mining pit-scaler helper powder carrier � underground mining rock duster � underground mining salvager, timber and steel props sample processor setter helper, timber and steel prop shoveller � underground mining slate picker stone duster � underground mining timber and steel prop salvager timber and steel prop setter helper timbering and steel prop setting helper timberman/woman helper � underground mining underground helper � mining underground labourer � mining underground mine labourer",
    "workers": 4710,
    "minEduc": 1,
    "yearsStudy": 1.681372549,
    "automationRisk": 0.91,
    "salaryLow": 15,
    "salaryMed": 20.095,
    "salaryHigh": 27.425,
    "totalSkill": 95,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Harvesting, landscaping and natural resources labourers",
    "cluster": 10,
    "wage": 19.19,
    "skillsComp": 33,
    "skillsLogi": 25,
    "skillsMath": 8,
    "skillsLang": 29,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 1.5,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 4,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 15,
    "s14Writing": 7,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 1502.5,
    "f2Engineering": 265,
    "f3Humanities": 87.5,
    "f4SocialScience": 292.5,
    "f5FineArts": 230,
    "f6MathAndComputerScience": 27.5,
    "f7Arts&Education": 920,
    "f8Education(teachertraining)": 82.5,
    "f9Law": 285,
    "f10Health": 225,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 712.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1005,
    "d2Forestry": 112.5,
    "d3Architecture&LandscapeArchitecture": 60,
    "d4Humanities": 70,
    "d5SocialSciences": 292.5,
    "d6Fine&AppliedArts": 230,
    "d7ComputerScience": 27.5,
    "d8OtherArts&Science": 920,
    "d9Education(teachertraining)": 82.5,
    "d10Engineering": 205,
    "d11Law": 285,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 225,
    "d14Theology": 17.5,
    "d15PhysicalSciences": 385,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 712.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 423,
    "noc": 8615,
    "job": "Oil and gas drilling, servicing and related labourers",
    "title1": "cementer helper, oil well floorhand floorhand � offshore drilling rig floorhand � oil and gas drilling floorhand � service rig floorman/woman � offshore drilling rig floorman/woman � oil and gas drilling gravity prospecting observer helper helper, oil well cementer helper, perforator loader � oil field services helper, service rig � oil field services helper, tubing � oil field services helper, well puller � oil field services helper, well treatment � oil field services helper, wireline helper, wireline � oil field services labourer, oil field leasehand leasehand � oil and gas drilling observer helper � gravity prospecting observer helper � seismic prospecting oil well cementer helper operator helper, service rig operator, vibrator � seismic prospecting perforator helper � oil field services reeled tubing helper � oil field services roughneck roughneck � offshore drilling rig roughneck � oil and gas drilling roughneck, service rig � oil field services roustabout roustabout � offshore drilling rig roustabout � oil and gas drilling seismic GPS rover seismic line cutter seismic prospecting observer helper service rig helper service rig helper � oil field services service rig roughneck � oil field services shakerhand shakerhand � oil and gas drilling shooter � seismograph shooter helper � seismic prospecting slasher � oil and gas slasher � oil field services swamper � oil and gas swamper � oil field services tubing helper � oil field services vibrator operator � seismic prospecting well puller helper � oil field services well treatment helper well treatment helper � oil field services wireline helper � oil field services",
    "title2": 0,
    "title3": 0,
    "allTitles": "cementer helper, oil well floorhand floorhand � offshore drilling rig floorhand � oil and gas drilling floorhand � service rig floorman/woman � offshore drilling rig floorman/woman � oil and gas drilling gravity prospecting observer helper helper, oil well cementer helper, perforator loader � oil field services helper, service rig � oil field services helper, tubing � oil field services helper, well puller � oil field services helper, well treatment � oil field services helper, wireline helper, wireline � oil field services labourer, oil field leasehand leasehand � oil and gas drilling observer helper � gravity prospecting observer helper � seismic prospecting oil well cementer helper operator helper, service rig operator, vibrator � seismic prospecting perforator helper � oil field services reeled tubing helper � oil field services roughneck roughneck � offshore drilling rig roughneck � oil and gas drilling roughneck, service rig � oil field services roustabout roustabout � offshore drilling rig roustabout � oil and gas drilling seismic GPS rover seismic line cutter seismic prospecting observer helper service rig helper service rig helper � oil field services service rig roughneck � oil field services shakerhand shakerhand � oil and gas drilling shooter � seismograph shooter helper � seismic prospecting slasher � oil and gas slasher � oil field services swamper � oil and gas swamper � oil field services tubing helper � oil field services vibrator operator � seismic prospecting well puller helper � oil field services well treatment helper well treatment helper � oil field services wireline helper � oil field services",
    "workers": 4710,
    "minEduc": 1,
    "yearsStudy": 1.681372549,
    "automationRisk": 0.91,
    "salaryLow": 18,
    "salaryMed": 28,
    "salaryHigh": 31.7,
    "totalSkill": 95,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Harvesting, landscaping and natural resources labourers",
    "cluster": 10,
    "wage": 19.19,
    "skillsComp": 33,
    "skillsLogi": 25,
    "skillsMath": 8,
    "skillsLang": 29,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 1.5,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 4,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 1,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 15,
    "s14Writing": 7,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 1502.5,
    "f2Engineering": 265,
    "f3Humanities": 87.5,
    "f4SocialScience": 292.5,
    "f5FineArts": 230,
    "f6MathAndComputerScience": 27.5,
    "f7Arts&Education": 920,
    "f8Education(teachertraining)": 82.5,
    "f9Law": 285,
    "f10Health": 225,
    "f11Health,Nursing&ClinicalLaboratory": 80,
    "f12Business": 712.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 1005,
    "d2Forestry": 112.5,
    "d3Architecture&LandscapeArchitecture": 60,
    "d4Humanities": 70,
    "d5SocialSciences": 292.5,
    "d6Fine&AppliedArts": 230,
    "d7ComputerScience": 27.5,
    "d8OtherArts&Science": 920,
    "d9Education(teachertraining)": 82.5,
    "d10Engineering": 205,
    "d11Law": 285,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 225,
    "d14Theology": 17.5,
    "d15PhysicalSciences": 385,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 80,
    "d18Business&Commerce": 712.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 424,
    "noc": 8616,
    "job": "Logging and forestry labourers",
    "title1": "boom man",
    "title2": "boom man/woman",
    "title3": "boom woman",
    "allTitles": "boom manboom man/womanboom womanboom workerboom worker - loggingboom worker - mill pondcable hooker - loggingchokermanchokerman - loggingchokerman/womanchokerman/woman - loggingchokerwomanchokerwoman - loggingchoke setter - loggingforestry labourerlabourer, forestrylabourer, logginglabourer, logging and forestrylog driverlogging and forestry labourerlogging labourerlog riderpiler, pulpwoodpondmanpondman/womanpondwomanpulpwood pilerriver driverseasonal swamper - logging forestryseasonal tree plantersprayer - logging and forestryswamper - logging and forestryswamper, seasonal - loggingswamper, seasonal - logging and forestrytree planter, seasonal",
    "workers": 10,
    "minEduc": 1,
    "yearsStudy": 1,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 23.38,
    "salaryHigh": 35,
    "totalSkill": 95,
    "industry": "Natural resources, agriculture, production",
    "industryNum": 0,
    "sector": "Harvesting, landscaping and natural resources labourers",
    "cluster": 10,
    "wage": 23.38,
    "skillsComp": 35,
    "skillsLogi": 25,
    "skillsMath": 6,
    "skillsLang": 29,
    "topSkill1": "Digital Technology",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 8,
    "s9ProblemSolving": 5,
    "s10Reading": 14,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 17,
    "s13DocumentUse": 16,
    "s14Writing": 7,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 10,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 10,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 425,
    "noc": 9211,
    "job": "Supervisors, mineral and metal processing",
    "title1": "alumina plant foreman",
    "title2": "alumina plant foreman/woman",
    "title3": "alumina plant forewoman",
    "allTitles": "alumina plant foremanalumina plant foreman/womanalumina plant forewomanannealing foremanannealing foreman - primary metal processingannealing foreman/womanannealing foreman/woman - primary metal processingannealing forewomanannealing forewoman - primary metal processinganodizing foreman - primary metal processinganodizing foreman/woman - primary metal processinganodizing forewoman - primary metal processingasbestos manufacturing foremanasbestos manufacturing foreman/womanasbestos manufacturing forewomanball mill foreman - mineral products processingball mill foreman/woman - mineral products processingball mill forewoman - mineral products processingblast furnace foremanblast furnace foreman/womanblast furnace forewomanbrick and tile foremanbrick and tile foreman/womanbrick and tile forewomancasting operations foremancasting operations foreman/womancasting operations forewomancasting room foremancasting room foreman/womancasting room forewomancement manufacturing supervisorcement processing foremancement processing foreman/womancement processing forewomancement processing supervisorclay, glass and stone furnace and kiln operations foremanclay, glass and stone furnace and kiln operations foreman/womanclay, glass and stone furnace and kiln operations forewomanclay, glass and stone furnace and kiln operators supervisorclay preparation foremanclay preparation foreman/womanclay preparation forewomanclay products manufacturing foremanclay products manufacturing foreman/womanclay products manufacturing forewomanclay shop foremanclay shop foreman/womanclay shop forewomancoal-and-coke crushing and grinding foremancoal-and-coke crushing and grinding foreman/womancoal-and-coke crushing and grinding forewomancoke ovens foremancoke ovens foreman/womancoke ovens forewomancoke screening foremancoke screening foreman - mineral and metal processingcoke screening foreman/womancoke screening foreman/woman - mineral and metal processingcoke screening forewomancoke screening forewoman - mineral and metal processingconcentrator foreman - primary metal and mineral products processingconcentrator foreman/woman - primary metal and mineral products processingconcentrator forewoman - primary metal and mineral products processingconcrete products foremanconcrete products foreman/womanconcrete products forewomanconverter foreman - primary metal and mineral products processingconverter foreman/woman - primary metal and mineral products processingconverter forewoman - primary metal and mineral products processingcoremaking foremancoremaking foreman - foundrycoremaking foreman - mineral processingcoremaking foreman/womancoremaking foreman/woman - foundrycoremaking foreman/woman - mineral processingcoremaking forewomancoremaking forewoman - foundrycoremaking forewoman - mineral processingcrushing and grinding operations foreman - primary metal and mineral products processingcrushing and grinding operations foreman/woman - primary metal and mineral products processingcrushing and grinding operations forewoman - primary metal and mineral products processingcrushing and grinding supervisor - primary metal and mineral productsdie casting foreman - foundrydie casting foreman/woman - foundrydie casting forewoman - foundrydie casting supervisorelectrolytic cell operations foreman - primary metal and mineral products processingelectrolytic cell operations foreman/woman - primary metal and mineral products processingelectrolytic cell operations forewoman - primary metal and mineral products processingextruding foreman - primary metal and mineral products processingextruding foreman - primary metal processingextruding foreman/woman - primary metal and mineral products processingextruding foreman/woman - primary metal processingextruding forewoman - primary metal and mineral products processingextruding forewoman - primary metal processingfilter plant foreman - primary metal and mineral products processingfilter plant foreman/woman - primary metal and mineral products processingfilter plant forewoman - primary metal and mineral products processingforeman, annealingforeman, annealing - primary metal processing",
    "workers": 240,
    "minEduc": 2,
    "yearsStudy": 1.2,
    "automationRisk": 0.016,
    "salaryLow": 16.48,
    "salaryMed": 26.5,
    "salaryHigh": 52.66,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 26.5,
    "skillsComp": 37,
    "skillsLogi": 33,
    "skillsMath": 13,
    "skillsLang": 34,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 1,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 6,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 9,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 7,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 55,
    "f2Engineering": 35,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 150,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 150,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 35,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 55,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 426,
    "noc": 9212,
    "job": "Supervisors, petroleum, gas and chemical processing and utilities",
    "title1": "by-products extraction foreman - chemical processing",
    "title2": "by-products extraction foreman/woman - chemical processing",
    "title3": "by-products extraction forewoman - chemical processing",
    "allTitles": "by-products extraction foreman - chemical processingby-products extraction foreman/woman - chemical processingby-products extraction forewoman - chemical processingchemical processing plant foremanchemical processing plant foreman/womanchemical processing plant forewomanchemical processing supervisorchemical unit foremanchemical unit foreman/womanchemical unit forewomanchief operator, hydro-electric stationchief operator, water treatmentchief stationary engineerchief substation operatorchlorine plant foremanchlorine plant foreman/womanchlorine plant forewomancompost facility supervisorcompressor station foremancompressor station foreman/womancompressor station forewomancontinuous process foreman - chemical processingcontinuous process foreman/woman - chemical processingcontinuous process forewoman - chemical processingdistillation foreman - chemical processingdistillation foreman/woman - chemical processingdistillation forewoman - chemical processingevaporator foreman - chemical processingevaporator foreman/woman - chemical processingevaporator forewoman - chemical processingforeman, chemicalforeman, chemical processing plantforeman, coating and calendering workers - chemical processingforeman, cosmetics processingforeman, crushing and grinding workers - chemicals and related materialsforeman, detergents and removers manufacturingforeman, evaporator - chemical processingforeman, gas distributionforeman, gas plantforeman, grinding and packing - chemical processingforeman, heating plantforeman, incineratorforeman, ink preparation - chemical processingforeman, natural gas plantforeman, oven - chemical processingforeman - petroleum, gas and chemical processingforeman, petroleum processingforeman, pharmaceuticals compoundingforeman, pilot plantforeman, pipeline operationsforeman, power engineersforeman, power plantforeman, power station operatorsforeman, pumping and blending - chemical processingforeman, pumping and pipeline equipment operatorsforeman, refinery unitforeman, sanitary serviceforeman, sewage disposalforeman, sewer servicesforeman, steam plantforeman, viscose filtration - chemical processingforeman, water and sanitation-utilities equipment operating occupationsforeman, water purification plantforeman, water treatment plantforeman/woman, chemicalforeman/woman, chemical processing plantforeman/woman, coating and calendering workers - chemical processingforeman/woman, cosmetics processingforeman/woman, crushing and grinding workers - chemicals and related materialsforeman/woman, detergents and removers manufacturingforeman/woman, evaporator - chemical processingforeman/woman, gas distributionforeman/woman, gas plantforeman/woman, grinding and packing - chemical processingforeman/woman, heating plantforeman/woman, incineratorforeman/woman, ink preparation - chemical processingforeman/woman, natural gas plantforeman/woman, oven - chemical processingforeman/woman - petroleum, gas and chemical processingforeman/woman, petroleum processingforeman/woman, pharmaceuticals compoundingforeman/woman, pilot plantforeman/woman, pipeline operationsforeman/woman, power engineersforeman/woman, power plantforeman/woman, power station operatorsforeman/woman, pumping and blending - chemical processingforeman/woman, pumping and pipeline equipment operatorsforeman/woman, refinery unitforeman/woman, sanitary serviceforeman/woman, sewage disposalforeman/woman, sewer servicesforeman/woman, steam plantforeman/woman, viscose filtration - chemical processingforeman/woman, water and sanitation-utilities equipment operating occupationsforeman/woman, water purification plantforeman/woman, water treatment plantforewoman, chemicalforewoman, chemical processing plant",
    "workers": 1235,
    "minEduc": 2,
    "yearsStudy": 1.914285714,
    "automationRisk": 0.016,
    "salaryLow": 14.5,
    "salaryMed": 25,
    "salaryHigh": 54,
    "totalSkill": 153,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 25,
    "skillsComp": 38,
    "skillsLogi": 38,
    "skillsMath": 27,
    "skillsLang": 50,
    "topSkill1": "Reading",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 10,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 15,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 15,
    "s14Writing": 14,
    "s15CriticalThinking": 12,
    "f1Science&Agriculture": 270,
    "f2Engineering": 435,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 435,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 75,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 435,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 435,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 270,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 75,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 427,
    "noc": 9213,
    "job": "Supervisors, food and beverage processing",
    "title1": "abattoir supervisor",
    "title2": "bakery foreman - food and beverage processing",
    "title3": "bakery foreman/woman - food and beverage processing",
    "allTitles": "abattoir supervisorbakery foreman - food and beverage processingbakery foreman/woman - food and beverage processingbakery forewoman - food and beverage processingbakery plant supervisorbaking and confectionery making foremanbaking and confectionery making foreman/womanbaking and confectionery making forewomanbaking foreman - food and beverage processingbaking foreman/woman - food and beverage processingbaking forewoman - food and beverage processingbeef dressing foremanbeef dressing foreman/womanbeef dressing forewomanbottling foremanbottling foreman/womanbottling forewomanbottling supervisor - food and beverage processingbrewer supervisorbrewery supervisorcannery foreman - food processingcannery foreman/woman - food processingcannery forewoman - food processingcellar masterchocolate factory foremanchocolate factory foreman/womanchocolate factory forewomanchocolate refining foremanchocolate refining foreman/womanchocolate refining forewomancoffee roasting foremancoffee roasting foreman/womancoffee roasting forewomanconfectionery foremanconfectionery foreman/womanconfectionery forewomancuring room foreman - tobacco processingcuring room foreman/woman - tobacco processingcuring room forewoman - tobacco processingdairy plant foremandairy plant foreman/womandairy plant forewomandairy products processing foremandairy products processing foreman/womandairy products processing forewomandistillery foremandistillery foreman/womandistillery forewomandry-starch foreman - food processingdry-starch foreman/woman - food processingdry-starch forewoman - food processingfeed milling foremanfeed milling foreman/womanfeed milling forewomanfish canning, curing and packing workers foremanfish canning, curing and packing workers foreman/womanfish canning, curing and packing workers forewomanfish curing and canning foremanfish curing and canning foreman/womanfish curing and canning forewomanfish-freezing and storage foremanfish-freezing and storage foreman/womanfish-freezing and storage forewomanfish freezing foremanfish freezing foreman/womanfish freezing forewomanfish freezing supervisorfish preparation foremanfish preparation foreman/womanfish preparation forewomanfish processing supervisorfish reduction foremanfish reduction foreman/womanfish reduction forewomanflour-and-grain mill foremanflour-and-grain mill foreman/womanflour-and-grain mill forewomanflour mill foremanflour mill foreman/womanflour mill forewomanfood and beverage processing foremanfood and beverage processing foreman/womanfood and beverage processing forewomanfood and beverage processing supervisorfood product testers supervisorfood testing foreman - food and beverage processingfood testing foreman/woman - food and beverage processingfood testing forewoman - food and beverage processingfood testing supervisorforeman, abattoirforeman, bakery - food and beverage processingforeman, baking and confectionery makingforeman, baking - food and beverage processingforeman, beef boning and cuttingforeman, beef dressingforeman, boiling house - food and beverage processingforeman, bottling - food and beverage processingforeman, cannery - food processingforeman, char house - food and beverage processingforeman, chocolate candies processing",
    "workers": 1115,
    "minEduc": 1,
    "yearsStudy": 2.497807018,
    "automationRisk": 0.378,
    "salaryLow": 14,
    "salaryMed": 22.5,
    "salaryHigh": 33.65,
    "totalSkill": 145.5,
    "industry": "Art, culture, recreation, sport",
    "industryNum": 2,
    "sector": "Technical occupations in art, culture, recreation and sport",
    "cluster": 2,
    "wage": 22.82526371,
    "skillsComp": 35,
    "skillsLogi": 37,
    "skillsMath": 16.5,
    "skillsLang": 56.5,
    "topSkill1": "Oral Communication",
    "topSkill2": "Reading",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 22.5,
    "s9ProblemSolving": 12.5,
    "s10Reading": 21.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 20,
    "s14Writing": 12.5,
    "s15CriticalThinking": 3,
    "f1Science&Agriculture": 65,
    "f2Engineering": 50,
    "f3Humanities": 0,
    "f4SocialScience": 15,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 70,
    "f8Education(teachertraining)": 0,
    "f9Law": 35,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 275,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 15,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 70,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 35,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 275,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 428,
    "noc": 9214,
    "job": "Supervisors, plastic and rubber products manufacturing",
    "title1": "assemblers foreman - rubber and plastic manufacturing",
    "title2": "assemblers foreman/woman - rubber and plastic manufacturing",
    "title3": "assemblers forewoman - rubber and plastic manufacturing",
    "allTitles": "assemblers foreman - rubber and plastic manufacturingassemblers foreman/woman - rubber and plastic manufacturingassemblers forewoman - rubber and plastic manufacturingassemblers supervisor - rubber and plastic products manufacturingautomobile tire builders foremanautomobile tire builders foreman/womanautomobile tire builders forewomanbelt building foreman - rubber and plastic manufacturingbelt building foreman/woman - rubber and plastic manufacturingbelt building forewoman - rubber and plastic manufacturingblow moulding foreman - rubber and plastic manufacturingblow moulding foreman/woman - rubber and plastic manufacturingblow moulding forewoman - rubber and plastic manufacturingcalendering foreman - rubber and plastic manufacturingcalendering foreman/woman - rubber and plastic manufacturingcalendering forewoman - rubber and plastic manufacturingcompounding foreman - rubber and plastic manufacturingcompounding foreman/woman - rubber and plastic manufacturingcompounding forewoman - rubber and plastic manufacturingcompression moulding foreman - rubber and products manufacturingcompression moulding foreman/woman - rubber and products manufacturingcompression moulding forewoman - rubber and products manufacturingconveyor belt foreman - rubber manufacturingconveyor belt foreman/woman - rubber manufacturingconveyor belt forewoman - rubber manufacturingcuring foreman - rubber manufacturingcuring foreman/woman - rubber manufacturingcuring forewoman - rubber manufacturingcuring supervisor - rubber products manufacturingextruding supervisor - rubber and plastic products manufacturingextrusion foreman - rubber and plastic manufacturingextrusion foreman/woman - rubber and plastic manufacturingextrusion forewoman - rubber and plastic manufacturingextrusion supervisor - rubber and plastic products manufacturingfibreglass plastics foremanfibreglass plastics foreman/womanfibreglass plastics forewomanfibreglass plastics processing supervisorfinishing and trimming foreman - rubber and plastic manufacturingfinishing and trimming foreman/woman - rubber and plastic manufacturingfinishing and trimming forewoman - rubber and plastic manufacturingfinishing and trimming supervisor - rubber and plastic products manufacturingfinishing supervisor - plastic products manufacturingfinishing supervisor - rubber products manufacturingfoam products inspection foreman - rubber manufacturingfoam products inspection foreman/woman - rubber manufacturingfoam products inspection forewoman - rubber manufacturingfoam products inspection supervisor - rubber products manufacturingfootwear inspection foreman - rubber manufacturingfootwear inspection foreman/woman - rubber manufacturingfootwear inspection forewoman - rubber manufacturingfootwear inspection supervisor - rubber products manufacturingforeman, assemblers - rubber and plastic manufacturingforeman, belt building - rubber manufacturingforeman, blow mouldingforeman, blow moulding - rubber and plastic manufacturingforeman, calendering - rubber and plastic manufacturingforeman, conveyor belt building - rubber manufacturingforeman, curing - rubber manufacturingforeman, extruding - rubber and plastic manufacturingforeman, extrusion - rubber and plastic manufacturingforeman, fibreglass plasticsforeman, finishing and trimming - rubber and plastic manufacturingforeman, finishing - plastic manufacturingforeman, finishing - rubber manufacturingforeman, foam products inspection - rubber manufacturingforeman, footwear inspection - rubber manufacturingforeman, injection moulding - rubber and plastic manufacturingforeman, matting inspection - rubber manufacturingforeman, mixing - rubber and plastic manufacturingforeman, moulded rubber footwearforeman, moulding - rubber and plastic manufacturingforeman, paint department - plastic productsforeman, paint department - rubber productsforeman, plastic inspectorsforeman, plastic products manufacturingforeman, plastics-processing shopforeman, retread tire inspectionforeman, roll building - rubber manufacturingforeman, rubber goods dippingforeman, rubber hose buildingforeman, rubber hose inspection and testingforeman, rubber products inspectorsforeman, rubber products manufacturingforeman, snowtrack - rubber manufacturingforeman, stock preparation - rubber manufacturingforeman, tire buildingforeman, tire finishingforeman, tire inspectionforeman, tire retreadforeman, tire stock preparationforeman, vulcanizing - rubber manufacturingforeman/woman, assemblers - rubber and plastic manufacturingforeman/woman, belt building - rubber manufacturingforeman/woman, blow mouldingforeman/woman, blow moulding - rubber and plastic manufacturingforeman/woman, calendering - rubber and plastic manufacturingforeman/woman, conveyor belt building - rubber manufacturingforeman/woman, curing - rubber manufacturingforeman/woman, extruding - rubber and plastic manufacturing",
    "workers": 73055,
    "minEduc": 1.5,
    "yearsStudy": 3.825418995,
    "automationRisk": 0.478,
    "salaryLow": 14,
    "salaryMed": 22.56,
    "salaryHigh": 30,
    "totalSkill": 165.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 29.28,
    "skillsComp": 42.5,
    "skillsLogi": 37.5,
    "skillsMath": 28,
    "skillsLang": 58,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 5.5,
    "s5MeasurementandCalculation": 3.5,
    "s6MoneyMath": 4.5,
    "s7NumericalEstimation": 4.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 7.5,
    "s10Reading": 25.5,
    "s11SchedulingorBudgetingandAccounting": 15.5,
    "s12DigitalTechnology": 19.5,
    "s13DocumentUse": 16.5,
    "s14Writing": 17,
    "s15CriticalThinking": 10,
    "f1Science&Agriculture": 20,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 20,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 429,
    "noc": 9215,
    "job": "Supervisors, forest products processing",
    "title1": "beater room foreman - pulp and paper",
    "title2": "beater room foreman/woman - pulp and paper",
    "title3": "beater room forewoman - pulp and paper",
    "allTitles": "beater room foreman - pulp and paperbeater room foreman/woman - pulp and paperbeater room forewoman - pulp and paperbleach plant foreman - pulp and paperbleach plant foreman/woman - pulp and paperbleach plant forewoman - pulp and paperbox making foreman - paper convertingbox making foreman/woman - paper convertingbox making forewoman - paper convertingcoating room foreman - pulp and papercoating room foreman/woman - pulp and papercoating room forewoman - pulp and papercoremaking foreman - paper convertingcoremaking foreman/woman - paper convertingcoremaking forewoman - paper convertingcore room foreman - pulp and papercore room foreman/woman - pulp and papercore room forewoman - pulp and paperforeman, beater room - pulp and paperforeman, bleach plant - pulp and paperforeman, box making - paper convertingforeman, coating room - pulp and paperforeman, coremaking - paper convertingforeman, core room - pulp and paperforeman, lumber gradingforeman, lumber grading - wood processingforeman, paper inspectors - pulp and paperforeman, paper machine - pulp and paperforeman, papermaking and finishingforeman, paper millforeman, paper mill workersforeman, paper product fabricating and assemblingforeman, paper - pulp and paperforeman, particleboard makingforeman, plywood inspection - wood processingforeman, plywood makingforeman, pulp and paper millforeman, pulp millforeman, pulp processing - pulp and paperforeman, sawmillforeman, screen room - pulp and paperforeman, shingle millforeman, shingle mill - wood processingforeman, tour - pulp and paperforeman, treating plant - wood processingforeman, veneer inspection - wood processingforeman, veneer - wood processingforeman, waferboardforeman, waferboard making - wood processingforeman, winding room - pulp and paperforeman/woman, beater room - pulp and paperforeman/woman, bleach plant - pulp and paperforeman/woman, box making - paper convertingforeman/woman, coating room - pulp and paperforeman/woman, coremaking - paper convertingforeman/woman, core room - pulp and paperforeman/woman, lumber gradingforeman/woman, lumber grading - wood processingforeman/woman, paper inspectors - pulp and paperforeman/woman, paper machine - pulp and paperforeman/woman, papermaking and finishingforeman/woman, paper millforeman/woman, paper mill workersforeman/woman, paper product fabricating and assemblingforeman/woman, paper - pulp and paperforeman/woman, particleboard makingforeman/woman, plywood inspection - wood processingforeman/woman, plywood makingforeman/woman, pulp and paper millforeman/woman, pulp millforeman/woman, pulp processing - pulp and paperforeman/woman, sawmillforeman/woman, screen room - pulp and paperforeman/woman, shingle millforeman/woman, shingle mill - wood processingforeman/woman, tour - pulp and paperforeman/woman, treating plant - wood processingforeman/woman, veneer inspection - wood processingforeman/woman, veneer - wood processingforeman/woman, waferboardforeman/woman, waferboard making - wood processingforeman/woman, winding room - pulp and paperforeman/woman, wood treating plantforeman/woman, yard - pulp and paperforeman, wood treating plantforeman, yard - pulp and paperforest products processing supervisorforewoman, beater room - pulp and paperforewoman, bleach plant - pulp and paperforewoman, box making - paper convertingforewoman, coating room - pulp and paperforewoman, coremaking - paper convertingforewoman, core room - pulp and paperforewoman, lumber gradingforewoman, lumber grading - wood processingforewoman, paper inspectors - pulp and paperforewoman, paper machine - pulp and paperforewoman, papermaking and finishingforewoman, paper millforewoman, paper mill workers",
    "workers": 25,
    "minEduc": 2,
    "yearsStudy": 2,
    "automationRisk": 0.016,
    "salaryLow": 19.8,
    "salaryMed": 25,
    "salaryHigh": 38.46,
    "totalSkill": 136,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 25,
    "skillsComp": 33,
    "skillsLogi": 35,
    "skillsMath": 24,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 13,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 15,
    "s14Writing": 11,
    "s15CriticalThinking": 11,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 430,
    "noc": 9217,
    "job": "Supervisors, textile, fabric, fur and leather products processing and manufacturing",
    "title1": 0,
    "title2": 0,
    "title3": 0,
    "allTitles": 0,
    "workers": 15134,
    "minEduc": 1.7,
    "yearsStudy": 2.287502345,
    "automationRisk": 0.1808,
    "salaryLow": 14,
    "salaryMed": 19.04,
    "salaryHigh": 34.44,
    "totalSkill": 143.4,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "#DIV/0!",
    "cluster": 7,
    "wage": 25.72105274,
    "skillsComp": 37.1,
    "skillsLogi": 36.1,
    "skillsMath": 21.7,
    "skillsLang": 48.5,
    "topSkill1": "#DIV/0!",
    "topSkill2": "#DIV/0!",
    "topSkill3": "#DIV/0!",
    "s1DataAnalysis": 5.7,
    "s2DecisionMaking": 8.8,
    "s3FindingInformation": 5.1,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 4.5,
    "s6MoneyMath": 2.3,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 14.9,
    "s9ProblemSolving": 9.2,
    "s10Reading": 21.2,
    "s11SchedulingorBudgetingandAccounting": 11.4,
    "s12DigitalTechnology": 14.5,
    "s13DocumentUse": 16.9,
    "s14Writing": 12.3,
    "s15CriticalThinking": 9.4,
    "f1Science&Agriculture": 82,
    "f2Engineering": 104,
    "f3Humanities": 0,
    "f4SocialScience": 3,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 4,
    "f7Arts&Education": 131,
    "f8Education(teachertraining)": 0,
    "f9Law": 7,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 75,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 3,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 4,
    "d8OtherArts&Science": 131,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 104,
    "d11Law": 7,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 82,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 75,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 431,
    "noc": 9221,
    "job": "Supervisors, motor vehicle assembling",
    "title1": "area co-ordinator - motor vehicle assembly",
    "title2": "area co-ordinator - motor vehicle manufacturing",
    "title3": "assembly co-ordinator - motor vehicle manufacturing",
    "allTitles": "area co-ordinator - motor vehicle assemblyarea co-ordinator - motor vehicle manufacturingassembly co-ordinator - motor vehicle manufacturingassembly co-ordinator, motor vehiclesassembly foreman, automobilesassembly foreman - motor vehicle manufacturingassembly foreman, motor vehiclesassembly foreman/woman - motor vehicle manufacturingassembly foreman/woman, motor vehiclesassembly forewoman - motor vehicle manufacturingassembly forewoman, motor vehiclesassembly supervisor - motor vehicle manufacturingassembly supervisor, motor vehiclesassembly zone supervisor - motor vehicle manufacturingautomobile assembly foremanautomobile assembly foreman/womanautomobile assembly forewomanbody shop supervisor - motor vehicle manufacturingchassis assembly supervisor - motor vehicle manufacturingco-ordinator, assembly - motor vehicle manufacturingengine dress supervisor - motor vehicle manufacturingfinal-assembly supervisor - motor vehicle manufacturingforeman, assembly - motor vehicle manufacturingforeman, automobile assemblyforeman, motor vehicle inspection and testing - motor vehicle manufacturingforeman - motor vehicle manufacturingforeman, motor vehicle manufacturingforeman, paint department - motor vehicle manufacturingforeman, paint shop - motor vehicle manufacturingforeman, production line - motor vehicle manufacturingforeman/woman, assembly - motor vehicle manufacturingforeman/woman, automobile assemblyforeman/woman, motor vehicle inspection and testing - motor vehicle manufacturingforeman/woman - motor vehicle manufacturingforeman/woman, motor vehicle manufacturingforeman/woman, paint department - motor vehicle manufacturingforeman/woman, paint shop - motor vehicle manufacturingforeman/woman, production line - motor vehicle manufacturingforewoman, assembly - motor vehicle manufacturingforewoman, automobile assemblyforewoman, motor vehicle inspection and testing - motor vehicle manufacturingforewoman - motor vehicle manufacturingforewoman, motor vehicle manufacturingforewoman, paint department - motor vehicle manufacturingforewoman, paint shop - motor vehicle manufacturingforewoman, production line - motor vehicle manufacturinggeneral assembly supervisor - motor vehicle manufacturinggeneral supervisor, assembly - motor vehicle manufacturinggeneral supervisor, motor vehicle assemblymotor vehicle assembly co-ordinatormotor vehicle assembly foremanmotor vehicle assembly foreman/womanmotor vehicle assembly forewomanmotor vehicle assembly general supervisormotor vehicle assembly supervisormotor vehicle assembly zone supervisormotor vehicle inspection and testing foreman - motor vehicle manufacturingmotor vehicle inspection and testing foreman/woman - motor vehicle manufacturingmotor vehicle inspection and testing forewoman - motor vehicle manufacturingmotor vehicle manufacturing foremanmotor vehicle manufacturing foreman/womanmotor vehicle manufacturing forewomanpaint department foreman - motor vehicle manufacturingpaint department foreman/woman - motor vehicle manufacturingpaint department forewoman - motor vehicle manufacturingpaint shop foreman - motor vehicle manufacturingpaint shop foreman/woman - motor vehicle manufacturingpaint shop forewoman - motor vehicle manufacturingpaint shop supervisor - motor vehicle manufacturingproduction line foreman - motor vehicle manufacturingproduction line foreman/woman - motor vehicle manufacturingproduction line forewoman - motor vehicle manufacturingsupervisor, assembly - motor vehicle manufacturingsupervisor, body shop - motor vehicle manufacturingsupervisor, chassis assembly - motor vehicle manufacturingsupervisor, engine dress - motor vehicle manufacturingsupervisor, final assembly - motor vehicle manufacturingsupervisor, motor vehicle assemblysupervisor, paint shop - motor vehicle manufacturingsupervisor, trim and hardware - motor vehicle manufacturingtrim and hardware supervisor - motor vehicle manufacturingzone supervisor, assembly - motor vehicle manufacturingzone supervisor, motor vehicle assembly",
    "workers": 2730,
    "minEduc": 2,
    "yearsStudy": 1.91439206,
    "automationRisk": 0.468,
    "salaryLow": 20,
    "salaryMed": 34,
    "salaryHigh": 48.08,
    "totalSkill": 122.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 26.75,
    "skillsComp": 27.5,
    "skillsLogi": 28.5,
    "skillsMath": 21.5,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 5.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 11.5,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 6,
    "s10Reading": 18.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 10,
    "s13DocumentUse": 15.5,
    "s14Writing": 12,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 45,
    "f2Engineering": 190,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 270,
    "f8Education(teachertraining)": 0,
    "f9Law": 55,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 230,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 270,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 190,
    "d11Law": 55,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 45,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 230,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 432,
    "noc": 9222,
    "job": "Supervisors, electronics manufacturing",
    "title1": "assembly and test foreman - electronics manufacturing",
    "title2": "assembly and test foreman/woman - electronics manufacturing",
    "title3": "assembly and test forewoman - electronics manufacturing",
    "allTitles": "assembly and test foreman - electronics manufacturingassembly and test foreman/woman - electronics manufacturingassembly and test forewoman - electronics manufacturingassembly and testing supervisor - electronic equipment manufacturingassembly foreman, semiconductorsassembly foreman/woman, semiconductorsassembly forewoman, semiconductorsassembly supervisor - electronic equipment manufacturingbusiness and commercial machine assembly supervisorbusiness and commercial machines assembly foremanbusiness and commercial machines assembly foreman/womanbusiness and commercial machines assembly forewomancoil winding foreman - electronics manufacturingcoil winding foreman/woman - electronics manufacturingcoil winding forewoman - electronics manufacturingcommunications equipment assembly foreman - electronics manufacturingcommunications equipment assembly foreman/woman - electronics manufacturingcommunications equipment assembly forewoman - electronics manufacturingcommunications equipment testing supervisor - electronics manufacturingcrystal processing foreman - electronics manufacturingcrystal processing foreman/woman - electronics manufacturingcrystal processing forewoman - electronics manufacturingelectronic assembly foremanelectronic assembly foreman/womanelectronic assembly forewomanelectronic assembly supervisorelectronic equipment fabricating and assembling foremanelectronic equipment fabricating and assembling foreman/womanelectronic equipment fabricating and assembling forewomanelectronic equipment fabricating and assembling supervisorelectronic equipment fabricating and assembling workers foremanelectronic equipment fabricating and assembling workers foreman/womanelectronic equipment fabricating and assembling workers forewomanelectronic inspection foreman - electronics manufacturingelectronic inspection foreman/woman - electronics manufacturingelectronic inspection forewoman - electronics manufacturingelectronics manufacturing foremanelectronics manufacturing foreman/womanelectronics manufacturing forewomanelectronics manufacturing supervisorfinal assembly and testing foreman - electronic equipment manufacturingfinal assembly and testing foreman/woman - electronic equipment manufacturingfinal assembly and testing forewoman - electronic equipment manufacturingfinal assembly and testing supervisor - electronic equipment manufacturingforeman, business and commercial machines assemblyforeman, electronic assemblyforeman, electronic equipment fabricating and assemblingforeman, electronic equipment fabricating and assembling workersforeman - electronic equipment manufacturingforeman, electronic inspection - electronics manufacturingforeman, electronics manufacturingforeman, final assembly and test - electronics manufacturingforeman, inspectors and testers - electronic equipment fabrication, assembly, installation and repairforeman, PCB (printed circuit board) fabricationforeman, printed circuit board fabricationforeman, printed circuit board (PCB) fabrication - electronic equipment manufacturingforeman, production - electronic equipment manufacturingforeman, semiconductor assemblyforeman, systems test - electronics manufacturingforeman, testing - electronic equipment manufacturingforeman/woman, business and commercial machines assemblyforeman/woman, electronic assemblyforeman/woman, electronic equipment fabricating and assemblingforeman/woman, electronic equipment fabricating and assembling workersforeman/woman - electronic equipment manufacturingforeman/woman, electronic inspection - electronics manufacturingforeman/woman, electronics manufacturingforeman/woman, final assembly and test - electronics manufacturingforeman/woman, inspectors and testers - electronic equipment fabrication, assembly, installation and repairforeman/woman, PCB (printed circuit board) fabricationforeman/woman, printed circuit board fabricationforeman/woman, printed circuit board (PCB) fabrication - electronic equipment manufacturingforeman/woman, production - electronic equipment manufacturingforeman/woman, semiconductor assemblyforeman/woman, systems test - electronics manufacturingforeman/woman, testing - electronic equipment manufacturingforewoman, business and commercial machines assemblyforewoman, electronic assemblyforewoman, electronic equipment fabricating and assemblingforewoman, electronic equipment fabricating and assembling workersforewoman - electronic equipment manufacturingforewoman, electronic inspection - electronics manufacturingforewoman, electronics manufacturingforewoman, final assembly and test - electronics manufacturingforewoman, inspectors and testers - electronic equipment fabrication, assembly, installation and repairforewoman, PCB (printed circuit board) fabricationforewoman, printed circuit board fabricationforewoman, printed circuit board (PCB) fabrication - electronic equipment manufacturingforewoman, production - electronic equipment manufacturingforewoman, semiconductor assemblyforewoman, systems test - electronics manufacturingforewoman, testing - electronic equipment manufacturingIC (integrated circuit) fabrication supervisor - electronic equipment manufacturinginspectors and testers foreman - electronic equipment fabrication, assembly, installation and repairinspectors and testers foreman/woman - electronic equipment fabrication, assembly, installation and repairinspectors and testers forewoman - electronic equipment fabrication, assembly, installation and repairintegrated circuit (IC) fabrication supervisor - electronic equipment manufacturingPCB (printed circuit board) fabrication foreman - electronic equipment manufacturingPCB (printed circuit board) fabrication foreman/woman - electronic equipment manufacturingPCB (printed circuit board) fabrication forewoman - electronic equipment manufacturing",
    "workers": 65,
    "minEduc": 0,
    "yearsStudy": 2.666666667,
    "automationRisk": 0.016,
    "salaryLow": 14,
    "salaryMed": 23.35,
    "salaryHigh": 32.65,
    "totalSkill": 160,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 23.35,
    "skillsComp": 43,
    "skillsLogi": 40,
    "skillsMath": 22,
    "skillsLang": 55,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 7,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 17,
    "s9ProblemSolving": 10,
    "s10Reading": 21,
    "s11SchedulingorBudgetingandAccounting": 7,
    "s12DigitalTechnology": 20,
    "s13DocumentUse": 16,
    "s14Writing": 16,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 0,
    "f2Engineering": 40,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 25,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 40,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 25,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 433,
    "noc": 9223,
    "job": "Supervisors, electrical products manufacturing",
    "title1": "dry cell assemblers supervisors electric cable manufacturing foreman/woman electric motor and generator assembly foreman/woman electric motor testing foreman/woman electrical appliance assemblers supervisor electrical appliance manufacturing supervisor electrical dry cell assembly foreman/woman electrical equipment manufacturing foreman/woman foreman/woman, electric dry cell assembly foreman/woman, electric motor and generator assembly foreman/woman, electric motor testing foreman/woman, electrical appliance assembly foreman/woman, electrical equipment manufacturing foreman/woman, electrical motor assembly foreman/woman, electrical switchgear assembly foreman/woman, electrical transformer assembly foreman/woman, switchgear assembly supervisor, dry cell assemblers supervisor, electrical appliance assemblers supervisor, electrical appliance assembly supervisor, electrical appliance manufacturing supervisor, electrical equipment manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "dry cell assemblers supervisors electric cable manufacturing foreman/woman electric motor and generator assembly foreman/woman electric motor testing foreman/woman electrical appliance assemblers supervisor electrical appliance manufacturing supervisor electrical dry cell assembly foreman/woman electrical equipment manufacturing foreman/woman foreman/woman, electric dry cell assembly foreman/woman, electric motor and generator assembly foreman/woman, electric motor testing foreman/woman, electrical appliance assembly foreman/woman, electrical equipment manufacturing foreman/woman, electrical motor assembly foreman/woman, electrical switchgear assembly foreman/woman, electrical transformer assembly foreman/woman, switchgear assembly supervisor, dry cell assemblers supervisor, electrical appliance assemblers supervisor, electrical appliance assembly supervisor, electrical appliance manufacturing supervisor, electrical equipment manufacturing",
    "workers": 963.3333333,
    "minEduc": 1,
    "yearsStudy": 2.110352909,
    "automationRisk": 0.272333333,
    "salaryLow": 17.38,
    "salaryMed": 28.28,
    "salaryHigh": 46.16,
    "totalSkill": 137,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 24.70344584,
    "skillsComp": 36.16666667,
    "skillsLogi": 34,
    "skillsMath": 20.83333333,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.666666667,
    "s2DecisionMaking": 8.666666667,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 2.833333333,
    "s5MeasurementandCalculation": 8.666666667,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.833333333,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 8.666666667,
    "s10Reading": 18.16666667,
    "s11SchedulingorBudgetingandAccounting": 5.333333333,
    "s12DigitalTechnology": 15.33333333,
    "s13DocumentUse": 16.33333333,
    "s14Writing": 12.83333333,
    "s15CriticalThinking": 7.666666667,
    "f1Science&Agriculture": 25,
    "f2Engineering": 76.66666667,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 18.33333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 76.66666667,
    "d11Law": 18.33333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 434,
    "noc": 9224,
    "job": "Supervisors, furniture and fixtures manufacturing",
    "title1": "buffing and lacquering foreman/woman � furniture and fixtures manufacturing chair assembly foreman/woman � furniture and fixtures manufacturing finishing room foreman/woman � furniture and fixtures manufacturing foreman/woman, buffing and lacquering � furniture and fixtures manufacturing foreman/woman, cabinet assemblers and wood furniture makers foreman/woman, chair assembly � furniture and fixtures manufacturing foreman/woman, decorating � furniture and fixtures manufacturing foreman/woman, desk assembly foreman/woman, desk assembly � furniture and fixtures manufacturing foreman/woman, furniture assembly foreman/woman, furniture assembly � furniture and fixtures manufacturing foreman/woman, furniture components sanding department foreman/woman, furniture finishers � furniture and fixtures manufacturing foreman/woman, furniture finishing � furniture and fixtures manufacturing foreman/woman, furniture gluers � furniture and fixtures manufacturing foreman/woman, furniture inspectors � furniture and fixtures manufacturing foreman/woman, gluing � furniture and fixtures manufacturing foreman/woman, laminating � furniture and fixtures manufacturing foreman/woman, machining � furniture and fixtures manufacturing foreman/woman, mattress manufacturing foreman/woman, metal furniture assembly foreman/woman, paint department � furniture and fixtures manufacturing foreman/woman, planers, turners, shapers and related wood-machining workers � furniture and fixtures manufacturing foreman/woman, veneering � furniture and fixtures manufacturing foreman/woman, veneering shop � furniture and fixtures manufacturing foreman/woman, wood machining workers � furniture and fixtures manufacturing foreman/woman, wood sanders � furniture and fixtures manufacturing foreman/woman, wood sawing (except sawmill) foreman/woman, wood-machining quality-control inspectors � furniture and fixtures manufacturing foreman/woman, woodworking machine department foreman/woman, woodworking machine operators � furniture and fixtures manufacturing furniture and fixtures manufacturing supervisor furniture assembly foreman/woman � furniture and fixtures manufacturing furniture components sanding department foreman/woman furniture finishers foreman/woman � furniture and fixtures manufacturing furniture finishing foreman/woman � furniture and fixtures manufacturing furniture gluers foreman/woman � furniture and fixtures manufacturing furniture inspectors foreman/woman gluing foreman/woman � furniture and fixtures manufacturing laminating foreman/woman laminating foreman/woman � furniture and fixtures manufacturing machining foreman/woman � furniture and fixtures manufacturing mattress manufacturing foreman/woman metal furniture assembly foreman/woman paint department foreman/woman � furniture and fixtures manufacturing planers, turners, shapers and related wood-machining workers foreman/woman � furniture and fixtures manufacturing shop foreman/woman, veneering � furniture and fixtures manufacturing supervisor, furniture and fixture manufacturing supervisor, furniture finishers supervisor, woodworking machine operators supervisor, woodworking machine operators � furniture and fixtures manufacturing veneering foreman/woman � furniture and fixtures manufacturing veneering shop foreman/woman � furniture and fixtures manufacturing wood machining workers foreman/woman � furniture and fixtures manufacturing wood sanders foreman/woman � furniture and fixtures manufacturing wood sawing foreman/woman (except sawmill) wood-machining quality-control inspectors foreman/woman � furniture and fixtures manufacturing woodworking machine department foreman/woman � furniture and fixtures manufacturing woodworking machine operators supervisor � furniture and fixtures manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "buffing and lacquering foreman/woman � furniture and fixtures manufacturing chair assembly foreman/woman � furniture and fixtures manufacturing finishing room foreman/woman � furniture and fixtures manufacturing foreman/woman, buffing and lacquering � furniture and fixtures manufacturing foreman/woman, cabinet assemblers and wood furniture makers foreman/woman, chair assembly � furniture and fixtures manufacturing foreman/woman, decorating � furniture and fixtures manufacturing foreman/woman, desk assembly foreman/woman, desk assembly � furniture and fixtures manufacturing foreman/woman, furniture assembly foreman/woman, furniture assembly � furniture and fixtures manufacturing foreman/woman, furniture components sanding department foreman/woman, furniture finishers � furniture and fixtures manufacturing foreman/woman, furniture finishing � furniture and fixtures manufacturing foreman/woman, furniture gluers � furniture and fixtures manufacturing foreman/woman, furniture inspectors � furniture and fixtures manufacturing foreman/woman, gluing � furniture and fixtures manufacturing foreman/woman, laminating � furniture and fixtures manufacturing foreman/woman, machining � furniture and fixtures manufacturing foreman/woman, mattress manufacturing foreman/woman, metal furniture assembly foreman/woman, paint department � furniture and fixtures manufacturing foreman/woman, planers, turners, shapers and related wood-machining workers � furniture and fixtures manufacturing foreman/woman, veneering � furniture and fixtures manufacturing foreman/woman, veneering shop � furniture and fixtures manufacturing foreman/woman, wood machining workers � furniture and fixtures manufacturing foreman/woman, wood sanders � furniture and fixtures manufacturing foreman/woman, wood sawing (except sawmill) foreman/woman, wood-machining quality-control inspectors � furniture and fixtures manufacturing foreman/woman, woodworking machine department foreman/woman, woodworking machine operators � furniture and fixtures manufacturing furniture and fixtures manufacturing supervisor furniture assembly foreman/woman � furniture and fixtures manufacturing furniture components sanding department foreman/woman furniture finishers foreman/woman � furniture and fixtures manufacturing furniture finishing foreman/woman � furniture and fixtures manufacturing furniture gluers foreman/woman � furniture and fixtures manufacturing furniture inspectors foreman/woman gluing foreman/woman � furniture and fixtures manufacturing laminating foreman/woman laminating foreman/woman � furniture and fixtures manufacturing machining foreman/woman � furniture and fixtures manufacturing mattress manufacturing foreman/woman metal furniture assembly foreman/woman paint department foreman/woman � furniture and fixtures manufacturing planers, turners, shapers and related wood-machining workers foreman/woman � furniture and fixtures manufacturing shop foreman/woman, veneering � furniture and fixtures manufacturing supervisor, furniture and fixture manufacturing supervisor, furniture finishers supervisor, woodworking machine operators supervisor, woodworking machine operators � furniture and fixtures manufacturing veneering foreman/woman � furniture and fixtures manufacturing veneering shop foreman/woman � furniture and fixtures manufacturing wood machining workers foreman/woman � furniture and fixtures manufacturing wood sanders foreman/woman � furniture and fixtures manufacturing wood sawing foreman/woman (except sawmill) wood-machining quality-control inspectors foreman/woman � furniture and fixtures manufacturing woodworking machine department foreman/woman � furniture and fixtures manufacturing woodworking machine operators supervisor � furniture and fixtures manufacturing",
    "workers": 963.3333333,
    "minEduc": 1,
    "yearsStudy": 2.110352909,
    "automationRisk": 0.272333333,
    "salaryLow": 16.476,
    "salaryMed": 26.55,
    "salaryHigh": 41.464,
    "totalSkill": 137,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 24.70344584,
    "skillsComp": 36.16666667,
    "skillsLogi": 34,
    "skillsMath": 20.83333333,
    "skillsLang": 46,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.666666667,
    "s2DecisionMaking": 8.666666667,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 2.833333333,
    "s5MeasurementandCalculation": 8.666666667,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.833333333,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 8.666666667,
    "s10Reading": 18.16666667,
    "s11SchedulingorBudgetingandAccounting": 5.333333333,
    "s12DigitalTechnology": 15.33333333,
    "s13DocumentUse": 16.33333333,
    "s14Writing": 12.83333333,
    "s15CriticalThinking": 7.666666667,
    "f1Science&Agriculture": 25,
    "f2Engineering": 76.66666667,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 18.33333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 76.66666667,
    "d11Law": 18.33333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 435,
    "noc": 9226,
    "job": "Supervisors, other mechanical and metal products manufacturing",
    "title1": "aircraft assembly foreman",
    "title2": "aircraft assembly foreman/woman",
    "title3": "aircraft assembly forewoman",
    "allTitles": "aircraft assembly foremanaircraft assembly foreman/womanaircraft assembly forewomanaircraft assembly inspection foremanaircraft assembly inspection foreman/womanaircraft assembly inspection forewomanaircraft assembly supervisoraircraft hydraulic equipment installation foremanaircraft hydraulic equipment installation foreman/womanaircraft hydraulic equipment installation forewomanaircraft parts etching foremanaircraft parts etching foreman/womanaircraft parts etching forewomanaircraft rigging foremanaircraft rigging foreman/womanaircraft rigging forewomanassembly foreman, agricultural equipmentassembly foreman, engine accessories (except aircraft)assembly foreman, engines (except aircraft)assembly foreman, farm implementsassembly foreman, helicoptersassembly foreman, tractor-trailersassembly foreman/woman, agricultural equipmentassembly foreman/woman, engine accessories (except aircraft)assembly foreman/woman, engines (except aircraft)assembly foreman/woman, farm implementsassembly foreman/woman, helicoptersassembly foreman/woman, tractor-trailersassembly forewoman, agricultural equipmentassembly forewoman, engine accessories (except aircraft)assembly forewoman, engines (except aircraft)assembly forewoman, farm implementsassembly forewoman, helicoptersassembly forewoman, tractor-trailersassembly inspection foreman, aircraftassembly inspection foreman/woman, aircraftassembly inspection forewoman, aircraftassembly supervisor, engines (except aircraft)assembly supervisor, helicoptersassembly supervisor, mobile homesassembly supervisor, small enginesassembly supervisor, tractor-trailersball and roller-bearings assembly foremanball and roller-bearings assembly foreman/womanball and roller-bearings assembly forewomanconstruction machinery assembly foremanconstruction machinery assembly foreman/womanconstruction machinery assembly forewomandiesel engine assembly foremandiesel engine assembly foreman/womandiesel engine assembly forewomanelectroplating foremanelectroplating foreman/womanelectroplating forewomanengine accessories assembly foreman (except aircraft)engine accessories assembly foreman/woman (except aircraft)engine accessories assembly forewoman (except aircraft)engine assembly foreman (except aircraft)engine assembly foreman/woman (except aircraft)engine assembly forewoman (except aircraft)engine assembly supervisor (except aircraft)engine rebuilding shop foreman (except aircraft)engine rebuilding shop foreman/woman (except aircraft)engine rebuilding shop forewoman (except aircraft)engine testing foreman (except aircraft)engine testing foreman/woman (except aircraft)engine testing forewoman (except aircraft)farm machinery inspection foremanfarm machinery inspection foreman/womanfarm machinery inspection forewomanforeman, agricultural equipment assemblyforeman, aircraft assemblyforeman, aircraft fuselage assemblyforeman, aircraft paintersforeman, ball and roller-bearings assemblyforeman, construction machinery assemblyforeman, electroplatingforeman, engine assembly (except aircraft)foreman, engine guard assembly (except aircraft)foreman, engine rebuilding shop (except aircraft)foreman, engine testing (except aircraft)foreman, forge shop - metal products manufacturingforeman, forging-machine operatorsforeman, galvanizingforeman, garden tractor assemblyforeman, helicopter assemblyforeman, industrial truck assemblyforeman, light agricultural and farm equipment assemblyforeman, light construction machinery assemblyforeman, light industrial, farm and construction machinery assemblyforeman, light material-handling equipment assemblyforeman, metal buffersforeman, metal buffingforeman, metal products inspection and testingforeman, metalworking machine operatorsforeman, mobile home assemblyforeman, paint department - aircraft manufacturingforeman, paint department - heavy equipment manufacturingforeman, paint department - heavy truck, bus and trailer manufacturingforeman, paint department - machinery manufacturing",
    "workers": 95,
    "minEduc": 1,
    "yearsStudy": 1.75,
    "automationRisk": 0.333,
    "salaryLow": 17,
    "salaryMed": 24.04,
    "salaryHigh": 39.56,
    "totalSkill": 128.5,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 24.01033752,
    "skillsComp": 38,
    "skillsLogi": 33.5,
    "skillsMath": 19,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 4.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 7.5,
    "s6MoneyMath": 3.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 10,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 16,
    "s13DocumentUse": 17.5,
    "s14Writing": 10.5,
    "s15CriticalThinking": 9,
    "f1Science&Agriculture": 30,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 436,
    "noc": 9227,
    "job": "Supervisors, other products manufacturing and assembly",
    "title1": "assembly foreman/woman, clocks and watches assembly foreman/woman, fibreglass boats baby carriage assembly foreman/woman bench assemblers foreman/woman � wood products manufacturing brush making foreman/woman candle making foreman/woman clock and watch assembly repairers foreman/woman clock and watch assembly repairers supervisor clock and watch assembly supervisor clock and watch inspection foreman/woman controlling and recording instruments assembly foreman/woman cooper foreman/woman cutlery manufacturing foreman/woman door and sash assembly foreman/woman fibreglass boat foreman/woman firearms assembly foreman/woman foreman/woman, baby carriage assembly foreman/woman, bench assemblers � wood products foreman/woman, bicycle assembly foreman/woman, brush making foreman/woman, candle making foreman/woman, clock and watch assembly foreman/woman, clock and watch assembly repairers foreman/woman, clock and watch inspection foreman/woman, controlling and recording instruments assembly foreman/woman, cutlery manufacturing foreman/woman, door and sash assembly foreman/woman, fibreglass boat assembly foreman/woman, firearms assembly foreman/woman, hand tool manufacturing foreman/woman, jewellery and silverware-manufacturing workers foreman/woman, jewellery manufacturing foreman/woman, jewellery repairing � manufacturing foreman/woman, lamp shade fabrication foreman/woman, lens grinders and polishers foreman/woman, millwork assemblers � wood manufacturing foreman/woman, millwork assembly foreman/woman, millwork assembly � wood products manufacturing foreman/woman, mirror silvering foreman/woman, musical instrument manufacturing foreman/woman, optical instrument assembly foreman/woman, optical instrument manufacturing foreman/woman, photographic equipment assembly foreman/woman, precision instruments and related equipment assembly foreman/woman, prefab house assembly foreman/woman, prefab housing assemblers foreman/woman, prefab housing assembly foreman/woman, prefabricated joinery assembly � wood products manufacturing foreman/woman, sash and door assembly foreman/woman, sash and door shop foreman/woman, scale assembly foreman/woman, spikemaking foreman/woman, sporting equipment manufacturing foreman/woman, thermostat assembly foreman/woman, toy assembly foreman/woman, toy manufacturing foreman/woman, wooden barrel makers foreman/woman, wooden box maker foreman/woman, wooden truss makers � manufacturing foreman/woman, woodenware assemblers hand tools manufacturing foreman/woman jewellery manufacturing foreman/woman jewellery repairing foreman/woman � manufacturing millwork assemblers foreman/woman � wood products manufacturing millwork assembly supervisor mirror silvering foreman/woman optical instrument assembly foreman/woman optical instrument manufacturing foreman/woman prefabricated joinery assemblers foreman/woman � wood products manufacturing prefabricated joinery assembly supervisor silverware manufacturing supervisor sporting goods manufacturing supervisor supervisor, bicycle assembly supervisor, clock and watch assembly supervisor, clock and watch assembly repairers supervisor, jewellery assembly supervisor, lens manufacturing (non-prescription) supervisor, millwork assembly supervisor, silverware manufacturing supervisor, sports equipment assembly supervisor, sports equipment manufacturing supervisor, toy manufacturing toy assembly foreman/woman toy manufacturing foreman/woman toy manufacturing supervisor wood products foreman/woman wooden box maker foreman/woman wooden truss making foreman/woman � manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "assembly foreman/woman, clocks and watches assembly foreman/woman, fibreglass boats baby carriage assembly foreman/woman bench assemblers foreman/woman � wood products manufacturing brush making foreman/woman candle making foreman/woman clock and watch assembly repairers foreman/woman clock and watch assembly repairers supervisor clock and watch assembly supervisor clock and watch inspection foreman/woman controlling and recording instruments assembly foreman/woman cooper foreman/woman cutlery manufacturing foreman/woman door and sash assembly foreman/woman fibreglass boat foreman/woman firearms assembly foreman/woman foreman/woman, baby carriage assembly foreman/woman, bench assemblers � wood products foreman/woman, bicycle assembly foreman/woman, brush making foreman/woman, candle making foreman/woman, clock and watch assembly foreman/woman, clock and watch assembly repairers foreman/woman, clock and watch inspection foreman/woman, controlling and recording instruments assembly foreman/woman, cutlery manufacturing foreman/woman, door and sash assembly foreman/woman, fibreglass boat assembly foreman/woman, firearms assembly foreman/woman, hand tool manufacturing foreman/woman, jewellery and silverware-manufacturing workers foreman/woman, jewellery manufacturing foreman/woman, jewellery repairing � manufacturing foreman/woman, lamp shade fabrication foreman/woman, lens grinders and polishers foreman/woman, millwork assemblers � wood manufacturing foreman/woman, millwork assembly foreman/woman, millwork assembly � wood products manufacturing foreman/woman, mirror silvering foreman/woman, musical instrument manufacturing foreman/woman, optical instrument assembly foreman/woman, optical instrument manufacturing foreman/woman, photographic equipment assembly foreman/woman, precision instruments and related equipment assembly foreman/woman, prefab house assembly foreman/woman, prefab housing assemblers foreman/woman, prefab housing assembly foreman/woman, prefabricated joinery assembly � wood products manufacturing foreman/woman, sash and door assembly foreman/woman, sash and door shop foreman/woman, scale assembly foreman/woman, spikemaking foreman/woman, sporting equipment manufacturing foreman/woman, thermostat assembly foreman/woman, toy assembly foreman/woman, toy manufacturing foreman/woman, wooden barrel makers foreman/woman, wooden box maker foreman/woman, wooden truss makers � manufacturing foreman/woman, woodenware assemblers hand tools manufacturing foreman/woman jewellery manufacturing foreman/woman jewellery repairing foreman/woman � manufacturing millwork assemblers foreman/woman � wood products manufacturing millwork assembly supervisor mirror silvering foreman/woman optical instrument assembly foreman/woman optical instrument manufacturing foreman/woman prefabricated joinery assemblers foreman/woman � wood products manufacturing prefabricated joinery assembly supervisor silverware manufacturing supervisor sporting goods manufacturing supervisor supervisor, bicycle assembly supervisor, clock and watch assembly supervisor, clock and watch assembly repairers supervisor, jewellery assembly supervisor, lens manufacturing (non-prescription) supervisor, millwork assembly supervisor, silverware manufacturing supervisor, sports equipment assembly supervisor, sports equipment manufacturing supervisor, toy manufacturing toy assembly foreman/woman toy manufacturing foreman/woman toy manufacturing supervisor wood products foreman/woman wooden box maker foreman/woman wooden truss making foreman/woman � manufacturing",
    "workers": 963.3333333,
    "minEduc": 1,
    "yearsStudy": 2.110352909,
    "automationRisk": 0.272333333,
    "salaryLow": 14,
    "salaryMed": 23.08,
    "salaryHigh": 40.87,
    "totalSkill": 137,
    "industry": "Trades, transport, equipment operators",
    "industryNum": 3,
    "sector": "Industrial, electrical and construction trades",
    "cluster": 3,
    "wage": 24.70344584,
    "skillsComp": 36.16666667,
    "skillsLogi": 34,
    "skillsMath": 20.83333333,
    "skillsLang": 46,
    "topSkill1": "Document Use",
    "topSkill2": "Digital Technology",
    "topSkill3": "Reading",
    "s1DataAnalysis": 4.666666667,
    "s2DecisionMaking": 8.666666667,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 2.833333333,
    "s5MeasurementandCalculation": 8.666666667,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.833333333,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 8.666666667,
    "s10Reading": 18.16666667,
    "s11SchedulingorBudgetingandAccounting": 5.333333333,
    "s12DigitalTechnology": 15.33333333,
    "s13DocumentUse": 16.33333333,
    "s14Writing": 12.83333333,
    "s15CriticalThinking": 7.666666667,
    "f1Science&Agriculture": 25,
    "f2Engineering": 76.66666667,
    "f3Humanities": 0,
    "f4SocialScience": 8.333333333,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 18.33333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 85,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 8.333333333,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 76.66666667,
    "d11Law": 18.33333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 85,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 437,
    "noc": 9231,
    "job": "Central control and process operators, mineral and metal processing",
    "title1": "alloy control operator � zinc casting bar mill finisher � primary metal processing billet mill roller � primary metal processing blast furnace operator blast furnaceman/woman blooming mill roller breakdown mill operator central control caster central control caster � primary metal processing central control operator � cement manufacturing central control room operator � primary metal and mineral products processing central control room operator � primary metal processing chief flotation operator chief operator � zinc pressure leach coke plant by-products operator cold mill operator � primary metal processing concentrator control room operator console operator � cement manufacturing continuous casting operator � primary metal processing control operator, rolling mill � primary metal processing control room furnace operator � smelter control room operator � primary metal processing copper melter copper refinery operator crucible furnace operator crusher control room operator cupola furnace operator � primary metal processing dross furnace operator electric arc furnace operator � primary metal processing electric furnace operator � primary metal and mineral products processing electrolytic refinery process operator furnace operator � primary metal and mineral products processing head charger heater � primary metal processing hot mill roller � primary metal processing induction furnace operator � mineral and metal processing ion exchange operator lead-refining furnace operator melter � primary metal processing metal heater � primary metal processing metal heater operator metal melter metal roaster � primary metal processing metal smelter molybdenum roaster operator nuclear fuel processor open-flame furnace operator � primary metal processing operator, central control � cement manufacturing operator, central control room � primary metal and mineral products processing operator, cold mill � primary metal processing operator, continuous casting machine � primary metal processing operator, roaster � primary metal processing operator, rolling mill control � primary metal processing ore roaster oxygen furnace operator � primary metal processing panel board operator � primary metal and mineral products processing pelletizing control operator perlite expander control panel operator � mineral products processing process operator � primary metal and mineral products processing process operator � zinc pressure leach purity control operator � zinc leaching refinery process operator � primary metal processing reverberatory furnace operator � primary metal processing roaster operator � primary metal processing rolling mill control operator rolling mill control operator � primary metal processing slabbing mill roller � primary metal processing slurry controller � primary metal processing smelting furnace operator � primary metal processing steel heater operator steel-degasser process operator vacuum furnace operator � primary metal processing vacuum-degasser process operator � primary metal processing",
    "title2": 0,
    "title3": 0,
    "allTitles": "alloy control operator � zinc casting bar mill finisher � primary metal processing billet mill roller � primary metal processing blast furnace operator blast furnaceman/woman blooming mill roller breakdown mill operator central control caster central control caster � primary metal processing central control operator � cement manufacturing central control room operator � primary metal and mineral products processing central control room operator � primary metal processing chief flotation operator chief operator � zinc pressure leach coke plant by-products operator cold mill operator � primary metal processing concentrator control room operator console operator � cement manufacturing continuous casting operator � primary metal processing control operator, rolling mill � primary metal processing control room furnace operator � smelter control room operator � primary metal processing copper melter copper refinery operator crucible furnace operator crusher control room operator cupola furnace operator � primary metal processing dross furnace operator electric arc furnace operator � primary metal processing electric furnace operator � primary metal and mineral products processing electrolytic refinery process operator furnace operator � primary metal and mineral products processing head charger heater � primary metal processing hot mill roller � primary metal processing induction furnace operator � mineral and metal processing ion exchange operator lead-refining furnace operator melter � primary metal processing metal heater � primary metal processing metal heater operator metal melter metal roaster � primary metal processing metal smelter molybdenum roaster operator nuclear fuel processor open-flame furnace operator � primary metal processing operator, central control � cement manufacturing operator, central control room � primary metal and mineral products processing operator, cold mill � primary metal processing operator, continuous casting machine � primary metal processing operator, roaster � primary metal processing operator, rolling mill control � primary metal processing ore roaster oxygen furnace operator � primary metal processing panel board operator � primary metal and mineral products processing pelletizing control operator perlite expander control panel operator � mineral products processing process operator � primary metal and mineral products processing process operator � zinc pressure leach purity control operator � zinc leaching refinery process operator � primary metal processing reverberatory furnace operator � primary metal processing roaster operator � primary metal processing rolling mill control operator rolling mill control operator � primary metal processing slabbing mill roller � primary metal processing slurry controller � primary metal processing smelting furnace operator � primary metal processing steel heater operator steel-degasser process operator vacuum furnace operator � primary metal processing vacuum-degasser process operator � primary metal processing",
    "workers": 1035,
    "minEduc": 0,
    "yearsStudy": 2.12,
    "automationRisk": 0.8325,
    "salaryLow": 15.68971429,
    "salaryMed": 25.80285714,
    "salaryHigh": 41.64671429,
    "totalSkill": 129,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 28.55489665,
    "skillsComp": 35.5,
    "skillsLogi": 32.5,
    "skillsMath": 19,
    "skillsLang": 42.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 13.5,
    "s13DocumentUse": 17.5,
    "s14Writing": 10.5,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 195,
    "f2Engineering": 410,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 190,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 190,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 410,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 438,
    "noc": 9232,
    "job": "Central control and process operators, petroleum, gas and chemical processing",
    "title1": "absorption operator",
    "title2": "absorption plant operator",
    "title3": "acid mixer operator",
    "allTitles": "absorption operatorabsorption plant operatoracid mixer operatoracid plant operatoralkylation chief operatoralkylation operatoralkylation tower tenderalum-liquor plant operatorammonia plant operatorantibiotics fermenterassistant operator - chemical processingbatching chemical process operatorbenzol agitator operatorbitumen extraction plant operatorbitumen upgrading plant operatorblender, petroleumblender, propellantsboardman - chemical processingboardman/woman - chemical processingboardwoman - chemical processingbrine equipment tenderbrine purification operatorburner operator - petroleumcatalyst operator, gasolinecatalytic cracking unit operatorcaustic cell operatorcell room operator, chlor-alkali plantchemical process operatorchemical process unit operatorchemical roasterchief operator, batching processchief operator - chemical processingchief operator, continuous processchief operator, synthesischief technician, chemical processingchlorination plant operatorchlorine plant operatorcoal gas exhaust operatorcoal tar distillercolumn operator - chemical processingcompressor operator, gas processingcompressor operator, natural gascompressor station operator - pipelinescontroller - oilcontroller, oil movementcontrol panel operator - chemical processingcracking plant operatordesulphurizer operatordispatcher, gasdispatcher, oildissolver-precipitatordistillation operatordistillation operator, petroleumexplosives senior operatorfertilizer maker, phosphate processfilter operator - petroleum, gas and chemical processingfractionator operatorfuel gas treatergas control coordinatorgas controllergas control operatorgas dispatchergas field operatorgas field production operatorgas liquefaction and regasification plant operatorgasoline catalyst operatorgas pipeline operatorgas plant operatorgas pressure regulatorgas processing controllergas recovery operatorgas-treating unit operatorgauger, oilgauger, pipelinesglycerine refinerglycerine refinery operatorgrease makerheavy water chemical process operatorhydrogen process plant operatorlead operator - chemical processingliquefaction plant operatormaster operator - chemical processingmixer, wet explosivesnaphthalene clarifiernitric acid oxidation plant operatornitrocellulose makernitroglycerine makernitroglycerine nitrator operatornitroglycerine separatornitroglycerine separator operatoroil blenderoil controlleroil dispatcheroil field production operatoroil field pumperoil movement controlleroil movement coordinatoroil pipeline operatoroil refineroil refinery process operator",
    "workers": 1035,
    "minEduc": 0,
    "yearsStudy": 2.12,
    "automationRisk": 0.8325,
    "salaryLow": 15.68971429,
    "salaryMed": 25.80285714,
    "salaryHigh": 41.64671429,
    "totalSkill": 129,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 28.55489665,
    "skillsComp": 35.5,
    "skillsLogi": 32.5,
    "skillsMath": 19,
    "skillsLang": 42.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13.5,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 13.5,
    "s13DocumentUse": 17.5,
    "s14Writing": 10.5,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 195,
    "f2Engineering": 410,
    "f3Humanities": 0,
    "f4SocialScience": 25,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 190,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 15,
    "f12Business": 20,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 25,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 190,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 410,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 195,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 15,
    "d18Business&Commerce": 20,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 439,
    "noc": 9241,
    "job": "Power engineers and power systems operators",
    "title1": "air compressor operator",
    "title2": "air conditioning system operator",
    "title3": "apprentice power dispatcher",
    "allTitles": "air compressor operatorair conditioning system operatorapprentice power dispatcherapprentice power dispatcher - electrical power systemsapprentice power engineerapprentice stationary engineerarea dispatch chief operatorarea load centre dispatcherautomated substation operator - electrical power systemsauxiliary equipment operatorauxiliary plant operatorboilerhouse operatorboiler operatorbuilding systems operatorbuilding systems techniciancentral control room operator - electrical power systemscentral-office power control room operator - electrical power systemschief operator, area dispatchchief operator, area dispatch - electrical power systemscontrol room operator - electrical power systemscontrol room operator, trainee - electrical power systemsconversion substation operator - electrical power systemscooling system operatordiesel engine operator, stationarydiesel generating station operator - electrical power systemsdiesel plant operator - electrical power systemsdiesel station operatordistribution control operatordistribution control operator - electrical power systemsdistribution system dispatcher apprentice - electrical power systemsdistribution system operatorelectrical power systems operatorelectrical station operatorelectrical station operator - electrical power systemselectrical station power distribution inspectorenergy from waste plant operatorenergy recovery incinerator plant operatorfeeder switchboard apprentice operator - electrical power systemsfeeder switchboard operator - electrical power systemsfifth-class stationary engineerfirst-class power engineerfirst-class stationary engineerfourth-class power engineerfourth-class stationary engineerfurnace boiler operatorgenerating station main operatorgenerating station operatorgenerating station operator - electrical power systemsgenerating station switchboard operatorgeneration substation operator - electrical power systemsheating and ventilation equipment tenderheating stationary engineerheavy water steam plant operatorhumidifying systems operatorhydro-electric generating station operatorhydro-electric power plant operatorload dispatcher apprentice - electrical power systemsload dispatcher - electrical power systemsmobile generator operatornuclear generating station field operatornuclear generating station operatornuclear generating station operator - electrical power systemsnuclear reactor control room operator - electrical power systemsnuclear reactor operatornuclear reactor operator - electrical power systemsnuclear station control room operatoroperator, air conditioning systemsoperator, boileroperator, steam plantplant maintenance engineer, stationaryplant maintenance stationary engineerpower control room operator - electrical power systemspower dispatcherpower dispatcher - electrical power systemspower dispatcher - generating stationpower engineerpower engineer apprenticepower engineer, first classpower engineer, fourth classpower engineer, second classpower engineer, third classpowerhouse operatorpower plant operatorpower plant operator - electrical power systemspower plant stationary engineerpower reactor operator - electrical power systemspower station operator - electrical power systemspower substation operatorpower switchboard operator apprentice - electrical power systemspower switchboard operator - electrical power systemspower system operatorpower system operator - offshore drillingrectifier operator - electrical power systemsrefrigeration plant operatorsecond-class stationary engineersecond-lass power engineerstationary engineerstationary engineer \"A\" and refrigeration plant operatorstationary engineer apprenticestationary engineer \"B\" and refrigeration plant operator",
    "workers": 5755,
    "minEduc": 0,
    "yearsStudy": 2.505154639,
    "automationRisk": 0.9,
    "salaryLow": 14.02,
    "salaryMed": 36,
    "salaryHigh": 51.5,
    "totalSkill": 127,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 36,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 41,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 2740,
    "f2Engineering": 2240,
    "f3Humanities": 0,
    "f4SocialScience": 35,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 635,
    "f8Education(teachertraining)": 0,
    "f9Law": 25,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 80,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 20,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 35,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 635,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 2240,
    "d11Law": 25,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 2720,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 80,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 440,
    "noc": 9243,
    "job": "Water and waste treatment plant operators",
    "title1": "environmental systems operator - water treatment",
    "title2": "filter plant operator - water treatment",
    "title3": "filtration plant controller - water treatment",
    "allTitles": "environmental systems operator - water treatmentfilter plant operator - water treatmentfiltration plant controller - water treatmentindustrial waste treatment plant operatorliquid waste-processing plant, operatorliquid waste process operatoroperator, liquid waste treatment plantoperator, pumphouse - water treatmentoperator, pumping station - water treatmentoperator, sewage plantoperator, wastewater treatment plantoperator, water filtration plantoperator, water plant pumpoperator, water purification plantoperator, water treatment plantoperator, waterworks pumping stationprocessing plant operator, liquid wasteprocess operator, liquid wasteprocess technician, water treatment plantpumphouse operator - water treatmentpump operator, water plantpump station operator - water treatmentsewage plant operatorsewage-processing equipment tendersystems operator, water treatmenttender, sewage-processing equipmentwaste treatment plant operatorwastewater collection operatorwastewater collection systems operatorwastewater treatment operatorwastewater treatment plant operatorwastewater treatment plant workerwater and wastewater technicianwater filtration plant operatorwater gate operatorwater plant pump operatorwater treatment operatorwater treatment plant operatorwater treatment plant process technicianwater treatment systems operatorwater utility operatorwaterworks pump house operatorwell-point pump operator",
    "workers": 1095,
    "minEduc": 0,
    "yearsStudy": 2,
    "automationRisk": 0.61,
    "salaryLow": 14,
    "salaryMed": 25.34,
    "salaryHigh": 39.56,
    "totalSkill": 135,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing, manufacturing and utilities supervisors and central control operators",
    "cluster": 7,
    "wage": 25.34,
    "skillsComp": 37,
    "skillsLogi": 34,
    "skillsMath": 19,
    "skillsLang": 45,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Digital Technology",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 9,
    "s10Reading": 19,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 7,
    "f1Science&Agriculture": 165,
    "f2Engineering": 805,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 40,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 45,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 85,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 40,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 805,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 80,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 45,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 441,
    "noc": 9411,
    "job": "Machine operators, mineral and metal processing",
    "title1": "agglomerating attendant, iron ore pellets",
    "title2": "alumina clarifier operator",
    "title3": "alumina recovery operator",
    "allTitles": "agglomerating attendant, iron ore pelletsalumina clarifier operatoralumina recovery operatoraluminum-briquetting equipment operatoraluminum-casting machine operator - primary metal processingaluminum classifieraluminum electrolytic tank reconditioneraluminum electrolytic tank tenderaluminum oxide controlleraluminum pourer - primary metal processingaluminum powder makeraluminum slurry pump tenderaluminum stretcher-leveller operatoramalgamation process tenderannealer - primary metal processinganode casteranode caster - primary metal processinganode operatoranode press operatorarsenic recovery operatorasbestos dryerasbestos screen tenderauxiliary equipment operator - primary metal processingbaghouse operatorball mill operatorbar-straightening machine operator - metal processingbillet caster, zincbillet heaterblast furnace tapperblender tender - primary metal and mineral products processingbrick and tile crusher operatorbrine maker - mineral products processingbriquetting machine operatorbulk cement-blender tendercadmium control operator - zinc leachingcadmium plant operatorcadmium recoverercadmium zinc leachercalciner operator - mineral products processingcase hardener - primary metal processingcasting machine operator - primary metal processingcathode-stripping machine operator - zinc electrolysiscell operator - primary metal and mineral processingcementation equipment operatorcement millercement mixer - primary metal and mineral products processingcement pumping tendercharge control operatorcharging car operatorcharging machine operator - mineral and metal processingclassifier operatorcoal breakercoal screenercoal separatorcoal washercoarse salt equipment operatorcoiler operator - primary metal processingcoke by-products pump operator - primary metal processingcoke grindercoke oven door operatorcoke oven operatorcoke-screen and coke-blender tendercoke screen tendercold steel roller - steel productioncold steel rolling mill operatorconcrete batch plant operator - cement manufacturingcondenser setter - primary metal processingcone tendercontinuous drossing operatorcooling bed operator - steel millcopper billet piercercopper billet piercing mill operatorcopper-briquetting machine operatorcopper flotation operatorcopper ore slime treaterCottrell tendercrane ladle pourercrucible pourercrusher and blender operatorcrusher settercrushing equipment operatorcryolite recovery equipment operatordental amalgam processordewaterer tender - primary metal processingdewatering equipment operatordiamond powder blenderdigester operator - primary metal and mineral processingdischarge door attendantdross treatment operator - zinc meltingdryer operator - mineral and metal processingdust operatordust pump operator - slag furnaceelectrolytic cleaner operator - primary metal processingelectrolytic descaler - primary metal processingelectrolytic tank maintainer - primary metal and mineral products processingelectrostatic separator tender - primary metal processingextrusion press operatorfinisher - primary metal processingflame annealing tender - primary metal processingflotation cell tender - primary metal processing",
    "workers": 240,
    "minEduc": 1,
    "yearsStudy": 1.428571429,
    "automationRisk": 0.883,
    "salaryLow": 14.0775,
    "salaryMed": 22.1725,
    "salaryHigh": 35.8925,
    "totalSkill": 84,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.92537194,
    "skillsComp": 31,
    "skillsLogi": 23,
    "skillsMath": 6,
    "skillsLang": 24,
    "topSkill1": "Digital Technology",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 5,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 1,
    "s5MeasurementandCalculation": 3,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 7,
    "s9ProblemSolving": 7,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 12,
    "s14Writing": 5,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 205,
    "f8Education(teachertraining)": 0,
    "f9Law": 35,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 205,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 35,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 442,
    "noc": 9412,
    "job": "Foundry workers",
    "title1": "ammunition caster � foundry apprentice moulder � foundry automatic casting machine operator � foundry automatic moulding machine operator � foundry bench coremaker � foundry bench moulder bench moulder � foundry brass caster bullet moulder � foundry caster, metal � foundry casting machine operator casting machine operator � foundry casting machine operator, lead centrifugal casting machine operator centrifugal casting machine tender � foundry ceramic mouldmaker ceramic mouldmaker � foundry channel furnace operator � foundry cope and drag pinlift operator � foundry copper caster � foundry core extruder � foundry core machine operator � foundry core oven operator � foundry core oven tender � foundry core room set-up man/woman � foundry core setter � foundry core-blower machine operator � foundry coremaker � foundry coremaker, machine � foundry coremaking machine operator � foundry core-sand-mixer � foundry cupola furnace operator � foundry custom moulder � foundry die-casting machine operator die-casting machine operator � foundry die-casting machine setter � foundry die-casting machine set-up man/woman � foundry die-casting machine tender � foundry dry-sand moulder � foundry electric furnace operator � foundry floor moulder � foundry floor moulder, sand � foundry foundry furnace operator foundry mouldmaker foundry pourer foundry sand mixer foundry worker furnace operator � foundry granular aluminum caster � foundry grid caster � foundry grid-caster operator � foundry hand lead caster � foundry hand mouldmaker � foundry hand sand-core maker � foundry hot-box moulder � foundry hunter machine operator � foundry induction furnace operator � foundry investment caster � foundry iron caster � foundry iron moulder � foundry job moulder � foundry jobbing coremaker jobbing moulder lead caster, hand � foundry lead casting machine operator lead shot caster � foundry lost pattern caster � foundry lost wax caster � foundry machine coremaker machine coremaker � foundry machine moulder � foundry machine-line moulder � foundry manual moulder melter � foundry metal caster metal caster � foundry metal frame moulder � foundry mould caster � foundry mould setter � foundry moulder, bench � foundry moulder, floor � foundry moulder, squeezer � foundry moulding and coremaking machine setter � foundry moulding and coremaking machine set-up man/woman � foundry moulding sand mixer � foundry mouldmaker, hand � foundry ornamental caster � foundry pattern gater pattern moulder � foundry pellet maker � foundry permanent mould operator � foundry pipe coremaker � foundry pit moulder pit moulder � foundry Roto-lift operator � foundry sand control man/woman � foundry sand control operator � foundry sand coremaker sand floor moulder � foundry sand mill operator � foundry sand moulder sand moulder � foundry sand processing operator � foundry sand system operator � foundry sand-core maker, hand � foundry sand-slinger operator � foundry set-up man/woman, core room � foundry shell core maker � foundry shell mould assembler � foundry shell moulder � foundry shot maker � foundry sintering press tender � foundry squeezer machine operator � foundry squeezer moulder � foundry strand operator � foundry vessel operator � foundry wax-pattern assembler and repairer wax-pattern coater wax-pattern moulder wax-pattern mouldmaker white-metal caster � foundry",
    "title2": 0,
    "title3": 0,
    "allTitles": "ammunition caster � foundry apprentice moulder � foundry automatic casting machine operator � foundry automatic moulding machine operator � foundry bench coremaker � foundry bench moulder bench moulder � foundry brass caster bullet moulder � foundry caster, metal � foundry casting machine operator casting machine operator � foundry casting machine operator, lead centrifugal casting machine operator centrifugal casting machine tender � foundry ceramic mouldmaker ceramic mouldmaker � foundry channel furnace operator � foundry cope and drag pinlift operator � foundry copper caster � foundry core extruder � foundry core machine operator � foundry core oven operator � foundry core oven tender � foundry core room set-up man/woman � foundry core setter � foundry core-blower machine operator � foundry coremaker � foundry coremaker, machine � foundry coremaking machine operator � foundry core-sand-mixer � foundry cupola furnace operator � foundry custom moulder � foundry die-casting machine operator die-casting machine operator � foundry die-casting machine setter � foundry die-casting machine set-up man/woman � foundry die-casting machine tender � foundry dry-sand moulder � foundry electric furnace operator � foundry floor moulder � foundry floor moulder, sand � foundry foundry furnace operator foundry mouldmaker foundry pourer foundry sand mixer foundry worker furnace operator � foundry granular aluminum caster � foundry grid caster � foundry grid-caster operator � foundry hand lead caster � foundry hand mouldmaker � foundry hand sand-core maker � foundry hot-box moulder � foundry hunter machine operator � foundry induction furnace operator � foundry investment caster � foundry iron caster � foundry iron moulder � foundry job moulder � foundry jobbing coremaker jobbing moulder lead caster, hand � foundry lead casting machine operator lead shot caster � foundry lost pattern caster � foundry lost wax caster � foundry machine coremaker machine coremaker � foundry machine moulder � foundry machine-line moulder � foundry manual moulder melter � foundry metal caster metal caster � foundry metal frame moulder � foundry mould caster � foundry mould setter � foundry moulder, bench � foundry moulder, floor � foundry moulder, squeezer � foundry moulding and coremaking machine setter � foundry moulding and coremaking machine set-up man/woman � foundry moulding sand mixer � foundry mouldmaker, hand � foundry ornamental caster � foundry pattern gater pattern moulder � foundry pellet maker � foundry permanent mould operator � foundry pipe coremaker � foundry pit moulder pit moulder � foundry Roto-lift operator � foundry sand control man/woman � foundry sand control operator � foundry sand coremaker sand floor moulder � foundry sand mill operator � foundry sand moulder sand moulder � foundry sand processing operator � foundry sand system operator � foundry sand-core maker, hand � foundry sand-slinger operator � foundry set-up man/woman, core room � foundry shell core maker � foundry shell mould assembler � foundry shell moulder � foundry shot maker � foundry sintering press tender � foundry squeezer machine operator � foundry squeezer moulder � foundry strand operator � foundry vessel operator � foundry wax-pattern assembler and repairer wax-pattern coater wax-pattern moulder wax-pattern mouldmaker white-metal caster � foundry",
    "workers": 340,
    "minEduc": 0.666666667,
    "yearsStudy": 1.453296703,
    "automationRisk": 0.906,
    "salaryLow": 14.31,
    "salaryMed": 26.45,
    "salaryHigh": 39.71,
    "totalSkill": 109.1666667,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 20.4064102,
    "skillsComp": 32.33333333,
    "skillsLogi": 28.5,
    "skillsMath": 15.66666667,
    "skillsLang": 32.83333333,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3.333333333,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.166666667,
    "s4JobTaskPlanningandOrganizing": 2.166666667,
    "s5MeasurementandCalculation": 6.833333333,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4.333333333,
    "s8OralCommunication": 10.5,
    "s9ProblemSolving": 8.333333333,
    "s10Reading": 14.66666667,
    "s11SchedulingorBudgetingandAccounting": 2.5,
    "s12DigitalTechnology": 9.5,
    "s13DocumentUse": 19.5,
    "s14Writing": 7.833333333,
    "s15CriticalThinking": 2.666666667,
    "f1Science&Agriculture": 21.66666667,
    "f2Engineering": 68.33333333,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 238.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 5.833333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 3.333333333,
    "f12Business": 2.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 238.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 68.33333333,
    "d11Law": 5.833333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 21.66666667,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3.333333333,
    "d18Business&Commerce": 2.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 443,
    "noc": 9413,
    "job": "Glass forming and finishing machine operators and glass cutters",
    "title1": "annealer - glass products manufacturing",
    "title2": "automatic glass-cutting table operator",
    "title3": "automatic sealing gun operator - glass",
    "allTitles": "annealer - glass products manufacturingautomatic glass-cutting table operatorautomatic sealing gun operator - glassbanding machine tender, glasswarebatch plant tender - glassbeaker testerbeveller, glassbonding machine operator, glassbottle inspector - glass products manufacturingbottle machine operator - glass products manufacturingbottle maker operatorbottle maker operator - glass and glass productsbottle testerdiamond grinder operator - glass finishingdiamond wheel edger - glass finishingdrawing kiln operator - glass formingdrill operator, glassedger, glassenamel burner - glass products manufacturingenamelling furnace operator - glass products manufacturingenamelware paint baker - glass products manufacturingfloat chief operator - glass formingfloat operator - glass formingforming-cutting operator - glass productsgatherer - glass products manufacturingglass-annealing furnace tenderglass benderglass bevellerglass beveller operatorglass beveller tenderglass-blowing lathe operatorglass-blowing machine operatorglass-blowing machine setterglass breakerglass bufferglass chipperglass-coating line operatorglass cut-off machine operatorglass cutterglass cutter-framerglass cutter, handglass cutter operatorglass-decorating machine operatorglass-drawing machine operatorglass drill tenderglass edge finisher, handglass edgerglass edger operatorglass edger tenderglass-edging machine feederglass etcherglass finisherglass-finishing machine operatorglass-forming machine operatorglass-forming machine setterglass-forming machine set-up personglass forming operatorglass forming specialistglass furnace operatorglass furnace setter-operatorglass furnace set-up operatorglass grinderglass-grinding machine feederglass heaterglass laminatorglass lathe operatorglass lehr attendantglass lehr operatorglass lehr tenderglass markerglass melterglass mixerglass mould cleanerglass moulderglass mould polisherglass polisherglass polisher tenderglass presserglass-pressing and glass-blowing machine operatorglass-pressing machine operatorglass-silvering machine operatorglass spin mould machine set-up operatorglass-stopper grinderglass tank furnace operatorglass tempererglass-tempering furnace operatorglass-tube-expander operatorglassware-banding machine tenderglassware-decorating machine operatorglassware grinderglass windshield autoclave operatorglass worker - glass products manufacturinggroove grinder - glasshand finisher, glass edgeshand glass edge finisherheater, glassmachine operator - glass forming and finishingmirror makermirror silverermirror-silvering equipment operator",
    "workers": 45,
    "minEduc": 1,
    "yearsStudy": 1,
    "automationRisk": 0.9,
    "salaryLow": 14.0775,
    "salaryMed": 22.1725,
    "salaryHigh": 35.8925,
    "totalSkill": 111,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.7313629,
    "skillsComp": 36,
    "skillsLogi": 33,
    "skillsMath": 16,
    "skillsLang": 26,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Reading",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 14,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 10,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 3,
    "s13DocumentUse": 31,
    "s14Writing": 4,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 45,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 45,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 444,
    "noc": 9414,
    "job": "Concrete, clay and stone forming operators",
    "title1": "abrasive mixer - stone products",
    "title2": "abrasive products kiln fireman - non-metallic mineral products",
    "title3": "abrasive products kiln fireman/woman - non-metallic mineral products",
    "allTitles": "abrasive mixer - stone productsabrasive products kiln fireman - non-metallic mineral productsabrasive products kiln fireman/woman - non-metallic mineral productsabrasive products kiln firewoman - non-metallic mineral productsabrasives furnace preparer - stone productsabrasive wheel grinderabrasive wheel grinder, rubberabrasive wheel makerabrasive wheel maker, diamondabrasive wheel maker, rubberabrasive wheel moulderasbestos board curerasbestos board machine operatorasbestos board machinery setterasbestos mixer tenderasbestos shingle assemblerasbestos shingle cutterasbestos shingle makerasbestos shingle presserassembler, asbestos shinglesauger machine operator, drain tiles - clay productsautomatic jigger man - clay productsautomatic jigger man/woman - clay productsautomatic jigger operator - clay productsautomatic jigger woman - clay productsbaker, bricks - clay productsbender, clay pipesbeveller, stonesbisque kiln operator - clay productsblock cuber - concrete, clay and stone productsblock machine operator - concrete, clay and stone productsblock maker, cement - concrete productsblock maker, concreteblock maker, stoneworkblock-making machine operator - concrete, clay and stone productsblock-making machine tender - concrete, clay and stone productsblock moulder, cement - concrete productsboat builder, quartz - stone productsboring mill operator - concrete productsbrake lining finisher, asbestosbrick and tile caster - clay productsbrick and tile-making machine operator - clay productsbrick baker - clay productsbrick burner - clay productsbrick cutter - clay productsbrick-cutting machine operator - clay productsbrick kilnman - clay productsbrick kilnman/woman - clay productsbrick kiln operator - clay productsbrick kilnwoman - clay productsbrick machine set-up operator - clay productsbrick maker - clay productsbrick moulder - clay productsbrick moulder, hand - clay productsbrick-moulding machine operator - clay productsbrick presser - clay productsbrick presser operatorbrush coater operator - concrete productsbuffer, stone productsbuilder, insulators - clay productsburial vault maker, concreteburner, bricks - clay productscarbon planer tender - stone productscarver, granitecarver, marble - concrete, clay and stone formingcarver, monuments - stone productscaster, bricks and tiles - clay productscaster, concrete mixercaster - concrete productscaster, pottery and porcelain warecaster, scagliola - stone productscement block maker - concrete productscement block moulder - concrete productscement pipe shaper, machine - clay productscement pipe shaper operator - concrete productscement polisherceramic tile press operator - concrete productschipper, pottery and porcelaincinder block machine operator - concrete productscircular saw operator - concrete, clay and stone productsclay dry press operatorclay insulator builder - clay productsclay pipe benderclay press operatorclay products machine operatorclay products moulderclay products moulder, handclay products polisherclay structure moulder and installerclay temperer - clay productsclayware drillerclayware turnerclaywork moulderconcrete block machine operatorconcrete block makerconcrete burial vault makerconcrete fittings makerconcrete hydraulic press operatorconcrete mixer casterconcrete mixer-caster",
    "workers": 20,
    "minEduc": 1,
    "yearsStudy": 1,
    "automationRisk": 0.9,
    "salaryLow": 14,
    "salaryMed": 20.25,
    "salaryHigh": 35,
    "totalSkill": 88,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 20.25,
    "skillsComp": 20,
    "skillsLogi": 25,
    "skillsMath": 18,
    "skillsLang": 25,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 9,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 7,
    "s9ProblemSolving": 8,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 3,
    "s13DocumentUse": 15,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 20,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 20,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 445,
    "noc": 9415,
    "job": "Inspectors and testers, mineral and metal processing",
    "title1": "abrasive and clay products grader",
    "title2": "abrasive wheel tester",
    "title3": "anode adjuster - primary metal processing",
    "allTitles": "abrasive and clay products graderabrasive wheel testeranode adjuster - primary metal processingasbestos classifierasbestos fibre inspector and testerasbestos graderasbestos shingle inspectorbrick and tile inspectorbrick and tile testerbrick gradercasting inspectorcastings inspector - foundrycastings tester - primary metal and mineral products processingcell tester - primary metal processingcement plant inspectorclay products graderclay tile grader - mineral products processingcoke inspector - primary metal processingcoke sampler and tester - primary metal processingcombustion tester, furnace - primary metal processingconcrete products inspectorconcrete products testercontainer tester, glasscore inspector - foundrycore tester - foundryelectrolytic cell tester - primary metal processingevaluator, uranium orefibreglass testerfinishing inspector - primary metal and mineral products processingfoundry sand testerglass container testerglass inspectorglass quality control inspectorglass testergrader, abrasive and clay productsgrader, asbestosgrader, bricksgrader, clay productsgrader, clay tiles - mineral products processinggrader, stoneworkgravel grader - mineral products processinghardness tester - primary metal processingheat treating inspectorheat treating inspector - metal processingingots inspector - primary metal processinginspector and grader, tin platesinspector, asbestos shinglesinspector, bricks and tilesinspector, castings - foundryinspector, glassinspector, heat treating - metal processinginspector, ingots - primary metal processinginspector - metal processinginspector, metal processinginspector, pottery and porcelain wareinspector - primary metal and mineral products processinginspector, sheet steel - primary metal processinginspector, steel - primary metal processinginspector, steel sheets - primary metal processinginspector, stones - mineral products processinginspectors, wire productsiron pellet hardness tester - metal processinglaminated asbestos products inspectormetal processing inspectormetal strength tester - primary metal processingmetal tensile strength tester - primary metal processingmineral samplermineral sampler - mineral products processingmolten metal samplermolten metal sampler - primary metal processingmonument inspector - mineral products processingore sampler - mineral products processingore sample tester - mineral products processingphysical tester - steel millplasterboard inspector - mineral products processingpottery and porcelain ware inspectorquality assurance inspector - steel millquality control inspector, glasssalvage glass inspectorsampler and tester, coke - primary metal processingsampler, minerals - mineral products processingsampler, molten metal - primary metal processingsampler - primary metal and mineral products processingsample tester - primary metal and mineral products processingsand tester, foundrysheet and plate inspector - steel millsheet steel inspectorsheet steel inspector - primary metal processingsteel inspector - primary metal processingsteel sheet inspectorsteel sheet inspector - primary metal processingsteel testersteel tester - primary metal processingstone inspector - mineral products processingtensile strength tester, metal - primary metal processingtester and inspector - primary metal and mineral products processingtester and inspector, wires - primary metal processingtester, bricks and tilestester, castings - primary metal and mineral products processingtester, cells - primary metal processing",
    "workers": 40,
    "minEduc": 1,
    "yearsStudy": 1.5,
    "automationRisk": 0.98,
    "salaryLow": 14,
    "salaryMed": 23.96,
    "salaryHigh": 41.86,
    "totalSkill": 125,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 23.96,
    "skillsComp": 39,
    "skillsLogi": 28,
    "skillsMath": 17,
    "skillsLang": 41,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 11,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 6,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 23,
    "s14Writing": 11,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 25,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 25,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 446,
    "noc": 9416,
    "job": "Metalworking and forging machine operators",
    "title1": "acetylene torch operator � metal fabrication air hammer operator � metal forging aluminum sheet cutter � ductwork aluminum sheet cutter � metal fabrication aluminum sheet trimmer � ductwork angle shear operator � metal fabrication arc cutter � metal fabrication automatic cut-off operator � metal fabrication automatic cut-off saw operator � metal products manufacturing bender set-up operator � metal products manufacturing bending machine operator � metal forging bending machine set-up operator � metal fabrication bending machine tender � metal fabrication bending machine tender � metal products manufacturing bending press operator � metal fabrication bending roll operator � metal fabrication board drop hammer operator board hammer operator � metal forging brake setter � metalworking buffing line setter buffing machine set-up operator � metal fabrication burning machine operator � metal fabrication burning table operator � metal fabrication cage builder � metal fabrication CNC (computer numerically controlled) brake press operator CNC (computer numerically controlled) brake press set-up operator cold drawn operator � metal forging cold press operator � metal forging corrugation machine operator, sheet metal corrugator sheet metal operator disc flanging operator � metal fabrication disk flange operator disk flange operator � metal fabrication drop forge hand drop forge operator drop forge operator � metal forging drop forger drop hammer forger drop hammer operator � metal forging dual action hammer operator � metal forging duplicator punch operator � metal fabrication electric arc cutter � metal products manufacturing expanding machine operator � metal products manufacturing flame cutting machine operator � metal fabrication flame cutting tracer machine operator � metal fabrication flame hardening machine setter flying shear operator � metal fabrication forge manipulator operator forging air hammer operator forging machine operator forging machine setter forging machine set-up man/woman forging press operator forging press tender forging roll operator forming machine operator � metal fabrication forming press operator � metal fabrication forming roll set-up operator � metal fabrication forming roll tender � metal fabrication group leader, forging machine operator hammer driver � forging hammer operator � metal forging heater operator � metal forging heavy forger heavy-duty press set-up operator � metal fabrication hoop bender hoop-maker machine operator � metal fabrication hot press operator � metal forging hydraulic press operator � metal fabrication impact hammer operator � metal forging impression die press operator � metal fabrication laser cutter � metal fabrication lay-out marker � metal products manufacturing lead fabricator lead hand, forging machine operators leaf spring inspector leaf spring maker � metal fabrication machine power saw operator magnetic flame cutting machine operator � metal fabrication manipulator operator � metal forging mechanical press operator � metal products manufacturing metal cut-off saw operator metal fabricating machine operator metal parts inspector metal power saw operator metal sawing machine operator metal spinner metal table saw operator metal-forming machine set-up operator metal-forming machine tender metal-stamping press operator metalworking machine operator metalworking machine setter metalworking machine set-up man/woman metalworking machine set-up operator multi-operation forming machine tender multiple punch press operator � metal fabrication musical instrument tube bender nibbling machine operator � metal fabrication ornamental metal worker � metal fabrication pantograph burner � metal fabrication pantograph flame cutter � metal fabrication pipe-bending machine operator � metal fabrication plate burner � metal fabrication plate shear operator � metal fabrication power brake operator � metal fabrication power hammer operator � metal forging power press operator power press operator � metal fabrication power press operator � metal products manufacturing power press set-up operator � metal fabrication power shear operator � metal fabrication power shear tender � metal fabrication press brake operator press brake operator � metal products manufacturing press tender � pierce and shave punch and shear machine operator � metal fabrication punch press operator punch press operator � metal fabrication punch press setter � metalworking puncher and shearer � metal products manufacturing restrike hammer operator � metal forging ring mill operator � metal forging rod-bending machine operator � metal fabrication roll bender operator � metal products manufacturing roll forger roll operator � metal fabrication roll-forming machine setter � metalworking rolling machine operator � metal forging rotary shear operator � metal fabrication saw operator � metal fabrication shear operator shear operator � metal fabrication shear setter � metal fabrication shearer � metal working sheet metal brake tender sheet metal corrugator sheet metal cutter � metal fabrication sheet metal fabrication inspector sheet metal roll operator � metal fabrication sheet metal spinner � metal fabrication sheet-metal-embossing machine operator sheet-metal-working machine operator � metal products manufacturing sheet-metal-working machine set-up operator sheet-metal-working machine tender � metal fabrication slide forming machine setter � metal fabrication slide forming machine set-up operator slide forming machine tender � metal fabrication steam hammer operator � metal forging steel shot machine operator straight line press setter � metal fabrication straightener hand � metal fabrication straightening press operator � metal fabrication strip-roll-forming machine operator � metal fabrication strip-roll-forming machine tender � metal fabrication threader � metal products manufacturing trip hammer operator � metal forging tube-bending machine operator � metal fabrication tubular metal products fabricator turret press operator turret press set-up operator turret punch press operator � metal fabrication upsetter operator � metal forging upsetting machine operator � metal forging vehicle spring repairer � metal forging vertical press operator vertical press operator � metal fabrication vertical roll operator � metal fabrication",
    "title2": 0,
    "title3": 0,
    "allTitles": "acetylene torch operator � metal fabrication air hammer operator � metal forging aluminum sheet cutter � ductwork aluminum sheet cutter � metal fabrication aluminum sheet trimmer � ductwork angle shear operator � metal fabrication arc cutter � metal fabrication automatic cut-off operator � metal fabrication automatic cut-off saw operator � metal products manufacturing bender set-up operator � metal products manufacturing bending machine operator � metal forging bending machine set-up operator � metal fabrication bending machine tender � metal fabrication bending machine tender � metal products manufacturing bending press operator � metal fabrication bending roll operator � metal fabrication board drop hammer operator board hammer operator � metal forging brake setter � metalworking buffing line setter buffing machine set-up operator � metal fabrication burning machine operator � metal fabrication burning table operator � metal fabrication cage builder � metal fabrication CNC (computer numerically controlled) brake press operator CNC (computer numerically controlled) brake press set-up operator cold drawn operator � metal forging cold press operator � metal forging corrugation machine operator, sheet metal corrugator sheet metal operator disc flanging operator � metal fabrication disk flange operator disk flange operator � metal fabrication drop forge hand drop forge operator drop forge operator � metal forging drop forger drop hammer forger drop hammer operator � metal forging dual action hammer operator � metal forging duplicator punch operator � metal fabrication electric arc cutter � metal products manufacturing expanding machine operator � metal products manufacturing flame cutting machine operator � metal fabrication flame cutting tracer machine operator � metal fabrication flame hardening machine setter flying shear operator � metal fabrication forge manipulator operator forging air hammer operator forging machine operator forging machine setter forging machine set-up man/woman forging press operator forging press tender forging roll operator forming machine operator � metal fabrication forming press operator � metal fabrication forming roll set-up operator � metal fabrication forming roll tender � metal fabrication group leader, forging machine operator hammer driver � forging hammer operator � metal forging heater operator � metal forging heavy forger heavy-duty press set-up operator � metal fabrication hoop bender hoop-maker machine operator � metal fabrication hot press operator � metal forging hydraulic press operator � metal fabrication impact hammer operator � metal forging impression die press operator � metal fabrication laser cutter � metal fabrication lay-out marker � metal products manufacturing lead fabricator lead hand, forging machine operators leaf spring inspector leaf spring maker � metal fabrication machine power saw operator magnetic flame cutting machine operator � metal fabrication manipulator operator � metal forging mechanical press operator � metal products manufacturing metal cut-off saw operator metal fabricating machine operator metal parts inspector metal power saw operator metal sawing machine operator metal spinner metal table saw operator metal-forming machine set-up operator metal-forming machine tender metal-stamping press operator metalworking machine operator metalworking machine setter metalworking machine set-up man/woman metalworking machine set-up operator multi-operation forming machine tender multiple punch press operator � metal fabrication musical instrument tube bender nibbling machine operator � metal fabrication ornamental metal worker � metal fabrication pantograph burner � metal fabrication pantograph flame cutter � metal fabrication pipe-bending machine operator � metal fabrication plate burner � metal fabrication plate shear operator � metal fabrication power brake operator � metal fabrication power hammer operator � metal forging power press operator power press operator � metal fabrication power press operator � metal products manufacturing power press set-up operator � metal fabrication power shear operator � metal fabrication power shear tender � metal fabrication press brake operator press brake operator � metal products manufacturing press tender � pierce and shave punch and shear machine operator � metal fabrication punch press operator punch press operator � metal fabrication punch press setter � metalworking puncher and shearer � metal products manufacturing restrike hammer operator � metal forging ring mill operator � metal forging rod-bending machine operator � metal fabrication roll bender operator � metal products manufacturing roll forger roll operator � metal fabrication roll-forming machine setter � metalworking rolling machine operator � metal forging rotary shear operator � metal fabrication saw operator � metal fabrication shear operator shear operator � metal fabrication shear setter � metal fabrication shearer � metal working sheet metal brake tender sheet metal corrugator sheet metal cutter � metal fabrication sheet metal fabrication inspector sheet metal roll operator � metal fabrication sheet metal spinner � metal fabrication sheet-metal-embossing machine operator sheet-metal-working machine operator � metal products manufacturing sheet-metal-working machine set-up operator sheet-metal-working machine tender � metal fabrication slide forming machine setter � metal fabrication slide forming machine set-up operator slide forming machine tender � metal fabrication steam hammer operator � metal forging steel shot machine operator straight line press setter � metal fabrication straightener hand � metal fabrication straightening press operator � metal fabrication strip-roll-forming machine operator � metal fabrication strip-roll-forming machine tender � metal fabrication threader � metal products manufacturing trip hammer operator � metal forging tube-bending machine operator � metal fabrication tubular metal products fabricator turret press operator turret press set-up operator turret punch press operator � metal fabrication upsetter operator � metal forging upsetting machine operator � metal forging vehicle spring repairer � metal forging vertical press operator vertical press operator � metal fabrication vertical roll operator � metal fabrication",
    "workers": 340,
    "minEduc": 0.666666667,
    "yearsStudy": 1.453296703,
    "automationRisk": 0.906,
    "salaryLow": 14.0775,
    "salaryMed": 22.1725,
    "salaryHigh": 35.8925,
    "totalSkill": 109.1666667,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 20.4064102,
    "skillsComp": 32.33333333,
    "skillsLogi": 28.5,
    "skillsMath": 15.66666667,
    "skillsLang": 32.83333333,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3.333333333,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.166666667,
    "s4JobTaskPlanningandOrganizing": 2.166666667,
    "s5MeasurementandCalculation": 6.833333333,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 4.333333333,
    "s8OralCommunication": 10.5,
    "s9ProblemSolving": 8.333333333,
    "s10Reading": 14.66666667,
    "s11SchedulingorBudgetingandAccounting": 2.5,
    "s12DigitalTechnology": 9.5,
    "s13DocumentUse": 19.5,
    "s14Writing": 7.833333333,
    "s15CriticalThinking": 2.666666667,
    "f1Science&Agriculture": 21.66666667,
    "f2Engineering": 68.33333333,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 238.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 5.833333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 3.333333333,
    "f12Business": 2.5,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 238.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 68.33333333,
    "d11Law": 5.833333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 21.66666667,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 3.333333333,
    "d18Business&Commerce": 2.5,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 447,
    "noc": 9417,
    "job": "Machining tool operators",
    "title1": "aircraft engine parts machine tool set-up operator",
    "title2": "aircraft parts etcher",
    "title3": "automated machine tool set-up operator",
    "allTitles": "aircraft engine parts machine tool set-up operatoraircraft parts etcherautomated machine tool set-up operatorautomatic screw machine operatorautomatic transfer machine operator - metal machiningaxle lathe operatorbarrel riflerbarrel threader, small armsbearing borerbearing grinderbench set-up operator, machine toolbolt threaderbolt-threading machine operatorborer - metal machiningboring machine operator - metal machiningboring mill operator - metal machiningboring mill set-up operator - metal machiningbrake drum lathe operatorbroacher, production - metal machiningbroaching machine operator - metal machiningbroaching machine set-up operator - metal machiningBullard multiple-spindle lathe operatorcamming machine operator - metal machiningcentreless cylindrical-grinder operatorcentreless cylindrical grinder set-up operatorcentreless grinder operatorcentreless grinder set-up operatorchucking machine set-up operatorCNC (computer numerical control) lathe operator - metal machiningCNC (computer numerical control) machining tool operatorCNC (computer numerical control) profile mill operatorCNC (computer numerically controlled) machine set-up operator - metal machiningCNC (computer numerically controlled) machining centre operatorCNC machining tool operatorcomputer numerically controlled (CNC) machine set-up operator - metal machiningcomputer numerically controlled (CNC) machining centre operatorconnecting rod borercountersinker - metal machiningcustom screw machine operatorcutlery and tool etchercylinder grinder - metal machiningcylinder honer - metal machiningdiesinking machine set-up operatordrilling and milling machine operator - metal machiningdrilling machine operator - metal machiningdrill press operator - metal machiningdrill press set-up operator - metal machiningEDM (electrical discharge machine) operatorEDM (electrical discharge machine) set-up operatorEDM (electrical discharge machine) tenderelectrical discharge machine (EDM) operatorelectrical discharge machine (EDM) tenderelectrochemical machining tool operatorelectrolytic etcher - metal machiningengine lathe set-up operatoretcher, aircraft partsetcher, electrolytic - metal machiningetcher, firearmsexternal cylindrical-grinder operatorexternal cylindrical grinder set-up operatorfile cutter - metal machiningfile maker - metal machiningfirearms etchergear cuttergear-cutting machine set-up operatorgear-cutting machine tendergear grindergear-grinding machine set-up operatorgear hobber set-up operatorgear-hobbing machine set-up operatorgear-hob-milling machine set-up operatorgear-lapping machine operatorgear-lapping machine set-up operatorgear-milling machine operatorgear-milling machine set-up operatorgear roller grindergear-rolling machine operatorgear-shaper operatorgear-shaving machine set-up operatorgeneral machine tool set-up operatorgrinder, cylinders - metal machininggrinder, metal saw teethgrinder, printing rollersgrinder set-up operator - metal machininggrooving machine set-up operator - metal machininghand filer, tools - metal machininghand lapper - metal machiningheavy chucking lathe operator - metal machininghoning machine operator - metal machininghoning machine set-up operator - metal machininghorizontal boring and milling machine set-up operatorimpressing machine tender - metal machiningjig grinder set-up operatorkeyseater operatorkeyseater set-up operatorkeyseating machine operatorlapper, hand - metal machininglapping machine operatorlapping machine set-up operatorlapping machine tender",
    "workers": 1515,
    "minEduc": 0,
    "yearsStudy": 2.076923077,
    "automationRisk": 0.879,
    "salaryLow": 14.0775,
    "salaryMed": 22.1725,
    "salaryHigh": 35.8925,
    "totalSkill": 128,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 20.54172635,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 18,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 105,
    "f2Engineering": 385,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 1005,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 1005,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 385,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 105,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 448,
    "noc": 9418,
    "job": "Other metal products machine operators",
    "title1": "asbestos wire finisher",
    "title2": "assembler and tester, wire cables",
    "title3": "assembler, wire mesh gates",
    "allTitles": "asbestos wire finisherassembler and tester, wire cablesassembler, wire mesh gatesautomatic bolt machine operatorautomatic coiling machine operator - metal products manufacturingautomatic coil machine operatorautomatic machine polisher, metalaxle cutterbarbed wire machine tenderbasket maker, wirebeading machine operator - metal products manufacturingbench loom wire weaverbolt header operatorbolt machine operatorbolt makerbraider tenderbraiding machine tender - wire products manufacturingbuckshot swage operatorbullet cutter and formerbullet makerbullet shaper, machine - metal products manufacturingbullet-shaping machine tenderbullet-swaging machine adjusterbullet-swaging machine setter - metal products manufacturingbunching machine operatorcable armourercable-braiding machine operatorcable insulatorcable maker, metalcage maker - wire products manufacturingcan-forming machine operatorcan inspector - metal products manufacturingcan machine operatorcan machine settercan-making machine operatorcan-making machine settercarbide press tendercartridge primers drop testerchain inspectorchain-link fence machine operatorchain maker, machinechain-making machine feederchain-making machine operatorchain-making machine tenderchain testerchain tester, machinechain-testing machine tenderchamfering and boring machine operator - metal products manufacturingchamfering machine tenderchandelier makercoiler, hot-wound springscoiler - metal products manufacturingcoiler, springscoiler, valve springscoiling machine operator - metal products manufacturingcoil machine operatorcoil-rewind machine tendercoil spring machine tendercrimping machine feeder - wire products manufacturingcrimping machine operator, wirescutter and former, bullets - metal products manufacturingcutter, nut diskscylinder roll fabricatordrop tester, cartridge primersembossing machine tender - explosives manufacturingextruder operator, welding rodsextruder tender, welding rodsfeeder, knurling machinefence-making machine operator, wire meshfinisher, asbestos-covered wiresfixture maker, plating equipmentfoil rewinderformer, metal nutsformer, wire screensframe machine operator, tentsgrid machine job setterheader machine operator - metalhoop-making machine operatorhoop-punching and hoop-coiling machine operator - metal products manufacturinghoop-riveting machine operatorhot-wound spring coilerindustrial knitting needle machine feederindustrial needle machine setter-operatorindustrial needle machine set-up operatorindustrial needle makerinspector, cans - metal products manufacturinginspector, chainsinspector, springsinspector, tin caninsulation machine operatorinsulator, cablesknife blade polisherknitter, wire meshknurling machine feederlampshade frame maker, wirelattice weaver, wirelink wire machine set-up operatorlink wire machine tenderloom setter, wiresloom setter, wire weaving",
    "workers": 180,
    "minEduc": 0,
    "yearsStudy": 1.714285714,
    "automationRisk": 0.894,
    "salaryLow": 14,
    "salaryMed": 18.03,
    "salaryHigh": 27,
    "totalSkill": 119,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 18.03,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 25,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 140,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 15,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 140,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 25,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 15,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 449,
    "noc": 9421,
    "job": "Chemical plant machine operators",
    "title1": "acetylene plant attendant",
    "title2": "acid pumper - chemical processing",
    "title3": "acidulation plant tender",
    "allTitles": "acetylene plant attendantacid pumper - chemical processingacidulation plant tenderasphalt coater - chemical processingasphalt heater tenderasphalt plant dryer tenderasphalt roofing material mixerasphalt roofing materials inspectorautoclave operator - chemical processingbacking-in machine tenderbatch mixer - chemical processingbatch still operatorbattery acid adjusterbattery paste makerbattery paste mixerblack powder grainer and glazier tenderblack powder press tenderbleacher, oilsbleaching solution makerblender - chemical processingblender, glues - chemical processingblender operator - chemical processingcadmium liquor makercalciner tendercapsule filler - chemical processingcapsule machine operatorcapsule machine operator - chemical processingcarbon black pelletizercarbon paste mixer operatorcellulose film caster - chemical processingcellulose film dry-end tendercellulose film rewindercellulose film wet-end tendercentrifugal separator tender - chemical processingcentrifuge tender - chemical processingcharcoal burnerchemical operator, chemical-processingchemical plant machine operatorchiller operator - chemical processingchiller tender - chemical processingcleaning compounds mixercoater, asphaltcoating compounds mixer - chemical processingcoating machine operator - chemical processingcoating machine tender - chemical processingcoatings mixer - chemical processingcoke by-products pump operator - chemical processingcolour grinder tender - chemical processingcolour matcher - chemical processingcolour mixer, prints - chemical processingcolour weigher and mixercomposition mixer - chemical processingcompounder - chemical processingcompounder, latexcooker - chemical processingcosmetics and perfume makercrusher tender - chemical processingcrutcher operator - chemical processingcrystallizer tender - chemical processingdehydrating press tender - chemical processingdetergent and powdered soap screener-perfumerdevulcanizer tenderdigester operator - chemical processingdistiller operator - soda ash processingdistiller, wood distillation and charcoaldrug and toilet goods weigherdrum filler, liquefied gasesdry-end tender, cellulose filmsdryer operator - chemical processingdryer operator, soap flakesdryer tender, asphalt plantdryer tender - chemical processingdryer tender, nitrocellulosedry explosive mixerdryhouse attendant - chemical processingdryhouse tender, explosive primers - chemical processingDry Ice makerdye makerelectrode oven operatorevaporator operator - chemical processingexplosive primers dryhouse attendant - chemical processingexplosive primers dryhouse tender - chemical processingexplosives mixerexplosives mixer tenderextractor operator, phenolextractor operator, phosphoric acidfertilizer mixerfibreglass binder mixerfilter press tender - chemical processingflaker tender - chemical processingformulation blender operator, pesticidesformulations blender operatorformulations blender operator - chemical processingfurnace coolerfuse maker - chemical processingglue blendergraining press operator - chemical processinggranulator machine operatorgranulator machine operator - chemical processinggrinder tender - chemical processing",
    "workers": 4810,
    "minEduc": 0,
    "yearsStudy": 3.431192661,
    "automationRisk": 0.57,
    "salaryLow": 14,
    "salaryMed": 18,
    "salaryHigh": 26.39,
    "totalSkill": 133,
    "industry": "Natural & applied sciences",
    "industryNum": 6,
    "sector": "Technical occupations related to natural and applied sciences",
    "cluster": 6,
    "wage": 25,
    "skillsComp": 39,
    "skillsLogi": 36,
    "skillsMath": 13,
    "skillsLang": 45,
    "topSkill1": "Critical Thinking",
    "topSkill2": "Document Use",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 1,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 2,
    "s7NumericalEstimation": 2,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 5,
    "s10Reading": 20,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 21,
    "s14Writing": 12,
    "s15CriticalThinking": 22,
    "f1Science&Agriculture": 60,
    "f2Engineering": 20,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 95,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 35,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 95,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 20,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 60,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 35,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 450,
    "noc": 9422,
    "job": "Plastics processing machine operators",
    "title1": "arch cushion press operator - plastic manufacturing",
    "title2": "bag machine operator",
    "title3": "bag-making machine operator - plastic manufacturing",
    "allTitles": "arch cushion press operator - plastic manufacturingbag machine operatorbag-making machine operator - plastic manufacturingbakelite mixer operator - plastic manufacturingbanbury mixer operator - plastic manufacturingbanbury operator - plastic manufacturingblender operator - plastic manufacturingblow moulder operator - plastic manufacturingblow moulding machine operatorblow moulding machine operator - plastic manufacturingblow-moulding process operator - plastic manufacturingcake press operator - plastic manufacturingcalendering machine tender - plastic manufacturingcalender operator, multi-roll - plastic manufacturingcalender operator - plastic manufacturingcalender wind-up tender - plastic manufacturingcaster - plastic manufacturingcasting room operator - plastic manufacturingcellophane bag machine operator - plastic manufacturingcellophane bag maker - plastic manufacturingcellophane making worker - plastic manufacturingcoagulator, plasticscompounder, plasticscompounder, plastics and plastic productscompression moulder - plastic manufacturingencapsulator - plastic manufacturingextruder operator - plastic manufacturingextruder operator, plastic pipesextruding machine operator - plastic manufacturingextrusion blow moulding operatorextrusion machine operator - plastic manufacturingfibreglass machine operator - plastic manufacturingfibreglass moulderfibreglass-spraying machine operatorflatbed press operator - plastic manufacturingfoam plastic-producing machine operatorfoam plastic-spraying machine operatorfootwear presser - plastic manufacturinggel coat sprayer operator - plastic manufacturinggrinder operator - plastic manufacturingheat-sealing machine tender - plastic manufacturingimprinting machine tender, plasticsinjection blow moulding processing operatorinjection molding set-up operatorinjection moulder operator - plastic manufacturinginjection moulder - plastic manufacturinginjection-moulding machine operator - plastic manufacturinginjection moulding operatorinjection moulding operator - plastic manufacturinginjection moulding processing operatorinjection operator - plastic manufacturinginjection plastic moulderlaminating machine tender - plastic manufacturinglead operator, blow-moulding machine - plastic manufacturinglead operator, injection-moulding machine - plastic manufacturinglinoleum floor tile backerlinoleum floor tile calender operatormachine operator - plastic manufacturingmachine operator - plastics processingmachine set-up operator - plastic manufacturingmannequin moulder - plastic manufacturingmixer operator, solutions - plastic manufacturingmoulder, compression - plastic manufacturingmoulder, fibreglassmoulder operator - plastic manufacturingmoulder, plastic mannequins - plastic manufacturingmoulder, printing rollers - plastic manufacturingmoulding machine operator, injection - plastic manufacturingmoulding operator, injection - plastic manufacturingmould setter, plasticmultiple extruder operator - plastic manufacturingneoprene sprayer operator - plastic manufacturingoperator, blender - plastic manufacturingoperator, fibreglass-spinning machine - plastic manufacturingoperator, fibreglass-spraying machineoperator, flatbed press - plastic manufacturingoperator, foamed-plastic-producing machineoperator, gel coat sprayer - plastic manufacturingoperator, injection moulding - plastic manufacturingoperator, moulder - plastic manufacturingoperator, pipe extrusion machine - plastic manufacturingoperator, plastic footwear moulderpipe extrusion machine operator - plastic manufacturingplasticator operatorplastic bag machine operatorplastic bag maker operatorplastic centrifugal casterplastic coagulation operatorplastic coagulatorplastic compounderplastic extruder operatorplastic-extrusion operatorplastic-fibre-extruding machine tenderplastic-film extrusion machine operatorplastic film roll inspectorplastic footwear moulder operatorplastic mannequin moulder - plastic manufacturingplastic mixer operatorplastic moulder, compressionplastic moulder, injection",
    "workers": 2175,
    "minEduc": 0.5,
    "yearsStudy": 2.284290271,
    "automationRisk": 0.923,
    "salaryLow": 14,
    "salaryMed": 15.5,
    "salaryHigh": 27.69,
    "totalSkill": 103,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 16.25,
    "skillsComp": 30.5,
    "skillsLogi": 26.5,
    "skillsMath": 15.5,
    "skillsLang": 30.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 8,
    "s10Reading": 12.5,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 6,
    "s13DocumentUse": 20.5,
    "s14Writing": 7.5,
    "s15CriticalThinking": 2.5,
    "f1Science&Agriculture": 125,
    "f2Engineering": 310,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 20,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 545,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 35,
    "f11Health,Nursing&ClinicalLaboratory": 20,
    "f12Business": 195,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 20,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 545,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 310,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 35,
    "d14Theology": 0,
    "d15PhysicalSciences": 125,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 20,
    "d18Business&Commerce": 195,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 451,
    "noc": 9423,
    "job": "Rubber processing machine operators and related workers",
    "title1": "airbag and tube curer - rubber products manufacturing",
    "title2": "airbag builder - rubber products manufacturing",
    "title3": "air brake hose builder - rubber products manufacturing",
    "allTitles": "airbag and tube curer - rubber products manufacturingairbag builder - rubber products manufacturingair brake hose builder - rubber products manufacturingaircraft tire tube builder - rubber products manufacturingarch-cushion-skiving machine operatorassembler, rubber goodsassembler, rubber sponge gasketsassembly line tire repairerassembly line tire repairmanassembly line tire repairwomanautomotive rubber parts cutterback strip machine tender - rubber products manufacturingbanbury machine operator - rubber products manufacturingbanbury mixer operator - rubber products manufacturingbanbury operator - rubber products manufacturingband assembler - rubber products manufacturingband stock preparer - rubber products manufacturingbead-forming machine operator - rubber products manufacturingbeading machine operator - rubber products manufacturingbelt brander - rubber products manufacturingbelt buffer, rubberbelt builder, rubberbelt maker, rubberbias cutter - rubber products manufacturingbias cutting operator - rubber products manufacturingbladder moulder - rubber products manufacturingblow-out and test operator - rubber productsbonder - rubber products manufacturingbonding press tender - rubber products manufacturingboot cutter, rubberboot maker, rubberbraider operator - rubber products manufacturingbraiding machine tender - rubber products manufacturingbuffer, rubber beltsbuilder, rubber drumsbuilder, rubber V-beltscalender let-off operator - rubber products manufacturingcalender machine operator - rubber products manufacturingcalender operator - rubber products manufacturingcalender roll warmer - rubber products manufacturingcalender wind-up tender - rubber products manufacturingcementer operator - rubber products manufacturingcementer - rubber products manufacturingchafer buildercogger, rubber beltscontinuous mixer operator - rubber products manufacturingconveyor belt splicer - rubber products manufacturingcoverer, rubber V-beltscracker operator - rubber products manufacturingcross head operator - rubber products manufacturingcured tire repairercured tire repairmancured tire repairwomancure operator - rubber products manufacturingcurer, rubbercurer, rubber flapscurer, rubber V-beltscuring machine operator - rubber products manufacturingcuring man - rubber products manufacturingcuring man/woman - rubber products manufacturingcuring press set-up operator - rubber products manufacturingcuring press tender - rubber products manufacturingcuring woman - rubber products manufacturingcutter, heels - rubber footwear manufacturingcutter, rubbercutter, rubber bootscutting machine operator, rubberdipping machine tender - rubber products manufacturingdrum builder, rubberearth mover tire builderelectrical rubber goods manufacturing testerexpansion joint builder - rubber products manufacturingexpansion joint finisher - rubber products manufacturingexperimental tire manufacturing inspectorextruder operator - rubber products manufacturingextruding machine operator - rubber products manufacturingextrusion finisher - rubber products manufacturingfeeder mill operator - rubber products manufacturingfinisher, rubber V-beltsfire hose curer rubberfire hose maker, rubberflap curer, rubberflap presser, rubberfloor mat press tender - rubber products manufacturingfoam rubber goods inspectorfoam rubber machine operatorfoam rubber makerfoam rubber mattress inspectorfoam rubber mixerfoam rubber press operatorfolded gasket maker - rubber products manufacturingfoxer - rubber goodsfreeze tumbler tender - rubber products manufacturingfuel tank builder, rubberfuel tank finisher and repairer, rubberfuel tank finisher and repairman, rubberfuel tank finisher and repairwoman, rubberfuel tank form buildergang press operator - rubber products manufacturinggasket cutter, rubber",
    "workers": 22315,
    "minEduc": 1.5,
    "yearsStudy": 2.264880952,
    "automationRisk": 0.854,
    "salaryLow": 14,
    "salaryMed": 16.75,
    "salaryHigh": 27.04,
    "totalSkill": 136,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Retail sales supervisors and specialized sales occupations",
    "cluster": 9,
    "wage": 23.54723892,
    "skillsComp": 33,
    "skillsLogi": 38.5,
    "skillsMath": 25,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 9.5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 2.5,
    "s7NumericalEstimation": 5.5,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 13.5,
    "s11SchedulingorBudgetingandAccounting": 10.5,
    "s12DigitalTechnology": 9.5,
    "s13DocumentUse": 20,
    "s14Writing": 13.5,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 10,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 35,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 35,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 10,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 452,
    "noc": 9431,
    "job": "Sawmill machine operators",
    "title1": "block splitter � sawmill board sawyer � sawmill bolt sawyer � sawmill bolterman/woman � sawmill canter operator � sawmill chip reclaim operator � sawmill Chip-N-Saw operator � sawmill circular saw operator circular saw operator � sawmill cut-off saw operator � sawmill cut-off sawyer, timber � sawmill cutter, shingles � sawmill drag saw operator � sawmill edger � sawmill edger operator, automatic � sawmill edgerman/woman edgerman/woman � sawmill gang sawyer � sawmill gang sawyer, logs � sawmill head sawyer head sawyer � sawmill headrig operator � sawmill head-saw operator � sawmill high-speed stud operator � sawmill jumbo operator � sawmill log cut-off operator log cut-off operator � sawmill log cut-off sawyer � sawmill log gang saw operator � sawmill log gang sawyer � sawmill log haul cut-off saw operator � sawmill log hoist operator � sawmill lumber sizer operator � sawmill machine splitter � sawmill operator, automatic edger � sawmill operator, head saw � sawmill operator, log cut-off � sawmill operator, resaw � sawmill operator, splitter � sawmill operator, trimmer � sawmill planer � sawmill planer mill machine operator planer operator planer operator � sawmill planerman/woman � sawmill resaw operator resaw operator � sawmill resawyer � sawmill ripsaw operator � sawmill saw operator � sawmill sawdust reclaim operator � sawmill sawing machine operator � sawmill sawmill machine operator sawyer � sawmill sawyer, boards � sawmill sawyer, shakes � sawmill sawyer, stave bolts � sawmill scrag-saw operator � sawmill shake maker shake sawyer shake splitter shingle cutter shingle maker shingle sawyer slab saw operator slasher operator � sawmill slasher saw operator � sawmill slasher trim operator � sawmill splitter � sawmill splitter operator � sawmill splitter, machine � sawmill stave bolt saw operator stave bolt sawyer � sawmill tender, trimmer � sawmill tender, trimming machine � sawmill tilt-hoist operator � sawmill timber cut-off sawyer � sawmill transfer operator � sawmill trim saw operator � sawmill trim sawyer � sawmill trimmer operator � sawmill trimmer tender � sawmill trimmerman/woman trimmerman/woman � sawmill trimming machine operator � sawmill trimming machine tender � sawmill",
    "title2": 0,
    "title3": 0,
    "allTitles": "block splitter � sawmill board sawyer � sawmill bolt sawyer � sawmill bolterman/woman � sawmill canter operator � sawmill chip reclaim operator � sawmill Chip-N-Saw operator � sawmill circular saw operator circular saw operator � sawmill cut-off saw operator � sawmill cut-off sawyer, timber � sawmill cutter, shingles � sawmill drag saw operator � sawmill edger � sawmill edger operator, automatic � sawmill edgerman/woman edgerman/woman � sawmill gang sawyer � sawmill gang sawyer, logs � sawmill head sawyer head sawyer � sawmill headrig operator � sawmill head-saw operator � sawmill high-speed stud operator � sawmill jumbo operator � sawmill log cut-off operator log cut-off operator � sawmill log cut-off sawyer � sawmill log gang saw operator � sawmill log gang sawyer � sawmill log haul cut-off saw operator � sawmill log hoist operator � sawmill lumber sizer operator � sawmill machine splitter � sawmill operator, automatic edger � sawmill operator, head saw � sawmill operator, log cut-off � sawmill operator, resaw � sawmill operator, splitter � sawmill operator, trimmer � sawmill planer � sawmill planer mill machine operator planer operator planer operator � sawmill planerman/woman � sawmill resaw operator resaw operator � sawmill resawyer � sawmill ripsaw operator � sawmill saw operator � sawmill sawdust reclaim operator � sawmill sawing machine operator � sawmill sawmill machine operator sawyer � sawmill sawyer, boards � sawmill sawyer, shakes � sawmill sawyer, stave bolts � sawmill scrag-saw operator � sawmill shake maker shake sawyer shake splitter shingle cutter shingle maker shingle sawyer slab saw operator slasher operator � sawmill slasher saw operator � sawmill slasher trim operator � sawmill splitter � sawmill splitter operator � sawmill splitter, machine � sawmill stave bolt saw operator stave bolt sawyer � sawmill tender, trimmer � sawmill tender, trimming machine � sawmill tilt-hoist operator � sawmill timber cut-off sawyer � sawmill transfer operator � sawmill trim saw operator � sawmill trim sawyer � sawmill trimmer operator � sawmill trimmer tender � sawmill trimmerman/woman trimmerman/woman � sawmill trimming machine operator � sawmill trimming machine tender � sawmill",
    "workers": 25,
    "minEduc": 0.666666667,
    "yearsStudy": 1.333333333,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 20.4975,
    "salaryHigh": 32.2375,
    "totalSkill": 106.3333333,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.00333333,
    "skillsComp": 30,
    "skillsLogi": 29.66666667,
    "skillsMath": 15,
    "skillsLang": 31.66666667,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.333333333,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 6.333333333,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 5.666666667,
    "s8OralCommunication": 11.66666667,
    "s9ProblemSolving": 10,
    "s10Reading": 13.33333333,
    "s11SchedulingorBudgetingandAccounting": 2.333333333,
    "s12DigitalTechnology": 4.666666667,
    "s13DocumentUse": 23,
    "s14Writing": 6.666666667,
    "s15CriticalThinking": 1.333333333,
    "f1Science&Agriculture": 5,
    "f2Engineering": 5,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 5,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 453,
    "noc": 9432,
    "job": "Pulp mill machine operators",
    "title1": "acid maker � pulp and paper assistant bleacher operator � pulp and paper assistant digester operator assistant digester operator � pulp and paper baler � pulp and paper batch digester operator batch process cook � pulp and paper beater operator � pulp and paper bleach boiler tender bleach field operator � pulp and paper bleach liquor maker, pulp bleach stock preparation operator � pulp and paper bleacher operator � pulp and paper bleacher tender � pulp and paper bleacher, rag stock blow pit tender � pulp and paper breaker � pulp and paper breaker tender � pulp and paper breakerman/woman � pulp and paper broke beater tender � pulp and paper brown stock operator � pulp and paper brown stock washer � pulp and paper caustic plant operator causticizer operator causticizing operator � pulp and paper centri-cleaner tender � pulp and paper chemical liquor preparation operator � pulp and paper chemical pulping plant operator � pulp and paper chemical solutions operator � pulp and paper chemi-thermomechanical pulp (CTMP) machine assistant operator chemi-thermomechanical pulp (CTMP) operator chemi-wash operator � pulp and paper continuous digester operator � pulp and paper continuous process cook � pulp and paper cook � pulp and paper cook's first helper � pulp and paper CTMP (chemi-thermomechanical pulp) machine assistant operator CTMP (chemi-thermomechanical pulp) operator decker tender � pulp and paper deckerman/woman � pulp and paper digester cook � pulp and paper digester field operator digester operator � pulp and paper digester tender � pulp and paper dryer tender, insulation boards evaporator tender � pulp and paper field operator � pulp and paper filterman/woman � pulp and paper grinder loader � pulp and paper grinder operator � pulp and paper grinderman/woman � pulp and paper kiln-recaust operator � pulp and paper lime kiln operator � pulp and paper lime sludge mixer liquor maker � pulp and paper mixing operator � pulp and paper operator, bleacher � pulp and paper operator, digester � pulp and paper operator, pulp refiner � pulp and paper operator, pulp washer � pulp and paper operator, thermomechanical pulp paper pulp tester pulp and paper size maker pulp baler � pulp and paper pulp bleach liquor maker pulp cook pulp dryer operator pulp grader pulp maker pulp mill equipment operator pulp mill machine operator pulp refiner operator � pulp and paper pulp tester � pulp and paper pulp washer pulp washer operator � pulp and paper pulpwood products tester recovery operator � pulp and paper refiner � pulp and paper refiner man/woman � pulp and paper refiner operator � pulp and paper repulper operator screen room operator � pulp and paper screen tender � pulp and paper screenman/woman � pulp and paper size maker, pulp and paper stock tester � pulp and paper stock washer � pulp and paper tall oil operator tender, broke beater � pulp and paper thermomechanical pulp assistant operator thermomechanical pulp assistant operator � pulp and paper thermomechanical pulp operator unbleached pulp washer � pulp and paper washer operator, pulp washerman/woman � pulp and paper washing-screening operator � pulp and paper wood pulp caustic liquor maker",
    "title2": 0,
    "title3": 0,
    "allTitles": "acid maker � pulp and paper assistant bleacher operator � pulp and paper assistant digester operator assistant digester operator � pulp and paper baler � pulp and paper batch digester operator batch process cook � pulp and paper beater operator � pulp and paper bleach boiler tender bleach field operator � pulp and paper bleach liquor maker, pulp bleach stock preparation operator � pulp and paper bleacher operator � pulp and paper bleacher tender � pulp and paper bleacher, rag stock blow pit tender � pulp and paper breaker � pulp and paper breaker tender � pulp and paper breakerman/woman � pulp and paper broke beater tender � pulp and paper brown stock operator � pulp and paper brown stock washer � pulp and paper caustic plant operator causticizer operator causticizing operator � pulp and paper centri-cleaner tender � pulp and paper chemical liquor preparation operator � pulp and paper chemical pulping plant operator � pulp and paper chemical solutions operator � pulp and paper chemi-thermomechanical pulp (CTMP) machine assistant operator chemi-thermomechanical pulp (CTMP) operator chemi-wash operator � pulp and paper continuous digester operator � pulp and paper continuous process cook � pulp and paper cook � pulp and paper cook's first helper � pulp and paper CTMP (chemi-thermomechanical pulp) machine assistant operator CTMP (chemi-thermomechanical pulp) operator decker tender � pulp and paper deckerman/woman � pulp and paper digester cook � pulp and paper digester field operator digester operator � pulp and paper digester tender � pulp and paper dryer tender, insulation boards evaporator tender � pulp and paper field operator � pulp and paper filterman/woman � pulp and paper grinder loader � pulp and paper grinder operator � pulp and paper grinderman/woman � pulp and paper kiln-recaust operator � pulp and paper lime kiln operator � pulp and paper lime sludge mixer liquor maker � pulp and paper mixing operator � pulp and paper operator, bleacher � pulp and paper operator, digester � pulp and paper operator, pulp refiner � pulp and paper operator, pulp washer � pulp and paper operator, thermomechanical pulp paper pulp tester pulp and paper size maker pulp baler � pulp and paper pulp bleach liquor maker pulp cook pulp dryer operator pulp grader pulp maker pulp mill equipment operator pulp mill machine operator pulp refiner operator � pulp and paper pulp tester � pulp and paper pulp washer pulp washer operator � pulp and paper pulpwood products tester recovery operator � pulp and paper refiner � pulp and paper refiner man/woman � pulp and paper refiner operator � pulp and paper repulper operator screen room operator � pulp and paper screen tender � pulp and paper screenman/woman � pulp and paper size maker, pulp and paper stock tester � pulp and paper stock washer � pulp and paper tall oil operator tender, broke beater � pulp and paper thermomechanical pulp assistant operator thermomechanical pulp assistant operator � pulp and paper thermomechanical pulp operator unbleached pulp washer � pulp and paper washer operator, pulp washerman/woman � pulp and paper washing-screening operator � pulp and paper wood pulp caustic liquor maker",
    "workers": 25,
    "minEduc": 0.666666667,
    "yearsStudy": 1.333333333,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 20.4975,
    "salaryHigh": 32.2375,
    "totalSkill": 106.3333333,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.00333333,
    "skillsComp": 30,
    "skillsLogi": 29.66666667,
    "skillsMath": 15,
    "skillsLang": 31.66666667,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.333333333,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 6.333333333,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 5.666666667,
    "s8OralCommunication": 11.66666667,
    "s9ProblemSolving": 10,
    "s10Reading": 13.33333333,
    "s11SchedulingorBudgetingandAccounting": 2.333333333,
    "s12DigitalTechnology": 4.666666667,
    "s13DocumentUse": 23,
    "s14Writing": 6.666666667,
    "s15CriticalThinking": 1.333333333,
    "f1Science&Agriculture": 5,
    "f2Engineering": 5,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 5,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 454,
    "noc": 9433,
    "job": "Papermaking and finishing machine operators",
    "title1": "assistant coating operator � pulp and paper back tender, paper machine balerman/woman � pulp and paper baling press tender � pulp and paper calender man/woman � pulp and paper calender operator � pulp and paper calenderer � pulp and paper combiner machine operator � paper mill core cutter and reamer crimping head operator � papermaking cutter and reamer, cores � pulp and paper embossing calender operator � pulp and paper finisher � pulp and paper finisher, paper rolls � pulp and paper fourdrinier machine operator � pulp and paper fourth hand � pulp and paper grader � pulp and paper graderman/woman � pulp and paper inspector, sheet paper label operator � papermaking laminating machine operator � paper mill operator, calender � pulp and paper operator, coating machine � pulp and paper operator, fourdrinier machine � pulp and paper operator, paper machine operator, sheeter � pulp and paper packer-wrapper attendant � papermaking paper grader paper jogger operation � pulp and paper paper machine hand paper machine operator paper machine winderman/woman paper roll finisher � pulp and paper paper roll wrapper � pulp and paper paper-coating machine operator paper-finishing machine operator papermaking and finishing machine operator pressman/woman, pulp � pulp and paper processed paper rewinder pulp press tender rewinder � pulp and paper rewinder tender � pulp and paper rewinder, processed paper roll finisher � paper roll wrapper � paper salvage winder operator � papermaking sampler, sheet paper second hand, paper machine sheet paper inspector sheet paper sampler sheeter operator � pulp and paper specialty rewinder operator � papermaking supercalender operator � pulp and paper tender, rewinder � pulp and paper third hand � pulp and paper winder operator � pulp and paper winderman/woman � pulp and paper wrapline operator � papermaking wrapper, paper rolls � pulp and paper wrapper, rolls � pulp and paper",
    "title2": 0,
    "title3": 0,
    "allTitles": "assistant coating operator � pulp and paper back tender, paper machine balerman/woman � pulp and paper baling press tender � pulp and paper calender man/woman � pulp and paper calender operator � pulp and paper calenderer � pulp and paper combiner machine operator � paper mill core cutter and reamer crimping head operator � papermaking cutter and reamer, cores � pulp and paper embossing calender operator � pulp and paper finisher � pulp and paper finisher, paper rolls � pulp and paper fourdrinier machine operator � pulp and paper fourth hand � pulp and paper grader � pulp and paper graderman/woman � pulp and paper inspector, sheet paper label operator � papermaking laminating machine operator � paper mill operator, calender � pulp and paper operator, coating machine � pulp and paper operator, fourdrinier machine � pulp and paper operator, paper machine operator, sheeter � pulp and paper packer-wrapper attendant � papermaking paper grader paper jogger operation � pulp and paper paper machine hand paper machine operator paper machine winderman/woman paper roll finisher � pulp and paper paper roll wrapper � pulp and paper paper-coating machine operator paper-finishing machine operator papermaking and finishing machine operator pressman/woman, pulp � pulp and paper processed paper rewinder pulp press tender rewinder � pulp and paper rewinder tender � pulp and paper rewinder, processed paper roll finisher � paper roll wrapper � paper salvage winder operator � papermaking sampler, sheet paper second hand, paper machine sheet paper inspector sheet paper sampler sheeter operator � pulp and paper specialty rewinder operator � papermaking supercalender operator � pulp and paper tender, rewinder � pulp and paper third hand � pulp and paper winder operator � pulp and paper winderman/woman � pulp and paper wrapline operator � papermaking wrapper, paper rolls � pulp and paper wrapper, rolls � pulp and paper",
    "workers": 25,
    "minEduc": 0.666666667,
    "yearsStudy": 1.333333333,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 24.98,
    "salaryHigh": 49.04,
    "totalSkill": 106.3333333,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.00333333,
    "skillsComp": 30,
    "skillsLogi": 29.66666667,
    "skillsMath": 15,
    "skillsLang": 31.66666667,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.333333333,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 6.333333333,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 5.666666667,
    "s8OralCommunication": 11.66666667,
    "s9ProblemSolving": 10,
    "s10Reading": 13.33333333,
    "s11SchedulingorBudgetingandAccounting": 2.333333333,
    "s12DigitalTechnology": 4.666666667,
    "s13DocumentUse": 23,
    "s14Writing": 6.666666667,
    "s15CriticalThinking": 1.333333333,
    "f1Science&Agriculture": 5,
    "f2Engineering": 5,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 5,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 455,
    "noc": 9434,
    "job": "Other wood processing machine operators",
    "title1": "automatic veneer clipper tender - wood processing",
    "title2": "barker operator",
    "title3": "barker operator - wood processing",
    "allTitles": "automatic veneer clipper tender - wood processingbarker operatorbarker operator - wood processingbarking machine operator - wood processingchip-mixing machine tender - wood processingchipper operatorchipper operator - wood processingchip screen tender - wood processingclipper operator - wood processingcore layer - wood processingcore-laying machine tender - wood processingcut-off sawyer, veneer strips - wood processingdebarker operator - wood processingdip tank tender - wood processingdrop sorter operator - wood processingdrum barker tender - wood processingdryer tender, wood particlesdrying kiln operator - wood processingedge gluer - wood processingexcelsior machine tenderflaker operator - wood processingforming line operator, hardboardforming machine operator, particleboardfuel log maker - wood processinggrinding machine operator, hardboardgroover operator, plywood panels - wood processinghardboard-forming line operatorhardboard-grinding machine operatorhardboard-oiling machine tenderhardboard press operator - wood processinghot press operator - wood processinghumidifier tender - wood processinghydraulic barker operator - wood processingincising machine tender - wood processinginsulation board press tenderjointer tender - wood processingjointer, veneer - wood processinglathe spotter - wood processinglayup machine operator - wood processinglog cooker - wood processinglog vat tender - wood processinglumber drop sorter - wood processinglumber kiln operatorlumber sorter, machinemachine plywood patchermiller, wood flourmixer-dryer tender, wood particlesmultidrum sander operatoroperator, lumber kilnoperator, multidrum sanderoperator, particleboardoperator, plywood presspanel-groover operator - wood processingpanel-sanding machine operator - wood processingparticleboard-forming machine operatorparticleboard line operatorparticleboard-sizing saw tenderpatcher operator - wood processingplywood and veneer patcher and repairerplywood and veneer patcher and repairmanplywood and veneer patcher and repairwomanplywood bundlerplywood panel assemblerplywood panel groover operator - wood processingplywood patcherplywood patcher, machineplywood press operatorplywood-sizing saw tender - wood processingpress operator, hardboard - wood processingpress tender, insulation boardring barker operator - wood processingscarfer tender - wood processingscarf gluer - wood processingscarfing machine tender - wood processingscreen tender, chips - wood processingsizing saw tender, plywood - wood processingtempering plant tendertender, automatic veneer clipper - wood processingtender, log vat - wood processingtender, scarfing machine - wood processingtender, tempering planttimber treating tank operatortreating worker - wood preservingvat tender, logs - wood processingveneer clipper tender, automatic - wood processingveneer clipper - wood processingveneer cutter - wood processingveneer dryer tenderveneer dryer tender - wood processingveneer jointer operator - wood processingveneer jointer - wood processingveneer lathe operatorveneer lathe operator - wood processingveneer matcher - wood processingveneer patcher - wood processingveneer reel tender - wood processingveneer slicer-lather - wood processingveneer-slicing machine operator - wood processingveneer splicer tender - wood processingveneer strip cut-off sawyer - wood processing",
    "workers": 15,
    "minEduc": 1,
    "yearsStudy": 1,
    "automationRisk": 0.97,
    "salaryLow": 14,
    "salaryMed": 19.51,
    "salaryHigh": 29.91,
    "totalSkill": 115,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.51,
    "skillsComp": 34,
    "skillsLogi": 33,
    "skillsMath": 15,
    "skillsLang": 33,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 12,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 4,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 8,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 11,
    "s10Reading": 13,
    "s11SchedulingorBudgetingandAccounting": 3,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 29,
    "s14Writing": 7,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 456,
    "noc": 9435,
    "job": "Paper converting machine operators",
    "title1": "assembler, packing cartons",
    "title2": "automatic carton maker - paper converting",
    "title3": "automatic carton-making machine operator - paper converting",
    "allTitles": "assembler, packing cartonsautomatic carton maker - paper convertingautomatic carton-making machine operator - paper convertingautomatic paper-cutting machine operator - paper convertingbag maker, paperbag maker - paper convertingbag-making machine set-up operator - paper convertingbag repairer - paper productsbag repairman - paper productsbag repairwoman - paper productsbook cover creaserbook jacket machine tenderbox cutter, corrugated - paper convertingbox cutter - paper convertingbox finisher - paper convertingbox gluer - paper convertingbox liner - paper convertingbox maker, cardboard - paper convertingbox maker operatorbox maker - paper convertingbox maker, paper - paper convertingbutton envelope machine tendercarbon coater operatorcarbon-coating machine operatorcarbon paper cuttercarbon-paper-making machine operatorcardboard box gluercardboard box maker - paper convertingcardboard box press operatorcardboard maker, machinecardboard maker - paper convertingcardboard-tube-winding machine operator - paper convertingcarton assembler - paper convertingcarton forming machine operatorcarton gluercarton-making machine operatorcoater-laminator - paper productscolour card maker, machinecone former - paper convertingcone winder - paper convertingcore cutter - paper convertingcore maker - paper convertingcore winder - paper convertingcore-winding machine operator - paper convertingcorrugated box cutter - paper convertingcorrugating machine operator-cutter - paper convertingcorrugating machine operator - paper convertingcorrugator operator-cutter - paper convertingcorrugator operator - paper convertingcreaser - paper convertingcreping machine operator - paper convertingcutter, carbon papercutter, cores - paper convertingcutter, corrugated boxes - paper convertingcutter, labels - paper convertingcutter, revenue stampscutting and creasing press operator - paper convertingdiaper machine tender - paper convertingdie-cutting machine operator - paper productsdrill punch tender - paper convertingenvelope-flap-cutting machine setterenvelope flap gummer, machine - paper convertingenvelope-flap-gumming machine tender - paper convertingenvelope machine operatorenvelope machine tender - paper convertingenvelope maker operatorenvelope-making machine operatorenvelope-making machine setter - paper convertingfeeder, slitter-creaser - paper convertingflexo-folder operator - paper convertingfolding machine tender - paper convertingfriction paint machine tender - paper convertinggluer, cardboard boxesgumming machine tender - paper convertinginspector, paper productslabel cutter - paper convertinglaminating machine tender - paper convertinglapper, wallpaperlapper, wallpaper - paper convertingliner machine operator - paper convertingmachine cardboard makermachine colour card makermachine cutter, rolls - paper convertingmachine envelope flap gummer - paper convertingmachine gluer, pads - paper convertingmachine gummer, envelope flaps - paper convertingmachine operator, paper convertingmachine pad gluer - paper convertingmachine roll cutter - paper convertingmachine roll slitter - paper convertingmachine slitter, rolls - paper convertingmachine tube maker - paper convertingmachine tuber - paper convertingmatchbook comb-cutting machine tendermatchbook folding-stapling machine tendermoulder, papier-m�ch�operator, carbon-paper-making machineoperator, cardboard box pressoperator, carton-making machineoperator, core-winding machine - paper converting",
    "workers": 30,
    "minEduc": 1,
    "yearsStudy": 2,
    "automationRisk": 0.67,
    "salaryLow": 14,
    "salaryMed": 21,
    "salaryHigh": 26,
    "totalSkill": 89,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 21,
    "skillsComp": 24,
    "skillsLogi": 27,
    "skillsMath": 13,
    "skillsLang": 25,
    "topSkill1": "Document Use",
    "topSkill2": "Problem Solving",
    "topSkill3": "Problem Solving",
    "s1DataAnalysis": 1,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 8,
    "s6MoneyMath": 0,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 10,
    "s9ProblemSolving": 11,
    "s10Reading": 11,
    "s11SchedulingorBudgetingandAccounting": 0,
    "s12DigitalTechnology": 1,
    "s13DocumentUse": 22,
    "s14Writing": 4,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 15,
    "f2Engineering": 15,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 15,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 457,
    "noc": 9436,
    "job": "Lumber graders and other wood processing inspectors and graders",
    "title1": "board grader � wood processing flooring grader � wood processing grader � wood processing grader tallyman/woman � wood processing grader, board � wood processing grader, lumber grader, particleboards � wood processing grader, plywood � wood processing grader, veneer � wood processing grader, veneer and plywood � wood processing grader, wood processing green lumber grader inspector � wood processing inspector, plywood � wood processing inspector, shakes � wood processing inspector, treated poles � wood processing lumber grader lumber inspector lumber marker marker, lumber panel inspector � wood processing particleboard grader � wood processing planer grader � wood processing planer mill grader � wood processing plywood and veneer matcher � wood processing plywood grader plywood grader � wood processing plywood inspector plywood inspector � wood processing pole inspector � wood processing shake inspector � wood processing shingle inspector � wood processing stake grader � wood processing tie and timber inspector treated pole tester � wood processing veneer and plywood grader � wood processing veneer grader veneer grader � wood processing wood marker � wood processing wood measurer wood measurer � wood processing wood processing grader wood processing inspector",
    "title2": 0,
    "title3": 0,
    "allTitles": "board grader � wood processing flooring grader � wood processing grader � wood processing grader tallyman/woman � wood processing grader, board � wood processing grader, lumber grader, particleboards � wood processing grader, plywood � wood processing grader, veneer � wood processing grader, veneer and plywood � wood processing grader, wood processing green lumber grader inspector � wood processing inspector, plywood � wood processing inspector, shakes � wood processing inspector, treated poles � wood processing lumber grader lumber inspector lumber marker marker, lumber panel inspector � wood processing particleboard grader � wood processing planer grader � wood processing planer mill grader � wood processing plywood and veneer matcher � wood processing plywood grader plywood grader � wood processing plywood inspector plywood inspector � wood processing pole inspector � wood processing shake inspector � wood processing shingle inspector � wood processing stake grader � wood processing tie and timber inspector treated pole tester � wood processing veneer and plywood grader � wood processing veneer grader veneer grader � wood processing wood marker � wood processing wood measurer wood measurer � wood processing wood processing grader wood processing inspector",
    "workers": 25,
    "minEduc": 0.666666667,
    "yearsStudy": 1.333333333,
    "automationRisk": 0.87,
    "salaryLow": 14,
    "salaryMed": 20.4975,
    "salaryHigh": 32.2375,
    "totalSkill": 106.3333333,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 19.00333333,
    "skillsComp": 30,
    "skillsLogi": 29.66666667,
    "skillsMath": 15,
    "skillsLang": 31.66666667,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 2.333333333,
    "s2DecisionMaking": 9.333333333,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3.333333333,
    "s5MeasurementandCalculation": 6.333333333,
    "s6MoneyMath": 1,
    "s7NumericalEstimation": 5.666666667,
    "s8OralCommunication": 11.66666667,
    "s9ProblemSolving": 10,
    "s10Reading": 13.33333333,
    "s11SchedulingorBudgetingandAccounting": 2.333333333,
    "s12DigitalTechnology": 4.666666667,
    "s13DocumentUse": 23,
    "s14Writing": 6.666666667,
    "s15CriticalThinking": 1.333333333,
    "f1Science&Agriculture": 5,
    "f2Engineering": 5,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 5,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 458,
    "noc": 9437,
    "job": "Woodworking machine operators",
    "title1": "adzing and boring machine operator",
    "title2": "automatic nailing machine operator - woodworking",
    "title3": "automatic shaper operator - woodworking",
    "allTitles": "adzing and boring machine operatorautomatic nailing machine operator - woodworkingautomatic shaper operator - woodworkingbanding machine tender - woodworkingband resaw operator - woodworkingband ripsaw operator - woodworkingband-sawing machine tender - woodworkingband saw operator - woodworkingband saw tender - woodworkingband scroll saw operator - woodworkingbarrel assemblerbarrel cooper - woodworkingbarrel end fitter, wood - woodworkingbarrel end machine tender - woodworkingbarrel end sawyerbarrel-header fitter, wood - woodworkingbarrel heading sawyerbasket machine operator - woodworkingbelt sander - woodworkingbench machine operator - woodworkingbender, lacrosse sticks - woodworkingbilliard cue makerborer - woodworkingboring machine operator - woodworkingbowl blank boring and finishing machine operatorbox blank repairer - woodworkingbox blank repairman - woodworkingbox blank repairwoman - woodworkingbriar-bowl turner - woodworkingbucket chucker - woodworkingbucket lathe operatorcarver, machine - woodworkingcarver operator - woodworkingcarving machine operator - woodworkingcask makerchair leveler - woodworkingchair seat planer tendercheckerer, gunstockscheckerer, small armschucking and boring machine operator - woodworkingchucking machine operator - woodworkingcircular saw operator - woodworkingclamping machine tender - woodworkingclean-up sander - woodworkingcleat notcher - woodworkingCNC band saw operator - woodworkingCNC (computer numerically controlled) band saw operatorCNC (computer numerically controlled) woodworking machine tool operatorcold press tender - woodworkingcomputerized panel saw tendercomputer numerically controlled (CNC) band saw operatorcontour sander operator - woodworkingcooperage heading machine operator - woodworkingcooperage heading sawyercooperage setter-up - woodworkingcooperage set-up man/woman - woodworkingcooperage set-up man - woodworkingcooperage set-up woman - woodworkingcooper header operator - woodcooper header - woodworkingcooper operator - woodworkingcooper's head-saw operator - woodworkingcopy lathe tendercorrugated fastener driver - woodworkingcrosscut saw operator - woodworkingcroze machine operator - woodworkingcustom cue maker and repairercustom cue maker and repairmancustom cue maker and repairman/womancustom cue maker and repairwomancut-off saw operator - woodworkingcutter, disks - wood products manufacturingcutter, mouldings - wood products manufacturingcutter, stock - woodworkingcylinder-sander feeder - woodworkingcylinder saw tender - woodworkingdado operator, overhead - woodworkingdado operator - woodworkingdado saw operator - woodworkingdefect trimmer - woodworkingdesk sander - woodworkingdetail shaper - woodworkingdimension planer operator - woodworkingdisk cutter - wood productsdoor-hang machine operator - woodworkingdovetail machine operator - woodworkingdowelling machine operator - woodworkingdowelling machine set-up operator - woodworkingdowelling machine tender - woodworkingdowel machine operator - woodworkingdowel machine set-up operator - woodworkingdowel machine tenderdowel-making machine operator - woodworkingdowel-making machine set-up operator - woodworkingdowel-making machine tender - woodworkingdowel pointer - woodworkingdriller, wood - woodworkingdrill operator - woodworkingdrill press operator - woodworkingdrum sander operator - woodworking",
    "workers": 30,
    "minEduc": 0,
    "yearsStudy": 1,
    "automationRisk": 0.97,
    "salaryLow": 14,
    "salaryMed": 16.5,
    "salaryHigh": 24,
    "totalSkill": 115,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 16.5,
    "skillsComp": 32,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 30,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 30,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 459,
    "noc": 9441,
    "job": "Textile fibre and yarn, hide and pelt processing machine operators and workers",
    "title1": "ager operator � textile manufacturing ager tender � textile manufacturing aging machine operator � textile manufacturing aging machine tender � textile manufacturing asbestos rope maker autoclave tender � textile manufacturing automatic quiller tender � textile manufacturing back tender � cloth printing bale breaker � textile manufacturing bale-breaker tender � textile manufacturing batch dyer � textile manufacturing bater � hide and pelt processing batting machine tender � textile manufacturing beam dyer � textile manufacturing beam setter � textile manufacturing beam tier � textile manufacturing beam warper � textile manufacturing beamer � hide and pelt processing beamer � textile manufacturing beamhouse worker � hide and pelt processing beating machine tender � hide and pelt processing bleacher � textile manufacturing bleaching machine operator � textile manufacturing bleaching range operator � textile manufacturing blending machine tender � textile manufacturing boarder � textile manufacturing boarding machine tender � hide and pelt processing boarding machine tender � textile manufacturing bobbin dryer � textile manufacturing bobbin stripper � textile manufacturing bobbin winder � textile manufacturing boiler � textile manufacturing bonding machine tender � textile manufacturing bowker � textile manufacturing breaker feeder � textile manufacturing breaker tender � textile manufacturing brush machine tender � textile manufacturing brusher and shearer � textile manufacturing brushing machine operator � hide and pelt processing brushing operator � textile manufacturing buffer, leather � hide and pelt processing burnisher � hide and pelt processing calender operator � textile manufacturing calendering machine tender � textile manufacturing can tender carbonizer tender � textile manufacturing card feeder � textile manufacturing card operator � textile manufacturing card stripper � textile manufacturing card tender � textile manufacturing carder � textile manufacturing carding machine feeder � textile manufacturing carding machine operator � textile manufacturing carding machine tender � textile manufacturing carpet drying machine tender carpet drying machine tender � textile manufacturing centrifugal extractor � textile manufacturing centrifuge operator � textile manufacturing chenille tender � textile manufacturing chopping machine tender clipping machine tender cloth bleacher cloth dryer cloth dyer cloth finisher cloth mercerizer operator cloth neutralizer cloth printer cloth shade maker cloth shader cloth shrinker cloth steamer cloth stretcher-dryer tender cloth washer � textile manufacturing cloth-bleaching range tender cloth-doubling machine operator cloth-dyeing range tender cloth-finishing range operator cloth-neutralizing and cloth-rinsing machine operator cloth-printing machine helper cloth-printing machine tender cloth-printing roller changer cloth-processing range tender coater operator � textile manufacturing coater tender � textile manufacturing coating and embossing unit operator � textile manufacturing coating machine operator � textile manufacturing coating machine tender � textile manufacturing colour mixer � textile manufacturing colourer tender � hide and pelt processing colourist � textile manufacturing combed sliver dyer � textile manufacturing comber � textile manufacturing combining and drawing machine tender � textile manufacturing conditioner tender � textile manufacturing cone winder � textile manufacturing continuous dyeing machine operator � textile manufacturing continuous felt dryer operator � textile manufacturing continuous press tender � textile manufacturing cotton ball machine tender covering-machine tender crabber � textile manufacturing crabbing machine tender crabbing machine tender � textile manufacturing crimp setter crimper crimping machine tender � textile manufacturing cropping machine tender � textile manufacturing cutting and printing machine set-up operator � textile manufacturing decating machine tender � textile manufacturing dehairing machine operator � hide and pelt processing doubling machine operator � textile manufacturing doubling machine tender � textile manufacturing drawing machine tender � textile fibre dressed hide and pelt finisher dresser � textile manufacturing dry cans operator � textile manufacturing dryer � textile manufacturing dryer operator � textile manufacturing dryer tender � textile manufacturing drying machine operator � textile manufacturing drying machine tender � textile manufacturing drying machine tender, yarn dye mixer dyeing machine tender � textile manufacturing dyeing range operator � textile manufacturing dyeing tub tender � textile manufacturing dyeing vat operator � textile manufacturing dyeing worker � textile manufacturing dyer dyer � textile manufacturing dye-reel tender � textile manufacturing embossing calender tender � textile manufacturing extractor tender � textile manufacturing fabric dyer fabric printer fabric-printing machine operator felt dryer � textile manufacturing fibre classer fibre mixer fibre washer fibreglass roving winder finisher � textile manufacturing finishing machine operator � textile manufacturing finishing range operator � textile manufacturing fleecer � textile manufacturing fleecing machine operator � textile manufacturing fleecing machine tender � textile manufacturing flesher, hand � hide and pelt processing fleshing machine tender � hide and pelt processing flocking machine tender folding machine tender � textile manufacturing frame spinner � textile manufacturing fuller � textile manufacturing fulling machine operator � textile manufacturing fulling mill operator � textile manufacturing fur blender fur blower � textile manufacturing fur dresser � hide and pelt processing fur floor worker � hide and pelt processing fur mixer fur pelt dresser � hide and pelt processing fur plucker � hide and pelt processing fur-shaving machine tender � hide and pelt processing furskin dresser � hide and pelt processing garment steamer tender garnett machine tender � textile manufacturing gig machine operator � textile manufacturing glass fibre dyer � textile manufacturing graining machine operator � tannery hand screen printer � textile manufacturing heat curer � textile manufacturing hide and pelt processing worker hide and skin preparer hide fluffer � hide and pelt processing hide parer � hide and pelt processing hide processing worker hide stretcher high-speed machine warper � textile manufacturing hosiery boarder jig operator � textile manufacturing jigger operator � textile manufacturing kettle tender � textile manufacturing kier-boiler tender � textile manufacturing lap machine tender � textile manufacturing lapper � textile manufacturing lapper tender � textile manufacturing lap-winder tender � textile manufacturing latex-coating machine operator � textile manufacturing leather buffer � hide and pelt processing leather dyer � hide and pelt processing leather measurer � hide and pelt processing leather polisher � hide and pelt processing leather sander � hide and pelt processing leather shaver � hide and pelt processing leather stainer � hide and pelt processing leather stretcher � hide and pelt processing leather tanner limer � hide and pelt processing line spooler loom-winder tender lusterer � textile manufacturing machine flesher � hide and pelt processing machine operator � hide and pelt processing machine operator � textile fibre and yarn preparation mangler tender � textile manufacturing measuring machine tender � hide and pelt processing mercerizer � textile manufacturing mercerizer machine operator � textile manufacturing napper � textile manufacturing napper operator � textile manufacturing napper tender � textile manufacturing naps teaseller � textile manufacturing neutralizer � textile manufacturing open-end spinner � textile manufacturing opener tender � textiles opening and blending operator operator, bleaching range � textile manufacturing operator, dye-range � textile manufacturing padder tender � textile manufacturing padding machine tender � textile manufacturing pad-extractor tender � textile manufacturing pelt dresser pelt dyer � hide and pelt processing pelt processing worker pelt shearer pelt stretcher � hide and pelt processing picker � textile manufacturing picker tender � textile manufacturing picking machine operator � textile manufacturing picking machine tender � textile manufacturing pickler � hide and pelt processing pile fabric finisher pile-finishing machine tender � textile manufacturing pleater � textile manufacturing poler � textile manufacturing polisher � textile fibre prepared hide and pelt dresser presser and threader � textile manufacturing presser-threader � textile manufacturing printing machine operator � textile manufacturing printing operator � textile manufacturing quill winder � textile manufacturing quiller � textile manufacturing quilling machine tender, automatic � textile manufacturing raw stock dryer � textile manufacturing raw stock dyer � textile manufacturing rebeamer � textile manufacturing redraw operator � textile manufacturing reel tender � textile manufacturing reel winder � textile manufacturing reeler � textile manufacturing reeling machine operator � textile manufacturing respooler � textile manufacturing rewarper � textile manufacturing rewinder � textile manufacturing ring frame operator � textile manufacturing ring spinner � textile manufacturing rinser � textile manufacturing roller machine tender � tannery roller printer � textile manufacturing rope coiler rotogravure press operator � textile manufacturing rover � textile manufacturing roving frame tender � textile manufacturing roving machine operator � textile manufacturing rubber and vinyl coater operator � textile manufacturing rubber-coating and vinyl-coating machine operator � textile manufacturing rug setter � textile manufacturing rug-coating machine operator rug-yarn-setting machine operator � textile manufacturing sample printer � textile manufacturing saturator � textile manufacturing scouring machine operator scray machine feeder screen printer, hand � textile manufacturing screen printing operator � textile manufacturing screen-printing machine operator � textile manufacturing scudder � hide and pelt processing shaving machine tender � hide and pelt processing shearing machine tender shearing machine tender � textile manufacturing shrinking machine operator � textile manufacturing silk-screen printing machine operator � textile manufacturing singeing and boiling machine tender � textile manufacturing size maker � textile manufacturing sizing machine tender � textiles skein spooler � textile manufacturing skein winder � textile manufacturing skeiner � textile manufacturing slasher � textile manufacturing slasher operator � textile manufacturing sliver lapper � textile manufacturing slubber tender � textile manufacturing slubber, hand spinner � textile manufacturing spinning frame tender � textile manufacturing spinning machine operator � textile manufacturing spinning machine tender � textile manufacturing spinning operator � textile manufacturing splicing machine tender � textile manufacturing splitter � hide and pelt processing sponge-range operator � textile manufacturing spool winder � textile manufacturing spooler � textile manufacturing spooler operator, automatic � textile manufacturing spooling machine tender � textile manufacturing spray-coating machine tender � textile manufacturing spraying machine tender � textile manufacturing spun yarn doubler � textile manufacturing staple cutter � textile manufacturing staple processing machine tender � textile manufacturing steam cabinet operator � textile manufacturing steam sponger � textile manufacturing steamer tender � textile manufacturing stender tender stock mixer � textile manufacturing strand-forming machine tender � textile manufacturing stretching machine operator � hide and pelt processing stretching machine tender � textile fibre stretching machine tender � textile manufacturing strike-off machine tender � textile manufacturing super-draft tender tanner � hide and pelt processing tannery vatman/woman tanning solution preparer tape-folding machine tender tar machine tender � textile manufacturing tension drying machine tender � textile manufacturing tenter machine tender tenter machine tender � textile manufacturing tenterframe tender textile colourist textile dyer textile fleecer � textile manufacturing textile napper � textile manufacturing textile printer textile product bleacher textile spinner textile washer textile wringer textile-dyeing and finishing machine operator textile-twisting-frame operator texturing machine tender � textile manufacturing thread doubler thread spinner thread spooler thread winder top dyer � textile manufacturing tumbler tender � textile manufacturing twine dyer twine maker twine-cropping machine tender twine-shearing machine tender twister operator � textile manufacturing twister tender � textile manufacturing twisting frame operator � textile manufacturing twisting operator � textile manufacturing uptwister operator � textile manufacturing uptwister tender � textile manufacturing warp beamer � textile manufacturing warp dresser � textile manufacturing warp end dresser � textile manufacturing warp end dyer � textile manufacturing warp spinner � textile manufacturing warp twister tender � textile manufacturing warper � textile manufacturing warper operator � textile manufacturing warper tender, automatic � textiles manufacturing warping operator � textile manufacturing washing machine tender � textile manufacturing waxer � textile manufacturing weft straightener � textile manufacturing willow operator � textile manufacturing winder operator � textile manufacturing winder tender � textile manufacturing winding machine operator � textile manufacturing winding machine tender � textile manufacturing wool batcher wool blender wool mixer wool opener and duster wool scourer wool sorter wool washer wringer operator � textile manufacturing wringer tender � textile manufacturing wring-out machine operator � textile manufacturing yarn conditioner yarn doubler � textile manufacturing yarn dryer yarn dyer yarn finisher yarn mercerizer yarn soaker yarn spinner yarn spooler yarn winder yarn winder tender yarn winder, automatic yarn-drying machine tender yarn-plaiting equipment tender yarn-texturing machine tender � textile fibre yarn-texturing machine tender � textile manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "ager operator � textile manufacturing ager tender � textile manufacturing aging machine operator � textile manufacturing aging machine tender � textile manufacturing asbestos rope maker autoclave tender � textile manufacturing automatic quiller tender � textile manufacturing back tender � cloth printing bale breaker � textile manufacturing bale-breaker tender � textile manufacturing batch dyer � textile manufacturing bater � hide and pelt processing batting machine tender � textile manufacturing beam dyer � textile manufacturing beam setter � textile manufacturing beam tier � textile manufacturing beam warper � textile manufacturing beamer � hide and pelt processing beamer � textile manufacturing beamhouse worker � hide and pelt processing beating machine tender � hide and pelt processing bleacher � textile manufacturing bleaching machine operator � textile manufacturing bleaching range operator � textile manufacturing blending machine tender � textile manufacturing boarder � textile manufacturing boarding machine tender � hide and pelt processing boarding machine tender � textile manufacturing bobbin dryer � textile manufacturing bobbin stripper � textile manufacturing bobbin winder � textile manufacturing boiler � textile manufacturing bonding machine tender � textile manufacturing bowker � textile manufacturing breaker feeder � textile manufacturing breaker tender � textile manufacturing brush machine tender � textile manufacturing brusher and shearer � textile manufacturing brushing machine operator � hide and pelt processing brushing operator � textile manufacturing buffer, leather � hide and pelt processing burnisher � hide and pelt processing calender operator � textile manufacturing calendering machine tender � textile manufacturing can tender carbonizer tender � textile manufacturing card feeder � textile manufacturing card operator � textile manufacturing card stripper � textile manufacturing card tender � textile manufacturing carder � textile manufacturing carding machine feeder � textile manufacturing carding machine operator � textile manufacturing carding machine tender � textile manufacturing carpet drying machine tender carpet drying machine tender � textile manufacturing centrifugal extractor � textile manufacturing centrifuge operator � textile manufacturing chenille tender � textile manufacturing chopping machine tender clipping machine tender cloth bleacher cloth dryer cloth dyer cloth finisher cloth mercerizer operator cloth neutralizer cloth printer cloth shade maker cloth shader cloth shrinker cloth steamer cloth stretcher-dryer tender cloth washer � textile manufacturing cloth-bleaching range tender cloth-doubling machine operator cloth-dyeing range tender cloth-finishing range operator cloth-neutralizing and cloth-rinsing machine operator cloth-printing machine helper cloth-printing machine tender cloth-printing roller changer cloth-processing range tender coater operator � textile manufacturing coater tender � textile manufacturing coating and embossing unit operator � textile manufacturing coating machine operator � textile manufacturing coating machine tender � textile manufacturing colour mixer � textile manufacturing colourer tender � hide and pelt processing colourist � textile manufacturing combed sliver dyer � textile manufacturing comber � textile manufacturing combining and drawing machine tender � textile manufacturing conditioner tender � textile manufacturing cone winder � textile manufacturing continuous dyeing machine operator � textile manufacturing continuous felt dryer operator � textile manufacturing continuous press tender � textile manufacturing cotton ball machine tender covering-machine tender crabber � textile manufacturing crabbing machine tender crabbing machine tender � textile manufacturing crimp setter crimper crimping machine tender � textile manufacturing cropping machine tender � textile manufacturing cutting and printing machine set-up operator � textile manufacturing decating machine tender � textile manufacturing dehairing machine operator � hide and pelt processing doubling machine operator � textile manufacturing doubling machine tender � textile manufacturing drawing machine tender � textile fibre dressed hide and pelt finisher dresser � textile manufacturing dry cans operator � textile manufacturing dryer � textile manufacturing dryer operator � textile manufacturing dryer tender � textile manufacturing drying machine operator � textile manufacturing drying machine tender � textile manufacturing drying machine tender, yarn dye mixer dyeing machine tender � textile manufacturing dyeing range operator � textile manufacturing dyeing tub tender � textile manufacturing dyeing vat operator � textile manufacturing dyeing worker � textile manufacturing dyer dyer � textile manufacturing dye-reel tender � textile manufacturing embossing calender tender � textile manufacturing extractor tender � textile manufacturing fabric dyer fabric printer fabric-printing machine operator felt dryer � textile manufacturing fibre classer fibre mixer fibre washer fibreglass roving winder finisher � textile manufacturing finishing machine operator � textile manufacturing finishing range operator � textile manufacturing fleecer � textile manufacturing fleecing machine operator � textile manufacturing fleecing machine tender � textile manufacturing flesher, hand � hide and pelt processing fleshing machine tender � hide and pelt processing flocking machine tender folding machine tender � textile manufacturing frame spinner � textile manufacturing fuller � textile manufacturing fulling machine operator � textile manufacturing fulling mill operator � textile manufacturing fur blender fur blower � textile manufacturing fur dresser � hide and pelt processing fur floor worker � hide and pelt processing fur mixer fur pelt dresser � hide and pelt processing fur plucker � hide and pelt processing fur-shaving machine tender � hide and pelt processing furskin dresser � hide and pelt processing garment steamer tender garnett machine tender � textile manufacturing gig machine operator � textile manufacturing glass fibre dyer � textile manufacturing graining machine operator � tannery hand screen printer � textile manufacturing heat curer � textile manufacturing hide and pelt processing worker hide and skin preparer hide fluffer � hide and pelt processing hide parer � hide and pelt processing hide processing worker hide stretcher high-speed machine warper � textile manufacturing hosiery boarder jig operator � textile manufacturing jigger operator � textile manufacturing kettle tender � textile manufacturing kier-boiler tender � textile manufacturing lap machine tender � textile manufacturing lapper � textile manufacturing lapper tender � textile manufacturing lap-winder tender � textile manufacturing latex-coating machine operator � textile manufacturing leather buffer � hide and pelt processing leather dyer � hide and pelt processing leather measurer � hide and pelt processing leather polisher � hide and pelt processing leather sander � hide and pelt processing leather shaver � hide and pelt processing leather stainer � hide and pelt processing leather stretcher � hide and pelt processing leather tanner limer � hide and pelt processing line spooler loom-winder tender lusterer � textile manufacturing machine flesher � hide and pelt processing machine operator � hide and pelt processing machine operator � textile fibre and yarn preparation mangler tender � textile manufacturing measuring machine tender � hide and pelt processing mercerizer � textile manufacturing mercerizer machine operator � textile manufacturing napper � textile manufacturing napper operator � textile manufacturing napper tender � textile manufacturing naps teaseller � textile manufacturing neutralizer � textile manufacturing open-end spinner � textile manufacturing opener tender � textiles opening and blending operator operator, bleaching range � textile manufacturing operator, dye-range � textile manufacturing padder tender � textile manufacturing padding machine tender � textile manufacturing pad-extractor tender � textile manufacturing pelt dresser pelt dyer � hide and pelt processing pelt processing worker pelt shearer pelt stretcher � hide and pelt processing picker � textile manufacturing picker tender � textile manufacturing picking machine operator � textile manufacturing picking machine tender � textile manufacturing pickler � hide and pelt processing pile fabric finisher pile-finishing machine tender � textile manufacturing pleater � textile manufacturing poler � textile manufacturing polisher � textile fibre prepared hide and pelt dresser presser and threader � textile manufacturing presser-threader � textile manufacturing printing machine operator � textile manufacturing printing operator � textile manufacturing quill winder � textile manufacturing quiller � textile manufacturing quilling machine tender, automatic � textile manufacturing raw stock dryer � textile manufacturing raw stock dyer � textile manufacturing rebeamer � textile manufacturing redraw operator � textile manufacturing reel tender � textile manufacturing reel winder � textile manufacturing reeler � textile manufacturing reeling machine operator � textile manufacturing respooler � textile manufacturing rewarper � textile manufacturing rewinder � textile manufacturing ring frame operator � textile manufacturing ring spinner � textile manufacturing rinser � textile manufacturing roller machine tender � tannery roller printer � textile manufacturing rope coiler rotogravure press operator � textile manufacturing rover � textile manufacturing roving frame tender � textile manufacturing roving machine operator � textile manufacturing rubber and vinyl coater operator � textile manufacturing rubber-coating and vinyl-coating machine operator � textile manufacturing rug setter � textile manufacturing rug-coating machine operator rug-yarn-setting machine operator � textile manufacturing sample printer � textile manufacturing saturator � textile manufacturing scouring machine operator scray machine feeder screen printer, hand � textile manufacturing screen printing operator � textile manufacturing screen-printing machine operator � textile manufacturing scudder � hide and pelt processing shaving machine tender � hide and pelt processing shearing machine tender shearing machine tender � textile manufacturing shrinking machine operator � textile manufacturing silk-screen printing machine operator � textile manufacturing singeing and boiling machine tender � textile manufacturing size maker � textile manufacturing sizing machine tender � textiles skein spooler � textile manufacturing skein winder � textile manufacturing skeiner � textile manufacturing slasher � textile manufacturing slasher operator � textile manufacturing sliver lapper � textile manufacturing slubber tender � textile manufacturing slubber, hand spinner � textile manufacturing spinning frame tender � textile manufacturing spinning machine operator � textile manufacturing spinning machine tender � textile manufacturing spinning operator � textile manufacturing splicing machine tender � textile manufacturing splitter � hide and pelt processing sponge-range operator � textile manufacturing spool winder � textile manufacturing spooler � textile manufacturing spooler operator, automatic � textile manufacturing spooling machine tender � textile manufacturing spray-coating machine tender � textile manufacturing spraying machine tender � textile manufacturing spun yarn doubler � textile manufacturing staple cutter � textile manufacturing staple processing machine tender � textile manufacturing steam cabinet operator � textile manufacturing steam sponger � textile manufacturing steamer tender � textile manufacturing stender tender stock mixer � textile manufacturing strand-forming machine tender � textile manufacturing stretching machine operator � hide and pelt processing stretching machine tender � textile fibre stretching machine tender � textile manufacturing strike-off machine tender � textile manufacturing super-draft tender tanner � hide and pelt processing tannery vatman/woman tanning solution preparer tape-folding machine tender tar machine tender � textile manufacturing tension drying machine tender � textile manufacturing tenter machine tender tenter machine tender � textile manufacturing tenterframe tender textile colourist textile dyer textile fleecer � textile manufacturing textile napper � textile manufacturing textile printer textile product bleacher textile spinner textile washer textile wringer textile-dyeing and finishing machine operator textile-twisting-frame operator texturing machine tender � textile manufacturing thread doubler thread spinner thread spooler thread winder top dyer � textile manufacturing tumbler tender � textile manufacturing twine dyer twine maker twine-cropping machine tender twine-shearing machine tender twister operator � textile manufacturing twister tender � textile manufacturing twisting frame operator � textile manufacturing twisting operator � textile manufacturing uptwister operator � textile manufacturing uptwister tender � textile manufacturing warp beamer � textile manufacturing warp dresser � textile manufacturing warp end dresser � textile manufacturing warp end dyer � textile manufacturing warp spinner � textile manufacturing warp twister tender � textile manufacturing warper � textile manufacturing warper operator � textile manufacturing warper tender, automatic � textiles manufacturing warping operator � textile manufacturing washing machine tender � textile manufacturing waxer � textile manufacturing weft straightener � textile manufacturing willow operator � textile manufacturing winder operator � textile manufacturing winder tender � textile manufacturing winding machine operator � textile manufacturing winding machine tender � textile manufacturing wool batcher wool blender wool mixer wool opener and duster wool scourer wool sorter wool washer wringer operator � textile manufacturing wringer tender � textile manufacturing wring-out machine operator � textile manufacturing yarn conditioner yarn doubler � textile manufacturing yarn dryer yarn dyer yarn finisher yarn mercerizer yarn soaker yarn spinner yarn spooler yarn winder yarn winder tender yarn winder, automatic yarn-drying machine tender yarn-plaiting equipment tender yarn-texturing machine tender � textile fibre yarn-texturing machine tender � textile manufacturing",
    "workers": 245,
    "minEduc": 0,
    "yearsStudy": 1.583333333,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 16.13,
    "salaryHigh": 25,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 460,
    "noc": 9442,
    "job": "Weavers, knitters and other fabric making occupations",
    "title1": "automatic embroidery machine tender automatic stocking loom tender Axminster carpet weaver ball fringe machine tender band-knitting machine operator beam changer � textiles blanket weaver braid maker � textiles braid weaver � textiles braider � textiles braiding machine tender � textiles card lacer � textiles carpet weaver carpet-tufting machine operator carpet-weaving machine operator chain builder � textiles chainman/woman � textiles circular knitter circular knitting machine knitter cloth ribber cloth weaver crochet machine operator crocheting machine operator dobby loom drawer-in dobby loom weaver drawer-in � textiles drawer-in helper � textiles drawing-in machine operator drawing-in machine operator � textiles drop-pinning machine operator � textiles embroidery machine operator embroidery machine tender entering machine operator � textiles felt press tender � textiles felting machine tender felt-making machine operator flat knitter flat knitting machine knitter garment looper glass-fibre-bonding machine tender glove knitter harness preparer � textiles harness tier � textiles hosiery knitter hosiery looper � textiles hosiery seamer � textiles hosiery-knitting machine tender jacquard card cutter � textiles jacquard card lacer � textiles jacquard card-cutting machine operator � textiles jacquard card-lacing machine operator � textiles jacquard loom heddles tier jacquard loom knitter jacquard loom pattern changer jacquard loom weaver jacquard machine knitter jacquard machine operator jersey knitter knitter � textiles knitting area patroller � textiles knitting machine operator knitting machine tender knotting machine operator � textiles lace weaver lease worker � textiles leaser � textiles leasing machine tender � textiles link machine knitter loom drawer-in loom drawer-in helper loom operator loom threader loom threader helper loom weaver looper � textiles machine ball fringe maker machine knitting mender machine loom drawer-in machine loom threader machine tassel maker machine warp tier-in � textiles mattress sewing machine operator needle loom operator needle loom weaver net maker, machine � textiles net weaver � textiles net-knitting machine operator � textiles netting-making machine operator � textiles pad mangle operator � textiles padding machine operator � textiles pattern card preparer � textiles pattern puncher � textiles pattern weaver � textiles pinning machine operator pinning machine operator � textiles power loom weaver quilting machine operator rib knitter � textiles ribbing machine operator � textiles rope maker � textiles rope twister rope-coiling machine tender � textiles rope-twisting machine tender rug weaver sample knitter sample weaver scroll-quilting machine operator seamless hosiery knitter sock foot knitter sock knitter � textiles sock looper surgical pad knitter tassel machine tender � textiles textile weaver threader � textiles top knitter topper � textiles transfer knitter tufting machine operator � textiles tufting operator warp drawer � textiles warp drawer-in helper � textiles warp knitting machine tender warp placer � textiles warp tier-in warp tier-in � textiles warp tying machine tender � textiles weaver � textiles",
    "title2": 0,
    "title3": 0,
    "allTitles": "automatic embroidery machine tender automatic stocking loom tender Axminster carpet weaver ball fringe machine tender band-knitting machine operator beam changer � textiles blanket weaver braid maker � textiles braid weaver � textiles braider � textiles braiding machine tender � textiles card lacer � textiles carpet weaver carpet-tufting machine operator carpet-weaving machine operator chain builder � textiles chainman/woman � textiles circular knitter circular knitting machine knitter cloth ribber cloth weaver crochet machine operator crocheting machine operator dobby loom drawer-in dobby loom weaver drawer-in � textiles drawer-in helper � textiles drawing-in machine operator drawing-in machine operator � textiles drop-pinning machine operator � textiles embroidery machine operator embroidery machine tender entering machine operator � textiles felt press tender � textiles felting machine tender felt-making machine operator flat knitter flat knitting machine knitter garment looper glass-fibre-bonding machine tender glove knitter harness preparer � textiles harness tier � textiles hosiery knitter hosiery looper � textiles hosiery seamer � textiles hosiery-knitting machine tender jacquard card cutter � textiles jacquard card lacer � textiles jacquard card-cutting machine operator � textiles jacquard card-lacing machine operator � textiles jacquard loom heddles tier jacquard loom knitter jacquard loom pattern changer jacquard loom weaver jacquard machine knitter jacquard machine operator jersey knitter knitter � textiles knitting area patroller � textiles knitting machine operator knitting machine tender knotting machine operator � textiles lace weaver lease worker � textiles leaser � textiles leasing machine tender � textiles link machine knitter loom drawer-in loom drawer-in helper loom operator loom threader loom threader helper loom weaver looper � textiles machine ball fringe maker machine knitting mender machine loom drawer-in machine loom threader machine tassel maker machine warp tier-in � textiles mattress sewing machine operator needle loom operator needle loom weaver net maker, machine � textiles net weaver � textiles net-knitting machine operator � textiles netting-making machine operator � textiles pad mangle operator � textiles padding machine operator � textiles pattern card preparer � textiles pattern puncher � textiles pattern weaver � textiles pinning machine operator pinning machine operator � textiles power loom weaver quilting machine operator rib knitter � textiles ribbing machine operator � textiles rope maker � textiles rope twister rope-coiling machine tender � textiles rope-twisting machine tender rug weaver sample knitter sample weaver scroll-quilting machine operator seamless hosiery knitter sock foot knitter sock knitter � textiles sock looper surgical pad knitter tassel machine tender � textiles textile weaver threader � textiles top knitter topper � textiles transfer knitter tufting machine operator � textiles tufting operator warp drawer � textiles warp drawer-in helper � textiles warp knitting machine tender warp placer � textiles warp tier-in warp tier-in � textiles warp tying machine tender � textiles weaver � textiles",
    "workers": 245,
    "minEduc": 0,
    "yearsStudy": 1.583333333,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14.26,
    "salaryHigh": 18,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 461,
    "noc": 9445,
    "job": "Fabric, fur and leather cutters",
    "title1": "bias-cutting machine tender � fabric, fur and leather products manufacturing canvas cutter � fabric products manufacturing cloth cutter � fabric products manufacturing cloth-cutting machine operator � fabric products manufacturing clothing cutter clothing cutter � clothing manufacturing cuff-cutting machine tender cutter � leather products manufacturing cutting machine operator � clothing manufacturing die cutter � fabric, fur and leather products manufacturing fabric cutter fabric cutter � fabric products manufacturing fabric marker fur cutter garment marker glove cutter hand cutter � clothing manufacturing hand cutter � fabric, fur and leather products manufacturing hand leather cutter � leather products manufacturing leather cutter leather cutter � leather footwear manufacturing leather garment cutter � manufacturing leather harness maker leather marker leather pressman/woman leather rifle case maker leather trunk maker leather-stripping machine tender � leather products manufacturing machine felt cutter master pattern cutter mink tail slitter � fur products manufacturing pattern cutter saddle cutter � leather products manufacturing sailcloth cutter � fabric products manufacturing sample cutter sample cutter � fabric, fur and leather products manufacturing shoe cutter shoe parts cutter � footwear manufacturing slipcover cutter � fabric products manufacturing slitter and rewinder slitter-rewinder stripping machine tender � leather products manufacturing trimmer � leather products manufacturing upholstery marker and cutter welt maker � hat manufacturing welt-trimming machine tender � hat manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "bias-cutting machine tender � fabric, fur and leather products manufacturing canvas cutter � fabric products manufacturing cloth cutter � fabric products manufacturing cloth-cutting machine operator � fabric products manufacturing clothing cutter clothing cutter � clothing manufacturing cuff-cutting machine tender cutter � leather products manufacturing cutting machine operator � clothing manufacturing die cutter � fabric, fur and leather products manufacturing fabric cutter fabric cutter � fabric products manufacturing fabric marker fur cutter garment marker glove cutter hand cutter � clothing manufacturing hand cutter � fabric, fur and leather products manufacturing hand leather cutter � leather products manufacturing leather cutter leather cutter � leather footwear manufacturing leather garment cutter � manufacturing leather harness maker leather marker leather pressman/woman leather rifle case maker leather trunk maker leather-stripping machine tender � leather products manufacturing machine felt cutter master pattern cutter mink tail slitter � fur products manufacturing pattern cutter saddle cutter � leather products manufacturing sailcloth cutter � fabric products manufacturing sample cutter sample cutter � fabric, fur and leather products manufacturing shoe cutter shoe parts cutter � footwear manufacturing slipcover cutter � fabric products manufacturing slitter and rewinder slitter-rewinder stripping machine tender � leather products manufacturing trimmer � leather products manufacturing upholstery marker and cutter welt maker � hat manufacturing welt-trimming machine tender � hat manufacturing",
    "workers": 245,
    "minEduc": 0,
    "yearsStudy": 1.583333333,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 21,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 462,
    "noc": 9446,
    "job": "Industrial sewing machine operators",
    "title1": "automatic sewing machine operator",
    "title2": "bag sewer, leather",
    "title3": "bag sewer - textile manufacturing",
    "allTitles": "automatic sewing machine operatorbag sewer, leatherbag sewer - textile manufacturingbasting machine operator - sewingbasting sewing machine operator, automaticbinding machine operator - sewingbinding sewing machine operatorbinding stitcher - footwear manufacturingblindstitch-sewing machine operatorbuttonhole finisherbuttonhole machine operatorbuttonhole makerbuttonhole stayerbutton sewer, machinebutton stayercanvas goods sewing machine operatorcarpet bindercarpet sewercloser - sewingcloser sewing machine operatorcloth mendercommercial sewing machine operatordomestic sewing machine operatordouble needle sewing machine operatordouble needle sewing machine stitcherdrapery headerdrapery heading makerdrapery sewerfabric menderfabric repairerfabric repairmanfabric repairwomanfactory hat sewerfancy stitch machine operatorfootwear sewerfur goods sewerfur sewerfur sewing machine operatorgarment braider - garment manufacturinggarment braid maker - garment manufacturinggarment mender - sewingglove stitcherhat sewer, factoryhemmer machine operator - sewingindustrial sewing machine operatorjoiner sewing machine operatorleather garment sewerleather garment sewing machine operatorleather glove repairerleather glove repairmanleather glove repairwomanleather-glove-stitching machine operatorleather products sewing machine operatorleather sewerleather-sewing machine operatorlining sewerlining stitchermachine operator - garment manufacturingmaterial mendermender, garment - sewingmender, textile productsmoccasin sewermultineedle sewing machine operatoroperator, leather gloves stitching machineoperator, sewing machineovercaster - garment manufacturingovercasting machine operatoroveredging machine operatoroverlock sewing machine operatoroverseamer - garment manufacturingpiping-sewing machine operatorpocket setterprofile-pocket sewing machine operatorrepairer, leather gloverepairman, leather gloverepairwoman, leather gloverug joinerrug sewersample sewerserger - garment manufacturingserging machine operatorsewer, fur goodssewer - garment manufacturingsewer, textile productssewing machine operatorsewing machine operator, automaticsewing machine operator, furshoe parts sewershoe sewershoe stitchersingle-needle sewing machine operatorslide-fastener-sewing machine operatorslipper makerstitcher - garment manufacturingstitching machine operator - industrial sewing machinestocking stitchertacking machine operator - sewingtextile products mendertufted carpet menderunderwear sewer",
    "workers": 245,
    "minEduc": 0,
    "yearsStudy": 1.583333333,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 17.5,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 463,
    "noc": 9447,
    "job": "Inspectors and graders, textile, fabric, fur and leather products manufacturing",
    "title1": "blue-leather grader boot and shoe grader boot and shoe inspector boot and shoe sorter canvas goods inspector carpet inspector cloth examiner cloth grader cloth inspector cloth measurer cloth sampler cloth sorter cloth tester clothing inspector cloth-measuring machine tender colour grader � textiles colour matcher � textiles cushion and cover inspector cushion and furniture-coverings manufacturing inspector draper fabric examiner fabric grader fabric inspector fabric manufacturing inspector fabric sampler fibre examiner � textiles fibre grader � textiles fibre inspector � textiles final inspector, garments finishing inspector � textiles fitting room inspector � fabric products manufacturing foundation garments inspector fur grader fur matcher � fur products manufacturing fur sorter fur sorter, hats garment final inspector garment inspector garment manufacturing inspector glove and mitten examiner grader � textiles grader, fabric grader, hosiery greige-cloth examiner hat fur sorter hat inspector hide and pelt processing inspector hide grader hide inspector hide sorter hosiery grader hosiery inspector hosiery pairer hosiery sizer inspecting machine tender � textiles inspector � fabric products manufacturing inspector � fur products manufacturing inspector � textiles inspector, foundation garments inspector, garment inspector, knitting inspector, leather goods inspector, loom inspector, trimming material inspector-grader, seconds jacket manufacturing inspector knitted fabric inspector knitting inspector leather glove examiner leather goods inspector leather grader leather inspector leather sorter leather stock inspector leather tanneries inspector loom inspector narrow fabric examiner parachute inspector � fabric products manufacturing pelt grader � hide and pelt processing pelt processing inspector perch operator perch operator � textiles percher � textiles preshrinking process tester � textiles quality control inspector � textiles quality control tester � textiles quality controller � textiles roving weight gauger � textiles sample checker � textiles sample preparer � textiles sampler � textiles seconds inspector-grader shade matcher � textiles shirt inspector shoe inspector skein yarn examiner � textiles sorter, boot and shoe sorter, leather stocking inspector swatch checker � textiles textile grader textile inspector textile product sampler textile products inspector textile sampler textile shader textile tester thread inspector � textiles trimming material inspector warp tension tester � textiles weaving inspector wool fleece grader wool grader yarn and spun yarn inspector yarn examiner yarn inspector yarn tester",
    "title2": 0,
    "title3": 0,
    "allTitles": "blue-leather grader boot and shoe grader boot and shoe inspector boot and shoe sorter canvas goods inspector carpet inspector cloth examiner cloth grader cloth inspector cloth measurer cloth sampler cloth sorter cloth tester clothing inspector cloth-measuring machine tender colour grader � textiles colour matcher � textiles cushion and cover inspector cushion and furniture-coverings manufacturing inspector draper fabric examiner fabric grader fabric inspector fabric manufacturing inspector fabric sampler fibre examiner � textiles fibre grader � textiles fibre inspector � textiles final inspector, garments finishing inspector � textiles fitting room inspector � fabric products manufacturing foundation garments inspector fur grader fur matcher � fur products manufacturing fur sorter fur sorter, hats garment final inspector garment inspector garment manufacturing inspector glove and mitten examiner grader � textiles grader, fabric grader, hosiery greige-cloth examiner hat fur sorter hat inspector hide and pelt processing inspector hide grader hide inspector hide sorter hosiery grader hosiery inspector hosiery pairer hosiery sizer inspecting machine tender � textiles inspector � fabric products manufacturing inspector � fur products manufacturing inspector � textiles inspector, foundation garments inspector, garment inspector, knitting inspector, leather goods inspector, loom inspector, trimming material inspector-grader, seconds jacket manufacturing inspector knitted fabric inspector knitting inspector leather glove examiner leather goods inspector leather grader leather inspector leather sorter leather stock inspector leather tanneries inspector loom inspector narrow fabric examiner parachute inspector � fabric products manufacturing pelt grader � hide and pelt processing pelt processing inspector perch operator perch operator � textiles percher � textiles preshrinking process tester � textiles quality control inspector � textiles quality control tester � textiles quality controller � textiles roving weight gauger � textiles sample checker � textiles sample preparer � textiles sampler � textiles seconds inspector-grader shade matcher � textiles shirt inspector shoe inspector skein yarn examiner � textiles sorter, boot and shoe sorter, leather stocking inspector swatch checker � textiles textile grader textile inspector textile product sampler textile products inspector textile sampler textile shader textile tester thread inspector � textiles trimming material inspector warp tension tester � textiles weaving inspector wool fleece grader wool grader yarn and spun yarn inspector yarn examiner yarn inspector yarn tester",
    "workers": 245,
    "minEduc": 0,
    "yearsStudy": 1.583333333,
    "automationRisk": 0.89,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 16.3,
    "totalSkill": 117,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13,
    "skillsComp": 32,
    "skillsLogi": 30,
    "skillsMath": 17,
    "skillsLang": 38,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 17,
    "s14Writing": 9,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 50,
    "f4SocialScience": 0,
    "f5FineArts": 45,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 25,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 65,
    "f12Business": 60,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 50,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 45,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 25,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 65,
    "d18Business&Commerce": 60,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 464,
    "noc": 9461,
    "job": "Process control and machine operators, food and beverage processing",
    "title1": "applesauce processor operator",
    "title2": "assistant brewer - food and beverage processing",
    "title3": "assistant miller - food and beverage processing",
    "allTitles": "applesauce processor operatorassistant brewer - food and beverage processingassistant miller - food and beverage processingbacon curerbagging machine setterbagging machine set-up manbagging machine set-up man/womanbagging machine set-up womanBake-off equipment tender - food and beverage processingbakery machine operator - food and beverage processingbasket unloaderbatch mixer, feed - food and beverage processingbatter and dough mixer - food and beverage processingbeer carton packerbeer filter operatorbeer pasteurizerbeet pulp press tenderbeverage-canning machine operatorblanching machine tenderbleacher operator - food and beverage processingblender, margarineblender operator - food and beverage processingblender - tobacco processingbologna makerbolter operator - food and beverage processingbone crusher - food and beverage processingbooker - tobacco processingbottling machine operatorbottling machine operator - food and beverage processingbox machine operator - food and beverage processingbread slicer operatorbread-slicing machine operatorbreaker tank attendant - food and beverage processingbrewerbrewer helper - food and beverage processingbrewery kettle tender - food and beverage processingbrewery pumpmanbrewery pumpman/womanbrewery pumpwomanbrewery stillman - beverage processingbrewery stillman/woman - beverage processingbrewery stillwoman - beverage processingbrewery workerbrewhouse operatorbrine man - food and beverage processingbrine man/woman - food and beverage processingbrine mixer operator - food and beverage processingbrine tank separator tenderbrine woman - food and beverage processingbrown sugar makerbuhr mill operator - food and beverage processingbulk blender - tobacco processingbulker blender - tobacco processingbulk-sausage-stuffing machine operator - food and beverage processingbuncher, cigarbutter makercake mix equipment operator - food and beverage processingcandied fruit processorcandy centre makercandy-cutting machine tendercandy makercandy-making machine tendercandy puller and rollercandy-rolling machine operatorcandy-spinning machine operator - food and beverage processingcan-filling machine operator - food and beverage processingcanned goods cookercanned milk sterilizercanning machine operatorcaramel equipment operatorcarbonation equipment operator - food and beverage processingcarbonator - food and beverage processingcascade blender - tobacco processingcasing machine operator - food and beverage processingcasing machine operator - tobacco processingcasing machine tender - tobacco processingcatsup makercellarman, winery - food and beverage processingcellarman/woman, winery - food and beverage processingcellarwoman, winery - food and beverage processingcentrifugal station tender - food and beverage processingcereal baker - food and beverage processingcereal cleanercereal-cleaning equipment operatorcereal-coating operatorcereal cooker and extruder operatorcereal maker - food and beverage processingcereal oven tenderchar filter tender - food and beverage processingchar kiln tender - food and beverage processingcheese blender - food and beverage processingcheese cookercheese gratercheese makerchewing-gum machine tenderchicle centrifuge operator - food and beverage processingchocolate chips makerchocolate coater - food and beverage processingchocolate crumbs makerchocolate moulder, machine",
    "workers": 8855,
    "minEduc": 0.5,
    "yearsStudy": 2.495265152,
    "automationRisk": 0.7925,
    "salaryLow": 14,
    "salaryMed": 16.5,
    "salaryHigh": 23.13,
    "totalSkill": 120,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 19.16837135,
    "skillsComp": 34.5,
    "skillsLogi": 32,
    "skillsMath": 15,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9.5,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 5,
    "s8OralCommunication": 11.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 2.5,
    "s12DigitalTechnology": 7.5,
    "s13DocumentUse": 23,
    "s14Writing": 10.5,
    "s15CriticalThinking": 3,
    "f1Science&Agriculture": 235,
    "f2Engineering": 160,
    "f3Humanities": 0,
    "f4SocialScience": 20,
    "f5FineArts": 85,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 290,
    "f8Education(teachertraining)": 20,
    "f9Law": 95,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 280,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 110,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 20,
    "d6Fine&AppliedArts": 85,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 290,
    "d9Education(teachertraining)": 20,
    "d10Engineering": 160,
    "d11Law": 95,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 125,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 280,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 465,
    "noc": 9462,
    "job": "Industrial butchers and meat cutters, poultry preparers and related workers",
    "title1": "animal eviscerator � meat packing plant animal skinner � meat packing plant animal sticker � meat packing plant animal stunner beef boner beef boner � meat packing plant beef cooler worker � meat packing plant beef sticker � meat packing plant beef trimmer � meat packing plant beef-pluck trimmer benchman/woman � meat packing plant boner, meat brisket cutter � meat packing plant butcher, industrial butcher, slaughterhouse calf skinner � meat packing plant carcass splitter � meat packing plant chicken plucker cutter � meat packing plant dehairing machine dropper � meat packing plant dropper, dehairing machine � meat packing plant enzyme injector � food and beverage processing eviscerator, animals � meat packing plant eviscerator, poultry ham cutter ham sawyer � meat packing plant head boner � meat packing plant hog killer industrial butcher industrial meat chopper industrial meat cutter livestock killer meat boner meat chopper � meat packing plant meat cutter � meat packing plant meat dresser � meat packing plant meat portion cutter � meat packing plant meat roll tier � food and beverage processing meat sawyer � meat packing plant meat tenderizer � food and beverage processing meat trimmer meat trimmer � meat packing plant poultry boner poultry butcher � meat packing plant poultry dresser poultry eviscerator poultry hanger poultry plucker poultry plucker tender poultry preparer poultry slaughterer � food and beverage processing poultry worker � meat packing plant ritual slaughterer � meat packing plant shackle hoist operator � meat packing plant sheep sticker shohet � meat packing plant skinner, animals � meat packing plant slaughterer slaughterer � meat packing plant slaughterer, ritual � meat packing plant slaughterhouse butcher sticker, animals � meat packing plant trimmer � meat packing plant trimmer, meat � meat packing plant",
    "title2": 0,
    "title3": 0,
    "allTitles": "animal eviscerator � meat packing plant animal skinner � meat packing plant animal sticker � meat packing plant animal stunner beef boner beef boner � meat packing plant beef cooler worker � meat packing plant beef sticker � meat packing plant beef trimmer � meat packing plant beef-pluck trimmer benchman/woman � meat packing plant boner, meat brisket cutter � meat packing plant butcher, industrial butcher, slaughterhouse calf skinner � meat packing plant carcass splitter � meat packing plant chicken plucker cutter � meat packing plant dehairing machine dropper � meat packing plant dropper, dehairing machine � meat packing plant enzyme injector � food and beverage processing eviscerator, animals � meat packing plant eviscerator, poultry ham cutter ham sawyer � meat packing plant head boner � meat packing plant hog killer industrial butcher industrial meat chopper industrial meat cutter livestock killer meat boner meat chopper � meat packing plant meat cutter � meat packing plant meat dresser � meat packing plant meat portion cutter � meat packing plant meat roll tier � food and beverage processing meat sawyer � meat packing plant meat tenderizer � food and beverage processing meat trimmer meat trimmer � meat packing plant poultry boner poultry butcher � meat packing plant poultry dresser poultry eviscerator poultry hanger poultry plucker poultry plucker tender poultry preparer poultry slaughterer � food and beverage processing poultry worker � meat packing plant ritual slaughterer � meat packing plant shackle hoist operator � meat packing plant sheep sticker shohet � meat packing plant skinner, animals � meat packing plant slaughterer slaughterer � meat packing plant slaughterer, ritual � meat packing plant slaughterhouse butcher sticker, animals � meat packing plant trimmer � meat packing plant trimmer, meat � meat packing plant",
    "workers": 10682.5,
    "minEduc": 0.5,
    "yearsStudy": 3.010355791,
    "automationRisk": 0.75875,
    "salaryLow": 14,
    "salaryMed": 18,
    "salaryHigh": 22.7,
    "totalSkill": 120,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 23.69118136,
    "skillsComp": 35,
    "skillsLogi": 31.25,
    "skillsMath": 14.25,
    "skillsLang": 40,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.25,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6.25,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.25,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 4.25,
    "s8OralCommunication": 13.75,
    "s9ProblemSolving": 8.75,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3.25,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 21.25,
    "s14Writing": 10,
    "s15CriticalThinking": 3.25,
    "f1Science&Agriculture": 150,
    "f2Engineering": 80,
    "f3Humanities": 0,
    "f4SocialScience": 10,
    "f5FineArts": 42.5,
    "f6MathAndComputerScience": 10,
    "f7Arts&Education": 152.5,
    "f8Education(teachertraining)": 10,
    "f9Law": 47.5,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 12.5,
    "f12Business": 140,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 87.5,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 10,
    "d6Fine&AppliedArts": 42.5,
    "d7ComputerScience": 10,
    "d8OtherArts&Science": 152.5,
    "d9Education(teachertraining)": 10,
    "d10Engineering": 80,
    "d11Law": 47.5,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 62.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 12.5,
    "d18Business&Commerce": 140,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 466,
    "noc": 9463,
    "job": "Fish and seafood plant workers",
    "title1": "basket filter tender � fish and seafood processing can filler � fish and seafood processing can-filling machine operator � fish processing canner, oysters � fish processing centrifuge machine tender � fish processing clam shucker � fish and seafood processing clam steamer � fish and seafood processing clam-shucking machine tender � fish and seafood processing cleaner and cutter, fish � fish processing crab butcher � fish and seafood processing crab steamer � fish and seafood processing curer, fish � fish processing cutter, fish � fish processing fillet chopper � fish processing filleting machine operator � fish processing filleting machine setter � fish processing filling machine operator � fish and seafood products fish boner � fish processing fish broiler � fish processing fish by-products processor fish cake former � fish processing fish cake maker fish cake maker � fish processing fish cake processor � fish processing fish canning machine operator fish canning machine operator � fish processing fish cleaner and cutter fish cleaner and cutter � fish processing fish cook � fish processing fish curer � fish processing fish cutter � fish processing fish cutting machine operator � fish processing fish cutting machine setter � fish processing fish dresser � fish processing fish dryer and grinder tender � fish processing fish dryer tender � fish processing fish egg processor � fish processing fish fryer � fish processing fish header � fish processing fish offal processor � fish processing fish oil extractor tender � fish processing fish paste grinder � fish processing fish plant machine operator � fish processing fish plant worker fish presser operator � fish processing fish processor fish products maker � fish processing fish skinner operator � fish processing fish smoke chamber tender � fish processing fish smoker � fish processing fish splitter � fish processing fish stick machine tender � fish processing fish trimmer � fish processing fish-cleaning machine tender � fish processing fish-processing machine operator fish-processing machine tender fish-processing plant worker fish-skinning machine operator � fish processing frozen fish cutter � fish processing fryer, fish � fish processing hand shellfish processor � fish and seafood processing lobster processor � fish processing machine operator � fish processing oyster canner � fish processing oyster packer � fish processing oyster shucker � fish processing oyster washer tender � fish processing packer, oysters � fish processing plant worker, fish preparer, seafood � fish and seafood processing processing plant worker, fish scallop shucker � fish and seafood processing seafood preparer � fish and seafood processing shellfish processor shellfish processor, hand � fish and seafood processing shellfish separator tender � fish and seafood processing shellfish shucker shellfish shucker � fish and seafood processing shellfish-processing machine tender shrimp peeler � fish and seafood processing shrimp peeler tender � fish and seafood processing shrimp processor � fish and seafood processing shucker � fish and seafood processing shucker, clams � fish and seafood processing shucker, oysters � fish processing shucker, scallops � fish and seafood processing skinner operator � fish processing skinning machine setter � fish processing smoke chamber tender, fish � fish processing splitter, fish � fish processing steamer, clams � fish and seafood processing trimmer � fish processing",
    "title2": 0,
    "title3": 0,
    "allTitles": "basket filter tender � fish and seafood processing can filler � fish and seafood processing can-filling machine operator � fish processing canner, oysters � fish processing centrifuge machine tender � fish processing clam shucker � fish and seafood processing clam steamer � fish and seafood processing clam-shucking machine tender � fish and seafood processing cleaner and cutter, fish � fish processing crab butcher � fish and seafood processing crab steamer � fish and seafood processing curer, fish � fish processing cutter, fish � fish processing fillet chopper � fish processing filleting machine operator � fish processing filleting machine setter � fish processing filling machine operator � fish and seafood products fish boner � fish processing fish broiler � fish processing fish by-products processor fish cake former � fish processing fish cake maker fish cake maker � fish processing fish cake processor � fish processing fish canning machine operator fish canning machine operator � fish processing fish cleaner and cutter fish cleaner and cutter � fish processing fish cook � fish processing fish curer � fish processing fish cutter � fish processing fish cutting machine operator � fish processing fish cutting machine setter � fish processing fish dresser � fish processing fish dryer and grinder tender � fish processing fish dryer tender � fish processing fish egg processor � fish processing fish fryer � fish processing fish header � fish processing fish offal processor � fish processing fish oil extractor tender � fish processing fish paste grinder � fish processing fish plant machine operator � fish processing fish plant worker fish presser operator � fish processing fish processor fish products maker � fish processing fish skinner operator � fish processing fish smoke chamber tender � fish processing fish smoker � fish processing fish splitter � fish processing fish stick machine tender � fish processing fish trimmer � fish processing fish-cleaning machine tender � fish processing fish-processing machine operator fish-processing machine tender fish-processing plant worker fish-skinning machine operator � fish processing frozen fish cutter � fish processing fryer, fish � fish processing hand shellfish processor � fish and seafood processing lobster processor � fish processing machine operator � fish processing oyster canner � fish processing oyster packer � fish processing oyster shucker � fish processing oyster washer tender � fish processing packer, oysters � fish processing plant worker, fish preparer, seafood � fish and seafood processing processing plant worker, fish scallop shucker � fish and seafood processing seafood preparer � fish and seafood processing shellfish processor shellfish processor, hand � fish and seafood processing shellfish separator tender � fish and seafood processing shellfish shucker shellfish shucker � fish and seafood processing shellfish-processing machine tender shrimp peeler � fish and seafood processing shrimp peeler tender � fish and seafood processing shrimp processor � fish and seafood processing shucker � fish and seafood processing shucker, clams � fish and seafood processing shucker, oysters � fish processing shucker, scallops � fish and seafood processing skinner operator � fish processing skinning machine setter � fish processing smoke chamber tender, fish � fish processing splitter, fish � fish processing steamer, clams � fish and seafood processing trimmer � fish processing",
    "workers": 10682.5,
    "minEduc": 0.5,
    "yearsStudy": 3.010355791,
    "automationRisk": 0.75875,
    "salaryLow": 16.33333333,
    "salaryMed": 20.90333333,
    "salaryHigh": 28.95333333,
    "totalSkill": 120,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 23.69118136,
    "skillsComp": 35,
    "skillsLogi": 31.25,
    "skillsMath": 14.25,
    "skillsLang": 40,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4.25,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6.25,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.25,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 4.25,
    "s8OralCommunication": 13.75,
    "s9ProblemSolving": 8.75,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 3.25,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 21.25,
    "s14Writing": 10,
    "s15CriticalThinking": 3.25,
    "f1Science&Agriculture": 150,
    "f2Engineering": 80,
    "f3Humanities": 0,
    "f4SocialScience": 10,
    "f5FineArts": 42.5,
    "f6MathAndComputerScience": 10,
    "f7Arts&Education": 152.5,
    "f8Education(teachertraining)": 10,
    "f9Law": 47.5,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 12.5,
    "f12Business": 140,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 87.5,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 10,
    "d6Fine&AppliedArts": 42.5,
    "d7ComputerScience": 10,
    "d8OtherArts&Science": 152.5,
    "d9Education(teachertraining)": 10,
    "d10Engineering": 80,
    "d11Law": 47.5,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 62.5,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 12.5,
    "d18Business&Commerce": 140,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 467,
    "noc": 9465,
    "job": "Testers and graders, food and beverage processing",
    "title1": "bacon grader",
    "title2": "beef grader",
    "title3": "beer bottling line quality control tester",
    "allTitles": "bacon graderbeef graderbeer bottling line quality control testerbeer testerbeverage and bottle inspectorbeverage inspectorbread testerbrewery tester - food and beverage processingbutterfat testerbutter gradercandy inspectorcan inspector - food and beverage processingcanned and bottled foods inspectorcapon grader - food and beverage processingcasing grader - food and beverage processingcheese gradercigarette gradercigarette testercigar gradercookie and cracker testercream graderdairy cream testerdairy grader - food and beverage processingdairy moisture testerdairy product tester - food and beverage processingdairy tester - food and beverage processingdressed poultry graderfeed tester - food and beverage processingfermentation inspector, wineriesfilter tip inspector - tobacco processingfish graderfood and beverage processing graderfruit and vegetable grader - food and beverage processinggauger - wineriesgrader, buttergrader, cheesesgrader, cigarettesgrader, cigarsgrader, creamgrader, fishgrader - food and beverage processinggrader, lambgrader, meatgrader, milkgrader, tobaccograin sampler - food and beverage processingham graderhogshead inspector - tobacco processinghoney grader and blenderinspector, beveragesinspector, beverages and bottlesinspector, canned and bottled foodsinspector, filter tip - tobacco processinginspector, kosher - food and beverage processingkosher inspector - food and beverage processinglamb graderliquor tester - food and beverage processingmashgiach - food and beverage processingmeat gradermilk gradermilk receiver-testermoisture content tester - dairy productsmoisture content tester - tobacco processingpork graderpoultry graderprocess control checker - food and beverage processingproduce grader - food and beverage processingproduct tester - food and beverage processingquality control checker - food and beverage processingquality control tester, beer bottling lineseed corn gradersoybean testerstarch tester - food and beverage processingsugar testertenderometer tender - food and beverage processingtest baker - food and beverage processingtester, beertester, cookies and crackerstester, liquor - food and beverage processingtester, moisture content - tobacco processingtester, products - food and beverage processingtester, sugartobacco gradertobacco leaf gradertobacco sample pullerveal graderwineries fermentation inspectorwineries gaugerwine tester",
    "workers": 12510,
    "minEduc": 0.5,
    "yearsStudy": 3.525446429,
    "automationRisk": 0.725,
    "salaryLow": 21,
    "salaryMed": 28.21,
    "salaryHigh": 41.03,
    "totalSkill": 120,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in trades, transportation, production and utilities",
    "cluster": 1,
    "wage": 28.21399136,
    "skillsComp": 35.5,
    "skillsLogi": 30.5,
    "skillsMath": 13.5,
    "skillsLang": 41,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 5,
    "s2DecisionMaking": 10.5,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 4.5,
    "s6MoneyMath": 1.5,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 16,
    "s9ProblemSolving": 8,
    "s10Reading": 15,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 10.5,
    "s13DocumentUse": 19.5,
    "s14Writing": 9.5,
    "s15CriticalThinking": 3.5,
    "f1Science&Agriculture": 65,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 15,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 65,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 15,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 468,
    "noc": 9471,
    "job": "Plateless printing equipment operators",
    "title1": "balloon printer",
    "title2": "blueprint blocker",
    "title3": "blueprint developer",
    "allTitles": "balloon printerblueprint blockerblueprint developerblueprinting machine operatorbox, case and lining printerbox printer - printingbox-printing machine operatorbraille duplicatorbraille-impressing machine operatorbraille printercolour and large copier operatorcolour copier operatorcolour photocopier operatorcolour photocopy operatorcopy, staple and glue machine operatordie stamper - printingelectronic printing machine operatorelectronic sign maker operatorembossing-imprinting machine operatorembossing printerengraving machine operator - printingfloorcovering printerglove printerhigh speed printer operatorlabel printerlaser printer operatormachine advertising signs printermachine markermachine printer, advertising signsmachine printer, signsmachine shotgun-shell printermachine sign writeroffline-printing machine operatoroperator, printing machine - printingoperator, transfer pressphotocopying machine tenderphotocopy operator, colourplastic printerpochoir silk-screen printing machine operatorpress operator, transferprinter, boxes, cases and liningsprinter operator - printingprinter-slotter operatorprinter-slotter tenderprinting machine operatorprinting machine operator - printingproofsheet approver - printingquick print machine operatorruling machine operator - printingscreen printing machine operator - printingscreen print operatorshotgun-shell printer, machineshotgun-shell-printing machine tendersign writer, machinesilk-screening machine operatorsilk-screen printing machine operatorsilk-screen tender - printingsteel die printerstencil silk-screen printing machine operatortabulating cards printertag-printing machine tendertape rule printertransfer machine tender - printingtransfer press operatorwallpaper printerwallpaper sample sheet cutter-markerwallpaper sample sheet marker",
    "workers": 26080,
    "minEduc": 0.5,
    "yearsStudy": 2.752480418,
    "automationRisk": 0.5045,
    "salaryLow": 14,
    "salaryMed": 16,
    "salaryHigh": 26.71,
    "totalSkill": 129,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Professional occupations in business and finance",
    "cluster": 4,
    "wage": 23,
    "skillsComp": 34.5,
    "skillsLogi": 35.5,
    "skillsMath": 17.5,
    "skillsLang": 41,
    "topSkill1": "Document Use",
    "topSkill2": "Oral Communication",
    "topSkill3": "Reading",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 3.5,
    "s8OralCommunication": 15,
    "s9ProblemSolving": 12,
    "s10Reading": 14.5,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 14,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 35,
    "f2Engineering": 90,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 500,
    "f6MathAndComputerScience": 35,
    "f7Arts&Education": 35,
    "f8Education(teachertraining)": 0,
    "f9Law": 20,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 70,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 500,
    "d7ComputerScience": 35,
    "d8OtherArts&Science": 35,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 90,
    "d11Law": 20,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 35,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 70,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 469,
    "noc": 9472,
    "job": "Camera, platemaking and other prepress occupations",
    "title1": "alignment examiner � printing assembler, flexographic printing cylinders assistant newspaper make-up man/woman automated letterer-engraver bright type processor camera operator � graphic arts camera operator � printing camera operator, colour separation � printing camera operator, photogravure � printing carbon tissue cylinder preparer � printing clamper � camera and platemaking colour correction scanning machine operator colour edition preparer � printing colour printer-technician � photographic processing colour scanner operator � printing colour separation assistant � scanning colour separation camera operator colour separation camera operator � printing colour separation electronic scanning machine operator colour separation operator colour-editing terminal operator � printing computer-assisted letterer-engraver contact printer copper engraver � camera and platemaking copper photoengraver copperplate photoengraver cylinder engraver, printing cylinder painter � printing cylinder preparer � printing cylinder preparer, carbon tissue � printing cylinder-impresser operator digital printing technician dot etcher dot etcher � printing electronic engraver electronic prepress technician electronic scanning machine operator, colour separation electroplating tank tender electrostatic camera operator electrotyper � printing electrotyper and platemaker engraver, pictures � printing engraver, printing cylinders engraver, printing plates engraver, templates engraver-letterer engraver-transferrer etcher � printing etcher, photoengraving � printing etcher, platemaking etching corrector file preparation operator film assembler film sizer film stripper film stripper and layout specialist � printing film stripper specialist � printing film stripper-assembler film stripper-assembler � printing flexible plate engraver flexible printing plate mounter flexible-plate hand engraver flexographic mounter-proofer flexographic printing cylinder assembler graphic arts camera operator gravure printer � prepress halftone camera operator � printing image processing operator image reproduction machine operator image setter operator image-processing system operator laser beam colour scanner operator lineup examiner � printing lithographic plate preparer lithographic platemaker monochrome plate film stripper negative merger negative spotter � printing offset plate preparer offset platemaker offset printing plate preparer opticopy keypunch operator � printing opticopy machine operator � printing opticopy offline programmer � printing opticopy program tape preparer � printing pantograph setter pantographer � printing paper-plate maker photoengraver � printing photoengraving etcher � printing photoengraving finisher photoengraving platemaker photoengraving retoucher � printing photogravure camera operator � printing photopolymer platemaker picture engraver � printing plate finisher � printing plate grainer � printing plate processor � printing plate processor operator � printing plate-graining machine tender platemaker platemaker � printing platemaking etcher pre-flight operator � printing prepress technician preprint-coating machine tender print roller repairer print transferrer � printing printing cylinder engraver printing plate engraver printing plate moulder printing plate presensitizer tender process camera operator processor � printing proofmaker proofmaker � printing retoucher, photoengraving � printing roller engraver � printing rotogravure cylinder technician rotogravure press technician scanner operator � printing scanning machine operator, colour corrections screenmaker siderographer � printing silkscreen assembler � printing stager � printing stencil preparer step and repeat camera operator stereotyper stripper � printing stripper-assembler, film � printing stripper-image assembler � printing stripper-layout specialist � printing studio-image-processing system operator template engraver tracer-transferrer transferrer",
    "title2": 0,
    "title3": 0,
    "allTitles": "alignment examiner � printing assembler, flexographic printing cylinders assistant newspaper make-up man/woman automated letterer-engraver bright type processor camera operator � graphic arts camera operator � printing camera operator, colour separation � printing camera operator, photogravure � printing carbon tissue cylinder preparer � printing clamper � camera and platemaking colour correction scanning machine operator colour edition preparer � printing colour printer-technician � photographic processing colour scanner operator � printing colour separation assistant � scanning colour separation camera operator colour separation camera operator � printing colour separation electronic scanning machine operator colour separation operator colour-editing terminal operator � printing computer-assisted letterer-engraver contact printer copper engraver � camera and platemaking copper photoengraver copperplate photoengraver cylinder engraver, printing cylinder painter � printing cylinder preparer � printing cylinder preparer, carbon tissue � printing cylinder-impresser operator digital printing technician dot etcher dot etcher � printing electronic engraver electronic prepress technician electronic scanning machine operator, colour separation electroplating tank tender electrostatic camera operator electrotyper � printing electrotyper and platemaker engraver, pictures � printing engraver, printing cylinders engraver, printing plates engraver, templates engraver-letterer engraver-transferrer etcher � printing etcher, photoengraving � printing etcher, platemaking etching corrector file preparation operator film assembler film sizer film stripper film stripper and layout specialist � printing film stripper specialist � printing film stripper-assembler film stripper-assembler � printing flexible plate engraver flexible printing plate mounter flexible-plate hand engraver flexographic mounter-proofer flexographic printing cylinder assembler graphic arts camera operator gravure printer � prepress halftone camera operator � printing image processing operator image reproduction machine operator image setter operator image-processing system operator laser beam colour scanner operator lineup examiner � printing lithographic plate preparer lithographic platemaker monochrome plate film stripper negative merger negative spotter � printing offset plate preparer offset platemaker offset printing plate preparer opticopy keypunch operator � printing opticopy machine operator � printing opticopy offline programmer � printing opticopy program tape preparer � printing pantograph setter pantographer � printing paper-plate maker photoengraver � printing photoengraving etcher � printing photoengraving finisher photoengraving platemaker photoengraving retoucher � printing photogravure camera operator � printing photopolymer platemaker picture engraver � printing plate finisher � printing plate grainer � printing plate processor � printing plate processor operator � printing plate-graining machine tender platemaker platemaker � printing platemaking etcher pre-flight operator � printing prepress technician preprint-coating machine tender print roller repairer print transferrer � printing printing cylinder engraver printing plate engraver printing plate moulder printing plate presensitizer tender process camera operator processor � printing proofmaker proofmaker � printing retoucher, photoengraving � printing roller engraver � printing rotogravure cylinder technician rotogravure press technician scanner operator � printing scanning machine operator, colour corrections screenmaker siderographer � printing silkscreen assembler � printing stager � printing stencil preparer step and repeat camera operator stereotyper stripper � printing stripper-assembler, film � printing stripper-image assembler � printing stripper-layout specialist � printing studio-image-processing system operator template engraver tracer-transferrer transferrer",
    "workers": 8761.666667,
    "minEduc": 0.833333333,
    "yearsStudy": 2.000826806,
    "automationRisk": 0.814833333,
    "salaryLow": 14,
    "salaryMed": 21.42,
    "salaryHigh": 40.04,
    "totalSkill": 122.6666667,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 17.06666667,
    "skillsComp": 38.5,
    "skillsLogi": 30.5,
    "skillsMath": 20.5,
    "skillsLang": 33,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 10.33333333,
    "s3FindingInformation": 6.333333333,
    "s4JobTaskPlanningandOrganizing": 2.833333333,
    "s5MeasurementandCalculation": 7.333333333,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3.833333333,
    "s8OralCommunication": 10.33333333,
    "s9ProblemSolving": 9.333333333,
    "s10Reading": 14.83333333,
    "s11SchedulingorBudgetingandAccounting": 5.333333333,
    "s12DigitalTechnology": 10.66666667,
    "s13DocumentUse": 23.33333333,
    "s14Writing": 8,
    "s15CriticalThinking": 1.5,
    "f1Science&Agriculture": 11.66666667,
    "f2Engineering": 30,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 221.6666667,
    "f6MathAndComputerScience": 11.66666667,
    "f7Arts&Education": 11.66666667,
    "f8Education(teachertraining)": 0,
    "f9Law": 6.666666667,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 36.66666667,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 221.6666667,
    "d7ComputerScience": 11.66666667,
    "d8OtherArts&Science": 11.66666667,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 30,
    "d11Law": 6.666666667,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 11.66666667,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 36.66666667,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 470,
    "noc": 9473,
    "job": "Binding and finishing machine operators",
    "title1": "assistant binder",
    "title2": "assistant bookbinder",
    "title3": "binder and finisher",
    "allTitles": "assistant binderassistant bookbinderbinder and finisherbinder and finisher - printingbinder assistantbinder, machine - printingbinder - printingbindery machine operator - printingbindery operatorbindery worker - printingbinding and finishing machine operatorblocking press operator - printingblocking press stamper - printingbookbinder assistantbookbinder, machinebookbinder - printingbookbinding machine operatorbook-cutting machine operatorbook finisher - printingbook-sewing machine operator - printingbook trimmerbronzer, machine - printingbronzer - printingbronzing machine tender - printingcasing-in machine set-up operator - printingcasing-in machine tender - printingCerlox binder operatorCerlox binder operator - printingcollating machine operator - printingcollator and gluer, machine - printingcontinuous glue machine operator - printingcovering machine operator - printingcredit card die-cutter operator - printingcutter, guillotine - printingcutter, machine - printingcutter operator - printingcutting machine operator, bookscutting machine operator - printingdesign and lettering stamper - printingdie-cutting or die-numbering press operator - printingdie-cutting platen press operator - printingembossing/encoding machine tender - printingembossing press operator - printingembossing press tender - printingfinishing machine operator - printingfoil stamper - printingfoil-stamping platen press operatorfolder, machine - printingfolder operator - printingfolding machine operator - printinggatherer and gluer, machine - printinggathering machine operator - printinggathering machine set-up operator - printinggluer, headbands and liners - printinggluing and folding machine operator - printinggold leaf stampergold leaf stamper - printingguillotine cutter - printingguillotine operator - printinghand stitcher - bindingheadband and liner gluer - printinghologram-imprinting machine tenderindustrial binder - printinginserting machine operator - printinglaminating machine operatorlaminating machine operator - printingmachine binder - printingmachine bookbindermachine bronzer - printingmachine collator and gluer - printingmachine cutter - printingmachine folder - printingmachine gatherer and gluer - printingmachine operator, binding and finishingmachine side stitcher - printingmachine stitcher - bindingnumbering machine operator - printingoperator, binderyoperator, bindery machine - printingoperator, binding and finishing machineoperator, bookbinding machineoperator, book-cutting machineoperator, book-sewing machine - printingoperator, Cerlox binder - printingoperator, collating machine - printingoperator, continuous glue machine - printingoperator, covering machine - printingoperator, credit card die cutter - printingoperator, cutter - printingoperator, cutting machine - printingoperator, die-cutting or die-numbering press - printingoperator, die-cutting platen pressoperator, embossing press - printingoperator, finishing machine - printingoperator, foil-stamping platen pressoperator, folder - printingoperator, folding machine - printingoperator, gathering machine - printingoperator, gluing and folding machine - printingoperator, guillotine - printing",
    "workers": 110,
    "minEduc": 1,
    "yearsStudy": 1.25,
    "automationRisk": 0.95,
    "salaryLow": 14,
    "salaryMed": 15,
    "salaryHigh": 27.95,
    "totalSkill": 115,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 15,
    "skillsComp": 40,
    "skillsLogi": 28,
    "skillsMath": 21,
    "skillsLang": 26,
    "topSkill1": "Document Use",
    "topSkill2": "Decision Making",
    "topSkill3": "Decision Making",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 13,
    "s3FindingInformation": 5,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 6,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 7,
    "s9ProblemSolving": 7,
    "s10Reading": 13,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 27,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 110,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 110,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 471,
    "noc": 9474,
    "job": "Photographic and film processors",
    "title1": "analyzer, colour films - photographic processing",
    "title2": "chemical mixer - photographic processing",
    "title3": "colour film analyzer - photographic processing",
    "allTitles": "analyzer, colour films - photographic processingchemical mixer - photographic processingcolour film analyzer - photographic processingcopy camera operator - photographic processingcutter, negatives - film processingdarkroom techniciandarkroom technician - photographic processingdeveloper, filmsdeveloper, motion picture filmdeveloper, photographsdeveloper, photosdeveloper-printer machine tenderdeveloper-printer, photosdeveloper, printsdeveloper, X-ray filmsdeveloper, X-ray platesdeveloping machine operator - photographic processingenlarger operator - photographic processingenlarger, photographsenlarger, pictures - photographic processingexaminer, motion picture film - photographic processingfilm developerfilm-developing machine tenderfilm printing machine operatorfilm-printing machine tenderfilm-processing machine operatorfilm processing technicianfilm processorfilm splicer - photographic processingfinisher, photosfinisher, prints - photographic processinginspector, photographs - photographic processinginspector, prints - photographic processingmaker, slides - photographic processingmixer, chemicals - photographic processingmotion picture film developermotion picture film examiner - photographic processingmotion picture film printermounter, photographsnegative-contact-frame operatornegative cutter - film processingnegative restorer - photographic processingnegative retouchernegative spotter - film processingoperator, copy camera - photographic processingoperator, developing machine - photographic processingoperator, film-printing machineoperator, film-processing machineoperator, negative-contact-frameoperator, photographic and film processing machinephoto developerphoto developer-printerphoto developing inspectorphotofinisherphotograph developerphotograph developing inspectorphotograph enlargerphotographic and film-processing machine operatorphotographic enlarger operatorphotographic film printerphotographic-film-processing machine operatorphotographic film processorphotographic printerphotographic-processing machine operatorphotographic processorphotograph inspectorphotograph inspector - photographic processingphotograph mounterphoto lab technicianphoto processorphoto technicianpicture enlarger - photographic processingprint developerprinter, motion picture filmprinter, photographic filmsprinter, photographsprint finisher - photographic processingprint inspector - photographic processingprint retoucher - photographic processingprint tender - photographic processingprocessor, filmsprocessor, photographic filmquick print machine tender - photographic processingrestorer, negatives - photographic processingretoucher, negativesslide maker - photographic processingsplicer, films - photographic processingspotter, negatives - film processingtechnician, darkroom - photographic processingtechnician, film processingtechnician, phototechnician, photo labtender, developer-printer machinetender, film-developing machinetender, film-printing machinetender, quick print machine - photographic processingX-ray film developerX-ray plate developer",
    "workers": 95,
    "minEduc": 1,
    "yearsStudy": 2,
    "automationRisk": 0.99,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 32,
    "totalSkill": 124,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Processing and manufacturing machine operators and related production workers",
    "cluster": 7,
    "wage": 13.2,
    "skillsComp": 41,
    "skillsLogi": 28,
    "skillsMath": 23,
    "skillsLang": 32,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Measurement and Calculation",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 8,
    "s3FindingInformation": 8,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 10,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 9,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 9,
    "s13DocumentUse": 26,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 55,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 55,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 472,
    "noc": 9521,
    "job": "Aircraft assemblers and aircraft assembly inspectors",
    "title1": "aileron fitter � aircraft assembly aircraft assembler aircraft assembly inspector aircraft assembly rigger aircraft bench assembler aircraft fabrication inspector aircraft final assembly inspector aircraft fitter-assembler � aircraft assembly aircraft inspector, assemblies and installations aircraft inspector, assembly aircraft parts fitter � aircraft assembly aircraft power plant assembler-installer aircraft rigger � aircraft assembly aircraft rigging and controls mechanic � aircraft assembly aircraft sealer � aircraft assembly aircraft structure and surface assembler aircraft structure assembler aircraft tester � aircraft assembly airframe assembler airframe assembler � aircraft assembly airframe fitter � aircraft assembly airframe subassembler airframe unit assembler assembler, aircraft assembler, aircraft structures and surfaces assembler, airframes � aircraft assembly assembler, power plants � aircraft assembly assembly inspector, aircraft bench and structural assembler bench and structural assembler � aircraft assembly bench assembler, aircraft bench fitter � aircraft assembly bench fitter mechanic � aircraft assembly control assembler, aircraft detail assembler � aircraft assembly detail inspector � aircraft assembly development mechanic � aircraft assembly drill and ream mechanic � aircraft assembly fabric installer-repairer � aircraft assembly final-assembly inspector � aircraft assembly final-assembly inspector, aircraft fitter, ailerons � aircraft assembly fitter, bench � aircraft assembly fitter-tester, welded assembly � aircraft assembly fuselage assembler fuselage fitter � aircraft assembly hydraulic installation � aircraft assembly hydraulic system installer � aircraft assembly inspector, aircraft assembly inspector, aircraft fabrication installation mechanic, power plants � aircraft assembly installation, hydraulic � aircraft assembly mechanic, power plant installation � aircraft assembly mechanic, wing marry-up � aircraft assembly mechanic, wing tanks � aircraft assembly power plant assembler � aircraft assembly power plant installation mechanic � aircraft assembly power plant mechanic � aircraft assembly pressure compartment sealer and tester � aircraft assembly propeller mechanic � aircraft assembly rigger � aircraft assembly rigger mechanic, aircraft controls rigger, aircraft � aircraft assembly rigger, aircraft assembly sealer � aircraft assembly sealer and tester, pressurized compartments � aircraft assembly sealer, aircraft � aircraft assembly sheet metal assembler � aircraft assembly skin fitter � aircraft assembly spar assembler � aircraft assembly structural assembler, bench � aircraft assembly subassembler � aircraft assembly welded assemblies fitter-tester � aircraft assembly wing assembler, aircraft wing inspector � aircraft assembly wing marry-up mechanic � aircraft assembly wing tank mechanic � aircraft assembly",
    "title2": 0,
    "title3": 0,
    "allTitles": "aileron fitter � aircraft assembly aircraft assembler aircraft assembly inspector aircraft assembly rigger aircraft bench assembler aircraft fabrication inspector aircraft final assembly inspector aircraft fitter-assembler � aircraft assembly aircraft inspector, assemblies and installations aircraft inspector, assembly aircraft parts fitter � aircraft assembly aircraft power plant assembler-installer aircraft rigger � aircraft assembly aircraft rigging and controls mechanic � aircraft assembly aircraft sealer � aircraft assembly aircraft structure and surface assembler aircraft structure assembler aircraft tester � aircraft assembly airframe assembler airframe assembler � aircraft assembly airframe fitter � aircraft assembly airframe subassembler airframe unit assembler assembler, aircraft assembler, aircraft structures and surfaces assembler, airframes � aircraft assembly assembler, power plants � aircraft assembly assembly inspector, aircraft bench and structural assembler bench and structural assembler � aircraft assembly bench assembler, aircraft bench fitter � aircraft assembly bench fitter mechanic � aircraft assembly control assembler, aircraft detail assembler � aircraft assembly detail inspector � aircraft assembly development mechanic � aircraft assembly drill and ream mechanic � aircraft assembly fabric installer-repairer � aircraft assembly final-assembly inspector � aircraft assembly final-assembly inspector, aircraft fitter, ailerons � aircraft assembly fitter, bench � aircraft assembly fitter-tester, welded assembly � aircraft assembly fuselage assembler fuselage fitter � aircraft assembly hydraulic installation � aircraft assembly hydraulic system installer � aircraft assembly inspector, aircraft assembly inspector, aircraft fabrication installation mechanic, power plants � aircraft assembly installation, hydraulic � aircraft assembly mechanic, power plant installation � aircraft assembly mechanic, wing marry-up � aircraft assembly mechanic, wing tanks � aircraft assembly power plant assembler � aircraft assembly power plant installation mechanic � aircraft assembly power plant mechanic � aircraft assembly pressure compartment sealer and tester � aircraft assembly propeller mechanic � aircraft assembly rigger � aircraft assembly rigger mechanic, aircraft controls rigger, aircraft � aircraft assembly rigger, aircraft assembly sealer � aircraft assembly sealer and tester, pressurized compartments � aircraft assembly sealer, aircraft � aircraft assembly sheet metal assembler � aircraft assembly skin fitter � aircraft assembly spar assembler � aircraft assembly structural assembler, bench � aircraft assembly subassembler � aircraft assembly welded assemblies fitter-tester � aircraft assembly wing assembler, aircraft wing inspector � aircraft assembly wing marry-up mechanic � aircraft assembly wing tank mechanic � aircraft assembly",
    "workers": 8240,
    "minEduc": 0,
    "yearsStudy": 2.158260234,
    "automationRisk": 0.9325,
    "salaryLow": 28.85,
    "salaryMed": 34.71,
    "salaryHigh": 40,
    "totalSkill": 121,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 17.82379547,
    "skillsComp": 33.5,
    "skillsLogi": 30.5,
    "skillsMath": 18,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1125,
    "f2Engineering": 1915,
    "f3Humanities": 155,
    "f4SocialScience": 322.5,
    "f5FineArts": 292.5,
    "f6MathAndComputerScience": 232.5,
    "f7Arts&Education": 1717.5,
    "f8Education(teachertraining)": 112.5,
    "f9Law": 470,
    "f10Health": 125,
    "f11Health,Nursing&ClinicalLaboratory": 392.5,
    "f12Business": 1380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 155,
    "d5SocialSciences": 322.5,
    "d6Fine&AppliedArts": 292.5,
    "d7ComputerScience": 200,
    "d8OtherArts&Science": 1717.5,
    "d9Education(teachertraining)": 112.5,
    "d10Engineering": 1885,
    "d11Law": 470,
    "d12Mathematics": 32.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 1025,
    "d16Therapy&Rehabilitation": 82.5,
    "d17Health,Nursing&ClinicalLaboratory": 392.5,
    "d18Business&Commerce": 1380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 473,
    "noc": 9522,
    "job": "Motor vehicle assemblers, inspectors and testers",
    "title1": "accessories installer, automobiles - motor vehicle manufacturing",
    "title2": "adjuster, doors and deck lids - motor vehicle manufacturing",
    "title3": "adjuster, doors - motor vehicle manufacturing",
    "allTitles": "accessories installer, automobiles - motor vehicle manufacturingadjuster, doors and deck lids - motor vehicle manufacturingadjuster, doors - motor vehicle manufacturingadjuster, headlights - motor vehicle manufacturingadjuster, line-up - motor vehicle manufacturingassembler - automobile assemblyassembler, automobile hoods - motor vehicle manufacturingassembler, automobilesassembler, axles - automobile assemblyassembler, bodies - motor vehicle manufacturingassembler, brakes - motor vehicle manufacturingassembler, carsassembler, chassis - motor vehicle manufacturingassembler, convertible tops - motor vehicle manufacturingassembler, crankshafts - motor vehicle manufacturingassembler, doors - motor vehicle manufacturingassembler, frames - motor vehicle manufacturingassembler, instrument clusters - motor vehicle manufacturingassembler, instrument panels - automobile assemblyassembler, interior finishing - automobile assemblyassembler, interior trim - automobile assemblyassembler, leaf springs - motor vehicle manufacturingassembler, light trucks - automobile assemblyassembler-mechanic - motor vehicle manufacturingassembler, minivans - motor vehicle manufacturingassembler, motor vehicles - motor vehicle manufacturingassembler, seats - motor vehicle manufacturingassembler, small parts - motor vehicle manufacturingassembler, springs - motor vehicle manufacturingassembler, vansassembly inspector, chassis - motor vehicle manufacturingassembly inspector - motor vehicle manufacturingassembly quality upgrader - motor vehicle manufacturingassembly worker, autosauto assembly workerautomobile accessories installerautomobile accessories installer and repairerautomobile accessories installer and repairmanautomobile accessories installer and repairwomanautomobile assemblerautomobile assembly workerautomobile engine tester - automobile assemblyautomobile final inspector - automobile assemblyautomobile hood assembler - motor vehicle manufacturingautomobile inspector and tester - motor vehicle manufacturingautomobile inspector - motor vehicle manufacturingautomobile radio and accessories installer - motor vehicle manufacturingautomotive assembler - motor vehicle manufacturingautomotive electronic accessories installer and repairer - motor vehicle manufacturingautomotive electronic accessories installer and repairman - motor vehicle manufacturingautomotive electronic accessories installer and repairwoman - motor vehicle manufacturingautomotive engine quality control inspectorauto parts assembleraxle assembler - automobile assemblybattery installer - motor vehicle manufacturingbody assembler - motor vehicle manufacturingbody department technician - motor vehicle manufacturingbody frame inspector - motor vehicle manufacturingbody-in-white inspector - motor vehicle manufacturingbody production operator - motor vehicle manufacturingbrake assembler - motor vehicle manufacturingcar assemblercar examiner - automobile assemblycar inspector - automobile assemblychassis assembler - motor vehicle manufacturingchassis assembly inspector - motor vehicle manufacturingchassis inspector - motor vehicle manufacturingconvertible top assembler - motor vehicle manufacturingcrankshaft assembler - motor vehicle manufacturingdoor adjuster - motor vehicle manufacturingdoor and deck lid adjuster - motor vehicle manufacturingdoor assembler - motor vehicle manufacturingdoor fitterdoor fitter - motor vehicle manufacturingdoor hanger - motor vehicle manufacturingdoor paneler - motor vehicle manufacturingelectrical quality assurance inspector - motor vehicle manufacturingelectrical tester, instrument panels - motor vehicle manufacturingelectrical testing technician - motor vehicle manufacturingelectrical test technician - motor vehicle manufacturingelectrical wirer - automotive assemblyengine block tester - motor vehicle manufacturingengine dress assembler - motor vehicle manufacturingengine inspector - motor vehicle manufacturingengine installer - motor vehicle manufacturingengine tester - automobile assemblyengine tester, automobiles - automobile assemblyexaminer, cars - motor vehicle manufacturingexaminer, water leaks - motor vehicle manufacturingfinal inspector, automobiles - automobile assemblyfinished assembled vehicle inspector - motor vehicle manufacturingfinishing department technician - motor vehicle manufacturingfitter and adjuster - motor vehicle manufacturingfitter, doors - motor vehicle manufacturingfitter, hoods - motor vehicle manufacturingfloor inspector - motor vehicle manufacturingframe assembler - motor vehicle manufacturinggeneral repairer and adjuster - motor vehicle manufacturinggeneral repairman and adjuster - motor vehicle manufacturinggeneral repairwoman and adjuster - motor vehicle manufacturing",
    "workers": 15985,
    "minEduc": 0,
    "yearsStudy": 2.441520468,
    "automationRisk": 0.9,
    "salaryLow": 16.97,
    "salaryMed": 21.318,
    "salaryHigh": 30.48,
    "totalSkill": 127,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 20.14759093,
    "skillsComp": 35,
    "skillsLogi": 32,
    "skillsMath": 19,
    "skillsLang": 42,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 4,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 13,
    "s9ProblemSolving": 9,
    "s10Reading": 17,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 13,
    "s13DocumentUse": 18,
    "s14Writing": 11,
    "s15CriticalThinking": 6,
    "f1Science&Agriculture": 2140,
    "f2Engineering": 3575,
    "f3Humanities": 310,
    "f4SocialScience": 645,
    "f5FineArts": 560,
    "f6MathAndComputerScience": 465,
    "f7Arts&Education": 3360,
    "f8Education(teachertraining)": 225,
    "f9Law": 940,
    "f10Health": 250,
    "f11Health,Nursing&ClinicalLaboratory": 785,
    "f12Business": 2730,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 140,
    "d2Forestry": 60,
    "d3Architecture&LandscapeArchitecture": 60,
    "d4Humanities": 310,
    "d5SocialSciences": 645,
    "d6Fine&AppliedArts": 560,
    "d7ComputerScience": 400,
    "d8OtherArts&Science": 3360,
    "d9Education(teachertraining)": 225,
    "d10Engineering": 3515,
    "d11Law": 940,
    "d12Mathematics": 65,
    "d13Kinesiology/Recreation/PhysicalEducation": 85,
    "d14Theology": 0,
    "d15PhysicalSciences": 1940,
    "d16Therapy&Rehabilitation": 165,
    "d17Health,Nursing&ClinicalLaboratory": 785,
    "d18Business&Commerce": 2730,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 474,
    "noc": 9523,
    "job": "Electronics assemblers, fabricators, inspectors and testers",
    "title1": "adjuster, filament-winding machine aligner � electronic equipment manufacturing aluminizing equipment operator � electronic equipment manufacturing antenna-tuner inspector � electronic equipment manufacturing assembler � electronic equipment manufacturing assembler, avionics equipment assembler, electronic cash registers assembler, electronic equipment � electronic equipment manufacturing assembler, electronic keyboard assembler, office machines assembler, telecommunications equipment assembly inspector � electronic equipment manufacturing assembly tester � electronic equipment manufacturing automatic component-assembly-machine operator � electronic equipment manufacturing automatic wire-wrapping machine tender � electronic equipment manufacturing avionics assembler avionics equipment assembler backplane and frame wiring operator base-filling machine operator � electronic equipment manufacturing bench assembler � electronic equipment manufacturing bench worker � electronic equipment manufacturing board laboratory operator calibrator, wire wound resistors capacitor assembler capacitor inspector capacitor-treating tank operator cathode coater � electronic equipment manufacturing cathode-ray-tube-processing equipment setter chassis assembler � electronic equipment manufacturing chassis installer � electronic equipment manufacturing choke winder � electronic equipment manufacturing circuit board assembler coil assembler � electronic equipment manufacturing coil inspector � electronic equipment manufacturing coil-winding machine operator � electronic equipment manufacturing colour picture tube assembler communications equipment assembler compact disc player assembler compact disc player inspector and tester component inserting machine operator component inspector � electronic equipment manufacturing components assembler � electronic equipment manufacturing condenser winder � electronic equipment manufacturing cone assembler � electronic equipment manufacturing console assembler � electronic equipment manufacturing conveyor line worker � electronic equipment manufacturing crystal calibrator � electronic equipment manufacturing crystal final tester crystal final tester � electronic equipment manufacturing crystal finisher � electronic equipment manufacturing crystal frequency measurer � electronic equipment manufacturing crystal grower crystal inspector � electronic equipment manufacturing crystal lapper crystal unit assembler crystal-dicing saw operator die attacher � electronic equipment manufacturing diffusion furnace operator � electronic equipment manufacturing dip-soldering machine operator � electronic equipment manufacturing duplicating machine assembler electrical wire group assembler � electronic equipment manufacturing electron tube assembler electron tube inspector and tester electron tube stem assembly inspector electronic business machine assembler electronic cash register assembler electronic component assembler electronic component cleaner electronic component insertion colour coder electronic component tester � electronic equipment manufacturing electronic control assembler electronic control operator � electronic equipment manufacturing electronic equipment assembler � electronic equipment manufacturing electronic equipment inspector electronic equipment subassembler electronic instrument maker electronic keyboard assembler electronic office machines assembler electronic organ assembler electronic peripheral equipment assembler electronic products mounter � electronic equipment manufacturing electronic unit inspector � electronic equipment manufacturing electronics assembler electronics equipment assembler electronics inspector � electronic equipment manufacturing electronics manufacturing shop worker electronics tester electronics-manufacturing process inspector etcher and plater, quartz crystals � electronic equipment manufacturing etcher, printed circuit board (PCB) exhaust and sealing machine operator exhaust equipment setter � electronic equipment manufacturing fabricator, microelectronic circuits filament stem inspector � electronic equipment manufacturing filament tester � electronic equipment manufacturing filter assembler � electronic equipment manufacturing final-assembly tester � electronic equipment manufacturing finished product inspector � electronic equipment manufacturing fluorescent screen former frequency measurer, crystals � electronic equipment manufacturing funnel coater � electronic equipment manufacturing gauger, semiconductor material � electronic equipment manufacturing general assembler and light machine operator � electronic equipment manufacturing geophysical instrument assembler � electronic equipment manufacturing grid gauger � electronic equipment manufacturing grid inspector � electronic equipment manufacturing grid operator � electronic equipment manufacturing gun assembler, television pictures tubes harness and cable fabricator � electronic equipment manufacturing hearing aid inspector � electronic equipment manufacturing hybrid circuit assembler � electronic equipment manufacturing hybrid inspector � electronic equipment manufacturing impregnator and dryer � electronic equipment manufacturing in-circuit test operator inspector � electronic equipment manufacturing inspector � printed circuit board fabrication inspector and tester, electron tube inspector, components � electronic equipment manufacturing inspector, electron tube stem assemblies inspector, printed circuit board (PCB) assembly installer � electronic equipment manufacturing integrated circuit assembler lab technician, wafer fabrication � electronic equipment manufacturing laminator, television picture tubes laser assembler � electronic equipment manufacturing laser-trimmer operator � electronic equipment manufacturing machine operator � electronic equipment manufacturing magnetometer assembler � electronic equipment manufacturing manufacturing operator � electronic equipment manufacturing mica capacitor assembler microcircuit assembler microelectronic circuit fabricator mobile transceiver inspector � electronic equipment manufacturing mount operator � electronic equipment manufacturing mounter � electronic equipment manufacturing nautical instrument maker � electronic equipment manufacturing navigation aid inspector � electronic equipment manufacturing nucleonics instrument assembler pacemaker assembler � electronic equipment manufacturing parts tester � electronic equipment manufacturing PCB (printed circuit board) assembler PCB (printed circuit board) assembly inspector PCB (printed circuit board) assembly machine operator � electronic equipment manufacturing PCB (printed circuit board) etcher PCB (printed circuit board) fabrication inspector PCB (printed circuit board) fabrication machine operator PCB (printed circuit board) in-circuit machine -and repairing-machine operator PCB (printed circuit board) inspector PCB (printed circuit board) inspector and tester � electronic equipment manufacturing photoresist printer � electronic equipment manufacturing pick and place machine operator � electronic equipment manufacturing picture tube assembler picture tube screen aluminizer picture tube tester � electronic equipment manufacturing plater, vacuum evaporation process � electronic equipment manufacturing precision instrument assembler � electronic equipment manufacturing printed circuit board (PCB) assembler printed circuit board (PCB) assembly machine operator printed circuit board (PCB) assembly machine operator � electronic equipment manufacturing printed circuit board (PCB) etcher printed circuit board (PCB) fabrication inspector printed circuit board (PCB) fabrication machine operator printed circuit board (PCB) in-circuit machine -and repairing-machine operator printed circuit board (PCB) in-circuit test machine and repair operator printed circuit board (PCB) inspector printed circuit board (PCB) inspector and tester � electronic equipment manufacturing process inspector � electronic equipment manufacturing process technician � electronic equipment manufacturing process tester � electronic equipment manufacturing production operator � electronic equipment manufacturing production tester � electronic equipment manufacturing quartz crystal etcher and plater � electronic equipment manufacturing radar-indicator inspector � electronic equipment manufacturing radar-receiver assembler radiation-detector assembler radio assembler and installer resistor assembler � electronic equipment manufacturing resistor machine feeder resistor-processing equipment operator rim bander, television picture tube salvage operator � electronic equipment manufacturing screen aluminizer, picture tube assemblies semiconductor assembler semiconductor calibrator semiconductor material gauger � electronic equipment manufacturing semiconductor mounter setter, exhaust equipment � electronic equipment manufacturing silicon wafer fabricator silicon wafer grower speaker assembler subassembler, electronic equipment surface mount assembler surface mount assembler � electronic equipment manufacturing tape cartridge and cassette assembler tape cartridge and cassette inspector telephone assembler television assembler television assembly chief inspector television picture tube laminator television picture tube tester � electronic equipment manufacturing television receiver inspector and tester � electronic equipment manufacturing television tube assembler tension meter assembler � electronic equipment manufacturing test and trim operator � electronic equipment manufacturing tester, electronic components testing machine operator � electronic equipment manufacturing through-hole assembler through-hole assembler � electronic equipment manufacturing transistor assembler tube assembler � electronic equipment manufacturing tube tester TV set inspector and tester � electronic equipment manufacturing type-bar-and-segment assembler typewriter aligner typewriter inspector, parts and assemblies typewriter parts salvager utility operator � electronic equipment manufacturing vacuum evaporation process plater � electronic equipment manufacturing variable capacitor tester variable resistor assembler wafer fabrication operator wafer fabrication operator � electronic equipment manufacturing wafer technician � electronic equipment manufacturing wave soldering machine operator wave soldering machine operator � electronic equipment manufacturing wire and harness assembler wire bonder � electronic equipment manufacturing wire soldering operator wire wound resistor calibrator wire wound resistor calibrator � electronic equipment manufacturing wire wound resistor inspector � electronic equipment manufacturing wire-cutting machine operator � electronic equipment manufacturing wire-wrapping machine operator � electronic equipment manufacturing wiring and assembly operator wiring and soldering operator � electronic equipment manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "adjuster, filament-winding machine aligner � electronic equipment manufacturing aluminizing equipment operator � electronic equipment manufacturing antenna-tuner inspector � electronic equipment manufacturing assembler � electronic equipment manufacturing assembler, avionics equipment assembler, electronic cash registers assembler, electronic equipment � electronic equipment manufacturing assembler, electronic keyboard assembler, office machines assembler, telecommunications equipment assembly inspector � electronic equipment manufacturing assembly tester � electronic equipment manufacturing automatic component-assembly-machine operator � electronic equipment manufacturing automatic wire-wrapping machine tender � electronic equipment manufacturing avionics assembler avionics equipment assembler backplane and frame wiring operator base-filling machine operator � electronic equipment manufacturing bench assembler � electronic equipment manufacturing bench worker � electronic equipment manufacturing board laboratory operator calibrator, wire wound resistors capacitor assembler capacitor inspector capacitor-treating tank operator cathode coater � electronic equipment manufacturing cathode-ray-tube-processing equipment setter chassis assembler � electronic equipment manufacturing chassis installer � electronic equipment manufacturing choke winder � electronic equipment manufacturing circuit board assembler coil assembler � electronic equipment manufacturing coil inspector � electronic equipment manufacturing coil-winding machine operator � electronic equipment manufacturing colour picture tube assembler communications equipment assembler compact disc player assembler compact disc player inspector and tester component inserting machine operator component inspector � electronic equipment manufacturing components assembler � electronic equipment manufacturing condenser winder � electronic equipment manufacturing cone assembler � electronic equipment manufacturing console assembler � electronic equipment manufacturing conveyor line worker � electronic equipment manufacturing crystal calibrator � electronic equipment manufacturing crystal final tester crystal final tester � electronic equipment manufacturing crystal finisher � electronic equipment manufacturing crystal frequency measurer � electronic equipment manufacturing crystal grower crystal inspector � electronic equipment manufacturing crystal lapper crystal unit assembler crystal-dicing saw operator die attacher � electronic equipment manufacturing diffusion furnace operator � electronic equipment manufacturing dip-soldering machine operator � electronic equipment manufacturing duplicating machine assembler electrical wire group assembler � electronic equipment manufacturing electron tube assembler electron tube inspector and tester electron tube stem assembly inspector electronic business machine assembler electronic cash register assembler electronic component assembler electronic component cleaner electronic component insertion colour coder electronic component tester � electronic equipment manufacturing electronic control assembler electronic control operator � electronic equipment manufacturing electronic equipment assembler � electronic equipment manufacturing electronic equipment inspector electronic equipment subassembler electronic instrument maker electronic keyboard assembler electronic office machines assembler electronic organ assembler electronic peripheral equipment assembler electronic products mounter � electronic equipment manufacturing electronic unit inspector � electronic equipment manufacturing electronics assembler electronics equipment assembler electronics inspector � electronic equipment manufacturing electronics manufacturing shop worker electronics tester electronics-manufacturing process inspector etcher and plater, quartz crystals � electronic equipment manufacturing etcher, printed circuit board (PCB) exhaust and sealing machine operator exhaust equipment setter � electronic equipment manufacturing fabricator, microelectronic circuits filament stem inspector � electronic equipment manufacturing filament tester � electronic equipment manufacturing filter assembler � electronic equipment manufacturing final-assembly tester � electronic equipment manufacturing finished product inspector � electronic equipment manufacturing fluorescent screen former frequency measurer, crystals � electronic equipment manufacturing funnel coater � electronic equipment manufacturing gauger, semiconductor material � electronic equipment manufacturing general assembler and light machine operator � electronic equipment manufacturing geophysical instrument assembler � electronic equipment manufacturing grid gauger � electronic equipment manufacturing grid inspector � electronic equipment manufacturing grid operator � electronic equipment manufacturing gun assembler, television pictures tubes harness and cable fabricator � electronic equipment manufacturing hearing aid inspector � electronic equipment manufacturing hybrid circuit assembler � electronic equipment manufacturing hybrid inspector � electronic equipment manufacturing impregnator and dryer � electronic equipment manufacturing in-circuit test operator inspector � electronic equipment manufacturing inspector � printed circuit board fabrication inspector and tester, electron tube inspector, components � electronic equipment manufacturing inspector, electron tube stem assemblies inspector, printed circuit board (PCB) assembly installer � electronic equipment manufacturing integrated circuit assembler lab technician, wafer fabrication � electronic equipment manufacturing laminator, television picture tubes laser assembler � electronic equipment manufacturing laser-trimmer operator � electronic equipment manufacturing machine operator � electronic equipment manufacturing magnetometer assembler � electronic equipment manufacturing manufacturing operator � electronic equipment manufacturing mica capacitor assembler microcircuit assembler microelectronic circuit fabricator mobile transceiver inspector � electronic equipment manufacturing mount operator � electronic equipment manufacturing mounter � electronic equipment manufacturing nautical instrument maker � electronic equipment manufacturing navigation aid inspector � electronic equipment manufacturing nucleonics instrument assembler pacemaker assembler � electronic equipment manufacturing parts tester � electronic equipment manufacturing PCB (printed circuit board) assembler PCB (printed circuit board) assembly inspector PCB (printed circuit board) assembly machine operator � electronic equipment manufacturing PCB (printed circuit board) etcher PCB (printed circuit board) fabrication inspector PCB (printed circuit board) fabrication machine operator PCB (printed circuit board) in-circuit machine -and repairing-machine operator PCB (printed circuit board) inspector PCB (printed circuit board) inspector and tester � electronic equipment manufacturing photoresist printer � electronic equipment manufacturing pick and place machine operator � electronic equipment manufacturing picture tube assembler picture tube screen aluminizer picture tube tester � electronic equipment manufacturing plater, vacuum evaporation process � electronic equipment manufacturing precision instrument assembler � electronic equipment manufacturing printed circuit board (PCB) assembler printed circuit board (PCB) assembly machine operator printed circuit board (PCB) assembly machine operator � electronic equipment manufacturing printed circuit board (PCB) etcher printed circuit board (PCB) fabrication inspector printed circuit board (PCB) fabrication machine operator printed circuit board (PCB) in-circuit machine -and repairing-machine operator printed circuit board (PCB) in-circuit test machine and repair operator printed circuit board (PCB) inspector printed circuit board (PCB) inspector and tester � electronic equipment manufacturing process inspector � electronic equipment manufacturing process technician � electronic equipment manufacturing process tester � electronic equipment manufacturing production operator � electronic equipment manufacturing production tester � electronic equipment manufacturing quartz crystal etcher and plater � electronic equipment manufacturing radar-indicator inspector � electronic equipment manufacturing radar-receiver assembler radiation-detector assembler radio assembler and installer resistor assembler � electronic equipment manufacturing resistor machine feeder resistor-processing equipment operator rim bander, television picture tube salvage operator � electronic equipment manufacturing screen aluminizer, picture tube assemblies semiconductor assembler semiconductor calibrator semiconductor material gauger � electronic equipment manufacturing semiconductor mounter setter, exhaust equipment � electronic equipment manufacturing silicon wafer fabricator silicon wafer grower speaker assembler subassembler, electronic equipment surface mount assembler surface mount assembler � electronic equipment manufacturing tape cartridge and cassette assembler tape cartridge and cassette inspector telephone assembler television assembler television assembly chief inspector television picture tube laminator television picture tube tester � electronic equipment manufacturing television receiver inspector and tester � electronic equipment manufacturing television tube assembler tension meter assembler � electronic equipment manufacturing test and trim operator � electronic equipment manufacturing tester, electronic components testing machine operator � electronic equipment manufacturing through-hole assembler through-hole assembler � electronic equipment manufacturing transistor assembler tube assembler � electronic equipment manufacturing tube tester TV set inspector and tester � electronic equipment manufacturing type-bar-and-segment assembler typewriter aligner typewriter inspector, parts and assemblies typewriter parts salvager utility operator � electronic equipment manufacturing vacuum evaporation process plater � electronic equipment manufacturing variable capacitor tester variable resistor assembler wafer fabrication operator wafer fabrication operator � electronic equipment manufacturing wafer technician � electronic equipment manufacturing wave soldering machine operator wave soldering machine operator � electronic equipment manufacturing wire and harness assembler wire bonder � electronic equipment manufacturing wire soldering operator wire wound resistor calibrator wire wound resistor calibrator � electronic equipment manufacturing wire wound resistor inspector � electronic equipment manufacturing wire-cutting machine operator � electronic equipment manufacturing wire-wrapping machine operator � electronic equipment manufacturing wiring and assembly operator wiring and soldering operator � electronic equipment manufacturing",
    "workers": 8240,
    "minEduc": 0,
    "yearsStudy": 2.158260234,
    "automationRisk": 0.9325,
    "salaryLow": 14,
    "salaryMed": 15.85,
    "salaryHigh": 28,
    "totalSkill": 8240,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 17.82379547,
    "skillsComp": 33.5,
    "skillsLogi": 30.5,
    "skillsMath": 18,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1125,
    "f2Engineering": 1915,
    "f3Humanities": 155,
    "f4SocialScience": 322.5,
    "f5FineArts": 292.5,
    "f6MathAndComputerScience": 232.5,
    "f7Arts&Education": 1717.5,
    "f8Education(teachertraining)": 112.5,
    "f9Law": 470,
    "f10Health": 125,
    "f11Health,Nursing&ClinicalLaboratory": 392.5,
    "f12Business": 1380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 155,
    "d5SocialSciences": 322.5,
    "d6Fine&AppliedArts": 292.5,
    "d7ComputerScience": 200,
    "d8OtherArts&Science": 1717.5,
    "d9Education(teachertraining)": 112.5,
    "d10Engineering": 1885,
    "d11Law": 470,
    "d12Mathematics": 32.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 1025,
    "d16Therapy&Rehabilitation": 82.5,
    "d17Health,Nursing&ClinicalLaboratory": 392.5,
    "d18Business&Commerce": 1380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 475,
    "noc": 9524,
    "job": "Assemblers and inspectors, electrical appliance, apparatus and equipment manufacturing",
    "title1": "adjuster, coils - electrical equipment manufacturing",
    "title2": "air conditioner coil assembler",
    "title3": "air conditioning unit tester",
    "allTitles": "adjuster, coils - electrical equipment manufacturingair conditioner coil assemblerair conditioning unit testerarmature banderarmature winder, small electric motorassembler air conditionerassembler, air conditioner coilassembler, air conditioningassembler, ballast transformersassembler, bushings - small transformer manufacturingassembler, circuit breakersassembler, commercial refrigeratorsassembler, compact discsassembler, cooling units - electrical equipment manufacturingassembler, dishwashersassembler, electric air conditioning unitsassembler, electrical accessoriesassembler, electrical appliancesassembler, electrical equipmentassembler, electrical switchesassembler, electrical wire groupsassembler, electric baseboard heatersassembler, electric clocksassembler, electric clothes dryersassembler, electric coffee makersassembler, electric fansassembler, electric heatersassembler, electric lampsassembler, electric lawn mowersassembler, electric metersassembler, electric refrigeratorsassembler, electric signsassembler, electric toastersassembler, engine generator setsassembler, fluorescent light fixturesassembler, heavy current switchesassembler, heavy-duty capacitorsassembler, heavy-duty resistorsassembler, large electrical appliancesassembler, light fixturesassembler, lighting fixturesassembler, motor and generator - electrical equipment manufacturingassembler, motor vehicle lighting fixturesassembler, neon signs - electrical equipment manufacturingassembler, portable electrical applianceassembler, quartz lampsassembler, small electrical appliancesassembler, small electrical productsassembler, small electric motorassembler, small transformerassembler, spark plugsassembler, thermostatassembler, toggle switches - electrical equipment manufacturingassembler, transformer static plateassembler, vacuum cleanersassembler, washing machines - electrical equipment manufacturingassembly, hair dryersassembly inspector, electrical appliancesassembly lead hand - electrical equipment manufacturingassembly lead hand, large electrical appliancesassembly lead hand, small electrical appliancesassembly line expediter - electrical equipment manufacturingassembly line inspector and tester - electrical equipment manufacturingassembly line inspector - electrical equipment manufacturingassembly line repairer, electrical appliancesassembly line repairman, electrical appliancesassembly line repairwoman, electrical appliancesassembly line worker, electric heating systemsassembly section leader, lighting fixturesautomatic coil winder operator - electrical equipment manufacturingballast transformer assemblerballast transformer testerbench assembler, electrical appliancesbench worker, electrical appliancesbushing assembler - small transformer manufacturingcalibrator, electrical controlscalibrator, thermostats - electrical equipment manufacturingcarbon brush inspectorcarbon products inspectorcircuit breaker assemblercircuit breaker assembly testerclothes dryer assembler, electriccoffee maker assemblercoil adjuster - electrical equipment manufacturingcoil finisher - electrical equipment manufacturingcoil taper - electrical equipment manufacturingcoil-winding machine tender - automatic electrical equipmentcoil-winding machine tender, automatic - electrical equipment manufacturingcommercial refrigerator assemblercompact disc assemblerconnector assembler - electrical equipment manufacturingcooling unit assembler - electrical equipment manufacturingcore builder, small transformerscutter and former, insulation - electrical equipment manufacturingdishwasher assemblerelectric air conditioning assemblerelectrical accessories assemblerelectrical appliance assemblerelectrical appliance assembly inspectorelectrical appliance assembly tester",
    "workers": 495,
    "minEduc": 0,
    "yearsStudy": 1.875,
    "automationRisk": 0.965,
    "salaryLow": 14,
    "salaryMed": 15.5,
    "salaryHigh": 23,
    "totalSkill": 115,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 15.5,
    "skillsComp": 32,
    "skillsLogi": 29,
    "skillsMath": 17,
    "skillsLang": 37,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12,
    "s9ProblemSolving": 8,
    "s10Reading": 16,
    "s11SchedulingorBudgetingandAccounting": 4,
    "s12DigitalTechnology": 11,
    "s13DocumentUse": 18,
    "s14Writing": 9,
    "s15CriticalThinking": 4,
    "f1Science&Agriculture": 110,
    "f2Engineering": 255,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 25,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 75,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 30,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 25,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 75,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 255,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 110,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 30,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 476,
    "noc": 9525,
    "job": "Assemblers, fabricators and inspectors, industrial electrical motors and transformers",
    "title1": "alternating current (AC) and direct current (DC) motors fitter-assembler alternator tester armature assembler � industrial electrical equipment armature coil former � industrial electrical equipment armature coil winder � industrial electric equipment armature inspector � industrial electrical equipment armature insulator � industrial electrical equipment armature winder � industrial electrical equipment automotive wiring harness inspector � industrial electrical equipment bushing core winder � industrial electrical equipment carbon brush assembler carbon brush maker circuit breaker fitter � industrial electrical equipment coil assembler � industrial electrical equipment coil builder � industrial electrical equipment coil former � industrial electrical equipment coil maker � industrial electrical equipment coil shaper � industrial electrical equipment coil-winding machine setter � industrial electrical equipment commutator assembler commutator assembler � industrial electrical equipment control panel assembler control panel assembler � industrial electrical equipment control panel technician � industrial electrical equipment core assembler � industrial electrical equipment current-transformer assembler current-transformer coil winder custom electrical panel assembler electric meter tester � industrial electrical equipment electric motor assembler electric motor inspector electrical continuity tester � industrial electrical equipment electrical control equipment fitter-assembler electrical control panel assembler electrical control panel final assembler electrical control panel subassembler electrical fitter electrical fitter � industrial electrical equipment electrical panel assembler and wirer � industrial electrical equipment electrical switchgear inspector electrical switchgear panel wirer electrical switchgear tester electrical switchgear wireperson electrolytic cell repairer � industrial electrical equipment field coil taper � industrial electrical equipment fitter-assembler � electrical control equipment fitter-assembler � industrial electrical equipment generator tester � industrial electrical equipment hand coil taper � industrial electrical equipment heavy-duty coil former � industrial electrical equipment heavy-duty transformer assembler heavy-duty transformer coil winder high voltage transformer bushing assembler industrial brake and alternating current (AC) motor assembler industrial electric equipment assembler industrial electric equipment fabricator industrial electric equipment inspector inspector � large transformer manufacturing inspector and tester, AC and DC motors inspector, AC (alternating current) and DC (direct current) motors inspector, electrical control panel inspector, electrical switchboards and panels inspector, electrical switchgear panel laminated core assembler � industrial electrical equipment lamination stacker � industrial electrical equipment large power transformer coil winder large transformer coil winder locomotive electrical inspector motor and control tester motor and generator assembler � industrial electrical equipment motor and generator assembler and wirer motor and generator inspector motor and transformer tester motor control assembler � industrial electrical equipment motor winder � industrial electrical equipment motor-coil and generator-coil builder motor-coil and generator-coil installer � industrial electrical equipment panelboard assembler � industrial electrical equipment pole shoe assembler � industrial electrical equipment power transformer assembler power transformer core builder rotating field coil assembler � industrial electrical equipment rotor assembler � industrial electrical equipment rotor coil former � industrial electrical equipment rotor core assembler � industrial electrical equipment stator inspector � industrial electrical equipment stator-core and rotor-core builder and welder � industrial electrical equipment storage battery salvager switchgear and control panel assembler � industrial electrical equipment switchgear assembler and wirer switchgear fitter-wirer switchgear fitter-wirer � industrial electrical equipment switchgear panel assembler � industrial electrical equipment switchgear panel installer-fitter switchgear rack assembler � industrial electrical equipment transformer accessories assembler transformer assembler transformer assembly clamper transformer assembly coil clamper transformer builder transformer coil winder transformer core assembler transformer core lapper transformer core maker transformer core stacker transformer department lead hand transformer fitter transformer fitter-wirer transformer gas detector relay assembler transformer inspector transformer maker transformer subassembler transformer tapgear assembler transformer tester transformer winder undercutting machine operator � industrial electrical equipment winder, AC (alternating current) and DC (direct current) armatures windings inspector � large electric motors manufacturing wireman/woman � industrial electrical equipment",
    "title2": 0,
    "title3": 0,
    "allTitles": "alternating current (AC) and direct current (DC) motors fitter-assembler alternator tester armature assembler � industrial electrical equipment armature coil former � industrial electrical equipment armature coil winder � industrial electric equipment armature inspector � industrial electrical equipment armature insulator � industrial electrical equipment armature winder � industrial electrical equipment automotive wiring harness inspector � industrial electrical equipment bushing core winder � industrial electrical equipment carbon brush assembler carbon brush maker circuit breaker fitter � industrial electrical equipment coil assembler � industrial electrical equipment coil builder � industrial electrical equipment coil former � industrial electrical equipment coil maker � industrial electrical equipment coil shaper � industrial electrical equipment coil-winding machine setter � industrial electrical equipment commutator assembler commutator assembler � industrial electrical equipment control panel assembler control panel assembler � industrial electrical equipment control panel technician � industrial electrical equipment core assembler � industrial electrical equipment current-transformer assembler current-transformer coil winder custom electrical panel assembler electric meter tester � industrial electrical equipment electric motor assembler electric motor inspector electrical continuity tester � industrial electrical equipment electrical control equipment fitter-assembler electrical control panel assembler electrical control panel final assembler electrical control panel subassembler electrical fitter electrical fitter � industrial electrical equipment electrical panel assembler and wirer � industrial electrical equipment electrical switchgear inspector electrical switchgear panel wirer electrical switchgear tester electrical switchgear wireperson electrolytic cell repairer � industrial electrical equipment field coil taper � industrial electrical equipment fitter-assembler � electrical control equipment fitter-assembler � industrial electrical equipment generator tester � industrial electrical equipment hand coil taper � industrial electrical equipment heavy-duty coil former � industrial electrical equipment heavy-duty transformer assembler heavy-duty transformer coil winder high voltage transformer bushing assembler industrial brake and alternating current (AC) motor assembler industrial electric equipment assembler industrial electric equipment fabricator industrial electric equipment inspector inspector � large transformer manufacturing inspector and tester, AC and DC motors inspector, AC (alternating current) and DC (direct current) motors inspector, electrical control panel inspector, electrical switchboards and panels inspector, electrical switchgear panel laminated core assembler � industrial electrical equipment lamination stacker � industrial electrical equipment large power transformer coil winder large transformer coil winder locomotive electrical inspector motor and control tester motor and generator assembler � industrial electrical equipment motor and generator assembler and wirer motor and generator inspector motor and transformer tester motor control assembler � industrial electrical equipment motor winder � industrial electrical equipment motor-coil and generator-coil builder motor-coil and generator-coil installer � industrial electrical equipment panelboard assembler � industrial electrical equipment pole shoe assembler � industrial electrical equipment power transformer assembler power transformer core builder rotating field coil assembler � industrial electrical equipment rotor assembler � industrial electrical equipment rotor coil former � industrial electrical equipment rotor core assembler � industrial electrical equipment stator inspector � industrial electrical equipment stator-core and rotor-core builder and welder � industrial electrical equipment storage battery salvager switchgear and control panel assembler � industrial electrical equipment switchgear assembler and wirer switchgear fitter-wirer switchgear fitter-wirer � industrial electrical equipment switchgear panel assembler � industrial electrical equipment switchgear panel installer-fitter switchgear rack assembler � industrial electrical equipment transformer accessories assembler transformer assembler transformer assembly clamper transformer assembly coil clamper transformer builder transformer coil winder transformer core assembler transformer core lapper transformer core maker transformer core stacker transformer department lead hand transformer fitter transformer fitter-wirer transformer gas detector relay assembler transformer inspector transformer maker transformer subassembler transformer tapgear assembler transformer tester transformer winder undercutting machine operator � industrial electrical equipment winder, AC (alternating current) and DC (direct current) armatures windings inspector � large electric motors manufacturing wireman/woman � industrial electrical equipment",
    "workers": 8240,
    "minEduc": 0,
    "yearsStudy": 2.158260234,
    "automationRisk": 0.9325,
    "salaryLow": 16.97,
    "salaryMed": 21.318,
    "salaryHigh": 30.48,
    "totalSkill": 8240,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 17.82379547,
    "skillsComp": 33.5,
    "skillsLogi": 30.5,
    "skillsMath": 18,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1125,
    "f2Engineering": 1915,
    "f3Humanities": 155,
    "f4SocialScience": 322.5,
    "f5FineArts": 292.5,
    "f6MathAndComputerScience": 232.5,
    "f7Arts&Education": 1717.5,
    "f8Education(teachertraining)": 112.5,
    "f9Law": 470,
    "f10Health": 125,
    "f11Health,Nursing&ClinicalLaboratory": 392.5,
    "f12Business": 1380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 155,
    "d5SocialSciences": 322.5,
    "d6Fine&AppliedArts": 292.5,
    "d7ComputerScience": 200,
    "d8OtherArts&Science": 1717.5,
    "d9Education(teachertraining)": 112.5,
    "d10Engineering": 1885,
    "d11Law": 470,
    "d12Mathematics": 32.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 1025,
    "d16Therapy&Rehabilitation": 82.5,
    "d17Health,Nursing&ClinicalLaboratory": 392.5,
    "d18Business&Commerce": 1380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 477,
    "noc": 9526,
    "job": "Mechanical assemblers and inspectors",
    "title1": "agricultural equipment assembler agricultural equipment assembly inspector agricultural equipment bench assembler agricultural equipment inspector agricultural implement gearcase assembler agricultural implements inspector air-cooled engine assembler all-terrain vehicles inspector assembler, agricultural implements assembler, air-cooled engines assembler, automobile gear assembler, automotive engine accessories assembler, automotive engines assembler, automotive radiator assembler, buses assembler, carburetors assembler, clutches assembler, cylinder heads assembler, diesel engines assembler, differentials assembler, electric furnace assembler, farm equipment assembler, fuel pumps assembler, garden machinery assembler, gas furnace assembler, gasoline engines assembler, gearbox assembler, hydraulic hoist assembler, hydraulic pump assembler, light material-handling equipment assembler, mechanical pumps assembler, outboard motor � mechanical assembly assembler, power lawn mowers assembler, power snowblowers assembler, railway cars assembler, recreational vehicles assembler, rotary tillers assembler, sewing machine assembler, small marine engines assembler, snowmobiles assembler, tractors assembler, trailer assembler, transmissions assembler, truck assembler, truck trailers assembler, vending machines automobile gear assembler automotive engine accessories assembler automotive engine assembler automotive engine quality-control assembly inspector automotive production fitter automotive radiator assembler bench assembler, agricultural implements bench fitter � buses and trucks bus and truck floor framer bus and truck frame builder bus assembler bus parts inspector calibrator, gasoline pumps carburetor assembler carburetor assembly inspector clutch assembler clutch assembly inspector, motor vehicles clutch inspector clutch preassembler clutch rebuilder coach assembler � bus assembly cylinder head assembler diesel engine assembler diesel engine erector diesel engine tester differential assembler dismantler, farm machinery dynamometer tester, engines electric furnace assembler engine accessories inspector engine dynamometer tester erector, diesel engines exterior trailer finisher farm equipment assembly inspector farm implement assembler farm machinery dismantler final inspector, snowmobile final inspector, truck trailer finisher, trailer exteriors firearms fitter fitter, firearms floor framer, buses and trucks food-packaging equipment assembly inspector frame builder, buses and trucks fuel pump assembler garden machinery assembler gas furnace assembler gasoline engine assembler gasoline pump calibrator gasoline pump tester gear train assembler gearbox assembler gearcase assembler gearcase assembler, agricultural implements gearcase tester go-kart assembler group leader, mechanical assemblers gun assembler gun subassembler hydraulic hoist assembler hydraulic pump assembler inspector and tester, outboard motors inspector and tester, turbine assembly inspector, agricultural implements inspector, agricultural implements assembly inspector, all-terrain vehicles inspector, bus parts inspector, carburetor assembly inspector, clutches inspector, engine accessories inspector, farm implements assembly inspector, food-packaging equipment assembly inspector, motor vehicle clutch assembly inspector, snowmobiles interior trailer finisher internal combustion engine assembler lead hand, mechanical assemblers light agricultural equipment assembler light agricultural machinery assembler light construction equipment assembler light farm equipment assembler light industrial truck assembler light material-handling equipment assembler machine try-out tester marine engine quality-control assembly inspector mechanical assembler mechanical pump assembler outboard motor assembler � mechanical assembly outboard motor inspector and tester outboard motor prototype tester power lawn mower assembler power snowblower assembler preassembler, clutches prototype tester, outboard motors quality-control assembly inspector, automotive engines quality-control assembly inspector, marine engines radiator maker railway car assembler railway car liner railway car trimmer rebuilder, clutches recreation vehicle assembler rotary tiller assembler sewing machine assembler sewing machine assembly tester small marine engine assembler snowmobile assembler snowmobile final inspector snowmobile inspector snowmobile test rider steel plate caulker � shipbuilding steering box assembler tester, diesel engines tester, gasoline pumps tester, gearcases tooling and metalworking machine try-out tester tractor assembler trailer assembler trailer frame assembler transmission assembler transmission assembly inspector transmission assembly tester truck assembler truck assembly inspector truck body builder truck trailer assembler truck trailer builder truck trailer final inspector try-out tester, tooling and metalworking machines turbine assembly inspector and tester vending machine assembler vending machine tester water pump assembler wheelchair lift assembler",
    "title2": 0,
    "title3": 0,
    "allTitles": "agricultural equipment assembler agricultural equipment assembly inspector agricultural equipment bench assembler agricultural equipment inspector agricultural implement gearcase assembler agricultural implements inspector air-cooled engine assembler all-terrain vehicles inspector assembler, agricultural implements assembler, air-cooled engines assembler, automobile gear assembler, automotive engine accessories assembler, automotive engines assembler, automotive radiator assembler, buses assembler, carburetors assembler, clutches assembler, cylinder heads assembler, diesel engines assembler, differentials assembler, electric furnace assembler, farm equipment assembler, fuel pumps assembler, garden machinery assembler, gas furnace assembler, gasoline engines assembler, gearbox assembler, hydraulic hoist assembler, hydraulic pump assembler, light material-handling equipment assembler, mechanical pumps assembler, outboard motor � mechanical assembly assembler, power lawn mowers assembler, power snowblowers assembler, railway cars assembler, recreational vehicles assembler, rotary tillers assembler, sewing machine assembler, small marine engines assembler, snowmobiles assembler, tractors assembler, trailer assembler, transmissions assembler, truck assembler, truck trailers assembler, vending machines automobile gear assembler automotive engine accessories assembler automotive engine assembler automotive engine quality-control assembly inspector automotive production fitter automotive radiator assembler bench assembler, agricultural implements bench fitter � buses and trucks bus and truck floor framer bus and truck frame builder bus assembler bus parts inspector calibrator, gasoline pumps carburetor assembler carburetor assembly inspector clutch assembler clutch assembly inspector, motor vehicles clutch inspector clutch preassembler clutch rebuilder coach assembler � bus assembly cylinder head assembler diesel engine assembler diesel engine erector diesel engine tester differential assembler dismantler, farm machinery dynamometer tester, engines electric furnace assembler engine accessories inspector engine dynamometer tester erector, diesel engines exterior trailer finisher farm equipment assembly inspector farm implement assembler farm machinery dismantler final inspector, snowmobile final inspector, truck trailer finisher, trailer exteriors firearms fitter fitter, firearms floor framer, buses and trucks food-packaging equipment assembly inspector frame builder, buses and trucks fuel pump assembler garden machinery assembler gas furnace assembler gasoline engine assembler gasoline pump calibrator gasoline pump tester gear train assembler gearbox assembler gearcase assembler gearcase assembler, agricultural implements gearcase tester go-kart assembler group leader, mechanical assemblers gun assembler gun subassembler hydraulic hoist assembler hydraulic pump assembler inspector and tester, outboard motors inspector and tester, turbine assembly inspector, agricultural implements inspector, agricultural implements assembly inspector, all-terrain vehicles inspector, bus parts inspector, carburetor assembly inspector, clutches inspector, engine accessories inspector, farm implements assembly inspector, food-packaging equipment assembly inspector, motor vehicle clutch assembly inspector, snowmobiles interior trailer finisher internal combustion engine assembler lead hand, mechanical assemblers light agricultural equipment assembler light agricultural machinery assembler light construction equipment assembler light farm equipment assembler light industrial truck assembler light material-handling equipment assembler machine try-out tester marine engine quality-control assembly inspector mechanical assembler mechanical pump assembler outboard motor assembler � mechanical assembly outboard motor inspector and tester outboard motor prototype tester power lawn mower assembler power snowblower assembler preassembler, clutches prototype tester, outboard motors quality-control assembly inspector, automotive engines quality-control assembly inspector, marine engines radiator maker railway car assembler railway car liner railway car trimmer rebuilder, clutches recreation vehicle assembler rotary tiller assembler sewing machine assembler sewing machine assembly tester small marine engine assembler snowmobile assembler snowmobile final inspector snowmobile inspector snowmobile test rider steel plate caulker � shipbuilding steering box assembler tester, diesel engines tester, gasoline pumps tester, gearcases tooling and metalworking machine try-out tester tractor assembler trailer assembler trailer frame assembler transmission assembler transmission assembly inspector transmission assembly tester truck assembler truck assembly inspector truck body builder truck trailer assembler truck trailer builder truck trailer final inspector try-out tester, tooling and metalworking machines turbine assembly inspector and tester vending machine assembler vending machine tester water pump assembler wheelchair lift assembler",
    "workers": 8240,
    "minEduc": 0,
    "yearsStudy": 2.158260234,
    "automationRisk": 0.9325,
    "salaryLow": 14,
    "salaryMed": 20,
    "salaryHigh": 26.59,
    "totalSkill": 8240,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 17.82379547,
    "skillsComp": 33.5,
    "skillsLogi": 30.5,
    "skillsMath": 18,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1125,
    "f2Engineering": 1915,
    "f3Humanities": 155,
    "f4SocialScience": 322.5,
    "f5FineArts": 292.5,
    "f6MathAndComputerScience": 232.5,
    "f7Arts&Education": 1717.5,
    "f8Education(teachertraining)": 112.5,
    "f9Law": 470,
    "f10Health": 125,
    "f11Health,Nursing&ClinicalLaboratory": 392.5,
    "f12Business": 1380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 155,
    "d5SocialSciences": 322.5,
    "d6Fine&AppliedArts": 292.5,
    "d7ComputerScience": 200,
    "d8OtherArts&Science": 1717.5,
    "d9Education(teachertraining)": 112.5,
    "d10Engineering": 1885,
    "d11Law": 470,
    "d12Mathematics": 32.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 1025,
    "d16Therapy&Rehabilitation": 82.5,
    "d17Health,Nursing&ClinicalLaboratory": 392.5,
    "d18Business&Commerce": 1380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 478,
    "noc": 9527,
    "job": "Machine operators and inspectors, electrical apparatus manufacturing",
    "title1": "arbor press tender � electrical equipment manufacturing armature tester assembler, battery chargers assembler, dry cell and battery assembler, dry cell batteries assembler, dry cells assembler, flat dry batteries assembler, flat dry cells assembler, industrial storage battery plates assembler, storage batteries assembly line operator, storage batteries assembly machine setter � electrical equipment manufacturing assembly machine set-up person � electrical equipment manufacturing automatic coil winder � electrical equipment manufacturing balancing machine operator � electrical equipment manufacturing balancing machine operator � small electric motors balancing machine tender � electrical equipment manufacturing base filler � electrical equipment manufacturing base-filling machine operator � electrical equipment manufacturing base-filling machine tender � electrical equipment manufacturing battery assembler battery case inspector and tester battery charger � electrical equipment manufacturing battery charger assembler battery charger operator � electrical equipment manufacturing battery maker brush lacer and trimmer � electrical equipment manufacturing brush-lacing and trimming operator � electrical equipment manufacturing cable-coding machine tender � electrical equipment manufacturing cable-marking machine tender � electrical equipment manufacturing capping machine tender, dry cells � electrical equipment manufacturing cement-filling machine operator � electrical equipment manufacturing charger � electrical equipment manufacturing charger operator � electrical equipment manufacturing charging room operator � electrical equipment manufacturing coater � electrical equipment manufacturing coating machine operator � electrical equipment manufacturing coding machine tender � electrical equipment manufacturing crimping machine tender � electrical equipment manufacturing dip and bake operator � electrical equipment manufacturing dry battery coremaking machine tender dry battery inspector � electrical equipment manufacturing dry battery process room operator � electrical equipment manufacturing dry battery tester � electrical equipment manufacturing dry cell and battery assembler dry cell assembler dry cell assembly machine feeder � electrical equipment manufacturing dry cell battery assembler dry cell charge machine operator dry cell charge machine operator � electrical equipment manufacturing dry cell charger operator � electrical equipment manufacturing dry cell coremaking machine tender dry cell coremaking machine tender � electrical equipment manufacturing dry cell sealer � electrical equipment manufacturing dry cell tester � electrical equipment manufacturing dry cell tube machine assembler � electrical equipment manufacturing electric bulb maker electric fuse maker electrical connection crimper electrical dry cell inspector electrical dry cell inspector � electrical equipment manufacturing electrical dry cell-making inspector electrical equipment base filler electrical equipment impregnator electrical equipment manufacturing machine operator electrical lamp-making machine set-up man/woman electrical lead acid storage battery filler electrical plug maker electrical storage battery charger operator electrical storage battery inspector electrical storage battery plate washer and dryer electrical storage battery repairer � electrical equipment manufacturing electrical storage battery tester electrical-equipment-impregnating machine operator electrode installer electrolytic anode changer encapsulator � electrical equipment manufacturing epoxy coater � electrical equipment manufacturing epoxy coating machine operator epoxy coating machine operator � electrical equipment manufacturing epoxy encapsulator � electrical equipment manufacturing filler, electrical lead acid storage batteries filling machine tender � electrical equipment manufacturing flat battery maker flat cell maker � electrical equipment manufacturing flat dry battery assembler flat dry cell assembler flat dry cell machine tender � electrical equipment manufacturing foam machine operator � electrical equipment manufacturing forming room operator � electrical equipment manufacturing heat seal equipment operator � electrical equipment manufacturing heating element coil former � electrical equipment manufacturing heating element coil-former operator heavy-duty electrical battery charger tester impregnator, electrical equipment incandescent lamp making inspector industrial battery assembler industrial storage battery plate assembler inspector and tester, battery case � electrical equipment manufacturing inspector and tester, battery cases inspector, electrical dry battery inspector, electrical dry cell inspector, electrical light bulbs inspector, lead acid battery parts inspector, light bulbs lamination-stacking machine tender � electrical equipment manufacturing lamp filament processor lead acid battery parts inspector lead acid battery production tester � electrical equipment manufacturing lead acid electrical battery production tester lead acid storage battery plate former � electrical equipment manufacturing lead acid storage battery plate maker lead acid storage battery tester lead acid storage battery tester � electrical equipment manufacturing lead former � electrical equipment manufacturing light bulb inspector light bulb inspector and tester light bulb maker light bulb making inspector light bulb making machine operator light bulb tester light-bulb-sealing machine operator � electrical equipment manufacturing light-bulb-sealing machine tender � electrical equipment manufacturing machine base cement filler � electrical equipment manufacturing machine operator � electrical appliance and equipment manufacturing machine operator � electrical appliance manufacturing machine operator � electrical equipment manufacturing machine riveter � electrical equipment manufacturing machine set-up operator � electric equipment manufacturing machine set-up operator � electrical appliance manufacturing machine set-up operator � electrical equipment manufacturing machine sleeve assembler � electrical equipment manufacturing machine tube assembler � electrical equipment manufacturing machine tuber � electrical equipment manufacturing machine wire-cutter and wire-stripper � electrical equipment manufacturing operator � electrical equipment manufacturing operator, forming room � electrical equipment manufacturing operator, press � electrical equipment manufacturing pasting machine operator � electrical equipment manufacturing plate former, lead acid storage battery � electrical equipment manufacturing plate-parting machine operator � electrical equipment manufacturing press operator � electrical equipment manufacturing press tender � electrical equipment manufacturing process room operator, dry battery � electrical equipment manufacturing production line battery repairer � electrical equipment manufacturing production line setter and servicer � electrical equipment manufacturing production line storage battery repairer � electrical equipment manufacturing production machine operator � electrical equipment manufacturing production machine set-up operator � electrical appliance and equipment manufacturing production tester, lead acid electrical battery riveting machine operator � electrical equipment manufacturing riveting machine tender � electrical equipment manufacturing sealer, dry cell � electrical equipment manufacturing set-up man/woman, electrical lamp-making machines sleeve-making machine tender � electrical equipment manufacturing spray foam machine operator � electrical equipment manufacturing stacking machine operator � electrical equipment manufacturing storage battery assembler storage battery assembly line operator storage battery charger � electrical equipment manufacturing storage battery tester storage battery tube filler � electrical equipment manufacturing taper operator � electrical equipment manufacturing taper tender � electrical equipment manufacturing taping machine tender � electrical equipment manufacturing tester, electrical storage batteries tester, lead acid storage battery tester, light bulbs top-capping machine tender � electrical equipment manufacturing transformer coil impregnator wafer machine tender � electrical equipment manufacturing wafering machine operator � electrical equipment manufacturing wire stripper � electrical equipment manufacturing wire-numbering machine tender � electrical equipment manufacturing wireworker � electrical equipment manufacturing wrapper-stacker operator � electrical equipment manufacturing wrapping machine tender � electrical equipment manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "arbor press tender � electrical equipment manufacturing armature tester assembler, battery chargers assembler, dry cell and battery assembler, dry cell batteries assembler, dry cells assembler, flat dry batteries assembler, flat dry cells assembler, industrial storage battery plates assembler, storage batteries assembly line operator, storage batteries assembly machine setter � electrical equipment manufacturing assembly machine set-up person � electrical equipment manufacturing automatic coil winder � electrical equipment manufacturing balancing machine operator � electrical equipment manufacturing balancing machine operator � small electric motors balancing machine tender � electrical equipment manufacturing base filler � electrical equipment manufacturing base-filling machine operator � electrical equipment manufacturing base-filling machine tender � electrical equipment manufacturing battery assembler battery case inspector and tester battery charger � electrical equipment manufacturing battery charger assembler battery charger operator � electrical equipment manufacturing battery maker brush lacer and trimmer � electrical equipment manufacturing brush-lacing and trimming operator � electrical equipment manufacturing cable-coding machine tender � electrical equipment manufacturing cable-marking machine tender � electrical equipment manufacturing capping machine tender, dry cells � electrical equipment manufacturing cement-filling machine operator � electrical equipment manufacturing charger � electrical equipment manufacturing charger operator � electrical equipment manufacturing charging room operator � electrical equipment manufacturing coater � electrical equipment manufacturing coating machine operator � electrical equipment manufacturing coding machine tender � electrical equipment manufacturing crimping machine tender � electrical equipment manufacturing dip and bake operator � electrical equipment manufacturing dry battery coremaking machine tender dry battery inspector � electrical equipment manufacturing dry battery process room operator � electrical equipment manufacturing dry battery tester � electrical equipment manufacturing dry cell and battery assembler dry cell assembler dry cell assembly machine feeder � electrical equipment manufacturing dry cell battery assembler dry cell charge machine operator dry cell charge machine operator � electrical equipment manufacturing dry cell charger operator � electrical equipment manufacturing dry cell coremaking machine tender dry cell coremaking machine tender � electrical equipment manufacturing dry cell sealer � electrical equipment manufacturing dry cell tester � electrical equipment manufacturing dry cell tube machine assembler � electrical equipment manufacturing electric bulb maker electric fuse maker electrical connection crimper electrical dry cell inspector electrical dry cell inspector � electrical equipment manufacturing electrical dry cell-making inspector electrical equipment base filler electrical equipment impregnator electrical equipment manufacturing machine operator electrical lamp-making machine set-up man/woman electrical lead acid storage battery filler electrical plug maker electrical storage battery charger operator electrical storage battery inspector electrical storage battery plate washer and dryer electrical storage battery repairer � electrical equipment manufacturing electrical storage battery tester electrical-equipment-impregnating machine operator electrode installer electrolytic anode changer encapsulator � electrical equipment manufacturing epoxy coater � electrical equipment manufacturing epoxy coating machine operator epoxy coating machine operator � electrical equipment manufacturing epoxy encapsulator � electrical equipment manufacturing filler, electrical lead acid storage batteries filling machine tender � electrical equipment manufacturing flat battery maker flat cell maker � electrical equipment manufacturing flat dry battery assembler flat dry cell assembler flat dry cell machine tender � electrical equipment manufacturing foam machine operator � electrical equipment manufacturing forming room operator � electrical equipment manufacturing heat seal equipment operator � electrical equipment manufacturing heating element coil former � electrical equipment manufacturing heating element coil-former operator heavy-duty electrical battery charger tester impregnator, electrical equipment incandescent lamp making inspector industrial battery assembler industrial storage battery plate assembler inspector and tester, battery case � electrical equipment manufacturing inspector and tester, battery cases inspector, electrical dry battery inspector, electrical dry cell inspector, electrical light bulbs inspector, lead acid battery parts inspector, light bulbs lamination-stacking machine tender � electrical equipment manufacturing lamp filament processor lead acid battery parts inspector lead acid battery production tester � electrical equipment manufacturing lead acid electrical battery production tester lead acid storage battery plate former � electrical equipment manufacturing lead acid storage battery plate maker lead acid storage battery tester lead acid storage battery tester � electrical equipment manufacturing lead former � electrical equipment manufacturing light bulb inspector light bulb inspector and tester light bulb maker light bulb making inspector light bulb making machine operator light bulb tester light-bulb-sealing machine operator � electrical equipment manufacturing light-bulb-sealing machine tender � electrical equipment manufacturing machine base cement filler � electrical equipment manufacturing machine operator � electrical appliance and equipment manufacturing machine operator � electrical appliance manufacturing machine operator � electrical equipment manufacturing machine riveter � electrical equipment manufacturing machine set-up operator � electric equipment manufacturing machine set-up operator � electrical appliance manufacturing machine set-up operator � electrical equipment manufacturing machine sleeve assembler � electrical equipment manufacturing machine tube assembler � electrical equipment manufacturing machine tuber � electrical equipment manufacturing machine wire-cutter and wire-stripper � electrical equipment manufacturing operator � electrical equipment manufacturing operator, forming room � electrical equipment manufacturing operator, press � electrical equipment manufacturing pasting machine operator � electrical equipment manufacturing plate former, lead acid storage battery � electrical equipment manufacturing plate-parting machine operator � electrical equipment manufacturing press operator � electrical equipment manufacturing press tender � electrical equipment manufacturing process room operator, dry battery � electrical equipment manufacturing production line battery repairer � electrical equipment manufacturing production line setter and servicer � electrical equipment manufacturing production line storage battery repairer � electrical equipment manufacturing production machine operator � electrical equipment manufacturing production machine set-up operator � electrical appliance and equipment manufacturing production tester, lead acid electrical battery riveting machine operator � electrical equipment manufacturing riveting machine tender � electrical equipment manufacturing sealer, dry cell � electrical equipment manufacturing set-up man/woman, electrical lamp-making machines sleeve-making machine tender � electrical equipment manufacturing spray foam machine operator � electrical equipment manufacturing stacking machine operator � electrical equipment manufacturing storage battery assembler storage battery assembly line operator storage battery charger � electrical equipment manufacturing storage battery tester storage battery tube filler � electrical equipment manufacturing taper operator � electrical equipment manufacturing taper tender � electrical equipment manufacturing taping machine tender � electrical equipment manufacturing tester, electrical storage batteries tester, lead acid storage battery tester, light bulbs top-capping machine tender � electrical equipment manufacturing transformer coil impregnator wafer machine tender � electrical equipment manufacturing wafering machine operator � electrical equipment manufacturing wire stripper � electrical equipment manufacturing wire-numbering machine tender � electrical equipment manufacturing wireworker � electrical equipment manufacturing wrapper-stacker operator � electrical equipment manufacturing wrapping machine tender � electrical equipment manufacturing",
    "workers": 8240,
    "minEduc": 0,
    "yearsStudy": 2.158260234,
    "automationRisk": 0.9325,
    "salaryLow": 14,
    "salaryMed": 20.53,
    "salaryHigh": 34.81,
    "totalSkill": 8240,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Assemblers in manufacturing",
    "cluster": 7,
    "wage": 17.82379547,
    "skillsComp": 33.5,
    "skillsLogi": 30.5,
    "skillsMath": 18,
    "skillsLang": 39.5,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 10,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 1125,
    "f2Engineering": 1915,
    "f3Humanities": 155,
    "f4SocialScience": 322.5,
    "f5FineArts": 292.5,
    "f6MathAndComputerScience": 232.5,
    "f7Arts&Education": 1717.5,
    "f8Education(teachertraining)": 112.5,
    "f9Law": 470,
    "f10Health": 125,
    "f11Health,Nursing&ClinicalLaboratory": 392.5,
    "f12Business": 1380,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 70,
    "d2Forestry": 30,
    "d3Architecture&LandscapeArchitecture": 30,
    "d4Humanities": 155,
    "d5SocialSciences": 322.5,
    "d6Fine&AppliedArts": 292.5,
    "d7ComputerScience": 200,
    "d8OtherArts&Science": 1717.5,
    "d9Education(teachertraining)": 112.5,
    "d10Engineering": 1885,
    "d11Law": 470,
    "d12Mathematics": 32.5,
    "d13Kinesiology/Recreation/PhysicalEducation": 42.5,
    "d14Theology": 0,
    "d15PhysicalSciences": 1025,
    "d16Therapy&Rehabilitation": 82.5,
    "d17Health,Nursing&ClinicalLaboratory": 392.5,
    "d18Business&Commerce": 1380,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 479,
    "noc": 9531,
    "job": "Boat assemblers and inspectors",
    "title1": "aluminum boat assembler aluminum boat leak tester assembler, boats assembler, canoes assembler, dinghies assembler, motorboats assembler, sailboats assembly inspector, boats assembly inspector, motorboats assembly inspector, wooden boats assembly laminator, boats assembly repairer, boats boat assembler boat assembler, aluminum boat assembler, fibreglass boat assembly inspector boat assembly laminator boat assembly repairer boat assembly repairer, fibreglass boat inspector boat inspector and finisher, fibreglass boat inspector, wood boat motor installer canoe assembler canoe building inspector canoe canvasser canvas canoe waterproofer caulker, wooden hulls � boat assembly dinghy assembler fibreglass boat assembler fibreglass boat inspector and finisher hull inspector hull surveyor inspector and finisher, fibreglass boats inspector, boat assembly inspector, boats inspector, canoe building inspector, hull inspector, motorboat assembly inspector, wooden boat assembly inspector, wooden boats installer, boat motors installer, outboard motors installer-fitter, outboard motors laminator, boat assembly leak tester, aluminum boats loft rigger � boat assembly motor installer, boats motorboat assembler motorboat assembly inspector outboard motor installer outboard motor installer-fitter plywood boat veneer layer repairer, boat assembly repairer, fibreglass boat assembly rivet tester � boat assembly sailboat assembler tester, rivets � boat assembly veneer layer, plywood boat waterproofer, canoe canvas wooden boat assembly inspector wooden boat inspector wooden hull caulker � boat assembly",
    "title2": 0,
    "title3": 0,
    "allTitles": "aluminum boat assembler aluminum boat leak tester assembler, boats assembler, canoes assembler, dinghies assembler, motorboats assembler, sailboats assembly inspector, boats assembly inspector, motorboats assembly inspector, wooden boats assembly laminator, boats assembly repairer, boats boat assembler boat assembler, aluminum boat assembler, fibreglass boat assembly inspector boat assembly laminator boat assembly repairer boat assembly repairer, fibreglass boat inspector boat inspector and finisher, fibreglass boat inspector, wood boat motor installer canoe assembler canoe building inspector canoe canvasser canvas canoe waterproofer caulker, wooden hulls � boat assembly dinghy assembler fibreglass boat assembler fibreglass boat inspector and finisher hull inspector hull surveyor inspector and finisher, fibreglass boats inspector, boat assembly inspector, boats inspector, canoe building inspector, hull inspector, motorboat assembly inspector, wooden boat assembly inspector, wooden boats installer, boat motors installer, outboard motors installer-fitter, outboard motors laminator, boat assembly leak tester, aluminum boats loft rigger � boat assembly motor installer, boats motorboat assembler motorboat assembly inspector outboard motor installer outboard motor installer-fitter plywood boat veneer layer repairer, boat assembly repairer, fibreglass boat assembly rivet tester � boat assembly sailboat assembler tester, rivets � boat assembly veneer layer, plywood boat waterproofer, canoe canvas wooden boat assembly inspector wooden boat inspector wooden hull caulker � boat assembly",
    "workers": 33646.66667,
    "minEduc": 0.5,
    "yearsStudy": 2.219475472,
    "automationRisk": 0.935,
    "salaryLow": 14.1,
    "salaryMed": 16.79,
    "salaryHigh": 26.36,
    "totalSkill": 125,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 18.51088859,
    "skillsComp": 35.16666667,
    "skillsLogi": 30.33333333,
    "skillsMath": 17.66666667,
    "skillsLang": 41.66666667,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 8.333333333,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.666666667,
    "s6MoneyMath": 3.833333333,
    "s7NumericalEstimation": 3.666666667,
    "s8OralCommunication": 12.66666667,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17.83333333,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15.16666667,
    "s13DocumentUse": 15.5,
    "s14Writing": 10.83333333,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 16.66666667,
    "f3Humanities": 8.333333333,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 6.666666667,
    "f7Arts&Education": 118.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 3.333333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 8.333333333,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 6.666666667,
    "d8OtherArts&Science": 118.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 16.66666667,
    "d11Law": 3.333333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 480,
    "noc": 9532,
    "job": "Furniture and fixture assemblers and inspectors",
    "title1": "assembler, box spring units � furniture manufacturing assembler, box springs assembler, cabinet � furniture manufacturing assembler, chairs assembler, desk assembler, fixture assembler, furniture assembler, mattress � furniture manufacturing assembler, metal cabinets assembler, metal chairs assembler, metal tables assembler, mirror and picture frames assembler, office chairs assembler, picture frames � furniture and fixtures manufacturing assembler, tables assembler, wooden tables assembly inspector � furniture manufacturing assembly repairer, wooden furniture assembly repairman/woman, wooden furniture bed assembler bedspring stretcher bench worker � furniture manufacturing billiard table assembler box spring assembler box spring frame assembler box spring unit assembler � furniture manufacturing cabinet assembler � furniture manufacturing cabinet assembler � wood products manufacturing cabinet inspector � furniture manufacturing casket assembler, wood casket maker, wood chair assembler chair caner � furniture manufacturing chair inspector � furniture manufacturing chair seat weaver coffin and casket fitter desk assembler drawer assembler drawer fitter final inspector, furniture assembly fitter-up, furniture � furniture manufacturing fixture assembler frame assembler, wood furniture frame maker � furniture manufacturing furniture and fixtures assembler furniture and fixtures assembling inspector furniture and fixtures assembly inspector furniture and fixtures inspector � furniture manufacturing furniture and fixtures manufacturing inspector furniture assembler furniture assembler, metal furniture assembler, wood furniture assembly inspector � furniture manufacturing furniture caner furniture checker furniture finishing inspector furniture fitter-up � furniture manufacturing furniture inspector furniture parts inspector furniture shipping inspector gluer � furniture manufacturing grader, stock � furniture manufacturing hand laminator � furniture manufacturing hardware assembler � furniture manufacturing hardware installer � furniture manufacturing hardware installer, metal � furniture manufacturing hardware mounter � furniture manufacturing hydraulic chair assembler inlayer � woodworking inspector � furniture manufacturing inspector, assembled furniture inspector, assembly � furniture manufacturing inspector, chairs � furniture manufacturing inspector, furniture inspector, furniture and fixtures � furniture manufacturing inspector, furniture and fixtures assembling inspector, furniture and fixtures assembly inspector, furniture assembly � furniture manufacturing inspector, furniture finishing inspector, furniture parts inspector, metal furniture inspector, product � furniture manufacturing inspector, sofas � furniture manufacturing installer, hardware � furniture manufacturing installer, metal hardware � furniture manufacturing laminator, hand � furniture manufacturing lead hand assembler � furniture manufacturing marquetry worker � furniture manufacturing mattress assembler � furniture manufacturing mattress inspector mattress maker mattress manufacturing inspector metal cabinet assembler metal casket assembler metal chair assembler metal furniture assembler metal furniture inspector metal hardware installer � furniture manufacturing metal locker assembler metal table assembler mirror and picture frame assembler mirror and picture frame maker office chair assembler picture frame assembler � furniture and fixtures manufacturing product inspector � furniture manufacturing production worker � furniture manufacturing sofa inspector � furniture manufacturing stock grader � furniture manufacturing subassembler � furniture manufacturing table assembler table assembler, wood upfitter � furniture manufacturing weaver, chair seat wood furniture assembler wooden casket assembler wooden furniture assembly repairer wooden table assembler",
    "title2": 0,
    "title3": 0,
    "allTitles": "assembler, box spring units � furniture manufacturing assembler, box springs assembler, cabinet � furniture manufacturing assembler, chairs assembler, desk assembler, fixture assembler, furniture assembler, mattress � furniture manufacturing assembler, metal cabinets assembler, metal chairs assembler, metal tables assembler, mirror and picture frames assembler, office chairs assembler, picture frames � furniture and fixtures manufacturing assembler, tables assembler, wooden tables assembly inspector � furniture manufacturing assembly repairer, wooden furniture assembly repairman/woman, wooden furniture bed assembler bedspring stretcher bench worker � furniture manufacturing billiard table assembler box spring assembler box spring frame assembler box spring unit assembler � furniture manufacturing cabinet assembler � furniture manufacturing cabinet assembler � wood products manufacturing cabinet inspector � furniture manufacturing casket assembler, wood casket maker, wood chair assembler chair caner � furniture manufacturing chair inspector � furniture manufacturing chair seat weaver coffin and casket fitter desk assembler drawer assembler drawer fitter final inspector, furniture assembly fitter-up, furniture � furniture manufacturing fixture assembler frame assembler, wood furniture frame maker � furniture manufacturing furniture and fixtures assembler furniture and fixtures assembling inspector furniture and fixtures assembly inspector furniture and fixtures inspector � furniture manufacturing furniture and fixtures manufacturing inspector furniture assembler furniture assembler, metal furniture assembler, wood furniture assembly inspector � furniture manufacturing furniture caner furniture checker furniture finishing inspector furniture fitter-up � furniture manufacturing furniture inspector furniture parts inspector furniture shipping inspector gluer � furniture manufacturing grader, stock � furniture manufacturing hand laminator � furniture manufacturing hardware assembler � furniture manufacturing hardware installer � furniture manufacturing hardware installer, metal � furniture manufacturing hardware mounter � furniture manufacturing hydraulic chair assembler inlayer � woodworking inspector � furniture manufacturing inspector, assembled furniture inspector, assembly � furniture manufacturing inspector, chairs � furniture manufacturing inspector, furniture inspector, furniture and fixtures � furniture manufacturing inspector, furniture and fixtures assembling inspector, furniture and fixtures assembly inspector, furniture assembly � furniture manufacturing inspector, furniture finishing inspector, furniture parts inspector, metal furniture inspector, product � furniture manufacturing inspector, sofas � furniture manufacturing installer, hardware � furniture manufacturing installer, metal hardware � furniture manufacturing laminator, hand � furniture manufacturing lead hand assembler � furniture manufacturing marquetry worker � furniture manufacturing mattress assembler � furniture manufacturing mattress inspector mattress maker mattress manufacturing inspector metal cabinet assembler metal casket assembler metal chair assembler metal furniture assembler metal furniture inspector metal hardware installer � furniture manufacturing metal locker assembler metal table assembler mirror and picture frame assembler mirror and picture frame maker office chair assembler picture frame assembler � furniture and fixtures manufacturing product inspector � furniture manufacturing production worker � furniture manufacturing sofa inspector � furniture manufacturing stock grader � furniture manufacturing subassembler � furniture manufacturing table assembler table assembler, wood upfitter � furniture manufacturing weaver, chair seat wood furniture assembler wooden casket assembler wooden furniture assembly repairer wooden table assembler",
    "workers": 33646.66667,
    "minEduc": 0.5,
    "yearsStudy": 2.219475472,
    "automationRisk": 0.935,
    "salaryLow": 14,
    "salaryMed": 17,
    "salaryHigh": 22,
    "totalSkill": 125,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 18.51088859,
    "skillsComp": 35.16666667,
    "skillsLogi": 30.33333333,
    "skillsMath": 17.66666667,
    "skillsLang": 41.66666667,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 8.333333333,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.666666667,
    "s6MoneyMath": 3.833333333,
    "s7NumericalEstimation": 3.666666667,
    "s8OralCommunication": 12.66666667,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17.83333333,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15.16666667,
    "s13DocumentUse": 15.5,
    "s14Writing": 10.83333333,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 16.66666667,
    "f3Humanities": 8.333333333,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 6.666666667,
    "f7Arts&Education": 118.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 3.333333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 8.333333333,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 6.666666667,
    "d8OtherArts&Science": 118.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 16.66666667,
    "d11Law": 3.333333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 481,
    "noc": 9533,
    "job": "Other wood products assemblers and inspectors",
    "title1": "assembler, bench - wood products manufacturing",
    "title2": "assembler, hockey sticks",
    "title3": "assembler, hogsheads - wood products manufacturing",
    "allTitles": "assembler, bench - wood products manufacturingassembler, hockey sticksassembler, hogsheads - wood products manufacturingassembler, manufactured homesassembler, millwork - wood products manufacturingassembler, prefab housingassemblers lead hand - wood products manufacturingassembler, wooden barrel stavesassembler, wooden boxesassembler, wooden bucket stavesassembler, wooden casesassembler, wooden casket framesassembler, wooden cratesassembler, wooden doorsassembler, wooden prefab housingassembler, wooden reelsassembler, wooden tanksassembler, wooden tank stavesassembler, woodenwareassembler, wood productsassembly line gluer - wood products manufacturingbanquette assembler - wood product manufacturingbarrel builder, woodbarrel end fitter, woodbarrel header, woodbarrel heading fitter, woodbarrel inspector - wood products manufacturingbarrel maker, woodbarrel stave assembler, woodbasket maker, woodbench assembler, wood productsbench assembler - wood products manufacturingbench hand, wooden boxbox assembler, woodbox blank former, woodbox builder, woodbox maker, woodcase maker, woodcasket frame assembler, woodcasket inspector, woodcasket moulding setter, woodcasket top frame fitter, woodcasket top frame setter, woodclamp carriercoopercrate builder, woodcrate maker, wooddoor assembler, wooddoor finisher - wood products manufacturingdoor inspector, wooddoor maker, wooddoor patcher, wood - wood products manufacturingdoor repairer, wood - wood products manufacturingdoor repairman, wood - wood products manufacturingdoor repairwoman, wood - wood products manufacturingfabricator, wooden modular housingfactory assembler, wood productsfinisher, doors - wood products manufacturingfinisher, wooden golf club headsfitter, wooden barrel endsfitter, wooden barrel headingsfitter, wooden casket top framesflask maker, wood - foundryglue clamp operator, chain carrier - wood products manufacturingglue clamp operator - wood products manufacturinggluer, assembly line - wood products manufacturinggluer, wood productsgolf club facer, woodgolf club head finisher, woodgrader, wooden sashes and doorshockey stick assemblerhockey stick inspector-graderhogshead assembler - wood products manufacturinginspector, barrels - wood products manufacturinginspector-grader, hockey sticksinspector, laminated beamsinspector, quality control - wood products manufacturinginspector, sanding - woodworkinginspector, sashes and doors - millwork manufacturinginspector, wooden boxesinspector, wooden casketsinspector, wooden doorsinspector, wooden sashes and doorsinspector, wooden shuttlesinspector, wooden stavesinspector, wood machininginspector, wood products assemblyinspector, wood products - wood products manufacturingkeg builder, woodkeg maker, woodladder assembler, woodladder builder, woodlaminated beam inspectorlead hand, assemblers - wood products manufacturinglead hand, wood products assemblymanufactured home assemblermanufactured housing production workermatcher and assembler, wooden barrel headingsmillwork assemblermillwork assembler - wood products manufacturing",
    "workers": 27870,
    "minEduc": 0.5,
    "yearsStudy": 1.975890986,
    "automationRisk": 0.9,
    "salaryLow": 14,
    "salaryMed": 15.2,
    "salaryHigh": 21.03,
    "totalSkill": 140.5,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 20.03,
    "skillsComp": 43,
    "skillsLogi": 34.5,
    "skillsMath": 18.5,
    "skillsLang": 44,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 8,
    "s2DecisionMaking": 10,
    "s3FindingInformation": 6.5,
    "s4JobTaskPlanningandOrganizing": 3.5,
    "s5MeasurementandCalculation": 6,
    "s6MoneyMath": 4.5,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14,
    "s9ProblemSolving": 8.5,
    "s10Reading": 20.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 18.5,
    "s13DocumentUse": 16.5,
    "s14Writing": 9.5,
    "s15CriticalThinking": 6.5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 45,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 45,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 482,
    "noc": 9534,
    "job": "Furniture finishers and refinishers",
    "title1": "antiquer � furniture finishing buffer, furniture � furniture finishing decorator � furniture finishing and refinishing decorator, furniture finishing finisher � furniture finishing finisher and repairer, furniture finisher, frame mouldings � furniture manufacturing finisher, furniture finisher, wood � furniture finishing and refinishing finishing machine operator � furniture manufacturing frame moulding finisher � furniture manufacturing frame moulding painter � furniture manufacturing furniture buffer � furniture finishing furniture decorator � furniture finishing and refinishing furniture enameller furniture finisher furniture finisher and repairer furniture finishing decorator furniture finishing varnisher furniture polisher, wood � furniture finishing furniture refinisher furniture refinishing varnisher furniture reproducer furniture stainer furniture stripper furniture varnisher furniture-finishing machine operator grainer � furniture finishing and refinishing grainer, wood � furniture finishing and refinishing matcher � furniture finishing and refinishing metal furniture repairer ornamenter � furniture finishing and refinishing painter, frame mouldings � furniture manufacturing piano and organ finisher piano and organ refinisher polisher, furniture � furniture finishing polisher, wooden furniture � furniture finishing refinisher, furniture repairer, metal furniture satin finisher � furniture finishing and refinishing shader � furniture finishing and refinishing shellac sprayers � furniture finishing and refinishing spray stainer � furniture finishing and refinishing sprayer, rough shellac � furniture finishing and refinishing sprayer, shellac � furniture finishing and refinishing stainer, furniture stripper, furniture touch-up person � furniture finishing touch-up worker � furniture finishing trimmer � furniture finishing varnisher, furniture varnisher, furniture finishing varnisher, furniture refinishing wash-off operator � furniture finishing whitener � furniture finishing and refinishing wood finisher � furniture finishing and refinishing wood grainer � furniture finishing and refinishing",
    "title2": 0,
    "title3": 0,
    "allTitles": "antiquer � furniture finishing buffer, furniture � furniture finishing decorator � furniture finishing and refinishing decorator, furniture finishing finisher � furniture finishing finisher and repairer, furniture finisher, frame mouldings � furniture manufacturing finisher, furniture finisher, wood � furniture finishing and refinishing finishing machine operator � furniture manufacturing frame moulding finisher � furniture manufacturing frame moulding painter � furniture manufacturing furniture buffer � furniture finishing furniture decorator � furniture finishing and refinishing furniture enameller furniture finisher furniture finisher and repairer furniture finishing decorator furniture finishing varnisher furniture polisher, wood � furniture finishing furniture refinisher furniture refinishing varnisher furniture reproducer furniture stainer furniture stripper furniture varnisher furniture-finishing machine operator grainer � furniture finishing and refinishing grainer, wood � furniture finishing and refinishing matcher � furniture finishing and refinishing metal furniture repairer ornamenter � furniture finishing and refinishing painter, frame mouldings � furniture manufacturing piano and organ finisher piano and organ refinisher polisher, furniture � furniture finishing polisher, wooden furniture � furniture finishing refinisher, furniture repairer, metal furniture satin finisher � furniture finishing and refinishing shader � furniture finishing and refinishing shellac sprayers � furniture finishing and refinishing spray stainer � furniture finishing and refinishing sprayer, rough shellac � furniture finishing and refinishing sprayer, shellac � furniture finishing and refinishing stainer, furniture stripper, furniture touch-up person � furniture finishing touch-up worker � furniture finishing trimmer � furniture finishing varnisher, furniture varnisher, furniture finishing varnisher, furniture refinishing wash-off operator � furniture finishing whitener � furniture finishing and refinishing wood finisher � furniture finishing and refinishing wood grainer � furniture finishing and refinishing",
    "workers": 33646.66667,
    "minEduc": 0.5,
    "yearsStudy": 2.219475472,
    "automationRisk": 0.935,
    "salaryLow": 14,
    "salaryMed": 18,
    "salaryHigh": 31.38,
    "totalSkill": 125,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 18.51088859,
    "skillsComp": 35.16666667,
    "skillsLogi": 30.33333333,
    "skillsMath": 17.66666667,
    "skillsLang": 41.66666667,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 8.333333333,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.666666667,
    "s6MoneyMath": 3.833333333,
    "s7NumericalEstimation": 3.666666667,
    "s8OralCommunication": 12.66666667,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17.83333333,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15.16666667,
    "s13DocumentUse": 15.5,
    "s14Writing": 10.83333333,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 16.66666667,
    "f3Humanities": 8.333333333,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 6.666666667,
    "f7Arts&Education": 118.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 3.333333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 8.333333333,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 6.666666667,
    "d8OtherArts&Science": 118.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 16.66666667,
    "d11Law": 3.333333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 483,
    "noc": 9535,
    "job": "Plastic products assemblers, finishers and inspectors",
    "title1": "aircraft parts assembly repairer - plastic products manufacturing",
    "title2": "aircraft parts assembly repairman - plastic products manufacturing",
    "title3": "aircraft parts assembly repairwoman - plastic products manufacturing",
    "allTitles": "aircraft parts assembly repairer - plastic products manufacturingaircraft parts assembly repairman - plastic products manufacturingaircraft parts assembly repairwoman - plastic products manufacturingaircraft plastic panelling assembleraircraft plastic parts trimmer-assemblerassembler, aircraft plastic panellingassembler, automotive door panelling - plastic products manufacturingassembler, cooler shells - plastic products manufacturingassembler, fibreglass filtersassembler, luggage bindings - plastic products manufacturingassembler, marine craft plastic panellingassembler, plastic casesassembler, plastic partsassembler, plastic productsassembler, plasticsassembler, plastic tanksassembler, plastic toysassembler, Plexiglasassembler, skylights - plastic products manufacturingassembly inspector - plastic manufacturingassembly line inspector - plastic manufacturingassembly repairer, plastic productsassembly repairman, plastic productsassembly repairwoman, plastic productsatomizer cap machine tenderautomotive door panelling assembler - plastic products manufacturingbelt laminator, hand - plastic products manufacturingblister former - plastic products manufacturingbuffer, plastic productsbuffing machine operator - plastic manufacturingbuilder, plastic templatescellophane finisher - plastic manufacturingcementer, plasticschanger, plates - plastic manufacturingcompact disc inspector - plastic products manufacturingcooler shell assembler - plastic products manufacturingcutter, floorcovering insets - plastic manufacturingcutter, plasticsdicer tender - plastic manufacturingdicing machine tender - plastic manufacturingfabricator, plastic coatingfabricator, plastic packingfabricator, plastic pipingfabricator, plastic productsfibreglass filter assemblerfibreglass inspectorfibreglass laminatorfibreglass layup man - plastic manufacturingfibreglass layup man/woman - plastic manufacturingfibreglass layup woman - plastic manufacturingfibreglass layup worker - plastic manufacturingfiller-stripper, moulds - plastic manufacturingfinisher, cellophane - plastic manufacturingfinisher-grinder - plastic manufacturingfinisher, moulded plasticfinisher, plastic productsfinisher, plastic sheetsfinisher, radomes - plastic manufacturingfloorcovering inset cutter - plastic manufacturingfoam cushion production repairer - plastic products manufacturingfoam cushion production repairman - plastic products manufacturingfoam cushion production repairwoman - plastic products manufacturingfoam cushion reinforcer - plastic products manufacturingformer, blisters - plastic products manufacturingformer, Plexiglasinspector and tester, plastic productsinspector, assembly line - plastic manufacturinginspector, fibreglassinspector, linoleuminspector, moulded plasticinspector, plastic productsinspector, plastic products manufacturinginspector, plasticsinspector-tester, moulded plasticlaminator, moulds - plastic manufacturinglaminator, plastics - plastic manufacturinglayup man, fibreglass - plastic manufacturinglayup man/woman, fibreglass - plastic manufacturinglayup woman, fibreglass - plastic manufacturinglayup worker, fibreglass - plastic manufacturinglayup worker, plastic reproductionline inspector, linoleumlinoleum inspectorlinoleum line inspectorlinoleum quality control inspectormanufacturing inspector, plastic productsmarine craft plastic panelling assemblermoulded plastic finishermoulded plastic inspectormoulded plastic inspector-testermoulded plastic products trimmermoulded products finisher - plastic products manufacturingmoulded products stripper - plastic products manufacturingmoulder, plastic ankle piecesmoulder, upholstery - plastic manufacturingmould filler-stripper - plastic manufacturingmould laminator - plastic manufacturingmould stripper - plastic manufacturingmould waxer - plastic manufacturingnet applicator - plastic products manufacturing",
    "workers": 11025,
    "minEduc": 0,
    "yearsStudy": 2.054850747,
    "automationRisk": 0.9675,
    "salaryLow": 14.1,
    "salaryMed": 16.79,
    "salaryHigh": 26.36,
    "totalSkill": 120,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Distribution, tracking and scheduling co-ordination occupations",
    "cluster": 4,
    "wage": 17.80766576,
    "skillsComp": 33,
    "skillsLogi": 30,
    "skillsMath": 18,
    "skillsLang": 39,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 3.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 6,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 3,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 12.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 4.5,
    "s12DigitalTechnology": 12,
    "s13DocumentUse": 18,
    "s14Writing": 9.5,
    "s15CriticalThinking": 4.5,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 165,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 30,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 165,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 30,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 484,
    "noc": 9536,
    "job": "Industrial painters, coaters and metal finishing process operators",
    "title1": "airbrush painter aircraft painter anodizer assembly line painter, automobiles assembly painter automatic paint-sprayer operator automobile assembly line painter automobile assembly painter automobile dipper-painter automobile painter � motor vehicle manufacturing aviation painter bathtub refinisher bathtub varnisher bench lacquer sprayer bench spray painter block sander and glazier boiler painter bronze plater brush painter, production brush stainer � production cadmium galvanizer car painter � manufacturing ceramic and enamel refinisher ceramic enameler ceramic painter ceramic spray painter ceramic sprayer chromium plater cleaner-coater, vehicles coater, rustproof � motor vehicle manufacturing coater-painter, pipes coating equipment operator coating equipment operator � metal plating coating machine operator � industrial painting and coating coating machine operator, production coating machine tender � product manufacturing coating machine tender, pencils coating oven tender � manufacturing coating tank dipper continuous galvanizing line operator copper coater � metal plating copper plater corrosion resistant metal sprayer crester cylinder painter � industrial cylinder plater-grinder � metal processing decal applier dip tank attendant dipper and coater � metal plating dipper operator, paint and varnish dipper, coating tank dipper, coil springs dipper, enamel dipper-baker dipping tank operator dipping tank tender drum painter electroformer electrogalvanizer electrogalvanizing machine operator electroless plater electrolytic tank tender electroplasty equipment operator electroplater electroplater operator electroplater, metal electroplater, production electrostatic machine painter electrostatic painter electrostatic painting line tender electrostatic painting machine operator electrostatic painting machine set-up operator Elpo tank attendant enamel baker � manufacturing enamel dipper enamel painter enameller enameller � industrial painting and coating enameller � ship and boat building enameller, ceramic enameller, electrical equipment enameller, tin can dipping enamelling machine tender engine and generator support painter filament coater final colour production painter finished enamel sprayman/woman finished vehicle paint repairman/woman finishing roller industrial painter firearm burnisher � metal plating firearm finisher � metal plating galvanizer galvanizing machine operator gilder, metal-leaf hand touch-up painter � production hardboard spray-coating machine tender hot-dip coater � metal plating hot-dip galvanizer � metal plating industrial coater industrial paint baker industrial paint dipper industrial paint finisher industrial paint mixer industrial paint sprayer operator industrial painter industrial painter, finishing rollers industrial products painter industrial spray painter inspector, paint spray lacquer sprayer, bench lacquer-sprayer lacquer-sprayer, products large surface spray painter lead coater lead hand, industrial painters leather goods spray painter leather goods sprayer letterer, railway cars letterer, signs locomotive painter machine enameller machine operator � plating and metal spraying manufacturing painter metal bluer metal coater metal coater operator metal coating-equipment operator metal dipper metal electroplater metal electroplating inspector metal plater-polisher metal plating-equipment operator metal product spray painter metal spray operator metal sprayer metal-dipping equipment operator metal-leaf gilder metallizer motor and generator subassemblies painter motor vehicle painter � motor vehicle manufacturing nickel plater oven tender � painting and coating paint and mix production and control operator paint and varnish dipper operator paint baking oven tender paint control operator paint dipper � flow coating paint machine operator paint production operator paint repairman/woman, finished vehicles paint room attendant paint spray inspector paint systems attendant painter and letterer, railway cars painter, airbrush painter, aircraft painter, assembly line painter, automobile assembly painter, automobiles � motor vehicle manufacturing painter, boilers painter, cylinders painter, drum painter, enamel painter, industrial products painter, locomotives painter, motor and generator subassemblies painter, products painter, shipyard painter, tumbling barrel painter-finisher, production painting machine attendant painting machine operator painting machine tender paint-sprayer operator particleboard spraying machine tender pencil-coating machine tender pencil-tip-banding machine tender pipe coater-painter pipe spray painter plating tank operator prep line attendant � bulk galvanizing primer sprayer print applier � production product lacquer-sprayer product painter product spray painter product stainer product surface preparer and prefinisher production and control operator, paint and mix production brush painter production coating machine operator production electroplater production operator, paint production painter production painter, final colours production painter-finisher production touch-up painter railway car letterer railway car stenciller railway car varnisher refinisher, bathtubs refinisher, ceramic and enamel refinisher, stoves robotic paint sprayer attendant robotic spray paint system attendant rough benchwork spray painter rough spray painter � manufacturing rustproof coater � motor vehicle manufacturing rustproof sprayer � motor vehicle manufacturing rustproofer, motor vehicle set-up operator, electrostatic painting machine shellacker sherardizer shipyard painter sign letterer sign panel primer sign spray painter silver plater silver spray operator smoking-pipe stainer spray paint machine operator spray paint machine tender spray paint operator spray painter spray painter � motor vehicle manufacturing spray painter � production spray painter, bench spray painter, large surfaces spray painter, metal products spray painter, pipes spray painter, products spray painter, signs spray stainer � production spray-coating machine tender, hardboard sprayer, ceramic sprayer, leather goods sprayman/woman, finished enamel stainer, products stainer, smoking-pipe stenciller, railway cars stove refinisher stove varnisher temperer � plating and metal spraying thermospray operator tin can dipping enameller tin plater tinned sheet coating machine operator tinware dipper and enameller tinware dipping enameller touch-up painter, production tumbling barrel painter tumbling barrel tender undercoater � motor vehicle manufacturing vacuum-metallizer tender varnisher, railway cars vehicle cleaner-coater wire coater wire tinner wire-coating equipment operator wire-paint-coating machine tender zinc galvanizer",
    "title2": 0,
    "title3": 0,
    "allTitles": "airbrush painter aircraft painter anodizer assembly line painter, automobiles assembly painter automatic paint-sprayer operator automobile assembly line painter automobile assembly painter automobile dipper-painter automobile painter � motor vehicle manufacturing aviation painter bathtub refinisher bathtub varnisher bench lacquer sprayer bench spray painter block sander and glazier boiler painter bronze plater brush painter, production brush stainer � production cadmium galvanizer car painter � manufacturing ceramic and enamel refinisher ceramic enameler ceramic painter ceramic spray painter ceramic sprayer chromium plater cleaner-coater, vehicles coater, rustproof � motor vehicle manufacturing coater-painter, pipes coating equipment operator coating equipment operator � metal plating coating machine operator � industrial painting and coating coating machine operator, production coating machine tender � product manufacturing coating machine tender, pencils coating oven tender � manufacturing coating tank dipper continuous galvanizing line operator copper coater � metal plating copper plater corrosion resistant metal sprayer crester cylinder painter � industrial cylinder plater-grinder � metal processing decal applier dip tank attendant dipper and coater � metal plating dipper operator, paint and varnish dipper, coating tank dipper, coil springs dipper, enamel dipper-baker dipping tank operator dipping tank tender drum painter electroformer electrogalvanizer electrogalvanizing machine operator electroless plater electrolytic tank tender electroplasty equipment operator electroplater electroplater operator electroplater, metal electroplater, production electrostatic machine painter electrostatic painter electrostatic painting line tender electrostatic painting machine operator electrostatic painting machine set-up operator Elpo tank attendant enamel baker � manufacturing enamel dipper enamel painter enameller enameller � industrial painting and coating enameller � ship and boat building enameller, ceramic enameller, electrical equipment enameller, tin can dipping enamelling machine tender engine and generator support painter filament coater final colour production painter finished enamel sprayman/woman finished vehicle paint repairman/woman finishing roller industrial painter firearm burnisher � metal plating firearm finisher � metal plating galvanizer galvanizing machine operator gilder, metal-leaf hand touch-up painter � production hardboard spray-coating machine tender hot-dip coater � metal plating hot-dip galvanizer � metal plating industrial coater industrial paint baker industrial paint dipper industrial paint finisher industrial paint mixer industrial paint sprayer operator industrial painter industrial painter, finishing rollers industrial products painter industrial spray painter inspector, paint spray lacquer sprayer, bench lacquer-sprayer lacquer-sprayer, products large surface spray painter lead coater lead hand, industrial painters leather goods spray painter leather goods sprayer letterer, railway cars letterer, signs locomotive painter machine enameller machine operator � plating and metal spraying manufacturing painter metal bluer metal coater metal coater operator metal coating-equipment operator metal dipper metal electroplater metal electroplating inspector metal plater-polisher metal plating-equipment operator metal product spray painter metal spray operator metal sprayer metal-dipping equipment operator metal-leaf gilder metallizer motor and generator subassemblies painter motor vehicle painter � motor vehicle manufacturing nickel plater oven tender � painting and coating paint and mix production and control operator paint and varnish dipper operator paint baking oven tender paint control operator paint dipper � flow coating paint machine operator paint production operator paint repairman/woman, finished vehicles paint room attendant paint spray inspector paint systems attendant painter and letterer, railway cars painter, airbrush painter, aircraft painter, assembly line painter, automobile assembly painter, automobiles � motor vehicle manufacturing painter, boilers painter, cylinders painter, drum painter, enamel painter, industrial products painter, locomotives painter, motor and generator subassemblies painter, products painter, shipyard painter, tumbling barrel painter-finisher, production painting machine attendant painting machine operator painting machine tender paint-sprayer operator particleboard spraying machine tender pencil-coating machine tender pencil-tip-banding machine tender pipe coater-painter pipe spray painter plating tank operator prep line attendant � bulk galvanizing primer sprayer print applier � production product lacquer-sprayer product painter product spray painter product stainer product surface preparer and prefinisher production and control operator, paint and mix production brush painter production coating machine operator production electroplater production operator, paint production painter production painter, final colours production painter-finisher production touch-up painter railway car letterer railway car stenciller railway car varnisher refinisher, bathtubs refinisher, ceramic and enamel refinisher, stoves robotic paint sprayer attendant robotic spray paint system attendant rough benchwork spray painter rough spray painter � manufacturing rustproof coater � motor vehicle manufacturing rustproof sprayer � motor vehicle manufacturing rustproofer, motor vehicle set-up operator, electrostatic painting machine shellacker sherardizer shipyard painter sign letterer sign panel primer sign spray painter silver plater silver spray operator smoking-pipe stainer spray paint machine operator spray paint machine tender spray paint operator spray painter spray painter � motor vehicle manufacturing spray painter � production spray painter, bench spray painter, large surfaces spray painter, metal products spray painter, pipes spray painter, products spray painter, signs spray stainer � production spray-coating machine tender, hardboard sprayer, ceramic sprayer, leather goods sprayman/woman, finished enamel stainer, products stainer, smoking-pipe stenciller, railway cars stove refinisher stove varnisher temperer � plating and metal spraying thermospray operator tin can dipping enameller tin plater tinned sheet coating machine operator tinware dipper and enameller tinware dipping enameller touch-up painter, production tumbling barrel painter tumbling barrel tender undercoater � motor vehicle manufacturing vacuum-metallizer tender varnisher, railway cars vehicle cleaner-coater wire coater wire tinner wire-coating equipment operator wire-paint-coating machine tender zinc galvanizer",
    "workers": 33646.66667,
    "minEduc": 0.5,
    "yearsStudy": 2.219475472,
    "automationRisk": 0.935,
    "salaryLow": 14.5,
    "salaryMed": 19.25,
    "salaryHigh": 33.39,
    "totalSkill": 125,
    "industry": "Sales and service",
    "industryNum": 9,
    "sector": "Sales representatives and salespersons - wholesale and retail trade",
    "cluster": 9,
    "wage": 18.51088859,
    "skillsComp": 35.16666667,
    "skillsLogi": 30.33333333,
    "skillsMath": 17.66666667,
    "skillsLang": 41.66666667,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Document Use",
    "s1DataAnalysis": 4.5,
    "s2DecisionMaking": 8.333333333,
    "s3FindingInformation": 5.666666667,
    "s4JobTaskPlanningandOrganizing": 3,
    "s5MeasurementandCalculation": 5.666666667,
    "s6MoneyMath": 3.833333333,
    "s7NumericalEstimation": 3.666666667,
    "s8OralCommunication": 12.66666667,
    "s9ProblemSolving": 8.5,
    "s10Reading": 17.83333333,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 15.16666667,
    "s13DocumentUse": 15.5,
    "s14Writing": 10.83333333,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 15,
    "f2Engineering": 16.66666667,
    "f3Humanities": 8.333333333,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 6.666666667,
    "f7Arts&Education": 118.3333333,
    "f8Education(teachertraining)": 0,
    "f9Law": 3.333333333,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 25,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 8.333333333,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 6.666666667,
    "d8OtherArts&Science": 118.3333333,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 16.66666667,
    "d11Law": 3.333333333,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 25,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 485,
    "noc": 9537,
    "job": "Other products assemblers, finishers and inspectors",
    "title1": "abrasive belt cutter",
    "title2": "abrasive wheel binder",
    "title3": "acoustic tile surfacer",
    "allTitles": "abrasive belt cutterabrasive wheel binderacoustic tile surfaceradhesive bandage machine tenderadjuster, watch balance wheeladjuster, watch escapement put-in-beataircraft heat shield makerair filter assembleraligner, archery bow limbsaluminum awning assemblerammunition assemblerammunition inspectorammunition loading inspectorammunition makerammunition manufacturing inspectorammunition salvage inspectorammunition workerannealer, jewelleryantenna assembleranvil-seating press tenderarchery bow limb alignerarchery bow makerarchery bow string makerarrow assemblerartificial pearl makerartificial turf makerasphalt roofing slitter operatorassembler, advertising buttonsassembler, air filtersassembler, aluminum awningsassembler, aluminum doors and windowsassembler, ammunitionassembler and finisher, casesassembler, antennasassembler, arrow pointsassembler, arrowsassembler, atomic fuel bundlesassembler, automated valvesassembler, awning framesassembler, baby carriagesassembler, barometersassembler, bearingsassembler, bicyclesassembler, blasting capsassembler, braceletsassembler, broomsassembler, brushes and mopsassembler, camerasassembler, canvas goodsassembler, car seatsassembler, cartridgesassembler, clocksassembler, clocks and watchesassembler, compassesassembler, compressed air and gas regulatorsassembler, corncob pipesassembler, curtain rodsassembler, dental instrumentsassembler, detonatorsassembler, drawing instrumentsassembler, dust brushesassembler, dust mopassembler, earmuffsassembler, eyeglass framesassembler, fabric hatsassembler, filtersassembler, firefighters' hatsassembler, fireworksassembler, fishing reelsassembler, fishing rodsassembler, flaresassembler, fuel filtersassembler, gas metersassembler, golf clubsassembler, hard hatsassembler, hardwareassembler, heat sensorsassembler, hydrometersassembler, ignitersassembler, jewelleryassembler, jewellery casesassembler, jewellery partsassembler, knivesassembler, lampshadesassembler, leather productsassembler, lint roller brushesassembler, locksassembler, mannequinsassembler, metal door framesassembler, metal productsassembler, metersassembler, mirrorsassembler, mopsassembler, multifocal lensesassembler, munitionsassembler, necklacesassembler, oil filtersassembler, optical instrumentsassembler, pens and pencilsassembler, photographic equipment",
    "workers": 62045,
    "minEduc": 1,
    "yearsStudy": 2.627684683,
    "automationRisk": 0.9375,
    "salaryLow": 14,
    "salaryMed": 14.5,
    "salaryHigh": 24,
    "totalSkill": 114.5,
    "industry": "Business, finance, administration",
    "industryNum": 4,
    "sector": "Administrative and financial supervisors and administrative occupations",
    "cluster": 4,
    "wage": 17.695,
    "skillsComp": 29.5,
    "skillsLogi": 26.5,
    "skillsMath": 16.5,
    "skillsLang": 42,
    "topSkill1": "Reading",
    "topSkill2": "Digital Technology",
    "topSkill3": "Writing",
    "s1DataAnalysis": 2,
    "s2DecisionMaking": 6,
    "s3FindingInformation": 4.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 4,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11.5,
    "s9ProblemSolving": 8.5,
    "s10Reading": 16.5,
    "s11SchedulingorBudgetingandAccounting": 6,
    "s12DigitalTechnology": 15,
    "s13DocumentUse": 12,
    "s14Writing": 13.5,
    "s15CriticalThinking": 5.5,
    "f1Science&Agriculture": 30,
    "f2Engineering": 50,
    "f3Humanities": 25,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 20,
    "f7Arts&Education": 145,
    "f8Education(teachertraining)": 0,
    "f9Law": 10,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 45,
    "f12Business": 120,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 25,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 20,
    "d8OtherArts&Science": 145,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 50,
    "d11Law": 10,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 30,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 45,
    "d18Business&Commerce": 120,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 486,
    "noc": 9611,
    "job": "Labourers in mineral and metal processing",
    "title1": "abrasive reclaimer - mineral products processing",
    "title2": "acid conditioning worker - primary metal processing",
    "title3": "alloy mixer - primary metal processing",
    "allTitles": "abrasive reclaimer - mineral products processingacid conditioning worker - primary metal processingalloy mixer - primary metal processingalloy processor - primary metal processingalumina clarifier helperalumina recovery helperaluminum sheet separatorannealer helper - primary metal processingasbestosboard sanderasbestosboard shearerasbestos moulderasbestos mould stripperasbestos shingle floor handasbestos workerasbestos worker - mineral processingatomizer operator - primary metal and mineral products processingattendant, filtering - primary metal and mineral products processingautomatic scrap washer operatorbaghouse attendant - mineral processingbalcony labourer - glass manufacturingbalcony worker - glass manufacturingbaler, scrap metal - primary metal processingball mill helper - mineral products processingball mill labourer - mineral products processingball mill worker - mineral products processingbillet helper - primary metal processingbillet mill helper - primary metal processingbillet pusherbillet rolling mill helper - primary metal processingbisque placer - mineral products manufacturingblast furnace helperbrick and tile batch mixerbrick and tile kiln cleanerbuggy operator - primary metal processingbusher - primary metal processingcadmium leach helpercarnallite flux makercartridge flux makercasting helpercasting house labourercasting machine helpercastings cleaner - primary metal and mineral products processingcastings trimmercasting wheel operator helpercathode loaderchalk extruderchalk moulder - mineral products processingcharger, cupola - primary metal and mineral processingcharger, furnace - primary metal processingcharger helper - primary metal processingcharge weigher - primary metal processingcladding assembler - primary metal processingclassifier helper - primary metal and mineral products processingclay press workerclay products finishercleaner, brick and tile kilnscleaner, castings - primary metal and mineral products processingcleaner, soaking pit bottom - primary metal processingcoil bander - primary metal processingcoke loader - primary metal processingcoke oven heater helpercold mill feeder - primary metal processingcold roll catcher - primary metal processingcold rolling mill feeder - primary metal processingconveyor labourer - primary metal and mineral products processingconveyor operator - primary metal and mineral products processingcopper dust-collector workercore room labourer - foundrycore shop labourer - foundryCottrell precipitator helper - primary metal processingcrushing operations helper - mineral products processingcupola charger - primary metal and mineral processingcupola furnace helpercupola tapperdepiler helper - primary metal processingdrawer helper - primary metal processingdross skimmer - primary metal and mineral products processingdryer worker - primary metal processingdust-collector labourer - primary metal processingdust remover - primary metal processingelectrolytic refiner helper - primary metal and mineral products processingextruder helper - primary metal processingextruder tender - mineral products processingextrusion helper - primary metal processingfeeder, cold mill - primary metal processingfeeder, cold rolling mill - primary metal processingfeeder, furnace - primary metal and mineral products processingfettler - clay products manufacturingfibreglass oven helperfiltering attendant - primary metal and mineral products processingfilter leaves cleaner - primary metal and mineral products processingfinisher, clay productsflotation cell helper - primary metal and mineral products processingflue dust labourer - primary metal and mineral products processingfluorspar flux maker - primary metal processingfoil roller helper - primary metal processingfoil separator - primary metal processingfoundry helper - primary metal processingfoundry labourerfoundry worker - primary metal processing",
    "workers": 265,
    "minEduc": 1,
    "yearsStudy": 1.7,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 17.03,
    "salaryHigh": 28,
    "totalSkill": 95,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 17.03,
    "skillsComp": 25,
    "skillsLogi": 25,
    "skillsMath": 16,
    "skillsLang": 29,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 9,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 17,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 65,
    "f2Engineering": 40,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 130,
    "f8Education(teachertraining)": 0,
    "f9Law": 30,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 0,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 130,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 40,
    "d11Law": 30,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 65,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 0,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 487,
    "noc": 9612,
    "job": "Labourers in metal fabrication",
    "title1": "automatic machine polisher - metal products manufacturing",
    "title2": "battery lead burner helper",
    "title3": "bench grinder - metal products manufacturing",
    "allTitles": "automatic machine polisher - metal products manufacturingbattery lead burner helperbench grinder - metal products manufacturingbench hand, machine shop - metal products manufacturingbending machine helper - metal products manufacturingbit sharpener tenderblacksmith helperboilermaker helperbrake helper - metal products manufacturingbrazing machine feederbuffer, hand - metal products manufacturingbuffer, metal - metal products manufacturingbuffing machine tender - metal products manufacturingbumper operator, aircraftburnisher - metalworkingcalibrator, tanks - metal products manufacturingcartridge parts cleaner - explosives and ammunition manufacturingchipper-grinderchipper-grinder - metal products manufacturingchipper - metal products manufacturingchisel grinder - metal products manufacturingcleaner, metal - metal products manufacturingcleaner, moulds - foundrycoil spring grinder - metal products manufacturingdeburrer - metal products manufacturingdie blanking press operator helper - metal products manufacturingdresser - metal products manufacturingdrill grinder - metal products manufacturingdrop hammer helper - metal fabricationfabrication shop helper - metal productsfeeder, brazing machinefeeder, soldering machinefiler, hand - metal products manufacturingfinisher, foundry mouldsfinisher, metal castingsfinisher, wiresfinish grinder - metal products manufacturingfirearms cleaner - metal products manufacturingfitter helper - metal products manufacturingfitter helper, shipbuildingfitter helper, structural metalflame cutter helper - metal products manufacturingforge helperforger helperfoundry mould finishergalvanizer helpergrinder and sharpener - metal products manufacturinggrinder-chipper - metal products manufacturinggrinder-deburrergrinder-deburrer - metal products manufacturinggrinder-dresser - metal products manufacturinggrinder - metal products manufacturinggrinder, plates - metal products manufacturinggrinder-trimmer - metal products manufacturinghand buffer - metal products manufacturinghand filer - metal products manufacturingheat treater helperhelper, blacksmithhelper, boilermakerhelper, drop hammer - metal products manufacturinghelper, fitter - metal products manufacturinghelper, flame cutter - metal products manufacturinghelper, forgehelper, forgerhelper, galvanizerhelper, heat treaterhelper, industrial sheet metal workerhelper, machine shop - metal products manufacturinghelper, metal-fabricating shophelper, metal polisherhelper, metalworking machinehelper, plater - metal fabricationhelper, plate worker - metal products manufacturinghelper, plating roomhelper, production - metal coatinghelper, punch press - metal products manufacturinghelper, rigger - shipbuildinghelper, shear - metal fabricationhelper, sherardizerhelper, shipfitterhelper, shipwrighthelper, structural metal fitterhelper, upsetter - metal fabricationhelper, welderhelper, welder-fitterhelper, welder-fitter - manufacturinghelper, welding machine operatorhelper, wire loomhelper, wire weaverlabourer - metal fabricationlabourer, metal polishing-platingloom helper, wiremachine shop bench hand - metal products manufacturingmachine shop helper - metal products manufacturingmechanical press operator helper - metal products manufacturingmetal bluing cleaner - metal products manufacturingmetal buffer - metal products manufacturingmetal casting finishermetal cleanermetal cleaner, immersion - metal products manufacturing",
    "workers": 250,
    "minEduc": 1,
    "yearsStudy": 1.4,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 20,
    "totalSkill": 95,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 14,
    "skillsComp": 25,
    "skillsLogi": 25,
    "skillsMath": 16,
    "skillsLang": 29,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 9,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 17,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 210,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 40,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 210,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 40,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 488,
    "noc": 9613,
    "job": "Labourers in chemical products processing and utilities",
    "title1": "acetylene cylinder preparer",
    "title2": "batch dryer tender helper",
    "title3": "bath mix solvent recoverer",
    "allTitles": "acetylene cylinder preparerbatch dryer tender helperbath mix solvent recovererboilerhouse helperboiler operator helperboiler water testerbullet lubricant compoundercatalyst operator helper, gasolinechemical plant labourercleaner, filter - chemical processingcleaner, still - chemical processingcoating machine feeder - chemical processingcompressed gas plant workercrutcher operator helperdistillation equipment helperdistillation equipment helper - chemical processingdistiller helper - chemical processingdryer tender helper - chemical processingelectrode cleanerelectrolytic cell cleanerequipment cleaner - chemical processingfilm spoolerfilter cleaner - chemical processingfiltration helper - chemical processingflue cleaner - utilitiesgas fitter helper - utilitiesgasket coatergas utility labourerhelper - chemical processinghelper, substation operatorintegrator operatorlabourer, chemical plantlabourer - chemical processinglabourer - gas utilitylabourer, paint plantlabourer, petroleum refinerylandfill scale operatorlandfill weigh scale attendantloader - chemical processingmill charger - chemical processingoven loader - chemical processingpaint plant labourerpaint pourerpetroleum process operator helperpetroleum refinery labourerpigment presserpowerhouse helperrack loaderrefrigeration plant operator helperretort unloadersample preparer - chemical processingsampler - chemical processingsaturating machine feeder - chemical processingscale operator, landfillshutdown labourer - chemical processingslug-press feederstationary engineer helperstill cleaner - chemical processingstove-bottom workerstove-carriage workersubstation operator helpersulphuric acid plant operator helpertemperature regulatortransformer stockroom attendanttreater helper - chemical processingvarnish maker helperwater intake tenderwater intake tender - utilitieswaterworks labourerwax moulderweigh scale attendant, landfill",
    "workers": 85,
    "minEduc": 1,
    "yearsStudy": 1.666666667,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 17.1,
    "salaryHigh": 35.73,
    "totalSkill": 94,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 17.1,
    "skillsComp": 25,
    "skillsLogi": 24,
    "skillsMath": 16,
    "skillsLang": 29,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 8,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 17,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 15,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 0,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 70,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 0,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 15,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 70,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 489,
    "noc": 9614,
    "job": "Labourers in wood, pulp and paper processing",
    "title1": "attendant, chip bin - wood processing",
    "title2": "bag-making machine tender helper",
    "title3": "barking machine cleaner - wood processing",
    "allTitles": "attendant, chip bin - wood processingbag-making machine tender helperbarking machine cleaner - wood processingbeater helper - pulp and paperbeater operator helper - pulp and paperbolt loader - sawmillbroke hustler - pulp and paperbrown stock washer helper - pulp and papercant loader - wood processingcar stacker - wood processingcarton-forming machine feederchain conveyor tender - sawmillchain conveyor tender - wood processingchainman/woman - wood processingchainman - wood processingchainwoman - wood processingchip bin attendant - wood processingchip dump operator - wood processingchip silo attendant - wood processingchip storage attendant - wood processingcoating machine helpercombiner machine helperconveyor cleaner - pulp and papercorrugator-operator helpercutter helper - pulp and paperdry chainman/woman - wood processingdry chainman - wood processingdry chain offbearer - wood processingdry chainwoman - wood processingfeeder, logsfeeder - wood processingfifth hand - pulp and papergreensaw offbearer - wood processinggreen sorter - wood processinggreen wood chainman/woman - wood processinggreen wood chainman - wood processinggreen wood chainwoman - wood processinggrinder feeder - pulp and paperhand bundler - wood processinghandler - wood treatmenthelper, lime kiln - pulp and paperhelper, sheeter - pulp and paperhelper, supercalender - pulp and paperhelper, timber-treating tankhog machine tender - wood processinghot plate press tender helperjack ladder tenderlabourer, paper convertinglabourer, plywood and veneer plantlabourer - pulp and paperlabourer, sawmilllabourer, wood-preserving plantlabourer - wood processingleverman/woman - wood processingleverman - wood processingleverwoman - wood processinglime kiln helper - pulp and paperlog deck tenderlog feederlog handlerlog peeler, handlog transfer tenderlumber feeder - wood processinglumber handler - wood processinglumber salvager - wood processinglumber straightener - wood processinglumber tailer - wood processinglumber tier - wood processingoperator helper, beater - pulp and paperpaper sorter and counterpaper tube production helperpiler - wood processingplywood and veneer plant labourerplywood dryer feederpulp and paper labourerpulp-log recleanerpulp-washer helperrag checker - pulp and paperrag sorter - pulp and paperrecovery plant helper - pulp and paperrollerman/woman - wood processingrollerman - wood processingrollerwoman - wood processingsalvager, lumber - wood processingsawmill labourersawmill workersaw tailer - wood processingscrap piler - wood processingscreen cleaner - pulp and papershake packersheeter helper - pulp and papershingle trimmersixth hand - pulp and paperstacker - wood processingsupercalender helper - pulp and papertender, hogger - wood processingthrasher feedertimber-treating tank helpertransfer equipment tender - wood processingtransfer man/woman - wood processing",
    "workers": 115,
    "minEduc": 1,
    "yearsStudy": 1.2,
    "automationRisk": 0.66,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 20.46,
    "totalSkill": 94,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 13.5,
    "skillsComp": 25,
    "skillsLogi": 24,
    "skillsMath": 16,
    "skillsLang": 29,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6,
    "s2DecisionMaking": 7,
    "s3FindingInformation": 7,
    "s4JobTaskPlanningandOrganizing": 2,
    "s5MeasurementandCalculation": 7,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3,
    "s8OralCommunication": 11,
    "s9ProblemSolving": 8,
    "s10Reading": 12,
    "s11SchedulingorBudgetingandAccounting": 2,
    "s12DigitalTechnology": 2,
    "s13DocumentUse": 17,
    "s14Writing": 6,
    "s15CriticalThinking": 0,
    "f1Science&Agriculture": 0,
    "f2Engineering": 0,
    "f3Humanities": 0,
    "f4SocialScience": 0,
    "f5FineArts": 0,
    "f6MathAndComputerScience": 0,
    "f7Arts&Education": 85,
    "f8Education(teachertraining)": 0,
    "f9Law": 0,
    "f10Health": 0,
    "f11Health,Nursing&ClinicalLaboratory": 0,
    "f12Business": 30,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 0,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 0,
    "d5SocialSciences": 0,
    "d6Fine&AppliedArts": 0,
    "d7ComputerScience": 0,
    "d8OtherArts&Science": 85,
    "d9Education(teachertraining)": 0,
    "d10Engineering": 0,
    "d11Law": 0,
    "d12Mathematics": 0,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 0,
    "d16Therapy&Rehabilitation": 0,
    "d17Health,Nursing&ClinicalLaboratory": 0,
    "d18Business&Commerce": 30,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 490,
    "noc": 9615,
    "job": "Labourers in rubber and plastic products manufacturing",
    "title1": "airbag extractor � rubber products manufacturing aircraft tire tube balancer baling machine tender � rubber and plastic products manufacturing baling press tender � rubber and plastic products manufacturing balloon collar roller � rubber products manufacturing balloon form stripper and cleaner � rubber products manufacturing balloon leacher and curer � rubber products manufacturing bead picker � rubber products manufacturing belt builder helper belt builder helper � rubber products manufacturing bias cutting machine operator helper � rubber products manufacturing booker � rubber products manufacturing builder helper, belts � rubber products manufacturing calender feeder � rubber and plastic products manufacturing cementer, hand � rubber and plastic products manufacturing cementer, tire repair � rubber products manufacturing cleaner, moulds � rubber products manufacturing cleaner, tires � rubber products manufacturing coating machine feeder � plastic products manufacturing coating machine feeder � rubber products manufacturing extruding machine helper � rubber and plastic products manufacturing feeder, opening machine � rubber products manufacturing feeder, rubber-cutting machine footwear moulding press feeder � rubber products manufacturing footwear sorter � rubber products manufacturing formula weigher � rubber and plastic products manufacturing hand cementer � rubber and plastic products manufacturing helper, belt builder � rubber products manufacturing helper, bias machine operator � rubber products manufacturing helper, extruding machine � rubber and plastic products manufacturing helper, plastic products manufacturing machine operator helper, rubber products manufacturing helper, rubber products manufacturing machine operator hose checker � rubber products manufacturing hose cutter, hand � rubber products manufacturing inner tube checker � rubber products manufacturing inner tube inserter � rubber products manufacturing inner tube repairer � rubber products manufacturing inserter, inner tubes � rubber products manufacturing inserter, tire tubes � rubber products manufacturing inspector, golf balls � rubber products manufacturing insulation packer � rubber products manufacturing labourer � plastic products manufacturing labourer � rubber products manufacturing labourer, plastic products manufacturing latex thread spooler � rubber products manufacturing machine feeder, rubber cutting machine offbearer � rubber products manufacturing machine operator helper, plastic products manufacturing machine operator helper, rubber products manufacturing milled rubber cooler mould cleaner � rubber and plastic products manufacturing mould cleaner � rubber products manufacturing mould filler � rubber and plastic products manufacturing mould preparer � rubber and plastic products manufacturing mould setter � rubber and plastic products manufacturing mould waxer � rubber and plastic products manufacturing moulded products stripper � rubber and plastic products manufacturing moulded rubber products trimmer moulding machine offbearer � rubber products manufacturing moulding press feeder, footwear � rubber products manufacturing offbearer, machine � rubber products manufacturing offbearer, moulding machine � rubber products manufacturing opening machine feeder � rubber products manufacturing packer, insulation � rubber products manufacturing picker, beam press � rubber products manufacturing plastic products manufacturing labourer pole-up man/woman � rubber products manufacturing pressroom worker, tires and inner tubes � rubber products manufacturing production day labourer � tire industry repairer, inner tubes � rubber products manufacturing repairer, tire tubes � rubber products manufacturing roll changer � rubber manufacturing rubber and canvas footwear dipper rubber compound weigher rubber compounder rubber goods seamer rubber hose checker rubber manufacturing roll changer rubber products manufacturing labourer rubber products seamer rubber-cutting machine feeder screen cleaner � rubber products manufacturing screening machine feeder � rubber products manufacturing sifting machine feeder � rubber products manufacturing slab-off machine tender � rubber products manufacturing slab-off man/woman � rubber products manufacturing sorter � rubber products manufacturing sorter, footwear � rubber products manufacturing spooler, latex threads � rubber products manufacturing spreader operator helper � plastic products manufacturing stock lay-up man/woman � rubber products manufacturing stock preparer � rubber products manufacturing stripper, moulded products � rubber and plastic products manufacturing tender, baling machine � rubber and plastic products manufacturing tender, baling press � rubber and plastic products manufacturing tire balance checker � rubber products manufacturing tire band wrapper � rubber products manufacturing tire bead picker � rubber products manufacturing tire cleaner � rubber products manufacturing tire cleaner and painter � rubber products manufacturing tire measurer � rubber products manufacturing tire tube checker � rubber products manufacturing tire tube inserter � rubber products manufacturing tire tube repairer � rubber products manufacturing vulcanization worker � rubber products manufacturing weigher � plastic and rubber manufacturing",
    "title2": 0,
    "title3": 0,
    "allTitles": "airbag extractor � rubber products manufacturing aircraft tire tube balancer baling machine tender � rubber and plastic products manufacturing baling press tender � rubber and plastic products manufacturing balloon collar roller � rubber products manufacturing balloon form stripper and cleaner � rubber products manufacturing balloon leacher and curer � rubber products manufacturing bead picker � rubber products manufacturing belt builder helper belt builder helper � rubber products manufacturing bias cutting machine operator helper � rubber products manufacturing booker � rubber products manufacturing builder helper, belts � rubber products manufacturing calender feeder � rubber and plastic products manufacturing cementer, hand � rubber and plastic products manufacturing cementer, tire repair � rubber products manufacturing cleaner, moulds � rubber products manufacturing cleaner, tires � rubber products manufacturing coating machine feeder � plastic products manufacturing coating machine feeder � rubber products manufacturing extruding machine helper � rubber and plastic products manufacturing feeder, opening machine � rubber products manufacturing feeder, rubber-cutting machine footwear moulding press feeder � rubber products manufacturing footwear sorter � rubber products manufacturing formula weigher � rubber and plastic products manufacturing hand cementer � rubber and plastic products manufacturing helper, belt builder � rubber products manufacturing helper, bias machine operator � rubber products manufacturing helper, extruding machine � rubber and plastic products manufacturing helper, plastic products manufacturing machine operator helper, rubber products manufacturing helper, rubber products manufacturing machine operator hose checker � rubber products manufacturing hose cutter, hand � rubber products manufacturing inner tube checker � rubber products manufacturing inner tube inserter � rubber products manufacturing inner tube repairer � rubber products manufacturing inserter, inner tubes � rubber products manufacturing inserter, tire tubes � rubber products manufacturing inspector, golf balls � rubber products manufacturing insulation packer � rubber products manufacturing labourer � plastic products manufacturing labourer � rubber products manufacturing labourer, plastic products manufacturing latex thread spooler � rubber products manufacturing machine feeder, rubber cutting machine offbearer � rubber products manufacturing machine operator helper, plastic products manufacturing machine operator helper, rubber products manufacturing milled rubber cooler mould cleaner � rubber and plastic products manufacturing mould cleaner � rubber products manufacturing mould filler � rubber and plastic products manufacturing mould preparer � rubber and plastic products manufacturing mould setter � rubber and plastic products manufacturing mould waxer � rubber and plastic products manufacturing moulded products stripper � rubber and plastic products manufacturing moulded rubber products trimmer moulding machine offbearer � rubber products manufacturing moulding press feeder, footwear � rubber products manufacturing offbearer, machine � rubber products manufacturing offbearer, moulding machine � rubber products manufacturing opening machine feeder � rubber products manufacturing packer, insulation � rubber products manufacturing picker, beam press � rubber products manufacturing plastic products manufacturing labourer pole-up man/woman � rubber products manufacturing pressroom worker, tires and inner tubes � rubber products manufacturing production day labourer � tire industry repairer, inner tubes � rubber products manufacturing repairer, tire tubes � rubber products manufacturing roll changer � rubber manufacturing rubber and canvas footwear dipper rubber compound weigher rubber compounder rubber goods seamer rubber hose checker rubber manufacturing roll changer rubber products manufacturing labourer rubber products seamer rubber-cutting machine feeder screen cleaner � rubber products manufacturing screening machine feeder � rubber products manufacturing sifting machine feeder � rubber products manufacturing slab-off machine tender � rubber products manufacturing slab-off man/woman � rubber products manufacturing sorter � rubber products manufacturing sorter, footwear � rubber products manufacturing spooler, latex threads � rubber products manufacturing spreader operator helper � plastic products manufacturing stock lay-up man/woman � rubber products manufacturing stock preparer � rubber products manufacturing stripper, moulded products � rubber and plastic products manufacturing tender, baling machine � rubber and plastic products manufacturing tender, baling press � rubber and plastic products manufacturing tire balance checker � rubber products manufacturing tire band wrapper � rubber products manufacturing tire bead picker � rubber products manufacturing tire cleaner � rubber products manufacturing tire cleaner and painter � rubber products manufacturing tire measurer � rubber products manufacturing tire tube checker � rubber products manufacturing tire tube inserter � rubber products manufacturing tire tube repairer � rubber products manufacturing vulcanization worker � rubber products manufacturing weigher � plastic and rubber manufacturing",
    "workers": 5969,
    "minEduc": 0.9,
    "yearsStudy": 1.771720232,
    "automationRisk": 0.5953,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 20.62,
    "totalSkill": 101.9,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 18.026,
    "skillsComp": 27.1,
    "skillsLogi": 26.2,
    "skillsMath": 16.6,
    "skillsLang": 31.9,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.1,
    "s2DecisionMaking": 7.4,
    "s3FindingInformation": 7.1,
    "s4JobTaskPlanningandOrganizing": 2.1,
    "s5MeasurementandCalculation": 6.9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3.2,
    "s8OralCommunication": 11.7,
    "s9ProblemSolving": 8.7,
    "s10Reading": 13.1,
    "s11SchedulingorBudgetingandAccounting": 2.6,
    "s12DigitalTechnology": 3.9,
    "s13DocumentUse": 17,
    "s14Writing": 7.2,
    "s15CriticalThinking": 1,
    "f1Science&Agriculture": 92,
    "f2Engineering": 135,
    "f3Humanities": 35,
    "f4SocialScience": 48,
    "f5FineArts": 59,
    "f6MathAndComputerScience": 61,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 68,
    "f9Law": 48,
    "f10Health": 9,
    "f11Health,Nursing&ClinicalLaboratory": 108,
    "f12Business": 439,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 48,
    "d6Fine&AppliedArts": 59,
    "d7ComputerScience": 55,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 68,
    "d10Engineering": 135,
    "d11Law": 48,
    "d12Mathematics": 6,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 72,
    "d16Therapy&Rehabilitation": 9,
    "d17Health,Nursing&ClinicalLaboratory": 108,
    "d18Business&Commerce": 439,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 491,
    "noc": 9616,
    "job": "Labourers in textile processing",
    "title1": "bale checker � textile processing battery loader � textile processing beam warper helper � textile processing bleacher helper � textile processing bobbin changer � textile processing bobbin cleaner � textile processing bobbin collector � textile processing bobbin processor bobbin scraper � textile processing bobbin sorter � textile processing calender helper � textile processing can doffer � textile processing carding machine cleaner � textile processing chainer � textile processing cleaner, textile machines cloth carrier cloth folder, hand cloth offbearer cloth turner cloth winder creeler � textile processing doffer drying machine helper � textile processing drying machine tender � textile processing dyeing and finishing machine loader dyer helper � textile processing feeder, textile machines felt goods labourer felt press machine tender filling carrier � textile processing floor helper � textile processing hand skeiner � textile processing harness cleaner � textile processing helper � textiles hosiery folder hosiery tray dryer knitted fabric turner knitter helper knitter helper, machine labourer � textile processing labourer, felt goods labourer, woollen mill loom cleaner loom doffer � textile processing machine knitter helper offbearer, textile machines pick remover � textile processing pick-pulling machine tender piece hauler � textile processing rag sorter and cutter � textile processing reed cleaner � textile processing roll carrier � textile processing roll hauler � textile processing roll turner � textile processing roller cleaner � textile processing roll-mat machine feeder � textile processing sample steamer scutcher tender shuttle filler � textile processing slasher operator helper � textile processing spool carrier � textile processing spool hauler � textile processing spun yarn linker spun yarn storekeeper spun yarn weigher textile machine cleaner textile machine feeder textile machine offbearer textile product labourer traveller changer tubing folder � textile processing twisted end finder � textile processing warp beamer helper � textile processing waste machine feeder waste machine feeder � textile processing winder cleaner � textile processing winding frame cleaner � textile processing yarn handler yarn salvager",
    "title2": 0,
    "title3": 0,
    "allTitles": "bale checker � textile processing battery loader � textile processing beam warper helper � textile processing bleacher helper � textile processing bobbin changer � textile processing bobbin cleaner � textile processing bobbin collector � textile processing bobbin processor bobbin scraper � textile processing bobbin sorter � textile processing calender helper � textile processing can doffer � textile processing carding machine cleaner � textile processing chainer � textile processing cleaner, textile machines cloth carrier cloth folder, hand cloth offbearer cloth turner cloth winder creeler � textile processing doffer drying machine helper � textile processing drying machine tender � textile processing dyeing and finishing machine loader dyer helper � textile processing feeder, textile machines felt goods labourer felt press machine tender filling carrier � textile processing floor helper � textile processing hand skeiner � textile processing harness cleaner � textile processing helper � textiles hosiery folder hosiery tray dryer knitted fabric turner knitter helper knitter helper, machine labourer � textile processing labourer, felt goods labourer, woollen mill loom cleaner loom doffer � textile processing machine knitter helper offbearer, textile machines pick remover � textile processing pick-pulling machine tender piece hauler � textile processing rag sorter and cutter � textile processing reed cleaner � textile processing roll carrier � textile processing roll hauler � textile processing roll turner � textile processing roller cleaner � textile processing roll-mat machine feeder � textile processing sample steamer scutcher tender shuttle filler � textile processing slasher operator helper � textile processing spool carrier � textile processing spool hauler � textile processing spun yarn linker spun yarn storekeeper spun yarn weigher textile machine cleaner textile machine feeder textile machine offbearer textile product labourer traveller changer tubing folder � textile processing twisted end finder � textile processing warp beamer helper � textile processing waste machine feeder waste machine feeder � textile processing winder cleaner � textile processing winding frame cleaner � textile processing yarn handler yarn salvager",
    "workers": 5969,
    "minEduc": 0.9,
    "yearsStudy": 1.771720232,
    "automationRisk": 0.5953,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 16,
    "totalSkill": 101.9,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 18.026,
    "skillsComp": 27.1,
    "skillsLogi": 26.2,
    "skillsMath": 16.6,
    "skillsLang": 31.9,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.1,
    "s2DecisionMaking": 7.4,
    "s3FindingInformation": 7.1,
    "s4JobTaskPlanningandOrganizing": 2.1,
    "s5MeasurementandCalculation": 6.9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3.2,
    "s8OralCommunication": 11.7,
    "s9ProblemSolving": 8.7,
    "s10Reading": 13.1,
    "s11SchedulingorBudgetingandAccounting": 2.6,
    "s12DigitalTechnology": 3.9,
    "s13DocumentUse": 17,
    "s14Writing": 7.2,
    "s15CriticalThinking": 1,
    "f1Science&Agriculture": 92,
    "f2Engineering": 135,
    "f3Humanities": 35,
    "f4SocialScience": 48,
    "f5FineArts": 59,
    "f6MathAndComputerScience": 61,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 68,
    "f9Law": 48,
    "f10Health": 9,
    "f11Health,Nursing&ClinicalLaboratory": 108,
    "f12Business": 439,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 48,
    "d6Fine&AppliedArts": 59,
    "d7ComputerScience": 55,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 68,
    "d10Engineering": 135,
    "d11Law": 48,
    "d12Mathematics": 6,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 72,
    "d16Therapy&Rehabilitation": 9,
    "d17Health,Nursing&ClinicalLaboratory": 108,
    "d18Business&Commerce": 439,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 492,
    "noc": 9617,
    "job": "Labourers in food and beverage processing",
    "title1": "animal feed sack filler bagger � food and beverage processing baker helper bakery labourer bakery products bander bakery products divider � food and beverage processing bakery products packager bakery products wrapper banding machine tender � tobacco products barrel cleaner � food and beverage processing barrel filler � food and beverage processing beef marker � food and beverage processing beer sampler � food and beverage processing beet washer beet washer helper bin cleaner � food and beverage processing biscuit packer blender and packer � food and beverage processing blender and wrapper � food and beverage processing bolter helper � food and beverage processing bottle caser � food and beverage processing bottle checker � food and beverage processing bottle washer bottle washer � food and beverage processing bottler bottle-washing machine tender � food and beverage processing bottling line worker box stitcher � food and beverage processing bread pan greaser � food and beverage processing brewery labourer butcher helper � meat processing butter packer butter sampler butter wrapper cake wrapper candy dipper, hand � food and beverage processing candy maker helper candy packer candy wrapper cannery packer cannery worker � food and beverage processing carcass washer � food and beverage processing carcass weigher � food and beverage processing carton bander carton package stapler carton-packaging machine tender � food and beverage processing case stacker � food and beverage processing caser � tobacco processing casing salter � food and beverage processing casing shirrer � food and beverage processing casing stripper � food and beverage processing cellophaner � tobacco products centrifuge tender � food and beverage processing centrifuge tender � meat packing plant char filter helper � food and beverage processing char kiln helper � food and beverage processing cheese cutter cheese factory worker cheese maker helper chewing gum batch mixer chewing gum production attendant chicle-grinder feeder � food and beverage processing chilling worker � food and beverage processing chocolate packer, hand chocolate processing helper cigar bander cigar brander cigar wrapper cigarette packer cigar-wrapping machine tender cocoa bean cleaner cocoa bean press-mill helper cocoa bean roaster helper cocoa powder mixer coffee-blending machine feeder confection labourer � food and beverage processing container washer, machine � food and beverage processing corn syrup processing labourer cream sampler � food and beverage processing custom feed miller helper dairy helper � food and beverage processing dairy sampler � food and beverage processing dough feeder � food and beverage processing dough roller dough weigher dry curer � food and beverage processing dumping machine tender � food and beverage processing edible oil processing labourer edible oil refiner helper egg breaker � food and beverage processing filler � food and beverage processing filler, animal feed sacks film-coating machine tender � tobacco products flour mixer helper flumer helper � food and beverage processing food processing labourer food product sampler food-cooling pan tender food-processing equipment cleaner freezer worker � food and beverage processing freezing worker � food and beverage processing frozen food packer frozen meat cutter helper fruit and vegetable cleaner � food and beverage processing fruit peeler � food and beverage processing fruit preparer � food and beverage processing fruit splitter gambreler � food and beverage processing gelatin stock cooker attendant glucose transferrer � food and beverage processing gluten settler � food and beverage processing grain cleaner helper hogshead filler � tobacco products hoof remover � food and beverage processing ice cream worker � food and beverage processing icing dipper � food and beverage processing industrial butcher helper juice blender label coder � food and beverage processing labourer � food and beverage processing labourer, meat-packing plant labourer, syrup-processing plant labourer, tobacco processing labourer, yeast-processing plant lard bleacher � food and beverage processing linking machine tender � food and beverage processing liquor gallery tender helper � food and beverage processing machine cigar wrapper machine tobacco packer machine wrapper, cigars meat dryer meat loaf trimmer meat mould sealer meat mould stripper meat packager meat packer � food and beverage processing meat press tender meat vacuum wrapper meat washer meat wrapper meat-packing plant labourer meat-rolling machine tender milk powder grinder milk sampler neck skewerer � food and beverage processing neutralizer, corn starch noodle paste mixer tender nut sorter � food and beverage processing nut-chopping machine feeder packager, bakery products packager, poultry packer, liquid packer, tobacco pastry cook helper pastry wrapper pellet mill worker � food and beverage processing popcorn maker � food and beverage processing potato chip sorter potato-peeling machine tender poultry cooler worker � food and beverage processing poultry packager production helper production helper � food and beverage processing production labourer � food processing salt packer sampler � food and beverage processing sampler, food products sausage casing curer sausage linker � food and beverage processing sausage tier � food and beverage processing sausage wrapper � food and beverage processing seasoning mixer � food and beverage processing shrouder � food and beverage processing singeing machine tender skinning machine feeder � food and beverage processing smoked meat preparer � food and beverage processing snuff-packing machine tender soft drink mixer sorting machine feeder � food and beverage processing starch centrifuge tender starch factory labourer � food and beverage processing stunner and shackler � meat packing sugar boiler helper sugar grinder tank attendant � food and beverage processing tare assessor � food and beverage processing tea blender ticket checker � tobacco processing tobacco baler tobacco hogshead liner tobacco packer tobacco packer, machine tobacco processing labourer tobacco weigher tobacco-packing machine tender tub filler � food and beverage processing tumbler tender � food and beverage processing vinegar maker helper washing and waxing machine tender � food and beverage processing yeast processing labourer yeast sampler � food and beverage processing",
    "title2": 0,
    "title3": 0,
    "allTitles": "animal feed sack filler bagger � food and beverage processing baker helper bakery labourer bakery products bander bakery products divider � food and beverage processing bakery products packager bakery products wrapper banding machine tender � tobacco products barrel cleaner � food and beverage processing barrel filler � food and beverage processing beef marker � food and beverage processing beer sampler � food and beverage processing beet washer beet washer helper bin cleaner � food and beverage processing biscuit packer blender and packer � food and beverage processing blender and wrapper � food and beverage processing bolter helper � food and beverage processing bottle caser � food and beverage processing bottle checker � food and beverage processing bottle washer bottle washer � food and beverage processing bottler bottle-washing machine tender � food and beverage processing bottling line worker box stitcher � food and beverage processing bread pan greaser � food and beverage processing brewery labourer butcher helper � meat processing butter packer butter sampler butter wrapper cake wrapper candy dipper, hand � food and beverage processing candy maker helper candy packer candy wrapper cannery packer cannery worker � food and beverage processing carcass washer � food and beverage processing carcass weigher � food and beverage processing carton bander carton package stapler carton-packaging machine tender � food and beverage processing case stacker � food and beverage processing caser � tobacco processing casing salter � food and beverage processing casing shirrer � food and beverage processing casing stripper � food and beverage processing cellophaner � tobacco products centrifuge tender � food and beverage processing centrifuge tender � meat packing plant char filter helper � food and beverage processing char kiln helper � food and beverage processing cheese cutter cheese factory worker cheese maker helper chewing gum batch mixer chewing gum production attendant chicle-grinder feeder � food and beverage processing chilling worker � food and beverage processing chocolate packer, hand chocolate processing helper cigar bander cigar brander cigar wrapper cigarette packer cigar-wrapping machine tender cocoa bean cleaner cocoa bean press-mill helper cocoa bean roaster helper cocoa powder mixer coffee-blending machine feeder confection labourer � food and beverage processing container washer, machine � food and beverage processing corn syrup processing labourer cream sampler � food and beverage processing custom feed miller helper dairy helper � food and beverage processing dairy sampler � food and beverage processing dough feeder � food and beverage processing dough roller dough weigher dry curer � food and beverage processing dumping machine tender � food and beverage processing edible oil processing labourer edible oil refiner helper egg breaker � food and beverage processing filler � food and beverage processing filler, animal feed sacks film-coating machine tender � tobacco products flour mixer helper flumer helper � food and beverage processing food processing labourer food product sampler food-cooling pan tender food-processing equipment cleaner freezer worker � food and beverage processing freezing worker � food and beverage processing frozen food packer frozen meat cutter helper fruit and vegetable cleaner � food and beverage processing fruit peeler � food and beverage processing fruit preparer � food and beverage processing fruit splitter gambreler � food and beverage processing gelatin stock cooker attendant glucose transferrer � food and beverage processing gluten settler � food and beverage processing grain cleaner helper hogshead filler � tobacco products hoof remover � food and beverage processing ice cream worker � food and beverage processing icing dipper � food and beverage processing industrial butcher helper juice blender label coder � food and beverage processing labourer � food and beverage processing labourer, meat-packing plant labourer, syrup-processing plant labourer, tobacco processing labourer, yeast-processing plant lard bleacher � food and beverage processing linking machine tender � food and beverage processing liquor gallery tender helper � food and beverage processing machine cigar wrapper machine tobacco packer machine wrapper, cigars meat dryer meat loaf trimmer meat mould sealer meat mould stripper meat packager meat packer � food and beverage processing meat press tender meat vacuum wrapper meat washer meat wrapper meat-packing plant labourer meat-rolling machine tender milk powder grinder milk sampler neck skewerer � food and beverage processing neutralizer, corn starch noodle paste mixer tender nut sorter � food and beverage processing nut-chopping machine feeder packager, bakery products packager, poultry packer, liquid packer, tobacco pastry cook helper pastry wrapper pellet mill worker � food and beverage processing popcorn maker � food and beverage processing potato chip sorter potato-peeling machine tender poultry cooler worker � food and beverage processing poultry packager production helper production helper � food and beverage processing production labourer � food processing salt packer sampler � food and beverage processing sampler, food products sausage casing curer sausage linker � food and beverage processing sausage tier � food and beverage processing sausage wrapper � food and beverage processing seasoning mixer � food and beverage processing shrouder � food and beverage processing singeing machine tender skinning machine feeder � food and beverage processing smoked meat preparer � food and beverage processing snuff-packing machine tender soft drink mixer sorting machine feeder � food and beverage processing starch centrifuge tender starch factory labourer � food and beverage processing stunner and shackler � meat packing sugar boiler helper sugar grinder tank attendant � food and beverage processing tare assessor � food and beverage processing tea blender ticket checker � tobacco processing tobacco baler tobacco hogshead liner tobacco packer tobacco packer, machine tobacco processing labourer tobacco weigher tobacco-packing machine tender tub filler � food and beverage processing tumbler tender � food and beverage processing vinegar maker helper washing and waxing machine tender � food and beverage processing yeast processing labourer yeast sampler � food and beverage processing",
    "workers": 5969,
    "minEduc": 0.9,
    "yearsStudy": 1.771720232,
    "automationRisk": 0.5953,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 19.25,
    "totalSkill": 101.9,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 18.026,
    "skillsComp": 27.1,
    "skillsLogi": 26.2,
    "skillsMath": 16.6,
    "skillsLang": 31.9,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.1,
    "s2DecisionMaking": 7.4,
    "s3FindingInformation": 7.1,
    "s4JobTaskPlanningandOrganizing": 2.1,
    "s5MeasurementandCalculation": 6.9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3.2,
    "s8OralCommunication": 11.7,
    "s9ProblemSolving": 8.7,
    "s10Reading": 13.1,
    "s11SchedulingorBudgetingandAccounting": 2.6,
    "s12DigitalTechnology": 3.9,
    "s13DocumentUse": 17,
    "s14Writing": 7.2,
    "s15CriticalThinking": 1,
    "f1Science&Agriculture": 92,
    "f2Engineering": 135,
    "f3Humanities": 35,
    "f4SocialScience": 48,
    "f5FineArts": 59,
    "f6MathAndComputerScience": 61,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 68,
    "f9Law": 48,
    "f10Health": 9,
    "f11Health,Nursing&ClinicalLaboratory": 108,
    "f12Business": 439,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 48,
    "d6Fine&AppliedArts": 59,
    "d7ComputerScience": 55,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 68,
    "d10Engineering": 135,
    "d11Law": 48,
    "d12Mathematics": 6,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 72,
    "d16Therapy&Rehabilitation": 9,
    "d17Health,Nursing&ClinicalLaboratory": 108,
    "d18Business&Commerce": 439,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 493,
    "noc": 9618,
    "job": "Labourers in fish and seafood processing",
    "title1": "briner, fish � fish processing cannery labourer cannery labourer � fish processing cooler operator � fish processing fish bin worker � fish processing fish briner � fish processing fish culler fish curing worker fish dipper � fish processing fish flaker � fish processing fish freezing worker � fish processing fish hopper filling worker fish icer � fish processing fish packer � fish processing fish pickler � fish processing fish plant labourer fish processing labourer fish salter � fish processing fish sorter fish washer � fish processing fish weigher fish-processing plant labourer handler, fish-processing plant labourer � shellfish processing labourer, cannery � fish processing labourer, fish-processing plant plant labourer � fish processing shellfish checker � fish processing shellfish labourer shellfish packer � fish processing shellfish processing labourer",
    "title2": 0,
    "title3": 0,
    "allTitles": "briner, fish � fish processing cannery labourer cannery labourer � fish processing cooler operator � fish processing fish bin worker � fish processing fish briner � fish processing fish culler fish curing worker fish dipper � fish processing fish flaker � fish processing fish freezing worker � fish processing fish hopper filling worker fish icer � fish processing fish packer � fish processing fish pickler � fish processing fish plant labourer fish processing labourer fish salter � fish processing fish sorter fish washer � fish processing fish weigher fish-processing plant labourer handler, fish-processing plant labourer � shellfish processing labourer, cannery � fish processing labourer, fish-processing plant plant labourer � fish processing shellfish checker � fish processing shellfish labourer shellfish packer � fish processing shellfish processing labourer",
    "workers": 5969,
    "minEduc": 0.9,
    "yearsStudy": 1.771720232,
    "automationRisk": 0.5953,
    "salaryLow": 14,
    "salaryMed": 14.76625,
    "salaryHigh": 22.7575,
    "totalSkill": 101.9,
    "industry": "Manufacturing & utilities",
    "industryNum": 7,
    "sector": "Labourers in processing, manufacturing and utilities",
    "cluster": 7,
    "wage": 18.026,
    "skillsComp": 27.1,
    "skillsLogi": 26.2,
    "skillsMath": 16.6,
    "skillsLang": 31.9,
    "topSkill1": "Document Use",
    "topSkill2": "Reading",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.1,
    "s2DecisionMaking": 7.4,
    "s3FindingInformation": 7.1,
    "s4JobTaskPlanningandOrganizing": 2.1,
    "s5MeasurementandCalculation": 6.9,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 3.2,
    "s8OralCommunication": 11.7,
    "s9ProblemSolving": 8.7,
    "s10Reading": 13.1,
    "s11SchedulingorBudgetingandAccounting": 2.6,
    "s12DigitalTechnology": 3.9,
    "s13DocumentUse": 17,
    "s14Writing": 7.2,
    "s15CriticalThinking": 1,
    "f1Science&Agriculture": 92,
    "f2Engineering": 135,
    "f3Humanities": 35,
    "f4SocialScience": 48,
    "f5FineArts": 59,
    "f6MathAndComputerScience": 61,
    "f7Arts&Education": 410,
    "f8Education(teachertraining)": 68,
    "f9Law": 48,
    "f10Health": 9,
    "f11Health,Nursing&ClinicalLaboratory": 108,
    "f12Business": 439,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 20,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 35,
    "d5SocialSciences": 48,
    "d6Fine&AppliedArts": 59,
    "d7ComputerScience": 55,
    "d8OtherArts&Science": 410,
    "d9Education(teachertraining)": 68,
    "d10Engineering": 135,
    "d11Law": 48,
    "d12Mathematics": 6,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 72,
    "d16Therapy&Rehabilitation": 9,
    "d17Health,Nursing&ClinicalLaboratory": 108,
    "d18Business&Commerce": 439,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  },
  {
    "id": 494,
    "noc": 9619,
    "job": "Other labourers in processing, manufacturing and utilities",
    "title1": "lens blocker",
    "title2": "seed packager",
    "title3": "carton marker",
    "allTitles": "lens blockerseed packagercarton markerchair sanderlabourer, shoe manufacturingbindery helperbox packerclothing plant labourerelectrical products labourerfilm cutter - film processingfurniture packergarment foldersorter, recyclable materialsupholsterer helperpackager, machine",
    "workers": 29130,
    "minEduc": 0.5,
    "yearsStudy": 2.891934494,
    "automationRisk": 0.3365,
    "salaryLow": 14,
    "salaryMed": 14,
    "salaryHigh": 22,
    "totalSkill": 131.5,
    "industry": "Management",
    "industryNum": 1,
    "sector": "Middle management occupations in retail and wholesale trade and customer services",
    "cluster": 1,
    "wage": 28.5,
    "skillsComp": 35.5,
    "skillsLogi": 33,
    "skillsMath": 19,
    "skillsLang": 43.5,
    "topSkill1": "Reading",
    "topSkill2": "Document Use",
    "topSkill3": "Oral Communication",
    "s1DataAnalysis": 6.5,
    "s2DecisionMaking": 9,
    "s3FindingInformation": 7.5,
    "s4JobTaskPlanningandOrganizing": 2.5,
    "s5MeasurementandCalculation": 6.5,
    "s6MoneyMath": 4,
    "s7NumericalEstimation": 4,
    "s8OralCommunication": 14.5,
    "s9ProblemSolving": 9.5,
    "s10Reading": 17.5,
    "s11SchedulingorBudgetingandAccounting": 5,
    "s12DigitalTechnology": 11.5,
    "s13DocumentUse": 17,
    "s14Writing": 12,
    "s15CriticalThinking": 5,
    "f1Science&Agriculture": 380,
    "f2Engineering": 635,
    "f3Humanities": 175,
    "f4SocialScience": 240,
    "f5FineArts": 295,
    "f6MathAndComputerScience": 305,
    "f7Arts&Education": 1625,
    "f8Education(teachertraining)": 340,
    "f9Law": 210,
    "f10Health": 45,
    "f11Health,Nursing&ClinicalLaboratory": 540,
    "f12Business": 2055,
    "f13Medical,Dental&Veterinary": 0,
    "d1Agriculture&BiologicalScience": 100,
    "d2Forestry": 0,
    "d3Architecture&LandscapeArchitecture": 0,
    "d4Humanities": 175,
    "d5SocialSciences": 240,
    "d6Fine&AppliedArts": 295,
    "d7ComputerScience": 275,
    "d8OtherArts&Science": 1625,
    "d9Education(teachertraining)": 340,
    "d10Engineering": 635,
    "d11Law": 210,
    "d12Mathematics": 30,
    "d13Kinesiology/Recreation/PhysicalEducation": 0,
    "d14Theology": 0,
    "d15PhysicalSciences": 280,
    "d16Therapy&Rehabilitation": 45,
    "d17Health,Nursing&ClinicalLaboratory": 540,
    "d18Business&Commerce": 2055,
    "d19Medical,Dental&Veterinary": 0,
    "equalRadius": 10
  }
]
export default NOCData;